// This file is auto-generated by @hey-api/openapi-ts

export const $AIChatRelatedData = {
    type: 'object',
    title: 'AIChatRelatedData',
    properties: {
        ai_chat_session_uuid: {
            type: 'string',
            nullable: true
        },
        ai_chat_session_message_uuid: {
            type: 'string',
            nullable: true
        }
    }
} as const;

export const $AIChatSession = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        messages: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/AIChatSessionMessage'
            },
            readOnly: true
        },
        documents: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/Document'
            },
            readOnly: true
        },
        title: {
            type: 'string',
            maxLength: 255
        },
        description: {
            type: 'string'
        },
        session_state: {
            allOf: [
                {
                    '$ref': '#/components/schemas/SessionStateEnum'
                }
            ],
            readOnly: true
        },
        session_type: {
            '$ref': '#/components/schemas/AIChatSessionTypeEnum'
        },
        session_group: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        started_by_user: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        started_by_user_data: {
            allOf: [
                {
                    '$ref': '#/components/schemas/CustomerOrganisationUser'
                }
            ],
            readOnly: true
        },
        system_rating: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,1}(?:\\.\\d{0,1})?$',
            readOnly: true,
            nullable: true
        },
        human_rating: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,1}(?:\\.\\d{0,1})?$',
            nullable: true
        },
        system_rating_explanation: {
            type: 'string',
            readOnly: true
        },
        system_rating_improvement_suggestions: {
            type: 'string',
            readOnly: true
        }
    },
    required: ['created_at', 'documents', 'messages', 'session_group', 'session_state', 'started_by_user', 'started_by_user_data', 'system_rating', 'system_rating_explanation', 'system_rating_improvement_suggestions', 'uuid']
} as const;

export const $AIChatSessionEnhancePromptRequestRequest = {
    type: 'object',
    properties: {
        content: {
            type: 'string',
            minLength: 1,
            description: 'The original prompt content to enhance.',
            maxLength: 10000
        }
    },
    required: ['content']
} as const;

export const $AIChatSessionEnhancePromptResponse = {
    type: 'object',
    properties: {
        enhanced_content: {
            type: 'string',
            description: 'The enhanced version of the prompt.'
        }
    },
    required: ['enhanced_content']
} as const;

export const $AIChatSessionMessage = {
    type: 'object',
    title: 'AIChatSessionMessage',
    properties: {
        content: {
            type: 'string'
        },
        role: {
            '$ref': '#/components/schemas/AIChatSessionMessageRoleEnum'
        },
        created_at: {
            type: 'string',
            nullable: true
        },
        uuid: {
            type: 'string',
            nullable: true
        },
        user_uuid: {
            type: 'string',
            nullable: true
        },
        context: {
            '$ref': '#/components/schemas/CaseAiContext',
            nullable: true
        },
        organization_context: {
            '$ref': '#/components/schemas/OrganizationAiContext',
            nullable: true
        },
        preference_suggestion: {
            '$ref': '#/components/schemas/PreferenceSuggestionData',
            nullable: true
        },
        case_specific_info_unavailable: {
            type: 'boolean',
            nullable: true
        }
    },
    required: ['content', 'role']
} as const;

export const $AIChatSessionMessageRoleEnum = {
    type: 'string',
    enum: ['system', 'user', 'assistant']
} as const;

export const $AIChatSessionRequest = {
    type: 'object',
    properties: {
        title: {
            type: 'string',
            maxLength: 255
        },
        description: {
            type: 'string'
        },
        session_type: {
            '$ref': '#/components/schemas/AIChatSessionTypeEnum'
        },
        case_uuid: {
            type: 'string',
            format: 'uuid',
            writeOnly: true
        },
        session_group_uuid: {
            type: 'string',
            format: 'uuid',
            writeOnly: true,
            nullable: true
        },
        human_rating: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,1}(?:\\.\\d{0,1})?$',
            nullable: true
        }
    }
} as const;

export const $AIChatSessionSendMessageRequestRequest = {
    type: 'object',
    properties: {
        content: {
            type: 'string',
            minLength: 1,
            description: 'The message to send to the AI chat session.'
        }
    },
    required: ['content']
} as const;

export const $AIChatSessionSendMessageResponse = {
    type: 'object',
    properties: {
        message: {
            type: 'string'
        }
    },
    required: ['message']
} as const;

export const $AIChatSessionTypeEnum = {
    enum: ['GLOBAL', 'CASE'],
    type: 'string',
    description: `* \`GLOBAL\` - Global
* \`CASE\` - Case`
} as const;

export const $AISplitGroupResponse = {
    type: 'object',
    description: 'Response serializer for individual AI split groups.',
    properties: {
        name: {
            type: 'string',
            description: 'Suggested name for the document group'
        },
        pages: {
            type: 'array',
            items: {
                type: 'integer'
            },
            description: 'Page numbers to include in this group'
        },
        reasoning: {
            type: 'string',
            description: 'Explanation for why this split makes sense'
        },
        confidence: {
            type: 'number',
            format: 'double',
            description: 'Confidence score for this split (0.0-1.0)'
        }
    },
    required: ['confidence', 'name', 'pages', 'reasoning']
} as const;

export const $ActaportDataRequest = {
    type: 'object',
    properties: {
        clerk: {
            type: 'string',
            minLength: 1
        },
        assistant: {
            type: 'string',
            minLength: 1
        },
        title: {
            type: 'string',
            minLength: 1
        },
        fileData: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/FileDataRequest'
            }
        },
        entities_with_relationships: {
            type: 'array',
            items: {
                type: 'string',
                format: 'uuid'
            }
        },
        wegen: {
            type: 'string'
        }
    },
    required: ['assistant', 'clerk', 'entities_with_relationships', 'title']
} as const;

export const $ActaportSettings = {
    type: 'object',
    description: 'Serializer for Actaport integration settings in Organisation model.',
    properties: {
        is_actaport_export_integration_enabled: {
            type: 'boolean',
            title: 'Actaport Integration aktivieren'
        },
        actaport_client_id: {
            type: 'string',
            nullable: true,
            title: 'Client ID',
            maxLength: 64
        },
        actaport_client_secret: {
            type: 'string',
            nullable: true
        },
        actaport_realm: {
            type: 'string',
            nullable: true,
            title: 'Realm',
            maxLength: 64
        },
        actaport_username: {
            type: 'string',
            nullable: true,
            title: 'Username',
            maxLength: 64
        },
        actaport_password: {
            type: 'string',
            nullable: true
        }
    }
} as const;

export const $ActaportSettingsRequest = {
    type: 'object',
    description: 'Serializer for Actaport integration settings in Organisation model.',
    properties: {
        is_actaport_export_integration_enabled: {
            type: 'boolean',
            title: 'Actaport Integration aktivieren'
        },
        actaport_client_id: {
            type: 'string',
            nullable: true,
            title: 'Client ID',
            maxLength: 64
        },
        actaport_client_secret: {
            type: 'string',
            nullable: true
        },
        actaport_realm: {
            type: 'string',
            nullable: true,
            title: 'Realm',
            maxLength: 64
        },
        actaport_username: {
            type: 'string',
            nullable: true,
            title: 'Username',
            maxLength: 64
        },
        actaport_password: {
            type: 'string',
            nullable: true
        }
    }
} as const;

export const $ActionTypeEnum = {
    enum: ['DRAFT_WORD_DOCUMENT_TEMPLATE', 'CASE_ASSIGN_LIFECYCLE_WORKFLOW', 'SEND_APPOINTMENT_BOOKING_LINK_TO_CLIENT', 'SEND_CLIENT_TEMPLATE_EMAIL', 'CASE_ASSIGN_LAWYER', 'CASE_ASSIGN_LAW_DOMAIN', 'CASE_ASSIGN_STATUS'],
    type: 'string',
    description: `* \`DRAFT_WORD_DOCUMENT_TEMPLATE\` - Draft Word Document Template
* \`CASE_ASSIGN_LIFECYCLE_WORKFLOW\` - Case Assign Lifecycle Workflow
* \`SEND_APPOINTMENT_BOOKING_LINK_TO_CLIENT\` - Send Appointment Booking Link To Client
* \`SEND_CLIENT_TEMPLATE_EMAIL\` - Send Client Template Email
* \`CASE_ASSIGN_LAWYER\` - Case Assign Lawyer
* \`CASE_ASSIGN_LAW_DOMAIN\` - Case Assign Law Domain
* \`CASE_ASSIGN_STATUS\` - Case Assign Status`
} as const;

export const $Activity = {
    type: 'object',
    description: 'Base serializer for Activity model.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        seen_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        activity_type: {
            '$ref': '#/components/schemas/ActivityTypeEnum'
        }
    },
    required: ['activity_type', 'created_at']
} as const;

export const $ActivityRequest = {
    type: 'object',
    description: 'Base serializer for Activity model.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        seen_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        activity_type: {
            '$ref': '#/components/schemas/ActivityTypeEnum'
        }
    },
    required: ['activity_type']
} as const;

export const $ActivityTypeEnum = {
    enum: ['DOCUMENT_SIGNED', 'QUESTIONNAIRE_CLOSED', 'EMAIL_RECEIVED', 'EMAIL_SENT', 'CASE_CREATED', 'APPOINTMENT_CREATED'],
    type: 'string',
    description: `* \`DOCUMENT_SIGNED\` - Document Signed
* \`QUESTIONNAIRE_CLOSED\` - Questionnaire Closed
* \`EMAIL_RECEIVED\` - Email Received
* \`EMAIL_SENT\` - Email Sent
* \`CASE_CREATED\` - Case Created
* \`APPOINTMENT_CREATED\` - Appointment Created`
} as const;

export const $AdvoluxDataRequest = {
    type: 'object',
    properties: {
        label: {
            type: 'string',
            minLength: 1
        },
        caseGroup: {
            type: 'integer',
            nullable: true
        },
        fileData: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/FileDataRequest'
            }
        },
        entities_with_relationships: {
            type: 'array',
            items: {
                type: 'string',
                format: 'uuid'
            }
        }
    },
    required: ['entities_with_relationships', 'label']
} as const;

export const $AdvoluxSettings = {
    type: 'object',
    description: 'Serializer for Advolux integration settings in Organisation model.',
    properties: {
        is_advolux_export_integration_enabled: {
            type: 'boolean'
        }
    }
} as const;

export const $AdvoluxSettingsRequest = {
    type: 'object',
    description: 'Serializer for Advolux integration settings in Organisation model.',
    properties: {
        is_advolux_export_integration_enabled: {
            type: 'boolean'
        }
    }
} as const;

export const $AdvowareDataRequest = {
    type: 'object',
    properties: {
        rubrum: {
            type: 'string',
            minLength: 1
        },
        lawField: {
            type: 'string',
            minLength: 1
        },
        lawTopic: {
            type: 'string',
            minLength: 1
        },
        clerk: {
            type: 'string',
            minLength: 1
        },
        rvg: {
            nullable: true,
            oneOf: [
                {
                    '$ref': '#/components/schemas/AdvowareRVGChoiceEnum'
                },
                {
                    '$ref': '#/components/schemas/NullEnum'
                }
            ]
        },
        fileData: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/FileDataRequest'
            }
        },
        entities_with_relationships: {
            type: 'array',
            items: {
                type: 'string',
                format: 'uuid'
            }
        }
    },
    required: ['clerk', 'entities_with_relationships', 'lawField', 'lawTopic', 'rubrum']
} as const;

export const $AdvowareRVGChoiceEnum = {
    enum: [0, 1, 2, 3, 8, 9, 10, 14, 15, 16, 21],
    description: `* \`None\` - RVG 2025
* \`0\` - BRAGO
* \`1\` - RVG 2004
* \`2\` - RVG 2006
* \`3\` - Pauschale
* \`8\` - RVG 2013
* \`9\` - StBVV
* \`10\` - Zeithonorar
* \`14\` - Akte nicht abrechnen
* \`15\` - kanzleispezifische Rechnung
* \`16\` - RVG 2021
* \`21\` - StBVV 2025`
} as const;

export const $AdvowareSettings = {
    type: 'object',
    description: 'Serializer for Advoware integration settings in Organisation model.',
    properties: {
        is_advoware_export_integration_enabled: {
            type: 'boolean',
            title: 'Advoware Integration aktivieren'
        },
        advoware_lawfirm_id: {
            type: 'string',
            nullable: true,
            title: 'Online Kennung',
            maxLength: 64
        },
        advoware_database: {
            type: 'string',
            nullable: true,
            title: 'Datenbank',
            maxLength: 64
        },
        advoware_user: {
            type: 'string',
            nullable: true,
            title: 'Nutzer (Kürzel)',
            maxLength: 64
        },
        advoware_password: {
            type: 'string'
        }
    }
} as const;

export const $AdvowareSettingsRequest = {
    type: 'object',
    description: 'Serializer for Advoware integration settings in Organisation model.',
    properties: {
        is_advoware_export_integration_enabled: {
            type: 'boolean',
            title: 'Advoware Integration aktivieren'
        },
        advoware_lawfirm_id: {
            type: 'string',
            nullable: true,
            title: 'Online Kennung',
            maxLength: 64
        },
        advoware_database: {
            type: 'string',
            nullable: true,
            title: 'Datenbank',
            maxLength: 64
        },
        advoware_user: {
            type: 'string',
            nullable: true,
            title: 'Nutzer (Kürzel)',
            maxLength: 64
        },
        advoware_password: {
            type: 'string'
        }
    }
} as const;

export const $AgentActionCommitRequest = {
    type: 'object',
    description: 'Serializer for committing an agent action.',
    properties: {
        agent_action_uuid: {
            type: 'string',
            format: 'uuid',
            description: 'UUID of the agent action to commit'
        },
        payload: {
            type: 'string',
            nullable: true,
            description: 'Payload to commit the agent action with. Optional, depending on the action.'
        }
    },
    required: ['agent_action_uuid']
} as const;

export const $AgentActionRateRequest = {
    type: 'object',
    description: 'Serializer for rating an agent action.',
    properties: {
        agent_action_uuid: {
            type: 'string',
            format: 'uuid',
            description: 'UUID of the agent action to rate'
        },
        rating: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,1}(?:\\.\\d{0,1})?$',
            description: 'Rating value from 0.0 to 5.0'
        },
        rating_negative_variant: {
            nullable: true,
            description: `Variant for negative rating feedback

* \`INSTRUCTIONS_NOT_FOLLOWED\` - Instructions Not Followed
* \`PAYLOAD_NOT_CORRECT\` - Payload Not Correct
* \`ACTION_NOT_NEEDED\` - Action Not Needed
* \`OTHER\` - Other`,
            oneOf: [
                {
                    '$ref': '#/components/schemas/RatingNegativeVariantEnum'
                },
                {
                    '$ref': '#/components/schemas/NullEnum'
                }
            ]
        },
        rating_negative_comment: {
            type: 'string',
            nullable: true,
            description: 'Additional comment for negative rating'
        }
    },
    required: ['agent_action_uuid', 'rating']
} as const;

export const $AgentActionRelatedData = {
    type: 'object',
    title: 'AgentActionRelatedData',
    properties: {
        agent_action_uuid: {
            type: 'string',
            nullable: true
        }
    }
} as const;

export const $AgentActionRevertRequest = {
    type: 'object',
    description: 'Serializer for reverting an agent action.',
    properties: {
        agent_action_uuid: {
            type: 'string',
            format: 'uuid',
            description: 'UUID of the agent action to revert'
        },
        revert_payload: {
            type: 'string',
            nullable: true,
            description: 'Payload to revert the agent action with. Optional, depending on the action.'
        }
    },
    required: ['agent_action_uuid']
} as const;

export const $AiAnalysisRelatedData = {
    type: 'object',
    title: 'AiAnalysisRelatedData',
    properties: {
        ai_augmentation_uuid: {
            type: 'string',
            nullable: true
        }
    }
} as const;

export const $AiAugmentedByMapperKeysEnum = {
    enum: ['entities.field.address_line_2', 'entities.field.bank_name', 'entities.field.bic', 'entities.field.city', 'entities.field.company_legal_form', 'entities.field.company_name', 'entities.field.company_register_court', 'entities.field.company_register_number', 'entities.field.company_tax_id', 'entities.field.company_vat_id', 'entities.field.date_of_birth', 'entities.field.date_of_death', 'entities.field.email', 'entities.field.entity_type', 'entities.field.fax', 'entities.field.first_name', 'entities.field.iban', 'entities.field.institution_name', 'entities.field.is_entitled_to_deduct_vat', 'entities.field.is_valid_email', 'entities.field.is_valid_phone_number', 'entities.field.last_name', 'entities.field.legal_insurance_deductible_amount', 'entities.field.legal_insurance', 'entities.field.legal_insurance_name', 'entities.field.legal_insurance_number', 'entities.field.marital_status', 'entities.field.phone', 'entities.field.specific_title', 'entities.field.street', 'entities.field.street_number', 'entities.field.title', 'entities.field.website', 'entities.field.zip', 'law.civil_law_accessories_sold_separately', 'law.civil_law_case_number', 'law.civil_law_claim_amount', 'law.civil_law_contract_date', 'law.civil_law_contract_duration', 'law.civil_law_contract_end_date', 'law.civil_law_contract', 'law.civil_law_contract_object', 'law.civil_law_contract_start_date', 'law.civil_law_contract_value', 'law.civil_law_correspondence', 'law.civil_law_court_costs', 'law.civil_law_court_document', 'law.civil_law_court_name', 'law.civil_law_damage_amount', 'law.civil_law_damage_cause', 'law.civil_law_damage_claim', 'law.civil_law_damage_date', 'law.civil_law_damage_description', 'law.civil_law_default_interest', 'law.civil_law_defects', 'law.civil_law_defects_present', 'law.civil_law_delivery_date', 'law.civil_law_document_date', 'law.civil_law_file_reference', 'law.civil_law_handover_date', 'law.civil_law_hearing_date', 'law.civil_law_insurance_claim_number', 'law.civil_law_interest_rate', 'law.civil_law_judgment_date', 'law.civil_law_liability_percentage', 'law.civil_law_notarial_certification_date', 'law.civil_law_payment_due_date', 'law.civil_law_purchase_agreement', 'law.civil_law_purchase_contract_file_reference', 'law.civil_law_purchase_date', 'law.civil_law_purchase_object', 'law.civil_law_purchase_price_components', 'law.civil_law_purchase_price', 'law.civil_law_purchase_price_paid_amount', 'law.civil_law_purchase_price_paid_boolean', 'law.civil_law_purchase_price_paid_date', 'law.civil_law_purchase_price_paid', 'law.civil_law_purchase_price_payment_date', 'law.civil_law_subject_line', 'law.civil_law_termination_notice_period', 'law.civil_law_vehicle_make', 'law.civil_law_vehicle_mileage', 'law.civil_law_vehicle_model', 'law.civil_law_vehicle_vin', 'law.civil_law_vehicle_year', 'law.civil_law_warranty_period', 'law.criminal_law_amount_of_daily_rates', 'law.criminal_law_applicable_laws', 'law.criminal_law_charge_description', 'law.criminal_law_complaint', 'law.criminal_law_criminal_warrant', 'law.criminal_law_damage_description', 'law.criminal_law_damage_value', 'law.criminal_law_date_of_offense', 'law.criminal_law_duration_of_prison_sentence', 'law.criminal_law_evidence_location', 'law.criminal_law_evidence', 'law.criminal_law_incident_description', 'law.criminal_law_indictment_date', 'law.criminal_law_indictment_delivery_date', 'law.criminal_law_indictment', 'law.criminal_law_legal_classification_of_offense', 'law.criminal_law_means_of_evidence', 'law.criminal_law_number_of_daily_rates', 'law.criminal_law_offense_type', 'law.criminal_law_penalty_infromation', 'law.criminal_law_physical_evidence', 'law.criminal_law_place_of_offense', 'law.criminal_law_police_file_number', 'law.criminal_law_preliminary_proceedings_date', 'law.criminal_law_prison_sentence', 'law.criminal_law_probation', 'law.criminal_law_prosecution_file_number', 'law.criminal_law_report_date', 'law.criminal_law_report_time', 'law.criminal_law_time_of_offense', 'law.debt_collection_law_business_fee', 'law.debt_collection_law_case_value', 'law.debt_collection_law_invoice_amount', 'law.debt_collection_law_invoice_date', 'law.debt_collection_law_invoice_ground', 'law.debt_collection_law_invoice_lawyer', 'law.debt_collection_law_invoice', 'law.debt_collection_law_invoice_number', 'law.debt_collection_law_invoice_recipient', 'law.debt_collection_law_invoice_tax_number', 'law.debt_collection_law_lumps_sum_expenses', 'law.debt_collection_law_sales_tax', 'law.debt_collection_law_subtotal_lawyer_fees', 'law.debt_collection_law_total_amount', 'law.external_case_id', 'law.family_law_average_net_income', 'law.family_law_birth_certificate', 'law.family_law_birth_register_number', 'law.family_law_birth_register_office_location', 'law.family_law_children', 'law.family_law_date_of_marriage', 'law.family_law_divorce_application', 'law.family_law_divorce_settlement_agreement', 'law.family_law_marriage_certificate', 'law.family_law_marriage_contract_date', 'law.family_law_marriage_contract', 'law.family_law_marriage_register_number', 'law.family_law_registry_office_location', 'law.family_law_separation_date', 'law.field', 'law.general_law_amount_net', 'law.general_law_amount_total', 'law.general_law_appendices', 'law.general_law_case_number', 'law.general_law_court_costs', 'law.general_law_court_name', 'law.general_law_doc_date', 'law.general_law_due_date', 'law.general_law_file_ref', 'law.general_law_hearing_date', 'law.general_law_invoice_date', 'law.general_law_invoice_number', 'law.general_law_judgment_date', 'law.general_law_correspondence', 'law.general_law_court_document', 'law.general_law_invoice', 'law.general_law_payment_terms', 'law.general_law_prior_ref', 'law.general_law_subject', 'law.general_law_vat', 'law.generic_document', 'law.inheritance_law_certificate_of_inheritance_applicable_law', 'law.inheritance_law_certificate_of_inheritance_date_death', 'law.inheritance_law_certificate_of_inheritance_date', 'law.inheritance_law_certificate_of_inheritance', 'law.inheritance_law_certificate_of_inheritance_number', 'law.inheritance_law_certificate_of_inheritance_place_of_death', 'law.inheritance_law_death_certificate_date_death', 'law.inheritance_law_death_certificate_date', 'law.inheritance_law_death_certificate', 'law.inheritance_law_death_certificate_number', 'law.inheritance_law_death_certificate_place_death', 'law.inheritance_law_death_certificate_place', 'law.inheritance_law_death_certificate_time_death', 'law.inheritance_law_estate_inventory_amount', 'law.inheritance_law_estate_inventory_date', 'law.inheritance_law_estate_inventory_status', 'law.inheritance_law_inheritance_contract_date', 'law.inheritance_law_inheritance_contract', 'law.inheritance_law_lasting_power_of_attorney_date', 'law.inheritance_law_lasting_power_of_attorney', 'law.inheritance_law_list_of_estate', 'law.inheritance_law_living_will', 'law.inheritance_law_patient_enrollment_date', 'law.inheritance_law_testament_date', 'law.inheritance_law_will', 'law.labor_law_amount_dependent_children', 'law.labor_law_beginning_of_employment', 'law.labor_law_certificate_clause', 'law.labor_law_child_allowances', 'law.labor_law_collective_agreement', 'law.labor_law_company_agreement', 'law.labor_law_company_hearing', 'law.labor_law_dependent_children', 'law.labor_law_different_place_of_work', 'law.labor_law_disability', 'law.labor_law_employee_probation_period_end_date', 'law.labor_law_end_of_employment', 'law.labor_law_exemption_irrevocable', 'law.labor_law_exemption_revocable', 'law.labor_law_fixed_term_contract_duration', 'law.labor_law_fixed_term_contract', 'law.labor_law_grade_certificate_clause', 'law.labor_law_is_employee_in_probation_period', 'law.labor_law_job_title', 'law.labor_law_local_transfer_clause', 'law.labor_law_LTI', 'law.labor_law_married', 'law.labor_law_monthly_gross_salary', 'law.labor_law_monthly_working_days', 'law.labor_law_notice_period', 'law.labor_law_notice_period_observed', 'law.labor_law_payslip', 'law.labor_law_percent_sprinter_clause', 'law.labor_law_place_of_work', 'law.labor_law_pregnancy', 'law.labor_law_reaction_company_hering', 'law.labor_law_reason_for_termination_given', 'law.labor_law_return_of_company_property', 'law.labor_law_settlement_agreement_date', 'law.labor_law_settlement_agreement', 'law.labor_law_severance_amount', 'law.labor_law_signature_of_employer', 'law.labor_law_special_documents', 'law.labor_law_special_payments_amount', 'law.labor_law_special_payments', 'law.labor_law_special_personal_circumstances', 'law.labor_law_special_protection_against_dismissal', 'law.labor_law_special_sentence', 'law.labor_law_sprinter_clause', 'law.labor_law_termination_access_to_termination_to_employee', 'law.labor_law_termination_agreement_date', 'law.labor_law_termination_agreement', 'law.labor_law_termination_agreement_severance_pay_amount', 'law.labor_law_termination_agreement_termination_date', 'law.labor_law_termination_authorization', 'law.labor_law_termination_date_effective', 'law.labor_law_termination_date', 'law.labor_law_termination_employer_more_than_10_employees', 'law.labor_law_termination_is_agreement_severance_pay', 'law.labor_law_termination', 'law.labor_law_termination_operational_reasons', 'law.labor_law_termination_without_notice', 'law.labor_law_total_gross_salary', 'law.labor_law_vacation_days', 'law.labor_law_visum', 'law.labor_law_VSOP', 'law.labor_law_warning_letter_access_to_warning_letter_to_employee', 'law.labor_law_warning_letter_date', 'law.labor_law_warning_letter_incident_date', 'law.labor_law_warning_letter_incident_location', 'law.labor_law_warning_letter_incident_time', 'law.labor_law_warning_letter', 'law.labor_law_warning_letter_reason', 'law.labor_law_work_contract', 'law.labor_law_work_council', 'law.labor_law_work_hours_per_week', 'law.labor_law_works_council_membership', 'law.labor_law_yearly_gross_salary', 'law.labor_law_years_of_employment', 'law.medicine_law_health_insurance_letter_date', 'law.medicine_law_health_insurance_letter_decision_justification', 'law.medicine_law_health_insurance_letter_decision', 'law.medicine_law_health_insurance_letter_legal_remedy_instruction', 'law.medicine_law_health_insurance_letter', 'law.medicine_law_health_insurance_letter_reference_to_application', 'law.medicine_law_hospital_records_admission_date', 'law.medicine_law_hospital_records_diagnoses_icd_codes', 'law.medicine_law_hospital_records_discharge_date', 'law.medicine_law_hospital_records_discharge_prognosis', 'law.medicine_law_hospital_records_documented_complications', 'law.medicine_law_hospital_records', 'law.medicine_law_hospital_records_medication_during_stay', 'law.medicine_law_hospital_records_operation_date', 'law.medicine_law_hospital_records_operations', 'law.medicine_law_hospital_records_station', 'law.medicine_law_laboratory_results_examination_date', 'law.medicine_law_laboratory_results_examination_type', 'law.medicine_law_laboratory_results_further_investigation_recommendation', 'law.medicine_law_laboratory_results', 'law.medicine_law_laboratory_results_relevant_deviations', 'law.medicine_law_medical_bill_cost_bearer', 'law.medicine_law_medical_bill_invoice_date', 'law.medicine_law_medical_bill_invoice_number', 'law.medicine_law_medical_bill', 'law.medicine_law_medical_bill_payment_deadline', 'law.medicine_law_medical_bill_service_period', 'law.medicine_law_medical_bill_services_list', 'law.medicine_law_medical_bill_total_amount', 'law.medicine_law_medical_expertise_date', 'law.medicine_law_medical_expertise_justification', 'law.medicine_law_medical_expertise', 'law.medicine_law_medical_expertise_medical_assessment', 'law.medicine_law_medical_expertise_question_posed', 'law.medicine_law_medical_expertise_result', 'law.medicine_law_medical_report_complications', 'law.medicine_law_medical_report_date', 'law.medicine_law_medical_report_diagnosis_icd_code', 'law.medicine_law_medical_report_diagnosis_short_text', 'law.medicine_law_medical_report_further_treatment', 'law.medicine_law_medical_report', 'law.medicine_law_medical_report_surgery_date', 'law.medicine_law_medical_report_treatment_measures', 'law.medicine_law_medical_report_treatment_period', 'law.migration_law_approval_notice_case_number', 'law.migration_law_approval_notice_conditions', 'law.migration_law_approval_notice_decision_date', 'law.migration_law_approval_notice_issuing_authority', 'law.migration_law_approval_notice', 'law.migration_law_approval_notice_permit_type', 'law.migration_law_approval_notice_pickup_deadline', 'law.migration_law_approval_notice_validity_period', 'law.migration_law_asylum_seeker_certificate_application_number', 'law.migration_law_asylum_seeker_certificate_first_registration_date', 'law.migration_law_asylum_seeker_certificate_issue_date', 'law.migration_law_asylum_seeker_certificate_issuing_authority', 'law.migration_law_asylum_seeker_certificate', 'law.migration_law_asylum_seeker_certificate_residence_obligation', 'law.migration_law_asylum_seeker_certificate_valid_until', 'law.migration_law_asylum_seeker_certificate_work_permission', 'law.migration_law_cooperation_letter_attachments', 'law.migration_law_cooperation_letter_date', 'law.migration_law_cooperation_letter_deadlines', 'law.migration_law_cooperation_letter_file_number', 'law.migration_law_cooperation_letter', 'law.migration_law_cooperation_letter_non_cooperation_consequences', 'law.migration_law_cooperation_letter_specified_obligations', 'law.migration_law_fictional_certificate_authority', 'law.migration_law_fictional_certificate_fiction_type', 'law.migration_law_fictional_certificate_issue_date', 'law.migration_law_fictional_certificate_legal_basis', 'law.migration_law_fictional_certificate', 'law.migration_law_fictional_certificate_reason_for_issuance', 'law.migration_law_fictional_certificate_valid_until', 'law.migration_law_hearing_letter_date', 'law.migration_law_hearing_letter_intended_measure_justification', 'law.migration_law_hearing_letter_legal_advice', 'law.migration_law_hearing_letter', 'law.migration_law_hearing_letter_requested_documents', 'law.migration_law_hearing_letter_response_deadline', 'law.migration_law_other_letters_action_required', 'law.migration_law_other_letters_date', 'law.migration_law_other_letters_deadlines', 'law.migration_law_other_letters_file_number', 'law.migration_law_other_letters_issuing_authority', 'law.migration_law_other_letters_legal_basis', 'law.migration_law_other_letters', 'law.migration_law_other_letters_matter_purpose', 'law.migration_law_other_letters_subject', 'law.migration_law_rejection_notice_case_number', 'law.migration_law_rejection_notice_decision_date', 'law.migration_law_rejection_notice_legal_grounds', 'law.migration_law_rejection_notice_legal_remedy_deadline', 'law.migration_law_rejection_notice', 'law.migration_law_rejection_notice_officer_name', 'law.migration_law_rejection_notice_reasoning', 'law.migration_law_rejection_notice_signature_seal', 'law.migration_law_rejection_notice_subject', 'law.migration_law_residence_permit_conditions', 'law.migration_law_residence_permit_issue_date', 'law.migration_law_residence_permit_issuing_authority', 'law.migration_law_residence_permit', 'law.migration_law_residence_permit_national_id_number', 'law.migration_law_residence_permit_passport_number', 'law.migration_law_residence_permit_purpose', 'law.migration_law_residence_permit_type', 'law.migration_law_residence_permit_valid_until', 'law.migration_law_toleration_issue_date', 'law.migration_law_toleration_issuing_authority', 'law.migration_law_toleration_legal_basis', 'law.migration_law_toleration', 'law.migration_law_toleration_reason', 'law.migration_law_toleration_restrictions', 'law.migration_law_toleration_valid_until', 'law.real_estate_law_basic_debts_amount', 'law.real_estate_law_broker_commission_amount', 'law.real_estate_law_broker_contract_type', 'law.real_estate_law_broker_scope_of_work', 'law.real_estate_law_broker_termination_periods', 'law.real_estate_law_brokerage_contract_date', 'law.real_estate_law_brokerage_contract', 'law.real_estate_law_brokerage_fee', 'law.real_estate_law_building_dimensions', 'law.real_estate_law_building_permit_date', 'law.real_estate_law_building_permit', 'law.real_estate_law_building_permit_number', 'law.real_estate_law_building_permit_validity_duration', 'law.real_estate_law_building_plan', 'law.real_estate_law_building_restrictions_clause', 'law.real_estate_law_building_usage', 'law.real_estate_law_co_ownership_share', 'law.real_estate_law_commission_percentage', 'law.real_estate_law_contaminated_sites_clause', 'law.real_estate_law_declaration_of_division', 'law.real_estate_law_division_declaration_date', 'law.real_estate_law_encumbrance_restrictions', 'law.real_estate_law_encumbrances_section_ii', 'law.real_estate_law_encumbrances_section_iii', 'law.real_estate_law_exclusive_brokerage_contract', 'law.real_estate_law_full_repayment_date', 'law.real_estate_law_installment_amount', 'law.real_estate_law_interest_rate', 'law.real_estate_law_land_register_address', 'law.real_estate_law_land_register_city', 'law.real_estate_law_land_register_date', 'law.real_estate_law_land_register', 'law.real_estate_law_land_register_number', 'law.real_estate_law_land_register_plot_of_land', 'law.real_estate_law_legal_defects_clause', 'law.real_estate_law_loan_agreement', 'law.real_estate_law_loan_amount', 'law.real_estate_law_loan_security', 'law.real_estate_law_monument_protection_basis', 'law.real_estate_law_monument_protection_notice', 'law.real_estate_law_monument_protection_order_date', 'law.real_estate_law_monument_protection_order_number', 'law.real_estate_law_monument_protection_requirements', 'law.real_estate_law_monument_registration_date', 'law.real_estate_law_plan_author', 'law.real_estate_law_plan_designation', 'law.real_estate_law_plan_scale', 'law.real_estate_law_plot_size', 'law.real_estate_law_property_brokered_by_agent', 'law.real_estate_law_purchase_contract_amount', 'law.real_estate_law_purchase_contract_date', 'law.real_estate_law_purchase_contract_description', 'law.real_estate_law_purchase_contract', 'law.real_estate_law_purchase_contract_registration_date', 'law.real_estate_law_purchase_contract_registration_number', 'law.real_estate_law_purchase_object_rented', 'law.real_estate_law_purchase_price_loan_financed', 'law.real_estate_law_repayment_rate', 'law.real_estate_law_withdrawal_instruction_date', 'law.residential_property_law_co_ownership_shares', 'law.residential_property_law_contract_date', 'law.residential_property_law_contract', 'law.residential_property_law_inventory', 'law.residential_property_law_land_register_address', 'law.residential_property_law_land_register_city', 'law.residential_property_law_land_register_number', 'law.residential_property_law_land_register_plot_of_land', 'law.social_law_affected_benefit', 'law.social_law_application_arrival_date', 'law.social_law_application_date', 'law.social_law_application_file_reference', 'law.social_law_application_form', 'law.social_law_appointment_date', 'law.social_law_appointment_file_reference', 'law.social_law_appointment_invitation', 'law.social_law_appointment_purpose', 'law.social_law_appointment_required_documents', 'law.social_law_appointment_time', 'law.social_law_approval_file_reference', 'law.social_law_approval_internal_reference', 'law.social_law_approval_legal_basis', 'law.social_law_approval_notice_date', 'law.social_law_approval_notice', 'law.social_law_approval_period_end', 'law.social_law_approval_period_start', 'law.social_law_approved_benefit_amount', 'law.social_law_approved_benefit_period', 'law.social_law_approved_benefit_type', 'law.social_law_asset_type', 'law.social_law_attachment_list', 'law.social_law_benefit_type', 'law.social_law_change_description', 'law.social_law_change_file_reference', 'law.social_law_change_notification_date', 'law.social_law_change_notification', 'law.social_law_change_reason', 'law.social_law_creditable_income', 'law.social_law_disability_card_issue_date', 'law.social_law_disability_card', 'law.social_law_disability_card_markers', 'law.social_law_disability_card_validity_period', 'law.social_law_disability_degree', 'law.social_law_disability_file_reference', 'law.social_law_employment_income', 'law.social_law_follow_up_application_notes', 'law.social_law_hearing_file_reference', 'law.social_law_hearing_letter_date', 'law.social_law_hearing_letter', 'law.social_law_hearing_planned_administrative_act', 'law.social_law_housing_costs_amount', 'law.social_law_income_amount', 'law.social_law_income_date', 'law.social_law_income_legal_basis', 'law.social_law_income_provider', 'law.social_law_income_source', 'law.social_law_income_type', 'law.social_law_interim_legal_protection', 'law.social_law_interim_protection_affidavit', 'law.social_law_interim_protection_attachment_list', 'law.social_law_interim_protection_file_reference', 'law.social_law_interim_protection_request_date', 'law.social_law_interim_protection_request_text', 'law.social_law_interim_protection_urgency_reason', 'law.social_law_lawsuit_alternative_request', 'law.social_law_lawsuit_attachment_list', 'law.social_law_lawsuit_cost_request', 'law.social_law_lawsuit_court_file_number', 'law.social_law_lawsuit_delivery_date', 'law.social_law_lawsuit_dispute_value', 'law.social_law_lawsuit_disputed_amount', 'law.social_law_lawsuit_evidence_requests', 'law.social_law_lawsuit_file_reference', 'law.social_law_lawsuit_filing_date', 'law.social_law_lawsuit_income_amount', 'law.social_law_lawsuit_legal_basis', 'law.social_law_lawsuit_main_request', 'law.social_law_lawsuit', 'law.social_law_lawsuit_monthly_benefit_amount', 'law.social_law_lawsuit_objection_decision_date', 'law.social_law_lawsuit_objection_filing_date', 'law.social_law_lawsuit_original_decision_date', 'law.social_law_lawsuit_subject', 'law.social_law_lawsuit_type', 'law.social_law_legal_basis', 'law.social_law_medical_certificate', 'law.social_law_medical_diagnosis', 'law.social_law_medical_examination_date', 'law.social_law_medical_file_reference', 'law.social_law_medical_icd_code', 'law.social_law_medical_limitations', 'law.social_law_medical_prognosis', 'law.social_law_medical_work_capacity_relation', 'law.social_law_monthly_payment_amount', 'law.social_law_needs_cost_breakdown', 'law.social_law_needs_file_reference', 'law.social_law_needs_proof_basis', 'law.social_law_needs_proof_date', 'law.social_law_needs_proof', 'law.social_law_needs_type', 'law.social_law_notice_date', 'law.social_law_notice_of_objection_date', 'law.social_law_notice_of_objection_file_reference', 'law.social_law_notice_of_objection', 'law.social_law_notification_date', 'law.social_law_notification_legal_basis', 'law.social_law_notification_source', 'law.social_law_objection_challenged_notice', 'law.social_law_objection_date', 'law.social_law_objection_evidence', 'law.social_law_objection_file_reference', 'law.social_law_objection', 'law.social_law_objection_reasoning', 'law.social_law_objection_suspension_request', 'law.social_law_original_decision_date', 'law.social_law_other_income', 'law.social_law_own_income_amount', 'law.social_law_reclaim_amount', 'law.social_law_reclaim_file_reference', 'law.social_law_reclaim_legal_basis', 'law.social_law_reclaim_legal_norm', 'law.social_law_reclaim_notice_date', 'law.social_law_reclaim_notice', 'law.social_law_reclaim_payment_deadline', 'law.social_law_reclaim_payment_terms', 'law.social_law_regelbedarf_amount', 'law.social_law_rejection_file_reference', 'law.social_law_rejection_legal_norm', 'law.social_law_rejection_notice_date', 'law.social_law_rejection_notice', 'law.social_law_rejection_reason', 'law.social_law_residence_status', 'law.social_law_revocation_benefit_type', 'law.social_law_revocation_file_reference', 'law.social_law_revocation_legal_norm', 'law.social_law_revocation_notice_date', 'law.social_law_revocation_notice', 'law.social_law_revocation_period_end', 'law.social_law_revocation_period_start', 'law.social_law_revocation_reason', 'law.social_law_revocation_reclaim_notes', 'law.social_law_social_benefit_type', 'law.social_law_summary_grounds_opposition', 'law.social_law_total_need_amount', 'law.social_law_total_reclaim_amount', 'law.social_law_violation_type', 'law.tenancy_law_adress_rental_property', 'law.tenancy_law_advance_payment_service_charge', 'law.tenancy_law_advance_payment_service_charges', 'law.tenancy_law_bank_guarantee', 'law.tenancy_law_cash_deposit_agreed', 'law.tenancy_law_cash_deposit_payment_date', 'law.tenancy_law_competent_court', 'law.tenancy_law_cost_share', 'law.tenancy_law_cost_shares', 'law.tenancy_law_counter_number', 'law.tenancy_law_court_case_number', 'law.tenancy_law_court_proceedings_pending', 'law.tenancy_law_description_of_rental_property', 'law.tenancy_law_duration_of_lease', 'law.tenancy_law_expert_report_commission_date', 'law.tenancy_law_expert_report_damage_description', 'law.tenancy_law_expert_report_damage_number', 'law.tenancy_law_expert_report_date', 'law.tenancy_law_expert_report_inspection_date', 'law.tenancy_law_expert_report', 'law.tenancy_law_expert_report_object_address', 'law.tenancy_law_expert_report_purpose', 'law.tenancy_law_expert_report_repair_duration', 'law.tenancy_law_expert_report_subject', 'law.tenancy_law_extension_option_count', 'law.tenancy_law_extension_option_duration', 'law.tenancy_law_fixed_term_tenancy', 'law.tenancy_law_garage_available', 'law.tenancy_law_garage_costs', 'law.tenancy_law_general_status_documents', 'law.tenancy_law_gross_rent', 'law.tenancy_law_handover_counter', 'law.tenancy_law_handover_date', 'law.tenancy_law_handover_defects', 'law.tenancy_law_handover_protocol', 'law.tenancy_law_landlord_termination_given', 'law.tenancy_law_last_rent_increase_letter_date', 'law.tenancy_law_last_signature_date', 'law.tenancy_law_lease_agreement', 'law.tenancy_law_location_in_rental_property', 'law.tenancy_law_net_rent', 'law.tenancy_law_operating_costs_agreement', 'law.tenancy_law_parking_space_available', 'law.tenancy_law_parking_space_costs', 'law.tenancy_law_property_return_date', 'law.tenancy_law_rent_increase_effective_date', 'law.tenancy_law_rent_increase_notice', 'law.tenancy_law_rental_agreement_date', 'law.tenancy_law_rental_agreement_duration', 'law.tenancy_law_rental_agreement', 'law.tenancy_law_rental_agreement_validity_end', 'law.tenancy_law_rental_agreement_validity_start', 'law.tenancy_law_rental_object_size_sqm', 'law.tenancy_law_repayment', 'law.tenancy_law_repayment_period_end', 'law.tenancy_law_repayment_period_start', 'law.tenancy_law_security_deposit_additional_regulations', 'law.tenancy_law_security_deposit_amount', 'law.tenancy_law_service_charge_settlement', 'law.tenancy_law_staggered_rental_agreement', 'law.tenancy_law_start_of_lease', 'law.tenancy_law_tenancy_terminated', 'law.tenancy_law_tenancy_termination_date', 'law.tenancy_law_tenant_extension_option', 'law.tenancy_law_tenant_warned', 'law.tenancy_law_termination_declared_date', 'law.tenancy_law_termination_letter_date', 'law.tenancy_law_termination_notice', 'law.tenancy_law_termination_notice_period', 'law.tenancy_law_total_cost_service_charge', 'law.tenancy_law_total_rent', 'law.tenancy_law_unlimited_term_tenancy', 'law.tenancy_law_value_security_clause', 'law.tenancy_law_warning_letter_date', 'law.tenancy_law_warning_letter', 'law.topic', 'law.traffic_law_accident_date', 'law.traffic_law_accident_report', 'law.traffic_law_amount_of_fine', 'law.traffic_law_appeal_instruction', 'law.traffic_law_at_fault_driver_drivers_license_issued_by', 'law.traffic_law_at_fault_driver_drivers_license_valid_until', 'law.traffic_law_at_fault_driver_green_card_number', 'law.traffic_law_at_fault_driver_insurance_expiry_date', 'law.traffic_law_at_fault_driver_insurance_number', 'law.traffic_law_at_fault_driver_insurer', 'law.traffic_law_blood_alcohol_concentration', 'law.traffic_law_calculated_total_damage_costs', 'law.traffic_law_calculated_total_days', 'law.traffic_law_charges', 'law.traffic_law_cost_per_scale', 'law.traffic_law_daily_rate', 'law.traffic_law_damage_number', 'law.traffic_law_damage_scope', 'law.traffic_law_date_of_accident', 'law.traffic_law_date_of_crime', 'law.traffic_law_date_of_fine', 'law.traffic_law_date_of_infraction', 'law.traffic_law_date_of_inspection', 'law.traffic_law_date_of_issue', 'law.traffic_law_date_of_offense', 'law.traffic_law_date_of_report', 'law.traffic_law_differencial_tax', 'law.traffic_law_driver_logbook_required', 'law.traffic_law_driving_ban_duration', 'law.traffic_law_driving_ban', 'law.traffic_law_evidence_infraction', 'law.traffic_law_expert_cost', 'law.traffic_law_expert_date', 'law.traffic_law_expert_report', 'law.traffic_law_expert_report_number', 'law.traffic_law_file_number', 'law.traffic_law_fine', 'law.traffic_law_fine_notice', 'law.traffic_law_gross_gross_replacement_value', 'law.traffic_law_gross_replacement_value', 'law.traffic_law_injured', 'law.traffic_law_insurance_holder', 'law.traffic_law_insurance', 'law.traffic_law_insurance_policy_number', 'law.traffic_law_legal_basis_infraction', 'law.traffic_law_legal_basis', 'law.traffic_law_licenseplate_at_fault_driver', 'law.traffic_law_licenseplate', 'law.traffic_law_licenseplate_victim_driver', 'law.traffic_law_loss_amount_repair_case', 'law.traffic_law_loss_amount_total_damage_case', 'law.traffic_law_loss_of_use_per_day', 'law.traffic_law_mark_and_type_of_at_fault_driver', 'law.traffic_law_mark_and_type_of_victim_driver', 'law.traffic_law_merantile_value_loss', 'law.traffic_law_net_gross_replacement_value', 'law.traffic_law_net_replacement_value', 'law.traffic_law_number_of_daily_rates', 'law.traffic_law_offense_infraction_description', 'law.traffic_law_other_damages', 'law.traffic_law_payment_deadline', 'law.traffic_law_penalty_order', 'law.traffic_law_place_of_accident', 'law.traffic_law_place_of_crime', 'law.traffic_law_place_of_infraction', 'law.traffic_law_place_of_inspection', 'law.traffic_law_place_of_issue', 'law.traffic_law_place_of_offense', 'law.traffic_law_points_for_offense', 'law.traffic_law_police_case_number', 'law.traffic_law_procedure_costs', 'law.traffic_law_prosecution_number', 'law.traffic_law_regular_tax', 'law.traffic_law_repair_costs_with_vat', 'law.traffic_law_repair_costs_without_vat', 'law.traffic_law_repair_damage', 'law.traffic_law_repair_duration', 'law.traffic_law_replacement_cost', 'law.traffic_law_replacement_value', 'law.traffic_law_reregistration_cost', 'law.traffic_law_residual_value', 'law.traffic_law_speed_allowed', 'law.traffic_law_speed_driven', 'law.traffic_law_speed_too_high', 'law.traffic_law_time_of_accident', 'law.traffic_law_time_of_crime', 'law.traffic_law_time_of_infraction', 'law.traffic_law_time_of_inspection', 'law.traffic_law_time_of_issue', 'law.traffic_law_time_of_offense', 'law.traffic_law_total_damage', 'law.traffic_law_vehicle_age_months', 'law.traffic_law_vehicle_mileage', 'law.traffic_law_vehicle_type_and_brand', 'law.traffic_law_victim_driver_drivers_license_issued_by', 'law.traffic_law_victim_driver_green_card_number', 'law.traffic_law_victim_driver_insurance_expiry_date', 'law.traffic_law_victim_driver_insurance_number', 'law.traffic_law_victim_driver_insurer', 'law.traffic_law_victim_driver_license_valid_until', 'law.traffic_law_violated_section', 'law.traffic_law_violation_type', 'law.traffic_law_warning_fee_infraction', 'law.traffic_law_warning_notice'],
    type: 'string',
    description: `* \`entities.field.address_line_2\` - entities.field.address_line_2
* \`entities.field.bank_name\` - entities.field.bank_name
* \`entities.field.bic\` - entities.field.bic
* \`entities.field.city\` - entities.field.city
* \`entities.field.company_legal_form\` - entities.field.company_legal_form
* \`entities.field.company_name\` - entities.field.company_name
* \`entities.field.company_register_court\` - entities.field.company_register_court
* \`entities.field.company_register_number\` - entities.field.company_register_number
* \`entities.field.company_tax_id\` - entities.field.company_tax_id
* \`entities.field.company_vat_id\` - entities.field.company_vat_id
* \`entities.field.date_of_birth\` - entities.field.date_of_birth
* \`entities.field.date_of_death\` - entities.field.date_of_death
* \`entities.field.email\` - entities.field.email
* \`entities.field.entity_type\` - entities.field.entity_type
* \`entities.field.fax\` - entities.field.fax
* \`entities.field.first_name\` - entities.field.first_name
* \`entities.field.iban\` - entities.field.iban
* \`entities.field.institution_name\` - entities.field.institution_name
* \`entities.field.is_entitled_to_deduct_vat\` - entities.field.is_entitled_to_deduct_vat
* \`entities.field.is_valid_email\` - entities.field.is_valid_email
* \`entities.field.is_valid_phone_number\` - entities.field.is_valid_phone_number
* \`entities.field.last_name\` - entities.field.last_name
* \`entities.field.legal_insurance_deductible_amount\` - entities.field.legal_insurance_deductible_amount
* \`entities.field.legal_insurance\` - entities.field.legal_insurance
* \`entities.field.legal_insurance_name\` - entities.field.legal_insurance_name
* \`entities.field.legal_insurance_number\` - entities.field.legal_insurance_number
* \`entities.field.marital_status\` - entities.field.marital_status
* \`entities.field.phone\` - entities.field.phone
* \`entities.field.specific_title\` - entities.field.specific_title
* \`entities.field.street\` - entities.field.street
* \`entities.field.street_number\` - entities.field.street_number
* \`entities.field.title\` - entities.field.title
* \`entities.field.website\` - entities.field.website
* \`entities.field.zip\` - entities.field.zip
* \`law.civil_law_accessories_sold_separately\` - law.civil_law_accessories_sold_separately
* \`law.civil_law_case_number\` - law.civil_law_case_number
* \`law.civil_law_claim_amount\` - law.civil_law_claim_amount
* \`law.civil_law_contract_date\` - law.civil_law_contract_date
* \`law.civil_law_contract_duration\` - law.civil_law_contract_duration
* \`law.civil_law_contract_end_date\` - law.civil_law_contract_end_date
* \`law.civil_law_contract\` - law.civil_law_contract
* \`law.civil_law_contract_object\` - law.civil_law_contract_object
* \`law.civil_law_contract_start_date\` - law.civil_law_contract_start_date
* \`law.civil_law_contract_value\` - law.civil_law_contract_value
* \`law.civil_law_correspondence\` - law.civil_law_correspondence
* \`law.civil_law_court_costs\` - law.civil_law_court_costs
* \`law.civil_law_court_document\` - law.civil_law_court_document
* \`law.civil_law_court_name\` - law.civil_law_court_name
* \`law.civil_law_damage_amount\` - law.civil_law_damage_amount
* \`law.civil_law_damage_cause\` - law.civil_law_damage_cause
* \`law.civil_law_damage_claim\` - law.civil_law_damage_claim
* \`law.civil_law_damage_date\` - law.civil_law_damage_date
* \`law.civil_law_damage_description\` - law.civil_law_damage_description
* \`law.civil_law_default_interest\` - law.civil_law_default_interest
* \`law.civil_law_defects\` - law.civil_law_defects
* \`law.civil_law_defects_present\` - law.civil_law_defects_present
* \`law.civil_law_delivery_date\` - law.civil_law_delivery_date
* \`law.civil_law_document_date\` - law.civil_law_document_date
* \`law.civil_law_file_reference\` - law.civil_law_file_reference
* \`law.civil_law_handover_date\` - law.civil_law_handover_date
* \`law.civil_law_hearing_date\` - law.civil_law_hearing_date
* \`law.civil_law_insurance_claim_number\` - law.civil_law_insurance_claim_number
* \`law.civil_law_interest_rate\` - law.civil_law_interest_rate
* \`law.civil_law_judgment_date\` - law.civil_law_judgment_date
* \`law.civil_law_liability_percentage\` - law.civil_law_liability_percentage
* \`law.civil_law_notarial_certification_date\` - law.civil_law_notarial_certification_date
* \`law.civil_law_payment_due_date\` - law.civil_law_payment_due_date
* \`law.civil_law_purchase_agreement\` - law.civil_law_purchase_agreement
* \`law.civil_law_purchase_contract_file_reference\` - law.civil_law_purchase_contract_file_reference
* \`law.civil_law_purchase_date\` - law.civil_law_purchase_date
* \`law.civil_law_purchase_object\` - law.civil_law_purchase_object
* \`law.civil_law_purchase_price_components\` - law.civil_law_purchase_price_components
* \`law.civil_law_purchase_price\` - law.civil_law_purchase_price
* \`law.civil_law_purchase_price_paid_amount\` - law.civil_law_purchase_price_paid_amount
* \`law.civil_law_purchase_price_paid_boolean\` - law.civil_law_purchase_price_paid_boolean
* \`law.civil_law_purchase_price_paid_date\` - law.civil_law_purchase_price_paid_date
* \`law.civil_law_purchase_price_paid\` - law.civil_law_purchase_price_paid
* \`law.civil_law_purchase_price_payment_date\` - law.civil_law_purchase_price_payment_date
* \`law.civil_law_subject_line\` - law.civil_law_subject_line
* \`law.civil_law_termination_notice_period\` - law.civil_law_termination_notice_period
* \`law.civil_law_vehicle_make\` - law.civil_law_vehicle_make
* \`law.civil_law_vehicle_mileage\` - law.civil_law_vehicle_mileage
* \`law.civil_law_vehicle_model\` - law.civil_law_vehicle_model
* \`law.civil_law_vehicle_vin\` - law.civil_law_vehicle_vin
* \`law.civil_law_vehicle_year\` - law.civil_law_vehicle_year
* \`law.civil_law_warranty_period\` - law.civil_law_warranty_period
* \`law.criminal_law_amount_of_daily_rates\` - law.criminal_law_amount_of_daily_rates
* \`law.criminal_law_applicable_laws\` - law.criminal_law_applicable_laws
* \`law.criminal_law_charge_description\` - law.criminal_law_charge_description
* \`law.criminal_law_complaint\` - law.criminal_law_complaint
* \`law.criminal_law_criminal_warrant\` - law.criminal_law_criminal_warrant
* \`law.criminal_law_damage_description\` - law.criminal_law_damage_description
* \`law.criminal_law_damage_value\` - law.criminal_law_damage_value
* \`law.criminal_law_date_of_offense\` - law.criminal_law_date_of_offense
* \`law.criminal_law_duration_of_prison_sentence\` - law.criminal_law_duration_of_prison_sentence
* \`law.criminal_law_evidence_location\` - law.criminal_law_evidence_location
* \`law.criminal_law_evidence\` - law.criminal_law_evidence
* \`law.criminal_law_incident_description\` - law.criminal_law_incident_description
* \`law.criminal_law_indictment_date\` - law.criminal_law_indictment_date
* \`law.criminal_law_indictment_delivery_date\` - law.criminal_law_indictment_delivery_date
* \`law.criminal_law_indictment\` - law.criminal_law_indictment
* \`law.criminal_law_legal_classification_of_offense\` - law.criminal_law_legal_classification_of_offense
* \`law.criminal_law_means_of_evidence\` - law.criminal_law_means_of_evidence
* \`law.criminal_law_number_of_daily_rates\` - law.criminal_law_number_of_daily_rates
* \`law.criminal_law_offense_type\` - law.criminal_law_offense_type
* \`law.criminal_law_penalty_infromation\` - law.criminal_law_penalty_infromation
* \`law.criminal_law_physical_evidence\` - law.criminal_law_physical_evidence
* \`law.criminal_law_place_of_offense\` - law.criminal_law_place_of_offense
* \`law.criminal_law_police_file_number\` - law.criminal_law_police_file_number
* \`law.criminal_law_preliminary_proceedings_date\` - law.criminal_law_preliminary_proceedings_date
* \`law.criminal_law_prison_sentence\` - law.criminal_law_prison_sentence
* \`law.criminal_law_probation\` - law.criminal_law_probation
* \`law.criminal_law_prosecution_file_number\` - law.criminal_law_prosecution_file_number
* \`law.criminal_law_report_date\` - law.criminal_law_report_date
* \`law.criminal_law_report_time\` - law.criminal_law_report_time
* \`law.criminal_law_time_of_offense\` - law.criminal_law_time_of_offense
* \`law.debt_collection_law_business_fee\` - law.debt_collection_law_business_fee
* \`law.debt_collection_law_case_value\` - law.debt_collection_law_case_value
* \`law.debt_collection_law_invoice_amount\` - law.debt_collection_law_invoice_amount
* \`law.debt_collection_law_invoice_date\` - law.debt_collection_law_invoice_date
* \`law.debt_collection_law_invoice_ground\` - law.debt_collection_law_invoice_ground
* \`law.debt_collection_law_invoice_lawyer\` - law.debt_collection_law_invoice_lawyer
* \`law.debt_collection_law_invoice\` - law.debt_collection_law_invoice
* \`law.debt_collection_law_invoice_number\` - law.debt_collection_law_invoice_number
* \`law.debt_collection_law_invoice_recipient\` - law.debt_collection_law_invoice_recipient
* \`law.debt_collection_law_invoice_tax_number\` - law.debt_collection_law_invoice_tax_number
* \`law.debt_collection_law_lumps_sum_expenses\` - law.debt_collection_law_lumps_sum_expenses
* \`law.debt_collection_law_sales_tax\` - law.debt_collection_law_sales_tax
* \`law.debt_collection_law_subtotal_lawyer_fees\` - law.debt_collection_law_subtotal_lawyer_fees
* \`law.debt_collection_law_total_amount\` - law.debt_collection_law_total_amount
* \`law.external_case_id\` - law.external_case_id
* \`law.family_law_average_net_income\` - law.family_law_average_net_income
* \`law.family_law_birth_certificate\` - law.family_law_birth_certificate
* \`law.family_law_birth_register_number\` - law.family_law_birth_register_number
* \`law.family_law_birth_register_office_location\` - law.family_law_birth_register_office_location
* \`law.family_law_children\` - law.family_law_children
* \`law.family_law_date_of_marriage\` - law.family_law_date_of_marriage
* \`law.family_law_divorce_application\` - law.family_law_divorce_application
* \`law.family_law_divorce_settlement_agreement\` - law.family_law_divorce_settlement_agreement
* \`law.family_law_marriage_certificate\` - law.family_law_marriage_certificate
* \`law.family_law_marriage_contract_date\` - law.family_law_marriage_contract_date
* \`law.family_law_marriage_contract\` - law.family_law_marriage_contract
* \`law.family_law_marriage_register_number\` - law.family_law_marriage_register_number
* \`law.family_law_registry_office_location\` - law.family_law_registry_office_location
* \`law.family_law_separation_date\` - law.family_law_separation_date
* \`law.field\` - law.field
* \`law.general_law_amount_net\` - law.general_law_amount_net
* \`law.general_law_amount_total\` - law.general_law_amount_total
* \`law.general_law_appendices\` - law.general_law_appendices
* \`law.general_law_case_number\` - law.general_law_case_number
* \`law.general_law_court_costs\` - law.general_law_court_costs
* \`law.general_law_court_name\` - law.general_law_court_name
* \`law.general_law_doc_date\` - law.general_law_doc_date
* \`law.general_law_due_date\` - law.general_law_due_date
* \`law.general_law_file_ref\` - law.general_law_file_ref
* \`law.general_law_hearing_date\` - law.general_law_hearing_date
* \`law.general_law_invoice_date\` - law.general_law_invoice_date
* \`law.general_law_invoice_number\` - law.general_law_invoice_number
* \`law.general_law_judgment_date\` - law.general_law_judgment_date
* \`law.general_law_correspondence\` - law.general_law_correspondence
* \`law.general_law_court_document\` - law.general_law_court_document
* \`law.general_law_invoice\` - law.general_law_invoice
* \`law.general_law_payment_terms\` - law.general_law_payment_terms
* \`law.general_law_prior_ref\` - law.general_law_prior_ref
* \`law.general_law_subject\` - law.general_law_subject
* \`law.general_law_vat\` - law.general_law_vat
* \`law.generic_document\` - law.generic_document
* \`law.inheritance_law_certificate_of_inheritance_applicable_law\` - law.inheritance_law_certificate_of_inheritance_applicable_law
* \`law.inheritance_law_certificate_of_inheritance_date_death\` - law.inheritance_law_certificate_of_inheritance_date_death
* \`law.inheritance_law_certificate_of_inheritance_date\` - law.inheritance_law_certificate_of_inheritance_date
* \`law.inheritance_law_certificate_of_inheritance\` - law.inheritance_law_certificate_of_inheritance
* \`law.inheritance_law_certificate_of_inheritance_number\` - law.inheritance_law_certificate_of_inheritance_number
* \`law.inheritance_law_certificate_of_inheritance_place_of_death\` - law.inheritance_law_certificate_of_inheritance_place_of_death
* \`law.inheritance_law_death_certificate_date_death\` - law.inheritance_law_death_certificate_date_death
* \`law.inheritance_law_death_certificate_date\` - law.inheritance_law_death_certificate_date
* \`law.inheritance_law_death_certificate\` - law.inheritance_law_death_certificate
* \`law.inheritance_law_death_certificate_number\` - law.inheritance_law_death_certificate_number
* \`law.inheritance_law_death_certificate_place_death\` - law.inheritance_law_death_certificate_place_death
* \`law.inheritance_law_death_certificate_place\` - law.inheritance_law_death_certificate_place
* \`law.inheritance_law_death_certificate_time_death\` - law.inheritance_law_death_certificate_time_death
* \`law.inheritance_law_estate_inventory_amount\` - law.inheritance_law_estate_inventory_amount
* \`law.inheritance_law_estate_inventory_date\` - law.inheritance_law_estate_inventory_date
* \`law.inheritance_law_estate_inventory_status\` - law.inheritance_law_estate_inventory_status
* \`law.inheritance_law_inheritance_contract_date\` - law.inheritance_law_inheritance_contract_date
* \`law.inheritance_law_inheritance_contract\` - law.inheritance_law_inheritance_contract
* \`law.inheritance_law_lasting_power_of_attorney_date\` - law.inheritance_law_lasting_power_of_attorney_date
* \`law.inheritance_law_lasting_power_of_attorney\` - law.inheritance_law_lasting_power_of_attorney
* \`law.inheritance_law_list_of_estate\` - law.inheritance_law_list_of_estate
* \`law.inheritance_law_living_will\` - law.inheritance_law_living_will
* \`law.inheritance_law_patient_enrollment_date\` - law.inheritance_law_patient_enrollment_date
* \`law.inheritance_law_testament_date\` - law.inheritance_law_testament_date
* \`law.inheritance_law_will\` - law.inheritance_law_will
* \`law.labor_law_amount_dependent_children\` - law.labor_law_amount_dependent_children
* \`law.labor_law_beginning_of_employment\` - law.labor_law_beginning_of_employment
* \`law.labor_law_certificate_clause\` - law.labor_law_certificate_clause
* \`law.labor_law_child_allowances\` - law.labor_law_child_allowances
* \`law.labor_law_collective_agreement\` - law.labor_law_collective_agreement
* \`law.labor_law_company_agreement\` - law.labor_law_company_agreement
* \`law.labor_law_company_hearing\` - law.labor_law_company_hearing
* \`law.labor_law_dependent_children\` - law.labor_law_dependent_children
* \`law.labor_law_different_place_of_work\` - law.labor_law_different_place_of_work
* \`law.labor_law_disability\` - law.labor_law_disability
* \`law.labor_law_employee_probation_period_end_date\` - law.labor_law_employee_probation_period_end_date
* \`law.labor_law_end_of_employment\` - law.labor_law_end_of_employment
* \`law.labor_law_exemption_irrevocable\` - law.labor_law_exemption_irrevocable
* \`law.labor_law_exemption_revocable\` - law.labor_law_exemption_revocable
* \`law.labor_law_fixed_term_contract_duration\` - law.labor_law_fixed_term_contract_duration
* \`law.labor_law_fixed_term_contract\` - law.labor_law_fixed_term_contract
* \`law.labor_law_grade_certificate_clause\` - law.labor_law_grade_certificate_clause
* \`law.labor_law_is_employee_in_probation_period\` - law.labor_law_is_employee_in_probation_period
* \`law.labor_law_job_title\` - law.labor_law_job_title
* \`law.labor_law_local_transfer_clause\` - law.labor_law_local_transfer_clause
* \`law.labor_law_LTI\` - law.labor_law_LTI
* \`law.labor_law_married\` - law.labor_law_married
* \`law.labor_law_monthly_gross_salary\` - law.labor_law_monthly_gross_salary
* \`law.labor_law_monthly_working_days\` - law.labor_law_monthly_working_days
* \`law.labor_law_notice_period\` - law.labor_law_notice_period
* \`law.labor_law_notice_period_observed\` - law.labor_law_notice_period_observed
* \`law.labor_law_payslip\` - law.labor_law_payslip
* \`law.labor_law_percent_sprinter_clause\` - law.labor_law_percent_sprinter_clause
* \`law.labor_law_place_of_work\` - law.labor_law_place_of_work
* \`law.labor_law_pregnancy\` - law.labor_law_pregnancy
* \`law.labor_law_reaction_company_hering\` - law.labor_law_reaction_company_hering
* \`law.labor_law_reason_for_termination_given\` - law.labor_law_reason_for_termination_given
* \`law.labor_law_return_of_company_property\` - law.labor_law_return_of_company_property
* \`law.labor_law_settlement_agreement_date\` - law.labor_law_settlement_agreement_date
* \`law.labor_law_settlement_agreement\` - law.labor_law_settlement_agreement
* \`law.labor_law_severance_amount\` - law.labor_law_severance_amount
* \`law.labor_law_signature_of_employer\` - law.labor_law_signature_of_employer
* \`law.labor_law_special_documents\` - law.labor_law_special_documents
* \`law.labor_law_special_payments_amount\` - law.labor_law_special_payments_amount
* \`law.labor_law_special_payments\` - law.labor_law_special_payments
* \`law.labor_law_special_personal_circumstances\` - law.labor_law_special_personal_circumstances
* \`law.labor_law_special_protection_against_dismissal\` - law.labor_law_special_protection_against_dismissal
* \`law.labor_law_special_sentence\` - law.labor_law_special_sentence
* \`law.labor_law_sprinter_clause\` - law.labor_law_sprinter_clause
* \`law.labor_law_termination_access_to_termination_to_employee\` - law.labor_law_termination_access_to_termination_to_employee
* \`law.labor_law_termination_agreement_date\` - law.labor_law_termination_agreement_date
* \`law.labor_law_termination_agreement\` - law.labor_law_termination_agreement
* \`law.labor_law_termination_agreement_severance_pay_amount\` - law.labor_law_termination_agreement_severance_pay_amount
* \`law.labor_law_termination_agreement_termination_date\` - law.labor_law_termination_agreement_termination_date
* \`law.labor_law_termination_authorization\` - law.labor_law_termination_authorization
* \`law.labor_law_termination_date_effective\` - law.labor_law_termination_date_effective
* \`law.labor_law_termination_date\` - law.labor_law_termination_date
* \`law.labor_law_termination_employer_more_than_10_employees\` - law.labor_law_termination_employer_more_than_10_employees
* \`law.labor_law_termination_is_agreement_severance_pay\` - law.labor_law_termination_is_agreement_severance_pay
* \`law.labor_law_termination\` - law.labor_law_termination
* \`law.labor_law_termination_operational_reasons\` - law.labor_law_termination_operational_reasons
* \`law.labor_law_termination_without_notice\` - law.labor_law_termination_without_notice
* \`law.labor_law_total_gross_salary\` - law.labor_law_total_gross_salary
* \`law.labor_law_vacation_days\` - law.labor_law_vacation_days
* \`law.labor_law_visum\` - law.labor_law_visum
* \`law.labor_law_VSOP\` - law.labor_law_VSOP
* \`law.labor_law_warning_letter_access_to_warning_letter_to_employee\` - law.labor_law_warning_letter_access_to_warning_letter_to_employee
* \`law.labor_law_warning_letter_date\` - law.labor_law_warning_letter_date
* \`law.labor_law_warning_letter_incident_date\` - law.labor_law_warning_letter_incident_date
* \`law.labor_law_warning_letter_incident_location\` - law.labor_law_warning_letter_incident_location
* \`law.labor_law_warning_letter_incident_time\` - law.labor_law_warning_letter_incident_time
* \`law.labor_law_warning_letter\` - law.labor_law_warning_letter
* \`law.labor_law_warning_letter_reason\` - law.labor_law_warning_letter_reason
* \`law.labor_law_work_contract\` - law.labor_law_work_contract
* \`law.labor_law_work_council\` - law.labor_law_work_council
* \`law.labor_law_work_hours_per_week\` - law.labor_law_work_hours_per_week
* \`law.labor_law_works_council_membership\` - law.labor_law_works_council_membership
* \`law.labor_law_yearly_gross_salary\` - law.labor_law_yearly_gross_salary
* \`law.labor_law_years_of_employment\` - law.labor_law_years_of_employment
* \`law.medicine_law_health_insurance_letter_date\` - law.medicine_law_health_insurance_letter_date
* \`law.medicine_law_health_insurance_letter_decision_justification\` - law.medicine_law_health_insurance_letter_decision_justification
* \`law.medicine_law_health_insurance_letter_decision\` - law.medicine_law_health_insurance_letter_decision
* \`law.medicine_law_health_insurance_letter_legal_remedy_instruction\` - law.medicine_law_health_insurance_letter_legal_remedy_instruction
* \`law.medicine_law_health_insurance_letter\` - law.medicine_law_health_insurance_letter
* \`law.medicine_law_health_insurance_letter_reference_to_application\` - law.medicine_law_health_insurance_letter_reference_to_application
* \`law.medicine_law_hospital_records_admission_date\` - law.medicine_law_hospital_records_admission_date
* \`law.medicine_law_hospital_records_diagnoses_icd_codes\` - law.medicine_law_hospital_records_diagnoses_icd_codes
* \`law.medicine_law_hospital_records_discharge_date\` - law.medicine_law_hospital_records_discharge_date
* \`law.medicine_law_hospital_records_discharge_prognosis\` - law.medicine_law_hospital_records_discharge_prognosis
* \`law.medicine_law_hospital_records_documented_complications\` - law.medicine_law_hospital_records_documented_complications
* \`law.medicine_law_hospital_records\` - law.medicine_law_hospital_records
* \`law.medicine_law_hospital_records_medication_during_stay\` - law.medicine_law_hospital_records_medication_during_stay
* \`law.medicine_law_hospital_records_operation_date\` - law.medicine_law_hospital_records_operation_date
* \`law.medicine_law_hospital_records_operations\` - law.medicine_law_hospital_records_operations
* \`law.medicine_law_hospital_records_station\` - law.medicine_law_hospital_records_station
* \`law.medicine_law_laboratory_results_examination_date\` - law.medicine_law_laboratory_results_examination_date
* \`law.medicine_law_laboratory_results_examination_type\` - law.medicine_law_laboratory_results_examination_type
* \`law.medicine_law_laboratory_results_further_investigation_recommendation\` - law.medicine_law_laboratory_results_further_investigation_recommendation
* \`law.medicine_law_laboratory_results\` - law.medicine_law_laboratory_results
* \`law.medicine_law_laboratory_results_relevant_deviations\` - law.medicine_law_laboratory_results_relevant_deviations
* \`law.medicine_law_medical_bill_cost_bearer\` - law.medicine_law_medical_bill_cost_bearer
* \`law.medicine_law_medical_bill_invoice_date\` - law.medicine_law_medical_bill_invoice_date
* \`law.medicine_law_medical_bill_invoice_number\` - law.medicine_law_medical_bill_invoice_number
* \`law.medicine_law_medical_bill\` - law.medicine_law_medical_bill
* \`law.medicine_law_medical_bill_payment_deadline\` - law.medicine_law_medical_bill_payment_deadline
* \`law.medicine_law_medical_bill_service_period\` - law.medicine_law_medical_bill_service_period
* \`law.medicine_law_medical_bill_services_list\` - law.medicine_law_medical_bill_services_list
* \`law.medicine_law_medical_bill_total_amount\` - law.medicine_law_medical_bill_total_amount
* \`law.medicine_law_medical_expertise_date\` - law.medicine_law_medical_expertise_date
* \`law.medicine_law_medical_expertise_justification\` - law.medicine_law_medical_expertise_justification
* \`law.medicine_law_medical_expertise\` - law.medicine_law_medical_expertise
* \`law.medicine_law_medical_expertise_medical_assessment\` - law.medicine_law_medical_expertise_medical_assessment
* \`law.medicine_law_medical_expertise_question_posed\` - law.medicine_law_medical_expertise_question_posed
* \`law.medicine_law_medical_expertise_result\` - law.medicine_law_medical_expertise_result
* \`law.medicine_law_medical_report_complications\` - law.medicine_law_medical_report_complications
* \`law.medicine_law_medical_report_date\` - law.medicine_law_medical_report_date
* \`law.medicine_law_medical_report_diagnosis_icd_code\` - law.medicine_law_medical_report_diagnosis_icd_code
* \`law.medicine_law_medical_report_diagnosis_short_text\` - law.medicine_law_medical_report_diagnosis_short_text
* \`law.medicine_law_medical_report_further_treatment\` - law.medicine_law_medical_report_further_treatment
* \`law.medicine_law_medical_report\` - law.medicine_law_medical_report
* \`law.medicine_law_medical_report_surgery_date\` - law.medicine_law_medical_report_surgery_date
* \`law.medicine_law_medical_report_treatment_measures\` - law.medicine_law_medical_report_treatment_measures
* \`law.medicine_law_medical_report_treatment_period\` - law.medicine_law_medical_report_treatment_period
* \`law.migration_law_approval_notice_case_number\` - law.migration_law_approval_notice_case_number
* \`law.migration_law_approval_notice_conditions\` - law.migration_law_approval_notice_conditions
* \`law.migration_law_approval_notice_decision_date\` - law.migration_law_approval_notice_decision_date
* \`law.migration_law_approval_notice_issuing_authority\` - law.migration_law_approval_notice_issuing_authority
* \`law.migration_law_approval_notice\` - law.migration_law_approval_notice
* \`law.migration_law_approval_notice_permit_type\` - law.migration_law_approval_notice_permit_type
* \`law.migration_law_approval_notice_pickup_deadline\` - law.migration_law_approval_notice_pickup_deadline
* \`law.migration_law_approval_notice_validity_period\` - law.migration_law_approval_notice_validity_period
* \`law.migration_law_asylum_seeker_certificate_application_number\` - law.migration_law_asylum_seeker_certificate_application_number
* \`law.migration_law_asylum_seeker_certificate_first_registration_date\` - law.migration_law_asylum_seeker_certificate_first_registration_date
* \`law.migration_law_asylum_seeker_certificate_issue_date\` - law.migration_law_asylum_seeker_certificate_issue_date
* \`law.migration_law_asylum_seeker_certificate_issuing_authority\` - law.migration_law_asylum_seeker_certificate_issuing_authority
* \`law.migration_law_asylum_seeker_certificate\` - law.migration_law_asylum_seeker_certificate
* \`law.migration_law_asylum_seeker_certificate_residence_obligation\` - law.migration_law_asylum_seeker_certificate_residence_obligation
* \`law.migration_law_asylum_seeker_certificate_valid_until\` - law.migration_law_asylum_seeker_certificate_valid_until
* \`law.migration_law_asylum_seeker_certificate_work_permission\` - law.migration_law_asylum_seeker_certificate_work_permission
* \`law.migration_law_cooperation_letter_attachments\` - law.migration_law_cooperation_letter_attachments
* \`law.migration_law_cooperation_letter_date\` - law.migration_law_cooperation_letter_date
* \`law.migration_law_cooperation_letter_deadlines\` - law.migration_law_cooperation_letter_deadlines
* \`law.migration_law_cooperation_letter_file_number\` - law.migration_law_cooperation_letter_file_number
* \`law.migration_law_cooperation_letter\` - law.migration_law_cooperation_letter
* \`law.migration_law_cooperation_letter_non_cooperation_consequences\` - law.migration_law_cooperation_letter_non_cooperation_consequences
* \`law.migration_law_cooperation_letter_specified_obligations\` - law.migration_law_cooperation_letter_specified_obligations
* \`law.migration_law_fictional_certificate_authority\` - law.migration_law_fictional_certificate_authority
* \`law.migration_law_fictional_certificate_fiction_type\` - law.migration_law_fictional_certificate_fiction_type
* \`law.migration_law_fictional_certificate_issue_date\` - law.migration_law_fictional_certificate_issue_date
* \`law.migration_law_fictional_certificate_legal_basis\` - law.migration_law_fictional_certificate_legal_basis
* \`law.migration_law_fictional_certificate\` - law.migration_law_fictional_certificate
* \`law.migration_law_fictional_certificate_reason_for_issuance\` - law.migration_law_fictional_certificate_reason_for_issuance
* \`law.migration_law_fictional_certificate_valid_until\` - law.migration_law_fictional_certificate_valid_until
* \`law.migration_law_hearing_letter_date\` - law.migration_law_hearing_letter_date
* \`law.migration_law_hearing_letter_intended_measure_justification\` - law.migration_law_hearing_letter_intended_measure_justification
* \`law.migration_law_hearing_letter_legal_advice\` - law.migration_law_hearing_letter_legal_advice
* \`law.migration_law_hearing_letter\` - law.migration_law_hearing_letter
* \`law.migration_law_hearing_letter_requested_documents\` - law.migration_law_hearing_letter_requested_documents
* \`law.migration_law_hearing_letter_response_deadline\` - law.migration_law_hearing_letter_response_deadline
* \`law.migration_law_other_letters_action_required\` - law.migration_law_other_letters_action_required
* \`law.migration_law_other_letters_date\` - law.migration_law_other_letters_date
* \`law.migration_law_other_letters_deadlines\` - law.migration_law_other_letters_deadlines
* \`law.migration_law_other_letters_file_number\` - law.migration_law_other_letters_file_number
* \`law.migration_law_other_letters_issuing_authority\` - law.migration_law_other_letters_issuing_authority
* \`law.migration_law_other_letters_legal_basis\` - law.migration_law_other_letters_legal_basis
* \`law.migration_law_other_letters\` - law.migration_law_other_letters
* \`law.migration_law_other_letters_matter_purpose\` - law.migration_law_other_letters_matter_purpose
* \`law.migration_law_other_letters_subject\` - law.migration_law_other_letters_subject
* \`law.migration_law_rejection_notice_case_number\` - law.migration_law_rejection_notice_case_number
* \`law.migration_law_rejection_notice_decision_date\` - law.migration_law_rejection_notice_decision_date
* \`law.migration_law_rejection_notice_legal_grounds\` - law.migration_law_rejection_notice_legal_grounds
* \`law.migration_law_rejection_notice_legal_remedy_deadline\` - law.migration_law_rejection_notice_legal_remedy_deadline
* \`law.migration_law_rejection_notice\` - law.migration_law_rejection_notice
* \`law.migration_law_rejection_notice_officer_name\` - law.migration_law_rejection_notice_officer_name
* \`law.migration_law_rejection_notice_reasoning\` - law.migration_law_rejection_notice_reasoning
* \`law.migration_law_rejection_notice_signature_seal\` - law.migration_law_rejection_notice_signature_seal
* \`law.migration_law_rejection_notice_subject\` - law.migration_law_rejection_notice_subject
* \`law.migration_law_residence_permit_conditions\` - law.migration_law_residence_permit_conditions
* \`law.migration_law_residence_permit_issue_date\` - law.migration_law_residence_permit_issue_date
* \`law.migration_law_residence_permit_issuing_authority\` - law.migration_law_residence_permit_issuing_authority
* \`law.migration_law_residence_permit\` - law.migration_law_residence_permit
* \`law.migration_law_residence_permit_national_id_number\` - law.migration_law_residence_permit_national_id_number
* \`law.migration_law_residence_permit_passport_number\` - law.migration_law_residence_permit_passport_number
* \`law.migration_law_residence_permit_purpose\` - law.migration_law_residence_permit_purpose
* \`law.migration_law_residence_permit_type\` - law.migration_law_residence_permit_type
* \`law.migration_law_residence_permit_valid_until\` - law.migration_law_residence_permit_valid_until
* \`law.migration_law_toleration_issue_date\` - law.migration_law_toleration_issue_date
* \`law.migration_law_toleration_issuing_authority\` - law.migration_law_toleration_issuing_authority
* \`law.migration_law_toleration_legal_basis\` - law.migration_law_toleration_legal_basis
* \`law.migration_law_toleration\` - law.migration_law_toleration
* \`law.migration_law_toleration_reason\` - law.migration_law_toleration_reason
* \`law.migration_law_toleration_restrictions\` - law.migration_law_toleration_restrictions
* \`law.migration_law_toleration_valid_until\` - law.migration_law_toleration_valid_until
* \`law.real_estate_law_basic_debts_amount\` - law.real_estate_law_basic_debts_amount
* \`law.real_estate_law_broker_commission_amount\` - law.real_estate_law_broker_commission_amount
* \`law.real_estate_law_broker_contract_type\` - law.real_estate_law_broker_contract_type
* \`law.real_estate_law_broker_scope_of_work\` - law.real_estate_law_broker_scope_of_work
* \`law.real_estate_law_broker_termination_periods\` - law.real_estate_law_broker_termination_periods
* \`law.real_estate_law_brokerage_contract_date\` - law.real_estate_law_brokerage_contract_date
* \`law.real_estate_law_brokerage_contract\` - law.real_estate_law_brokerage_contract
* \`law.real_estate_law_brokerage_fee\` - law.real_estate_law_brokerage_fee
* \`law.real_estate_law_building_dimensions\` - law.real_estate_law_building_dimensions
* \`law.real_estate_law_building_permit_date\` - law.real_estate_law_building_permit_date
* \`law.real_estate_law_building_permit\` - law.real_estate_law_building_permit
* \`law.real_estate_law_building_permit_number\` - law.real_estate_law_building_permit_number
* \`law.real_estate_law_building_permit_validity_duration\` - law.real_estate_law_building_permit_validity_duration
* \`law.real_estate_law_building_plan\` - law.real_estate_law_building_plan
* \`law.real_estate_law_building_restrictions_clause\` - law.real_estate_law_building_restrictions_clause
* \`law.real_estate_law_building_usage\` - law.real_estate_law_building_usage
* \`law.real_estate_law_co_ownership_share\` - law.real_estate_law_co_ownership_share
* \`law.real_estate_law_commission_percentage\` - law.real_estate_law_commission_percentage
* \`law.real_estate_law_contaminated_sites_clause\` - law.real_estate_law_contaminated_sites_clause
* \`law.real_estate_law_declaration_of_division\` - law.real_estate_law_declaration_of_division
* \`law.real_estate_law_division_declaration_date\` - law.real_estate_law_division_declaration_date
* \`law.real_estate_law_encumbrance_restrictions\` - law.real_estate_law_encumbrance_restrictions
* \`law.real_estate_law_encumbrances_section_ii\` - law.real_estate_law_encumbrances_section_ii
* \`law.real_estate_law_encumbrances_section_iii\` - law.real_estate_law_encumbrances_section_iii
* \`law.real_estate_law_exclusive_brokerage_contract\` - law.real_estate_law_exclusive_brokerage_contract
* \`law.real_estate_law_full_repayment_date\` - law.real_estate_law_full_repayment_date
* \`law.real_estate_law_installment_amount\` - law.real_estate_law_installment_amount
* \`law.real_estate_law_interest_rate\` - law.real_estate_law_interest_rate
* \`law.real_estate_law_land_register_address\` - law.real_estate_law_land_register_address
* \`law.real_estate_law_land_register_city\` - law.real_estate_law_land_register_city
* \`law.real_estate_law_land_register_date\` - law.real_estate_law_land_register_date
* \`law.real_estate_law_land_register\` - law.real_estate_law_land_register
* \`law.real_estate_law_land_register_number\` - law.real_estate_law_land_register_number
* \`law.real_estate_law_land_register_plot_of_land\` - law.real_estate_law_land_register_plot_of_land
* \`law.real_estate_law_legal_defects_clause\` - law.real_estate_law_legal_defects_clause
* \`law.real_estate_law_loan_agreement\` - law.real_estate_law_loan_agreement
* \`law.real_estate_law_loan_amount\` - law.real_estate_law_loan_amount
* \`law.real_estate_law_loan_security\` - law.real_estate_law_loan_security
* \`law.real_estate_law_monument_protection_basis\` - law.real_estate_law_monument_protection_basis
* \`law.real_estate_law_monument_protection_notice\` - law.real_estate_law_monument_protection_notice
* \`law.real_estate_law_monument_protection_order_date\` - law.real_estate_law_monument_protection_order_date
* \`law.real_estate_law_monument_protection_order_number\` - law.real_estate_law_monument_protection_order_number
* \`law.real_estate_law_monument_protection_requirements\` - law.real_estate_law_monument_protection_requirements
* \`law.real_estate_law_monument_registration_date\` - law.real_estate_law_monument_registration_date
* \`law.real_estate_law_plan_author\` - law.real_estate_law_plan_author
* \`law.real_estate_law_plan_designation\` - law.real_estate_law_plan_designation
* \`law.real_estate_law_plan_scale\` - law.real_estate_law_plan_scale
* \`law.real_estate_law_plot_size\` - law.real_estate_law_plot_size
* \`law.real_estate_law_property_brokered_by_agent\` - law.real_estate_law_property_brokered_by_agent
* \`law.real_estate_law_purchase_contract_amount\` - law.real_estate_law_purchase_contract_amount
* \`law.real_estate_law_purchase_contract_date\` - law.real_estate_law_purchase_contract_date
* \`law.real_estate_law_purchase_contract_description\` - law.real_estate_law_purchase_contract_description
* \`law.real_estate_law_purchase_contract\` - law.real_estate_law_purchase_contract
* \`law.real_estate_law_purchase_contract_registration_date\` - law.real_estate_law_purchase_contract_registration_date
* \`law.real_estate_law_purchase_contract_registration_number\` - law.real_estate_law_purchase_contract_registration_number
* \`law.real_estate_law_purchase_object_rented\` - law.real_estate_law_purchase_object_rented
* \`law.real_estate_law_purchase_price_loan_financed\` - law.real_estate_law_purchase_price_loan_financed
* \`law.real_estate_law_repayment_rate\` - law.real_estate_law_repayment_rate
* \`law.real_estate_law_withdrawal_instruction_date\` - law.real_estate_law_withdrawal_instruction_date
* \`law.residential_property_law_co_ownership_shares\` - law.residential_property_law_co_ownership_shares
* \`law.residential_property_law_contract_date\` - law.residential_property_law_contract_date
* \`law.residential_property_law_contract\` - law.residential_property_law_contract
* \`law.residential_property_law_inventory\` - law.residential_property_law_inventory
* \`law.residential_property_law_land_register_address\` - law.residential_property_law_land_register_address
* \`law.residential_property_law_land_register_city\` - law.residential_property_law_land_register_city
* \`law.residential_property_law_land_register_number\` - law.residential_property_law_land_register_number
* \`law.residential_property_law_land_register_plot_of_land\` - law.residential_property_law_land_register_plot_of_land
* \`law.social_law_affected_benefit\` - law.social_law_affected_benefit
* \`law.social_law_application_arrival_date\` - law.social_law_application_arrival_date
* \`law.social_law_application_date\` - law.social_law_application_date
* \`law.social_law_application_file_reference\` - law.social_law_application_file_reference
* \`law.social_law_application_form\` - law.social_law_application_form
* \`law.social_law_appointment_date\` - law.social_law_appointment_date
* \`law.social_law_appointment_file_reference\` - law.social_law_appointment_file_reference
* \`law.social_law_appointment_invitation\` - law.social_law_appointment_invitation
* \`law.social_law_appointment_purpose\` - law.social_law_appointment_purpose
* \`law.social_law_appointment_required_documents\` - law.social_law_appointment_required_documents
* \`law.social_law_appointment_time\` - law.social_law_appointment_time
* \`law.social_law_approval_file_reference\` - law.social_law_approval_file_reference
* \`law.social_law_approval_internal_reference\` - law.social_law_approval_internal_reference
* \`law.social_law_approval_legal_basis\` - law.social_law_approval_legal_basis
* \`law.social_law_approval_notice_date\` - law.social_law_approval_notice_date
* \`law.social_law_approval_notice\` - law.social_law_approval_notice
* \`law.social_law_approval_period_end\` - law.social_law_approval_period_end
* \`law.social_law_approval_period_start\` - law.social_law_approval_period_start
* \`law.social_law_approved_benefit_amount\` - law.social_law_approved_benefit_amount
* \`law.social_law_approved_benefit_period\` - law.social_law_approved_benefit_period
* \`law.social_law_approved_benefit_type\` - law.social_law_approved_benefit_type
* \`law.social_law_asset_type\` - law.social_law_asset_type
* \`law.social_law_attachment_list\` - law.social_law_attachment_list
* \`law.social_law_benefit_type\` - law.social_law_benefit_type
* \`law.social_law_change_description\` - law.social_law_change_description
* \`law.social_law_change_file_reference\` - law.social_law_change_file_reference
* \`law.social_law_change_notification_date\` - law.social_law_change_notification_date
* \`law.social_law_change_notification\` - law.social_law_change_notification
* \`law.social_law_change_reason\` - law.social_law_change_reason
* \`law.social_law_creditable_income\` - law.social_law_creditable_income
* \`law.social_law_disability_card_issue_date\` - law.social_law_disability_card_issue_date
* \`law.social_law_disability_card\` - law.social_law_disability_card
* \`law.social_law_disability_card_markers\` - law.social_law_disability_card_markers
* \`law.social_law_disability_card_validity_period\` - law.social_law_disability_card_validity_period
* \`law.social_law_disability_degree\` - law.social_law_disability_degree
* \`law.social_law_disability_file_reference\` - law.social_law_disability_file_reference
* \`law.social_law_employment_income\` - law.social_law_employment_income
* \`law.social_law_follow_up_application_notes\` - law.social_law_follow_up_application_notes
* \`law.social_law_hearing_file_reference\` - law.social_law_hearing_file_reference
* \`law.social_law_hearing_letter_date\` - law.social_law_hearing_letter_date
* \`law.social_law_hearing_letter\` - law.social_law_hearing_letter
* \`law.social_law_hearing_planned_administrative_act\` - law.social_law_hearing_planned_administrative_act
* \`law.social_law_housing_costs_amount\` - law.social_law_housing_costs_amount
* \`law.social_law_income_amount\` - law.social_law_income_amount
* \`law.social_law_income_date\` - law.social_law_income_date
* \`law.social_law_income_legal_basis\` - law.social_law_income_legal_basis
* \`law.social_law_income_provider\` - law.social_law_income_provider
* \`law.social_law_income_source\` - law.social_law_income_source
* \`law.social_law_income_type\` - law.social_law_income_type
* \`law.social_law_interim_legal_protection\` - law.social_law_interim_legal_protection
* \`law.social_law_interim_protection_affidavit\` - law.social_law_interim_protection_affidavit
* \`law.social_law_interim_protection_attachment_list\` - law.social_law_interim_protection_attachment_list
* \`law.social_law_interim_protection_file_reference\` - law.social_law_interim_protection_file_reference
* \`law.social_law_interim_protection_request_date\` - law.social_law_interim_protection_request_date
* \`law.social_law_interim_protection_request_text\` - law.social_law_interim_protection_request_text
* \`law.social_law_interim_protection_urgency_reason\` - law.social_law_interim_protection_urgency_reason
* \`law.social_law_lawsuit_alternative_request\` - law.social_law_lawsuit_alternative_request
* \`law.social_law_lawsuit_attachment_list\` - law.social_law_lawsuit_attachment_list
* \`law.social_law_lawsuit_cost_request\` - law.social_law_lawsuit_cost_request
* \`law.social_law_lawsuit_court_file_number\` - law.social_law_lawsuit_court_file_number
* \`law.social_law_lawsuit_delivery_date\` - law.social_law_lawsuit_delivery_date
* \`law.social_law_lawsuit_dispute_value\` - law.social_law_lawsuit_dispute_value
* \`law.social_law_lawsuit_disputed_amount\` - law.social_law_lawsuit_disputed_amount
* \`law.social_law_lawsuit_evidence_requests\` - law.social_law_lawsuit_evidence_requests
* \`law.social_law_lawsuit_file_reference\` - law.social_law_lawsuit_file_reference
* \`law.social_law_lawsuit_filing_date\` - law.social_law_lawsuit_filing_date
* \`law.social_law_lawsuit_income_amount\` - law.social_law_lawsuit_income_amount
* \`law.social_law_lawsuit_legal_basis\` - law.social_law_lawsuit_legal_basis
* \`law.social_law_lawsuit_main_request\` - law.social_law_lawsuit_main_request
* \`law.social_law_lawsuit\` - law.social_law_lawsuit
* \`law.social_law_lawsuit_monthly_benefit_amount\` - law.social_law_lawsuit_monthly_benefit_amount
* \`law.social_law_lawsuit_objection_decision_date\` - law.social_law_lawsuit_objection_decision_date
* \`law.social_law_lawsuit_objection_filing_date\` - law.social_law_lawsuit_objection_filing_date
* \`law.social_law_lawsuit_original_decision_date\` - law.social_law_lawsuit_original_decision_date
* \`law.social_law_lawsuit_subject\` - law.social_law_lawsuit_subject
* \`law.social_law_lawsuit_type\` - law.social_law_lawsuit_type
* \`law.social_law_legal_basis\` - law.social_law_legal_basis
* \`law.social_law_medical_certificate\` - law.social_law_medical_certificate
* \`law.social_law_medical_diagnosis\` - law.social_law_medical_diagnosis
* \`law.social_law_medical_examination_date\` - law.social_law_medical_examination_date
* \`law.social_law_medical_file_reference\` - law.social_law_medical_file_reference
* \`law.social_law_medical_icd_code\` - law.social_law_medical_icd_code
* \`law.social_law_medical_limitations\` - law.social_law_medical_limitations
* \`law.social_law_medical_prognosis\` - law.social_law_medical_prognosis
* \`law.social_law_medical_work_capacity_relation\` - law.social_law_medical_work_capacity_relation
* \`law.social_law_monthly_payment_amount\` - law.social_law_monthly_payment_amount
* \`law.social_law_needs_cost_breakdown\` - law.social_law_needs_cost_breakdown
* \`law.social_law_needs_file_reference\` - law.social_law_needs_file_reference
* \`law.social_law_needs_proof_basis\` - law.social_law_needs_proof_basis
* \`law.social_law_needs_proof_date\` - law.social_law_needs_proof_date
* \`law.social_law_needs_proof\` - law.social_law_needs_proof
* \`law.social_law_needs_type\` - law.social_law_needs_type
* \`law.social_law_notice_date\` - law.social_law_notice_date
* \`law.social_law_notice_of_objection_date\` - law.social_law_notice_of_objection_date
* \`law.social_law_notice_of_objection_file_reference\` - law.social_law_notice_of_objection_file_reference
* \`law.social_law_notice_of_objection\` - law.social_law_notice_of_objection
* \`law.social_law_notification_date\` - law.social_law_notification_date
* \`law.social_law_notification_legal_basis\` - law.social_law_notification_legal_basis
* \`law.social_law_notification_source\` - law.social_law_notification_source
* \`law.social_law_objection_challenged_notice\` - law.social_law_objection_challenged_notice
* \`law.social_law_objection_date\` - law.social_law_objection_date
* \`law.social_law_objection_evidence\` - law.social_law_objection_evidence
* \`law.social_law_objection_file_reference\` - law.social_law_objection_file_reference
* \`law.social_law_objection\` - law.social_law_objection
* \`law.social_law_objection_reasoning\` - law.social_law_objection_reasoning
* \`law.social_law_objection_suspension_request\` - law.social_law_objection_suspension_request
* \`law.social_law_original_decision_date\` - law.social_law_original_decision_date
* \`law.social_law_other_income\` - law.social_law_other_income
* \`law.social_law_own_income_amount\` - law.social_law_own_income_amount
* \`law.social_law_reclaim_amount\` - law.social_law_reclaim_amount
* \`law.social_law_reclaim_file_reference\` - law.social_law_reclaim_file_reference
* \`law.social_law_reclaim_legal_basis\` - law.social_law_reclaim_legal_basis
* \`law.social_law_reclaim_legal_norm\` - law.social_law_reclaim_legal_norm
* \`law.social_law_reclaim_notice_date\` - law.social_law_reclaim_notice_date
* \`law.social_law_reclaim_notice\` - law.social_law_reclaim_notice
* \`law.social_law_reclaim_payment_deadline\` - law.social_law_reclaim_payment_deadline
* \`law.social_law_reclaim_payment_terms\` - law.social_law_reclaim_payment_terms
* \`law.social_law_regelbedarf_amount\` - law.social_law_regelbedarf_amount
* \`law.social_law_rejection_file_reference\` - law.social_law_rejection_file_reference
* \`law.social_law_rejection_legal_norm\` - law.social_law_rejection_legal_norm
* \`law.social_law_rejection_notice_date\` - law.social_law_rejection_notice_date
* \`law.social_law_rejection_notice\` - law.social_law_rejection_notice
* \`law.social_law_rejection_reason\` - law.social_law_rejection_reason
* \`law.social_law_residence_status\` - law.social_law_residence_status
* \`law.social_law_revocation_benefit_type\` - law.social_law_revocation_benefit_type
* \`law.social_law_revocation_file_reference\` - law.social_law_revocation_file_reference
* \`law.social_law_revocation_legal_norm\` - law.social_law_revocation_legal_norm
* \`law.social_law_revocation_notice_date\` - law.social_law_revocation_notice_date
* \`law.social_law_revocation_notice\` - law.social_law_revocation_notice
* \`law.social_law_revocation_period_end\` - law.social_law_revocation_period_end
* \`law.social_law_revocation_period_start\` - law.social_law_revocation_period_start
* \`law.social_law_revocation_reason\` - law.social_law_revocation_reason
* \`law.social_law_revocation_reclaim_notes\` - law.social_law_revocation_reclaim_notes
* \`law.social_law_social_benefit_type\` - law.social_law_social_benefit_type
* \`law.social_law_summary_grounds_opposition\` - law.social_law_summary_grounds_opposition
* \`law.social_law_total_need_amount\` - law.social_law_total_need_amount
* \`law.social_law_total_reclaim_amount\` - law.social_law_total_reclaim_amount
* \`law.social_law_violation_type\` - law.social_law_violation_type
* \`law.tenancy_law_adress_rental_property\` - law.tenancy_law_adress_rental_property
* \`law.tenancy_law_advance_payment_service_charge\` - law.tenancy_law_advance_payment_service_charge
* \`law.tenancy_law_advance_payment_service_charges\` - law.tenancy_law_advance_payment_service_charges
* \`law.tenancy_law_bank_guarantee\` - law.tenancy_law_bank_guarantee
* \`law.tenancy_law_cash_deposit_agreed\` - law.tenancy_law_cash_deposit_agreed
* \`law.tenancy_law_cash_deposit_payment_date\` - law.tenancy_law_cash_deposit_payment_date
* \`law.tenancy_law_competent_court\` - law.tenancy_law_competent_court
* \`law.tenancy_law_cost_share\` - law.tenancy_law_cost_share
* \`law.tenancy_law_cost_shares\` - law.tenancy_law_cost_shares
* \`law.tenancy_law_counter_number\` - law.tenancy_law_counter_number
* \`law.tenancy_law_court_case_number\` - law.tenancy_law_court_case_number
* \`law.tenancy_law_court_proceedings_pending\` - law.tenancy_law_court_proceedings_pending
* \`law.tenancy_law_description_of_rental_property\` - law.tenancy_law_description_of_rental_property
* \`law.tenancy_law_duration_of_lease\` - law.tenancy_law_duration_of_lease
* \`law.tenancy_law_expert_report_commission_date\` - law.tenancy_law_expert_report_commission_date
* \`law.tenancy_law_expert_report_damage_description\` - law.tenancy_law_expert_report_damage_description
* \`law.tenancy_law_expert_report_damage_number\` - law.tenancy_law_expert_report_damage_number
* \`law.tenancy_law_expert_report_date\` - law.tenancy_law_expert_report_date
* \`law.tenancy_law_expert_report_inspection_date\` - law.tenancy_law_expert_report_inspection_date
* \`law.tenancy_law_expert_report\` - law.tenancy_law_expert_report
* \`law.tenancy_law_expert_report_object_address\` - law.tenancy_law_expert_report_object_address
* \`law.tenancy_law_expert_report_purpose\` - law.tenancy_law_expert_report_purpose
* \`law.tenancy_law_expert_report_repair_duration\` - law.tenancy_law_expert_report_repair_duration
* \`law.tenancy_law_expert_report_subject\` - law.tenancy_law_expert_report_subject
* \`law.tenancy_law_extension_option_count\` - law.tenancy_law_extension_option_count
* \`law.tenancy_law_extension_option_duration\` - law.tenancy_law_extension_option_duration
* \`law.tenancy_law_fixed_term_tenancy\` - law.tenancy_law_fixed_term_tenancy
* \`law.tenancy_law_garage_available\` - law.tenancy_law_garage_available
* \`law.tenancy_law_garage_costs\` - law.tenancy_law_garage_costs
* \`law.tenancy_law_general_status_documents\` - law.tenancy_law_general_status_documents
* \`law.tenancy_law_gross_rent\` - law.tenancy_law_gross_rent
* \`law.tenancy_law_handover_counter\` - law.tenancy_law_handover_counter
* \`law.tenancy_law_handover_date\` - law.tenancy_law_handover_date
* \`law.tenancy_law_handover_defects\` - law.tenancy_law_handover_defects
* \`law.tenancy_law_handover_protocol\` - law.tenancy_law_handover_protocol
* \`law.tenancy_law_landlord_termination_given\` - law.tenancy_law_landlord_termination_given
* \`law.tenancy_law_last_rent_increase_letter_date\` - law.tenancy_law_last_rent_increase_letter_date
* \`law.tenancy_law_last_signature_date\` - law.tenancy_law_last_signature_date
* \`law.tenancy_law_lease_agreement\` - law.tenancy_law_lease_agreement
* \`law.tenancy_law_location_in_rental_property\` - law.tenancy_law_location_in_rental_property
* \`law.tenancy_law_net_rent\` - law.tenancy_law_net_rent
* \`law.tenancy_law_operating_costs_agreement\` - law.tenancy_law_operating_costs_agreement
* \`law.tenancy_law_parking_space_available\` - law.tenancy_law_parking_space_available
* \`law.tenancy_law_parking_space_costs\` - law.tenancy_law_parking_space_costs
* \`law.tenancy_law_property_return_date\` - law.tenancy_law_property_return_date
* \`law.tenancy_law_rent_increase_effective_date\` - law.tenancy_law_rent_increase_effective_date
* \`law.tenancy_law_rent_increase_notice\` - law.tenancy_law_rent_increase_notice
* \`law.tenancy_law_rental_agreement_date\` - law.tenancy_law_rental_agreement_date
* \`law.tenancy_law_rental_agreement_duration\` - law.tenancy_law_rental_agreement_duration
* \`law.tenancy_law_rental_agreement\` - law.tenancy_law_rental_agreement
* \`law.tenancy_law_rental_agreement_validity_end\` - law.tenancy_law_rental_agreement_validity_end
* \`law.tenancy_law_rental_agreement_validity_start\` - law.tenancy_law_rental_agreement_validity_start
* \`law.tenancy_law_rental_object_size_sqm\` - law.tenancy_law_rental_object_size_sqm
* \`law.tenancy_law_repayment\` - law.tenancy_law_repayment
* \`law.tenancy_law_repayment_period_end\` - law.tenancy_law_repayment_period_end
* \`law.tenancy_law_repayment_period_start\` - law.tenancy_law_repayment_period_start
* \`law.tenancy_law_security_deposit_additional_regulations\` - law.tenancy_law_security_deposit_additional_regulations
* \`law.tenancy_law_security_deposit_amount\` - law.tenancy_law_security_deposit_amount
* \`law.tenancy_law_service_charge_settlement\` - law.tenancy_law_service_charge_settlement
* \`law.tenancy_law_staggered_rental_agreement\` - law.tenancy_law_staggered_rental_agreement
* \`law.tenancy_law_start_of_lease\` - law.tenancy_law_start_of_lease
* \`law.tenancy_law_tenancy_terminated\` - law.tenancy_law_tenancy_terminated
* \`law.tenancy_law_tenancy_termination_date\` - law.tenancy_law_tenancy_termination_date
* \`law.tenancy_law_tenant_extension_option\` - law.tenancy_law_tenant_extension_option
* \`law.tenancy_law_tenant_warned\` - law.tenancy_law_tenant_warned
* \`law.tenancy_law_termination_declared_date\` - law.tenancy_law_termination_declared_date
* \`law.tenancy_law_termination_letter_date\` - law.tenancy_law_termination_letter_date
* \`law.tenancy_law_termination_notice\` - law.tenancy_law_termination_notice
* \`law.tenancy_law_termination_notice_period\` - law.tenancy_law_termination_notice_period
* \`law.tenancy_law_total_cost_service_charge\` - law.tenancy_law_total_cost_service_charge
* \`law.tenancy_law_total_rent\` - law.tenancy_law_total_rent
* \`law.tenancy_law_unlimited_term_tenancy\` - law.tenancy_law_unlimited_term_tenancy
* \`law.tenancy_law_value_security_clause\` - law.tenancy_law_value_security_clause
* \`law.tenancy_law_warning_letter_date\` - law.tenancy_law_warning_letter_date
* \`law.tenancy_law_warning_letter\` - law.tenancy_law_warning_letter
* \`law.topic\` - law.topic
* \`law.traffic_law_accident_date\` - law.traffic_law_accident_date
* \`law.traffic_law_accident_report\` - law.traffic_law_accident_report
* \`law.traffic_law_amount_of_fine\` - law.traffic_law_amount_of_fine
* \`law.traffic_law_appeal_instruction\` - law.traffic_law_appeal_instruction
* \`law.traffic_law_at_fault_driver_drivers_license_issued_by\` - law.traffic_law_at_fault_driver_drivers_license_issued_by
* \`law.traffic_law_at_fault_driver_drivers_license_valid_until\` - law.traffic_law_at_fault_driver_drivers_license_valid_until
* \`law.traffic_law_at_fault_driver_green_card_number\` - law.traffic_law_at_fault_driver_green_card_number
* \`law.traffic_law_at_fault_driver_insurance_expiry_date\` - law.traffic_law_at_fault_driver_insurance_expiry_date
* \`law.traffic_law_at_fault_driver_insurance_number\` - law.traffic_law_at_fault_driver_insurance_number
* \`law.traffic_law_at_fault_driver_insurer\` - law.traffic_law_at_fault_driver_insurer
* \`law.traffic_law_blood_alcohol_concentration\` - law.traffic_law_blood_alcohol_concentration
* \`law.traffic_law_calculated_total_damage_costs\` - law.traffic_law_calculated_total_damage_costs
* \`law.traffic_law_calculated_total_days\` - law.traffic_law_calculated_total_days
* \`law.traffic_law_charges\` - law.traffic_law_charges
* \`law.traffic_law_cost_per_scale\` - law.traffic_law_cost_per_scale
* \`law.traffic_law_daily_rate\` - law.traffic_law_daily_rate
* \`law.traffic_law_damage_number\` - law.traffic_law_damage_number
* \`law.traffic_law_damage_scope\` - law.traffic_law_damage_scope
* \`law.traffic_law_date_of_accident\` - law.traffic_law_date_of_accident
* \`law.traffic_law_date_of_crime\` - law.traffic_law_date_of_crime
* \`law.traffic_law_date_of_fine\` - law.traffic_law_date_of_fine
* \`law.traffic_law_date_of_infraction\` - law.traffic_law_date_of_infraction
* \`law.traffic_law_date_of_inspection\` - law.traffic_law_date_of_inspection
* \`law.traffic_law_date_of_issue\` - law.traffic_law_date_of_issue
* \`law.traffic_law_date_of_offense\` - law.traffic_law_date_of_offense
* \`law.traffic_law_date_of_report\` - law.traffic_law_date_of_report
* \`law.traffic_law_differencial_tax\` - law.traffic_law_differencial_tax
* \`law.traffic_law_driver_logbook_required\` - law.traffic_law_driver_logbook_required
* \`law.traffic_law_driving_ban_duration\` - law.traffic_law_driving_ban_duration
* \`law.traffic_law_driving_ban\` - law.traffic_law_driving_ban
* \`law.traffic_law_evidence_infraction\` - law.traffic_law_evidence_infraction
* \`law.traffic_law_expert_cost\` - law.traffic_law_expert_cost
* \`law.traffic_law_expert_date\` - law.traffic_law_expert_date
* \`law.traffic_law_expert_report\` - law.traffic_law_expert_report
* \`law.traffic_law_expert_report_number\` - law.traffic_law_expert_report_number
* \`law.traffic_law_file_number\` - law.traffic_law_file_number
* \`law.traffic_law_fine\` - law.traffic_law_fine
* \`law.traffic_law_fine_notice\` - law.traffic_law_fine_notice
* \`law.traffic_law_gross_gross_replacement_value\` - law.traffic_law_gross_gross_replacement_value
* \`law.traffic_law_gross_replacement_value\` - law.traffic_law_gross_replacement_value
* \`law.traffic_law_injured\` - law.traffic_law_injured
* \`law.traffic_law_insurance_holder\` - law.traffic_law_insurance_holder
* \`law.traffic_law_insurance\` - law.traffic_law_insurance
* \`law.traffic_law_insurance_policy_number\` - law.traffic_law_insurance_policy_number
* \`law.traffic_law_legal_basis_infraction\` - law.traffic_law_legal_basis_infraction
* \`law.traffic_law_legal_basis\` - law.traffic_law_legal_basis
* \`law.traffic_law_licenseplate_at_fault_driver\` - law.traffic_law_licenseplate_at_fault_driver
* \`law.traffic_law_licenseplate\` - law.traffic_law_licenseplate
* \`law.traffic_law_licenseplate_victim_driver\` - law.traffic_law_licenseplate_victim_driver
* \`law.traffic_law_loss_amount_repair_case\` - law.traffic_law_loss_amount_repair_case
* \`law.traffic_law_loss_amount_total_damage_case\` - law.traffic_law_loss_amount_total_damage_case
* \`law.traffic_law_loss_of_use_per_day\` - law.traffic_law_loss_of_use_per_day
* \`law.traffic_law_mark_and_type_of_at_fault_driver\` - law.traffic_law_mark_and_type_of_at_fault_driver
* \`law.traffic_law_mark_and_type_of_victim_driver\` - law.traffic_law_mark_and_type_of_victim_driver
* \`law.traffic_law_merantile_value_loss\` - law.traffic_law_merantile_value_loss
* \`law.traffic_law_net_gross_replacement_value\` - law.traffic_law_net_gross_replacement_value
* \`law.traffic_law_net_replacement_value\` - law.traffic_law_net_replacement_value
* \`law.traffic_law_number_of_daily_rates\` - law.traffic_law_number_of_daily_rates
* \`law.traffic_law_offense_infraction_description\` - law.traffic_law_offense_infraction_description
* \`law.traffic_law_other_damages\` - law.traffic_law_other_damages
* \`law.traffic_law_payment_deadline\` - law.traffic_law_payment_deadline
* \`law.traffic_law_penalty_order\` - law.traffic_law_penalty_order
* \`law.traffic_law_place_of_accident\` - law.traffic_law_place_of_accident
* \`law.traffic_law_place_of_crime\` - law.traffic_law_place_of_crime
* \`law.traffic_law_place_of_infraction\` - law.traffic_law_place_of_infraction
* \`law.traffic_law_place_of_inspection\` - law.traffic_law_place_of_inspection
* \`law.traffic_law_place_of_issue\` - law.traffic_law_place_of_issue
* \`law.traffic_law_place_of_offense\` - law.traffic_law_place_of_offense
* \`law.traffic_law_points_for_offense\` - law.traffic_law_points_for_offense
* \`law.traffic_law_police_case_number\` - law.traffic_law_police_case_number
* \`law.traffic_law_procedure_costs\` - law.traffic_law_procedure_costs
* \`law.traffic_law_prosecution_number\` - law.traffic_law_prosecution_number
* \`law.traffic_law_regular_tax\` - law.traffic_law_regular_tax
* \`law.traffic_law_repair_costs_with_vat\` - law.traffic_law_repair_costs_with_vat
* \`law.traffic_law_repair_costs_without_vat\` - law.traffic_law_repair_costs_without_vat
* \`law.traffic_law_repair_damage\` - law.traffic_law_repair_damage
* \`law.traffic_law_repair_duration\` - law.traffic_law_repair_duration
* \`law.traffic_law_replacement_cost\` - law.traffic_law_replacement_cost
* \`law.traffic_law_replacement_value\` - law.traffic_law_replacement_value
* \`law.traffic_law_reregistration_cost\` - law.traffic_law_reregistration_cost
* \`law.traffic_law_residual_value\` - law.traffic_law_residual_value
* \`law.traffic_law_speed_allowed\` - law.traffic_law_speed_allowed
* \`law.traffic_law_speed_driven\` - law.traffic_law_speed_driven
* \`law.traffic_law_speed_too_high\` - law.traffic_law_speed_too_high
* \`law.traffic_law_time_of_accident\` - law.traffic_law_time_of_accident
* \`law.traffic_law_time_of_crime\` - law.traffic_law_time_of_crime
* \`law.traffic_law_time_of_infraction\` - law.traffic_law_time_of_infraction
* \`law.traffic_law_time_of_inspection\` - law.traffic_law_time_of_inspection
* \`law.traffic_law_time_of_issue\` - law.traffic_law_time_of_issue
* \`law.traffic_law_time_of_offense\` - law.traffic_law_time_of_offense
* \`law.traffic_law_total_damage\` - law.traffic_law_total_damage
* \`law.traffic_law_vehicle_age_months\` - law.traffic_law_vehicle_age_months
* \`law.traffic_law_vehicle_mileage\` - law.traffic_law_vehicle_mileage
* \`law.traffic_law_vehicle_type_and_brand\` - law.traffic_law_vehicle_type_and_brand
* \`law.traffic_law_victim_driver_drivers_license_issued_by\` - law.traffic_law_victim_driver_drivers_license_issued_by
* \`law.traffic_law_victim_driver_green_card_number\` - law.traffic_law_victim_driver_green_card_number
* \`law.traffic_law_victim_driver_insurance_expiry_date\` - law.traffic_law_victim_driver_insurance_expiry_date
* \`law.traffic_law_victim_driver_insurance_number\` - law.traffic_law_victim_driver_insurance_number
* \`law.traffic_law_victim_driver_insurer\` - law.traffic_law_victim_driver_insurer
* \`law.traffic_law_victim_driver_license_valid_until\` - law.traffic_law_victim_driver_license_valid_until
* \`law.traffic_law_violated_section\` - law.traffic_law_violated_section
* \`law.traffic_law_violation_type\` - law.traffic_law_violation_type
* \`law.traffic_law_warning_fee_infraction\` - law.traffic_law_warning_fee_infraction
* \`law.traffic_law_warning_notice\` - law.traffic_law_warning_notice`
} as const;

export const $AiAugmentedFieldsRequest = {
    type: 'object',
    properties: {
        client: {
            '$ref': '#/components/schemas/EntityAugmentedFieldsRequest'
        },
        opponent: {
            '$ref': '#/components/schemas/EntityAugmentedFieldsRequest'
        },
        law: {
            '$ref': '#/components/schemas/LawAugmentedFieldsRequest'
        }
    },
    required: ['client', 'law', 'opponent']
} as const;

export const $AiChatQuestionTemplate = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        updated_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        is_jupus_template: {
            type: 'boolean',
            readOnly: true
        },
        law_field: {
            title: 'Rechtsgebiet',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawFieldEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        law_topic: {
            title: 'Rechtsthema',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawTopicEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        created_by_user: {
            type: 'string',
            format: 'uuid',
            readOnly: true,
            nullable: true
        },
        prompt: {
            type: 'string'
        },
        title: {
            type: 'string',
            maxLength: 255
        },
        description: {
            type: 'string'
        },
        org: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        is_favorite: {
            type: 'string',
            readOnly: true
        }
    },
    required: ['created_at', 'created_by_user', 'is_favorite', 'is_jupus_template', 'org', 'prompt', 'title', 'updated_at', 'uuid']
} as const;

export const $AiChatQuestionTemplateRequest = {
    type: 'object',
    properties: {
        law_field: {
            title: 'Rechtsgebiet',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawFieldEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        law_topic: {
            title: 'Rechtsthema',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawTopicEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        prompt: {
            type: 'string',
            minLength: 1
        },
        title: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        },
        description: {
            type: 'string'
        }
    },
    required: ['prompt', 'title']
} as const;

export const $Announcement = {
    type: 'object',
    description: `Base announcement serializer for public viewing.

Returns only essential fields for displaying active announcements.`,
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        message: {
            type: 'string',
            readOnly: true,
            description: 'The announcement message to display'
        },
        message_type: {
            allOf: [
                {
                    '$ref': '#/components/schemas/MessageTypeEnum'
                }
            ],
            readOnly: true,
            description: `The type of announcement (determines color/styling)

* \`INFO\` - Info
* \`WARNING\` - Warning
* \`ERROR\` - Error
* \`SUCCESS\` - Success`
        },
        dismissible: {
            type: 'boolean',
            readOnly: true,
            description: 'Whether users can dismiss this announcement'
        }
    },
    required: ['dismissible', 'message', 'message_type', 'uuid']
} as const;

export const $AppointmentSettings = {
    type: 'object',
    properties: {
        start_of_working_day: {
            type: 'string',
            format: 'time'
        },
        end_of_working_day: {
            type: 'string',
            format: 'time'
        },
        working_days: {
            title: 'Arbeitstage'
        }
    },
    required: ['end_of_working_day', 'start_of_working_day']
} as const;

export const $AppointmentStatusEnum = {
    enum: ['CONFIRMED', 'TENTATIVE', 'CANCELLED', 'UNKNOWN'],
    type: 'string',
    description: `* \`CONFIRMED\` - Bestätigt
* \`TENTATIVE\` - Unbestätigt
* \`CANCELLED\` - Abgesagt
* \`UNKNOWN\` - Unbekannt`
} as const;

export const $AssignedToEnum = {
    enum: ['client', 'lawyer'],
    type: 'string',
    description: `* \`client\` - client
* \`lawyer\` - lawyer`
} as const;

export const $AugmentationVariantEnum = {
    enum: ['DOCUMENT ANALYSIS', 'EMAIL EXTRACTION', 'CONTEXTUAL ANALYSIS', 'UNIVERSAL ENTITY EXTRACTION', 'CALL', 'CHATBOT', 'AGENT'],
    type: 'string',
    description: `* \`DOCUMENT ANALYSIS\` - Document Analysis
* \`EMAIL EXTRACTION\` - Email Extraction
* \`CONTEXTUAL ANALYSIS\` - Contextual Analysis
* \`UNIVERSAL ENTITY EXTRACTION\` - Universal Entity Extraction
* \`CALL\` - Call
* \`CHATBOT\` - Chatbot
* \`AGENT\` - Agent`
} as const;

export const $BlankEnum = {
    enum: ['']
} as const;

export const $BlockEvaluation = {
    type: 'object',
    title: 'BlockEvaluation',
    properties: {
        block_variable: {
            type: 'string'
        },
        german_label: {
            type: 'string',
            nullable: true
        },
        english_label: {
            type: 'string',
            nullable: true
        },
        is_true: {
            type: 'boolean'
        }
    },
    required: ['block_variable', 'is_true']
} as const;

export const $BotButtonPositionEnum = {
    enum: ['top-left', 'top-right', 'top-center', 'bottom-left', 'bottom-right', 'bottom-center', 'middle-left', 'middle-right', 'none'],
    type: 'string',
    description: `* \`top-left\` - Oben links
* \`top-right\` - Oben rechts
* \`top-center\` - Oben zentriert
* \`bottom-left\` - Unten links
* \`bottom-right\` - Unten rechts
* \`bottom-center\` - Unten zentriert
* \`middle-left\` - Links zentriert
* \`middle-right\` - Rechts zentriert
* \`none\` - Nicht anzeigen`
} as const;

export const $BulkSyncDocumentsRequestRequest = {
    type: 'object',
    description: 'Request serializer for bulk syncing documents between platforms.',
    properties: {
        document_uuids: {
            type: 'array',
            items: {
                type: 'string',
                format: 'uuid'
            },
            description: 'List of JUPUS document UUIDs to send to Actaport'
        },
        actaport_document_ids: {
            type: 'array',
            items: {
                type: 'string',
                minLength: 1
            },
            description: 'List of Actaport document IDs to import into JUPUS'
        }
    }
} as const;

export const $BulkSyncDocumentsResponse = {
    type: 'object',
    description: 'Response serializer for bulk sync endpoint.',
    properties: {
        status: {
            allOf: [
                {
                    '$ref': '#/components/schemas/BulkSyncDocumentsResponseStatusEnum'
                }
            ],
            description: `Status of the bulk sync operation

* \`syncing\` - syncing
* \`error\` - error`
        },
        sending_count: {
            type: 'integer',
            description: 'Number of documents being sent to Actaport'
        },
        importing_count: {
            type: 'integer',
            description: 'Number of documents being imported from Actaport'
        },
        message: {
            type: 'string',
            description: 'Description of the sync operation'
        }
    },
    required: ['importing_count', 'message', 'sending_count', 'status']
} as const;

export const $BulkSyncDocumentsResponseStatusEnum = {
    enum: ['syncing', 'error'],
    type: 'string',
    description: `* \`syncing\` - syncing
* \`error\` - error`
} as const;

export const $BulkUploadRequest = {
    type: 'object',
    description: 'Serializer for bulk uploading Word document templates.',
    properties: {
        files: {
            type: 'array',
            items: {
                type: 'string',
                format: 'binary'
            },
            description: 'List of .docx files to upload',
            maxItems: 20,
            minItems: 1
        }
    },
    required: ['files']
} as const;

export const $Calendar = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        id: {
            type: 'integer',
            readOnly: true
        },
        name: {
            type: 'string',
            maxLength: 32
        },
        avatar: {
            type: 'string',
            format: 'uri',
            nullable: true,
            title: 'Profilbild'
        },
        calendar_id: {
            type: 'string'
        },
        availability_query: {
            type: 'object',
            additionalProperties: {},
            readOnly: true
        },
        account: {
            allOf: [
                {
                    '$ref': '#/components/schemas/CustomerAccount'
                }
            ],
            readOnly: true
        }
    },
    required: ['account', 'availability_query', 'calendar_id', 'id']
} as const;

export const $CalendarRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        name: {
            type: 'string',
            minLength: 1,
            maxLength: 32
        },
        avatar: {
            type: 'string',
            format: 'binary',
            nullable: true,
            title: 'Profilbild'
        },
        calendar_id: {
            type: 'string',
            minLength: 1
        }
    },
    required: ['calendar_id']
} as const;

export const $CallTranscriptMessage = {
    type: 'object',
    properties: {
        role: {
            type: 'string'
        },
        content: {
            type: 'string'
        }
    },
    required: ['content', 'role']
} as const;

export const $CallTranscriptMessageRequest = {
    type: 'object',
    properties: {
        role: {
            type: 'string',
            minLength: 1
        },
        content: {
            type: 'string',
            minLength: 1
        }
    },
    required: ['content', 'role']
} as const;

export const $CaseAiContext = {
    type: 'object',
    title: 'CaseAiContext',
    properties: {
        created_at: {
            type: 'string',
            nullable: true
        },
        case_created_at: {
            type: 'string'
        },
        updated_document_context_at: {
            type: 'string',
            nullable: true
        },
        inquiry: {
            type: 'string'
        },
        note: {
            type: 'string',
            nullable: true
        },
        data: {
            '$ref': '#/components/schemas/CaseDataAiContext'
        },
        entities: {
            '$ref': '#/components/schemas/CaseEntityAiContext'
        },
        documents: {
            '$ref': '#/components/schemas/DocumentAiContext'
        },
        preferences: {
            '$ref': '#/components/schemas/ChatPreferenceAiContext',
            nullable: true
        }
    },
    required: ['case_created_at', 'inquiry', 'data', 'entities', 'documents']
} as const;

export const $CaseAppointments = {
    oneOf: [
        {
            '$ref': '#/components/schemas/CustomerAppointment'
        },
        {
            '$ref': '#/components/schemas/CustomerAdminAppointment'
        },
        {
            '$ref': '#/components/schemas/SuperUserAppointment'
        }
    ]
} as const;

export const $CaseCreateEntityRequest = {
    type: 'object',
    properties: {
        entity_type: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EntityTypeEnum'
                }
            ],
            title: 'Personentyp'
        },
        title: {
            title: 'Anrede',
            oneOf: [
                {
                    '$ref': '#/components/schemas/TitleEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        first_name: {
            type: 'string',
            title: 'Vorname',
            maxLength: 128
        },
        last_name: {
            type: 'string',
            title: 'Nachname',
            maxLength: 128
        },
        company_name: {
            type: 'string',
            title: 'Firmenname',
            maxLength: 128
        },
        company_legal_form: {
            title: 'Rechtsform',
            oneOf: [
                {
                    '$ref': '#/components/schemas/CompanyLegalFormEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        institution_name: {
            type: 'string',
            title: 'Name der Institution',
            maxLength: 128
        },
        phone: {
            type: 'string',
            title: 'Telefon',
            maxLength: 128
        },
        email: {
            type: 'string',
            format: 'email',
            title: 'E-Mail',
            maxLength: 128
        },
        date_of_birth: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Geburtsdatum'
        },
        street: {
            type: 'string',
            title: 'Straße',
            maxLength: 128
        },
        street_number: {
            type: 'string',
            title: 'Hausnummer',
            maxLength: 16
        },
        zip: {
            type: 'string',
            title: 'PLZ',
            maxLength: 12
        },
        city: {
            type: 'string',
            title: 'Ort',
            maxLength: 100
        },
        legal_insurance: {
            type: 'boolean',
            nullable: true,
            title: 'Rechtsschutzversicherung'
        },
        legal_insurance_number: {
            type: 'string',
            title: 'Nummer der Rechtsschutzversicherung',
            maxLength: 128
        },
        legal_insurance_name: {
            type: 'string',
            title: 'Name der Rechtsschutzversicherung',
            maxLength: 128
        }
    },
    required: ['entity_type']
} as const;

export const $CaseCreateInstructionsAdvisory = {
    type: 'object',
    title: 'CaseCreateInstructionsAdvisory',
    properties: {
        revised_case_acceptance_instructions_html: {
            type: 'string'
        },
        suggestions_html: {
            type: 'string'
        },
        is_original_case_acceptance_instructions_valid: {
            type: 'boolean'
        },
        errors_html: {
            type: 'string'
        }
    },
    required: ['revised_case_acceptance_instructions_html', 'suggestions_html', 'is_original_case_acceptance_instructions_valid', 'errors_html']
} as const;

export const $CaseCreateInstructionsAdvisoryRequestRequest = {
    type: 'object',
    description: 'Serializer for requesting case create instructions advisory.',
    properties: {
        case_acceptance_instructions: {
            type: 'string',
            description: 'The case acceptance instructions to validate and get advisory for',
            maxLength: 10000
        }
    },
    required: ['case_acceptance_instructions']
} as const;

export const $CaseCreateInstructionsAdvisoryResponse = {
    type: 'object',
    description: 'Serializer for case create instructions advisory response.',
    properties: {
        advisory: {
            allOf: [
                {
                    '$ref': '#/components/schemas/CaseCreateInstructionsAdvisory'
                }
            ],
            description: 'Case create instructions advisory response'
        }
    },
    required: ['advisory']
} as const;

export const $CaseCreateLawRequest = {
    type: 'object',
    properties: {
        field: {
            oneOf: [
                {
                    '$ref': '#/components/schemas/FieldEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        topic: {
            oneOf: [
                {
                    '$ref': '#/components/schemas/TopicEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        }
    },
    required: ['field', 'topic']
} as const;

export const $CaseCreateRequest = {
    type: 'object',
    properties: {
        clerk_uuid: {
            type: 'string',
            format: 'uuid',
            nullable: true
        },
        client: {
            '$ref': '#/components/schemas/CaseCreateEntityRequest'
        },
        opponent: {
            '$ref': '#/components/schemas/CaseCreateEntityRequest'
        },
        law: {
            '$ref': '#/components/schemas/CaseCreateLawRequest'
        },
        inquiry: {
            type: 'string',
            default: ''
        },
        note: {
            type: 'string',
            default: ''
        },
        document_uuids: {
            type: 'array',
            items: {
                type: 'string',
                format: 'uuid'
            }
        },
        ai_augmented_fields: {
            allOf: [
                {
                    '$ref': '#/components/schemas/AiAugmentedFieldsRequest'
                }
            ],
            nullable: true
        }
    },
    required: ['ai_augmented_fields', 'clerk_uuid', 'client', 'document_uuids', 'law', 'opponent']
} as const;

export const $CaseCreatorTempDocument = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        original_filename: {
            type: 'string',
            maxLength: 255
        },
        file: {
            type: 'string',
            format: 'uri'
        },
        extraction_result: {
            allOf: [
                {
                    '$ref': '#/components/schemas/UUIDExtractionResult'
                }
            ],
            readOnly: true
        },
        images: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/ImageproxyImagePreset'
            },
            readOnly: true
        }
    },
    required: ['created_at', 'extraction_result', 'file', 'images', 'original_filename', 'uuid']
} as const;

export const $CaseCreatorTempDocumentRequest = {
    type: 'object',
    properties: {
        original_filename: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        },
        file: {
            type: 'string',
            format: 'binary'
        }
    },
    required: ['file', 'original_filename']
} as const;

export const $CaseDashboardWidgetsEnum = {
    type: 'string',
    enum: ['CASE_DATA', 'CLIENT_DATA', 'CURRENT_STATE', 'OPPONENT_DATA', 'ACTIVITIES', 'EMAILS', 'APPOINTMENTS', 'AI_CHAT', 'LAW_SPECIFIC_DATA', 'DOCUMENTS', 'GENERATED_DOCUMENTS', 'ENTITIES', 'NOTES']
} as const;

export const $CaseDataAiContext = {
    type: 'object',
    title: 'CaseDataAiContext',
    properties: {
        key: {
            type: 'string'
        },
        label: {
            type: 'string'
        },
        data: {
            type: 'string',
            nullable: true
        },
        is_default: {
            type: 'boolean'
        },
        uuid: {
            type: 'string'
        }
    },
    required: ['key', 'label', 'is_default', 'uuid']
} as const;

export const $CaseEntityAiContext = {
    type: 'object',
    title: 'CaseEntityAiContext',
    properties: {
        uuid: {
            type: 'string'
        },
        entity_type: {
            '$ref': '#/components/schemas/EntityTypeC7aEnum'
        },
        first_name: {
            type: 'string',
            nullable: true
        },
        last_name: {
            type: 'string',
            nullable: true
        },
        company_name: {
            type: 'string',
            nullable: true
        },
        institution_name: {
            type: 'string',
            nullable: true
        }
    },
    required: ['uuid', 'entity_type']
} as const;

export const $CaseInfo = {
    type: 'object',
    description: 'Minimal case info for calls that are connected to cases',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        pk: {
            type: 'integer'
        },
        note: {
            type: 'string',
            nullable: true
        },
        clerk: {
            allOf: [
                {
                    '$ref': '#/components/schemas/CustomerOrganisationUser'
                }
            ],
            readOnly: true
        },
        law_field: {
            type: 'string'
        },
        law_topic: {
            type: 'string'
        }
    },
    required: ['clerk', 'law_field', 'law_topic', 'note', 'pk', 'uuid']
} as const;

export const $CaseInfoRequest = {
    type: 'object',
    description: 'Minimal case info for calls that are connected to cases',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        pk: {
            type: 'integer'
        },
        note: {
            type: 'string',
            nullable: true
        },
        law_field: {
            type: 'string'
        },
        law_topic: {
            type: 'string'
        }
    },
    required: ['law_field', 'law_topic', 'note', 'pk', 'uuid']
} as const;

export const $CaseLifecycleStateRateRequest = {
    type: 'object',
    description: 'Serializer for rating a case lifecycle state.',
    properties: {
        rating: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,1}(?:\\.\\d{0,1})?$',
            description: 'Rating value from 0.0 to 5.0'
        },
        rating_negative_comment: {
            type: 'string',
            nullable: true,
            description: 'Additional comment for negative rating'
        }
    },
    required: ['rating']
} as const;

export const $CaseLifecycleStateReasoning = {
    type: 'object',
    description: 'Serializer for Case Lifecycle State Reasoning.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        reasoning: {
            allOf: [
                {
                    '$ref': '#/components/schemas/Translation'
                }
            ],
            nullable: true
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        updated_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        }
    },
    required: ['created_at', 'updated_at', 'uuid']
} as const;

export const $CaseLifecycleStateReasoningRequest = {
    type: 'object',
    description: 'Serializer for Case Lifecycle State Reasoning.',
    properties: {
        reasoning: {
            allOf: [
                {
                    '$ref': '#/components/schemas/Translation'
                }
            ],
            nullable: true
        }
    }
} as const;

export const $CaseLifecycleStateRelatedData = {
    type: 'object',
    title: 'CaseLifecycleStateRelatedData',
    properties: {
        case_uuid: {
            type: 'string',
            nullable: true
        }
    }
} as const;

export const $CaseLifecycleStateTransitionResult = {
    type: 'object',
    description: 'Serializer for Case Lifecycle State Transition Result.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        next_state: {
            readOnly: true,
            nullable: true,
            oneOf: [
                {
                    '$ref': '#/components/schemas/NextStateEnum'
                },
                {
                    '$ref': '#/components/schemas/NullEnum'
                }
            ]
        },
        confidence_score: {
            type: 'integer',
            readOnly: true,
            nullable: true
        },
        reasoning: {
            allOf: [
                {
                    '$ref': '#/components/schemas/CaseLifecycleStateReasoning'
                }
            ],
            readOnly: true
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        updated_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        }
    },
    required: ['confidence_score', 'created_at', 'next_state', 'reasoning', 'updated_at', 'uuid']
} as const;

export const $CaseType = {
    enum: ['API', 'CHAT BOT', 'QUESTIONNAIRE', 'EMAIL', 'MANUAL', 'PHONE', 'APPOINTMENT', 'AI_GENERATED'],
    type: 'string',
    description: `* \`API\` - API
* \`CHAT BOT\` - Chat
* \`QUESTIONNAIRE\` - Fragebogen
* \`EMAIL\` - E-Mail
* \`MANUAL\` - Manuell
* \`PHONE\` - Telefon
* \`APPOINTMENT\` - Terminbuchung
* \`AI_GENERATED\` - KI generiert`
} as const;

export const $CategoryEnum = {
    enum: ['Allgemein', 'Rechtsspezifisch'],
    type: 'string',
    description: `* \`Allgemein\` - General
* \`Rechtsspezifisch\` - Law Specific`
} as const;

export const $ChangeSourceEnum = {
    enum: ['USER', 'AI', 'QUESTIONNAIRE', 'APPOINTMENT', 'SYSTEM', 'PDF_FORM'],
    type: 'string',
    description: `* \`USER\` - User
* \`AI\` - Ai
* \`QUESTIONNAIRE\` - Questionnaire
* \`APPOINTMENT\` - Appointment
* \`SYSTEM\` - System
* \`PDF_FORM\` - Pdf Form`
} as const;

export const $ChatPreference = {
    type: 'object',
    description: 'Serializer for the ChatPreference model.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        title: {
            type: 'string',
            maxLength: 255
        },
        content: {
            type: 'string'
        },
        scope: {
            '$ref': '#/components/schemas/ScopeEnum'
        },
        source: {
            nullable: true,
            oneOf: [
                {
                    '$ref': '#/components/schemas/SourceEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                },
                {
                    '$ref': '#/components/schemas/NullEnum'
                }
            ]
        },
        org: {
            type: 'integer',
            nullable: true
        },
        created_by_user: {
            type: 'integer',
            nullable: true
        },
        created_by_user_name: {
            type: 'string',
            readOnly: true
        },
        user: {
            type: 'integer',
            nullable: true
        },
        case: {
            type: 'integer',
            nullable: true
        },
        case_uuid: {
            type: 'string',
            readOnly: true
        },
        message_uuid: {
            type: 'string',
            format: 'uuid',
            nullable: true,
            description: 'UUID of the AI chat message this preference was created from'
        },
        is_active: {
            type: 'boolean'
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        updated_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        sentiment: {
            type: 'string',
            nullable: true,
            description: 'Sentiment classification (like, dislike, neutral, etc.)',
            maxLength: 32
        },
        confidence: {
            type: 'number',
            format: 'double',
            nullable: true,
            description: 'Confidence score for the sentiment classification (0.0-1.0)'
        },
        entity: {
            type: 'string',
            nullable: true,
            description: 'Entity or topic this preference relates to',
            maxLength: 255
        },
        frequency_positive: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            description: 'Number of positive interactions with this preference'
        },
        frequency_negative: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            description: 'Number of negative interactions with this preference'
        },
        last_accessed: {
            type: 'string',
            format: 'date-time',
            nullable: true,
            description: 'Last time this preference was accessed/used'
        },
        max_preferences: {
            type: 'string',
            readOnly: true
        },
        max_active_preferences: {
            type: 'string',
            readOnly: true
        }
    },
    required: ['case_uuid', 'content', 'created_at', 'created_by_user_name', 'max_active_preferences', 'max_preferences', 'title', 'updated_at', 'uuid']
} as const;

export const $ChatPreferenceAiContext = {
    type: 'object',
    title: 'ChatPreferenceAiContext',
    properties: {
        uuid: {
            type: 'string'
        },
        title: {
            type: 'string'
        },
        content: {
            type: 'string'
        },
        scope: {
            type: 'string'
        },
        created_at: {
            type: 'string'
        },
        created_by: {
            type: 'string'
        },
        sentiment: {
            type: 'string',
            nullable: true
        },
        confidence: {
            type: 'number',
            nullable: true
        },
        entity: {
            type: 'string',
            nullable: true
        },
        computed_score: {
            type: 'number',
            nullable: true
        }
    },
    required: ['uuid', 'title', 'content', 'scope', 'created_at', 'created_by']
} as const;

export const $ChatPreferenceRequest = {
    type: 'object',
    description: 'Serializer for the ChatPreference model.',
    properties: {
        title: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        },
        content: {
            type: 'string',
            minLength: 1
        },
        scope: {
            '$ref': '#/components/schemas/ScopeEnum'
        },
        source: {
            nullable: true,
            oneOf: [
                {
                    '$ref': '#/components/schemas/SourceEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                },
                {
                    '$ref': '#/components/schemas/NullEnum'
                }
            ]
        },
        org: {
            type: 'integer',
            nullable: true
        },
        created_by_user: {
            type: 'integer',
            nullable: true
        },
        user: {
            type: 'integer',
            nullable: true
        },
        case: {
            type: 'integer',
            nullable: true
        },
        message_uuid: {
            type: 'string',
            format: 'uuid',
            nullable: true,
            description: 'UUID of the AI chat message this preference was created from'
        },
        is_active: {
            type: 'boolean'
        },
        sentiment: {
            type: 'string',
            nullable: true,
            description: 'Sentiment classification (like, dislike, neutral, etc.)',
            maxLength: 32
        },
        confidence: {
            type: 'number',
            format: 'double',
            nullable: true,
            description: 'Confidence score for the sentiment classification (0.0-1.0)'
        },
        entity: {
            type: 'string',
            nullable: true,
            description: 'Entity or topic this preference relates to',
            maxLength: 255
        },
        frequency_positive: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            description: 'Number of positive interactions with this preference'
        },
        frequency_negative: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            description: 'Number of negative interactions with this preference'
        },
        last_accessed: {
            type: 'string',
            format: 'date-time',
            nullable: true,
            description: 'Last time this preference was accessed/used'
        }
    },
    required: ['content', 'title']
} as const;

export const $ClassificationEnum = {
    enum: ['EXISTING_CLIENT_CALL_BACK', 'NEW_CLIENT_CALL', 'GENERAL_ENQUIRY', 'QUESTION', 'NOT_COMPLETED', 'LAWFIRM_PARTNER', 'CALL_FORWARDED', 'WITHOUT_MESSAGE', 'COURT'],
    type: 'string',
    description: `* \`EXISTING_CLIENT_CALL_BACK\` - Bestandsmandant
* \`NEW_CLIENT_CALL\` - Neumandant
* \`GENERAL_ENQUIRY\` - Allgemeine Anfrage
* \`QUESTION\` - Frage
* \`NOT_COMPLETED\` - Unvollständig
* \`LAWFIRM_PARTNER\` - Geschäftspartner
* \`CALL_FORWARDED\` - Anruf weitergeleitet
* \`WITHOUT_MESSAGE\` - Ohne Nachricht
* \`COURT\` - Gericht`
} as const;

export const $ClientAiAnalysis = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        mapper_key: {
            type: 'string',
            readOnly: true
        },
        ai_augments_mapper_keys: {
            readOnly: true
        },
        started_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true,
            nullable: true
        },
        finished_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true,
            nullable: true
        },
        is_finished: {
            type: 'boolean',
            readOnly: true
        },
        case_uuid: {
            type: 'string',
            format: 'uuid'
        },
        document_uuid: {
            type: 'string',
            format: 'uuid'
        }
    },
    required: ['ai_augments_mapper_keys', 'case_uuid', 'document_uuid', 'finished_at', 'is_finished', 'mapper_key', 'started_at', 'uuid']
} as const;

export const $ClientAiAnalysisRequest = {
    type: 'object',
    properties: {
        case_uuid: {
            type: 'string',
            format: 'uuid'
        },
        document_uuid: {
            type: 'string',
            format: 'uuid'
        }
    },
    required: ['case_uuid', 'document_uuid']
} as const;

export const $ClientAiAugmentation = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        augmentation_variant: {
            allOf: [
                {
                    '$ref': '#/components/schemas/AugmentationVariantEnum'
                }
            ],
            readOnly: true
        },
        document: {
            '$ref': '#/components/schemas/Document'
        },
        value: {
            oneOf: [
                {
                    type: 'string'
                },
                {
                    type: 'integer'
                },
                {
                    type: 'boolean'
                },
                {
                    type: 'string',
                    format: 'date'
                },
                {
                    type: 'object',
                    additionalProperties: {}
                },
                {
                    type: 'array',
                    items: {}
                }
            ]
        },
        analysis_mapper_key: {
            type: 'string',
            readOnly: true,
            nullable: true
        },
        augmented_mapper_key: {
            type: 'string',
            readOnly: true
        },
        referenced_document_pages: {
            type: 'array',
            items: {
                type: 'integer'
            }
        },
        explanation: {
            type: 'string'
        }
    },
    required: ['analysis_mapper_key', 'augmentation_variant', 'augmented_mapper_key', 'document', 'explanation', 'referenced_document_pages', 'uuid', 'value']
} as const;

export const $ClientAiAugmentationRequest = {
    type: 'object',
    properties: {
        value: {
            oneOf: [
                {
                    type: 'string'
                },
                {
                    type: 'integer'
                },
                {
                    type: 'boolean'
                },
                {
                    type: 'string',
                    format: 'date'
                },
                {
                    type: 'object',
                    additionalProperties: {}
                },
                {
                    type: 'array',
                    items: {}
                }
            ]
        },
        referenced_document_pages: {
            type: 'array',
            items: {
                type: 'integer'
            }
        },
        explanation: {
            type: 'string',
            minLength: 1
        }
    },
    required: ['explanation', 'referenced_document_pages', 'value']
} as const;

export const $ClientCase = {
    type: 'object',
    description: 'Case representation for clients.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        questionnaire_submissions: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/ClientQuestionnaireSubmission'
            },
            readOnly: true
        },
        form_requests: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/ClientRequest'
            },
            readOnly: true
        },
        pdf_form_submissions: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/ClientPDFFormSubmission'
            },
            readOnly: true
        },
        org: {
            allOf: [
                {
                    '$ref': '#/components/schemas/ClientOrganisation'
                }
            ],
            readOnly: true
        },
        user_access_token: {
            type: 'string',
            readOnly: true
        },
        activities: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/Activity'
            },
            readOnly: true
        },
        client_first_name: {
            type: 'string',
            readOnly: true
        },
        client_last_name: {
            type: 'string',
            readOnly: true
        }
    },
    required: ['activities', 'client_first_name', 'client_last_name', 'form_requests', 'org', 'pdf_form_submissions', 'questionnaire_submissions', 'user_access_token', 'uuid']
} as const;

export const $ClientEntity = {
    type: 'object',
    description: 'Entity representation for clients.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        entity_type: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EntityTypeEnum'
                }
            ],
            title: 'Personentyp'
        },
        title: {
            title: 'Anrede',
            oneOf: [
                {
                    '$ref': '#/components/schemas/TitleEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        first_name: {
            type: 'string',
            title: 'Vorname',
            maxLength: 128
        },
        last_name: {
            type: 'string',
            title: 'Nachname',
            maxLength: 128
        },
        email: {
            type: 'string',
            format: 'email',
            title: 'E-Mail',
            maxLength: 128
        },
        phone: {
            type: 'string',
            title: 'Telefon',
            maxLength: 128
        },
        street: {
            type: 'string',
            title: 'Straße',
            maxLength: 128
        },
        street_number: {
            type: 'string',
            title: 'Hausnummer',
            maxLength: 16
        },
        address_line_2: {
            type: 'string',
            title: 'Adresszusatz',
            maxLength: 128
        },
        zip: {
            type: 'string',
            title: 'PLZ',
            maxLength: 12
        },
        city: {
            type: 'string',
            title: 'Ort',
            maxLength: 100
        },
        date_of_birth: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Geburtsdatum'
        },
        legal_insurance: {
            type: 'boolean',
            nullable: true,
            title: 'Rechtsschutzversicherung'
        },
        legal_insurance_number: {
            type: 'string',
            title: 'Nummer der Rechtsschutzversicherung',
            maxLength: 128
        },
        legal_insurance_name: {
            type: 'string',
            title: 'Name der Rechtsschutzversicherung',
            maxLength: 128
        },
        legal_insurance_deductible_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Höhe der Selbstbeteiligung der Rechtsschutzversicherung'
        },
        is_company: {
            type: 'string',
            readOnly: true
        },
        company_name: {
            type: 'string',
            title: 'Firmenname',
            maxLength: 128
        },
        company_legal_form: {
            title: 'Rechtsform',
            oneOf: [
                {
                    '$ref': '#/components/schemas/CompanyLegalFormEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        company_register_number: {
            type: 'string',
            title: 'Handelsregisternummer',
            maxLength: 128
        },
        company_register_court: {
            type: 'string',
            title: 'Amtsgericht',
            maxLength: 128
        },
        company_vat_id: {
            type: 'string',
            title: 'USt. ID',
            maxLength: 128
        },
        company_tax_id: {
            type: 'string',
            title: 'Steuernummer',
            maxLength: 128
        },
        bank_name: {
            type: 'string',
            title: 'Bankname',
            maxLength: 128
        },
        iban: {
            type: 'string',
            maxLength: 34
        },
        bic: {
            type: 'string',
            maxLength: 11
        },
        institution_name: {
            type: 'string',
            title: 'Name der Institution',
            maxLength: 128
        },
        changes: {
            type: 'array',
            items: {
                type: 'integer'
            },
            readOnly: true
        }
    },
    required: ['changes', 'entity_type', 'is_company', 'uuid']
} as const;

export const $ClientEntityRequest = {
    type: 'object',
    description: 'Entity representation for clients.',
    properties: {
        entity_type: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EntityTypeEnum'
                }
            ],
            title: 'Personentyp'
        },
        title: {
            title: 'Anrede',
            oneOf: [
                {
                    '$ref': '#/components/schemas/TitleEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        first_name: {
            type: 'string',
            title: 'Vorname',
            maxLength: 128
        },
        last_name: {
            type: 'string',
            title: 'Nachname',
            maxLength: 128
        },
        email: {
            type: 'string',
            format: 'email',
            title: 'E-Mail',
            maxLength: 128
        },
        phone: {
            type: 'string',
            title: 'Telefon',
            maxLength: 128
        },
        street: {
            type: 'string',
            title: 'Straße',
            maxLength: 128
        },
        street_number: {
            type: 'string',
            title: 'Hausnummer',
            maxLength: 16
        },
        address_line_2: {
            type: 'string',
            title: 'Adresszusatz',
            maxLength: 128
        },
        zip: {
            type: 'string',
            title: 'PLZ',
            maxLength: 12
        },
        city: {
            type: 'string',
            title: 'Ort',
            maxLength: 100
        },
        date_of_birth: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Geburtsdatum'
        },
        legal_insurance: {
            type: 'boolean',
            nullable: true,
            title: 'Rechtsschutzversicherung'
        },
        legal_insurance_number: {
            type: 'string',
            title: 'Nummer der Rechtsschutzversicherung',
            maxLength: 128
        },
        legal_insurance_name: {
            type: 'string',
            title: 'Name der Rechtsschutzversicherung',
            maxLength: 128
        },
        legal_insurance_deductible_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Höhe der Selbstbeteiligung der Rechtsschutzversicherung'
        },
        company_name: {
            type: 'string',
            title: 'Firmenname',
            maxLength: 128
        },
        company_legal_form: {
            title: 'Rechtsform',
            oneOf: [
                {
                    '$ref': '#/components/schemas/CompanyLegalFormEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        company_register_number: {
            type: 'string',
            title: 'Handelsregisternummer',
            maxLength: 128
        },
        company_register_court: {
            type: 'string',
            title: 'Amtsgericht',
            maxLength: 128
        },
        company_vat_id: {
            type: 'string',
            title: 'USt. ID',
            maxLength: 128
        },
        company_tax_id: {
            type: 'string',
            title: 'Steuernummer',
            maxLength: 128
        },
        bank_name: {
            type: 'string',
            title: 'Bankname',
            maxLength: 128
        },
        iban: {
            type: 'string',
            maxLength: 34
        },
        bic: {
            type: 'string',
            maxLength: 11
        },
        institution_name: {
            type: 'string',
            title: 'Name der Institution',
            maxLength: 128
        }
    },
    required: ['entity_type']
} as const;

export const $ClientForm = {
    type: 'object',
    description: 'Form representation for clients.',
    properties: {
        id: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        organisation: {
            allOf: [
                {
                    '$ref': '#/components/schemas/ClientOrganisation'
                }
            ],
            readOnly: true
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        modified_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        tag: {
            allOf: [
                {
                    '$ref': '#/components/schemas/FormTag'
                }
            ],
            readOnly: true
        },
        title: {
            type: 'string',
            readOnly: true
        },
        description: {
            type: 'string',
            readOnly: true
        },
        file: {
            type: 'string',
            format: 'uri',
            readOnly: true,
            nullable: true
        },
        due_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        document_name: {
            type: 'string',
            readOnly: true
        }
    },
    required: ['created_at', 'description', 'document_name', 'due_at', 'file', 'id', 'modified_at', 'organisation', 'tag', 'title']
} as const;

export const $ClientOrganisation = {
    type: 'object',
    description: 'Organisation representation for clients.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        name: {
            type: 'string',
            readOnly: true,
            nullable: true,
            title: 'Name der Kanzlei'
        },
        logo: {
            type: 'string',
            format: 'uri',
            readOnly: true,
            nullable: true
        },
        description: {
            type: 'string',
            readOnly: true,
            title: 'Beschreibung'
        },
        theme: {
            allOf: [
                {
                    '$ref': '#/components/schemas/ThemeEnum'
                }
            ],
            readOnly: true,
            title: 'Mandanten portal Hauptfarbe'
        }
    },
    required: ['description', 'logo', 'name', 'theme', 'uuid']
} as const;

export const $ClientPDFFormSubmission = {
    type: 'object',
    description: `PDF form submission serializer for client portal.

The frontend handles PDF form submissions separately from legacy forms via type guards.`,
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        template_name: {
            type: 'string',
            readOnly: true,
            description: 'Snapshot of template name at submission creation time'
        },
        template_description: {
            type: 'string',
            readOnly: true,
            description: 'Snapshot of template description at submission creation time'
        },
        submission_status: {
            allOf: [
                {
                    '$ref': '#/components/schemas/SubmissionStatusEnum'
                }
            ],
            readOnly: true,
            description: `Current status of the form submission

* \`in_progress\` - In Progress
* \`completed\` - Completed`
        },
        progress_percentage: {
            type: 'integer',
            readOnly: true,
            description: 'Completion percentage (0-100)'
        },
        is_external: {
            type: 'boolean',
            readOnly: true,
            description: 'External submission linked to existing case for third-party completion'
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        due_at: {
            type: 'string',
            format: 'date-time',
            nullable: true,
            description: 'Calculate due date as 3 days from creation.',
            readOnly: true
        },
        document_uuid: {
            type: 'string',
            readOnly: true,
            nullable: true
        },
        processed_pdf: {
            type: 'string',
            readOnly: true
        },
        flattened_pdf: {
            type: 'string',
            readOnly: true,
            nullable: true
        },
        org: {
            allOf: [
                {
                    '$ref': '#/components/schemas/ClientOrganisation'
                }
            ],
            readOnly: true
        },
        images: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/ImageproxyImagePreset'
            },
            readOnly: true
        }
    },
    required: ['created_at', 'document_uuid', 'due_at', 'flattened_pdf', 'images', 'is_external', 'org', 'processed_pdf', 'progress_percentage', 'submission_status', 'template_description', 'template_name', 'uuid']
} as const;

export const $ClientQuestionnaireSubmission = {
    type: 'object',
    description: 'Questionnaire submission representation for clients.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        case_uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        short_id: {
            type: 'string',
            readOnly: true
        },
        title: {
            type: 'string',
            readOnly: true
        },
        law_field: {
            allOf: [
                {
                    '$ref': '#/components/schemas/LawFieldEnum'
                }
            ],
            readOnly: true,
            title: 'Rechtsgebiet'
        },
        law_topic: {
            allOf: [
                {
                    '$ref': '#/components/schemas/LawTopicEnum'
                }
            ],
            readOnly: true,
            title: 'Rechtsthema'
        },
        pdf_url: {
            type: 'string',
            readOnly: true
        },
        question_count: {
            type: 'integer',
            readOnly: true
        },
        required_question_count: {
            type: 'integer',
            readOnly: true
        },
        optional_question_count: {
            type: 'integer',
            readOnly: true
        },
        answered_question_count: {
            type: 'integer',
            readOnly: true
        },
        answered_required_questions_percent: {
            type: 'number',
            format: 'double',
            readOnly: true
        },
        answered_optional_questions_count: {
            type: 'integer',
            readOnly: true
        },
        answered_questions_percent: {
            type: 'number',
            format: 'double',
            readOnly: true
        },
        answered_optional_questions_percent: {
            type: 'number',
            format: 'double',
            readOnly: true
        },
        is_third_party_questionnaire: {
            type: 'boolean',
            readOnly: true
        },
        due_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        state: {
            type: 'string',
            readOnly: true
        },
        schema: {},
        closed: {
            type: 'boolean'
        }
    },
    required: ['answered_optional_questions_count', 'answered_optional_questions_percent', 'answered_question_count', 'answered_questions_percent', 'answered_required_questions_percent', 'case_uuid', 'created_at', 'due_at', 'is_third_party_questionnaire', 'law_field', 'law_topic', 'optional_question_count', 'pdf_url', 'question_count', 'required_question_count', 'short_id', 'state', 'title', 'uuid']
} as const;

export const $ClientQuestionnaireSubmissionRequest = {
    type: 'object',
    description: 'Questionnaire submission representation for clients.',
    properties: {
        schema: {},
        closed: {
            type: 'boolean'
        }
    }
} as const;

export const $ClientRequest = {
    type: 'object',
    properties: {
        id: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        token: {
            type: 'string',
            maxLength: 255
        },
        form: {
            '$ref': '#/components/schemas/ClientForm'
        },
        response_present: {
            type: 'object',
            additionalProperties: {},
            readOnly: true
        },
        document_uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        is_third_party: {
            type: 'boolean'
        }
    },
    required: ['document_uuid', 'form', 'id', 'response_present', 'token']
} as const;

export const $ClientRequestRequest = {
    type: 'object',
    properties: {
        token: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        },
        is_third_party: {
            type: 'boolean'
        }
    },
    required: ['token']
} as const;

export const $CompanyLegalFormEnum = {
    enum: ['GmbH', 'UG (haftungsbeschränkt)', 'GmbH & Co. KG', 'AG', 'AG & Co. KG', 'KG', 'OHG', 'GBR', 'PartG', 'PartG mbB', 'KGaA', 'eG', 'eV', 'Einzelunternehmen', 'Stiftung', 'SE', 'EWIV', 'Limited', 'PLC', 'SARL', 'SAS', 'SA (FR)', 'SCN', 'S.A.R.L.', 'SRL', 'SPA', 'SL', 'SA (ES)', 'BV', 'NV', 'AB', 'Oy', 'AS', 's.r.o.', 'Kft.', 'Sp. z o.o.', 'OOO'],
    type: 'string',
    description: `* \`\` - 
* \`GmbH\` - GmbH
* \`UG (haftungsbeschränkt)\` - UG (haftungsbeschränkt)
* \`GmbH & Co. KG\` - GmbH & Co. KG
* \`AG\` - AG
* \`AG & Co. KG\` - AG & Co. KG
* \`KG\` - KG
* \`OHG\` - OHG
* \`GBR\` - GbR
* \`PartG\` - PartG
* \`PartG mbB\` - PartG mbB
* \`KGaA\` - KGaA
* \`eG\` - eG
* \`eV\` - eV
* \`Einzelunternehmen\` - Einzelunternehmen
* \`Stiftung\` - Stiftung
* \`SE\` - SE
* \`EWIV\` - EWIV
* \`Limited\` - Limited
* \`PLC\` - PLC
* \`SARL\` - SARL
* \`SAS\` - SAS
* \`SA (FR)\` - SA (FR)
* \`SCN\` - SCN
* \`S.A.R.L.\` - S.A.R.L.
* \`SRL\` - SRL
* \`SPA\` - SPA
* \`SL\` - SL
* \`SA (ES)\` - SA (ES)
* \`BV\` - BV
* \`NV\` - NV
* \`AB\` - AB
* \`Oy\` - Oy
* \`AS\` - AS
* \`s.r.o.\` - s.r.o.
* \`Kft.\` - Kft.
* \`Sp. z o.o.\` - Sp. z o.o.
* \`OOO\` - OOO`
} as const;

export const $ContextRequest = {
    type: 'object',
    properties: {
        key: {
            type: 'string',
            minLength: 1
        },
        context: {
            type: 'object',
            additionalProperties: {}
        }
    },
    required: ['context', 'key']
} as const;

export const $CreateCaseFromInboundEmailRequest = {
    type: 'object',
    properties: {
        inquiry: {
            type: 'string',
            minLength: 1
        },
        client_title: {
            type: 'string',
            minLength: 1
        },
        client_first_name: {
            type: 'string'
        },
        client_last_name: {
            type: 'string',
            minLength: 1
        },
        client_email: {
            type: 'string',
            format: 'email',
            minLength: 1
        },
        client_phone: {
            type: 'string'
        },
        legal_insurance: {
            type: 'boolean',
            nullable: true
        },
        legal_insurance_name: {
            type: 'string'
        },
        legal_insurance_number: {
            type: 'string'
        }
    },
    required: ['client_email', 'client_last_name', 'client_title', 'inquiry']
} as const;

export const $CreatePDFFormTemplateRequest = {
    type: 'object',
    description: 'Serializer for creating new PDF form templates.',
    properties: {
        name: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        },
        description: {
            type: 'string'
        },
        original_pdf: {
            type: 'string',
            format: 'binary',
            description: 'Original PDF template uploaded by user (preserved, never modified)'
        }
    },
    required: ['name', 'original_pdf']
} as const;

export const $CreateWordDocumentFromPlaceholderValuesRequestRequest = {
    type: 'object',
    properties: {
        word_document_template_uuid: {
            type: 'string',
            format: 'uuid'
        },
        name: {
            type: 'string',
            minLength: 1
        },
        placeholder_values: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/PlaceholderValueRequest'
            }
        },
        create_pdf: {
            type: 'boolean',
            default: false
        }
    },
    required: ['name', 'placeholder_values', 'word_document_template_uuid']
} as const;

export const $CreateWordDocumentFromPlaceholderValuesResponse = {
    type: 'object',
    properties: {
        url: {
            type: 'string',
            format: 'uri'
        },
        document_uuid: {
            type: 'string',
            format: 'uuid'
        }
    },
    required: ['document_uuid', 'url']
} as const;

export const $CreateWordDocumentPreviewBlobRequest = {
    type: 'object',
    properties: {
        word_document_template_uuid: {
            type: 'string',
            format: 'uuid'
        },
        placeholder_values: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/PlaceholderValueRequest'
            }
        },
        use_ai_template: {
            type: 'boolean',
            default: false,
            description: 'If true, use the AI-generated template with placeholders instead of the original template'
        }
    },
    required: ['placeholder_values', 'word_document_template_uuid']
} as const;

export const $CreateWordDocumentRequestRequest = {
    type: 'object',
    properties: {
        name: {
            type: 'string',
            minLength: 1
        },
        html: {
            type: 'string',
            minLength: 1
        },
        create_pdf: {
            type: 'boolean'
        }
    },
    required: ['create_pdf', 'html', 'name']
} as const;

export const $CreateWordDocumentResponse = {
    type: 'object',
    properties: {
        url: {
            type: 'string',
            format: 'uri'
        },
        document_uuid: {
            type: 'string'
        }
    },
    required: ['document_uuid', 'url']
} as const;

export const $CreateWordDocumentTemplateDocxWithPlaceholdersRequest = {
    type: 'object',
    description: 'Serializer for creating Word document template with placeholders.',
    properties: {
        word_document_template_uuid: {
            type: 'string',
            format: 'uuid'
        }
    },
    required: ['word_document_template_uuid']
} as const;

export const $CurrentStateEnum = {
    enum: ['CREATED', 'CLIENT_INFO_GATHERING', 'PRE_CASE_CONTEXT_GATHERING', 'CASE_CONTEXT_GATHERING', 'POST_CASE_CONTEXT_GATHERING', 'LEGAL_DOMAIN_CLASSIFICATION', 'WORKFLOW_ASSIGNMENT', 'READY_FOR_ONBOARDING_STEP_1', 'READY_FOR_ONBOARDING_STEP_2', 'DATA_COLLECTION', 'ALL_DATA_COLLECTED', 'DOCUMENT_DRAFTING', 'ALL_DOCUMENTS_DRAFTED', 'READY_FOR_EXPORT', 'EXPORTED', 'ABORTED'],
    type: 'string',
    description: `* \`CREATED\` - Created
* \`CLIENT_INFO_GATHERING\` - Client Info Gathering
* \`PRE_CASE_CONTEXT_GATHERING\` - Pre Case Context Gathering
* \`CASE_CONTEXT_GATHERING\` - Case Context Gathering
* \`POST_CASE_CONTEXT_GATHERING\` - Post Case Context Gathering
* \`LEGAL_DOMAIN_CLASSIFICATION\` - Legal Domain Classification
* \`WORKFLOW_ASSIGNMENT\` - Workflow Assignment
* \`READY_FOR_ONBOARDING_STEP_1\` - Ready For Onboarding Step 1
* \`READY_FOR_ONBOARDING_STEP_2\` - Ready For Onboarding Step 2
* \`DATA_COLLECTION\` - Data Collection
* \`ALL_DATA_COLLECTED\` - All Data Collected
* \`DOCUMENT_DRAFTING\` - Document Drafting
* \`ALL_DOCUMENTS_DRAFTED\` - All Documents Drafted
* \`READY_FOR_EXPORT\` - Ready For Export
* \`EXPORTED\` - Exported
* \`ABORTED\` - Aborted`
} as const;

export const $CustomerAccount = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        account_id: {
            type: 'string',
            maxLength: 28
        }
    },
    required: ['account_id']
} as const;

export const $CustomerAccountRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        account_id: {
            type: 'string',
            minLength: 1,
            maxLength: 28
        }
    },
    required: ['account_id']
} as const;

export const $CustomerActionAutoCommitSettings = {
    type: 'object',
    description: 'ActionAutoCommitSettings representation for customers.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        auto_commit_settings_key: {
            type: 'string',
            maxLength: 255
        },
        can_auto_commit: {
            type: 'boolean'
        },
        additional_user_instructions: {
            type: 'string'
        },
        confidence_threshold: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648
        }
    },
    required: ['auto_commit_settings_key', 'uuid']
} as const;

export const $CustomerActionAutoCommitSettingsRequest = {
    type: 'object',
    description: 'ActionAutoCommitSettings representation for customers.',
    properties: {
        auto_commit_settings_key: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        },
        can_auto_commit: {
            type: 'boolean'
        },
        additional_user_instructions: {
            type: 'string'
        },
        confidence_threshold: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648
        }
    },
    required: ['auto_commit_settings_key']
} as const;

export const $CustomerActivity = {
    type: 'object',
    description: 'Activity serializer for customer role.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        seen_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        activity_type: {
            '$ref': '#/components/schemas/ActivityTypeEnum'
        },
        case_uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        case_client_display_name: {
            type: 'string',
            readOnly: true
        },
        case_client_initials: {
            type: 'string',
            readOnly: true
        },
        case_client_email: {
            type: 'string',
            readOnly: true
        },
        clerk_uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true,
            nullable: true
        },
        clerk_first_name: {
            type: 'string',
            readOnly: true,
            nullable: true
        },
        clerk_last_name: {
            type: 'string',
            readOnly: true,
            nullable: true
        },
        document_title: {
            type: 'string',
            readOnly: true,
            nullable: true
        },
        questionnaire_title: {
            type: 'string',
            readOnly: true,
            nullable: true
        },
        email_from: {
            type: 'string',
            format: 'email',
            readOnly: true,
            nullable: true
        },
        email_to: {
            type: 'string',
            readOnly: true
        },
        appointment_start: {
            type: 'string',
            format: 'date-time',
            readOnly: true,
            nullable: true
        },
        appointment_is_confirmed: {
            type: 'boolean',
            readOnly: true,
            nullable: true
        }
    },
    required: ['activity_type', 'appointment_is_confirmed', 'appointment_start', 'case_client_display_name', 'case_client_email', 'case_client_initials', 'case_uuid', 'clerk_first_name', 'clerk_last_name', 'clerk_uuid', 'created_at', 'document_title', 'email_from', 'email_to', 'questionnaire_title']
} as const;

export const $CustomerActivityRequest = {
    type: 'object',
    description: 'Activity serializer for customer role.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        seen_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        activity_type: {
            '$ref': '#/components/schemas/ActivityTypeEnum'
        }
    },
    required: ['activity_type']
} as const;

export const $CustomerAdminAccount = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        account_id: {
            type: 'string',
            maxLength: 28
        }
    },
    required: ['account_id']
} as const;

export const $CustomerAdminAccountRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        account_id: {
            type: 'string',
            minLength: 1,
            maxLength: 28
        }
    },
    required: ['account_id']
} as const;

export const $CustomerAdminActionAutoCommitSettings = {
    type: 'object',
    description: 'ActionAutoCommitSettings representation for customer admins.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        auto_commit_settings_key: {
            type: 'string',
            maxLength: 255
        },
        can_auto_commit: {
            type: 'boolean'
        },
        additional_user_instructions: {
            type: 'string'
        },
        confidence_threshold: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648
        }
    },
    required: ['auto_commit_settings_key', 'uuid']
} as const;

export const $CustomerAdminActionAutoCommitSettingsRequest = {
    type: 'object',
    description: 'ActionAutoCommitSettings representation for customer admins.',
    properties: {
        auto_commit_settings_key: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        },
        can_auto_commit: {
            type: 'boolean'
        },
        additional_user_instructions: {
            type: 'string'
        },
        confidence_threshold: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648
        }
    },
    required: ['auto_commit_settings_key']
} as const;

export const $CustomerAdminActivity = {
    type: 'object',
    description: 'Activity serializer for customer admin role.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        seen_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        activity_type: {
            '$ref': '#/components/schemas/ActivityTypeEnum'
        },
        case_uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        case_client_display_name: {
            type: 'string',
            readOnly: true
        },
        case_client_initials: {
            type: 'string',
            readOnly: true
        },
        case_client_email: {
            type: 'string',
            readOnly: true
        },
        clerk_uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true,
            nullable: true
        },
        clerk_first_name: {
            type: 'string',
            readOnly: true,
            nullable: true
        },
        clerk_last_name: {
            type: 'string',
            readOnly: true,
            nullable: true
        },
        document_title: {
            type: 'string',
            readOnly: true,
            nullable: true
        },
        questionnaire_title: {
            type: 'string',
            readOnly: true,
            nullable: true
        },
        email_from: {
            type: 'string',
            format: 'email',
            readOnly: true,
            nullable: true
        },
        email_to: {
            type: 'string',
            readOnly: true
        },
        appointment_start: {
            type: 'string',
            format: 'date-time',
            readOnly: true,
            nullable: true
        },
        appointment_is_confirmed: {
            type: 'boolean',
            readOnly: true,
            nullable: true
        }
    },
    required: ['activity_type', 'appointment_is_confirmed', 'appointment_start', 'case_client_display_name', 'case_client_email', 'case_client_initials', 'case_uuid', 'clerk_first_name', 'clerk_last_name', 'clerk_uuid', 'created_at', 'document_title', 'email_from', 'email_to', 'questionnaire_title']
} as const;

export const $CustomerAdminActivityRequest = {
    type: 'object',
    description: 'Activity serializer for customer admin role.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        seen_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        activity_type: {
            '$ref': '#/components/schemas/ActivityTypeEnum'
        }
    },
    required: ['activity_type']
} as const;

export const $CustomerAdminAgentAction = {
    type: 'object',
    description: 'AgentAction representation for customer admins.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        updated_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        agent: {
            type: 'string',
            readOnly: true
        },
        agent_trace_id: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        calling_agent: {
            type: 'string',
            readOnly: true,
            nullable: true
        },
        calling_agent_trace_id: {
            type: 'string',
            format: 'uuid',
            readOnly: true,
            nullable: true
        },
        action_type: {
            allOf: [
                {
                    '$ref': '#/components/schemas/ActionTypeEnum'
                }
            ],
            readOnly: true
        },
        delivery_mode: {
            allOf: [
                {
                    '$ref': '#/components/schemas/DeliveryModeEnum'
                }
            ],
            readOnly: true
        },
        reasoning_translation: {
            type: 'string',
            readOnly: true
        },
        reasoning_commit_decision_translation: {
            type: 'string',
            readOnly: true
        },
        payload: {
            type: 'string',
            readOnly: true
        },
        revert_payload: {
            type: 'string',
            readOnly: true
        },
        is_commitable: {
            type: 'boolean',
            readOnly: true
        },
        is_committed: {
            type: 'boolean',
            readOnly: true
        },
        is_committing: {
            type: 'boolean',
            readOnly: true
        },
        commit_return_value: {
            readOnly: true,
            nullable: true
        },
        commited_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true,
            nullable: true
        },
        commited_by_uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        has_commit_error: {
            type: 'boolean',
            readOnly: true,
            nullable: true
        },
        commit_error: {
            type: 'string',
            readOnly: true,
            nullable: true
        },
        is_revertable: {
            type: 'boolean',
            readOnly: true
        },
        is_reverted: {
            type: 'boolean',
            readOnly: true
        },
        is_reverting: {
            type: 'boolean',
            readOnly: true
        },
        revert_return_value: {
            readOnly: true,
            nullable: true
        },
        reverted_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true,
            nullable: true
        },
        reverted_by_uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        has_revert_error: {
            type: 'boolean',
            readOnly: true,
            nullable: true
        },
        revert_error: {
            type: 'string',
            readOnly: true,
            nullable: true
        },
        case_uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        org_uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        rating: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,1}(?:\\.\\d{0,1})?$',
            readOnly: true,
            nullable: true
        },
        langfuse_trace_url: {
            type: 'string',
            readOnly: true
        }
    },
    required: ['action_type', 'agent', 'agent_trace_id', 'calling_agent', 'calling_agent_trace_id', 'case_uuid', 'commit_error', 'commit_return_value', 'commited_at', 'commited_by_uuid', 'created_at', 'delivery_mode', 'has_commit_error', 'has_revert_error', 'is_commitable', 'is_committed', 'is_committing', 'is_revertable', 'is_reverted', 'is_reverting', 'langfuse_trace_url', 'org_uuid', 'payload', 'rating', 'reasoning_commit_decision_translation', 'reasoning_translation', 'revert_error', 'revert_payload', 'revert_return_value', 'reverted_at', 'reverted_by_uuid', 'updated_at', 'uuid']
} as const;

export const $CustomerAdminAiAnalysis = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        mapper_key: {
            type: 'string',
            readOnly: true
        },
        ai_augments_mapper_keys: {
            readOnly: true
        },
        started_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true,
            nullable: true
        },
        finished_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true,
            nullable: true
        },
        is_finished: {
            type: 'boolean',
            readOnly: true
        },
        case_uuid: {
            type: 'string',
            format: 'uuid'
        },
        document_uuid: {
            type: 'string',
            format: 'uuid'
        }
    },
    required: ['ai_augments_mapper_keys', 'case_uuid', 'document_uuid', 'finished_at', 'is_finished', 'mapper_key', 'started_at', 'uuid']
} as const;

export const $CustomerAdminAiAnalysisRequest = {
    type: 'object',
    properties: {
        case_uuid: {
            type: 'string',
            format: 'uuid'
        },
        document_uuid: {
            type: 'string',
            format: 'uuid'
        }
    },
    required: ['case_uuid', 'document_uuid']
} as const;

export const $CustomerAdminAiAugmentation = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        augmentation_variant: {
            allOf: [
                {
                    '$ref': '#/components/schemas/AugmentationVariantEnum'
                }
            ],
            readOnly: true
        },
        document: {
            '$ref': '#/components/schemas/Document'
        },
        value: {
            oneOf: [
                {
                    type: 'string'
                },
                {
                    type: 'integer'
                },
                {
                    type: 'boolean'
                },
                {
                    type: 'string',
                    format: 'date'
                },
                {
                    type: 'object',
                    additionalProperties: {}
                },
                {
                    type: 'array',
                    items: {}
                }
            ]
        },
        analysis_mapper_key: {
            type: 'string',
            readOnly: true,
            nullable: true
        },
        augmented_mapper_key: {
            type: 'string',
            readOnly: true
        },
        referenced_document_pages: {
            type: 'array',
            items: {
                type: 'integer'
            }
        },
        explanation: {
            type: 'string'
        }
    },
    required: ['analysis_mapper_key', 'augmentation_variant', 'augmented_mapper_key', 'document', 'explanation', 'referenced_document_pages', 'uuid', 'value']
} as const;

export const $CustomerAdminAiAugmentationRequest = {
    type: 'object',
    properties: {
        value: {
            oneOf: [
                {
                    type: 'string'
                },
                {
                    type: 'integer'
                },
                {
                    type: 'boolean'
                },
                {
                    type: 'string',
                    format: 'date'
                },
                {
                    type: 'object',
                    additionalProperties: {}
                },
                {
                    type: 'array',
                    items: {}
                }
            ]
        },
        referenced_document_pages: {
            type: 'array',
            items: {
                type: 'integer'
            }
        },
        explanation: {
            type: 'string',
            minLength: 1
        }
    },
    required: ['explanation', 'referenced_document_pages', 'value']
} as const;

export const $CustomerAdminAiSettings = {
    type: 'object',
    description: 'AI Settings representation for customer admins.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        entity_extraction_instructions: {
            type: 'string',
            description: 'Instructions for AI agents when performing entity extraction'
        },
        auto_commit_settings: {
            type: 'string'
        },
        notification_settings: {
            type: 'string'
        },
        ai_workflows_enabled: {
            type: 'boolean',
            description: 'Enable or disable AI workflows for this organisation. When disabled, AI workflows will not be executed for cases in this organisation.'
        },
        send_notifications_bundled: {
            type: 'boolean',
            description: 'Whether to send notifications bundled or individually'
        },
        bundled_notifications_max_delay: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            description: 'Maximum delay in seconds before sending bundled notifications'
        },
        on_case_pre_case_context_gathering_instructions: {
            type: 'string',
            title: 'Pre Case Context Gathering Instructions',
            description: 'Instructions for AI agents during pre case context gathering'
        },
        on_case_post_case_context_gathering_instructions: {
            type: 'string',
            title: 'Post Case Context Gathering Instructions',
            description: 'Instructions for AI agents during post case context gathering'
        }
    },
    required: ['uuid']
} as const;

export const $CustomerAdminAiSettingsRequest = {
    type: 'object',
    description: 'AI Settings representation for customer admins.',
    properties: {
        entity_extraction_instructions: {
            type: 'string',
            description: 'Instructions for AI agents when performing entity extraction'
        },
        auto_commit_settings: {
            type: 'string'
        },
        notification_settings: {
            type: 'string'
        },
        ai_workflows_enabled: {
            type: 'boolean',
            description: 'Enable or disable AI workflows for this organisation. When disabled, AI workflows will not be executed for cases in this organisation.'
        },
        send_notifications_bundled: {
            type: 'boolean',
            description: 'Whether to send notifications bundled or individually'
        },
        bundled_notifications_max_delay: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            description: 'Maximum delay in seconds before sending bundled notifications'
        },
        on_case_pre_case_context_gathering_instructions: {
            type: 'string',
            title: 'Pre Case Context Gathering Instructions',
            description: 'Instructions for AI agents during pre case context gathering'
        },
        on_case_post_case_context_gathering_instructions: {
            type: 'string',
            title: 'Post Case Context Gathering Instructions',
            description: 'Instructions for AI agents during post case context gathering'
        }
    }
} as const;

export const $CustomerAdminAppointment = {
    type: 'object',
    description: 'Appointment representation for customer admins.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        service: {
            allOf: [
                {
                    '$ref': '#/components/schemas/CustomerAdminService'
                }
            ],
            readOnly: true
        },
        calendar: {
            allOf: [
                {
                    '$ref': '#/components/schemas/CustomerAdminCalendar'
                }
            ],
            readOnly: true
        },
        start: {
            type: 'string',
            format: 'date-time'
        },
        end: {
            type: 'string',
            format: 'date-time'
        },
        location_types: {
            '$ref': '#/components/schemas/LocationTypesEnum'
        },
        location: {},
        conferencing: {},
        description: {
            type: 'string',
            maxLength: 8192
        },
        status: {
            '$ref': '#/components/schemas/AppointmentStatusEnum'
        },
        summary: {
            type: 'string',
            maxLength: 128
        }
    },
    required: ['calendar', 'end', 'service', 'start', 'status', 'summary']
} as const;

export const $CustomerAdminAppointmentProposal = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        service: {
            allOf: [
                {
                    '$ref': '#/components/schemas/CustomerAdminService'
                }
            ],
            readOnly: true
        },
        calendar: {
            allOf: [
                {
                    '$ref': '#/components/schemas/CustomerAdminCalendar'
                }
            ],
            readOnly: true
        },
        start: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        location_type: {
            '$ref': '#/components/schemas/LocationTypeEnum'
        },
        booked: {
            type: 'boolean',
            readOnly: true
        },
        slug: {
            type: 'string',
            readOnly: true,
            pattern: '^[-a-zA-Z0-9_]+$'
        },
        message: {
            type: 'string',
            nullable: true
        },
        channel: {
            type: 'string',
            readOnly: true,
            nullable: true
        }
    },
    required: ['booked', 'calendar', 'channel', 'location_type', 'service', 'slug', 'start']
} as const;

export const $CustomerAdminAppointmentProposalRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        case_uuid: {
            type: 'string',
            writeOnly: true,
            minLength: 1
        },
        start: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        location_type: {
            '$ref': '#/components/schemas/LocationTypeEnum'
        },
        message: {
            type: 'string',
            nullable: true
        },
        service_uuid: {
            type: 'string',
            format: 'uuid',
            writeOnly: true
        },
        calendar_uuid: {
            type: 'string',
            format: 'uuid',
            writeOnly: true
        }
    },
    required: ['calendar_uuid', 'case_uuid', 'location_type', 'service_uuid', 'start']
} as const;

export const $CustomerAdminAssignWorkflowResponse = {
    type: 'object',
    description: 'Customer admin workflow assignment response.',
    properties: {
        assigned_workflow: {
            allOf: [
                {
                    '$ref': '#/components/schemas/CustomerAdminCaseLifecycleWorkflow'
                }
            ],
            nullable: true,
            description: 'Assigned workflow details, null if no workflow is assigned'
        }
    },
    required: ['assigned_workflow']
} as const;

export const $CustomerAdminCalendar = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        active: {
            type: 'boolean',
            title: 'Dieser Kalender ist buchbar'
        },
        name: {
            type: 'string',
            maxLength: 32
        },
        description: {
            type: 'string',
            title: 'Titel',
            maxLength: 32
        },
        long_description: {
            type: 'string',
            title: 'Beschreibung',
            maxLength: 400
        },
        avatar: {
            type: 'string',
            format: 'uri',
            nullable: true,
            title: 'Profilbild'
        },
        services: {
            type: 'array',
            items: {
                type: 'integer'
            }
        },
        slug: {
            type: 'string',
            maxLength: 64,
            pattern: '^[-a-zA-Z0-9_]+$'
        },
        deactivated: {
            type: 'boolean'
        },
        profile: {
            type: 'integer'
        },
        account: {
            allOf: [
                {
                    '$ref': '#/components/schemas/CustomerAdminAccount'
                }
            ],
            readOnly: true
        },
        calendar_id: {
            type: 'string',
            maxLength: 64
        },
        calendar_name: {
            type: 'string',
            maxLength: 64
        },
        calendar_readonly: {
            type: 'boolean'
        },
        calendar_deleted: {
            type: 'boolean'
        },
        calendar_primary: {
            type: 'boolean'
        },
        calendar_integrated_conferencing_available: {
            type: 'boolean'
        },
        calendar_attachments_available: {
            type: 'boolean'
        },
        permission_level: {
            type: 'string',
            maxLength: 32
        }
    },
    required: ['account', 'calendar_id', 'calendar_name', 'permission_level', 'profile']
} as const;

export const $CustomerAdminCalendarRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        active: {
            type: 'boolean',
            title: 'Dieser Kalender ist buchbar'
        },
        name: {
            type: 'string',
            minLength: 1,
            maxLength: 32
        },
        description: {
            type: 'string',
            title: 'Titel',
            maxLength: 32
        },
        long_description: {
            type: 'string',
            title: 'Beschreibung',
            maxLength: 400
        },
        avatar: {
            type: 'string',
            format: 'binary',
            nullable: true,
            title: 'Profilbild'
        },
        services: {
            type: 'array',
            items: {
                type: 'integer'
            }
        },
        slug: {
            type: 'string',
            minLength: 1,
            maxLength: 64,
            pattern: '^[-a-zA-Z0-9_]+$'
        },
        deactivated: {
            type: 'boolean'
        },
        profile: {
            type: 'integer'
        },
        calendar_id: {
            type: 'string',
            minLength: 1,
            maxLength: 64
        },
        calendar_name: {
            type: 'string',
            minLength: 1,
            maxLength: 64
        },
        calendar_readonly: {
            type: 'boolean'
        },
        calendar_deleted: {
            type: 'boolean'
        },
        calendar_primary: {
            type: 'boolean'
        },
        calendar_integrated_conferencing_available: {
            type: 'boolean'
        },
        calendar_attachments_available: {
            type: 'boolean'
        },
        permission_level: {
            type: 'string',
            minLength: 1,
            maxLength: 32
        }
    },
    required: ['calendar_id', 'calendar_name', 'permission_level', 'profile']
} as const;

export const $CustomerAdminCase = {
    type: 'object',
    description: 'Case representation for customer admins.',
    properties: {
        id: {
            type: 'integer',
            readOnly: true
        },
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        questionnaire_submissions: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/CustomerAdminQuestionnaireSubmission'
            },
            readOnly: true
        },
        form_requests: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/CustomerRequest'
            },
            readOnly: true
        },
        org: {
            allOf: [
                {
                    '$ref': '#/components/schemas/CustomerAdminOrganisation'
                }
            ],
            readOnly: true
        },
        modified_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        created_at: {
            type: 'string',
            format: 'date-time'
        },
        note: {
            type: 'string',
            nullable: true,
            title: 'Interne Notizen',
            maxLength: 1024
        },
        type: {
            '$ref': '#/components/schemas/CaseType'
        },
        state: {
            allOf: [
                {
                    '$ref': '#/components/schemas/StateEnum'
                }
            ],
            title: 'Status'
        },
        inquiry: {
            type: 'string',
            title: 'Inhalt der Anfrage'
        },
        data: {
            '$ref': '#/components/schemas/CustomerAdminCaseData'
        },
        client_document_email_reminder_sent_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        client_document_email_reminder_opt_out: {
            type: 'boolean'
        },
        send_outstanding_document_email_reminder: {
            type: 'boolean',
            title: 'Automatisierte E-Mail Erinnerungen für angeforderte Dokumente aktiv'
        },
        sent_to_actaport_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        actaport_case_id: {
            type: 'string',
            nullable: true,
            maxLength: 48
        },
        sent_to_advoware_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        advoware_case_id: {
            type: 'string',
            nullable: true,
            maxLength: 48
        },
        sent_to_iusta_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        iusta_data: {},
        is_selected_for_export_to: {},
        exported_to: {},
        export_data: {},
        sent_to_ra_micro_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        sent_to_advolux_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        last_activity_at: {
            type: 'string',
            format: 'date-time'
        },
        last_activity_seen_at: {
            type: 'string',
            format: 'date-time'
        },
        pdf_form_submissions: {
            type: 'string',
            readOnly: true
        },
        virtual_documents: {
            type: 'string',
            readOnly: true
        },
        clerk: {
            allOf: [
                {
                    '$ref': '#/components/schemas/CustomerAdminOrganisationUser'
                }
            ],
            readOnly: true
        },
        forms: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/CustomerAdminForm'
            },
            readOnly: true
        },
        services: {
            type: 'string',
            readOnly: true
        },
        chat_sessions: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/AIChatSession'
            },
            readOnly: true
        },
        activities: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/Activity'
            },
            readOnly: true
        },
        case_lifecycle_state: {
            allOf: [
                {
                    '$ref': '#/components/schemas/CustomerAdminCaseLifecycleState'
                }
            ],
            readOnly: true
        },
        jupus_case_number: {
            type: 'string',
            nullable: true,
            maxLength: 24
        },
        kleos_case_id: {
            type: 'string',
            nullable: true,
            maxLength: 48
        },
        source_call_uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        }
    },
    required: ['activities', 'case_lifecycle_state', 'chat_sessions', 'clerk', 'form_requests', 'forms', 'id', 'modified_at', 'org', 'pdf_form_submissions', 'questionnaire_submissions', 'services', 'source_call_uuid', 'virtual_documents']
} as const;

export const $CustomerAdminCaseData = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        client: {
            '$ref': '#/components/schemas/Entity'
        },
        opponent: {
            '$ref': '#/components/schemas/Entity'
        },
        law: {
            '$ref': '#/components/schemas/LawData'
        },
        entities: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/CustomerAdminEntityWithRelationship'
            },
            readOnly: true
        },
        changes: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/CustomerAdminCaseDataChange'
            },
            readOnly: true
        },
        mappers: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/GenericDataMapper'
            },
            readOnly: true
        }
    },
    required: ['changes', 'client', 'entities', 'law', 'mappers', 'opponent']
} as const;

export const $CustomerAdminCaseDataChange = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        mapper_key: {
            type: 'string',
            maxLength: 255
        },
        old_value: {
            oneOf: [
                {
                    type: 'string'
                },
                {
                    type: 'integer'
                },
                {
                    type: 'boolean'
                },
                {
                    type: 'string',
                    format: 'date'
                },
                {
                    type: 'object',
                    additionalProperties: {}
                },
                {
                    type: 'array',
                    items: {}
                }
            ]
        },
        new_value: {
            oneOf: [
                {
                    type: 'string'
                },
                {
                    type: 'integer'
                },
                {
                    type: 'boolean'
                },
                {
                    type: 'string',
                    format: 'date'
                },
                {
                    type: 'object',
                    additionalProperties: {}
                },
                {
                    type: 'array',
                    items: {}
                }
            ]
        },
        change_source: {
            '$ref': '#/components/schemas/ChangeSourceEnum'
        },
        user: {
            '$ref': '#/components/schemas/CustomerOrganisationUser'
        },
        ai_augmentation: {
            '$ref': '#/components/schemas/CustomerAdminAiAugmentation'
        }
    },
    required: ['ai_augmentation', 'change_source', 'created_at', 'mapper_key', 'new_value', 'old_value', 'user']
} as const;

export const $CustomerAdminCaseDataChangeRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        mapper_key: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        },
        old_value: {
            oneOf: [
                {
                    type: 'string'
                },
                {
                    type: 'integer'
                },
                {
                    type: 'boolean'
                },
                {
                    type: 'string',
                    format: 'date'
                },
                {
                    type: 'object',
                    additionalProperties: {}
                },
                {
                    type: 'array',
                    items: {}
                }
            ]
        },
        new_value: {
            oneOf: [
                {
                    type: 'string'
                },
                {
                    type: 'integer'
                },
                {
                    type: 'boolean'
                },
                {
                    type: 'string',
                    format: 'date'
                },
                {
                    type: 'object',
                    additionalProperties: {}
                },
                {
                    type: 'array',
                    items: {}
                }
            ]
        },
        change_source: {
            '$ref': '#/components/schemas/ChangeSourceEnum'
        },
        ai_augmentation: {
            '$ref': '#/components/schemas/CustomerAdminAiAugmentationRequest'
        }
    },
    required: ['ai_augmentation', 'change_source', 'mapper_key', 'new_value', 'old_value']
} as const;

export const $CustomerAdminCaseDataRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        client: {
            '$ref': '#/components/schemas/EntityRequest'
        },
        opponent: {
            '$ref': '#/components/schemas/EntityRequest'
        },
        law: {
            '$ref': '#/components/schemas/LawDataRequest'
        }
    },
    required: ['client', 'law', 'opponent']
} as const;

export const $CustomerAdminCaseLifecycleState = {
    type: 'object',
    description: 'Case Lifecycle State representation for customer admins.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        current_state: {
            allOf: [
                {
                    '$ref': '#/components/schemas/CurrentStateEnum'
                }
            ],
            readOnly: true
        },
        assigned_workflow: {
            allOf: [
                {
                    '$ref': '#/components/schemas/CustomerAdminCaseLifecycleWorkflow'
                }
            ],
            readOnly: true
        },
        state_transition_results: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/CaseLifecycleStateTransitionResult'
            },
            readOnly: true
        },
        is_agent_active: {
            type: 'boolean'
        },
        rating: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,1}(?:\\.\\d{0,1})?$',
            readOnly: true,
            nullable: true
        },
        langfuse_session_url: {
            type: 'string',
            readOnly: true
        }
    },
    required: ['assigned_workflow', 'current_state', 'langfuse_session_url', 'rating', 'state_transition_results', 'uuid']
} as const;

export const $CustomerAdminCaseLifecycleStateRequest = {
    type: 'object',
    description: 'Case Lifecycle State representation for customer admins.',
    properties: {
        workflow_uuid: {
            type: 'string',
            format: 'uuid',
            writeOnly: true,
            nullable: true,
            description: 'UUID of the workflow to assign to the case. Set to null to remove workflow assignment.'
        },
        is_agent_active: {
            type: 'boolean'
        }
    }
} as const;

export const $CustomerAdminCaseLifecycleWorkflow = {
    type: 'object',
    description: 'Case Lifecycle Workflow representation for customer admins.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        name: {
            type: 'string',
            maxLength: 255
        },
        law_field: {
            title: 'Rechtsgebiet',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawFieldEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        law_topic: {
            title: 'Rechtsthema',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawTopicEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        on_case_ready_for_onboarding_step_1_instructions: {
            type: 'string',
            title: 'Case Ready for Onboarding Step 1 Instructions',
            description: 'Instructions for AI agents when handling a new case - Step 1'
        },
        on_case_ready_for_onboarding_step_1_auto_commit_settings: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/CustomerAdminActionAutoCommitSettings'
            }
        },
        on_case_ready_for_onboarding_step_2_instructions: {
            type: 'string',
            title: 'Case Ready for Onboarding Step 2 Instructions',
            description: 'Instructions for AI agents when handling a new case - Step 2'
        },
        on_case_ready_for_onboarding_step_2_auto_commit_settings: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/CustomerAdminActionAutoCommitSettings'
            }
        },
        on_all_data_collected_instructions: {
            type: 'string',
            title: 'All Data Collected Instructions',
            description: 'Instructions for AI agents when all data for a case has been collected'
        },
        on_all_data_collected_auto_commit_settings: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/CustomerAdminActionAutoCommitSettings'
            }
        },
        on_all_documents_drafted_auto_commit_settings: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/CustomerAdminActionAutoCommitSettings'
            }
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        updated_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        }
    },
    required: ['created_at', 'name', 'updated_at', 'uuid']
} as const;

export const $CustomerAdminCaseLifecycleWorkflowRequest = {
    type: 'object',
    description: 'Case Lifecycle Workflow representation for customer admins.',
    properties: {
        name: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        },
        law_field: {
            title: 'Rechtsgebiet',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawFieldEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        law_topic: {
            title: 'Rechtsthema',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawTopicEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        on_case_ready_for_onboarding_step_1_instructions: {
            type: 'string',
            title: 'Case Ready for Onboarding Step 1 Instructions',
            description: 'Instructions for AI agents when handling a new case - Step 1'
        },
        on_case_ready_for_onboarding_step_1_auto_commit_settings: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/CustomerAdminActionAutoCommitSettingsRequest'
            }
        },
        on_case_ready_for_onboarding_step_2_instructions: {
            type: 'string',
            title: 'Case Ready for Onboarding Step 2 Instructions',
            description: 'Instructions for AI agents when handling a new case - Step 2'
        },
        on_case_ready_for_onboarding_step_2_auto_commit_settings: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/CustomerAdminActionAutoCommitSettingsRequest'
            }
        },
        on_all_data_collected_instructions: {
            type: 'string',
            title: 'All Data Collected Instructions',
            description: 'Instructions for AI agents when all data for a case has been collected'
        },
        on_all_data_collected_auto_commit_settings: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/CustomerAdminActionAutoCommitSettingsRequest'
            }
        },
        on_all_documents_drafted_auto_commit_settings: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/CustomerAdminActionAutoCommitSettingsRequest'
            }
        }
    },
    required: ['name']
} as const;

export const $CustomerAdminCaseRequest = {
    type: 'object',
    description: 'Case representation for customer admins.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        created_at: {
            type: 'string',
            format: 'date-time'
        },
        note: {
            type: 'string',
            nullable: true,
            title: 'Interne Notizen',
            maxLength: 1024
        },
        type: {
            '$ref': '#/components/schemas/CaseType'
        },
        state: {
            allOf: [
                {
                    '$ref': '#/components/schemas/StateEnum'
                }
            ],
            title: 'Status'
        },
        inquiry: {
            type: 'string',
            title: 'Inhalt der Anfrage'
        },
        data: {
            '$ref': '#/components/schemas/CustomerAdminCaseDataRequest'
        },
        client_document_email_reminder_sent_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        client_document_email_reminder_opt_out: {
            type: 'boolean'
        },
        send_outstanding_document_email_reminder: {
            type: 'boolean',
            title: 'Automatisierte E-Mail Erinnerungen für angeforderte Dokumente aktiv'
        },
        sent_to_actaport_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        actaport_case_id: {
            type: 'string',
            nullable: true,
            minLength: 1,
            maxLength: 48
        },
        sent_to_advoware_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        advoware_case_id: {
            type: 'string',
            nullable: true,
            minLength: 1,
            maxLength: 48
        },
        sent_to_iusta_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        iusta_data: {},
        is_selected_for_export_to: {},
        exported_to: {},
        export_data: {},
        sent_to_ra_micro_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        sent_to_advolux_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        last_activity_at: {
            type: 'string',
            format: 'date-time'
        },
        last_activity_seen_at: {
            type: 'string',
            format: 'date-time'
        },
        clerk_id: {
            type: 'string',
            format: 'uuid',
            writeOnly: true,
            nullable: true
        },
        jupus_case_number: {
            type: 'string',
            nullable: true,
            minLength: 1,
            maxLength: 24
        },
        kleos_case_id: {
            type: 'string',
            nullable: true,
            minLength: 1,
            maxLength: 48
        }
    }
} as const;

export const $CustomerAdminDeliveryEvent = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        event: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EventEnum'
                }
            ],
            readOnly: true
        },
        event_description: {
            type: 'string',
            readOnly: true,
            nullable: true
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        updated_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        }
    },
    required: ['created_at', 'event', 'event_description', 'updated_at', 'uuid']
} as const;

export const $CustomerAdminDocumentTemplate = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        name: {
            type: 'string',
            maxLength: 255
        },
        description: {
            type: 'string'
        },
        system_prompt: {
            type: 'string'
        },
        document_template: {
            type: 'string'
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        updated_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        law_field: {
            title: 'Rechtsgebiet',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawFieldEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        law_topic: {
            title: 'Rechtsthema',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawTopicEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        document: {
            allOf: [
                {
                    '$ref': '#/components/schemas/Document'
                }
            ],
            readOnly: true
        },
        is_jupus_template: {
            type: 'boolean'
        }
    },
    required: ['created_at', 'description', 'document', 'is_jupus_template', 'name', 'system_prompt', 'updated_at']
} as const;

export const $CustomerAdminDocumentTemplateRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        name: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        },
        description: {
            type: 'string',
            minLength: 1
        },
        system_prompt: {
            type: 'string',
            minLength: 1
        },
        document_template: {
            type: 'string'
        },
        law_field: {
            title: 'Rechtsgebiet',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawFieldEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        law_topic: {
            title: 'Rechtsthema',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawTopicEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        is_jupus_template: {
            type: 'boolean'
        }
    },
    required: ['description', 'is_jupus_template', 'name', 'system_prompt']
} as const;

export const $CustomerAdminEmail = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        from_email: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EmailAddress'
                }
            ],
            readOnly: true
        },
        to: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/EmailAddress'
            },
            readOnly: true
        },
        cc: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/EmailAddress'
            },
            readOnly: true
        },
        bcc: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/EmailAddress'
            },
            readOnly: true
        },
        subject: {
            type: 'string',
            maxLength: 255
        },
        text: {
            type: 'string'
        },
        html: {
            type: 'string'
        },
        direction: {
            type: 'string',
            readOnly: true
        },
        source: {
            type: 'string',
            readOnly: true
        },
        sent_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        pdf_url: {
            type: 'string',
            readOnly: true
        },
        relevant_delivery_event: {
            allOf: [
                {
                    '$ref': '#/components/schemas/CustomerAdminDeliveryEvent'
                }
            ],
            readOnly: true
        },
        email_service: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EmailServiceEnum'
                }
            ],
            readOnly: true
        }
    },
    required: ['bcc', 'cc', 'direction', 'email_service', 'from_email', 'pdf_url', 'relevant_delivery_event', 'sent_at', 'source', 'subject', 'to', 'uuid']
} as const;

export const $CustomerAdminEmailTemplate = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        type: {
            '$ref': '#/components/schemas/EmailTemplateType'
        },
        name: {
            type: 'string',
            maxLength: 255
        },
        subject: {
            type: 'string',
            maxLength: 255
        },
        html: {
            type: 'string'
        },
        questionnaires: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/CustomerAdminQuestionnaire'
            },
            readOnly: true
        },
        forms: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/CustomerAdminForm'
            },
            readOnly: true
        },
        pdf_form_templates: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/PDFFormTemplate'
            },
            readOnly: true
        },
        default: {
            type: 'boolean'
        },
        law_field: {
            title: 'Rechtsgebiet',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawFieldEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        law_topic: {
            title: 'Rechtsthema',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawTopicEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        updated_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        }
    },
    required: ['default', 'forms', 'html', 'name', 'pdf_form_templates', 'questionnaires', 'subject', 'type', 'updated_at', 'uuid']
} as const;

export const $CustomerAdminEmailTemplateRequest = {
    type: 'object',
    properties: {
        type: {
            '$ref': '#/components/schemas/EmailTemplateType'
        },
        name: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        },
        subject: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        },
        html: {
            type: 'string',
            minLength: 1
        },
        default: {
            type: 'boolean'
        },
        law_field: {
            title: 'Rechtsgebiet',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawFieldEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        law_topic: {
            title: 'Rechtsthema',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawTopicEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        questionnaire_uuids: {
            type: 'array',
            items: {
                type: 'string',
                format: 'uuid'
            },
            writeOnly: true
        },
        form_uuids: {
            type: 'array',
            items: {
                type: 'string',
                format: 'uuid'
            },
            writeOnly: true
        }
    },
    required: ['default', 'form_uuids', 'html', 'name', 'questionnaire_uuids', 'subject', 'type']
} as const;

export const $CustomerAdminEntity = {
    type: 'object',
    description: 'Entity representation for customer admins.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        entity_type: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EntityTypeEnum'
                }
            ],
            title: 'Personentyp'
        },
        title: {
            title: 'Anrede',
            oneOf: [
                {
                    '$ref': '#/components/schemas/TitleEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        first_name: {
            type: 'string',
            title: 'Vorname',
            maxLength: 128
        },
        last_name: {
            type: 'string',
            title: 'Nachname',
            maxLength: 128
        },
        email: {
            type: 'string',
            format: 'email',
            title: 'E-Mail',
            maxLength: 128
        },
        phone: {
            type: 'string',
            title: 'Telefon',
            maxLength: 128
        },
        street: {
            type: 'string',
            title: 'Straße',
            maxLength: 128
        },
        street_number: {
            type: 'string',
            title: 'Hausnummer',
            maxLength: 16
        },
        address_line_2: {
            type: 'string',
            title: 'Adresszusatz',
            maxLength: 128
        },
        zip: {
            type: 'string',
            title: 'PLZ',
            maxLength: 12
        },
        city: {
            type: 'string',
            title: 'Ort',
            maxLength: 100
        },
        date_of_birth: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Geburtsdatum'
        },
        legal_insurance: {
            type: 'boolean',
            nullable: true,
            title: 'Rechtsschutzversicherung'
        },
        legal_insurance_number: {
            type: 'string',
            title: 'Nummer der Rechtsschutzversicherung',
            maxLength: 128
        },
        legal_insurance_name: {
            type: 'string',
            title: 'Name der Rechtsschutzversicherung',
            maxLength: 128
        },
        legal_insurance_deductible_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Höhe der Selbstbeteiligung der Rechtsschutzversicherung'
        },
        is_company: {
            type: 'string',
            readOnly: true
        },
        company_name: {
            type: 'string',
            title: 'Firmenname',
            maxLength: 128
        },
        company_legal_form: {
            title: 'Rechtsform',
            oneOf: [
                {
                    '$ref': '#/components/schemas/CompanyLegalFormEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        company_register_number: {
            type: 'string',
            title: 'Handelsregisternummer',
            maxLength: 128
        },
        company_register_court: {
            type: 'string',
            title: 'Amtsgericht',
            maxLength: 128
        },
        company_vat_id: {
            type: 'string',
            title: 'USt. ID',
            maxLength: 128
        },
        company_tax_id: {
            type: 'string',
            title: 'Steuernummer',
            maxLength: 128
        },
        bank_name: {
            type: 'string',
            title: 'Bankname',
            maxLength: 128
        },
        iban: {
            type: 'string',
            maxLength: 34
        },
        bic: {
            type: 'string',
            maxLength: 11
        },
        institution_name: {
            type: 'string',
            title: 'Name der Institution',
            maxLength: 128
        },
        changes: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/CustomerAdminEntityChange'
            },
            readOnly: true
        }
    },
    required: ['changes', 'entity_type', 'is_company', 'uuid']
} as const;

export const $CustomerAdminEntityChange = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        entities_mapper_key: {
            '$ref': '#/components/schemas/EntitiesMapperKeyEnum'
        },
        old_value: {
            oneOf: [
                {
                    type: 'string'
                },
                {
                    type: 'integer'
                },
                {
                    type: 'boolean'
                },
                {
                    type: 'string',
                    format: 'date'
                },
                {
                    type: 'object',
                    additionalProperties: {}
                },
                {
                    type: 'array',
                    items: {}
                }
            ]
        },
        new_value: {
            oneOf: [
                {
                    type: 'string'
                },
                {
                    type: 'integer'
                },
                {
                    type: 'boolean'
                },
                {
                    type: 'string',
                    format: 'date'
                },
                {
                    type: 'object',
                    additionalProperties: {}
                },
                {
                    type: 'array',
                    items: {}
                }
            ]
        },
        change_source: {
            '$ref': '#/components/schemas/ChangeSourceEnum'
        },
        user: {
            '$ref': '#/components/schemas/CustomerOrganisationUser'
        },
        ai_augmentation: {
            '$ref': '#/components/schemas/CustomerAdminAiAugmentation'
        }
    },
    required: ['ai_augmentation', 'change_source', 'created_at', 'entities_mapper_key', 'new_value', 'old_value', 'user']
} as const;

export const $CustomerAdminEntityChangeRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        entities_mapper_key: {
            '$ref': '#/components/schemas/EntitiesMapperKeyEnum'
        },
        old_value: {
            oneOf: [
                {
                    type: 'string'
                },
                {
                    type: 'integer'
                },
                {
                    type: 'boolean'
                },
                {
                    type: 'string',
                    format: 'date'
                },
                {
                    type: 'object',
                    additionalProperties: {}
                },
                {
                    type: 'array',
                    items: {}
                }
            ]
        },
        new_value: {
            oneOf: [
                {
                    type: 'string'
                },
                {
                    type: 'integer'
                },
                {
                    type: 'boolean'
                },
                {
                    type: 'string',
                    format: 'date'
                },
                {
                    type: 'object',
                    additionalProperties: {}
                },
                {
                    type: 'array',
                    items: {}
                }
            ]
        },
        change_source: {
            '$ref': '#/components/schemas/ChangeSourceEnum'
        },
        ai_augmentation: {
            '$ref': '#/components/schemas/CustomerAdminAiAugmentationRequest'
        }
    },
    required: ['ai_augmentation', 'change_source', 'entities_mapper_key', 'new_value', 'old_value']
} as const;

export const $CustomerAdminEntityRequest = {
    type: 'object',
    description: 'Entity representation for customer admins.',
    properties: {
        entity_type: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EntityTypeEnum'
                }
            ],
            title: 'Personentyp'
        },
        title: {
            title: 'Anrede',
            oneOf: [
                {
                    '$ref': '#/components/schemas/TitleEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        first_name: {
            type: 'string',
            title: 'Vorname',
            maxLength: 128
        },
        last_name: {
            type: 'string',
            title: 'Nachname',
            maxLength: 128
        },
        email: {
            type: 'string',
            format: 'email',
            title: 'E-Mail',
            maxLength: 128
        },
        phone: {
            type: 'string',
            title: 'Telefon',
            maxLength: 128
        },
        street: {
            type: 'string',
            title: 'Straße',
            maxLength: 128
        },
        street_number: {
            type: 'string',
            title: 'Hausnummer',
            maxLength: 16
        },
        address_line_2: {
            type: 'string',
            title: 'Adresszusatz',
            maxLength: 128
        },
        zip: {
            type: 'string',
            title: 'PLZ',
            maxLength: 12
        },
        city: {
            type: 'string',
            title: 'Ort',
            maxLength: 100
        },
        date_of_birth: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Geburtsdatum'
        },
        legal_insurance: {
            type: 'boolean',
            nullable: true,
            title: 'Rechtsschutzversicherung'
        },
        legal_insurance_number: {
            type: 'string',
            title: 'Nummer der Rechtsschutzversicherung',
            maxLength: 128
        },
        legal_insurance_name: {
            type: 'string',
            title: 'Name der Rechtsschutzversicherung',
            maxLength: 128
        },
        legal_insurance_deductible_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Höhe der Selbstbeteiligung der Rechtsschutzversicherung'
        },
        company_name: {
            type: 'string',
            title: 'Firmenname',
            maxLength: 128
        },
        company_legal_form: {
            title: 'Rechtsform',
            oneOf: [
                {
                    '$ref': '#/components/schemas/CompanyLegalFormEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        company_register_number: {
            type: 'string',
            title: 'Handelsregisternummer',
            maxLength: 128
        },
        company_register_court: {
            type: 'string',
            title: 'Amtsgericht',
            maxLength: 128
        },
        company_vat_id: {
            type: 'string',
            title: 'USt. ID',
            maxLength: 128
        },
        company_tax_id: {
            type: 'string',
            title: 'Steuernummer',
            maxLength: 128
        },
        bank_name: {
            type: 'string',
            title: 'Bankname',
            maxLength: 128
        },
        iban: {
            type: 'string',
            maxLength: 34
        },
        bic: {
            type: 'string',
            maxLength: 11
        },
        institution_name: {
            type: 'string',
            title: 'Name der Institution',
            maxLength: 128
        }
    },
    required: ['entity_type']
} as const;

export const $CustomerAdminEntityWithRelationship = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        entity: {
            '$ref': '#/components/schemas/CustomerAdminEntity'
        },
        relationships: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/EntityRelationship'
            }
        }
    },
    required: ['entity', 'relationships']
} as const;

export const $CustomerAdminEntityWithRelationshipRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        entity: {
            '$ref': '#/components/schemas/CustomerAdminEntityRequest'
        },
        relationships: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/EntityRelationshipRequest'
            }
        }
    },
    required: ['entity', 'relationships']
} as const;

export const $CustomerAdminForm = {
    type: 'object',
    description: 'Form representation for customer admins.',
    properties: {
        id: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        organisation: {
            allOf: [
                {
                    '$ref': '#/components/schemas/CustomerAdminOrganisation'
                }
            ],
            readOnly: true
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        modified_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        created_by: {
            allOf: [
                {
                    '$ref': '#/components/schemas/CustomerAdminUser'
                }
            ],
            readOnly: true
        },
        modified_by: {
            allOf: [
                {
                    '$ref': '#/components/schemas/CustomerAdminUser'
                }
            ],
            readOnly: true
        },
        tag: {
            allOf: [
                {
                    '$ref': '#/components/schemas/FormTag'
                }
            ],
            readOnly: true
        },
        title: {
            type: 'string',
            maxLength: 255
        },
        description: {
            type: 'string'
        },
        md5: {
            type: 'string',
            readOnly: true
        },
        file: {
            type: 'string',
            format: 'uri',
            readOnly: true,
            nullable: true
        },
        due_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        document_name: {
            type: 'string',
            readOnly: true
        }
    },
    required: ['created_at', 'created_by', 'document_name', 'due_at', 'file', 'id', 'md5', 'modified_at', 'modified_by', 'organisation', 'tag']
} as const;

export const $CustomerAdminFormRequest = {
    type: 'object',
    description: 'Form representation for customer admins.',
    properties: {
        title: {
            type: 'string',
            maxLength: 255
        },
        description: {
            type: 'string'
        }
    }
} as const;

export const $CustomerAdminOrganisation = {
    type: 'object',
    description: 'Organisation representation for customer admins.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        oid: {
            type: 'integer',
            readOnly: true
        },
        name: {
            type: 'string',
            nullable: true,
            title: 'Name der Kanzlei',
            maxLength: 128
        },
        logo: {
            type: 'string',
            format: 'uri',
            nullable: true
        },
        description: {
            type: 'string',
            title: 'Beschreibung',
            maxLength: 400
        },
        law_fields: {
            readOnly: true
        },
        short_id: {
            type: 'string',
            maxLength: 8
        },
        street: {
            type: 'string',
            nullable: true,
            title: 'Straße',
            maxLength: 96
        },
        street_number: {
            type: 'string',
            nullable: true,
            title: 'Haus',
            maxLength: 12
        },
        zip: {
            type: 'string',
            nullable: true,
            title: 'PLZ',
            maxLength: 5
        },
        city: {
            type: 'string',
            nullable: true,
            title: 'Stadt',
            maxLength: 64
        },
        country: {
            type: 'string',
            nullable: true,
            title: 'Land',
            maxLength: 96
        },
        latitude: {
            type: 'string',
            nullable: true,
            title: 'Breitengrad'
        },
        longitude: {
            type: 'string',
            nullable: true,
            title: 'Längengrad'
        },
        phone: {
            type: 'string',
            nullable: true,
            title: 'Telefonnummer',
            maxLength: 24
        },
        email: {
            type: 'string',
            format: 'email',
            nullable: true,
            maxLength: 96
        },
        inbound_email_slug: {
            type: 'string',
            readOnly: true
        },
        inbound_email_address: {
            type: 'string',
            readOnly: true
        },
        enable_inbound_email_replies: {
            type: 'boolean',
            title: 'Aktiv'
        },
        seats: {
            type: 'integer',
            readOnly: true,
            title: 'Sitze'
        },
        appointments_seats: {
            type: 'integer',
            readOnly: true,
            title: 'Terminbuchungen Sitze'
        },
        email_text_color: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EmailTextColorEnum'
                }
            ],
            title: 'Textfarbe'
        },
        email_text_font: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EmailTextFontEnum'
                }
            ],
            title: 'Schriftart'
        },
        email_text_size: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EmailTextSizeEnum'
                }
            ],
            title: 'Schriftgröße',
            minimum: -2147483648,
            maximum: 2147483647
        },
        email_signature: {
            type: 'string',
            title: 'E-Mail Signatur'
        },
        email_blocked_senders: {
            title: 'Blockierte Absender'
        },
        email_spam_filter_active: {
            type: 'boolean',
            title: 'Spamfilter aktiv'
        },
        track_email_delivery_events: {
            type: 'boolean',
            title: 'E-Mail Zustell-Events tracken'
        },
        track_opened_click_email_delivery_events: {
            type: 'boolean',
            title: 'E-Mail Öffnungs- und Klick-Events tracken'
        },
        receive_questionnaire_closed_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn ein Fragebogen abgeschlossen wird'
        },
        receive_document_signed_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn ein Dokument abgeschlossen wird'
        },
        receive_new_case_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn eine neue Anfrage erstellt wird'
        },
        receive_new_case_email_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn eine neue E-Mail zu einer Anfrage eingeht'
        },
        receive_new_appointment_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn ein neuer Terminvorschlag erstellt wird'
        },
        send_document_email_reminders: {
            type: 'boolean',
            title: 'Automatisierte E-Mail Erinnerungen aktiv'
        },
        send_document_email_reminders_every_x_days: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            title: 'E-Mail Erinnerungen alle x Tage senden'
        },
        max_reminders: {
            type: 'integer',
            maximum: 2147483647,
            minimum: 1,
            title: 'Maximale Anzahl Erinnerungen pro Dokument',
            description: 'Maximum number of reminders that can be sent per document or questionnaire'
        },
        send_email_client_confirmation_on_new_case: {
            type: 'boolean',
            title: 'E-Mail Bestätigung bei neuer Anfrage senden'
        },
        send_email_client_confirmation_on_new_case_via_email: {
            type: 'boolean',
            title: 'E-Mail Bestätigung bei neuer Anfrage per E-Mail senden'
        },
        receive_clerk_change_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn ein Sachbearbeiter zugewiesen wird'
        },
        receive_email_bounce_notifications: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn eine E-Mail nicht zugestellt werden konnte'
        },
        is_actaport_export_integration_enabled: {
            type: 'boolean',
            readOnly: true,
            title: 'Actaport Integration aktivieren'
        },
        questionnaire_creation_token: {
            type: 'string',
            readOnly: true
        },
        ai_enabled: {
            type: 'boolean',
            readOnly: true,
            title: 'KI Aktiv'
        },
        enable_ai_workflows: {
            type: 'boolean',
            readOnly: true,
            title: 'KI-Workflows aktivieren'
        },
        is_iusta_egress_integration_enabled: {
            type: 'boolean',
            readOnly: true,
            title: 'Iusta Integration aktivieren'
        },
        is_ra_micro_export_integration_enabled: {
            type: 'boolean'
        },
        ra_micro_export_integration_type: {
            nullable: true,
            title: 'Integration Type',
            oneOf: [
                {
                    '$ref': '#/components/schemas/RaMicroExportIntegrationTypeEnum'
                },
                {
                    '$ref': '#/components/schemas/NullEnum'
                }
            ]
        },
        ra_micro_oma_email_id: {
            type: 'string',
            nullable: true,
            title: 'OMA Email ID',
            maxLength: 64
        },
        ra_micro_oma_email: {
            type: 'string',
            format: 'email',
            nullable: true,
            title: 'OMA Email',
            maxLength: 96
        },
        is_advolux_export_integration_enabled: {
            type: 'boolean',
            readOnly: true
        },
        is_webhooks_egress_integration_enabled: {
            type: 'boolean',
            readOnly: true
        },
        webhook_urls: {
            type: 'string',
            nullable: true,
            maxLength: 256
        },
        is_email_egress_integration_enabled: {
            type: 'boolean',
            readOnly: true
        },
        email_egress_address: {
            type: 'string',
            format: 'email',
            nullable: true,
            title: 'Email',
            maxLength: 96
        },
        is_kleos_integration_enabled: {
            type: 'boolean',
            readOnly: true
        },
        is_advoware_export_integration_enabled: {
            type: 'boolean',
            readOnly: true,
            title: 'Advoware Integration aktivieren'
        },
        is_law_firm_software_exportation_enabled: {
            type: 'boolean',
            readOnly: true
        },
        enable_appointments: {
            type: 'boolean',
            readOnly: true,
            title: 'Terminbuchung aktivieren'
        },
        enable_voice: {
            type: 'boolean',
            readOnly: true,
            title: 'KI-Anrufbeantworter aktivieren'
        },
        enable_cases: {
            type: 'boolean',
            readOnly: true,
            title: 'Anfragen aktivieren (normale JUPUS Plattform)'
        },
        is_hubspot_egress_integration_enabled: {
            type: 'boolean',
            readOnly: true
        },
        is_haveibeenpwned_integration_enabled: {
            type: 'boolean',
            readOnly: true
        },
        is_jurnodes_export_integration_enabled: {
            type: 'boolean',
            readOnly: true,
            title: 'Jur|nodes Integration aktivieren'
        },
        is_datev_export_integration_enabled: {
            type: 'boolean'
        },
        advoware_clerk_options: {
            type: 'string',
            readOnly: true
        },
        advoware_law_field_options: {
            type: 'string',
            readOnly: true
        },
        actaport_clerk_options: {
            type: 'string',
            readOnly: true
        },
        actaport_assistant_options: {
            type: 'string',
            readOnly: true
        },
        kleos_case_type_options: {
            type: 'string',
            readOnly: true
        },
        jurnodes_datapool_options: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    id: {
                        type: 'integer'
                    },
                    name: {
                        type: 'string'
                    }
                },
                required: ['id', 'name']
            },
            readOnly: true
        },
        jurnodes_lawyer_options: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    id: {
                        type: 'integer'
                    },
                    name: {
                        type: 'string'
                    }
                },
                required: ['id', 'name']
            },
            readOnly: true
        },
        jurnodes_law_category_options: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    id: {
                        type: 'integer'
                    },
                    name: {
                        type: 'string'
                    }
                },
                required: ['id', 'name']
            },
            readOnly: true
        },
        jurnodes_record_schema_options: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    id: {
                        type: 'integer'
                    },
                    name: {
                        type: 'string'
                    }
                },
                required: ['id', 'name']
            },
            readOnly: true
        },
        users: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/CustomerAdminOrganisationUser'
            },
            readOnly: true
        },
        receive_monthly_updates_summary: {
            type: 'boolean',
            readOnly: true,
            title: 'Monatliche Zusammenfassung per E-Mail erhalten'
        },
        has_churned: {
            type: 'boolean',
            title: 'Hat gekündigt'
        },
        enable_law_specific_data: {
            type: 'boolean',
            readOnly: true,
            title: 'Rechtsspezifische Daten & Dokumentengenerator aktivieren'
        },
        ai_chat_question_templates: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/AiChatQuestionTemplate'
            },
            readOnly: true
        },
        is_new_ui_switch_enabled: {
            type: 'boolean',
            readOnly: true
        },
        is_forced_to_use_new_ui: {
            type: 'boolean',
            readOnly: true
        },
        is_phonebot_self_service_customer: {
            type: 'boolean',
            readOnly: true,
            title: 'Phonebot Self-Service Kunde'
        },
        phonebot_self_service_plan: {
            readOnly: true,
            nullable: true,
            oneOf: [
                {
                    '$ref': '#/components/schemas/PhonebotSelfServicePlanEnum'
                },
                {
                    '$ref': '#/components/schemas/NullEnum'
                }
            ]
        },
        phonebot_trial_ends_at: {
            type: 'string',
            format: 'date',
            readOnly: true,
            nullable: true
        }
    },
    required: ['actaport_assistant_options', 'actaport_clerk_options', 'advoware_clerk_options', 'advoware_law_field_options', 'ai_chat_question_templates', 'ai_enabled', 'appointments_seats', 'enable_ai_workflows', 'enable_appointments', 'enable_cases', 'enable_law_specific_data', 'enable_voice', 'inbound_email_address', 'inbound_email_slug', 'is_actaport_export_integration_enabled', 'is_advolux_export_integration_enabled', 'is_advoware_export_integration_enabled', 'is_email_egress_integration_enabled', 'is_forced_to_use_new_ui', 'is_haveibeenpwned_integration_enabled', 'is_hubspot_egress_integration_enabled', 'is_iusta_egress_integration_enabled', 'is_jurnodes_export_integration_enabled', 'is_kleos_integration_enabled', 'is_law_firm_software_exportation_enabled', 'is_new_ui_switch_enabled', 'is_phonebot_self_service_customer', 'is_webhooks_egress_integration_enabled', 'jurnodes_datapool_options', 'jurnodes_law_category_options', 'jurnodes_lawyer_options', 'jurnodes_record_schema_options', 'kleos_case_type_options', 'law_fields', 'oid', 'phonebot_self_service_plan', 'phonebot_trial_ends_at', 'questionnaire_creation_token', 'receive_monthly_updates_summary', 'seats', 'users', 'uuid']
} as const;

export const $CustomerAdminOrganisationRequest = {
    type: 'object',
    description: 'Organisation representation for customer admins.',
    properties: {
        name: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'Name der Kanzlei',
            maxLength: 128
        },
        logo: {
            type: 'string',
            format: 'binary',
            nullable: true
        },
        description: {
            type: 'string',
            title: 'Beschreibung',
            maxLength: 400
        },
        short_id: {
            type: 'string',
            minLength: 1,
            maxLength: 8
        },
        street: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'Straße',
            maxLength: 96
        },
        street_number: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'Haus',
            maxLength: 12
        },
        zip: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'PLZ',
            maxLength: 5
        },
        city: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'Stadt',
            maxLength: 64
        },
        country: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'Land',
            maxLength: 96
        },
        latitude: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'Breitengrad'
        },
        longitude: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'Längengrad'
        },
        phone: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'Telefonnummer',
            maxLength: 24
        },
        email: {
            type: 'string',
            format: 'email',
            nullable: true,
            minLength: 1,
            maxLength: 96
        },
        enable_inbound_email_replies: {
            type: 'boolean',
            title: 'Aktiv'
        },
        email_text_color: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EmailTextColorEnum'
                }
            ],
            title: 'Textfarbe'
        },
        email_text_font: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EmailTextFontEnum'
                }
            ],
            title: 'Schriftart'
        },
        email_text_size: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EmailTextSizeEnum'
                }
            ],
            title: 'Schriftgröße',
            minimum: -2147483648,
            maximum: 2147483647
        },
        email_signature: {
            type: 'string',
            title: 'E-Mail Signatur'
        },
        email_blocked_senders: {
            title: 'Blockierte Absender'
        },
        email_spam_filter_active: {
            type: 'boolean',
            title: 'Spamfilter aktiv'
        },
        track_email_delivery_events: {
            type: 'boolean',
            title: 'E-Mail Zustell-Events tracken'
        },
        track_opened_click_email_delivery_events: {
            type: 'boolean',
            title: 'E-Mail Öffnungs- und Klick-Events tracken'
        },
        receive_questionnaire_closed_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn ein Fragebogen abgeschlossen wird'
        },
        receive_document_signed_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn ein Dokument abgeschlossen wird'
        },
        receive_new_case_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn eine neue Anfrage erstellt wird'
        },
        receive_new_case_email_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn eine neue E-Mail zu einer Anfrage eingeht'
        },
        receive_new_appointment_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn ein neuer Terminvorschlag erstellt wird'
        },
        send_document_email_reminders: {
            type: 'boolean',
            title: 'Automatisierte E-Mail Erinnerungen aktiv'
        },
        send_document_email_reminders_every_x_days: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            title: 'E-Mail Erinnerungen alle x Tage senden'
        },
        max_reminders: {
            type: 'integer',
            maximum: 2147483647,
            minimum: 1,
            title: 'Maximale Anzahl Erinnerungen pro Dokument',
            description: 'Maximum number of reminders that can be sent per document or questionnaire'
        },
        send_email_client_confirmation_on_new_case: {
            type: 'boolean',
            title: 'E-Mail Bestätigung bei neuer Anfrage senden'
        },
        send_email_client_confirmation_on_new_case_via_email: {
            type: 'boolean',
            title: 'E-Mail Bestätigung bei neuer Anfrage per E-Mail senden'
        },
        receive_clerk_change_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn ein Sachbearbeiter zugewiesen wird'
        },
        receive_email_bounce_notifications: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn eine E-Mail nicht zugestellt werden konnte'
        },
        is_ra_micro_export_integration_enabled: {
            type: 'boolean'
        },
        ra_micro_export_integration_type: {
            nullable: true,
            title: 'Integration Type',
            oneOf: [
                {
                    '$ref': '#/components/schemas/RaMicroExportIntegrationTypeEnum'
                },
                {
                    '$ref': '#/components/schemas/NullEnum'
                }
            ]
        },
        ra_micro_oma_email_id: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'OMA Email ID',
            maxLength: 64
        },
        ra_micro_oma_email: {
            type: 'string',
            format: 'email',
            nullable: true,
            minLength: 1,
            title: 'OMA Email',
            maxLength: 96
        },
        webhook_urls: {
            type: 'string',
            nullable: true,
            maxLength: 256
        },
        email_egress_address: {
            type: 'string',
            format: 'email',
            nullable: true,
            minLength: 1,
            title: 'Email',
            maxLength: 96
        },
        is_datev_export_integration_enabled: {
            type: 'boolean'
        },
        has_churned: {
            type: 'boolean',
            title: 'Hat gekündigt'
        }
    }
} as const;

export const $CustomerAdminOrganisationUser = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        email: {
            type: 'string',
            format: 'email',
            readOnly: true
        },
        first_name: {
            type: 'string',
            readOnly: true,
            title: 'Vorname'
        },
        last_name: {
            type: 'string',
            readOnly: true,
            title: 'Nachname'
        },
        avatar: {
            type: 'string',
            format: 'uri',
            readOnly: true,
            nullable: true
        }
    },
    required: ['avatar', 'email', 'first_name', 'last_name', 'uuid']
} as const;

export const $CustomerAdminPhoneNumber = {
    type: 'object',
    description: 'PhoneNumber representation for customer admins.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        active: {
            type: 'boolean'
        },
        org: {
            allOf: [
                {
                    '$ref': '#/components/schemas/CustomerOrganisation'
                }
            ],
            readOnly: true
        },
        phone_number: {
            type: 'string',
            nullable: true,
            maxLength: 32
        },
        law_fields: {
            title: 'Rechtsgebiete'
        },
        description: {
            type: 'string',
            title: 'Bezeichnung',
            description: 'Hier können Sie eine interne Bezeichnung für die Rufnummer hinterlegen.',
            maxLength: 255
        },
        lawfirm_name: {
            type: 'string',
            title: 'Kanzleiname',
            description: 'Geben Sie hier den Namen Ihrer Kanzlei ein, wie er in der Begrüßungsansage genannt werden soll.',
            maxLength: 255
        },
        address: {
            type: 'string',
            title: 'Adresse',
            description: 'Hier können Sie die Adresse Ihrer Kanzlei hinterlegen. Bei Nachfrage geben wir diese an den Anrufer weiter. Wenn Sie keine unangekündigten Mandantenbesuch wünschen, dann geben Sie hier bitte einen entsprechenden Hinweis.',
            maxLength: 1024
        },
        opening_hours: {
            type: 'string',
            title: 'Öffnungszeiten',
            description: 'Hier können Sie Ihre Öffnungszeiten Ihrer Kanzlei hinterlegen. Bei Nachfrage geben wir diese an den Anrufer weiter.',
            maxLength: 1024
        },
        lawyer_names: {
            type: 'string',
            title: 'Anwälte/Sachbearbeiter',
            description: 'Hier können Sie die Namen Ihrer Anwälte oder Sachbearbeiter hinterlegen. Dies hilft uns dabei, den Namen des Anrufers besser zu erkennen. Bitte tragen Sie nur den Namen ein und keine weitere Bezeichnung wie zum Beispiel Anwalt oder Sachbearbeiter.',
            maxLength: 1024
        },
        has_free_initial_consultation: {
            type: 'boolean',
            title: 'Kostenlose Erstberatung',
            description: 'Bieten Sie eine kostenlose Erstberatung an? Wenn ja, dann aktivieren Sie diese Option und wir geben dies an den Anrufer weiter.'
        },
        original_phone_number: {
            type: 'string',
            title: 'Telefonnummer',
            description: 'Wenn Sie die von uns generierte Nummer intern weiterleiten, geben Sie hier unbedingt die Originalnummer an, welche von den Mandanten angerufen wird. So stellen Sie sicher, dass wir die Anrufe korrekt zuordnen können.',
            maxLength: 255
        },
        can_record_calls: {
            type: 'boolean',
            title: 'Anrufe aufzeichnen',
            description: 'Durch das Aktivieren dieser Option Stellen wir Ihnen auf der Detailseite eines Anrufs einen Mitschnitt des Namen bzw. der E-Mail-Addresse zur Verfügung. Die Aufzeichnung von Anrufen ist in Deutschland nur mit Zustimmung des Anrufers gestattet. Wir weisen Sie darauf hin, dass Sie diese Zustimmung von dem Anrufer einholen müssen.'
        },
        is_in_answering_machine_mode: {
            type: 'boolean',
            title: 'Reiner Anrufbeantworter'
        },
        begin_message: {
            type: 'string',
            title: 'Begrüßung',
            description: 'Hier können Sie eine Begrüßung für den Anrufbeantworter hinterlegen. Diese wird am Anfang des Anrufes abgespielt.',
            maxLength: 1024
        },
        end_message: {
            type: 'string',
            title: 'Abschiedsnachricht',
            description: 'Hier können Sie eine Abschiedsnachricht für den Anrufbeantworter hinterlegen. Diese wird am Ende des Anrufes abgespielt.',
            maxLength: 1024
        },
        forwarding_rules: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/PhoneForwardingRuleList'
            },
            readOnly: true
        }
    },
    required: ['forwarding_rules', 'org', 'uuid']
} as const;

export const $CustomerAdminPhoneNumberRequest = {
    type: 'object',
    description: 'PhoneNumber representation for customer admins.',
    properties: {
        active: {
            type: 'boolean'
        },
        phone_number: {
            type: 'string',
            nullable: true,
            minLength: 1,
            maxLength: 32
        },
        law_fields: {
            title: 'Rechtsgebiete'
        },
        description: {
            type: 'string',
            title: 'Bezeichnung',
            description: 'Hier können Sie eine interne Bezeichnung für die Rufnummer hinterlegen.',
            maxLength: 255
        },
        lawfirm_name: {
            type: 'string',
            title: 'Kanzleiname',
            description: 'Geben Sie hier den Namen Ihrer Kanzlei ein, wie er in der Begrüßungsansage genannt werden soll.',
            maxLength: 255
        },
        address: {
            type: 'string',
            title: 'Adresse',
            description: 'Hier können Sie die Adresse Ihrer Kanzlei hinterlegen. Bei Nachfrage geben wir diese an den Anrufer weiter. Wenn Sie keine unangekündigten Mandantenbesuch wünschen, dann geben Sie hier bitte einen entsprechenden Hinweis.',
            maxLength: 1024
        },
        opening_hours: {
            type: 'string',
            title: 'Öffnungszeiten',
            description: 'Hier können Sie Ihre Öffnungszeiten Ihrer Kanzlei hinterlegen. Bei Nachfrage geben wir diese an den Anrufer weiter.',
            maxLength: 1024
        },
        lawyer_names: {
            type: 'string',
            title: 'Anwälte/Sachbearbeiter',
            description: 'Hier können Sie die Namen Ihrer Anwälte oder Sachbearbeiter hinterlegen. Dies hilft uns dabei, den Namen des Anrufers besser zu erkennen. Bitte tragen Sie nur den Namen ein und keine weitere Bezeichnung wie zum Beispiel Anwalt oder Sachbearbeiter.',
            maxLength: 1024
        },
        has_free_initial_consultation: {
            type: 'boolean',
            title: 'Kostenlose Erstberatung',
            description: 'Bieten Sie eine kostenlose Erstberatung an? Wenn ja, dann aktivieren Sie diese Option und wir geben dies an den Anrufer weiter.'
        },
        original_phone_number: {
            type: 'string',
            title: 'Telefonnummer',
            description: 'Wenn Sie die von uns generierte Nummer intern weiterleiten, geben Sie hier unbedingt die Originalnummer an, welche von den Mandanten angerufen wird. So stellen Sie sicher, dass wir die Anrufe korrekt zuordnen können.',
            maxLength: 255
        },
        can_record_calls: {
            type: 'boolean',
            title: 'Anrufe aufzeichnen',
            description: 'Durch das Aktivieren dieser Option Stellen wir Ihnen auf der Detailseite eines Anrufs einen Mitschnitt des Namen bzw. der E-Mail-Addresse zur Verfügung. Die Aufzeichnung von Anrufen ist in Deutschland nur mit Zustimmung des Anrufers gestattet. Wir weisen Sie darauf hin, dass Sie diese Zustimmung von dem Anrufer einholen müssen.'
        },
        is_in_answering_machine_mode: {
            type: 'boolean',
            title: 'Reiner Anrufbeantworter'
        },
        begin_message: {
            type: 'string',
            title: 'Begrüßung',
            description: 'Hier können Sie eine Begrüßung für den Anrufbeantworter hinterlegen. Diese wird am Anfang des Anrufes abgespielt.',
            maxLength: 1024
        },
        end_message: {
            type: 'string',
            title: 'Abschiedsnachricht',
            description: 'Hier können Sie eine Abschiedsnachricht für den Anrufbeantworter hinterlegen. Diese wird am Ende des Anrufes abgespielt.',
            maxLength: 1024
        }
    }
} as const;

export const $CustomerAdminQuestionnaire = {
    type: 'object',
    description: 'Questionnaire representation for customer admins.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        title: {
            type: 'string',
            maxLength: 64
        },
        description: {
            type: 'string'
        },
        schema: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/QuestionnaireSection'
            }
        },
        theme_color: {
            type: 'string',
            readOnly: true
        },
        is_jupus_template: {
            type: 'boolean',
            readOnly: true,
            description: 'True if this questionnaire is a Jupus template that can be copied by organizations'
        },
        org: {
            allOf: [
                {
                    '$ref': '#/components/schemas/ClientOrganisation'
                }
            ],
            readOnly: true
        },
        law_field: {
            title: 'Rechtsgebiet',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawFieldEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        law_topic: {
            title: 'Rechtsthema',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawTopicEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        updated_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        created_by_name: {
            type: 'string',
            readOnly: true
        },
        questionnaire_creation_token: {
            type: 'string',
            readOnly: true
        },
        org_questionnaire_creation_token: {
            type: 'string',
            readOnly: true
        }
    },
    required: ['created_by_name', 'is_jupus_template', 'org', 'org_questionnaire_creation_token', 'questionnaire_creation_token', 'schema', 'theme_color', 'title', 'updated_at', 'uuid']
} as const;

export const $CustomerAdminQuestionnaireRequest = {
    type: 'object',
    description: 'Questionnaire representation for customer admins.',
    properties: {
        title: {
            type: 'string',
            minLength: 1,
            maxLength: 64
        },
        description: {
            type: 'string'
        },
        schema: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/QuestionnaireSectionRequest'
            }
        },
        law_field: {
            title: 'Rechtsgebiet',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawFieldEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        law_topic: {
            title: 'Rechtsthema',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawTopicEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        }
    },
    required: ['schema', 'title']
} as const;

export const $CustomerAdminQuestionnaireSubmission = {
    type: 'object',
    description: 'Questionnaire submission representation for customer admins.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        case_uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        short_id: {
            type: 'string',
            readOnly: true
        },
        title: {
            type: 'string',
            readOnly: true
        },
        law_field: {
            allOf: [
                {
                    '$ref': '#/components/schemas/LawFieldEnum'
                }
            ],
            readOnly: true,
            title: 'Rechtsgebiet'
        },
        law_topic: {
            allOf: [
                {
                    '$ref': '#/components/schemas/LawTopicEnum'
                }
            ],
            readOnly: true,
            title: 'Rechtsthema'
        },
        pdf_url: {
            type: 'string',
            readOnly: true
        },
        question_count: {
            type: 'integer',
            readOnly: true
        },
        required_question_count: {
            type: 'integer',
            readOnly: true
        },
        optional_question_count: {
            type: 'integer',
            readOnly: true
        },
        answered_question_count: {
            type: 'integer',
            readOnly: true
        },
        answered_required_questions_percent: {
            type: 'number',
            format: 'double',
            readOnly: true
        },
        answered_optional_questions_count: {
            type: 'integer',
            readOnly: true
        },
        answered_questions_percent: {
            type: 'number',
            format: 'double',
            readOnly: true
        },
        answered_optional_questions_percent: {
            type: 'number',
            format: 'double',
            readOnly: true
        },
        is_third_party_questionnaire: {
            type: 'boolean',
            readOnly: true
        },
        due_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        state: {
            type: 'string',
            readOnly: true
        },
        schema: {},
        closed: {
            type: 'boolean'
        }
    },
    required: ['answered_optional_questions_count', 'answered_optional_questions_percent', 'answered_question_count', 'answered_questions_percent', 'answered_required_questions_percent', 'case_uuid', 'created_at', 'due_at', 'is_third_party_questionnaire', 'law_field', 'law_topic', 'optional_question_count', 'pdf_url', 'question_count', 'required_question_count', 'short_id', 'state', 'title', 'uuid']
} as const;

export const $CustomerAdminQuestionnaireSubmissionRequest = {
    type: 'object',
    description: 'Questionnaire submission representation for customer admins.',
    properties: {
        schema: {},
        closed: {
            type: 'boolean'
        }
    }
} as const;

export const $CustomerAdminService = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        org: {
            type: 'integer'
        },
        active: {
            type: 'boolean',
            title: 'Diese Leistung ist buchbar'
        },
        name: {
            type: 'string',
            title: 'Titel',
            maxLength: 32
        },
        description: {
            type: 'string',
            title: 'Beschreibung',
            maxLength: 400
        },
        duration_mins: {
            type: 'integer'
        },
        buffer_mins: {
            type: 'integer'
        },
        price: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,6}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Preis'
        },
        currency: {
            type: 'string',
            title: 'Währung',
            maxLength: 8
        },
        unit: {
            type: 'string',
            title: 'Einheit',
            maxLength: 32
        },
        show_price: {
            type: 'boolean',
            title: 'Preis anzeigen',
            description: 'Wenn aktiviert, wird der Preis der Leistung während der Buchung des Termins angezeigt.'
        },
        slug: {
            type: 'string',
            maxLength: 64,
            pattern: '^[-a-zA-Z0-9_]+$'
        },
        online_appointment_enabled: {
            type: 'boolean',
            title: 'Online-Termin'
        },
        telephone_appointment_enabled: {
            type: 'boolean',
            title: 'Telefon-Termin'
        },
        in_person_appointment_enabled: {
            type: 'boolean',
            title: 'Termin vor Ort'
        },
        calendars: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/Calendar'
            },
            readOnly: true
        },
        location_types: {
            type: 'string',
            readOnly: true
        },
        availability_query: {
            type: 'object',
            additionalProperties: {},
            readOnly: true
        }
    },
    required: ['availability_query', 'buffer_mins', 'calendars', 'description', 'duration_mins', 'location_types', 'name', 'org']
} as const;

export const $CustomerAdminServiceRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        org: {
            type: 'integer'
        },
        active: {
            type: 'boolean',
            title: 'Diese Leistung ist buchbar'
        },
        name: {
            type: 'string',
            minLength: 1,
            title: 'Titel',
            maxLength: 32
        },
        description: {
            type: 'string',
            minLength: 1,
            title: 'Beschreibung',
            maxLength: 400
        },
        duration_mins: {
            type: 'integer'
        },
        buffer_mins: {
            type: 'integer'
        },
        price: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,6}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Preis'
        },
        currency: {
            type: 'string',
            minLength: 1,
            title: 'Währung',
            maxLength: 8
        },
        unit: {
            type: 'string',
            minLength: 1,
            title: 'Einheit',
            maxLength: 32
        },
        show_price: {
            type: 'boolean',
            title: 'Preis anzeigen',
            description: 'Wenn aktiviert, wird der Preis der Leistung während der Buchung des Termins angezeigt.'
        },
        slug: {
            type: 'string',
            minLength: 1,
            maxLength: 64,
            pattern: '^[-a-zA-Z0-9_]+$'
        },
        online_appointment_enabled: {
            type: 'boolean',
            title: 'Online-Termin'
        },
        telephone_appointment_enabled: {
            type: 'boolean',
            title: 'Telefon-Termin'
        },
        in_person_appointment_enabled: {
            type: 'boolean',
            title: 'Termin vor Ort'
        }
    },
    required: ['buffer_mins', 'description', 'duration_mins', 'name', 'org']
} as const;

export const $CustomerAdminUser = {
    type: 'object',
    description: 'User representation for customer admins.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        email: {
            type: 'string',
            format: 'email',
            maxLength: 254
        },
        first_name: {
            type: 'string',
            title: 'Vorname',
            maxLength: 150
        },
        last_name: {
            type: 'string',
            title: 'Nachname',
            maxLength: 150
        },
        avatar: {
            type: 'string',
            format: 'uri',
            nullable: true
        },
        org: {
            allOf: [
                {
                    '$ref': '#/components/schemas/CustomerAdminOrganisation'
                }
            ],
            readOnly: true
        },
        uid: {
            type: 'integer',
            readOnly: true
        },
        role: {
            nullable: true,
            oneOf: [
                {
                    '$ref': '#/components/schemas/Role5ccEnum'
                },
                {
                    '$ref': '#/components/schemas/NullEnum'
                }
            ]
        },
        email_signature: {
            type: 'string',
            title: 'E-Mail Signatur'
        },
        case_dashboard_widgets: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/CaseDashboardWidgetsEnum'
            }
        },
        global_ai_chat_intro_seen: {
            type: 'boolean',
            description: 'Whether the user has seen and accepted the global AI chat intro page'
        },
        global_ai_chat_badge_dismissed: {
            type: 'boolean',
            description: 'Whether the user has clicked on Global AI Chat navigation item (badge should be hidden)'
        },
        is_impersonated_session: {
            type: 'boolean',
            description: `Check if the current session is an impersonated session.

:param obj: The user object being serialized
:return: True if this is an impersonated session, False otherwise`,
            readOnly: true
        }
    },
    required: ['case_dashboard_widgets', 'email', 'is_impersonated_session', 'org', 'uid', 'uuid']
} as const;

export const $CustomerAdminUserRequest = {
    type: 'object',
    description: 'User representation for customer admins.',
    properties: {
        email: {
            type: 'string',
            format: 'email',
            minLength: 1,
            maxLength: 254
        },
        first_name: {
            type: 'string',
            title: 'Vorname',
            maxLength: 150
        },
        last_name: {
            type: 'string',
            title: 'Nachname',
            maxLength: 150
        },
        avatar: {
            type: 'string',
            format: 'binary',
            nullable: true
        },
        role: {
            nullable: true,
            oneOf: [
                {
                    '$ref': '#/components/schemas/Role5ccEnum'
                },
                {
                    '$ref': '#/components/schemas/NullEnum'
                }
            ]
        },
        email_signature: {
            type: 'string',
            title: 'E-Mail Signatur'
        },
        case_dashboard_widgets: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/CaseDashboardWidgetsEnum'
            }
        },
        global_ai_chat_intro_seen: {
            type: 'boolean',
            description: 'Whether the user has seen and accepted the global AI chat intro page'
        },
        global_ai_chat_badge_dismissed: {
            type: 'boolean',
            description: 'Whether the user has clicked on Global AI Chat navigation item (badge should be hidden)'
        }
    },
    required: ['case_dashboard_widgets', 'email']
} as const;

export const $CustomerAdminWordDocumentTemplate = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        name: {
            type: 'string',
            maxLength: 255
        },
        description: {
            type: 'string'
        },
        system_prompt: {
            type: 'string'
        },
        original_docx_template: {
            type: 'string',
            format: 'uri',
            readOnly: true,
            nullable: true
        },
        docx_template: {
            type: 'string',
            format: 'uri',
            nullable: true,
            description: 'Active template used for document generation (can be original, AI-generated, or custom upload)'
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        updated_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        law_field: {
            title: 'Rechtsgebiet',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawFieldEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        law_topic: {
            title: 'Rechtsthema',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawTopicEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        document: {
            allOf: [
                {
                    '$ref': '#/components/schemas/Document'
                }
            ],
            readOnly: true
        },
        is_jupus_template: {
            type: 'boolean'
        },
        replaceable_variables: {
            nullable: true
        },
        status: {
            allOf: [
                {
                    '$ref': '#/components/schemas/WordTemplateStatus'
                }
            ],
            description: `Current status of the template in the review workflow

* \`draft\` - Draft
* \`in_review\` - In Review
* \`approved\` - Approved`
        }
    },
    required: ['created_at', 'description', 'document', 'is_jupus_template', 'name', 'original_docx_template', 'system_prompt', 'updated_at']
} as const;

export const $CustomerAdminWordDocumentTemplateRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        name: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        },
        description: {
            type: 'string',
            minLength: 1
        },
        system_prompt: {
            type: 'string',
            minLength: 1
        },
        docx_template: {
            type: 'string',
            format: 'binary',
            nullable: true,
            description: 'Active template used for document generation (can be original, AI-generated, or custom upload)'
        },
        law_field: {
            title: 'Rechtsgebiet',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawFieldEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        law_topic: {
            title: 'Rechtsthema',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawTopicEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        is_jupus_template: {
            type: 'boolean'
        },
        replaceable_variables: {
            nullable: true
        },
        status: {
            allOf: [
                {
                    '$ref': '#/components/schemas/WordTemplateStatus'
                }
            ],
            description: `Current status of the template in the review workflow

* \`draft\` - Draft
* \`in_review\` - In Review
* \`approved\` - Approved`
        }
    },
    required: ['description', 'is_jupus_template', 'name', 'system_prompt']
} as const;

export const $CustomerAgentAction = {
    type: 'object',
    description: 'AgentAction representation for customers.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        updated_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        agent: {
            type: 'string',
            readOnly: true
        },
        agent_trace_id: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        calling_agent: {
            type: 'string',
            readOnly: true,
            nullable: true
        },
        calling_agent_trace_id: {
            type: 'string',
            format: 'uuid',
            readOnly: true,
            nullable: true
        },
        action_type: {
            allOf: [
                {
                    '$ref': '#/components/schemas/ActionTypeEnum'
                }
            ],
            readOnly: true
        },
        delivery_mode: {
            allOf: [
                {
                    '$ref': '#/components/schemas/DeliveryModeEnum'
                }
            ],
            readOnly: true
        },
        reasoning_translation: {
            type: 'string',
            readOnly: true
        },
        reasoning_commit_decision_translation: {
            type: 'string',
            readOnly: true
        },
        payload: {
            type: 'string',
            readOnly: true
        },
        revert_payload: {
            type: 'string',
            readOnly: true
        },
        is_commitable: {
            type: 'boolean',
            readOnly: true
        },
        is_committed: {
            type: 'boolean',
            readOnly: true
        },
        is_committing: {
            type: 'boolean',
            readOnly: true
        },
        commit_return_value: {
            readOnly: true,
            nullable: true
        },
        commited_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true,
            nullable: true
        },
        commited_by_uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        has_commit_error: {
            type: 'boolean',
            readOnly: true,
            nullable: true
        },
        commit_error: {
            type: 'string',
            readOnly: true,
            nullable: true
        },
        is_revertable: {
            type: 'boolean',
            readOnly: true
        },
        is_reverted: {
            type: 'boolean',
            readOnly: true
        },
        is_reverting: {
            type: 'boolean',
            readOnly: true
        },
        revert_return_value: {
            readOnly: true,
            nullable: true
        },
        reverted_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true,
            nullable: true
        },
        reverted_by_uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        has_revert_error: {
            type: 'boolean',
            readOnly: true,
            nullable: true
        },
        revert_error: {
            type: 'string',
            readOnly: true,
            nullable: true
        },
        case_uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        org_uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        rating: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,1}(?:\\.\\d{0,1})?$',
            readOnly: true,
            nullable: true
        },
        langfuse_trace_url: {
            type: 'string',
            readOnly: true
        }
    },
    required: ['action_type', 'agent', 'agent_trace_id', 'calling_agent', 'calling_agent_trace_id', 'case_uuid', 'commit_error', 'commit_return_value', 'commited_at', 'commited_by_uuid', 'created_at', 'delivery_mode', 'has_commit_error', 'has_revert_error', 'is_commitable', 'is_committed', 'is_committing', 'is_revertable', 'is_reverted', 'is_reverting', 'langfuse_trace_url', 'org_uuid', 'payload', 'rating', 'reasoning_commit_decision_translation', 'reasoning_translation', 'revert_error', 'revert_payload', 'revert_return_value', 'reverted_at', 'reverted_by_uuid', 'updated_at', 'uuid']
} as const;

export const $CustomerAiAnalysis = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        mapper_key: {
            type: 'string',
            readOnly: true
        },
        ai_augments_mapper_keys: {
            readOnly: true
        },
        started_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true,
            nullable: true
        },
        finished_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true,
            nullable: true
        },
        is_finished: {
            type: 'boolean',
            readOnly: true
        },
        case_uuid: {
            type: 'string',
            format: 'uuid'
        },
        document_uuid: {
            type: 'string',
            format: 'uuid'
        }
    },
    required: ['ai_augments_mapper_keys', 'case_uuid', 'document_uuid', 'finished_at', 'is_finished', 'mapper_key', 'started_at', 'uuid']
} as const;

export const $CustomerAiAnalysisRequest = {
    type: 'object',
    properties: {
        case_uuid: {
            type: 'string',
            format: 'uuid'
        },
        document_uuid: {
            type: 'string',
            format: 'uuid'
        }
    },
    required: ['case_uuid', 'document_uuid']
} as const;

export const $CustomerAiAugmentation = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        augmentation_variant: {
            allOf: [
                {
                    '$ref': '#/components/schemas/AugmentationVariantEnum'
                }
            ],
            readOnly: true
        },
        document: {
            '$ref': '#/components/schemas/Document'
        },
        value: {
            oneOf: [
                {
                    type: 'string'
                },
                {
                    type: 'integer'
                },
                {
                    type: 'boolean'
                },
                {
                    type: 'string',
                    format: 'date'
                },
                {
                    type: 'object',
                    additionalProperties: {}
                },
                {
                    type: 'array',
                    items: {}
                }
            ]
        },
        analysis_mapper_key: {
            type: 'string',
            readOnly: true,
            nullable: true
        },
        augmented_mapper_key: {
            type: 'string',
            readOnly: true
        },
        referenced_document_pages: {
            type: 'array',
            items: {
                type: 'integer'
            }
        },
        explanation: {
            type: 'string'
        }
    },
    required: ['analysis_mapper_key', 'augmentation_variant', 'augmented_mapper_key', 'document', 'explanation', 'referenced_document_pages', 'uuid', 'value']
} as const;

export const $CustomerAiAugmentationRequest = {
    type: 'object',
    properties: {
        value: {
            oneOf: [
                {
                    type: 'string'
                },
                {
                    type: 'integer'
                },
                {
                    type: 'boolean'
                },
                {
                    type: 'string',
                    format: 'date'
                },
                {
                    type: 'object',
                    additionalProperties: {}
                },
                {
                    type: 'array',
                    items: {}
                }
            ]
        },
        referenced_document_pages: {
            type: 'array',
            items: {
                type: 'integer'
            }
        },
        explanation: {
            type: 'string',
            minLength: 1
        }
    },
    required: ['explanation', 'referenced_document_pages', 'value']
} as const;

export const $CustomerAiSettings = {
    type: 'object',
    description: 'AI Settings representation for customers.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        entity_extraction_instructions: {
            type: 'string',
            description: 'Instructions for AI agents when performing entity extraction'
        },
        auto_commit_settings: {
            type: 'string'
        },
        notification_settings: {
            type: 'string'
        },
        ai_workflows_enabled: {
            type: 'boolean',
            description: 'Enable or disable AI workflows for this organisation. When disabled, AI workflows will not be executed for cases in this organisation.'
        },
        send_notifications_bundled: {
            type: 'boolean',
            description: 'Whether to send notifications bundled or individually'
        },
        bundled_notifications_max_delay: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            description: 'Maximum delay in seconds before sending bundled notifications'
        },
        on_case_pre_case_context_gathering_instructions: {
            type: 'string',
            title: 'Pre Case Context Gathering Instructions',
            description: 'Instructions for AI agents during pre case context gathering'
        },
        on_case_post_case_context_gathering_instructions: {
            type: 'string',
            title: 'Post Case Context Gathering Instructions',
            description: 'Instructions for AI agents during post case context gathering'
        }
    },
    required: ['uuid']
} as const;

export const $CustomerAiSettingsRequest = {
    type: 'object',
    description: 'AI Settings representation for customers.',
    properties: {
        entity_extraction_instructions: {
            type: 'string',
            description: 'Instructions for AI agents when performing entity extraction'
        },
        auto_commit_settings: {
            type: 'string'
        },
        notification_settings: {
            type: 'string'
        },
        ai_workflows_enabled: {
            type: 'boolean',
            description: 'Enable or disable AI workflows for this organisation. When disabled, AI workflows will not be executed for cases in this organisation.'
        },
        send_notifications_bundled: {
            type: 'boolean',
            description: 'Whether to send notifications bundled or individually'
        },
        bundled_notifications_max_delay: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            description: 'Maximum delay in seconds before sending bundled notifications'
        },
        on_case_pre_case_context_gathering_instructions: {
            type: 'string',
            title: 'Pre Case Context Gathering Instructions',
            description: 'Instructions for AI agents during pre case context gathering'
        },
        on_case_post_case_context_gathering_instructions: {
            type: 'string',
            title: 'Post Case Context Gathering Instructions',
            description: 'Instructions for AI agents during post case context gathering'
        }
    }
} as const;

export const $CustomerAppointment = {
    type: 'object',
    description: 'Appointment representation for customers.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        service: {
            '$ref': '#/components/schemas/CustomerService'
        },
        calendar: {
            '$ref': '#/components/schemas/CustomerCalendar'
        },
        start: {
            type: 'string',
            format: 'date-time'
        },
        end: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        location_types: {
            '$ref': '#/components/schemas/LocationTypesEnum'
        },
        location: {
            readOnly: true
        },
        conferencing: {
            readOnly: true
        },
        description: {
            type: 'string',
            readOnly: true
        },
        status: {
            allOf: [
                {
                    '$ref': '#/components/schemas/AppointmentStatusEnum'
                }
            ],
            readOnly: true
        },
        summary: {
            type: 'string',
            readOnly: true
        }
    },
    required: ['calendar', 'conferencing', 'description', 'end', 'location', 'service', 'start', 'status', 'summary', 'uuid']
} as const;

export const $CustomerAppointmentProposal = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        service: {
            allOf: [
                {
                    '$ref': '#/components/schemas/CustomerService'
                }
            ],
            readOnly: true
        },
        calendar: {
            allOf: [
                {
                    '$ref': '#/components/schemas/CustomerCalendar'
                }
            ],
            readOnly: true
        },
        start: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        location_type: {
            '$ref': '#/components/schemas/LocationTypeEnum'
        },
        booked: {
            type: 'boolean',
            readOnly: true
        },
        slug: {
            type: 'string',
            readOnly: true,
            pattern: '^[-a-zA-Z0-9_]+$'
        },
        message: {
            type: 'string',
            nullable: true
        },
        channel: {
            type: 'string',
            readOnly: true,
            nullable: true
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true,
            nullable: true
        }
    },
    required: ['booked', 'calendar', 'channel', 'created_at', 'location_type', 'service', 'slug', 'start']
} as const;

export const $CustomerAppointmentProposalRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        case_uuid: {
            type: 'string',
            writeOnly: true,
            minLength: 1
        },
        start: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        location_type: {
            '$ref': '#/components/schemas/LocationTypeEnum'
        },
        message: {
            type: 'string',
            nullable: true
        },
        service_uuid: {
            type: 'string',
            format: 'uuid',
            writeOnly: true
        },
        calendar_uuid: {
            type: 'string',
            format: 'uuid',
            writeOnly: true
        }
    },
    required: ['calendar_uuid', 'case_uuid', 'location_type', 'service_uuid', 'start']
} as const;

export const $CustomerAppointmentRequest = {
    type: 'object',
    description: 'Appointment representation for customers.',
    properties: {
        service: {
            '$ref': '#/components/schemas/CustomerServiceRequest'
        },
        calendar: {
            '$ref': '#/components/schemas/CustomerCalendarRequest'
        },
        start: {
            type: 'string',
            format: 'date-time'
        },
        location_types: {
            '$ref': '#/components/schemas/LocationTypesEnum'
        },
        case: {
            type: 'integer',
            writeOnly: true
        }
    },
    required: ['calendar', 'case', 'service', 'start']
} as const;

export const $CustomerAssignWorkflowResponse = {
    type: 'object',
    description: 'Customer workflow assignment response.',
    properties: {
        assigned_workflow: {
            allOf: [
                {
                    '$ref': '#/components/schemas/CustomerCaseLifecycleWorkflow'
                }
            ],
            nullable: true,
            description: 'Assigned workflow details, null if no workflow is assigned'
        }
    },
    required: ['assigned_workflow']
} as const;

export const $CustomerCalendar = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        active: {
            type: 'boolean',
            title: 'Dieser Kalender ist buchbar'
        },
        name: {
            type: 'string',
            maxLength: 32
        },
        description: {
            type: 'string',
            title: 'Titel',
            maxLength: 32
        },
        long_description: {
            type: 'string',
            title: 'Beschreibung',
            maxLength: 400
        },
        avatar: {
            type: 'string',
            format: 'uri',
            nullable: true,
            title: 'Profilbild'
        },
        services: {
            type: 'array',
            items: {
                type: 'integer'
            }
        },
        slug: {
            type: 'string',
            maxLength: 64,
            pattern: '^[-a-zA-Z0-9_]+$'
        },
        deactivated: {
            type: 'boolean'
        },
        profile: {
            type: 'integer'
        },
        account: {
            allOf: [
                {
                    '$ref': '#/components/schemas/CustomerAccount'
                }
            ],
            readOnly: true
        },
        calendar_id: {
            type: 'string',
            maxLength: 64
        },
        calendar_name: {
            type: 'string',
            maxLength: 64
        },
        calendar_readonly: {
            type: 'boolean'
        },
        calendar_deleted: {
            type: 'boolean'
        },
        calendar_primary: {
            type: 'boolean'
        },
        calendar_integrated_conferencing_available: {
            type: 'boolean'
        },
        calendar_attachments_available: {
            type: 'boolean'
        },
        permission_level: {
            type: 'string',
            maxLength: 32
        }
    },
    required: ['account', 'calendar_id', 'calendar_name', 'permission_level', 'profile']
} as const;

export const $CustomerCalendarRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        active: {
            type: 'boolean',
            title: 'Dieser Kalender ist buchbar'
        },
        name: {
            type: 'string',
            minLength: 1,
            maxLength: 32
        },
        description: {
            type: 'string',
            title: 'Titel',
            maxLength: 32
        },
        long_description: {
            type: 'string',
            title: 'Beschreibung',
            maxLength: 400
        },
        avatar: {
            type: 'string',
            format: 'binary',
            nullable: true,
            title: 'Profilbild'
        },
        services: {
            type: 'array',
            items: {
                type: 'integer'
            }
        },
        slug: {
            type: 'string',
            minLength: 1,
            maxLength: 64,
            pattern: '^[-a-zA-Z0-9_]+$'
        },
        deactivated: {
            type: 'boolean'
        },
        profile: {
            type: 'integer'
        },
        calendar_id: {
            type: 'string',
            minLength: 1,
            maxLength: 64
        },
        calendar_name: {
            type: 'string',
            minLength: 1,
            maxLength: 64
        },
        calendar_readonly: {
            type: 'boolean'
        },
        calendar_deleted: {
            type: 'boolean'
        },
        calendar_primary: {
            type: 'boolean'
        },
        calendar_integrated_conferencing_available: {
            type: 'boolean'
        },
        calendar_attachments_available: {
            type: 'boolean'
        },
        permission_level: {
            type: 'string',
            minLength: 1,
            maxLength: 32
        }
    },
    required: ['calendar_id', 'calendar_name', 'permission_level', 'profile']
} as const;

export const $CustomerCall = {
    type: 'object',
    description: 'Call representation for customers.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        audio_recording_url: {
            type: 'string',
            nullable: true,
            description: 'Return the URL of the audio recording of the call.',
            readOnly: true
        },
        call_start_time: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        call_end_time: {
            type: 'string',
            format: 'date-time',
            readOnly: true,
            nullable: true
        },
        phone_number: {
            allOf: [
                {
                    '$ref': '#/components/schemas/CustomerPhoneNumber'
                }
            ],
            readOnly: true
        },
        result: {
            '$ref': '#/components/schemas/CustomerCallResult'
        },
        lawyer_feedback: {
            allOf: [
                {
                    '$ref': '#/components/schemas/CustomerLawyerFeedback'
                }
            ],
            readOnly: true
        },
        duration: {
            type: 'integer',
            readOnly: true
        },
        case_uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        case_id: {
            type: 'integer',
            readOnly: true
        },
        case: {
            allOf: [
                {
                    '$ref': '#/components/schemas/CaseInfo'
                }
            ],
            readOnly: true
        },
        note: {
            type: 'string',
            nullable: true,
            title: 'Interne Notizen',
            maxLength: 1024
        },
        clerk: {
            allOf: [
                {
                    '$ref': '#/components/schemas/CustomerOrganisationUser'
                }
            ],
            readOnly: true
        },
        forward: {
            allOf: [
                {
                    '$ref': '#/components/schemas/Forward'
                }
            ],
            nullable: true
        }
    },
    required: ['audio_recording_url', 'call_end_time', 'call_start_time', 'case', 'case_id', 'case_uuid', 'clerk', 'duration', 'lawyer_feedback', 'phone_number', 'result', 'uuid']
} as const;

export const $CustomerCallRequest = {
    type: 'object',
    description: 'Call representation for customers.',
    properties: {
        result: {
            '$ref': '#/components/schemas/CustomerCallResultRequest'
        },
        note: {
            type: 'string',
            nullable: true,
            title: 'Interne Notizen',
            maxLength: 1024
        },
        clerk_id: {
            type: 'string',
            format: 'uuid',
            writeOnly: true,
            nullable: true
        },
        forward: {
            allOf: [
                {
                    '$ref': '#/components/schemas/ForwardRequest'
                }
            ],
            nullable: true
        }
    },
    required: ['result']
} as const;

export const $CustomerCallResult = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        classification: {
            allOf: [
                {
                    '$ref': '#/components/schemas/ClassificationEnum'
                }
            ],
            readOnly: true
        },
        inquiry: {
            type: 'string',
            readOnly: true
        },
        data: {
            '$ref': '#/components/schemas/ShallowCaseData'
        },
        first_name_recording_start_seconds: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            readOnly: true,
            nullable: true
        },
        first_name_recording_end_seconds: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            readOnly: true,
            nullable: true
        },
        last_name_recording_start_seconds: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            readOnly: true,
            nullable: true
        },
        last_name_recording_end_seconds: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            readOnly: true,
            nullable: true
        },
        email_recording_start_seconds: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            readOnly: true,
            nullable: true
        },
        email_recording_end_seconds: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            readOnly: true,
            nullable: true
        },
        phone_number_recording_start_seconds: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            readOnly: true,
            nullable: true
        },
        phone_number_recording_end_seconds: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            readOnly: true,
            nullable: true
        }
    },
    required: ['classification', 'data', 'email_recording_end_seconds', 'email_recording_start_seconds', 'first_name_recording_end_seconds', 'first_name_recording_start_seconds', 'inquiry', 'last_name_recording_end_seconds', 'last_name_recording_start_seconds', 'phone_number_recording_end_seconds', 'phone_number_recording_start_seconds', 'uuid']
} as const;

export const $CustomerCallResultRequest = {
    type: 'object',
    properties: {
        data: {
            '$ref': '#/components/schemas/ShallowCaseDataRequest'
        }
    },
    required: ['data']
} as const;

export const $CustomerCase = {
    type: 'object',
    description: 'Case representation for customers.',
    properties: {
        id: {
            type: 'integer',
            readOnly: true
        },
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        questionnaire_submissions: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/CustomerQuestionnaireSubmission'
            },
            readOnly: true
        },
        form_requests: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/CustomerRequest'
            },
            readOnly: true
        },
        org: {
            allOf: [
                {
                    '$ref': '#/components/schemas/CustomerOrganisation'
                }
            ],
            readOnly: true
        },
        modified_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        created_at: {
            type: 'string',
            format: 'date-time'
        },
        note: {
            type: 'string',
            nullable: true,
            title: 'Interne Notizen',
            maxLength: 1024
        },
        type: {
            '$ref': '#/components/schemas/CaseType'
        },
        state: {
            allOf: [
                {
                    '$ref': '#/components/schemas/StateEnum'
                }
            ],
            title: 'Status'
        },
        inquiry: {
            type: 'string',
            title: 'Inhalt der Anfrage'
        },
        data: {
            '$ref': '#/components/schemas/CustomerCaseData'
        },
        client_document_email_reminder_sent_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        client_document_email_reminder_opt_out: {
            type: 'boolean'
        },
        send_outstanding_document_email_reminder: {
            type: 'boolean',
            title: 'Automatisierte E-Mail Erinnerungen für angeforderte Dokumente aktiv'
        },
        sent_to_actaport_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        actaport_case_id: {
            type: 'string',
            nullable: true,
            maxLength: 48
        },
        sent_to_advoware_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        advoware_case_id: {
            type: 'string',
            nullable: true,
            maxLength: 48
        },
        sent_to_iusta_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        iusta_data: {},
        is_selected_for_export_to: {},
        exported_to: {},
        export_data: {},
        sent_to_ra_micro_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        sent_to_advolux_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        last_activity_at: {
            type: 'string',
            format: 'date-time'
        },
        last_activity_seen_at: {
            type: 'string',
            format: 'date-time'
        },
        pdf_form_submissions: {
            type: 'string',
            readOnly: true
        },
        virtual_documents: {
            type: 'string',
            readOnly: true
        },
        clerk: {
            allOf: [
                {
                    '$ref': '#/components/schemas/CustomerOrganisationUser'
                }
            ],
            readOnly: true
        },
        services: {
            type: 'string',
            readOnly: true
        },
        chat_sessions: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/AIChatSession'
            },
            readOnly: true
        },
        activities: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/Activity'
            },
            readOnly: true
        },
        case_lifecycle_state: {
            allOf: [
                {
                    '$ref': '#/components/schemas/CustomerCaseLifecycleState'
                }
            ],
            readOnly: true
        },
        jupus_case_number: {
            type: 'string',
            nullable: true,
            maxLength: 24
        },
        kleos_case_id: {
            type: 'string',
            nullable: true,
            maxLength: 48
        },
        source_call_uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        }
    },
    required: ['activities', 'case_lifecycle_state', 'chat_sessions', 'clerk', 'form_requests', 'id', 'modified_at', 'org', 'pdf_form_submissions', 'questionnaire_submissions', 'services', 'source_call_uuid', 'virtual_documents']
} as const;

export const $CustomerCaseData = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        client: {
            '$ref': '#/components/schemas/Entity'
        },
        opponent: {
            '$ref': '#/components/schemas/Entity'
        },
        law: {
            '$ref': '#/components/schemas/LawData'
        },
        entities: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/CustomerEntityWithRelationship'
            },
            readOnly: true
        },
        changes: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/CustomerCaseDataChange'
            },
            readOnly: true
        },
        mappers: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/GenericDataMapper'
            },
            readOnly: true
        }
    },
    required: ['changes', 'client', 'entities', 'law', 'mappers', 'opponent']
} as const;

export const $CustomerCaseDataChange = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        mapper_key: {
            type: 'string',
            maxLength: 255
        },
        old_value: {
            oneOf: [
                {
                    type: 'string'
                },
                {
                    type: 'integer'
                },
                {
                    type: 'boolean'
                },
                {
                    type: 'string',
                    format: 'date'
                },
                {
                    type: 'object',
                    additionalProperties: {}
                },
                {
                    type: 'array',
                    items: {}
                }
            ]
        },
        new_value: {
            oneOf: [
                {
                    type: 'string'
                },
                {
                    type: 'integer'
                },
                {
                    type: 'boolean'
                },
                {
                    type: 'string',
                    format: 'date'
                },
                {
                    type: 'object',
                    additionalProperties: {}
                },
                {
                    type: 'array',
                    items: {}
                }
            ]
        },
        change_source: {
            '$ref': '#/components/schemas/ChangeSourceEnum'
        },
        user: {
            '$ref': '#/components/schemas/CustomerOrganisationUser'
        },
        ai_augmentation: {
            '$ref': '#/components/schemas/CustomerAiAugmentation'
        }
    },
    required: ['ai_augmentation', 'change_source', 'created_at', 'mapper_key', 'new_value', 'old_value', 'user']
} as const;

export const $CustomerCaseDataChangeRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        mapper_key: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        },
        old_value: {
            oneOf: [
                {
                    type: 'string'
                },
                {
                    type: 'integer'
                },
                {
                    type: 'boolean'
                },
                {
                    type: 'string',
                    format: 'date'
                },
                {
                    type: 'object',
                    additionalProperties: {}
                },
                {
                    type: 'array',
                    items: {}
                }
            ]
        },
        new_value: {
            oneOf: [
                {
                    type: 'string'
                },
                {
                    type: 'integer'
                },
                {
                    type: 'boolean'
                },
                {
                    type: 'string',
                    format: 'date'
                },
                {
                    type: 'object',
                    additionalProperties: {}
                },
                {
                    type: 'array',
                    items: {}
                }
            ]
        },
        change_source: {
            '$ref': '#/components/schemas/ChangeSourceEnum'
        },
        ai_augmentation: {
            '$ref': '#/components/schemas/CustomerAiAugmentationRequest'
        }
    },
    required: ['ai_augmentation', 'change_source', 'mapper_key', 'new_value', 'old_value']
} as const;

export const $CustomerCaseDataRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        client: {
            '$ref': '#/components/schemas/EntityRequest'
        },
        opponent: {
            '$ref': '#/components/schemas/EntityRequest'
        },
        law: {
            '$ref': '#/components/schemas/LawDataRequest'
        }
    },
    required: ['client', 'law', 'opponent']
} as const;

export const $CustomerCaseLifecycleState = {
    type: 'object',
    description: 'Case Lifecycle State representation for customers.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        current_state: {
            allOf: [
                {
                    '$ref': '#/components/schemas/CurrentStateEnum'
                }
            ],
            readOnly: true
        },
        assigned_workflow: {
            allOf: [
                {
                    '$ref': '#/components/schemas/CustomerCaseLifecycleWorkflow'
                }
            ],
            readOnly: true
        },
        state_transition_results: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/CaseLifecycleStateTransitionResult'
            },
            readOnly: true
        },
        is_agent_active: {
            type: 'boolean'
        },
        rating: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,1}(?:\\.\\d{0,1})?$',
            readOnly: true,
            nullable: true
        },
        langfuse_session_url: {
            type: 'string',
            readOnly: true
        }
    },
    required: ['assigned_workflow', 'current_state', 'langfuse_session_url', 'rating', 'state_transition_results', 'uuid']
} as const;

export const $CustomerCaseLifecycleStateRequest = {
    type: 'object',
    description: 'Case Lifecycle State representation for customers.',
    properties: {
        workflow_uuid: {
            type: 'string',
            format: 'uuid',
            writeOnly: true,
            nullable: true,
            description: 'UUID of the workflow to assign to the case. Set to null to remove workflow assignment.'
        },
        is_agent_active: {
            type: 'boolean'
        }
    }
} as const;

export const $CustomerCaseLifecycleWorkflow = {
    type: 'object',
    description: 'Case Lifecycle Workflow representation for customers.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        name: {
            type: 'string',
            maxLength: 255
        },
        law_field: {
            title: 'Rechtsgebiet',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawFieldEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        law_topic: {
            title: 'Rechtsthema',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawTopicEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        on_case_ready_for_onboarding_step_1_instructions: {
            type: 'string',
            title: 'Case Ready for Onboarding Step 1 Instructions',
            description: 'Instructions for AI agents when handling a new case - Step 1'
        },
        on_case_ready_for_onboarding_step_1_auto_commit_settings: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/CustomerActionAutoCommitSettings'
            }
        },
        on_case_ready_for_onboarding_step_2_instructions: {
            type: 'string',
            title: 'Case Ready for Onboarding Step 2 Instructions',
            description: 'Instructions for AI agents when handling a new case - Step 2'
        },
        on_case_ready_for_onboarding_step_2_auto_commit_settings: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/CustomerActionAutoCommitSettings'
            }
        },
        on_all_data_collected_instructions: {
            type: 'string',
            title: 'All Data Collected Instructions',
            description: 'Instructions for AI agents when all data for a case has been collected'
        },
        on_all_data_collected_auto_commit_settings: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/CustomerActionAutoCommitSettings'
            }
        },
        on_all_documents_drafted_auto_commit_settings: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/CustomerActionAutoCommitSettings'
            }
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        updated_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        }
    },
    required: ['created_at', 'name', 'updated_at', 'uuid']
} as const;

export const $CustomerCaseLifecycleWorkflowRequest = {
    type: 'object',
    description: 'Case Lifecycle Workflow representation for customers.',
    properties: {
        name: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        },
        law_field: {
            title: 'Rechtsgebiet',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawFieldEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        law_topic: {
            title: 'Rechtsthema',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawTopicEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        on_case_ready_for_onboarding_step_1_instructions: {
            type: 'string',
            title: 'Case Ready for Onboarding Step 1 Instructions',
            description: 'Instructions for AI agents when handling a new case - Step 1'
        },
        on_case_ready_for_onboarding_step_1_auto_commit_settings: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/CustomerActionAutoCommitSettingsRequest'
            }
        },
        on_case_ready_for_onboarding_step_2_instructions: {
            type: 'string',
            title: 'Case Ready for Onboarding Step 2 Instructions',
            description: 'Instructions for AI agents when handling a new case - Step 2'
        },
        on_case_ready_for_onboarding_step_2_auto_commit_settings: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/CustomerActionAutoCommitSettingsRequest'
            }
        },
        on_all_data_collected_instructions: {
            type: 'string',
            title: 'All Data Collected Instructions',
            description: 'Instructions for AI agents when all data for a case has been collected'
        },
        on_all_data_collected_auto_commit_settings: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/CustomerActionAutoCommitSettingsRequest'
            }
        },
        on_all_documents_drafted_auto_commit_settings: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/CustomerActionAutoCommitSettingsRequest'
            }
        }
    },
    required: ['name']
} as const;

export const $CustomerCaseRequest = {
    type: 'object',
    description: 'Case representation for customers.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        created_at: {
            type: 'string',
            format: 'date-time'
        },
        note: {
            type: 'string',
            nullable: true,
            title: 'Interne Notizen',
            maxLength: 1024
        },
        type: {
            '$ref': '#/components/schemas/CaseType'
        },
        state: {
            allOf: [
                {
                    '$ref': '#/components/schemas/StateEnum'
                }
            ],
            title: 'Status'
        },
        inquiry: {
            type: 'string',
            title: 'Inhalt der Anfrage'
        },
        data: {
            '$ref': '#/components/schemas/CustomerCaseDataRequest'
        },
        client_document_email_reminder_sent_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        client_document_email_reminder_opt_out: {
            type: 'boolean'
        },
        send_outstanding_document_email_reminder: {
            type: 'boolean',
            title: 'Automatisierte E-Mail Erinnerungen für angeforderte Dokumente aktiv'
        },
        sent_to_actaport_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        actaport_case_id: {
            type: 'string',
            nullable: true,
            minLength: 1,
            maxLength: 48
        },
        sent_to_advoware_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        advoware_case_id: {
            type: 'string',
            nullable: true,
            minLength: 1,
            maxLength: 48
        },
        sent_to_iusta_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        iusta_data: {},
        is_selected_for_export_to: {},
        exported_to: {},
        export_data: {},
        sent_to_ra_micro_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        sent_to_advolux_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        last_activity_at: {
            type: 'string',
            format: 'date-time'
        },
        last_activity_seen_at: {
            type: 'string',
            format: 'date-time'
        },
        clerk_id: {
            type: 'string',
            format: 'uuid',
            writeOnly: true,
            nullable: true
        },
        jupus_case_number: {
            type: 'string',
            nullable: true,
            minLength: 1,
            maxLength: 24
        },
        kleos_case_id: {
            type: 'string',
            nullable: true,
            minLength: 1,
            maxLength: 48
        }
    }
} as const;

export const $CustomerDeliveryEvent = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        event: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EventEnum'
                }
            ],
            readOnly: true
        },
        event_description: {
            type: 'string',
            readOnly: true,
            nullable: true
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        updated_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        }
    },
    required: ['created_at', 'event', 'event_description', 'updated_at', 'uuid']
} as const;

export const $CustomerDocumentTemplate = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        name: {
            type: 'string',
            maxLength: 255
        },
        description: {
            type: 'string'
        },
        system_prompt: {
            type: 'string'
        },
        document_template: {
            type: 'string'
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        updated_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        law_field: {
            title: 'Rechtsgebiet',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawFieldEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        law_topic: {
            title: 'Rechtsthema',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawTopicEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        document: {
            allOf: [
                {
                    '$ref': '#/components/schemas/Document'
                }
            ],
            readOnly: true
        },
        is_jupus_template: {
            type: 'boolean'
        }
    },
    required: ['created_at', 'description', 'document', 'is_jupus_template', 'name', 'system_prompt', 'updated_at']
} as const;

export const $CustomerDocumentTemplateRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        name: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        },
        description: {
            type: 'string',
            minLength: 1
        },
        system_prompt: {
            type: 'string',
            minLength: 1
        },
        document_template: {
            type: 'string'
        },
        law_field: {
            title: 'Rechtsgebiet',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawFieldEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        law_topic: {
            title: 'Rechtsthema',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawTopicEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        is_jupus_template: {
            type: 'boolean'
        }
    },
    required: ['description', 'is_jupus_template', 'name', 'system_prompt']
} as const;

export const $CustomerEmail = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        from_email: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EmailAddress'
                }
            ],
            readOnly: true
        },
        to: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/EmailAddress'
            },
            readOnly: true
        },
        cc: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/EmailAddress'
            },
            readOnly: true
        },
        bcc: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/EmailAddress'
            },
            readOnly: true
        },
        subject: {
            type: 'string',
            maxLength: 255
        },
        text: {
            type: 'string'
        },
        html: {
            type: 'string'
        },
        direction: {
            type: 'string',
            readOnly: true
        },
        source: {
            type: 'string',
            readOnly: true
        },
        sent_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        pdf_url: {
            type: 'string',
            readOnly: true
        },
        relevant_delivery_event: {
            allOf: [
                {
                    '$ref': '#/components/schemas/CustomerDeliveryEvent'
                }
            ],
            readOnly: true
        },
        email_service: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EmailServiceEnum'
                }
            ],
            readOnly: true
        }
    },
    required: ['bcc', 'cc', 'direction', 'email_service', 'from_email', 'pdf_url', 'relevant_delivery_event', 'sent_at', 'source', 'subject', 'to', 'uuid']
} as const;

export const $CustomerEmailTemplate = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        type: {
            '$ref': '#/components/schemas/EmailTemplateType'
        },
        name: {
            type: 'string',
            maxLength: 255
        },
        subject: {
            type: 'string',
            maxLength: 255
        },
        html: {
            type: 'string'
        },
        questionnaires: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/CustomerQuestionnaire'
            },
            readOnly: true
        },
        forms: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/CustomerForm'
            },
            readOnly: true
        },
        pdf_form_templates: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/PDFFormTemplate'
            },
            readOnly: true
        },
        default: {
            type: 'boolean'
        },
        law_field: {
            title: 'Rechtsgebiet',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawFieldEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        law_topic: {
            title: 'Rechtsthema',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawTopicEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        updated_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        }
    },
    required: ['default', 'forms', 'html', 'name', 'pdf_form_templates', 'questionnaires', 'subject', 'type', 'updated_at', 'uuid']
} as const;

export const $CustomerEmailTemplateRequest = {
    type: 'object',
    properties: {
        type: {
            '$ref': '#/components/schemas/EmailTemplateType'
        },
        name: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        },
        subject: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        },
        html: {
            type: 'string',
            minLength: 1
        },
        default: {
            type: 'boolean'
        },
        law_field: {
            title: 'Rechtsgebiet',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawFieldEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        law_topic: {
            title: 'Rechtsthema',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawTopicEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        questionnaire_uuids: {
            type: 'array',
            items: {
                type: 'string',
                format: 'uuid'
            },
            writeOnly: true
        },
        form_uuids: {
            type: 'array',
            items: {
                type: 'string',
                format: 'uuid'
            },
            writeOnly: true
        }
    },
    required: ['default', 'form_uuids', 'html', 'name', 'questionnaire_uuids', 'subject', 'type']
} as const;

export const $CustomerEntity = {
    type: 'object',
    description: 'Entity representation for customers.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        entity_type: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EntityTypeEnum'
                }
            ],
            title: 'Personentyp'
        },
        title: {
            title: 'Anrede',
            oneOf: [
                {
                    '$ref': '#/components/schemas/TitleEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        first_name: {
            type: 'string',
            title: 'Vorname',
            maxLength: 128
        },
        last_name: {
            type: 'string',
            title: 'Nachname',
            maxLength: 128
        },
        email: {
            type: 'string',
            format: 'email',
            title: 'E-Mail',
            maxLength: 128
        },
        phone: {
            type: 'string',
            title: 'Telefon',
            maxLength: 128
        },
        street: {
            type: 'string',
            title: 'Straße',
            maxLength: 128
        },
        street_number: {
            type: 'string',
            title: 'Hausnummer',
            maxLength: 16
        },
        address_line_2: {
            type: 'string',
            title: 'Adresszusatz',
            maxLength: 128
        },
        zip: {
            type: 'string',
            title: 'PLZ',
            maxLength: 12
        },
        city: {
            type: 'string',
            title: 'Ort',
            maxLength: 100
        },
        date_of_birth: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Geburtsdatum'
        },
        legal_insurance: {
            type: 'boolean',
            nullable: true,
            title: 'Rechtsschutzversicherung'
        },
        legal_insurance_number: {
            type: 'string',
            title: 'Nummer der Rechtsschutzversicherung',
            maxLength: 128
        },
        legal_insurance_name: {
            type: 'string',
            title: 'Name der Rechtsschutzversicherung',
            maxLength: 128
        },
        legal_insurance_deductible_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Höhe der Selbstbeteiligung der Rechtsschutzversicherung'
        },
        is_company: {
            type: 'string',
            readOnly: true
        },
        company_name: {
            type: 'string',
            title: 'Firmenname',
            maxLength: 128
        },
        company_legal_form: {
            title: 'Rechtsform',
            oneOf: [
                {
                    '$ref': '#/components/schemas/CompanyLegalFormEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        company_register_number: {
            type: 'string',
            title: 'Handelsregisternummer',
            maxLength: 128
        },
        company_register_court: {
            type: 'string',
            title: 'Amtsgericht',
            maxLength: 128
        },
        company_vat_id: {
            type: 'string',
            title: 'USt. ID',
            maxLength: 128
        },
        company_tax_id: {
            type: 'string',
            title: 'Steuernummer',
            maxLength: 128
        },
        bank_name: {
            type: 'string',
            title: 'Bankname',
            maxLength: 128
        },
        iban: {
            type: 'string',
            maxLength: 34
        },
        bic: {
            type: 'string',
            maxLength: 11
        },
        institution_name: {
            type: 'string',
            title: 'Name der Institution',
            maxLength: 128
        },
        changes: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/CustomerEntityChange'
            },
            readOnly: true
        }
    },
    required: ['changes', 'entity_type', 'is_company', 'uuid']
} as const;

export const $CustomerEntityChange = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        entities_mapper_key: {
            '$ref': '#/components/schemas/EntitiesMapperKeyEnum'
        },
        old_value: {
            oneOf: [
                {
                    type: 'string'
                },
                {
                    type: 'integer'
                },
                {
                    type: 'boolean'
                },
                {
                    type: 'string',
                    format: 'date'
                },
                {
                    type: 'object',
                    additionalProperties: {}
                },
                {
                    type: 'array',
                    items: {}
                }
            ]
        },
        new_value: {
            oneOf: [
                {
                    type: 'string'
                },
                {
                    type: 'integer'
                },
                {
                    type: 'boolean'
                },
                {
                    type: 'string',
                    format: 'date'
                },
                {
                    type: 'object',
                    additionalProperties: {}
                },
                {
                    type: 'array',
                    items: {}
                }
            ]
        },
        change_source: {
            '$ref': '#/components/schemas/ChangeSourceEnum'
        },
        user: {
            '$ref': '#/components/schemas/CustomerOrganisationUser'
        },
        ai_augmentation: {
            '$ref': '#/components/schemas/CustomerAiAugmentation'
        }
    },
    required: ['ai_augmentation', 'change_source', 'created_at', 'entities_mapper_key', 'new_value', 'old_value', 'user']
} as const;

export const $CustomerEntityChangeRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        entities_mapper_key: {
            '$ref': '#/components/schemas/EntitiesMapperKeyEnum'
        },
        old_value: {
            oneOf: [
                {
                    type: 'string'
                },
                {
                    type: 'integer'
                },
                {
                    type: 'boolean'
                },
                {
                    type: 'string',
                    format: 'date'
                },
                {
                    type: 'object',
                    additionalProperties: {}
                },
                {
                    type: 'array',
                    items: {}
                }
            ]
        },
        new_value: {
            oneOf: [
                {
                    type: 'string'
                },
                {
                    type: 'integer'
                },
                {
                    type: 'boolean'
                },
                {
                    type: 'string',
                    format: 'date'
                },
                {
                    type: 'object',
                    additionalProperties: {}
                },
                {
                    type: 'array',
                    items: {}
                }
            ]
        },
        change_source: {
            '$ref': '#/components/schemas/ChangeSourceEnum'
        },
        ai_augmentation: {
            '$ref': '#/components/schemas/CustomerAiAugmentationRequest'
        }
    },
    required: ['ai_augmentation', 'change_source', 'entities_mapper_key', 'new_value', 'old_value']
} as const;

export const $CustomerEntityRequest = {
    type: 'object',
    description: 'Entity representation for customers.',
    properties: {
        entity_type: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EntityTypeEnum'
                }
            ],
            title: 'Personentyp'
        },
        title: {
            title: 'Anrede',
            oneOf: [
                {
                    '$ref': '#/components/schemas/TitleEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        first_name: {
            type: 'string',
            title: 'Vorname',
            maxLength: 128
        },
        last_name: {
            type: 'string',
            title: 'Nachname',
            maxLength: 128
        },
        email: {
            type: 'string',
            format: 'email',
            title: 'E-Mail',
            maxLength: 128
        },
        phone: {
            type: 'string',
            title: 'Telefon',
            maxLength: 128
        },
        street: {
            type: 'string',
            title: 'Straße',
            maxLength: 128
        },
        street_number: {
            type: 'string',
            title: 'Hausnummer',
            maxLength: 16
        },
        address_line_2: {
            type: 'string',
            title: 'Adresszusatz',
            maxLength: 128
        },
        zip: {
            type: 'string',
            title: 'PLZ',
            maxLength: 12
        },
        city: {
            type: 'string',
            title: 'Ort',
            maxLength: 100
        },
        date_of_birth: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Geburtsdatum'
        },
        legal_insurance: {
            type: 'boolean',
            nullable: true,
            title: 'Rechtsschutzversicherung'
        },
        legal_insurance_number: {
            type: 'string',
            title: 'Nummer der Rechtsschutzversicherung',
            maxLength: 128
        },
        legal_insurance_name: {
            type: 'string',
            title: 'Name der Rechtsschutzversicherung',
            maxLength: 128
        },
        legal_insurance_deductible_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Höhe der Selbstbeteiligung der Rechtsschutzversicherung'
        },
        company_name: {
            type: 'string',
            title: 'Firmenname',
            maxLength: 128
        },
        company_legal_form: {
            title: 'Rechtsform',
            oneOf: [
                {
                    '$ref': '#/components/schemas/CompanyLegalFormEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        company_register_number: {
            type: 'string',
            title: 'Handelsregisternummer',
            maxLength: 128
        },
        company_register_court: {
            type: 'string',
            title: 'Amtsgericht',
            maxLength: 128
        },
        company_vat_id: {
            type: 'string',
            title: 'USt. ID',
            maxLength: 128
        },
        company_tax_id: {
            type: 'string',
            title: 'Steuernummer',
            maxLength: 128
        },
        bank_name: {
            type: 'string',
            title: 'Bankname',
            maxLength: 128
        },
        iban: {
            type: 'string',
            maxLength: 34
        },
        bic: {
            type: 'string',
            maxLength: 11
        },
        institution_name: {
            type: 'string',
            title: 'Name der Institution',
            maxLength: 128
        }
    },
    required: ['entity_type']
} as const;

export const $CustomerEntityWithRelationship = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        entity: {
            '$ref': '#/components/schemas/CustomerEntity'
        },
        relationships: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/EntityRelationship'
            }
        }
    },
    required: ['entity', 'relationships']
} as const;

export const $CustomerEntityWithRelationshipRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        entity: {
            '$ref': '#/components/schemas/CustomerEntityRequest'
        },
        relationships: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/EntityRelationshipRequest'
            }
        }
    },
    required: ['entity', 'relationships']
} as const;

export const $CustomerForm = {
    type: 'object',
    description: 'Form representation for customers.',
    properties: {
        id: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        organisation: {
            allOf: [
                {
                    '$ref': '#/components/schemas/CustomerOrganisation'
                }
            ],
            readOnly: true
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        modified_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        created_by: {
            allOf: [
                {
                    '$ref': '#/components/schemas/CustomerUser'
                }
            ],
            readOnly: true
        },
        modified_by: {
            allOf: [
                {
                    '$ref': '#/components/schemas/CustomerUser'
                }
            ],
            readOnly: true
        },
        tag: {
            allOf: [
                {
                    '$ref': '#/components/schemas/FormTag'
                }
            ],
            readOnly: true
        },
        title: {
            type: 'string',
            maxLength: 255
        },
        description: {
            type: 'string'
        },
        file: {
            type: 'string',
            format: 'uri',
            readOnly: true,
            nullable: true
        },
        due_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        document_name: {
            type: 'string',
            readOnly: true
        }
    },
    required: ['created_at', 'created_by', 'document_name', 'due_at', 'file', 'id', 'modified_at', 'modified_by', 'organisation', 'tag']
} as const;

export const $CustomerFormRequest = {
    type: 'object',
    description: 'Form representation for customers.',
    properties: {
        title: {
            type: 'string',
            maxLength: 255
        },
        description: {
            type: 'string'
        }
    }
} as const;

export const $CustomerLawyerFeedback = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        rating: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,1}(?:\\.\\d{0,1})?$'
        },
        feedback: {
            type: 'string',
            maxLength: 1024
        }
    },
    required: ['rating', 'uuid']
} as const;

export const $CustomerLawyerFeedbackRequest = {
    type: 'object',
    properties: {
        rating: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,1}(?:\\.\\d{0,1})?$'
        },
        feedback: {
            type: 'string',
            maxLength: 1024
        },
        call_uuid: {
            type: 'string',
            format: 'uuid',
            writeOnly: true
        }
    },
    required: ['call_uuid', 'rating']
} as const;

export const $CustomerOrganisation = {
    type: 'object',
    description: 'Organisation representation for customers.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        oid: {
            type: 'integer',
            readOnly: true
        },
        name: {
            type: 'string',
            nullable: true,
            title: 'Name der Kanzlei',
            maxLength: 128
        },
        logo: {
            type: 'string',
            format: 'uri',
            nullable: true
        },
        law_fields: {
            readOnly: true
        },
        description: {
            type: 'string',
            title: 'Beschreibung',
            maxLength: 400
        },
        short_id: {
            type: 'string',
            maxLength: 8
        },
        street: {
            type: 'string',
            nullable: true,
            title: 'Straße',
            maxLength: 96
        },
        street_number: {
            type: 'string',
            nullable: true,
            title: 'Haus',
            maxLength: 12
        },
        zip: {
            type: 'string',
            nullable: true,
            title: 'PLZ',
            maxLength: 5
        },
        city: {
            type: 'string',
            nullable: true,
            title: 'Stadt',
            maxLength: 64
        },
        country: {
            type: 'string',
            nullable: true,
            title: 'Land',
            maxLength: 96
        },
        phone: {
            type: 'string',
            nullable: true,
            title: 'Telefonnummer',
            maxLength: 24
        },
        email: {
            type: 'string',
            format: 'email',
            nullable: true,
            maxLength: 96
        },
        inbound_email_slug: {
            type: 'string',
            readOnly: true
        },
        inbound_email_address: {
            type: 'string',
            readOnly: true
        },
        enable_inbound_email_replies: {
            type: 'boolean',
            title: 'Aktiv'
        },
        seats: {
            type: 'integer',
            readOnly: true,
            title: 'Sitze'
        },
        email_text_color: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EmailTextColorEnum'
                }
            ],
            title: 'Textfarbe'
        },
        email_text_font: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EmailTextFontEnum'
                }
            ],
            title: 'Schriftart'
        },
        email_text_size: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EmailTextSizeEnum'
                }
            ],
            title: 'Schriftgröße',
            minimum: -2147483648,
            maximum: 2147483647
        },
        email_signature: {
            type: 'string',
            title: 'E-Mail Signatur'
        },
        email_blocked_senders: {
            title: 'Blockierte Absender'
        },
        email_spam_filter_active: {
            type: 'boolean',
            title: 'Spamfilter aktiv'
        },
        track_email_delivery_events: {
            type: 'boolean',
            title: 'E-Mail Zustell-Events tracken'
        },
        track_opened_click_email_delivery_events: {
            type: 'boolean',
            title: 'E-Mail Öffnungs- und Klick-Events tracken'
        },
        receive_questionnaire_closed_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn ein Fragebogen abgeschlossen wird'
        },
        receive_document_signed_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn ein Dokument abgeschlossen wird'
        },
        receive_new_case_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn eine neue Anfrage erstellt wird'
        },
        receive_new_case_email_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn eine neue E-Mail zu einer Anfrage eingeht'
        },
        receive_new_appointment_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn ein neuer Terminvorschlag erstellt wird'
        },
        send_document_email_reminders: {
            type: 'boolean',
            title: 'Automatisierte E-Mail Erinnerungen aktiv'
        },
        send_document_email_reminders_every_x_days: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            title: 'E-Mail Erinnerungen alle x Tage senden'
        },
        max_reminders: {
            type: 'integer',
            maximum: 2147483647,
            minimum: 1,
            title: 'Maximale Anzahl Erinnerungen pro Dokument',
            description: 'Maximum number of reminders that can be sent per document or questionnaire'
        },
        send_email_client_confirmation_on_new_case: {
            type: 'boolean',
            title: 'E-Mail Bestätigung bei neuer Anfrage senden'
        },
        send_email_client_confirmation_on_new_case_via_email: {
            type: 'boolean',
            title: 'E-Mail Bestätigung bei neuer Anfrage per E-Mail senden'
        },
        receive_clerk_change_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn ein Sachbearbeiter zugewiesen wird'
        },
        receive_email_bounce_notifications: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn eine E-Mail nicht zugestellt werden konnte'
        },
        is_actaport_export_integration_enabled: {
            type: 'boolean',
            readOnly: true,
            title: 'Actaport Integration aktivieren'
        },
        questionnaire_creation_token: {
            type: 'string',
            readOnly: true
        },
        ai_enabled: {
            type: 'boolean',
            readOnly: true,
            title: 'KI Aktiv'
        },
        enable_ai_workflows: {
            type: 'boolean',
            readOnly: true,
            title: 'KI-Workflows aktivieren'
        },
        is_iusta_egress_integration_enabled: {
            type: 'boolean',
            readOnly: true,
            title: 'Iusta Integration aktivieren'
        },
        is_ra_micro_export_integration_enabled: {
            type: 'boolean'
        },
        ra_micro_export_integration_type: {
            readOnly: true,
            nullable: true,
            title: 'Integration Type',
            oneOf: [
                {
                    '$ref': '#/components/schemas/RaMicroExportIntegrationTypeEnum'
                },
                {
                    '$ref': '#/components/schemas/NullEnum'
                }
            ]
        },
        ra_micro_oma_email_id: {
            type: 'string',
            readOnly: true,
            nullable: true,
            title: 'OMA Email ID'
        },
        ra_micro_oma_email: {
            type: 'string',
            format: 'email',
            readOnly: true,
            nullable: true,
            title: 'OMA Email'
        },
        is_advolux_export_integration_enabled: {
            type: 'boolean',
            readOnly: true
        },
        is_webhooks_egress_integration_enabled: {
            type: 'boolean',
            readOnly: true
        },
        webhook_urls: {
            type: 'string',
            nullable: true,
            maxLength: 256
        },
        is_email_egress_integration_enabled: {
            type: 'boolean',
            readOnly: true
        },
        email_egress_address: {
            type: 'string',
            format: 'email',
            nullable: true,
            title: 'Email',
            maxLength: 96
        },
        is_kleos_integration_enabled: {
            type: 'boolean',
            readOnly: true
        },
        is_advoware_export_integration_enabled: {
            type: 'boolean',
            readOnly: true,
            title: 'Advoware Integration aktivieren'
        },
        is_law_firm_software_exportation_enabled: {
            type: 'boolean',
            readOnly: true
        },
        enable_appointments: {
            type: 'boolean',
            readOnly: true,
            title: 'Terminbuchung aktivieren'
        },
        appointments_seats: {
            type: 'integer',
            readOnly: true,
            title: 'Terminbuchungen Sitze'
        },
        enable_cases: {
            type: 'boolean',
            title: 'Anfragen aktivieren (normale JUPUS Plattform)'
        },
        enable_voice: {
            type: 'boolean',
            readOnly: true,
            title: 'KI-Anrufbeantworter aktivieren'
        },
        is_hubspot_egress_integration_enabled: {
            type: 'boolean',
            readOnly: true
        },
        is_haveibeenpwned_integration_enabled: {
            type: 'boolean',
            readOnly: true
        },
        is_jurnodes_export_integration_enabled: {
            type: 'boolean',
            readOnly: true,
            title: 'Jur|nodes Integration aktivieren'
        },
        is_datev_export_integration_enabled: {
            type: 'boolean'
        },
        advoware_clerk_options: {
            type: 'string',
            readOnly: true
        },
        advoware_law_field_options: {
            type: 'string',
            readOnly: true
        },
        actaport_clerk_options: {
            type: 'string',
            readOnly: true
        },
        actaport_assistant_options: {
            type: 'string',
            readOnly: true
        },
        kleos_case_type_options: {
            type: 'string',
            readOnly: true
        },
        jurnodes_datapool_options: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    id: {
                        type: 'integer'
                    },
                    name: {
                        type: 'string'
                    }
                },
                required: ['id', 'name']
            },
            readOnly: true
        },
        jurnodes_lawyer_options: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    id: {
                        type: 'integer'
                    },
                    name: {
                        type: 'string'
                    }
                },
                required: ['id', 'name']
            },
            readOnly: true
        },
        jurnodes_law_category_options: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    id: {
                        type: 'integer'
                    },
                    name: {
                        type: 'string'
                    }
                },
                required: ['id', 'name']
            },
            readOnly: true
        },
        jurnodes_record_schema_options: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    id: {
                        type: 'integer'
                    },
                    name: {
                        type: 'string'
                    }
                },
                required: ['id', 'name']
            },
            readOnly: true
        },
        users: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/CustomerOrganisationUser'
            },
            readOnly: true
        },
        receive_monthly_updates_summary: {
            type: 'boolean',
            title: 'Monatliche Zusammenfassung per E-Mail erhalten'
        },
        enable_law_specific_data: {
            type: 'boolean',
            readOnly: true,
            title: 'Rechtsspezifische Daten & Dokumentengenerator aktivieren'
        },
        ai_chat_question_templates: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/AiChatQuestionTemplate'
            },
            readOnly: true
        },
        is_new_ui_switch_enabled: {
            type: 'boolean',
            readOnly: true
        },
        is_forced_to_use_new_ui: {
            type: 'boolean',
            readOnly: true
        },
        is_phonebot_self_service_customer: {
            type: 'boolean',
            readOnly: true,
            title: 'Phonebot Self-Service Kunde'
        },
        phonebot_self_service_plan: {
            readOnly: true,
            nullable: true,
            oneOf: [
                {
                    '$ref': '#/components/schemas/PhonebotSelfServicePlanEnum'
                },
                {
                    '$ref': '#/components/schemas/NullEnum'
                }
            ]
        },
        phonebot_trial_ends_at: {
            type: 'string',
            format: 'date',
            readOnly: true,
            nullable: true
        }
    },
    required: ['actaport_assistant_options', 'actaport_clerk_options', 'advoware_clerk_options', 'advoware_law_field_options', 'ai_chat_question_templates', 'ai_enabled', 'appointments_seats', 'enable_ai_workflows', 'enable_appointments', 'enable_law_specific_data', 'enable_voice', 'inbound_email_address', 'inbound_email_slug', 'is_actaport_export_integration_enabled', 'is_advolux_export_integration_enabled', 'is_advoware_export_integration_enabled', 'is_email_egress_integration_enabled', 'is_forced_to_use_new_ui', 'is_haveibeenpwned_integration_enabled', 'is_hubspot_egress_integration_enabled', 'is_iusta_egress_integration_enabled', 'is_jurnodes_export_integration_enabled', 'is_kleos_integration_enabled', 'is_law_firm_software_exportation_enabled', 'is_new_ui_switch_enabled', 'is_phonebot_self_service_customer', 'is_webhooks_egress_integration_enabled', 'jurnodes_datapool_options', 'jurnodes_law_category_options', 'jurnodes_lawyer_options', 'jurnodes_record_schema_options', 'kleos_case_type_options', 'law_fields', 'oid', 'phonebot_self_service_plan', 'phonebot_trial_ends_at', 'questionnaire_creation_token', 'ra_micro_export_integration_type', 'ra_micro_oma_email', 'ra_micro_oma_email_id', 'seats', 'users', 'uuid']
} as const;

export const $CustomerOrganisationRequest = {
    type: 'object',
    description: 'Organisation representation for customers.',
    properties: {
        name: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'Name der Kanzlei',
            maxLength: 128
        },
        logo: {
            type: 'string',
            format: 'binary',
            nullable: true
        },
        description: {
            type: 'string',
            title: 'Beschreibung',
            maxLength: 400
        },
        short_id: {
            type: 'string',
            minLength: 1,
            maxLength: 8
        },
        street: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'Straße',
            maxLength: 96
        },
        street_number: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'Haus',
            maxLength: 12
        },
        zip: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'PLZ',
            maxLength: 5
        },
        city: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'Stadt',
            maxLength: 64
        },
        country: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'Land',
            maxLength: 96
        },
        phone: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'Telefonnummer',
            maxLength: 24
        },
        email: {
            type: 'string',
            format: 'email',
            nullable: true,
            minLength: 1,
            maxLength: 96
        },
        enable_inbound_email_replies: {
            type: 'boolean',
            title: 'Aktiv'
        },
        email_text_color: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EmailTextColorEnum'
                }
            ],
            title: 'Textfarbe'
        },
        email_text_font: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EmailTextFontEnum'
                }
            ],
            title: 'Schriftart'
        },
        email_text_size: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EmailTextSizeEnum'
                }
            ],
            title: 'Schriftgröße',
            minimum: -2147483648,
            maximum: 2147483647
        },
        email_signature: {
            type: 'string',
            title: 'E-Mail Signatur'
        },
        email_blocked_senders: {
            title: 'Blockierte Absender'
        },
        email_spam_filter_active: {
            type: 'boolean',
            title: 'Spamfilter aktiv'
        },
        track_email_delivery_events: {
            type: 'boolean',
            title: 'E-Mail Zustell-Events tracken'
        },
        track_opened_click_email_delivery_events: {
            type: 'boolean',
            title: 'E-Mail Öffnungs- und Klick-Events tracken'
        },
        receive_questionnaire_closed_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn ein Fragebogen abgeschlossen wird'
        },
        receive_document_signed_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn ein Dokument abgeschlossen wird'
        },
        receive_new_case_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn eine neue Anfrage erstellt wird'
        },
        receive_new_case_email_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn eine neue E-Mail zu einer Anfrage eingeht'
        },
        receive_new_appointment_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn ein neuer Terminvorschlag erstellt wird'
        },
        send_document_email_reminders: {
            type: 'boolean',
            title: 'Automatisierte E-Mail Erinnerungen aktiv'
        },
        send_document_email_reminders_every_x_days: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            title: 'E-Mail Erinnerungen alle x Tage senden'
        },
        max_reminders: {
            type: 'integer',
            maximum: 2147483647,
            minimum: 1,
            title: 'Maximale Anzahl Erinnerungen pro Dokument',
            description: 'Maximum number of reminders that can be sent per document or questionnaire'
        },
        send_email_client_confirmation_on_new_case: {
            type: 'boolean',
            title: 'E-Mail Bestätigung bei neuer Anfrage senden'
        },
        send_email_client_confirmation_on_new_case_via_email: {
            type: 'boolean',
            title: 'E-Mail Bestätigung bei neuer Anfrage per E-Mail senden'
        },
        receive_clerk_change_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn ein Sachbearbeiter zugewiesen wird'
        },
        receive_email_bounce_notifications: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn eine E-Mail nicht zugestellt werden konnte'
        },
        is_ra_micro_export_integration_enabled: {
            type: 'boolean'
        },
        webhook_urls: {
            type: 'string',
            nullable: true,
            maxLength: 256
        },
        email_egress_address: {
            type: 'string',
            format: 'email',
            nullable: true,
            minLength: 1,
            title: 'Email',
            maxLength: 96
        },
        enable_cases: {
            type: 'boolean',
            title: 'Anfragen aktivieren (normale JUPUS Plattform)'
        },
        is_datev_export_integration_enabled: {
            type: 'boolean'
        },
        receive_monthly_updates_summary: {
            type: 'boolean',
            title: 'Monatliche Zusammenfassung per E-Mail erhalten'
        }
    }
} as const;

export const $CustomerOrganisationUser = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        email: {
            type: 'string',
            format: 'email',
            readOnly: true
        },
        first_name: {
            type: 'string',
            readOnly: true,
            title: 'Vorname'
        },
        last_name: {
            type: 'string',
            readOnly: true,
            title: 'Nachname'
        },
        avatar: {
            type: 'string',
            format: 'uri',
            readOnly: true,
            nullable: true
        }
    },
    required: ['avatar', 'email', 'first_name', 'last_name', 'uuid']
} as const;

export const $CustomerPhoneNumber = {
    type: 'object',
    description: 'PhoneNumber representation for customers.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        active: {
            type: 'boolean',
            readOnly: true
        },
        org: {
            allOf: [
                {
                    '$ref': '#/components/schemas/CustomerOrganisation'
                }
            ],
            readOnly: true
        },
        phone_number: {
            type: 'string',
            readOnly: true,
            nullable: true
        },
        law_fields: {
            readOnly: true,
            title: 'Rechtsgebiete'
        },
        description: {
            type: 'string',
            readOnly: true,
            title: 'Bezeichnung',
            description: 'Hier können Sie eine interne Bezeichnung für die Rufnummer hinterlegen.'
        },
        lawfirm_name: {
            type: 'string',
            readOnly: true,
            title: 'Kanzleiname',
            description: 'Geben Sie hier den Namen Ihrer Kanzlei ein, wie er in der Begrüßungsansage genannt werden soll.'
        },
        address: {
            type: 'string',
            readOnly: true,
            title: 'Adresse',
            description: 'Hier können Sie die Adresse Ihrer Kanzlei hinterlegen. Bei Nachfrage geben wir diese an den Anrufer weiter. Wenn Sie keine unangekündigten Mandantenbesuch wünschen, dann geben Sie hier bitte einen entsprechenden Hinweis.'
        },
        opening_hours: {
            type: 'string',
            readOnly: true,
            title: 'Öffnungszeiten',
            description: 'Hier können Sie Ihre Öffnungszeiten Ihrer Kanzlei hinterlegen. Bei Nachfrage geben wir diese an den Anrufer weiter.'
        },
        lawyer_names: {
            type: 'string',
            readOnly: true,
            title: 'Anwälte/Sachbearbeiter',
            description: 'Hier können Sie die Namen Ihrer Anwälte oder Sachbearbeiter hinterlegen. Dies hilft uns dabei, den Namen des Anrufers besser zu erkennen. Bitte tragen Sie nur den Namen ein und keine weitere Bezeichnung wie zum Beispiel Anwalt oder Sachbearbeiter.'
        },
        has_free_initial_consultation: {
            type: 'boolean',
            readOnly: true,
            title: 'Kostenlose Erstberatung',
            description: 'Bieten Sie eine kostenlose Erstberatung an? Wenn ja, dann aktivieren Sie diese Option und wir geben dies an den Anrufer weiter.'
        },
        original_phone_number: {
            type: 'string',
            readOnly: true,
            title: 'Telefonnummer',
            description: 'Wenn Sie die von uns generierte Nummer intern weiterleiten, geben Sie hier unbedingt die Originalnummer an, welche von den Mandanten angerufen wird. So stellen Sie sicher, dass wir die Anrufe korrekt zuordnen können.'
        },
        can_record_calls: {
            type: 'boolean',
            readOnly: true,
            title: 'Anrufe aufzeichnen',
            description: 'Durch das Aktivieren dieser Option Stellen wir Ihnen auf der Detailseite eines Anrufs einen Mitschnitt des Namen bzw. der E-Mail-Addresse zur Verfügung. Die Aufzeichnung von Anrufen ist in Deutschland nur mit Zustimmung des Anrufers gestattet. Wir weisen Sie darauf hin, dass Sie diese Zustimmung von dem Anrufer einholen müssen.'
        },
        begin_message: {
            type: 'string',
            readOnly: true,
            title: 'Begrüßung',
            description: 'Hier können Sie eine Begrüßung für den Anrufbeantworter hinterlegen. Diese wird am Anfang des Anrufes abgespielt.'
        },
        end_message: {
            type: 'string',
            readOnly: true,
            title: 'Abschiedsnachricht',
            description: 'Hier können Sie eine Abschiedsnachricht für den Anrufbeantworter hinterlegen. Diese wird am Ende des Anrufes abgespielt.'
        },
        forwarding_rules: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/PhoneForwardingRuleList'
            },
            readOnly: true
        }
    },
    required: ['active', 'address', 'begin_message', 'can_record_calls', 'description', 'end_message', 'forwarding_rules', 'has_free_initial_consultation', 'law_fields', 'lawfirm_name', 'lawyer_names', 'opening_hours', 'org', 'original_phone_number', 'phone_number', 'uuid']
} as const;

export const $CustomerQuestionnaire = {
    type: 'object',
    description: 'Questionnaire representation for customers.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        title: {
            type: 'string',
            maxLength: 64
        },
        description: {
            type: 'string'
        },
        schema: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/QuestionnaireSection'
            }
        },
        theme_color: {
            type: 'string',
            readOnly: true
        },
        is_jupus_template: {
            type: 'boolean',
            readOnly: true,
            description: 'True if this questionnaire is a Jupus template that can be copied by organizations'
        },
        law_field: {
            title: 'Rechtsgebiet',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawFieldEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        law_topic: {
            title: 'Rechtsthema',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawTopicEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        updated_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        created_by_name: {
            type: 'string',
            readOnly: true
        },
        questionnaire_creation_token: {
            type: 'string',
            readOnly: true
        },
        org: {
            allOf: [
                {
                    '$ref': '#/components/schemas/ClientOrganisation'
                }
            ],
            readOnly: true
        },
        org_questionnaire_creation_token: {
            type: 'string',
            readOnly: true
        }
    },
    required: ['created_by_name', 'is_jupus_template', 'org', 'org_questionnaire_creation_token', 'questionnaire_creation_token', 'schema', 'theme_color', 'title', 'updated_at', 'uuid']
} as const;

export const $CustomerQuestionnaireRequest = {
    type: 'object',
    description: 'Questionnaire representation for customers.',
    properties: {
        title: {
            type: 'string',
            minLength: 1,
            maxLength: 64
        },
        description: {
            type: 'string'
        },
        schema: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/QuestionnaireSectionRequest'
            }
        },
        law_field: {
            title: 'Rechtsgebiet',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawFieldEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        law_topic: {
            title: 'Rechtsthema',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawTopicEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        }
    },
    required: ['schema', 'title']
} as const;

export const $CustomerQuestionnaireSubmission = {
    type: 'object',
    description: 'Questionnaire submission representation for customers.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        case_uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        short_id: {
            type: 'string',
            readOnly: true
        },
        title: {
            type: 'string',
            readOnly: true
        },
        law_field: {
            allOf: [
                {
                    '$ref': '#/components/schemas/LawFieldEnum'
                }
            ],
            readOnly: true,
            title: 'Rechtsgebiet'
        },
        law_topic: {
            allOf: [
                {
                    '$ref': '#/components/schemas/LawTopicEnum'
                }
            ],
            readOnly: true,
            title: 'Rechtsthema'
        },
        pdf_url: {
            type: 'string',
            readOnly: true
        },
        question_count: {
            type: 'integer',
            readOnly: true
        },
        required_question_count: {
            type: 'integer',
            readOnly: true
        },
        optional_question_count: {
            type: 'integer',
            readOnly: true
        },
        answered_question_count: {
            type: 'integer',
            readOnly: true
        },
        answered_required_questions_percent: {
            type: 'number',
            format: 'double',
            readOnly: true
        },
        answered_optional_questions_count: {
            type: 'integer',
            readOnly: true
        },
        answered_questions_percent: {
            type: 'number',
            format: 'double',
            readOnly: true
        },
        answered_optional_questions_percent: {
            type: 'number',
            format: 'double',
            readOnly: true
        },
        is_third_party_questionnaire: {
            type: 'boolean',
            readOnly: true
        },
        due_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        state: {
            type: 'string',
            readOnly: true
        },
        schema: {},
        closed: {
            type: 'boolean'
        }
    },
    required: ['answered_optional_questions_count', 'answered_optional_questions_percent', 'answered_question_count', 'answered_questions_percent', 'answered_required_questions_percent', 'case_uuid', 'created_at', 'due_at', 'is_third_party_questionnaire', 'law_field', 'law_topic', 'optional_question_count', 'pdf_url', 'question_count', 'required_question_count', 'short_id', 'state', 'title', 'uuid']
} as const;

export const $CustomerQuestionnaireSubmissionRequest = {
    type: 'object',
    description: 'Questionnaire submission representation for customers.',
    properties: {
        schema: {},
        closed: {
            type: 'boolean'
        }
    }
} as const;

export const $CustomerRequest = {
    type: 'object',
    properties: {
        id: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        token: {
            type: 'string',
            maxLength: 255
        },
        form: {
            type: 'string',
            format: 'uuid'
        },
        response_present: {
            type: 'object',
            additionalProperties: {},
            readOnly: true
        },
        document_uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        is_third_party: {
            type: 'boolean'
        }
    },
    required: ['document_uuid', 'form', 'id', 'response_present', 'token']
} as const;

export const $CustomerRequestRequest = {
    type: 'object',
    properties: {
        token: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        },
        form: {
            type: 'string',
            format: 'uuid'
        },
        is_third_party: {
            type: 'boolean'
        }
    },
    required: ['form', 'token']
} as const;

export const $CustomerService = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        org: {
            type: 'integer'
        },
        active: {
            type: 'boolean',
            title: 'Diese Leistung ist buchbar'
        },
        name: {
            type: 'string',
            title: 'Titel',
            maxLength: 32
        },
        description: {
            type: 'string',
            title: 'Beschreibung',
            maxLength: 400
        },
        duration_mins: {
            type: 'integer'
        },
        buffer_mins: {
            type: 'integer'
        },
        price: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,6}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Preis'
        },
        currency: {
            type: 'string',
            title: 'Währung',
            maxLength: 8
        },
        unit: {
            type: 'string',
            title: 'Einheit',
            maxLength: 32
        },
        show_price: {
            type: 'boolean',
            title: 'Preis anzeigen',
            description: 'Wenn aktiviert, wird der Preis der Leistung während der Buchung des Termins angezeigt.'
        },
        slug: {
            type: 'string',
            maxLength: 64,
            pattern: '^[-a-zA-Z0-9_]+$'
        },
        calendars: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/Calendar'
            },
            readOnly: true
        },
        location_types: {
            type: 'string',
            readOnly: true
        },
        availability_query: {
            type: 'object',
            additionalProperties: {},
            readOnly: true
        }
    },
    required: ['availability_query', 'buffer_mins', 'calendars', 'description', 'duration_mins', 'location_types', 'name', 'org']
} as const;

export const $CustomerServiceRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        org: {
            type: 'integer'
        },
        active: {
            type: 'boolean',
            title: 'Diese Leistung ist buchbar'
        },
        name: {
            type: 'string',
            minLength: 1,
            title: 'Titel',
            maxLength: 32
        },
        description: {
            type: 'string',
            minLength: 1,
            title: 'Beschreibung',
            maxLength: 400
        },
        duration_mins: {
            type: 'integer'
        },
        buffer_mins: {
            type: 'integer'
        },
        price: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,6}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Preis'
        },
        currency: {
            type: 'string',
            minLength: 1,
            title: 'Währung',
            maxLength: 8
        },
        unit: {
            type: 'string',
            minLength: 1,
            title: 'Einheit',
            maxLength: 32
        },
        show_price: {
            type: 'boolean',
            title: 'Preis anzeigen',
            description: 'Wenn aktiviert, wird der Preis der Leistung während der Buchung des Termins angezeigt.'
        },
        slug: {
            type: 'string',
            minLength: 1,
            maxLength: 64,
            pattern: '^[-a-zA-Z0-9_]+$'
        }
    },
    required: ['buffer_mins', 'description', 'duration_mins', 'name', 'org']
} as const;

export const $CustomerUser = {
    type: 'object',
    description: 'User representation for customers.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        email: {
            type: 'string',
            format: 'email',
            maxLength: 254
        },
        first_name: {
            type: 'string',
            title: 'Vorname',
            maxLength: 150
        },
        last_name: {
            type: 'string',
            title: 'Nachname',
            maxLength: 150
        },
        avatar: {
            type: 'string',
            format: 'uri',
            nullable: true
        },
        org: {
            allOf: [
                {
                    '$ref': '#/components/schemas/CustomerOrganisation'
                }
            ],
            readOnly: true
        },
        uid: {
            type: 'integer',
            readOnly: true
        },
        role: {
            readOnly: true,
            nullable: true,
            oneOf: [
                {
                    '$ref': '#/components/schemas/Role5ccEnum'
                },
                {
                    '$ref': '#/components/schemas/NullEnum'
                }
            ]
        },
        email_signature: {
            type: 'string',
            title: 'E-Mail Signatur'
        },
        case_dashboard_widgets: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/CaseDashboardWidgetsEnum'
            }
        },
        global_ai_chat_intro_seen: {
            type: 'boolean',
            description: 'Whether the user has seen and accepted the global AI chat intro page'
        },
        global_ai_chat_badge_dismissed: {
            type: 'boolean',
            description: 'Whether the user has clicked on Global AI Chat navigation item (badge should be hidden)'
        },
        is_impersonated_session: {
            type: 'boolean',
            description: `Check if the current session is an impersonated session.

:param obj: The user object being serialized
:return: True if this is an impersonated session, False otherwise`,
            readOnly: true
        }
    },
    required: ['case_dashboard_widgets', 'email', 'is_impersonated_session', 'org', 'role', 'uid', 'uuid']
} as const;

export const $CustomerUserRequest = {
    type: 'object',
    description: 'User representation for customers.',
    properties: {
        email: {
            type: 'string',
            format: 'email',
            minLength: 1,
            maxLength: 254
        },
        first_name: {
            type: 'string',
            title: 'Vorname',
            maxLength: 150
        },
        last_name: {
            type: 'string',
            title: 'Nachname',
            maxLength: 150
        },
        avatar: {
            type: 'string',
            format: 'binary',
            nullable: true
        },
        email_signature: {
            type: 'string',
            title: 'E-Mail Signatur'
        },
        case_dashboard_widgets: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/CaseDashboardWidgetsEnum'
            }
        },
        global_ai_chat_intro_seen: {
            type: 'boolean',
            description: 'Whether the user has seen and accepted the global AI chat intro page'
        },
        global_ai_chat_badge_dismissed: {
            type: 'boolean',
            description: 'Whether the user has clicked on Global AI Chat navigation item (badge should be hidden)'
        }
    },
    required: ['case_dashboard_widgets', 'email']
} as const;

export const $CustomerWordDocumentTemplate = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        name: {
            type: 'string',
            maxLength: 255
        },
        description: {
            type: 'string'
        },
        system_prompt: {
            type: 'string'
        },
        original_docx_template: {
            type: 'string',
            format: 'uri',
            readOnly: true,
            nullable: true
        },
        docx_template: {
            type: 'string',
            format: 'uri',
            nullable: true,
            description: 'Active template used for document generation (can be original, AI-generated, or custom upload)'
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        updated_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        law_field: {
            title: 'Rechtsgebiet',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawFieldEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        law_topic: {
            title: 'Rechtsthema',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawTopicEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        document: {
            allOf: [
                {
                    '$ref': '#/components/schemas/Document'
                }
            ],
            readOnly: true
        },
        is_jupus_template: {
            type: 'boolean'
        },
        replaceable_variables: {
            nullable: true
        },
        status: {
            allOf: [
                {
                    '$ref': '#/components/schemas/WordTemplateStatus'
                }
            ],
            description: `Current status of the template in the review workflow

* \`draft\` - Draft
* \`in_review\` - In Review
* \`approved\` - Approved`
        }
    },
    required: ['created_at', 'description', 'document', 'is_jupus_template', 'name', 'original_docx_template', 'system_prompt', 'updated_at']
} as const;

export const $CustomerWordDocumentTemplateRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        name: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        },
        description: {
            type: 'string',
            minLength: 1
        },
        system_prompt: {
            type: 'string',
            minLength: 1
        },
        docx_template: {
            type: 'string',
            format: 'binary',
            nullable: true,
            description: 'Active template used for document generation (can be original, AI-generated, or custom upload)'
        },
        law_field: {
            title: 'Rechtsgebiet',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawFieldEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        law_topic: {
            title: 'Rechtsthema',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawTopicEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        is_jupus_template: {
            type: 'boolean'
        },
        replaceable_variables: {
            nullable: true
        },
        status: {
            allOf: [
                {
                    '$ref': '#/components/schemas/WordTemplateStatus'
                }
            ],
            description: `Current status of the template in the review workflow

* \`draft\` - Draft
* \`in_review\` - In Review
* \`approved\` - Approved`
        }
    },
    required: ['description', 'is_jupus_template', 'name', 'system_prompt']
} as const;

export const $DatevDataRequest = {
    type: 'object',
    description: `Serializer for DATEV export integration data.
This handles the specific data needed for DATEV Anwalt Inkasso-Import format.`,
    properties: {
        fileData: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/FileDataRequest'
            }
        },
        entities_with_relationships: {
            type: 'array',
            items: {
                type: 'string',
                format: 'uuid'
            },
            description: 'List of entity relationship UUIDs to include in the export'
        },
        custom_case_name: {
            type: 'string',
            description: 'Custom case name for the export',
            maxLength: 255
        },
        case_group: {
            type: 'string',
            description: 'Case group identifier',
            maxLength: 100
        }
    },
    required: ['entities_with_relationships']
} as const;

export const $DeliveryEventRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        }
    }
} as const;

export const $DeliveryModeEnum = {
    enum: ['RECOMMENDATION', 'AUTO_COMMIT'],
    type: 'string',
    description: `* \`RECOMMENDATION\` - Recommendation
* \`AUTO_COMMIT\` - Auto Commit`
} as const;

export const $Document = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        document_type: {
            allOf: [
                {
                    '$ref': '#/components/schemas/DocumentTypeEnum'
                }
            ],
            readOnly: true
        },
        title: {
            type: 'string',
            readOnly: true
        },
        filename: {
            type: 'string',
            readOnly: true
        },
        is_uploaded: {
            type: 'boolean',
            readOnly: true
        },
        upload_origin: {
            readOnly: true,
            nullable: true,
            oneOf: [
                {
                    '$ref': '#/components/schemas/UploadOriginEnum'
                },
                {
                    '$ref': '#/components/schemas/NullEnum'
                }
            ]
        },
        url: {
            type: 'string',
            readOnly: true
        },
        page_count: {
            type: 'integer',
            readOnly: true
        },
        filesize: {
            type: 'integer',
            readOnly: true
        },
        images: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/ImageproxyImagePreset'
            },
            readOnly: true
        },
        needs_ocr: {
            type: 'boolean',
            readOnly: true
        },
        ocr_started_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true,
            nullable: true
        },
        ocr_finished_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true,
            nullable: true
        },
        ocr_is_finished: {
            type: 'boolean',
            readOnly: true,
            nullable: true
        },
        needs_embeddings: {
            type: 'boolean',
            readOnly: true
        },
        embeddings_started_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true,
            nullable: true
        },
        embeddings_finished_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true,
            nullable: true
        },
        embeddings_is_finished: {
            type: 'boolean',
            readOnly: true,
            nullable: true
        },
        needs_summary: {
            type: 'boolean',
            readOnly: true
        },
        summary_started_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true,
            nullable: true
        },
        summary_finished_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true,
            nullable: true
        },
        summary_is_finished: {
            type: 'boolean',
            readOnly: true,
            nullable: true
        },
        needs_summary_embedding: {
            type: 'boolean',
            readOnly: true
        },
        summary_embedding_started_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true,
            nullable: true
        },
        summary_embedding_finished_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true,
            nullable: true
        },
        summary_embedding_is_finished: {
            type: 'boolean',
            readOnly: true,
            nullable: true
        },
        needs_raptor_summaries: {
            type: 'boolean',
            readOnly: true
        },
        raptor_summaries_started_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true,
            nullable: true
        },
        raptor_summaries_finished_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true,
            nullable: true
        },
        raptor_summaries_is_finished: {
            type: 'boolean',
            readOnly: true,
            nullable: true
        },
        needs_analysis: {
            type: 'boolean',
            readOnly: true
        },
        analysis_started_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true,
            nullable: true
        },
        analysis_finished_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true,
            nullable: true
        },
        analysis_is_finished: {
            type: 'boolean',
            readOnly: true,
            nullable: true
        },
        needs_metadata_enrichment: {
            type: 'boolean',
            readOnly: true
        },
        metadata_enrichment_started_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true,
            nullable: true
        },
        metadata_enrichment_finished_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true,
            nullable: true
        },
        metadata_enrichment_is_finished: {
            type: 'boolean',
            readOnly: true,
            nullable: true
        },
        metadata_enrichment_error: {
            type: 'string',
            readOnly: true,
            nullable: true
        },
        embeddings_error: {
            type: 'string',
            readOnly: true,
            nullable: true
        },
        summary_error: {
            type: 'string',
            readOnly: true,
            nullable: true
        },
        summary_embedding_error: {
            type: 'string',
            readOnly: true,
            nullable: true
        },
        raptor_summaries_error: {
            type: 'string',
            readOnly: true,
            nullable: true
        },
        analysis_error: {
            type: 'string',
            readOnly: true,
            nullable: true
        },
        document_status: {
            allOf: [
                {
                    '$ref': '#/components/schemas/DocumentStatusEnum'
                }
            ],
            readOnly: true
        },
        source_type: {
            type: 'string',
            readOnly: true
        },
        source_id: {
            type: 'string',
            readOnly: true
        },
        is_pdf_modified: {
            type: 'boolean',
            description: 'Return True if a modified PDF exists.',
            readOnly: true
        },
        pdf_modified_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true,
            nullable: true,
            description: 'Timestamp when the PDF was last modified'
        },
        current_pdf_url: {
            type: 'string',
            nullable: true,
            description: `Get the URL of the current PDF file (modified if available, otherwise original).

:return: The URL of the current PDF file.`,
            readOnly: true
        },
        original_pdf_url: {
            type: 'string',
            nullable: true,
            description: `Get the URL of the original PDF file.

:return: The URL of the original PDF file.`,
            readOnly: true
        },
        case_uuid: {
            type: 'string',
            readOnly: true
        },
        case_number: {
            type: 'string',
            readOnly: true
        },
        case_id: {
            type: 'string',
            readOnly: true
        },
        organization_name: {
            type: 'string',
            readOnly: true
        },
        organization_uuid: {
            type: 'string',
            readOnly: true
        },
        organization_customer_number: {
            type: 'string',
            readOnly: true
        },
        platform_sync_status: {
            allOf: [
                {
                    '$ref': '#/components/schemas/PlatformSyncStatusEnum'
                }
            ],
            readOnly: true
        },
        actaport_id: {
            type: 'string',
            readOnly: true
        },
        actaport_url: {
            type: 'string',
            readOnly: true
        },
        is_virtual: {
            type: 'string',
            readOnly: true
        }
    },
    required: ['actaport_id', 'actaport_url', 'analysis_error', 'analysis_finished_at', 'analysis_is_finished', 'analysis_started_at', 'case_id', 'case_number', 'case_uuid', 'created_at', 'current_pdf_url', 'document_status', 'document_type', 'embeddings_error', 'embeddings_finished_at', 'embeddings_is_finished', 'embeddings_started_at', 'filename', 'filesize', 'images', 'is_pdf_modified', 'is_uploaded', 'is_virtual', 'metadata_enrichment_error', 'metadata_enrichment_finished_at', 'metadata_enrichment_is_finished', 'metadata_enrichment_started_at', 'needs_analysis', 'needs_embeddings', 'needs_metadata_enrichment', 'needs_ocr', 'needs_raptor_summaries', 'needs_summary', 'needs_summary_embedding', 'ocr_finished_at', 'ocr_is_finished', 'ocr_started_at', 'organization_customer_number', 'organization_name', 'organization_uuid', 'original_pdf_url', 'page_count', 'pdf_modified_at', 'platform_sync_status', 'raptor_summaries_error', 'raptor_summaries_finished_at', 'raptor_summaries_is_finished', 'raptor_summaries_started_at', 'source_id', 'source_type', 'summary_embedding_error', 'summary_embedding_finished_at', 'summary_embedding_is_finished', 'summary_embedding_started_at', 'summary_error', 'summary_finished_at', 'summary_is_finished', 'summary_started_at', 'title', 'upload_origin', 'url', 'uuid']
} as const;

export const $DocumentAiContext = {
    type: 'object',
    title: 'DocumentAiContext',
    properties: {
        created_at: {
            type: 'string'
        },
        uuid: {
            type: 'string'
        },
        document_type: {
            type: 'string'
        },
        is_uploaded: {
            type: 'boolean'
        },
        upload_origin: {
            type: 'string',
            nullable: true
        },
        title: {
            type: 'string'
        },
        summary: {
            type: 'string'
        },
        relevant_content: {
            '$ref': '#/components/schemas/DocumentContent'
        }
    },
    required: ['created_at', 'uuid', 'document_type', 'is_uploaded', 'title', 'summary', 'relevant_content']
} as const;

export const $DocumentContent = {
    type: 'object',
    title: 'DocumentContent',
    properties: {
        pages: {
            type: 'integer'
        },
        text: {
            type: 'string'
        }
    },
    required: ['pages', 'text']
} as const;

export const $DocumentEditTokenResponse = {
    type: 'object',
    description: 'Response serializer for document edit token creation.',
    properties: {
        token: {
            type: 'string'
        },
        expires_at: {
            type: 'string',
            format: 'date-time'
        },
        document_uuid: {
            type: 'string',
            format: 'uuid'
        },
        onlyoffice_jwt: {
            type: 'string'
        },
        resource_type: {
            '$ref': '#/components/schemas/ResourceTypeEnum'
        }
    },
    required: ['document_uuid', 'expires_at', 'onlyoffice_jwt', 'resource_type', 'token']
} as const;

export const $DocumentGeneratorRelatedData = {
    type: 'object',
    title: 'DocumentGeneratorRelatedData',
    properties: {
        template_uuid: {
            type: 'string',
            nullable: true
        },
        document_uuid: {
            type: 'string',
            nullable: true
        }
    }
} as const;

export const $DocumentGroupStateRequest = {
    type: 'object',
    description: 'Serializer for document group state.',
    properties: {
        name: {
            type: 'string',
            minLength: 1,
            description: 'Name of the document group',
            maxLength: 255
        },
        pages: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/PageStateRequest'
            },
            description: 'Pages in this document group'
        }
    },
    required: ['name', 'pages']
} as const;

export const $DocumentOrganizationStateRequest = {
    type: 'object',
    description: 'Serializer for the complete document organization state.',
    properties: {
        document_groups: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/DocumentGroupStateRequest'
            }
        }
    },
    required: ['document_groups']
} as const;

export const $DocumentPlaceholder = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        placeholder_name: {
            type: 'string',
            maxLength: 255
        },
        german_label: {
            type: 'string',
            nullable: true,
            maxLength: 255
        },
        english_label: {
            type: 'string',
            nullable: true,
            maxLength: 255
        },
        template_count: {
            type: 'string',
            readOnly: true
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        updated_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        }
    },
    required: ['created_at', 'placeholder_name', 'template_count', 'updated_at', 'uuid']
} as const;

export const $DocumentPlaceholderGenerateLabelsRequest = {
    type: 'object',
    properties: {
        placeholder_name: {
            type: 'string',
            minLength: 1
        }
    },
    required: ['placeholder_name']
} as const;

export const $DocumentPlaceholderLabelsResponse = {
    type: 'object',
    properties: {
        german_label: {
            type: 'string'
        },
        english_label: {
            type: 'string'
        }
    }
} as const;

export const $DocumentPlaceholderRequest = {
    type: 'object',
    properties: {
        placeholder_name: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        },
        german_label: {
            type: 'string',
            nullable: true,
            maxLength: 255
        },
        english_label: {
            type: 'string',
            nullable: true,
            maxLength: 255
        }
    },
    required: ['placeholder_name']
} as const;

export const $DocumentPlaceholderUpdate = {
    type: 'object',
    properties: {
        german_label: {
            type: 'string',
            nullable: true,
            maxLength: 255
        },
        english_label: {
            type: 'string',
            nullable: true,
            maxLength: 255
        }
    }
} as const;

export const $DocumentPlaceholderUpdateRequest = {
    type: 'object',
    properties: {
        german_label: {
            type: 'string',
            nullable: true,
            maxLength: 255
        },
        english_label: {
            type: 'string',
            nullable: true,
            maxLength: 255
        }
    }
} as const;

export const $DocumentProperties = {
    type: 'object',
    description: 'Serializer for document properties.',
    properties: {
        id: {
            type: 'string'
        },
        title: {
            type: 'string'
        },
        description: {
            type: 'string'
        },
        tag: {
            type: 'string'
        },
        download: {
            type: 'string',
            readOnly: true
        },
        annotationData: {
            type: 'string',
            readOnly: true
        },
        signatures: {
            type: 'string',
            readOnly: true
        },
        md5: {
            type: 'string'
        },
        filename: {
            type: 'string',
            readOnly: true
        }
    },
    required: ['annotationData', 'description', 'download', 'filename', 'id', 'md5', 'signatures', 'tag', 'title']
} as const;

export const $DocumentReorganizationErrorResponse = {
    type: 'object',
    description: 'Serializer for document reorganization error responses.',
    properties: {
        error: {
            type: 'string',
            description: 'Error message describing what went wrong'
        },
        details: {
            type: 'string',
            description: 'Detailed error information for debugging'
        }
    },
    required: ['details', 'error']
} as const;

export const $DocumentReorganizationRequestRequest = {
    type: 'object',
    description: 'Serializer for document reorganization requests.',
    properties: {
        case_uuid: {
            type: 'string',
            format: 'uuid',
            description: 'UUID of the case containing the documents'
        },
        operations: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/ReorganizationOperationRequest'
            },
            description: 'List of reorganization operations to perform',
            minItems: 1
        }
    },
    required: ['case_uuid', 'operations']
} as const;

export const $DocumentReorganizationResponse = {
    type: 'object',
    description: 'Serializer for document reorganization responses.',
    properties: {
        message: {
            type: 'string',
            description: 'Success message describing the operation result'
        },
        created_documents: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/Document'
            },
            description: 'List of newly created documents from the reorganization'
        },
        deleted_documents: {
            type: 'array',
            items: {
                type: 'string'
            },
            description: 'List of UUIDs of deleted documents'
        },
        operations_count: {
            type: 'integer',
            description: 'Number of reorganization operations performed'
        }
    },
    required: ['created_documents', 'deleted_documents', 'message', 'operations_count']
} as const;

export const $DocumentSplitWithAIRequestRequest = {
    type: 'object',
    description: 'Request serializer for AI document splitting.',
    properties: {
        case_uuid: {
            type: 'string',
            format: 'uuid',
            description: 'UUID of the case containing the document'
        },
        document_uuid: {
            type: 'string',
            format: 'uuid',
            description: 'UUID of the document to split'
        },
        current_organization_state: {
            allOf: [
                {
                    '$ref': '#/components/schemas/DocumentOrganizationStateRequest'
                }
            ],
            description: 'Current state of document groups in the frontend'
        }
    },
    required: ['case_uuid', 'document_uuid']
} as const;

export const $DocumentSplitWithAIResponse = {
    type: 'object',
    description: 'Response serializer for AI document splitting.',
    properties: {
        message: {
            type: 'string',
            description: 'Success message'
        },
        document_groups: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/AISplitGroupResponse'
            },
            description: 'Suggested document groups'
        }
    },
    required: ['document_groups', 'message']
} as const;

export const $DocumentStatusEnum = {
    enum: ['requested', 'received', 'completed'],
    type: 'string',
    description: `* \`requested\` - Requested
* \`received\` - Received
* \`completed\` - Completed`
} as const;

export const $DocumentThumbnails = {
    type: 'object',
    description: 'Serializer specifically for document thumbnails.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        thumbnails: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/ImageproxyImagePreset'
            },
            readOnly: true
        }
    },
    required: ['thumbnails', 'uuid']
} as const;

export const $DocumentTypeEnum = {
    enum: ['Anfrage', 'Notiz', 'E-Mail', 'Upload', 'Fragebogen', 'Dokumentenvorlage', 'Transkript', 'KI Dokumentengenerator Vorlage', 'KI generiertes Dokument', 'KI Chat', 'Globaler KI Chat'],
    type: 'string',
    description: `* \`Anfrage\` - Case
* \`Notiz\` - Note
* \`E-Mail\` - Email
* \`Upload\` - Upload
* \`Fragebogen\` - Questionnaire
* \`Dokumentenvorlage\` - Pdf Template
* \`Transkript\` - Call Transcript
* \`KI Dokumentengenerator Vorlage\` - Ai Document Generator Template
* \`KI generiertes Dokument\` - Ai Generated Document
* \`KI Chat\` - Ai Case Chat
* \`Globaler KI Chat\` - Ai Global Chat`
} as const;

export const $DocumentUploadRequest = {
    type: 'object',
    properties: {
        file: {
            type: 'string',
            format: 'binary'
        },
        upload_origin: {
            allOf: [
                {
                    '$ref': '#/components/schemas/UploadOriginEnum'
                }
            ],
            default: 'Manuell hinzugefügt',
            description: `Origin of the document upload

* \`None\` - Not Set
* \`Chatbot Upload\` - Chatbot
* \`Email Anhang\` - Email
* \`Terminbuchung\` - Appointment
* \`Fragebogen\` - Questionnaire
* \`Manuell hinzugefügt\` - Manual
* \`AI CASE CHAT\` - Ai Case Chat
* \`AI Global Chat\` - Ai Global Chat
* \`Dokument neu organisiert\` - Reorganization
* \`External platform\` - External Platform`
        }
    },
    required: ['file']
} as const;

export const $EditorUploadRequest = {
    type: 'object',
    description: 'Serializer for editor upload requests.',
    properties: {
        is_private: {
            type: 'boolean'
        }
    },
    required: ['is_private']
} as const;

export const $EditorUploadResponse = {
    type: 'object',
    description: 'Serializer for editor upload responses.',
    properties: {
        link: {
            type: 'string',
            format: 'uri'
        }
    },
    required: ['link']
} as const;

export const $EmailAddress = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        email: {
            type: 'string',
            format: 'email',
            maxLength: 254
        },
        name: {
            type: 'string',
            maxLength: 255
        }
    },
    required: ['email', 'name']
} as const;

export const $EmailRenderTemplateRequestRequest = {
    type: 'object',
    properties: {
        template_html: {
            type: 'string',
            minLength: 1
        },
        case_uuid: {
            type: 'string',
            format: 'uuid',
            nullable: true
        },
        subject: {
            type: 'string',
            minLength: 1
        },
        contexts: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/ContextRequest'
            },
            default: []
        }
    },
    required: ['subject', 'template_html']
} as const;

export const $EmailRenderTemplateResponse = {
    type: 'object',
    properties: {
        subject: {
            type: 'string'
        },
        text: {
            type: 'string'
        },
        html: {
            type: 'string'
        }
    },
    required: ['html', 'subject', 'text']
} as const;

export const $EmailRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        }
    }
} as const;

export const $EmailServiceEnum = {
    enum: ['BREVO', 'OTHER'],
    type: 'string',
    description: `* \`BREVO\` - Brevo
* \`OTHER\` - Other`
} as const;

export const $EmailTemplateType = {
    enum: ['create', 'reject'],
    type: 'string',
    description: `* \`create\` - Mandatsaufnahme
* \`reject\` - Mandatsablehnung`
} as const;

export const $EmailTextColorEnum = {
    enum: ['#000000', '#28324E', '#2969B0', '#2C82C9', '#553982', '#E25041', '#475577', '#9365B8', '#A38F84', '#1ABC9C', '#00A885', '#3D8EB9', '#61BD6D', '#41A85F', '#54ACD2', '#EB6B56', '#FBA026', '#F7DA64', '#CCCCCC'],
    type: 'string',
    description: `* \`#000000\` - Black
* \`#28324E\` - Dark Grey
* \`#2969B0\` - Darker Blue
* \`#2C82C9\` - Dark Blue
* \`#553982\` - Dark Purple
* \`#E25041\` - Dark Red
* \`#475577\` - Grey
* \`#9365B8\` - Purple
* \`#A38F84\` - Brown
* \`#1ABC9C\` - Teal
* \`#00A885\` - Aqua
* \`#3D8EB9\` - Light Blue
* \`#61BD6D\` - Green
* \`#41A85F\` - Light Green
* \`#54ACD2\` - Blue
* \`#EB6B56\` - Red
* \`#FBA026\` - Orange
* \`#F7DA64\` - Yellow
* \`#CCCCCC\` - Light Grey`
} as const;

export const $EmailTextFontEnum = {
    enum: ['Arial,Helvetica,sans-serif', 'Georgia,serif', 'Impact,Charcoal,sans-serif', 'Tahoma,Geneva,sans-serif', "'Times New Roman',Times,serif", 'Verdana,Geneva,sans-serif'],
    type: 'string',
    description: `* \`Arial,Helvetica,sans-serif\` - Arial
* \`Georgia,serif\` - Georgia
* \`Impact,Charcoal,sans-serif\` - Impact
* \`Tahoma,Geneva,sans-serif\` - Tahoma
* \`'Times New Roman',Times,serif\` - Times New Roman
* \`Verdana,Geneva,sans-serif\` - Verdana`
} as const;

export const $EmailTextSizeEnum = {
    enum: [8, 9, 10, 11, 12, 14, 18],
    type: 'integer',
    description: `* \`8\` - Size 8
* \`9\` - Size 9
* \`10\` - Size 10
* \`11\` - Size 11
* \`12\` - Size 12
* \`14\` - Size 14
* \`18\` - Size 18`
} as const;

export const $EntitiesMapperKeyEnum = {
    enum: ['entities.field.address_line_2', 'entities.field.bank_name', 'entities.field.bic', 'entities.field.city', 'entities.field.company_legal_form', 'entities.field.company_name', 'entities.field.company_register_court', 'entities.field.company_register_number', 'entities.field.company_tax_id', 'entities.field.company_vat_id', 'entities.field.date_of_birth', 'entities.field.date_of_death', 'entities.field.email', 'entities.field.entity_type', 'entities.field.fax', 'entities.field.first_name', 'entities.field.iban', 'entities.field.institution_name', 'entities.field.is_entitled_to_deduct_vat', 'entities.field.is_valid_email', 'entities.field.is_valid_phone_number', 'entities.field.last_name', 'entities.field.legal_insurance_deductible_amount', 'entities.field.legal_insurance', 'entities.field.legal_insurance_name', 'entities.field.legal_insurance_number', 'entities.field.marital_status', 'entities.field.phone', 'entities.field.specific_title', 'entities.field.street', 'entities.field.street_number', 'entities.field.title', 'entities.field.website', 'entities.field.zip'],
    type: 'string',
    description: `* \`entities.field.address_line_2\` - entities.field.address_line_2
* \`entities.field.bank_name\` - entities.field.bank_name
* \`entities.field.bic\` - entities.field.bic
* \`entities.field.city\` - entities.field.city
* \`entities.field.company_legal_form\` - entities.field.company_legal_form
* \`entities.field.company_name\` - entities.field.company_name
* \`entities.field.company_register_court\` - entities.field.company_register_court
* \`entities.field.company_register_number\` - entities.field.company_register_number
* \`entities.field.company_tax_id\` - entities.field.company_tax_id
* \`entities.field.company_vat_id\` - entities.field.company_vat_id
* \`entities.field.date_of_birth\` - entities.field.date_of_birth
* \`entities.field.date_of_death\` - entities.field.date_of_death
* \`entities.field.email\` - entities.field.email
* \`entities.field.entity_type\` - entities.field.entity_type
* \`entities.field.fax\` - entities.field.fax
* \`entities.field.first_name\` - entities.field.first_name
* \`entities.field.iban\` - entities.field.iban
* \`entities.field.institution_name\` - entities.field.institution_name
* \`entities.field.is_entitled_to_deduct_vat\` - entities.field.is_entitled_to_deduct_vat
* \`entities.field.is_valid_email\` - entities.field.is_valid_email
* \`entities.field.is_valid_phone_number\` - entities.field.is_valid_phone_number
* \`entities.field.last_name\` - entities.field.last_name
* \`entities.field.legal_insurance_deductible_amount\` - entities.field.legal_insurance_deductible_amount
* \`entities.field.legal_insurance\` - entities.field.legal_insurance
* \`entities.field.legal_insurance_name\` - entities.field.legal_insurance_name
* \`entities.field.legal_insurance_number\` - entities.field.legal_insurance_number
* \`entities.field.marital_status\` - entities.field.marital_status
* \`entities.field.phone\` - entities.field.phone
* \`entities.field.specific_title\` - entities.field.specific_title
* \`entities.field.street\` - entities.field.street
* \`entities.field.street_number\` - entities.field.street_number
* \`entities.field.title\` - entities.field.title
* \`entities.field.website\` - entities.field.website
* \`entities.field.zip\` - entities.field.zip`
} as const;

export const $Entity = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        entity_type: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EntityTypeEnum'
                }
            ],
            title: 'Personentyp'
        },
        title: {
            title: 'Anrede',
            oneOf: [
                {
                    '$ref': '#/components/schemas/TitleEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        first_name: {
            type: 'string',
            title: 'Vorname',
            maxLength: 128
        },
        last_name: {
            type: 'string',
            title: 'Nachname',
            maxLength: 128
        },
        email: {
            type: 'string',
            format: 'email',
            title: 'E-Mail',
            maxLength: 128
        },
        phone: {
            type: 'string',
            title: 'Telefon',
            maxLength: 128
        },
        street: {
            type: 'string',
            title: 'Straße',
            maxLength: 128
        },
        street_number: {
            type: 'string',
            title: 'Hausnummer',
            maxLength: 16
        },
        address_line_2: {
            type: 'string',
            title: 'Adresszusatz',
            maxLength: 128
        },
        zip: {
            type: 'string',
            title: 'PLZ',
            maxLength: 12
        },
        city: {
            type: 'string',
            title: 'Ort',
            maxLength: 100
        },
        date_of_birth: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Geburtsdatum'
        },
        legal_insurance: {
            type: 'boolean',
            nullable: true,
            title: 'Rechtsschutzversicherung'
        },
        legal_insurance_number: {
            type: 'string',
            title: 'Nummer der Rechtsschutzversicherung',
            maxLength: 128
        },
        legal_insurance_name: {
            type: 'string',
            title: 'Name der Rechtsschutzversicherung',
            maxLength: 128
        },
        legal_insurance_deductible_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Höhe der Selbstbeteiligung der Rechtsschutzversicherung'
        },
        is_company: {
            type: 'string',
            readOnly: true
        },
        company_name: {
            type: 'string',
            title: 'Firmenname',
            maxLength: 128
        },
        company_legal_form: {
            title: 'Rechtsform',
            oneOf: [
                {
                    '$ref': '#/components/schemas/CompanyLegalFormEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        company_register_number: {
            type: 'string',
            title: 'Handelsregisternummer',
            maxLength: 128
        },
        company_register_court: {
            type: 'string',
            title: 'Amtsgericht',
            maxLength: 128
        },
        company_vat_id: {
            type: 'string',
            title: 'USt. ID',
            maxLength: 128
        },
        company_tax_id: {
            type: 'string',
            title: 'Steuernummer',
            maxLength: 128
        },
        bank_name: {
            type: 'string',
            title: 'Bankname',
            maxLength: 128
        },
        iban: {
            type: 'string',
            maxLength: 34
        },
        bic: {
            type: 'string',
            maxLength: 11
        },
        institution_name: {
            type: 'string',
            title: 'Name der Institution',
            maxLength: 128
        },
        changes: {
            type: 'array',
            items: {
                type: 'integer'
            },
            readOnly: true
        }
    },
    required: ['changes', 'entity_type', 'is_company', 'uuid']
} as const;

export const $EntityAddCaseDataRelationshipRequest = {
    type: 'object',
    properties: {
        case_data_uuid: {
            type: 'string',
            minLength: 1
        },
        relationship_type: {
            '$ref': '#/components/schemas/RelationshipTypeEnum'
        },
        number: {
            type: 'integer',
            nullable: true
        }
    },
    required: ['case_data_uuid', 'relationship_type']
} as const;

export const $EntityAugmentedFieldsRequest = {
    type: 'object',
    properties: {
        entity_type: {
            type: 'string',
            format: 'uuid',
            nullable: true
        },
        title: {
            type: 'string',
            format: 'uuid',
            nullable: true
        },
        first_name: {
            type: 'string',
            format: 'uuid',
            nullable: true
        },
        last_name: {
            type: 'string',
            format: 'uuid',
            nullable: true
        },
        company_name: {
            type: 'string',
            format: 'uuid',
            nullable: true
        },
        company_legal_form: {
            type: 'string',
            format: 'uuid',
            nullable: true
        },
        institution_name: {
            type: 'string',
            format: 'uuid',
            nullable: true
        },
        phone: {
            type: 'string',
            format: 'uuid',
            nullable: true
        },
        email: {
            type: 'string',
            format: 'uuid',
            nullable: true
        },
        date_of_birth: {
            type: 'string',
            format: 'uuid',
            nullable: true
        },
        street: {
            type: 'string',
            format: 'uuid',
            nullable: true
        },
        street_number: {
            type: 'string',
            format: 'uuid',
            nullable: true
        },
        zip: {
            type: 'string',
            format: 'uuid',
            nullable: true
        },
        city: {
            type: 'string',
            format: 'uuid',
            nullable: true
        },
        legal_insurance: {
            type: 'string',
            format: 'uuid',
            nullable: true
        },
        legal_insurance_number: {
            type: 'string',
            format: 'uuid',
            nullable: true
        },
        legal_insurance_name: {
            type: 'string',
            format: 'uuid',
            nullable: true
        }
    },
    required: ['city', 'company_legal_form', 'company_name', 'date_of_birth', 'email', 'entity_type', 'first_name', 'institution_name', 'last_name', 'legal_insurance', 'legal_insurance_name', 'legal_insurance_number', 'phone', 'street', 'street_number', 'title', 'zip']
} as const;

export const $EntityRelationship = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        relationship_type: {
            '$ref': '#/components/schemas/RelationshipTypeEnum'
        },
        is_unique_per_case: {
            type: 'boolean'
        },
        number: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true
        }
    },
    required: ['is_unique_per_case', 'number', 'relationship_type']
} as const;

export const $EntityRelationshipRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        relationship_type: {
            '$ref': '#/components/schemas/RelationshipTypeEnum'
        },
        is_unique_per_case: {
            type: 'boolean'
        },
        number: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true
        }
    },
    required: ['is_unique_per_case', 'number', 'relationship_type']
} as const;

export const $EntityRemoveCaseDataRelationshipCustomerResponse = {
    type: 'object',
    properties: {
        relationship: {
            allOf: [
                {
                    '$ref': '#/components/schemas/CustomerEntityWithRelationship'
                }
            ],
            nullable: true
        }
    },
    required: ['relationship']
} as const;

export const $EntityRemoveCaseDataRelationshipRequestRequest = {
    type: 'object',
    properties: {
        case_data_uuid: {
            type: 'string',
            format: 'uuid'
        },
        relationship_uuid: {
            type: 'string',
            format: 'uuid',
            nullable: true
        },
        remove_case_data_association_if_no_relationships_exist: {
            type: 'boolean',
            default: false
        }
    },
    required: ['case_data_uuid']
} as const;

export const $EntityRemoveCaseDataRelationshipSuperUserResponse = {
    type: 'object',
    properties: {
        relationship: {
            allOf: [
                {
                    '$ref': '#/components/schemas/SuperUserEntityWithRelationship'
                }
            ],
            nullable: true
        }
    },
    required: ['relationship']
} as const;

export const $EntityRequest = {
    type: 'object',
    properties: {
        entity_type: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EntityTypeEnum'
                }
            ],
            title: 'Personentyp'
        },
        title: {
            title: 'Anrede',
            oneOf: [
                {
                    '$ref': '#/components/schemas/TitleEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        first_name: {
            type: 'string',
            title: 'Vorname',
            maxLength: 128
        },
        last_name: {
            type: 'string',
            title: 'Nachname',
            maxLength: 128
        },
        email: {
            type: 'string',
            format: 'email',
            title: 'E-Mail',
            maxLength: 128
        },
        phone: {
            type: 'string',
            title: 'Telefon',
            maxLength: 128
        },
        street: {
            type: 'string',
            title: 'Straße',
            maxLength: 128
        },
        street_number: {
            type: 'string',
            title: 'Hausnummer',
            maxLength: 16
        },
        address_line_2: {
            type: 'string',
            title: 'Adresszusatz',
            maxLength: 128
        },
        zip: {
            type: 'string',
            title: 'PLZ',
            maxLength: 12
        },
        city: {
            type: 'string',
            title: 'Ort',
            maxLength: 100
        },
        date_of_birth: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Geburtsdatum'
        },
        legal_insurance: {
            type: 'boolean',
            nullable: true,
            title: 'Rechtsschutzversicherung'
        },
        legal_insurance_number: {
            type: 'string',
            title: 'Nummer der Rechtsschutzversicherung',
            maxLength: 128
        },
        legal_insurance_name: {
            type: 'string',
            title: 'Name der Rechtsschutzversicherung',
            maxLength: 128
        },
        legal_insurance_deductible_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Höhe der Selbstbeteiligung der Rechtsschutzversicherung'
        },
        company_name: {
            type: 'string',
            title: 'Firmenname',
            maxLength: 128
        },
        company_legal_form: {
            title: 'Rechtsform',
            oneOf: [
                {
                    '$ref': '#/components/schemas/CompanyLegalFormEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        company_register_number: {
            type: 'string',
            title: 'Handelsregisternummer',
            maxLength: 128
        },
        company_register_court: {
            type: 'string',
            title: 'Amtsgericht',
            maxLength: 128
        },
        company_vat_id: {
            type: 'string',
            title: 'USt. ID',
            maxLength: 128
        },
        company_tax_id: {
            type: 'string',
            title: 'Steuernummer',
            maxLength: 128
        },
        bank_name: {
            type: 'string',
            title: 'Bankname',
            maxLength: 128
        },
        iban: {
            type: 'string',
            maxLength: 34
        },
        bic: {
            type: 'string',
            maxLength: 11
        },
        institution_name: {
            type: 'string',
            title: 'Name der Institution',
            maxLength: 128
        }
    },
    required: ['entity_type']
} as const;

export const $EntityTypeC7aEnum = {
    type: 'string',
    enum: ['natural_person', 'legal_person', 'institution']
} as const;

export const $EntityTypeEnum = {
    enum: ['natural_person', 'legal_person', 'institution'],
    type: 'string',
    description: `* \`natural_person\` - Natürliche Person
* \`legal_person\` - Juristische Person
* \`institution\` - Institution`
} as const;

export const $EventEnum = {
    enum: ['SENT', 'DELIVERED', 'HARD_BOUNCED', 'SOFT_BOUNCED', 'BLOCKED', 'SPAM', 'UNSUBSCRIBED', 'OPENED', 'CLICKED', 'UNKNOWN'],
    type: 'string',
    description: `* \`SENT\` - Sent
* \`DELIVERED\` - Delivered
* \`HARD_BOUNCED\` - Hard Bounced
* \`SOFT_BOUNCED\` - Soft Bounced
* \`BLOCKED\` - Blocked
* \`SPAM\` - Spam
* \`UNSUBSCRIBED\` - Unsubscribed
* \`OPENED\` - Opened
* \`CLICKED\` - Clicked
* \`UNKNOWN\` - Unknown`
} as const;

export const $EventNameEnum = {
    enum: ['Logout', 'Login', 'Bot Display', 'Bot Session Started', 'Bot Session Ended', 'Questionnaire Sent', 'Questionnaire Completed', 'PDFDocument Sent', 'PDFDocument Completed', 'Email Sent', 'Email Received', 'Email Template Edited', 'Case Created', 'Case Rejected', 'Case Accepted', 'Case In Progress', 'Case Deleted', 'Case Exported', 'Calculator Opened', 'Calculator Saved', 'Appointment Account Authorized', 'Appointment Account Revoked', 'Appointment Service Created', 'Appointment Service Edited', 'Appointment Service Enabled', 'Appointment Service Disabled', 'Appointment Service Soft Deleted', 'Appointment Service Recovered', 'Appointment Calendar Created', 'Appointment Calendar Edited', 'Appointment Calendar Enabled', 'Appointment Calendar Disabled', 'Appointment Lawfields Edited', 'Appointment Setup Completed', 'Appointment Created', 'Appointment Proposal Created', 'Appointment Settings Edited', 'Call Started', 'Call Ended', 'Call Automated Rating Received', 'Call Human Rating Received', 'Call Lawer Rating Received', 'Phone Forwarding Rule Created', 'Phone Forwarding Rule Updated', 'Entity Extraction Instructions Set', 'AI Token Used', 'AI Embedding Token Used', 'AI Function Voice Call Used', 'AI Function Document Analysis Used', 'AI Function Document Title Generation Used', 'AI Function Questionnaire Title Generation Used', 'AI Function Email Extraction Used', 'AI Function Gender Detection Used', 'AI Function Document Type Classification Used', 'AI Function Document Analysis Entity Classification Used', 'AI Function Document Generation Used', 'AI Function Inquiry Summary Used', 'AI Function Used Case Chat', 'AI Function Used Update Case Chat Document Context', 'AI Function Used Update Case Chat Document Context Alternative Queries', 'AI Function Used Update Case Chat Document Context Alternative Queries Create Embeddings', 'AI Function Case Create Document Entities Extraction Used', 'AI Function Universal Entity Extraction Used', 'AI Function Document Template Generation Used', 'User Feedback', 'Help Link Clicked', 'AI Function Document Summarization Used', 'AI Function Document Raptor Summarization Used', 'AI Function Used Rate AI Chat Session', 'AI Chat Session Rating', 'AI Chat Session Human Rating', 'Global AI Chat Folder Created', 'Global AI Chat Folder Updated', 'Global AI Chat Folder Deleted', 'Global AI Chat Session Created', 'Global AI Chat Session Deleted', 'Global AI Chat Visited', 'AI Function Used Global Chat', 'Global Chat Case Specific Info Requested', 'AI Function Template Description Generation Used', 'AI Function Memory Title Generation Used', 'AI Function Used Chat Memory Embedding', 'AI Function Used Chat Memory Importance Evaluation', 'AI Function Used Rate Memory Evaluation', 'AI Function Used Prompt Enhancement', 'AI Function Used Preference Suggestion Analysis', 'AI Function Used Feedback Preference Suggestion', 'AI Function Used Chat Preference Embedding', 'AI Function Used Chat Preference Importance Evaluation', 'Snippet Button Clicked in Document Generator', 'Snippet Selected in Document Generator', 'Document Metadata Enrichment Started', 'Document Metadata Enrichment Finished', 'Document Metadata Enrichment Retry', 'Document OCR Started', 'Document OCR Finished', 'Document Embeddings Started', 'Document Embeddings Finished', 'Document Summary Started', 'Document Summary Finished', 'Document Analysis Started', 'Document Analysis Finished', 'Document Entity Extraction Started', 'Document Entity Extraction Finished', 'Document Raptor Summaries Started', 'Document Raptor Summaries Finished', 'Document Inline Edit Started', 'Document Rename AI Clicked', 'Document Rename AI Completed', 'Document Rename AI Failed', 'Document Rename Saved', 'Document Rename Cancelled', 'Document Preview Opened', 'Document Preview Closed', 'Document Downloaded', 'Document Deleted', 'Document Organize Pages Opened', 'Documents Bulk Selected', 'Documents Bulk Deselected', 'Documents Bulk Rename Started', 'Documents Bulk Rename Completed', 'Documents Bulk Rename Failed', 'Documents Bulk Merge Started', 'Documents Bulk Download Started', 'Documents Bulk Download Completed', 'Documents Bulk Download Failed', 'Documents Bulk Delete Started', 'Documents Bulk Delete Completed', 'Documents Bulk Delete Failed', 'PDF Organize View Opened', 'PDF Organize View Closed', 'PDF Organize Changes Saved', 'PDF Organize Changes Discarded', 'PDF Organize Download Started', 'PDF Organize Download Completed', 'PDF Organize Download Failed', 'PDF Document Merged', 'PDF Documents Merged All', 'PDF Document Split Manual', 'PDF Document Split AI Started', 'PDF Document Split AI Completed', 'PDF Document Split AI Failed', 'PDF Document Duplicated', 'PDF Document Group Deleted', 'PDF Document Group Created', 'PDF Document Group Renamed', 'PDF Document Title AI Generated', 'PDF Pages Moved', 'PDF Pages Deleted', 'PDF Pages Rotated', 'PDF Pages Reordered', 'PDF Pages Merged', 'PDF Add Documents Opened', 'PDF Documents Added', 'PDF Viewer Edit Page Clicked', 'PDF Viewer Organize Pages Clicked', 'PDF Viewer Download Clicked', 'PDF Viewer Reset Edits Started', 'PDF Viewer Reset Edits Completed', 'PDF Viewer Reset Edits Cancelled', 'Image Editor Opened', 'Image Editor Closed', 'Image Editor Mode Changed', 'Image Editor Changes Applied', 'Image Editor Changes Discarded', 'Image Editor Crop Region Added', 'Image Editor Crop Region Removed', 'Image Editor Crop Applied', 'Image Editor Crop Reset', 'Image Editor Rotated', 'Image Editor Rotation Reset', 'Image Editor Adjustment Changed', 'Image Editor Adjustments Reset', 'Image Editor Trim Applied', 'Image Editor Trim Reset', 'Actaport Document Imported', 'Actaport Document Import Failed', 'Actaport Document Exported', 'Actaport Document Export Failed', 'Actaport Documents Refresh', 'Actaport API Rate Limit Hit', 'PDF Form Template Created', 'PDF Form Template Duplicated', 'PDF Form Template Updated', 'PDF Form Template Deleted', 'PDF Form Template Edit Started', 'PDF Form Template Edit Saved', 'PDF Form Template Edit Abandoned', 'PDF Form Template Field Added', 'PDF Form Template Field Removed', 'PDF Form Template Previewed', 'PDF Form Template Used', 'PDF Form Submission Created', 'PDF Form Submission Completed', 'PDF Form Submission Sent', 'PDF Form Flattened', 'Self Questionnaire Created', 'Self Questionnaire Updated', 'Self Questionnaire Published', 'Self Questionnaire AI Generated', 'Self Questionnaire Copy', 'Self Questionnaire Submission Partial Updated', 'Self Questionnaire Submission Completed'],
    type: 'string',
    description: `* \`Logout\` - Logout
* \`Login\` - Login
* \`Bot Display\` - Bot Display
* \`Bot Session Started\` - Bot Session Started
* \`Bot Session Ended\` - Bot Session Ended
* \`Questionnaire Sent\` - Questionnaire Sent
* \`Questionnaire Completed\` - Questionnaire Completed
* \`PDFDocument Sent\` - Form Sent
* \`PDFDocument Completed\` - Form Completed
* \`Email Sent\` - Email Sent
* \`Email Received\` - Email Received
* \`Email Template Edited\` - Email Template Edited
* \`Case Created\` - Case Created
* \`Case Rejected\` - Case Rejected
* \`Case Accepted\` - Case Completed
* \`Case In Progress\` - Case In Progress
* \`Case Deleted\` - Case Deleted
* \`Case Exported\` - Case Exported
* \`Calculator Opened\` - Calculator Opened
* \`Calculator Saved\` - Calculator Saved
* \`Appointment Account Authorized\` - Appointment Account Authorized
* \`Appointment Account Revoked\` - Appointment Account Revoked
* \`Appointment Service Created\` - Appointment Service Created
* \`Appointment Service Edited\` - Appointment Service Edited
* \`Appointment Service Enabled\` - Appointment Service Enabled
* \`Appointment Service Disabled\` - Appointment Service Disabled
* \`Appointment Service Soft Deleted\` - Appointment Service Soft Deleted
* \`Appointment Service Recovered\` - Appointment Service Recovered
* \`Appointment Calendar Created\` - Appointment Calendar Created
* \`Appointment Calendar Edited\` - Appointment Calendar Edited
* \`Appointment Calendar Enabled\` - Appointment Calendar Enabled
* \`Appointment Calendar Disabled\` - Appointment Calendar Disabled
* \`Appointment Lawfields Edited\` - Appointment Lawfields Edited
* \`Appointment Setup Completed\` - Appointment Setup Completed
* \`Appointment Created\` - Appointment Created
* \`Appointment Proposal Created\` - Appointment Proposal Created
* \`Appointment Settings Edited\` - Appointment Settings Edited
* \`Call Started\` - Call Started
* \`Call Ended\` - Call Ended
* \`Call Automated Rating Received\` - Call Automated Rating
* \`Call Human Rating Received\` - Call Human Rating
* \`Call Lawer Rating Received\` - Call Lawer Rating
* \`Phone Forwarding Rule Created\` - Phone Forwarding Rule Created
* \`Phone Forwarding Rule Updated\` - Phone Forwarding Rule Updated
* \`Entity Extraction Instructions Set\` - Entity Extraction Instructions Set
* \`AI Token Used\` - Ai Token Used
* \`AI Embedding Token Used\` - Ai Embedding Token Used
* \`AI Function Voice Call Used\` - Ai Function Voice Call Used
* \`AI Function Document Analysis Used\` - Ai Function Document Analysis Used
* \`AI Function Document Title Generation Used\` - Ai Function Document Title Generation Used
* \`AI Function Questionnaire Title Generation Used\` - Ai Function Questionnaire Title Generation Used
* \`AI Function Email Extraction Used\` - Ai Function Email Extraction Used
* \`AI Function Gender Detection Used\` - Ai Function Gender Detection Used
* \`AI Function Document Type Classification Used\` - Ai Function Document Type Classification Used
* \`AI Function Document Analysis Entity Classification Used\` - Ai Function Document Analysis Entity Classification Used
* \`AI Function Document Generation Used\` - Ai Function Document Generation Used
* \`AI Function Inquiry Summary Used\` - Ai Function Inquiry Summary Used
* \`AI Function Used Case Chat\` - Ai Function Used Case Chat
* \`AI Function Used Update Case Chat Document Context\` - Ai Function Used Update Case Chat Document Context
* \`AI Function Used Update Case Chat Document Context Alternative Queries\` - Ai Function Used Update Case Chat Document Context Alternative Queries
* \`AI Function Used Update Case Chat Document Context Alternative Queries Create Embeddings\` - Ai Function Used Update Case Chat Document Context Alternative Queries Create Embeddings
* \`AI Function Case Create Document Entities Extraction Used\` - Ai Function Case Create Document Entities Extraction Used
* \`AI Function Universal Entity Extraction Used\` - Ai Function Universal Entity Extraction Used
* \`AI Function Document Template Generation Used\` - Ai Function Document Template Generation Used
* \`User Feedback\` - User Feedback
* \`Help Link Clicked\` - Help Link Clicked
* \`AI Function Document Summarization Used\` - Ai Function Document Summarization Used
* \`AI Function Document Raptor Summarization Used\` - Ai Function Document Raptor Summarization Used
* \`AI Function Used Rate AI Chat Session\` - Ai Function Used Rate Ai Chat Session
* \`AI Chat Session Rating\` - Ai Chat Session Rating
* \`AI Chat Session Human Rating\` - Ai Chat Session Human Rating
* \`Global AI Chat Folder Created\` - Global Ai Chat Folder Created
* \`Global AI Chat Folder Updated\` - Global Ai Chat Folder Updated
* \`Global AI Chat Folder Deleted\` - Global Ai Chat Folder Deleted
* \`Global AI Chat Session Created\` - Global Ai Chat Session Created
* \`Global AI Chat Session Deleted\` - Global Ai Chat Session Deleted
* \`Global AI Chat Visited\` - Global Ai Chat Visited
* \`AI Function Used Global Chat\` - Ai Function Used Global Chat
* \`Global Chat Case Specific Info Requested\` - Global Chat Case Specific Info Requested
* \`AI Function Template Description Generation Used\` - Ai Function Template Description Generation Used
* \`AI Function Memory Title Generation Used\` - Ai Function Memory Title Generation Used
* \`AI Function Used Chat Memory Embedding\` - Ai Function Used Chat Memory Embedding
* \`AI Function Used Chat Memory Importance Evaluation\` - Ai Function Used Chat Memory Importance
* \`AI Function Used Rate Memory Evaluation\` - Ai Function Used Rate Memory Evaluation
* \`AI Function Used Prompt Enhancement\` - Ai Function Used Prompt Enhancement
* \`AI Function Used Preference Suggestion Analysis\` - Ai Function Used Preference Suggestion Analysis
* \`AI Function Used Feedback Preference Suggestion\` - Ai Function Used Feedback Preference Suggestion
* \`AI Function Used Chat Preference Embedding\` - Ai Function Used Chat Preference Embedding
* \`AI Function Used Chat Preference Importance Evaluation\` - Ai Function Used Chat Preference Importance
* \`Snippet Button Clicked in Document Generator\` - Snippet Button Clicked In Document Generator
* \`Snippet Selected in Document Generator\` - Snippet Selected In Document Generator
* \`Document Metadata Enrichment Started\` - Document Metadata Enrichment Started
* \`Document Metadata Enrichment Finished\` - Document Metadata Enrichment Finished
* \`Document Metadata Enrichment Retry\` - Document Metadata Enrichment Retry
* \`Document OCR Started\` - Document Ocr Started
* \`Document OCR Finished\` - Document Ocr Finished
* \`Document Embeddings Started\` - Document Embeddings Started
* \`Document Embeddings Finished\` - Document Embeddings Finished
* \`Document Summary Started\` - Document Summary Started
* \`Document Summary Finished\` - Document Summary Finished
* \`Document Analysis Started\` - Document Analysis Started
* \`Document Analysis Finished\` - Document Analysis Finished
* \`Document Entity Extraction Started\` - Document Entity Extraction Started
* \`Document Entity Extraction Finished\` - Document Entity Extraction Finished
* \`Document Raptor Summaries Started\` - Document Raptor Summaries Started
* \`Document Raptor Summaries Finished\` - Document Raptor Summaries Finished
* \`Document Inline Edit Started\` - Document Inline Edit Started
* \`Document Rename AI Clicked\` - Document Rename Ai Clicked
* \`Document Rename AI Completed\` - Document Rename Ai Completed
* \`Document Rename AI Failed\` - Document Rename Ai Failed
* \`Document Rename Saved\` - Document Rename Saved
* \`Document Rename Cancelled\` - Document Rename Cancelled
* \`Document Preview Opened\` - Document Preview Opened
* \`Document Preview Closed\` - Document Preview Closed
* \`Document Downloaded\` - Document Downloaded
* \`Document Deleted\` - Document Deleted
* \`Document Organize Pages Opened\` - Document Organize Pages Opened
* \`Documents Bulk Selected\` - Documents Bulk Selected
* \`Documents Bulk Deselected\` - Documents Bulk Deselected
* \`Documents Bulk Rename Started\` - Documents Bulk Rename Started
* \`Documents Bulk Rename Completed\` - Documents Bulk Rename Completed
* \`Documents Bulk Rename Failed\` - Documents Bulk Rename Failed
* \`Documents Bulk Merge Started\` - Documents Bulk Merge Started
* \`Documents Bulk Download Started\` - Documents Bulk Download Started
* \`Documents Bulk Download Completed\` - Documents Bulk Download Completed
* \`Documents Bulk Download Failed\` - Documents Bulk Download Failed
* \`Documents Bulk Delete Started\` - Documents Bulk Delete Started
* \`Documents Bulk Delete Completed\` - Documents Bulk Delete Completed
* \`Documents Bulk Delete Failed\` - Documents Bulk Delete Failed
* \`PDF Organize View Opened\` - Pdf Organize View Opened
* \`PDF Organize View Closed\` - Pdf Organize View Closed
* \`PDF Organize Changes Saved\` - Pdf Organize Changes Saved
* \`PDF Organize Changes Discarded\` - Pdf Organize Changes Discarded
* \`PDF Organize Download Started\` - Pdf Organize Download Started
* \`PDF Organize Download Completed\` - Pdf Organize Download Completed
* \`PDF Organize Download Failed\` - Pdf Organize Download Failed
* \`PDF Document Merged\` - Pdf Document Merged
* \`PDF Documents Merged All\` - Pdf Documents Merged All
* \`PDF Document Split Manual\` - Pdf Document Split Manual
* \`PDF Document Split AI Started\` - Pdf Document Split Ai Started
* \`PDF Document Split AI Completed\` - Pdf Document Split Ai Completed
* \`PDF Document Split AI Failed\` - Pdf Document Split Ai Failed
* \`PDF Document Duplicated\` - Pdf Document Duplicated
* \`PDF Document Group Deleted\` - Pdf Document Group Deleted
* \`PDF Document Group Created\` - Pdf Document Group Created
* \`PDF Document Group Renamed\` - Pdf Document Group Renamed
* \`PDF Document Title AI Generated\` - Pdf Document Title Ai Generated
* \`PDF Pages Moved\` - Pdf Pages Moved
* \`PDF Pages Deleted\` - Pdf Pages Deleted
* \`PDF Pages Rotated\` - Pdf Pages Rotated
* \`PDF Pages Reordered\` - Pdf Pages Reordered
* \`PDF Pages Merged\` - Pdf Pages Merged
* \`PDF Add Documents Opened\` - Pdf Add Documents Opened
* \`PDF Documents Added\` - Pdf Documents Added
* \`PDF Viewer Edit Page Clicked\` - Pdf Viewer Edit Page Clicked
* \`PDF Viewer Organize Pages Clicked\` - Pdf Viewer Organize Pages Clicked
* \`PDF Viewer Download Clicked\` - Pdf Viewer Download Clicked
* \`PDF Viewer Reset Edits Started\` - Pdf Viewer Reset Edits Started
* \`PDF Viewer Reset Edits Completed\` - Pdf Viewer Reset Edits Completed
* \`PDF Viewer Reset Edits Cancelled\` - Pdf Viewer Reset Edits Cancelled
* \`Image Editor Opened\` - Image Editor Opened
* \`Image Editor Closed\` - Image Editor Closed
* \`Image Editor Mode Changed\` - Image Editor Mode Changed
* \`Image Editor Changes Applied\` - Image Editor Changes Applied
* \`Image Editor Changes Discarded\` - Image Editor Changes Discarded
* \`Image Editor Crop Region Added\` - Image Editor Crop Region Added
* \`Image Editor Crop Region Removed\` - Image Editor Crop Region Removed
* \`Image Editor Crop Applied\` - Image Editor Crop Applied
* \`Image Editor Crop Reset\` - Image Editor Crop Reset
* \`Image Editor Rotated\` - Image Editor Rotated
* \`Image Editor Rotation Reset\` - Image Editor Rotation Reset
* \`Image Editor Adjustment Changed\` - Image Editor Adjustment Changed
* \`Image Editor Adjustments Reset\` - Image Editor Adjustments Reset
* \`Image Editor Trim Applied\` - Image Editor Trim Applied
* \`Image Editor Trim Reset\` - Image Editor Trim Reset
* \`Actaport Document Imported\` - Actaport Document Imported
* \`Actaport Document Import Failed\` - Actaport Document Import Failed
* \`Actaport Document Exported\` - Actaport Document Exported
* \`Actaport Document Export Failed\` - Actaport Document Export Failed
* \`Actaport Documents Refresh\` - Actaport Documents Refresh
* \`Actaport API Rate Limit Hit\` - Actaport Api Rate Limit Hit
* \`PDF Form Template Created\` - Pdf Form Template Created
* \`PDF Form Template Duplicated\` - Pdf Form Template Duplicated
* \`PDF Form Template Updated\` - Pdf Form Template Updated
* \`PDF Form Template Deleted\` - Pdf Form Template Deleted
* \`PDF Form Template Edit Started\` - Pdf Form Template Edit Started
* \`PDF Form Template Edit Saved\` - Pdf Form Template Edit Saved
* \`PDF Form Template Edit Abandoned\` - Pdf Form Template Edit Abandoned
* \`PDF Form Template Field Added\` - Pdf Form Template Field Added
* \`PDF Form Template Field Removed\` - Pdf Form Template Field Removed
* \`PDF Form Template Previewed\` - Pdf Form Template Previewed
* \`PDF Form Template Used\` - Pdf Form Template Used
* \`PDF Form Submission Created\` - Pdf Form Submission Created
* \`PDF Form Submission Completed\` - Pdf Form Submission Completed
* \`PDF Form Submission Sent\` - Pdf Form Submission Sent
* \`PDF Form Flattened\` - Pdf Form Flattened
* \`Self Questionnaire Created\` - Self Questionnaire Created
* \`Self Questionnaire Updated\` - Self Questionnaire Updated
* \`Self Questionnaire Published\` - Self Questionnaire Published
* \`Self Questionnaire AI Generated\` - Self Questionnaire Ai Generated
* \`Self Questionnaire Copy\` - Self Questionnaire Copy
* \`Self Questionnaire Submission Partial Updated\` - Self Questionnaire Submission Partial Updated
* \`Self Questionnaire Submission Completed\` - Self Questionnaire Submission Completed`
} as const;

export const $ExternalIntegrationCaseCreationResponse = {
    type: 'object',
    properties: {
        caseId: {
            type: 'string'
        },
        status: {
            type: 'string'
        },
        message: {
            type: 'string'
        }
    },
    required: ['caseId', 'message', 'status']
} as const;

export const $ExternalIntegrationFileDownloadResponse = {
    type: 'object',
    properties: {
        fileName: {
            type: 'string'
        },
        content: {
            type: 'string'
        },
        contentType: {
            type: 'string'
        },
        message: {
            type: 'string'
        }
    },
    required: ['content', 'contentType', 'fileName', 'message']
} as const;

export const $ExternalPDFFormSubmissionCreateRequest = {
    type: 'object',
    description: 'Serializer for creating external PDF form submissions linked to cases.',
    properties: {
        template_uuid: {
            type: 'string',
            format: 'uuid',
            description: 'UUID of the PDF form template'
        },
        case_uuid: {
            type: 'string',
            format: 'uuid',
            description: 'UUID of the case to link the submission to'
        }
    },
    required: ['case_uuid', 'template_uuid']
} as const;

export const $ExternalPDFFormSubmissionResponse = {
    type: 'object',
    description: 'Response serializer for external PDF form submission creation.',
    properties: {
        submission_uuid: {
            type: 'string',
            format: 'uuid',
            description: 'UUID of the created submission'
        },
        access_token: {
            type: 'string',
            description: 'Third-party access token for the submission'
        },
        submission_url: {
            type: 'string',
            description: 'Full URL to access the submission'
        }
    },
    required: ['access_token', 'submission_url', 'submission_uuid']
} as const;

export const $ExternalQuestionnaireSubmissionCreateRequest = {
    type: 'object',
    description: `Serializer for creating questionnaire submissions using creation tokens.
Used for external creation without authentication.`,
    properties: {
        questionnaire_creation_token: {
            type: 'string',
            minLength: 1,
            description: 'Creation token for the questionnaire'
        },
        org_questionnaire_creation_token: {
            type: 'string',
            minLength: 1,
            description: 'Creation token for the organization'
        }
    },
    required: ['org_questionnaire_creation_token', 'questionnaire_creation_token']
} as const;

export const $ExternalQuestionnaireSubmissionResponse = {
    type: 'object',
    description: `Response serializer for external questionnaire submission creation.
Returns the created submission with access token.`,
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        case_uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        short_id: {
            type: 'string',
            readOnly: true
        },
        title: {
            type: 'string',
            readOnly: true
        },
        law_field: {
            allOf: [
                {
                    '$ref': '#/components/schemas/LawFieldEnum'
                }
            ],
            readOnly: true,
            title: 'Rechtsgebiet'
        },
        law_topic: {
            allOf: [
                {
                    '$ref': '#/components/schemas/LawTopicEnum'
                }
            ],
            readOnly: true,
            title: 'Rechtsthema'
        },
        question_count: {
            type: 'string',
            readOnly: true
        },
        required_question_count: {
            type: 'string',
            readOnly: true
        },
        optional_question_count: {
            type: 'string',
            readOnly: true
        },
        answered_question_count: {
            type: 'string',
            readOnly: true
        },
        answered_required_questions_percent: {
            type: 'string',
            readOnly: true
        },
        answered_optional_questions_count: {
            type: 'string',
            readOnly: true
        },
        answered_questions_percent: {
            type: 'string',
            readOnly: true
        },
        answered_optional_questions_percent: {
            type: 'string',
            readOnly: true
        },
        is_third_party_questionnaire: {
            type: 'boolean'
        },
        third_party_access_token: {
            type: 'string',
            readOnly: true
        },
        due_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        state: {
            type: 'string',
            readOnly: true
        },
        schema: {},
        closed: {
            type: 'boolean'
        }
    },
    required: ['answered_optional_questions_count', 'answered_optional_questions_percent', 'answered_question_count', 'answered_questions_percent', 'answered_required_questions_percent', 'case_uuid', 'created_at', 'due_at', 'law_field', 'law_topic', 'optional_question_count', 'question_count', 'required_question_count', 'short_id', 'state', 'third_party_access_token', 'title', 'uuid']
} as const;

export const $ExtractedMetadata = {
    type: 'object',
    description: 'Serializer for AI-extracted metadata response.',
    properties: {
        id: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        extracted_metadata: {
            type: 'object',
            additionalProperties: {
                type: 'string'
            },
            description: 'Extracted metadata including name, law_field, law_topic, description'
        },
        confidence_scores: {
            type: 'object',
            additionalProperties: {
                type: 'number',
                format: 'double',
                maximum: 1,
                minimum: 0
            },
            description: 'Confidence scores for each extracted field'
        }
    },
    required: ['extracted_metadata', 'id']
} as const;

export const $FeatureEnum = {
    enum: ['ai_chat', 'document_generator', 'ai_analysis', 'new_case_page', 'agent_action', 'case_ai_workflow'],
    type: 'string',
    description: `* \`ai_chat\` - Ai Chat
* \`document_generator\` - Document Generator
* \`ai_analysis\` - Ai Analysis
* \`new_case_page\` - New Case Page
* \`agent_action\` - Agent Action
* \`case_ai_workflow\` - Case Ai Workflow`
} as const;

export const $FeatureFlagCheckRequestRequest = {
    type: 'object',
    description: 'Serializer for feature flag check requests.',
    properties: {
        flag: {
            allOf: [
                {
                    '$ref': '#/components/schemas/FlagEnum'
                }
            ],
            description: `The feature flag to check

* \`ACTAPORT_V2_ENABLED\` - Actaport V2 Enabled
* \`ACTAPORT_V2_TWO_WAY_SYNC\` - Actaport V2 Two Way Sync
* \`AGENTIC_WORKFLOWS\` - Agentic Workflows
* \`CASE_DETAIL_PAGE_V3_API\` - Case Detail Page V3 Api
* \`CLIENT_PORTAL_V3_API\` - Client Portal V3 Api
* \`ENABLE_INTERCOM_CHAT\` - Enable Intercom Chat
* \`GLOBAL_AI_CHAT\` - Global Ai Chat
* \`INCOMING_EMAIL_ENTITY_EXTRACTION_AGENT\` - Incoming Email Entity Extraction Agent
* \`NEW_ADMIN_QUESTIONNAIRE_EDITOR\` - New Admin Questionnaire Editor
* \`NEW_PDF_EDITOR\` - New Pdf Editor
* \`OFFICE_DOCUMENT_EDITING\` - Office Document Editing
* \`PDF_FORM_TEMPLATES\` - Pdf Form Templates
* \`PDF_FORM_TEMPLATES_ADMIN\` - Pdf Form Templates Admin
* \`PREFLIGHT_DOCUMENT_EXTRACTION_AGENT\` - Preflight Document Extraction Agent
* \`QUESTIONNAIRE_SELF_SERVICE\` - Questionnaire Self Service
* \`USE_AGENT_API\` - Use Agent Api
* \`USE_POSTHOG_METRICS\` - Use Posthog Metrics
* \`USE_SEGMENT_METRICS\` - Use Segment Metrics`
        }
    },
    required: ['flag']
} as const;

export const $FeatureFlagCheckResponse = {
    type: 'object',
    description: 'Serializer for feature flag check responses.',
    properties: {
        enabled: {
            type: 'boolean',
            description: 'Whether the feature flag is enabled'
        }
    },
    required: ['enabled']
} as const;

export const $Feedback = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        url: {
            type: 'string',
            maxLength: 255
        },
        user: {
            type: 'integer',
            readOnly: true,
            nullable: true
        },
        rating: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,1}(?:\\.\\d{0,1})?$'
        },
        feature: {
            '$ref': '#/components/schemas/FeatureEnum'
        },
        comment: {
            type: 'string'
        },
        related_data: {
            '$ref': '#/components/schemas/FeedbackRelatedData'
        }
    },
    required: ['created_at', 'feature', 'rating', 'related_data', 'url', 'user', 'uuid']
} as const;

export const $FeedbackRelatedData = {
    type: 'object',
    title: 'FeedbackRelatedData',
    properties: {
        document_generator: {
            '$ref': '#/components/schemas/DocumentGeneratorRelatedData',
            nullable: true
        },
        ai_chat: {
            '$ref': '#/components/schemas/AIChatRelatedData',
            nullable: true
        },
        ai_analysis: {
            '$ref': '#/components/schemas/AiAnalysisRelatedData',
            nullable: true
        },
        agent_action: {
            '$ref': '#/components/schemas/AgentActionRelatedData',
            nullable: true
        },
        case_lifecycle_state: {
            '$ref': '#/components/schemas/CaseLifecycleStateRelatedData',
            nullable: true
        }
    }
} as const;

export const $FeedbackRequest = {
    type: 'object',
    properties: {
        url: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        },
        rating: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,1}(?:\\.\\d{0,1})?$'
        },
        feature: {
            '$ref': '#/components/schemas/FeatureEnum'
        },
        comment: {
            type: 'string'
        },
        related_data: {
            '$ref': '#/components/schemas/FeedbackRelatedData'
        }
    },
    required: ['feature', 'rating', 'related_data', 'url']
} as const;

export const $FieldEnum = {
    enum: ['Allgemein', 'Arbeitsrecht', 'Asylrecht', 'Ausländerrecht', 'Bankrecht', 'Baurecht', 'Beamtenrecht', 'Bewertungen löschen', 'Casino', 'Coaching', 'Compliance', 'Corona Überbrückungshilfe', 'Datenleck', 'Erbrecht', 'Familienrecht', 'Gesellschaftsrecht', 'Gewerblicher Rechtsschutz/Urheberrecht', 'Hochschulrecht', 'Immobilienrecht', 'Inkasso', 'IT Recht', 'Insolvenzberatung', 'Markenrecht', 'Medien-und Presserecht', 'Medizinrecht', 'Mietrecht', 'Migrationsrecht', 'Musikrecht', 'Notariat', 'Personenschäden', 'Schufa', 'Schulrecht', 'Social Media Recht', 'Sozialrecht', 'Steuerberatung', 'Steuerrecht', 'Strafrecht', 'Tesla_Widerruf', 'Tierrecht', 'Verkehrsrecht', 'Versicherungsrecht', 'Verwaltungsrecht', 'Wegrecht', 'Zivilrecht'],
    type: 'string',
    description: `* \`Allgemein\` - Allgemein
* \`Arbeitsrecht\` - Arbeitsrecht
* \`Asylrecht\` - Asylrecht
* \`Ausländerrecht\` - Ausländerrecht
* \`Bankrecht\` - Bankrecht
* \`Baurecht\` - Baurecht
* \`Beamtenrecht\` - Beamtenrecht
* \`Bewertungen löschen\` - Bewertungen Löschen
* \`Casino\` - Casino
* \`Coaching\` - Coaching
* \`Compliance\` - Compliance
* \`Corona Überbrückungshilfe\` - Corona Überbrückungshilfe
* \`Datenleck\` - Datenleck
* \`Erbrecht\` - Erbrecht
* \`Familienrecht\` - Familienrecht
* \`Gesellschaftsrecht\` - Gesellschaftsrecht
* \`Gewerblicher Rechtsschutz/Urheberrecht\` - Gewerblicher Rechtsschutz/Urheberrecht
* \`Hochschulrecht\` - Hochschulrecht
* \`Immobilienrecht\` - Immobilienrecht
* \`Inkasso\` - Inkasso
* \`IT Recht\` - It Recht
* \`Insolvenzberatung\` - Insolvenzberatung
* \`Markenrecht\` - Markenrecht
* \`Medien-und Presserecht\` - Medien-Und Presserecht
* \`Medizinrecht\` - Medizinrecht
* \`Mietrecht\` - Mietrecht
* \`Migrationsrecht\` - Migrationsrecht
* \`Musikrecht\` - Musikrecht
* \`Notariat\` - Notariat
* \`Personenschäden\` - Personenschäden
* \`Schufa\` - Schufa
* \`Schulrecht\` - Schulrecht
* \`Social Media Recht\` - Social Media Recht
* \`Sozialrecht\` - Sozialrecht
* \`Steuerberatung\` - Steuerberatung
* \`Steuerrecht\` - Steuerrecht
* \`Strafrecht\` - Strafrecht
* \`Tesla_Widerruf\` - Tesla Widerruf
* \`Tierrecht\` - Tierrecht
* \`Verkehrsrecht\` - Verkehrsrecht
* \`Versicherungsrecht\` - Versicherungsrecht
* \`Verwaltungsrecht\` - Verwaltungsrecht
* \`Wegrecht\` - Wegrecht
* \`Zivilrecht\` - Zivilrecht`
} as const;

export const $FieldTypeEnum = {
    enum: ['multiselect', 'select', 'textarea', 'filefield', 'multifilefield', 'timefield', 'decimalnumberinput', 'datefield', 'textinput', 'numberinput', 'emailinput', 'phoneinput', 'urlinput', 'yesno'],
    type: 'string',
    description: `* \`multiselect\` - multiselect
* \`select\` - select
* \`textarea\` - textarea
* \`filefield\` - filefield
* \`multifilefield\` - multifilefield
* \`timefield\` - timefield
* \`decimalnumberinput\` - decimalnumberinput
* \`datefield\` - datefield
* \`textinput\` - textinput
* \`numberinput\` - numberinput
* \`emailinput\` - emailinput
* \`phoneinput\` - phoneinput
* \`urlinput\` - urlinput
* \`yesno\` - yesno`
} as const;

export const $FileDataRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        filename: {
            type: 'string',
            minLength: 1
        }
    },
    required: ['filename', 'uuid']
} as const;

export const $FileUploadRequest = {
    type: 'object',
    properties: {
        file: {
            type: 'string',
            format: 'binary'
        },
        page_index: {
            type: 'integer',
            minimum: 0
        },
        item_index: {
            type: 'integer',
            minimum: 0
        }
    },
    required: ['file', 'item_index', 'page_index']
} as const;

export const $FileUploadResponse = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        url: {
            type: 'string',
            format: 'uri'
        },
        filename: {
            type: 'string'
        },
        title: {
            type: 'string'
        },
        hash: {
            type: 'string'
        }
    },
    required: ['filename', 'hash', 'title', 'url', 'uuid']
} as const;

export const $FindWordDocumentTemplatePlaceholderValuesRequestRequest = {
    type: 'object',
    properties: {
        word_document_template_uuid: {
            type: 'string',
            format: 'uuid'
        }
    },
    required: ['word_document_template_uuid']
} as const;

export const $FindWordDocumentTemplatePlaceholderValuesResponse = {
    type: 'object',
    properties: {
        replaceable_variables: {
            allOf: [
                {
                    '$ref': '#/components/schemas/ReplaceableVariables'
                }
            ],
            readOnly: true
        }
    },
    required: ['replaceable_variables']
} as const;

export const $FlagEnum = {
    enum: ['ACTAPORT_V2_ENABLED', 'ACTAPORT_V2_TWO_WAY_SYNC', 'AGENTIC_WORKFLOWS', 'CASE_DETAIL_PAGE_V3_API', 'CLIENT_PORTAL_V3_API', 'ENABLE_INTERCOM_CHAT', 'GLOBAL_AI_CHAT', 'INCOMING_EMAIL_ENTITY_EXTRACTION_AGENT', 'NEW_ADMIN_QUESTIONNAIRE_EDITOR', 'NEW_PDF_EDITOR', 'OFFICE_DOCUMENT_EDITING', 'PDF_FORM_TEMPLATES', 'PDF_FORM_TEMPLATES_ADMIN', 'PREFLIGHT_DOCUMENT_EXTRACTION_AGENT', 'QUESTIONNAIRE_SELF_SERVICE', 'USE_AGENT_API', 'USE_POSTHOG_METRICS', 'USE_SEGMENT_METRICS'],
    type: 'string',
    description: `* \`ACTAPORT_V2_ENABLED\` - Actaport V2 Enabled
* \`ACTAPORT_V2_TWO_WAY_SYNC\` - Actaport V2 Two Way Sync
* \`AGENTIC_WORKFLOWS\` - Agentic Workflows
* \`CASE_DETAIL_PAGE_V3_API\` - Case Detail Page V3 Api
* \`CLIENT_PORTAL_V3_API\` - Client Portal V3 Api
* \`ENABLE_INTERCOM_CHAT\` - Enable Intercom Chat
* \`GLOBAL_AI_CHAT\` - Global Ai Chat
* \`INCOMING_EMAIL_ENTITY_EXTRACTION_AGENT\` - Incoming Email Entity Extraction Agent
* \`NEW_ADMIN_QUESTIONNAIRE_EDITOR\` - New Admin Questionnaire Editor
* \`NEW_PDF_EDITOR\` - New Pdf Editor
* \`OFFICE_DOCUMENT_EDITING\` - Office Document Editing
* \`PDF_FORM_TEMPLATES\` - Pdf Form Templates
* \`PDF_FORM_TEMPLATES_ADMIN\` - Pdf Form Templates Admin
* \`PREFLIGHT_DOCUMENT_EXTRACTION_AGENT\` - Preflight Document Extraction Agent
* \`QUESTIONNAIRE_SELF_SERVICE\` - Questionnaire Self Service
* \`USE_AGENT_API\` - Use Agent Api
* \`USE_POSTHOG_METRICS\` - Use Posthog Metrics
* \`USE_SEGMENT_METRICS\` - Use Segment Metrics`
} as const;

export const $FormField = {
    type: 'object',
    description: 'Serializer for individual form fields.',
    properties: {
        uuid: {
            type: 'string'
        },
        type: {
            '$ref': '#/components/schemas/FormFieldTypeEnum'
        },
        tag: {
            type: 'string',
            nullable: true
        },
        tag_relationship: {
            nullable: true,
            oneOf: [
                {
                    '$ref': '#/components/schemas/TagRelationshipEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                },
                {
                    '$ref': '#/components/schemas/NullEnum'
                }
            ]
        },
        placeholder: {
            type: 'string'
        },
        required: {
            type: 'boolean'
        },
        assigned_to: {
            '$ref': '#/components/schemas/AssignedToEnum'
        },
        coordinates: {
            '$ref': '#/components/schemas/FormFieldCoordinates'
        }
    },
    required: ['assigned_to', 'coordinates', 'required', 'type']
} as const;

export const $FormFieldCoordinates = {
    type: 'object',
    description: 'Serializer for form field coordinates.',
    properties: {
        x: {
            type: 'number',
            format: 'double'
        },
        y: {
            type: 'number',
            format: 'double'
        },
        width: {
            type: 'number',
            format: 'double'
        },
        height: {
            type: 'number',
            format: 'double'
        },
        page: {
            type: 'integer',
            minimum: 1
        }
    },
    required: ['height', 'page', 'width', 'x', 'y']
} as const;

export const $FormFieldCoordinatesRequest = {
    type: 'object',
    description: 'Serializer for form field coordinates.',
    properties: {
        x: {
            type: 'number',
            format: 'double'
        },
        y: {
            type: 'number',
            format: 'double'
        },
        width: {
            type: 'number',
            format: 'double'
        },
        height: {
            type: 'number',
            format: 'double'
        },
        page: {
            type: 'integer',
            minimum: 1
        }
    },
    required: ['height', 'page', 'width', 'x', 'y']
} as const;

export const $FormFieldRequest = {
    type: 'object',
    description: 'Serializer for individual form fields.',
    properties: {
        uuid: {
            type: 'string',
            minLength: 1
        },
        type: {
            '$ref': '#/components/schemas/FormFieldTypeEnum'
        },
        tag: {
            type: 'string',
            nullable: true
        },
        tag_relationship: {
            nullable: true,
            oneOf: [
                {
                    '$ref': '#/components/schemas/TagRelationshipEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                },
                {
                    '$ref': '#/components/schemas/NullEnum'
                }
            ]
        },
        placeholder: {
            type: 'string'
        },
        required: {
            type: 'boolean'
        },
        assigned_to: {
            '$ref': '#/components/schemas/AssignedToEnum'
        },
        coordinates: {
            '$ref': '#/components/schemas/FormFieldCoordinatesRequest'
        }
    },
    required: ['assigned_to', 'coordinates', 'required', 'type']
} as const;

export const $FormFieldTypeEnum = {
    enum: ['textinput', 'textarea', 'datefield', 'checkbox', 'signature'],
    type: 'string',
    description: `* \`textinput\` - Text
* \`textarea\` - Textarea
* \`datefield\` - Date
* \`checkbox\` - Checkbox
* \`signature\` - Signature`
} as const;

export const $FormTag = {
    enum: ['MASTER', 'PREFILLED', 'SIGNED'],
    type: 'string',
    description: `* \`MASTER\` - Master
* \`PREFILLED\` - Prefilled
* \`SIGNED\` - Signed`
} as const;

export const $Forward = {
    type: 'object',
    properties: {
        rule_uuid: {
            type: 'string',
            format: 'uuid',
            description: 'UUID of the forwarding rule that was applied'
        },
        status: {
            allOf: [
                {
                    '$ref': '#/components/schemas/ForwardStatusEnum'
                }
            ],
            description: `Status of the forwarding attempt

* \`succeeded\` - Succeeded
* \`failed\` - Failed`
        },
        reason: {
            type: 'string',
            description: 'Reason for the forwarding status (success details or failure reason)'
        }
    },
    required: ['reason', 'rule_uuid', 'status']
} as const;

export const $ForwardRequest = {
    type: 'object',
    properties: {
        rule_uuid: {
            type: 'string',
            format: 'uuid',
            description: 'UUID of the forwarding rule that was applied'
        },
        status: {
            allOf: [
                {
                    '$ref': '#/components/schemas/ForwardStatusEnum'
                }
            ],
            description: `Status of the forwarding attempt

* \`succeeded\` - Succeeded
* \`failed\` - Failed`
        },
        reason: {
            type: 'string',
            minLength: 1,
            description: 'Reason for the forwarding status (success details or failure reason)'
        }
    },
    required: ['reason', 'rule_uuid', 'status']
} as const;

export const $ForwardStatusEnum = {
    enum: ['succeeded', 'failed'],
    type: 'string',
    description: `* \`succeeded\` - Succeeded
* \`failed\` - Failed`
} as const;

export const $GenerateDocumentChatRequest = {
    type: 'object',
    properties: {
        role: {
            '$ref': '#/components/schemas/GenerateDocumentChatRoleEnum'
        },
        content: {
            type: 'string',
            minLength: 1
        },
        is_template: {
            type: 'boolean'
        }
    },
    required: ['content', 'is_template', 'role']
} as const;

export const $GenerateDocumentChatRoleEnum = {
    enum: ['system', 'user', 'assistant'],
    type: 'string',
    description: `* \`system\` - System
* \`user\` - User
* \`assistant\` - Assistant`
} as const;

export const $GenerateDocumentRequestRequest = {
    type: 'object',
    properties: {
        document_template_uuid: {
            type: 'string',
            format: 'uuid'
        },
        chat: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/GenerateDocumentChatRequest'
            }
        }
    },
    required: ['chat', 'document_template_uuid']
} as const;

export const $GenerateDocumentResponse = {
    type: 'object',
    description: 'Serializer for generate document response.',
    properties: {
        document_blob: {
            type: 'string'
        },
        filename: {
            type: 'string'
        },
        validation_data: {}
    },
    required: ['document_blob', 'filename', 'validation_data']
} as const;

export const $GenerateTitleRequestRequest = {
    type: 'object',
    description: 'Serializer for generating a title for a chat preference.',
    properties: {
        content: {
            type: 'string',
            minLength: 1
        }
    },
    required: ['content']
} as const;

export const $GenerateTitleResponse = {
    type: 'object',
    description: 'Response serializer for AI title generation.',
    properties: {
        suggested_title: {
            type: 'string',
            maxLength: 255
        },
        confidence: {
            type: 'number',
            format: 'double'
        }
    },
    required: ['confidence', 'suggested_title']
} as const;

export const $GenerateTitleWithStateRequestRequest = {
    type: 'object',
    description: 'Request serializer for AI title generation with current document state.',
    properties: {
        current_organization_state: {
            allOf: [
                {
                    '$ref': '#/components/schemas/DocumentOrganizationStateRequest'
                }
            ],
            description: 'Current state of document groups in the frontend'
        },
        document_group_name: {
            type: 'string',
            minLength: 1,
            description: 'Name of the specific document group to generate title for',
            maxLength: 255
        }
    }
} as const;

export const $GenericDataMapper = {
    type: 'object',
    properties: {
        key: {
            '$ref': '#/components/schemas/AiAugmentedByMapperKeysEnum'
        },
        label: {
            type: 'string'
        },
        field_type: {
            '$ref': '#/components/schemas/FieldTypeEnum'
        },
        choices: {
            type: 'array',
            items: {
                type: 'string'
            }
        },
        is_law_specific_field: {
            type: 'boolean'
        },
        is_entity_field: {
            type: 'boolean'
        },
        law_field: {
            '$ref': '#/components/schemas/LawFieldEnum'
        },
        max_length: {
            type: 'integer',
            nullable: true
        },
        is_nullable: {
            type: 'boolean'
        },
        default: {
            oneOf: [
                {
                    type: 'string'
                },
                {
                    type: 'integer'
                },
                {
                    type: 'boolean'
                },
                {
                    type: 'string',
                    format: 'date'
                },
                {
                    type: 'object',
                    additionalProperties: {}
                },
                {
                    type: 'array',
                    items: {}
                }
            ]
        },
        starts_ai_analysis: {
            type: 'boolean'
        },
        ai_augments_mapper_keys: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/AiAugmentedByMapperKeysEnum'
            }
        },
        ai_augmented_by_mapper_keys: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/AiAugmentedByMapperKeysEnum'
            }
        }
    },
    required: ['default', 'field_type', 'is_entity_field', 'is_law_specific_field', 'is_nullable', 'key', 'label', 'starts_ai_analysis']
} as const;

export const $GenericDataMapperRequest = {
    type: 'object',
    properties: {
        key: {
            '$ref': '#/components/schemas/AiAugmentedByMapperKeysEnum'
        },
        label: {
            type: 'string',
            minLength: 1
        },
        field_type: {
            '$ref': '#/components/schemas/FieldTypeEnum'
        },
        choices: {
            type: 'array',
            items: {
                type: 'string',
                minLength: 1
            }
        },
        is_law_specific_field: {
            type: 'boolean'
        },
        is_entity_field: {
            type: 'boolean'
        },
        law_field: {
            '$ref': '#/components/schemas/LawFieldEnum'
        },
        max_length: {
            type: 'integer',
            nullable: true
        },
        is_nullable: {
            type: 'boolean'
        },
        default: {
            oneOf: [
                {
                    type: 'string'
                },
                {
                    type: 'integer'
                },
                {
                    type: 'boolean'
                },
                {
                    type: 'string',
                    format: 'date'
                },
                {
                    type: 'object',
                    additionalProperties: {}
                },
                {
                    type: 'array',
                    items: {}
                }
            ]
        },
        starts_ai_analysis: {
            type: 'boolean'
        },
        ai_augments_mapper_keys: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/AiAugmentedByMapperKeysEnum'
            }
        },
        ai_augmented_by_mapper_keys: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/AiAugmentedByMapperKeysEnum'
            }
        }
    },
    required: ['default', 'field_type', 'is_entity_field', 'is_law_specific_field', 'is_nullable', 'key', 'label', 'starts_ai_analysis']
} as const;

export const $GenericMetricEvent = {
    type: 'object',
    description: 'Serializer for generic metric events from frontend.',
    properties: {
        event_name: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EventNameEnum'
                }
            ],
            description: `Name of the event to track

* \`Logout\` - Logout
* \`Login\` - Login
* \`Bot Display\` - Bot Display
* \`Bot Session Started\` - Bot Session Started
* \`Bot Session Ended\` - Bot Session Ended
* \`Questionnaire Sent\` - Questionnaire Sent
* \`Questionnaire Completed\` - Questionnaire Completed
* \`PDFDocument Sent\` - Form Sent
* \`PDFDocument Completed\` - Form Completed
* \`Email Sent\` - Email Sent
* \`Email Received\` - Email Received
* \`Email Template Edited\` - Email Template Edited
* \`Case Created\` - Case Created
* \`Case Rejected\` - Case Rejected
* \`Case Accepted\` - Case Completed
* \`Case In Progress\` - Case In Progress
* \`Case Deleted\` - Case Deleted
* \`Case Exported\` - Case Exported
* \`Calculator Opened\` - Calculator Opened
* \`Calculator Saved\` - Calculator Saved
* \`Appointment Account Authorized\` - Appointment Account Authorized
* \`Appointment Account Revoked\` - Appointment Account Revoked
* \`Appointment Service Created\` - Appointment Service Created
* \`Appointment Service Edited\` - Appointment Service Edited
* \`Appointment Service Enabled\` - Appointment Service Enabled
* \`Appointment Service Disabled\` - Appointment Service Disabled
* \`Appointment Service Soft Deleted\` - Appointment Service Soft Deleted
* \`Appointment Service Recovered\` - Appointment Service Recovered
* \`Appointment Calendar Created\` - Appointment Calendar Created
* \`Appointment Calendar Edited\` - Appointment Calendar Edited
* \`Appointment Calendar Enabled\` - Appointment Calendar Enabled
* \`Appointment Calendar Disabled\` - Appointment Calendar Disabled
* \`Appointment Lawfields Edited\` - Appointment Lawfields Edited
* \`Appointment Setup Completed\` - Appointment Setup Completed
* \`Appointment Created\` - Appointment Created
* \`Appointment Proposal Created\` - Appointment Proposal Created
* \`Appointment Settings Edited\` - Appointment Settings Edited
* \`Call Started\` - Call Started
* \`Call Ended\` - Call Ended
* \`Call Automated Rating Received\` - Call Automated Rating
* \`Call Human Rating Received\` - Call Human Rating
* \`Call Lawer Rating Received\` - Call Lawer Rating
* \`Phone Forwarding Rule Created\` - Phone Forwarding Rule Created
* \`Phone Forwarding Rule Updated\` - Phone Forwarding Rule Updated
* \`Entity Extraction Instructions Set\` - Entity Extraction Instructions Set
* \`AI Token Used\` - Ai Token Used
* \`AI Embedding Token Used\` - Ai Embedding Token Used
* \`AI Function Voice Call Used\` - Ai Function Voice Call Used
* \`AI Function Document Analysis Used\` - Ai Function Document Analysis Used
* \`AI Function Document Title Generation Used\` - Ai Function Document Title Generation Used
* \`AI Function Questionnaire Title Generation Used\` - Ai Function Questionnaire Title Generation Used
* \`AI Function Email Extraction Used\` - Ai Function Email Extraction Used
* \`AI Function Gender Detection Used\` - Ai Function Gender Detection Used
* \`AI Function Document Type Classification Used\` - Ai Function Document Type Classification Used
* \`AI Function Document Analysis Entity Classification Used\` - Ai Function Document Analysis Entity Classification Used
* \`AI Function Document Generation Used\` - Ai Function Document Generation Used
* \`AI Function Inquiry Summary Used\` - Ai Function Inquiry Summary Used
* \`AI Function Used Case Chat\` - Ai Function Used Case Chat
* \`AI Function Used Update Case Chat Document Context\` - Ai Function Used Update Case Chat Document Context
* \`AI Function Used Update Case Chat Document Context Alternative Queries\` - Ai Function Used Update Case Chat Document Context Alternative Queries
* \`AI Function Used Update Case Chat Document Context Alternative Queries Create Embeddings\` - Ai Function Used Update Case Chat Document Context Alternative Queries Create Embeddings
* \`AI Function Case Create Document Entities Extraction Used\` - Ai Function Case Create Document Entities Extraction Used
* \`AI Function Universal Entity Extraction Used\` - Ai Function Universal Entity Extraction Used
* \`AI Function Document Template Generation Used\` - Ai Function Document Template Generation Used
* \`User Feedback\` - User Feedback
* \`Help Link Clicked\` - Help Link Clicked
* \`AI Function Document Summarization Used\` - Ai Function Document Summarization Used
* \`AI Function Document Raptor Summarization Used\` - Ai Function Document Raptor Summarization Used
* \`AI Function Used Rate AI Chat Session\` - Ai Function Used Rate Ai Chat Session
* \`AI Chat Session Rating\` - Ai Chat Session Rating
* \`AI Chat Session Human Rating\` - Ai Chat Session Human Rating
* \`Global AI Chat Folder Created\` - Global Ai Chat Folder Created
* \`Global AI Chat Folder Updated\` - Global Ai Chat Folder Updated
* \`Global AI Chat Folder Deleted\` - Global Ai Chat Folder Deleted
* \`Global AI Chat Session Created\` - Global Ai Chat Session Created
* \`Global AI Chat Session Deleted\` - Global Ai Chat Session Deleted
* \`Global AI Chat Visited\` - Global Ai Chat Visited
* \`AI Function Used Global Chat\` - Ai Function Used Global Chat
* \`Global Chat Case Specific Info Requested\` - Global Chat Case Specific Info Requested
* \`AI Function Template Description Generation Used\` - Ai Function Template Description Generation Used
* \`AI Function Memory Title Generation Used\` - Ai Function Memory Title Generation Used
* \`AI Function Used Chat Memory Embedding\` - Ai Function Used Chat Memory Embedding
* \`AI Function Used Chat Memory Importance Evaluation\` - Ai Function Used Chat Memory Importance
* \`AI Function Used Rate Memory Evaluation\` - Ai Function Used Rate Memory Evaluation
* \`AI Function Used Prompt Enhancement\` - Ai Function Used Prompt Enhancement
* \`AI Function Used Preference Suggestion Analysis\` - Ai Function Used Preference Suggestion Analysis
* \`AI Function Used Feedback Preference Suggestion\` - Ai Function Used Feedback Preference Suggestion
* \`AI Function Used Chat Preference Embedding\` - Ai Function Used Chat Preference Embedding
* \`AI Function Used Chat Preference Importance Evaluation\` - Ai Function Used Chat Preference Importance
* \`Snippet Button Clicked in Document Generator\` - Snippet Button Clicked In Document Generator
* \`Snippet Selected in Document Generator\` - Snippet Selected In Document Generator
* \`Document Metadata Enrichment Started\` - Document Metadata Enrichment Started
* \`Document Metadata Enrichment Finished\` - Document Metadata Enrichment Finished
* \`Document Metadata Enrichment Retry\` - Document Metadata Enrichment Retry
* \`Document OCR Started\` - Document Ocr Started
* \`Document OCR Finished\` - Document Ocr Finished
* \`Document Embeddings Started\` - Document Embeddings Started
* \`Document Embeddings Finished\` - Document Embeddings Finished
* \`Document Summary Started\` - Document Summary Started
* \`Document Summary Finished\` - Document Summary Finished
* \`Document Analysis Started\` - Document Analysis Started
* \`Document Analysis Finished\` - Document Analysis Finished
* \`Document Entity Extraction Started\` - Document Entity Extraction Started
* \`Document Entity Extraction Finished\` - Document Entity Extraction Finished
* \`Document Raptor Summaries Started\` - Document Raptor Summaries Started
* \`Document Raptor Summaries Finished\` - Document Raptor Summaries Finished
* \`Document Inline Edit Started\` - Document Inline Edit Started
* \`Document Rename AI Clicked\` - Document Rename Ai Clicked
* \`Document Rename AI Completed\` - Document Rename Ai Completed
* \`Document Rename AI Failed\` - Document Rename Ai Failed
* \`Document Rename Saved\` - Document Rename Saved
* \`Document Rename Cancelled\` - Document Rename Cancelled
* \`Document Preview Opened\` - Document Preview Opened
* \`Document Preview Closed\` - Document Preview Closed
* \`Document Downloaded\` - Document Downloaded
* \`Document Deleted\` - Document Deleted
* \`Document Organize Pages Opened\` - Document Organize Pages Opened
* \`Documents Bulk Selected\` - Documents Bulk Selected
* \`Documents Bulk Deselected\` - Documents Bulk Deselected
* \`Documents Bulk Rename Started\` - Documents Bulk Rename Started
* \`Documents Bulk Rename Completed\` - Documents Bulk Rename Completed
* \`Documents Bulk Rename Failed\` - Documents Bulk Rename Failed
* \`Documents Bulk Merge Started\` - Documents Bulk Merge Started
* \`Documents Bulk Download Started\` - Documents Bulk Download Started
* \`Documents Bulk Download Completed\` - Documents Bulk Download Completed
* \`Documents Bulk Download Failed\` - Documents Bulk Download Failed
* \`Documents Bulk Delete Started\` - Documents Bulk Delete Started
* \`Documents Bulk Delete Completed\` - Documents Bulk Delete Completed
* \`Documents Bulk Delete Failed\` - Documents Bulk Delete Failed
* \`PDF Organize View Opened\` - Pdf Organize View Opened
* \`PDF Organize View Closed\` - Pdf Organize View Closed
* \`PDF Organize Changes Saved\` - Pdf Organize Changes Saved
* \`PDF Organize Changes Discarded\` - Pdf Organize Changes Discarded
* \`PDF Organize Download Started\` - Pdf Organize Download Started
* \`PDF Organize Download Completed\` - Pdf Organize Download Completed
* \`PDF Organize Download Failed\` - Pdf Organize Download Failed
* \`PDF Document Merged\` - Pdf Document Merged
* \`PDF Documents Merged All\` - Pdf Documents Merged All
* \`PDF Document Split Manual\` - Pdf Document Split Manual
* \`PDF Document Split AI Started\` - Pdf Document Split Ai Started
* \`PDF Document Split AI Completed\` - Pdf Document Split Ai Completed
* \`PDF Document Split AI Failed\` - Pdf Document Split Ai Failed
* \`PDF Document Duplicated\` - Pdf Document Duplicated
* \`PDF Document Group Deleted\` - Pdf Document Group Deleted
* \`PDF Document Group Created\` - Pdf Document Group Created
* \`PDF Document Group Renamed\` - Pdf Document Group Renamed
* \`PDF Document Title AI Generated\` - Pdf Document Title Ai Generated
* \`PDF Pages Moved\` - Pdf Pages Moved
* \`PDF Pages Deleted\` - Pdf Pages Deleted
* \`PDF Pages Rotated\` - Pdf Pages Rotated
* \`PDF Pages Reordered\` - Pdf Pages Reordered
* \`PDF Pages Merged\` - Pdf Pages Merged
* \`PDF Add Documents Opened\` - Pdf Add Documents Opened
* \`PDF Documents Added\` - Pdf Documents Added
* \`PDF Viewer Edit Page Clicked\` - Pdf Viewer Edit Page Clicked
* \`PDF Viewer Organize Pages Clicked\` - Pdf Viewer Organize Pages Clicked
* \`PDF Viewer Download Clicked\` - Pdf Viewer Download Clicked
* \`PDF Viewer Reset Edits Started\` - Pdf Viewer Reset Edits Started
* \`PDF Viewer Reset Edits Completed\` - Pdf Viewer Reset Edits Completed
* \`PDF Viewer Reset Edits Cancelled\` - Pdf Viewer Reset Edits Cancelled
* \`Image Editor Opened\` - Image Editor Opened
* \`Image Editor Closed\` - Image Editor Closed
* \`Image Editor Mode Changed\` - Image Editor Mode Changed
* \`Image Editor Changes Applied\` - Image Editor Changes Applied
* \`Image Editor Changes Discarded\` - Image Editor Changes Discarded
* \`Image Editor Crop Region Added\` - Image Editor Crop Region Added
* \`Image Editor Crop Region Removed\` - Image Editor Crop Region Removed
* \`Image Editor Crop Applied\` - Image Editor Crop Applied
* \`Image Editor Crop Reset\` - Image Editor Crop Reset
* \`Image Editor Rotated\` - Image Editor Rotated
* \`Image Editor Rotation Reset\` - Image Editor Rotation Reset
* \`Image Editor Adjustment Changed\` - Image Editor Adjustment Changed
* \`Image Editor Adjustments Reset\` - Image Editor Adjustments Reset
* \`Image Editor Trim Applied\` - Image Editor Trim Applied
* \`Image Editor Trim Reset\` - Image Editor Trim Reset
* \`Actaport Document Imported\` - Actaport Document Imported
* \`Actaport Document Import Failed\` - Actaport Document Import Failed
* \`Actaport Document Exported\` - Actaport Document Exported
* \`Actaport Document Export Failed\` - Actaport Document Export Failed
* \`Actaport Documents Refresh\` - Actaport Documents Refresh
* \`Actaport API Rate Limit Hit\` - Actaport Api Rate Limit Hit
* \`PDF Form Template Created\` - Pdf Form Template Created
* \`PDF Form Template Duplicated\` - Pdf Form Template Duplicated
* \`PDF Form Template Updated\` - Pdf Form Template Updated
* \`PDF Form Template Deleted\` - Pdf Form Template Deleted
* \`PDF Form Template Edit Started\` - Pdf Form Template Edit Started
* \`PDF Form Template Edit Saved\` - Pdf Form Template Edit Saved
* \`PDF Form Template Edit Abandoned\` - Pdf Form Template Edit Abandoned
* \`PDF Form Template Field Added\` - Pdf Form Template Field Added
* \`PDF Form Template Field Removed\` - Pdf Form Template Field Removed
* \`PDF Form Template Previewed\` - Pdf Form Template Previewed
* \`PDF Form Template Used\` - Pdf Form Template Used
* \`PDF Form Submission Created\` - Pdf Form Submission Created
* \`PDF Form Submission Completed\` - Pdf Form Submission Completed
* \`PDF Form Submission Sent\` - Pdf Form Submission Sent
* \`PDF Form Flattened\` - Pdf Form Flattened
* \`Self Questionnaire Created\` - Self Questionnaire Created
* \`Self Questionnaire Updated\` - Self Questionnaire Updated
* \`Self Questionnaire Published\` - Self Questionnaire Published
* \`Self Questionnaire AI Generated\` - Self Questionnaire Ai Generated
* \`Self Questionnaire Copy\` - Self Questionnaire Copy
* \`Self Questionnaire Submission Partial Updated\` - Self Questionnaire Submission Partial Updated
* \`Self Questionnaire Submission Completed\` - Self Questionnaire Submission Completed`
        },
        properties: {
            description: 'Additional properties for the event'
        }
    },
    required: ['event_name']
} as const;

export const $GenericMetricEventRequest = {
    type: 'object',
    description: 'Serializer for generic metric events from frontend.',
    properties: {
        event_name: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EventNameEnum'
                }
            ],
            description: `Name of the event to track

* \`Logout\` - Logout
* \`Login\` - Login
* \`Bot Display\` - Bot Display
* \`Bot Session Started\` - Bot Session Started
* \`Bot Session Ended\` - Bot Session Ended
* \`Questionnaire Sent\` - Questionnaire Sent
* \`Questionnaire Completed\` - Questionnaire Completed
* \`PDFDocument Sent\` - Form Sent
* \`PDFDocument Completed\` - Form Completed
* \`Email Sent\` - Email Sent
* \`Email Received\` - Email Received
* \`Email Template Edited\` - Email Template Edited
* \`Case Created\` - Case Created
* \`Case Rejected\` - Case Rejected
* \`Case Accepted\` - Case Completed
* \`Case In Progress\` - Case In Progress
* \`Case Deleted\` - Case Deleted
* \`Case Exported\` - Case Exported
* \`Calculator Opened\` - Calculator Opened
* \`Calculator Saved\` - Calculator Saved
* \`Appointment Account Authorized\` - Appointment Account Authorized
* \`Appointment Account Revoked\` - Appointment Account Revoked
* \`Appointment Service Created\` - Appointment Service Created
* \`Appointment Service Edited\` - Appointment Service Edited
* \`Appointment Service Enabled\` - Appointment Service Enabled
* \`Appointment Service Disabled\` - Appointment Service Disabled
* \`Appointment Service Soft Deleted\` - Appointment Service Soft Deleted
* \`Appointment Service Recovered\` - Appointment Service Recovered
* \`Appointment Calendar Created\` - Appointment Calendar Created
* \`Appointment Calendar Edited\` - Appointment Calendar Edited
* \`Appointment Calendar Enabled\` - Appointment Calendar Enabled
* \`Appointment Calendar Disabled\` - Appointment Calendar Disabled
* \`Appointment Lawfields Edited\` - Appointment Lawfields Edited
* \`Appointment Setup Completed\` - Appointment Setup Completed
* \`Appointment Created\` - Appointment Created
* \`Appointment Proposal Created\` - Appointment Proposal Created
* \`Appointment Settings Edited\` - Appointment Settings Edited
* \`Call Started\` - Call Started
* \`Call Ended\` - Call Ended
* \`Call Automated Rating Received\` - Call Automated Rating
* \`Call Human Rating Received\` - Call Human Rating
* \`Call Lawer Rating Received\` - Call Lawer Rating
* \`Phone Forwarding Rule Created\` - Phone Forwarding Rule Created
* \`Phone Forwarding Rule Updated\` - Phone Forwarding Rule Updated
* \`Entity Extraction Instructions Set\` - Entity Extraction Instructions Set
* \`AI Token Used\` - Ai Token Used
* \`AI Embedding Token Used\` - Ai Embedding Token Used
* \`AI Function Voice Call Used\` - Ai Function Voice Call Used
* \`AI Function Document Analysis Used\` - Ai Function Document Analysis Used
* \`AI Function Document Title Generation Used\` - Ai Function Document Title Generation Used
* \`AI Function Questionnaire Title Generation Used\` - Ai Function Questionnaire Title Generation Used
* \`AI Function Email Extraction Used\` - Ai Function Email Extraction Used
* \`AI Function Gender Detection Used\` - Ai Function Gender Detection Used
* \`AI Function Document Type Classification Used\` - Ai Function Document Type Classification Used
* \`AI Function Document Analysis Entity Classification Used\` - Ai Function Document Analysis Entity Classification Used
* \`AI Function Document Generation Used\` - Ai Function Document Generation Used
* \`AI Function Inquiry Summary Used\` - Ai Function Inquiry Summary Used
* \`AI Function Used Case Chat\` - Ai Function Used Case Chat
* \`AI Function Used Update Case Chat Document Context\` - Ai Function Used Update Case Chat Document Context
* \`AI Function Used Update Case Chat Document Context Alternative Queries\` - Ai Function Used Update Case Chat Document Context Alternative Queries
* \`AI Function Used Update Case Chat Document Context Alternative Queries Create Embeddings\` - Ai Function Used Update Case Chat Document Context Alternative Queries Create Embeddings
* \`AI Function Case Create Document Entities Extraction Used\` - Ai Function Case Create Document Entities Extraction Used
* \`AI Function Universal Entity Extraction Used\` - Ai Function Universal Entity Extraction Used
* \`AI Function Document Template Generation Used\` - Ai Function Document Template Generation Used
* \`User Feedback\` - User Feedback
* \`Help Link Clicked\` - Help Link Clicked
* \`AI Function Document Summarization Used\` - Ai Function Document Summarization Used
* \`AI Function Document Raptor Summarization Used\` - Ai Function Document Raptor Summarization Used
* \`AI Function Used Rate AI Chat Session\` - Ai Function Used Rate Ai Chat Session
* \`AI Chat Session Rating\` - Ai Chat Session Rating
* \`AI Chat Session Human Rating\` - Ai Chat Session Human Rating
* \`Global AI Chat Folder Created\` - Global Ai Chat Folder Created
* \`Global AI Chat Folder Updated\` - Global Ai Chat Folder Updated
* \`Global AI Chat Folder Deleted\` - Global Ai Chat Folder Deleted
* \`Global AI Chat Session Created\` - Global Ai Chat Session Created
* \`Global AI Chat Session Deleted\` - Global Ai Chat Session Deleted
* \`Global AI Chat Visited\` - Global Ai Chat Visited
* \`AI Function Used Global Chat\` - Ai Function Used Global Chat
* \`Global Chat Case Specific Info Requested\` - Global Chat Case Specific Info Requested
* \`AI Function Template Description Generation Used\` - Ai Function Template Description Generation Used
* \`AI Function Memory Title Generation Used\` - Ai Function Memory Title Generation Used
* \`AI Function Used Chat Memory Embedding\` - Ai Function Used Chat Memory Embedding
* \`AI Function Used Chat Memory Importance Evaluation\` - Ai Function Used Chat Memory Importance
* \`AI Function Used Rate Memory Evaluation\` - Ai Function Used Rate Memory Evaluation
* \`AI Function Used Prompt Enhancement\` - Ai Function Used Prompt Enhancement
* \`AI Function Used Preference Suggestion Analysis\` - Ai Function Used Preference Suggestion Analysis
* \`AI Function Used Feedback Preference Suggestion\` - Ai Function Used Feedback Preference Suggestion
* \`AI Function Used Chat Preference Embedding\` - Ai Function Used Chat Preference Embedding
* \`AI Function Used Chat Preference Importance Evaluation\` - Ai Function Used Chat Preference Importance
* \`Snippet Button Clicked in Document Generator\` - Snippet Button Clicked In Document Generator
* \`Snippet Selected in Document Generator\` - Snippet Selected In Document Generator
* \`Document Metadata Enrichment Started\` - Document Metadata Enrichment Started
* \`Document Metadata Enrichment Finished\` - Document Metadata Enrichment Finished
* \`Document Metadata Enrichment Retry\` - Document Metadata Enrichment Retry
* \`Document OCR Started\` - Document Ocr Started
* \`Document OCR Finished\` - Document Ocr Finished
* \`Document Embeddings Started\` - Document Embeddings Started
* \`Document Embeddings Finished\` - Document Embeddings Finished
* \`Document Summary Started\` - Document Summary Started
* \`Document Summary Finished\` - Document Summary Finished
* \`Document Analysis Started\` - Document Analysis Started
* \`Document Analysis Finished\` - Document Analysis Finished
* \`Document Entity Extraction Started\` - Document Entity Extraction Started
* \`Document Entity Extraction Finished\` - Document Entity Extraction Finished
* \`Document Raptor Summaries Started\` - Document Raptor Summaries Started
* \`Document Raptor Summaries Finished\` - Document Raptor Summaries Finished
* \`Document Inline Edit Started\` - Document Inline Edit Started
* \`Document Rename AI Clicked\` - Document Rename Ai Clicked
* \`Document Rename AI Completed\` - Document Rename Ai Completed
* \`Document Rename AI Failed\` - Document Rename Ai Failed
* \`Document Rename Saved\` - Document Rename Saved
* \`Document Rename Cancelled\` - Document Rename Cancelled
* \`Document Preview Opened\` - Document Preview Opened
* \`Document Preview Closed\` - Document Preview Closed
* \`Document Downloaded\` - Document Downloaded
* \`Document Deleted\` - Document Deleted
* \`Document Organize Pages Opened\` - Document Organize Pages Opened
* \`Documents Bulk Selected\` - Documents Bulk Selected
* \`Documents Bulk Deselected\` - Documents Bulk Deselected
* \`Documents Bulk Rename Started\` - Documents Bulk Rename Started
* \`Documents Bulk Rename Completed\` - Documents Bulk Rename Completed
* \`Documents Bulk Rename Failed\` - Documents Bulk Rename Failed
* \`Documents Bulk Merge Started\` - Documents Bulk Merge Started
* \`Documents Bulk Download Started\` - Documents Bulk Download Started
* \`Documents Bulk Download Completed\` - Documents Bulk Download Completed
* \`Documents Bulk Download Failed\` - Documents Bulk Download Failed
* \`Documents Bulk Delete Started\` - Documents Bulk Delete Started
* \`Documents Bulk Delete Completed\` - Documents Bulk Delete Completed
* \`Documents Bulk Delete Failed\` - Documents Bulk Delete Failed
* \`PDF Organize View Opened\` - Pdf Organize View Opened
* \`PDF Organize View Closed\` - Pdf Organize View Closed
* \`PDF Organize Changes Saved\` - Pdf Organize Changes Saved
* \`PDF Organize Changes Discarded\` - Pdf Organize Changes Discarded
* \`PDF Organize Download Started\` - Pdf Organize Download Started
* \`PDF Organize Download Completed\` - Pdf Organize Download Completed
* \`PDF Organize Download Failed\` - Pdf Organize Download Failed
* \`PDF Document Merged\` - Pdf Document Merged
* \`PDF Documents Merged All\` - Pdf Documents Merged All
* \`PDF Document Split Manual\` - Pdf Document Split Manual
* \`PDF Document Split AI Started\` - Pdf Document Split Ai Started
* \`PDF Document Split AI Completed\` - Pdf Document Split Ai Completed
* \`PDF Document Split AI Failed\` - Pdf Document Split Ai Failed
* \`PDF Document Duplicated\` - Pdf Document Duplicated
* \`PDF Document Group Deleted\` - Pdf Document Group Deleted
* \`PDF Document Group Created\` - Pdf Document Group Created
* \`PDF Document Group Renamed\` - Pdf Document Group Renamed
* \`PDF Document Title AI Generated\` - Pdf Document Title Ai Generated
* \`PDF Pages Moved\` - Pdf Pages Moved
* \`PDF Pages Deleted\` - Pdf Pages Deleted
* \`PDF Pages Rotated\` - Pdf Pages Rotated
* \`PDF Pages Reordered\` - Pdf Pages Reordered
* \`PDF Pages Merged\` - Pdf Pages Merged
* \`PDF Add Documents Opened\` - Pdf Add Documents Opened
* \`PDF Documents Added\` - Pdf Documents Added
* \`PDF Viewer Edit Page Clicked\` - Pdf Viewer Edit Page Clicked
* \`PDF Viewer Organize Pages Clicked\` - Pdf Viewer Organize Pages Clicked
* \`PDF Viewer Download Clicked\` - Pdf Viewer Download Clicked
* \`PDF Viewer Reset Edits Started\` - Pdf Viewer Reset Edits Started
* \`PDF Viewer Reset Edits Completed\` - Pdf Viewer Reset Edits Completed
* \`PDF Viewer Reset Edits Cancelled\` - Pdf Viewer Reset Edits Cancelled
* \`Image Editor Opened\` - Image Editor Opened
* \`Image Editor Closed\` - Image Editor Closed
* \`Image Editor Mode Changed\` - Image Editor Mode Changed
* \`Image Editor Changes Applied\` - Image Editor Changes Applied
* \`Image Editor Changes Discarded\` - Image Editor Changes Discarded
* \`Image Editor Crop Region Added\` - Image Editor Crop Region Added
* \`Image Editor Crop Region Removed\` - Image Editor Crop Region Removed
* \`Image Editor Crop Applied\` - Image Editor Crop Applied
* \`Image Editor Crop Reset\` - Image Editor Crop Reset
* \`Image Editor Rotated\` - Image Editor Rotated
* \`Image Editor Rotation Reset\` - Image Editor Rotation Reset
* \`Image Editor Adjustment Changed\` - Image Editor Adjustment Changed
* \`Image Editor Adjustments Reset\` - Image Editor Adjustments Reset
* \`Image Editor Trim Applied\` - Image Editor Trim Applied
* \`Image Editor Trim Reset\` - Image Editor Trim Reset
* \`Actaport Document Imported\` - Actaport Document Imported
* \`Actaport Document Import Failed\` - Actaport Document Import Failed
* \`Actaport Document Exported\` - Actaport Document Exported
* \`Actaport Document Export Failed\` - Actaport Document Export Failed
* \`Actaport Documents Refresh\` - Actaport Documents Refresh
* \`Actaport API Rate Limit Hit\` - Actaport Api Rate Limit Hit
* \`PDF Form Template Created\` - Pdf Form Template Created
* \`PDF Form Template Duplicated\` - Pdf Form Template Duplicated
* \`PDF Form Template Updated\` - Pdf Form Template Updated
* \`PDF Form Template Deleted\` - Pdf Form Template Deleted
* \`PDF Form Template Edit Started\` - Pdf Form Template Edit Started
* \`PDF Form Template Edit Saved\` - Pdf Form Template Edit Saved
* \`PDF Form Template Edit Abandoned\` - Pdf Form Template Edit Abandoned
* \`PDF Form Template Field Added\` - Pdf Form Template Field Added
* \`PDF Form Template Field Removed\` - Pdf Form Template Field Removed
* \`PDF Form Template Previewed\` - Pdf Form Template Previewed
* \`PDF Form Template Used\` - Pdf Form Template Used
* \`PDF Form Submission Created\` - Pdf Form Submission Created
* \`PDF Form Submission Completed\` - Pdf Form Submission Completed
* \`PDF Form Submission Sent\` - Pdf Form Submission Sent
* \`PDF Form Flattened\` - Pdf Form Flattened
* \`Self Questionnaire Created\` - Self Questionnaire Created
* \`Self Questionnaire Updated\` - Self Questionnaire Updated
* \`Self Questionnaire Published\` - Self Questionnaire Published
* \`Self Questionnaire AI Generated\` - Self Questionnaire Ai Generated
* \`Self Questionnaire Copy\` - Self Questionnaire Copy
* \`Self Questionnaire Submission Partial Updated\` - Self Questionnaire Submission Partial Updated
* \`Self Questionnaire Submission Completed\` - Self Questionnaire Submission Completed`
        },
        properties: {
            description: 'Additional properties for the event'
        }
    },
    required: ['event_name']
} as const;

export const $ImagePresetEnum = {
    enum: ['thumbnail', 'small', 'medium', 'large'],
    type: 'string',
    description: `* \`thumbnail\` - thumbnail
* \`small\` - small
* \`medium\` - medium
* \`large\` - large`
} as const;

export const $ImageproxyImagePreset = {
    type: 'object',
    properties: {
        url: {
            type: 'string',
            format: 'uri'
        },
        image_preset: {
            '$ref': '#/components/schemas/ImagePresetEnum'
        }
    },
    required: ['image_preset', 'url']
} as const;

export const $ImageproxyImagePresetRequest = {
    type: 'object',
    properties: {
        url: {
            type: 'string',
            format: 'uri',
            minLength: 1
        },
        image_preset: {
            '$ref': '#/components/schemas/ImagePresetEnum'
        }
    },
    required: ['image_preset', 'url']
} as const;

export const $ImportDocumentRequestRequest = {
    type: 'object',
    description: 'Request serializer for importing a document from Actaport.',
    properties: {
        actaport_document_id: {
            type: 'string',
            minLength: 1,
            description: 'ID of the document in Actaport to import'
        }
    },
    required: ['actaport_document_id']
} as const;

export const $ImportDocumentResponse = {
    type: 'object',
    description: 'Response serializer for import document endpoint.',
    properties: {
        status: {
            allOf: [
                {
                    '$ref': '#/components/schemas/ImportDocumentResponseStatusEnum'
                }
            ],
            description: `Status of the import operation

* \`importing\` - importing
* \`error\` - error`
        },
        message: {
            type: 'string',
            description: 'Optional message about the import status'
        }
    },
    required: ['status']
} as const;

export const $ImportDocumentResponseStatusEnum = {
    enum: ['importing', 'error'],
    type: 'string',
    description: `* \`importing\` - importing
* \`error\` - error`
} as const;

export const $InboundEmailAttachment = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        file_name: {
            type: 'string',
            maxLength: 255
        },
        file: {
            type: 'string',
            format: 'uri'
        }
    },
    required: ['file', 'file_name']
} as const;

export const $InboundEmailRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        }
    }
} as const;

export const $IntegrationError = {
    type: 'object',
    properties: {
        error: {
            type: 'string'
        },
        integrationType: {
            type: 'string'
        },
        errorType: {
            type: 'string'
        }
    },
    required: ['error', 'errorType', 'integrationType']
} as const;

export const $IntegrationSpecificDataRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/ActaportDataRequest'
        },
        {
            '$ref': '#/components/schemas/AdvoluxDataRequest'
        },
        {
            '$ref': '#/components/schemas/AdvowareDataRequest'
        },
        {
            '$ref': '#/components/schemas/LawFirmSoftwareDataRequest'
        },
        {
            '$ref': '#/components/schemas/RaMicroDataRequest'
        },
        {
            '$ref': '#/components/schemas/RaMicroApiDataRequest'
        },
        {
            '$ref': '#/components/schemas/JurnodesDataRequest'
        },
        {
            '$ref': '#/components/schemas/KleosDataRequest'
        },
        {
            '$ref': '#/components/schemas/DatevDataRequest'
        }
    ],
    discriminator: {
        propertyName: 'integrationType',
        mapping: {
            actaport: '#/components/schemas/ActaportDataRequest',
            advolux: '#/components/schemas/AdvoluxDataRequest',
            advoware: '#/components/schemas/AdvowareDataRequest',
            lawfirm: '#/components/schemas/LawFirmSoftwareDataRequest',
            ramicro: '#/components/schemas/RaMicroDataRequest',
            ramicroapi: '#/components/schemas/RaMicroApiDataRequest',
            jurnodes: '#/components/schemas/JurnodesDataRequest',
            kleos: '#/components/schemas/KleosDataRequest',
            datev: '#/components/schemas/DatevDataRequest'
        }
    }
} as const;

export const $IntegrationTypeEnum = {
    enum: ['actaport', 'advolux', 'advoware', 'lawfirm', 'ramicro', 'ramicroapi', 'jurnodes', 'kleos', 'datev'],
    type: 'string',
    description: `* \`actaport\` - Actaport
* \`advolux\` - Advolux
* \`advoware\` - Advoware
* \`lawfirm\` - LawFirm
* \`ramicro\` - RaMicro
* \`ramicroapi\` - RaMicroApi
* \`jurnodes\` - Jurnodes
* \`kleos\` - Kleos
* \`datev\` - DATEV`
} as const;

export const $JumpTo = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            nullable: true
        },
        value: {
            type: 'string'
        }
    },
    required: ['uuid', 'value']
} as const;

export const $JumpToRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            nullable: true,
            minLength: 1
        },
        value: {
            type: 'string'
        }
    },
    required: ['uuid', 'value']
} as const;

export const $JurnodesDataRequest = {
    type: 'object',
    properties: {
        datapool: {
            type: 'integer'
        },
        rubrum: {
            type: 'string',
            minLength: 1
        },
        lawCategory: {
            type: 'integer'
        },
        recordSchema: {
            type: 'integer'
        },
        lawyers: {
            type: 'array',
            items: {
                type: 'integer'
            }
        },
        fileData: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/FileDataRequest'
            }
        },
        entities_with_relationships: {
            type: 'array',
            items: {
                type: 'string',
                format: 'uuid'
            }
        }
    },
    required: ['datapool', 'entities_with_relationships', 'lawCategory', 'recordSchema', 'rubrum']
} as const;

export const $JurnodesLawCategory = {
    type: 'object',
    properties: {
        id: {
            type: 'integer'
        },
        name: {
            type: 'string'
        }
    },
    required: ['id', 'name']
} as const;

export const $JurnodesRecordSchema = {
    type: 'object',
    properties: {
        id: {
            type: 'integer'
        },
        name: {
            type: 'string'
        },
        lawCategory: {
            type: 'integer'
        }
    },
    required: ['id', 'lawCategory', 'name']
} as const;

export const $JurnodesSettings = {
    type: 'object',
    description: 'Serializer for Jurnodes integration settings in Organisation model.',
    properties: {
        is_jurnodes_export_integration_enabled: {
            type: 'boolean',
            title: 'Jur|nodes Integration aktivieren'
        },
        jurnodes_api_user: {
            type: 'string',
            nullable: true,
            title: 'API-Benutzername',
            maxLength: 64
        },
        jurnodes_api_url: {
            type: 'string',
            nullable: true,
            title: 'API-URL',
            maxLength: 256
        },
        jurnodes_api_token: {
            type: 'string'
        }
    }
} as const;

export const $JurnodesSettingsRequest = {
    type: 'object',
    description: 'Serializer for Jurnodes integration settings in Organisation model.',
    properties: {
        is_jurnodes_export_integration_enabled: {
            type: 'boolean',
            title: 'Jur|nodes Integration aktivieren'
        },
        jurnodes_api_user: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'API-Benutzername',
            maxLength: 64
        },
        jurnodes_api_url: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'API-URL',
            maxLength: 256
        },
        jurnodes_api_token: {
            type: 'string'
        }
    }
} as const;

export const $JurnodesUser = {
    type: 'object',
    properties: {
        id: {
            type: 'integer'
        },
        displayName: {
            type: 'string'
        },
        abbreviation: {
            type: 'string'
        },
        department: {
            type: 'string'
        },
        position: {
            type: 'string'
        },
        privateFileFolder: {
            type: 'string'
        },
        contact: {
            type: 'string'
        }
    },
    required: ['abbreviation', 'contact', 'department', 'displayName', 'id', 'position', 'privateFileFolder']
} as const;

export const $KleosCaseType = {
    type: 'object',
    properties: {
        id: {
            type: 'integer'
        },
        name: {
            type: 'string'
        },
        defaultRegister: {
            type: 'integer',
            nullable: true
        }
    },
    required: ['defaultRegister', 'id', 'name']
} as const;

export const $KleosCaseTypes = {
    type: 'object',
    properties: {
        caseTypes: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/KleosCaseType'
            }
        }
    },
    required: ['caseTypes']
} as const;

export const $KleosDataRequest = {
    type: 'object',
    properties: {
        name: {
            type: 'string',
            minLength: 1
        },
        description: {
            type: 'string',
            nullable: true
        },
        caseResponsibleId: {
            type: 'integer',
            nullable: true
        },
        typeId: {
            type: 'integer'
        },
        creationDate: {
            type: 'string',
            minLength: 1
        },
        fileData: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/FileDataRequest'
            }
        },
        entities_with_relationships: {
            type: 'array',
            items: {
                type: 'string',
                format: 'uuid'
            }
        }
    },
    required: ['creationDate', 'description', 'entities_with_relationships', 'name', 'typeId']
} as const;

export const $KleosSettings = {
    type: 'object',
    description: 'Serializer for Kleos integration settings in Organisation model.',
    properties: {
        is_kleos_integration_enabled: {
            type: 'boolean'
        },
        kleos_client_id: {
            type: 'string',
            nullable: true,
            title: 'Client ID',
            maxLength: 100
        },
        kleos_client_secret: {
            type: 'string'
        }
    }
} as const;

export const $KleosSettingsRequest = {
    type: 'object',
    description: 'Serializer for Kleos integration settings in Organisation model.',
    properties: {
        is_kleos_integration_enabled: {
            type: 'boolean'
        },
        kleos_client_id: {
            type: 'string',
            nullable: true,
            title: 'Client ID',
            maxLength: 100
        },
        kleos_client_secret: {
            type: 'string'
        }
    }
} as const;

export const $LawAugmentedFieldsRequest = {
    type: 'object',
    properties: {
        field: {
            type: 'string',
            format: 'uuid',
            nullable: true
        },
        topic: {
            type: 'string',
            format: 'uuid',
            nullable: true
        }
    },
    required: ['field', 'topic']
} as const;

export const $LawData = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        updated_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        labor_law_beginning_of_employment: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Beginn des Arbeitsverhältnisses'
        },
        labor_law_end_of_employment: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Ende des Arbeitsverhältnisses'
        },
        labor_law_job_title: {
            type: 'string',
            title: 'Berufsbezeichnung',
            maxLength: 100
        },
        labor_law_yearly_gross_salary: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Gehalt, jährlich, brutto'
        },
        labor_law_monthly_gross_salary: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Gehalt, monatlich, brutto'
        },
        labor_law_monthly_working_days: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Arbeitsstunden pro Monat'
        },
        labor_law_vacation_days: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Urlaubstage'
        },
        labor_law_work_hours_per_week: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Arbeitsstunden pro Woche'
        },
        labor_law_is_employee_in_probation_period: {
            type: 'boolean',
            nullable: true,
            title: 'Arbeitnehmer in Probezeit'
        },
        labor_law_employee_probation_period_end_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Ende der Probezeit'
        },
        labor_law_place_of_work: {
            type: 'string',
            title: 'Arbeitsort',
            maxLength: 100
        },
        labor_law_different_place_of_work: {
            type: 'string',
            title: 'Abweichender Arbeitsort',
            maxLength: 100
        },
        labor_law_fixed_term_contract: {
            type: 'boolean',
            nullable: true,
            title: 'Befristetes Arbeitsverhältnis'
        },
        labor_law_fixed_term_contract_duration: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Ende befristetes Arbeitsverhältnis'
        },
        labor_law_special_payments: {
            type: 'string',
            title: 'Sonderzahlungen',
            maxLength: 100
        },
        labor_law_special_payments_amount: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Höhe der Sonderzahlungen'
        },
        labor_law_special_protection_against_dismissal: {
            type: 'boolean',
            nullable: true,
            title: 'Sonderkündigungsschutz'
        },
        labor_law_work_council: {
            type: 'boolean',
            nullable: true,
            title: 'Betriebsrat'
        },
        labor_law_collective_agreement: {
            type: 'boolean',
            nullable: true,
            title: 'Tarifvertrag'
        },
        labor_law_company_agreement: {
            type: 'boolean',
            nullable: true,
            title: 'Betriebsvereinbarung'
        },
        labor_law_notice_period: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Kündigungsfrist in Monaten'
        },
        labor_law_signature_of_employer: {
            type: 'boolean',
            nullable: true,
            title: 'Unterschrift Arbeitgeber'
        },
        labor_law_local_transfer_clause: {
            type: 'boolean',
            nullable: true,
            title: 'Örtliche Versetzungsklausel'
        },
        labor_law_VSOP: {
            type: 'boolean',
            nullable: true,
            title: 'VSOP'
        },
        labor_law_LTI: {
            type: 'boolean',
            nullable: true,
            title: 'LTI'
        },
        labor_law_termination_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Kündigung durch Arbeitgeber'
        },
        labor_law_termination_date_effective: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Kündigung erfolgt zu welchem Datum'
        },
        labor_law_termination_employer_more_than_10_employees: {
            type: 'boolean',
            nullable: true,
            title: 'Arbeitgeber hat mehr als 10 Mitarbeiter'
        },
        labor_law_termination_access_to_termination_to_employee: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Zugang Kündigung beim Arbeitnehmer'
        },
        labor_law_notice_period_observed: {
            type: 'boolean',
            nullable: true,
            title: 'Kündigungsfrist eingehalten'
        },
        labor_law_termination_without_notice: {
            type: 'boolean',
            nullable: true,
            title: 'Fristlose Kündigung'
        },
        labor_law_reason_for_termination_given: {
            type: 'boolean',
            nullable: true,
            title: 'Kündigungsgrund angegeben'
        },
        labor_law_exemption_revocable: {
            type: 'boolean',
            nullable: true,
            title: 'Freistellung widerruflich'
        },
        labor_law_exemption_irrevocable: {
            type: 'boolean',
            nullable: true,
            title: 'Freistellung unwiderruflich'
        },
        labor_law_return_of_company_property: {
            type: 'boolean',
            nullable: true,
            title: 'Rückgabe Firmeneigentum'
        },
        labor_law_termination_operational_reasons: {
            type: 'boolean',
            nullable: true,
            title: '1a KSchG dringende betriebliche Kündigung'
        },
        labor_law_company_hearing: {
            type: 'boolean',
            nullable: true,
            title: 'Betriebsanhörung durchgeführt'
        },
        labor_law_reaction_company_hering: {
            type: 'string',
            nullable: true,
            title: 'Reaktion des Betriebsrats'
        },
        labor_law_termination_authorization: {
            type: 'string',
            nullable: true,
            title: 'Befugnis zur Kündigung'
        },
        labor_law_warning_letter_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Abmahnung'
        },
        labor_law_warning_letter_access_to_warning_letter_to_employee: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Zugang Abmahnung beim Arbeitnehmer'
        },
        labor_law_warning_letter_incident_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum des Vorfalls der zur Abmahnung geführt hat'
        },
        labor_law_warning_letter_incident_time: {
            type: 'string',
            format: 'time',
            nullable: true,
            title: 'Uhrzeit des Vorfalls der zur Abmahnung geführt hat'
        },
        labor_law_warning_letter_incident_location: {
            type: 'string',
            title: 'Ort des Vorfalls der zur Abmahnung geführt hat',
            maxLength: 100
        },
        labor_law_warning_letter_reason: {
            type: 'string',
            title: 'Grund der Abmahnung'
        },
        labor_law_termination_agreement_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Aufhebungsvertrag'
        },
        labor_law_settlement_agreement_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Abwicklungsvertrag'
        },
        labor_law_termination_agreement_termination_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Beendigung Arbeitsverhältnis'
        },
        labor_law_termination_is_agreement_severance_pay: {
            type: 'boolean',
            nullable: true,
            title: 'Abfindung vereinbart'
        },
        labor_law_termination_agreement_severance_pay_amount: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Höhe der Abfindung'
        },
        labor_law_special_sentence: {
            type: 'boolean',
            nullable: true,
            title: 'Zur Vermeidung Kündigung aus dringenden betrieblichen Gründen'
        },
        labor_law_sprinter_clause: {
            type: 'boolean',
            nullable: true,
            title: 'Sprinterklausel'
        },
        labor_law_percent_sprinter_clause: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Prozent Sprinterklausel'
        },
        labor_law_certificate_clause: {
            type: 'boolean',
            nullable: true,
            title: 'Zeugnisklausel'
        },
        labor_law_grade_certificate_clause: {
            type: 'string',
            title: 'Note Zeugnisklausel'
        },
        labor_law_child_allowances: {
            type: 'boolean',
            nullable: true,
            title: 'Kinderfreibeträge'
        },
        labor_law_married: {
            type: 'boolean',
            nullable: true,
            title: 'Verheiratet'
        },
        labor_law_dependent_children: {
            type: 'boolean',
            nullable: true,
            title: 'Unterhaltspflichtige Kinder'
        },
        labor_law_amount_dependent_children: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Anzahl unterhaltspflichtiger Kinder'
        },
        labor_law_years_of_employment: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Jahre der Betriebszugehörigkeit'
        },
        labor_law_total_gross_salary: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Gesamtgehalt Brutto'
        },
        labor_law_severance_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Abfindungssumme'
        },
        labor_law_works_council_membership: {
            type: 'boolean',
            nullable: true,
            title: 'Mitgliedschaft Betriebsrat'
        },
        labor_law_pregnancy: {
            type: 'boolean',
            nullable: true,
            title: 'Schwangerschaft'
        },
        labor_law_disability: {
            type: 'boolean',
            nullable: true,
            title: 'Behinderung'
        },
        labor_law_special_personal_circumstances: {
            type: 'boolean',
            nullable: true,
            title: 'Besondere persönliche Umstände'
        },
        traffic_law_place_of_accident: {
            type: 'string',
            title: 'Unfallort',
            maxLength: 100
        },
        traffic_law_date_of_accident: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Unfalltag'
        },
        traffic_law_time_of_accident: {
            type: 'string',
            format: 'time',
            nullable: true,
            title: 'Uhrzeit Unfall'
        },
        traffic_law_driving_ban_duration: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Fahrverbot Dauer'
        },
        traffic_law_driving_ban: {
            type: 'boolean',
            nullable: true,
            title: 'Fahrverbot verhängt'
        },
        traffic_law_licenseplate: {
            type: 'string',
            title: 'KFZ-Kennzeichen',
            maxLength: 100
        },
        traffic_law_vehicle_type_and_brand: {
            type: 'string',
            title: 'Fahrzeugtyp und Marke',
            maxLength: 100
        },
        traffic_law_amount_of_fine: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Bußgeldhöhe'
        },
        traffic_law_date_of_fine: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Bußgeldbescheid'
        },
        traffic_law_speed_allowed: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Erlaubte Geschwindigkeit'
        },
        traffic_law_speed_driven: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Gefahrene Geschwindigkeit'
        },
        traffic_law_speed_too_high: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Überschreitung Geschwindigkeit'
        },
        traffic_law_points_for_offense: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Punkte'
        },
        traffic_law_date_of_offense: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum der Tat'
        },
        traffic_law_time_of_offense: {
            type: 'string',
            format: 'time',
            nullable: true,
            title: 'Uhrzeit der Tat'
        },
        traffic_law_place_of_offense: {
            type: 'string',
            title: 'Ort der Tat',
            maxLength: 100
        },
        traffic_law_violation_type: {
            type: 'string',
            title: 'Tatvorwurf',
            maxLength: 100
        },
        traffic_law_violated_section: {
            type: 'string',
            title: 'Verletzte Vorschrift',
            maxLength: 100
        },
        traffic_law_file_number: {
            type: 'string',
            title: 'Aktenzeichen',
            maxLength: 100
        },
        traffic_law_driver_logbook_required: {
            type: 'boolean',
            nullable: true,
            title: 'Fahrtenbuch erforderlich'
        },
        traffic_law_licenseplate_at_fault_driver: {
            type: 'string',
            title: 'KFZ-Kennzeichen des Unfallverursachers',
            maxLength: 100
        },
        traffic_law_licenseplate_victim_driver: {
            type: 'string',
            title: 'KFZ-Kennzeichen des Unfallgeschädigten',
            maxLength: 100
        },
        traffic_law_injured: {
            type: 'boolean',
            nullable: true,
            title: 'Verletzte'
        },
        traffic_law_other_damages: {
            type: 'boolean',
            nullable: true,
            title: 'Andere Sachschäden'
        },
        traffic_law_mark_and_type_of_at_fault_driver: {
            type: 'string',
            title: 'Unfallverursacher - Marke, Typ des Fahrzeugs',
            maxLength: 100
        },
        traffic_law_mark_and_type_of_victim_driver: {
            type: 'string',
            title: 'Unfallgeschädigter - Marke, Typ des Fahrzeugs',
            maxLength: 100
        },
        traffic_law_at_fault_driver_insurer: {
            type: 'string',
            title: 'Unfallverursacher - Versicherer',
            maxLength: 100
        },
        traffic_law_victim_driver_insurer: {
            type: 'string',
            title: 'Unfallgeschädigter - Versicherer',
            maxLength: 100
        },
        traffic_law_at_fault_driver_insurance_number: {
            type: 'string',
            title: 'Unfallverursacher - Vers.-Nr.',
            maxLength: 100
        },
        traffic_law_victim_driver_insurance_number: {
            type: 'string',
            title: 'Unfallgeschädigter - Vers.-Nr.',
            maxLength: 100
        },
        traffic_law_at_fault_driver_green_card_number: {
            type: 'string',
            title: 'Unfallverursacher - Nr. der Grünen Karte',
            maxLength: 100
        },
        traffic_law_victim_driver_green_card_number: {
            type: 'string',
            title: 'Unfallgeschädigter - Nr. der Grünen Karte',
            maxLength: 100
        },
        traffic_law_at_fault_driver_insurance_expiry_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Unfallverursacher - Vers.-Schein gültig bis'
        },
        traffic_law_victim_driver_insurance_expiry_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Unfallgeschädigter - Vers.-Schein gültig bis'
        },
        traffic_law_at_fault_driver_drivers_license_issued_by: {
            type: 'string',
            title: 'Unfallverursacher - Führerschein ausgestellt durch',
            maxLength: 100
        },
        traffic_law_victim_driver_drivers_license_issued_by: {
            type: 'string',
            title: 'Unfallgeschädigter - Führerschein ausgestellt durch',
            maxLength: 100
        },
        traffic_law_at_fault_driver_drivers_license_valid_until: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Unfallverursacher - Führerschein gültig bis'
        },
        traffic_law_victim_driver_license_valid_until: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Unfallgeschädigter - Führerschein gültig bis'
        },
        traffic_law_date_of_report: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Sachverständigengutachten'
        },
        traffic_law_place_of_inspection: {
            type: 'string',
            title: 'Besichtigungsort',
            maxLength: 100
        },
        traffic_law_date_of_inspection: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Besichtigungsdatum'
        },
        traffic_law_time_of_inspection: {
            type: 'string',
            format: 'time',
            nullable: true,
            title: 'Besichtigungszeit'
        },
        traffic_law_insurance_holder: {
            type: 'string',
            title: 'Versicherungsnehmer',
            maxLength: 100
        },
        traffic_law_insurance: {
            type: 'string',
            title: 'Versicherung',
            maxLength: 100
        },
        traffic_law_police_case_number: {
            type: 'string',
            title: 'Polizeiliches Aktenzeichen',
            maxLength: 100
        },
        traffic_law_repair_costs_without_vat: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Reparaturkosten Netto'
        },
        traffic_law_repair_costs_with_vat: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Reparaturkosten Brutto'
        },
        traffic_law_replacement_value: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Wiederbeschaffungswert'
        },
        traffic_law_differencial_tax: {
            type: 'boolean',
            nullable: true,
            title: 'Differenzsteuer'
        },
        traffic_law_regular_tax: {
            type: 'boolean',
            nullable: true,
            title: 'Regelsteuer'
        },
        traffic_law_merantile_value_loss: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Merkantile Wertminderung'
        },
        traffic_law_loss_of_use_per_day: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Nutzungsausfallentschädigung pro Tag'
        },
        traffic_law_repair_duration: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Reparaturdauer Tage'
        },
        traffic_law_residual_value: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Restwert Brutto'
        },
        traffic_law_reregistration_cost: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Ummeldekosten'
        },
        traffic_law_damage_scope: {
            type: 'string',
            title: 'Schadensumfang'
        },
        traffic_law_expert_report_number: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Gutachten Nummer'
        },
        traffic_law_insurance_policy_number: {
            type: 'string',
            title: 'Versicherungsscheinnummer',
            maxLength: 100
        },
        traffic_law_damage_number: {
            type: 'string',
            title: 'Schadensnummer',
            maxLength: 100
        },
        traffic_law_expert_cost: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Sachverständigenkosten'
        },
        traffic_law_cost_per_scale: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Kostenpauschale'
        },
        traffic_law_loss_amount_repair_case: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Restschaden Reparaturschaden'
        },
        traffic_law_loss_amount_total_damage_case: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Restschaden Totalschaden'
        },
        traffic_law_replacement_cost: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Wiederbeschaffungsaufwand'
        },
        traffic_law_date_of_infraction: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum der Ordnungswidrigkeit'
        },
        traffic_law_time_of_infraction: {
            type: 'string',
            format: 'time',
            nullable: true,
            title: 'Uhrzeit der Ordnungswidrigkeit'
        },
        traffic_law_place_of_infraction: {
            type: 'string',
            title: 'Ort der Ordnungswidrigkeit',
            maxLength: 100
        },
        traffic_law_offense_infraction_description: {
            type: 'string',
            title: 'Tatbestand'
        },
        traffic_law_legal_basis_infraction: {
            type: 'string',
            title: 'Gesetzliche Grundlage'
        },
        traffic_law_evidence_infraction: {
            type: 'string',
            title: 'Beweismittel'
        },
        traffic_law_warning_fee_infraction: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Verwarnungsgeldbetrag'
        },
        traffic_law_payment_deadline: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Zahlungsfrist'
        },
        traffic_law_prosecution_number: {
            type: 'string',
            title: 'Geschäftsnummer',
            maxLength: 100
        },
        traffic_law_place_of_issue: {
            type: 'string',
            title: 'Ort der Ausstellung',
            maxLength: 100
        },
        traffic_law_date_of_issue: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum der Ausstellung'
        },
        traffic_law_time_of_issue: {
            type: 'string',
            format: 'time',
            nullable: true,
            title: 'Tag der Ausstellung'
        },
        traffic_law_charges: {
            type: 'string',
            title: 'Tatvorwurf'
        },
        traffic_law_legal_basis: {
            type: 'string',
            title: 'Gesetzliche Grundlage'
        },
        traffic_law_fine: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Geldstrafe'
        },
        traffic_law_daily_rate: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Höhe des Tagessatzes'
        },
        traffic_law_number_of_daily_rates: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Anzahl der Tagessätze'
        },
        traffic_law_procedure_costs: {
            type: 'string',
            title: 'Verfahrenskosten'
        },
        traffic_law_date_of_crime: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum der Tat'
        },
        traffic_law_time_of_crime: {
            type: 'string',
            format: 'time',
            nullable: true,
            title: 'Uhrzeit der Tat'
        },
        traffic_law_place_of_crime: {
            type: 'string',
            title: 'Ort der Tat',
            maxLength: 100
        },
        traffic_law_blood_alcohol_concentration: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Blutalkoholkonzentration'
        },
        traffic_law_appeal_instruction: {
            type: 'string',
            title: 'Rechtsbehelfsbelehrung'
        },
        traffic_law_vehicle_age_months: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Fahrzeugalter in Monaten'
        },
        traffic_law_vehicle_mileage: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Fahrzeugleistung in km'
        },
        traffic_law_accident_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Unfallverursacher - Vers.-Schein gültig bis'
        },
        traffic_law_expert_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Unfallverursacher - Sachverständigengutachten'
        },
        traffic_law_net_replacement_value: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Nettowiederbeschaffungswert'
        },
        traffic_law_gross_replacement_value: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Bruttowiederbeschaffungswert'
        },
        traffic_law_net_gross_replacement_value: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Netto-Brutto-Wiederbeschaffungswert'
        },
        traffic_law_gross_gross_replacement_value: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Brutto-Brutto-Wiederbeschaffungswert'
        },
        traffic_law_calculated_total_damage_costs: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Gesamtschadenshöhe'
        },
        traffic_law_calculated_total_days: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Gesamttage'
        },
        traffic_law_repair_damage: {
            type: 'boolean',
            nullable: true,
            title: 'Reparaturschaden'
        },
        traffic_law_total_damage: {
            type: 'boolean',
            nullable: true,
            title: 'Totalschaden'
        },
        criminal_law_legal_classification_of_offense: {
            type: 'string',
            nullable: true,
            title: 'Vergehen auf der Grundlage von',
            maxLength: 128
        },
        criminal_law_date_of_offense: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum der Tat'
        },
        criminal_law_time_of_offense: {
            type: 'string',
            format: 'time',
            nullable: true,
            title: 'Uhrzeit der Tat'
        },
        criminal_law_place_of_offense: {
            type: 'string',
            nullable: true,
            title: 'Ort der Tat',
            maxLength: 128
        },
        criminal_law_penalty_infromation: {
            type: 'string',
            nullable: true,
            title: 'Strafe',
            maxLength: 128
        },
        criminal_law_number_of_daily_rates: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Tagessatz'
        },
        criminal_law_amount_of_daily_rates: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Betrag des Tagessatzes'
        },
        criminal_law_evidence: {
            type: 'string',
            nullable: true,
            title: 'Beweis',
            maxLength: 128
        },
        criminal_law_probation: {
            type: 'boolean',
            nullable: true,
            title: 'Bewährung'
        },
        criminal_law_prison_sentence: {
            type: 'boolean',
            nullable: true,
            title: 'Freiheitsstrafe'
        },
        criminal_law_duration_of_prison_sentence: {
            type: 'string',
            nullable: true,
            title: 'Dauer der Freiheitsstrafe',
            maxLength: 128
        },
        criminal_law_police_file_number: {
            type: 'string',
            nullable: true,
            title: 'Vorgangsnummer',
            maxLength: 128
        },
        criminal_law_report_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum der Anzeigenerstattung'
        },
        criminal_law_report_time: {
            type: 'string',
            format: 'time',
            nullable: true,
            title: 'Uhrzeit der Anzeigenerstattung'
        },
        criminal_law_offense_type: {
            type: 'string',
            nullable: true,
            title: 'Art des Delikts',
            maxLength: 256
        },
        criminal_law_incident_description: {
            type: 'string',
            nullable: true,
            title: 'Sachverhalt'
        },
        criminal_law_physical_evidence: {
            type: 'string',
            nullable: true,
            title: 'Beschreibung der Beweismittel'
        },
        criminal_law_evidence_location: {
            type: 'string',
            nullable: true,
            title: 'Standort der Beweismittel',
            maxLength: 256
        },
        criminal_law_damage_description: {
            type: 'string',
            nullable: true,
            title: 'Beschreibung des Schadens'
        },
        criminal_law_damage_value: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Schadenshöhe in EUR'
        },
        criminal_law_prosecution_file_number: {
            type: 'string',
            nullable: true,
            title: 'Aktenzeichen der Staatsanwaltschaft',
            maxLength: 128
        },
        criminal_law_charge_description: {
            type: 'string',
            nullable: true,
            title: 'Anklagesatz'
        },
        criminal_law_means_of_evidence: {
            type: 'string',
            nullable: true,
            title: 'Beweismittel'
        },
        criminal_law_applicable_laws: {
            type: 'string',
            nullable: true,
            title: 'Anwendbare Vorschriften'
        },
        criminal_law_preliminary_proceedings_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum der Einleitung des Ermittlungsverfahrens'
        },
        criminal_law_indictment_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum der Anklageschrift'
        },
        criminal_law_indictment_delivery_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum der Zustellung der Anklageschrift'
        },
        family_law_divorce_settlement_agreement: {
            type: 'boolean',
            nullable: true,
            title: 'Scheidungsfolgenvereinbarung'
        },
        family_law_marriage_contract_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Ehevertragsdatum'
        },
        family_law_average_net_income: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Durchschnittliches Nettoeinkommen'
        },
        family_law_children: {
            type: 'boolean',
            nullable: true,
            title: 'Kinder vorhanden'
        },
        family_law_registry_office_location: {
            type: 'string',
            nullable: true,
            title: 'Standesamt Ort',
            maxLength: 100
        },
        family_law_date_of_marriage: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Eheschließungsdatum'
        },
        family_law_marriage_register_number: {
            type: 'string',
            nullable: true,
            title: 'Eheregisternummer',
            maxLength: 100
        },
        family_law_separation_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Trennungsdatumdatum'
        },
        family_law_birth_register_number: {
            type: 'string',
            nullable: true,
            title: 'Geburtsurkundennummer',
            maxLength: 100
        },
        family_law_birth_register_office_location: {
            type: 'string',
            nullable: true,
            title: 'Standesamt Geburtsurkunde',
            maxLength: 100
        },
        social_law_application_file_reference: {
            type: 'string',
            nullable: true,
            title: 'Aktenzeichen',
            maxLength: 256
        },
        social_law_legal_basis: {
            type: 'string',
            nullable: true,
            title: 'Rechtsgrundlage',
            maxLength: 256
        },
        social_law_benefit_type: {
            type: 'string',
            nullable: true,
            title: 'Leistungsart',
            maxLength: 256
        },
        social_law_own_income_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Höhe eigenes Einkommen'
        },
        social_law_social_benefit_type: {
            type: 'string',
            nullable: true,
            title: 'Art der Sozialleistung',
            maxLength: 256
        },
        social_law_residence_status: {
            type: 'string',
            nullable: true,
            title: 'Aufenthaltsstatus',
            maxLength: 256
        },
        social_law_income_type: {
            type: 'string',
            nullable: true,
            title: 'Art des Einkommens',
            maxLength: 256
        },
        social_law_asset_type: {
            type: 'string',
            nullable: true,
            title: 'Art des Vermögens',
            maxLength: 256
        },
        social_law_approval_file_reference: {
            type: 'string',
            nullable: true,
            title: 'Aktenzeichen',
            maxLength: 256
        },
        social_law_approval_notice_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum des Bescheids'
        },
        social_law_approval_legal_basis: {
            type: 'string',
            nullable: true,
            title: 'Rechtsgrundlage der Entscheidung',
            maxLength: 256
        },
        social_law_approval_internal_reference: {
            type: 'string',
            nullable: true,
            title: 'Interne Referenznummer der Behörde',
            maxLength: 256
        },
        social_law_approved_benefit_type: {
            type: 'string',
            nullable: true,
            title: 'Bewilligte Leistung (Art)',
            maxLength: 256
        },
        social_law_approved_benefit_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Bewilligte Leistung (Betrag)'
        },
        social_law_approved_benefit_period: {
            type: 'string',
            nullable: true,
            title: 'Bewilligte Leistung (Zeitraum)',
            maxLength: 256
        },
        social_law_follow_up_application_notes: {
            type: 'string',
            nullable: true,
            title: 'Hinweise zu Folgeanträgen',
            maxLength: 512
        },
        social_law_approval_period_start: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Bewilligungszeitraum Beginn'
        },
        social_law_approval_period_end: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Bewilligungszeitraum Ende'
        },
        social_law_regelbedarf_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Regelbedarf'
        },
        social_law_housing_costs_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Kosten für Unterkunft und Heizung'
        },
        social_law_total_need_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Gesamtbedarf'
        },
        social_law_monthly_payment_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Monatliche Leistung'
        },
        social_law_employment_income: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Erwerbseinkommen'
        },
        social_law_other_income: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Sonstiges Einkommen'
        },
        social_law_creditable_income: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Anrechenbares Einkommen'
        },
        social_law_change_file_reference: {
            type: 'string',
            nullable: true,
            title: 'Aktenzeichen',
            maxLength: 256
        },
        social_law_change_notification_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum der Mitteilung'
        },
        social_law_affected_benefit: {
            type: 'string',
            nullable: true,
            title: 'Betroffene Leistung',
            maxLength: 256
        },
        social_law_change_description: {
            type: 'string',
            nullable: true,
            title: 'Beschreibung der Änderung',
            maxLength: 256
        },
        social_law_change_reason: {
            type: 'string',
            nullable: true,
            title: 'Grund der Änderung',
            maxLength: 256
        },
        social_law_attachment_list: {
            type: 'string',
            nullable: true,
            title: 'Anlagenliste',
            maxLength: 512
        },
        social_law_rejection_file_reference: {
            type: 'string',
            nullable: true,
            title: 'Aktenzeichen',
            maxLength: 256
        },
        social_law_rejection_legal_norm: {
            type: 'string',
            nullable: true,
            title: 'Rechtsnorm',
            maxLength: 256
        },
        social_law_rejection_reason: {
            type: 'string',
            nullable: true,
            title: 'Ablehnungsgrund',
            maxLength: 512
        },
        social_law_rejection_notice_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum des Bescheids'
        },
        social_law_revocation_file_reference: {
            type: 'string',
            nullable: true,
            title: 'Aktenzeichen',
            maxLength: 256
        },
        social_law_revocation_legal_norm: {
            type: 'string',
            nullable: true,
            title: 'Rechtsnorm',
            maxLength: 256
        },
        social_law_revocation_reason: {
            type: 'string',
            nullable: true,
            title: 'Begründung der Aufhebung',
            maxLength: 512
        },
        social_law_revocation_notice_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum des Bescheids'
        },
        social_law_revocation_reclaim_notes: {
            type: 'string',
            nullable: true,
            title: 'Hinweise zu Rückforderungen',
            maxLength: 512
        },
        social_law_revocation_benefit_type: {
            type: 'string',
            nullable: true,
            title: 'Leistungsart',
            maxLength: 256
        },
        social_law_revocation_period_start: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Aufhebungszeitraum Beginn'
        },
        social_law_revocation_period_end: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Aufhebungszeitraum Ende'
        },
        social_law_original_decision_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum des ursprünglichen Bescheids'
        },
        social_law_total_reclaim_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Gesamtforderung'
        },
        social_law_income_source: {
            type: 'string',
            nullable: true,
            title: 'Einkommensquelle',
            maxLength: 256
        },
        social_law_income_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Einkommensbetrag'
        },
        social_law_income_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum der Einnahme'
        },
        social_law_income_provider: {
            type: 'string',
            nullable: true,
            title: 'Einkommensgeber',
            maxLength: 256
        },
        social_law_notification_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum der Kenntnisnahme'
        },
        social_law_notification_source: {
            type: 'string',
            nullable: true,
            title: 'Quelle der Kenntnisnahme',
            maxLength: 256
        },
        social_law_violation_type: {
            type: 'string',
            nullable: true,
            title: 'Art der Pflichtverletzung',
            maxLength: 256
        },
        social_law_income_legal_basis: {
            type: 'string',
            nullable: true,
            title: 'Rechtsgrundlage Einkommensberücksichtigung',
            maxLength: 256
        },
        social_law_reclaim_legal_basis: {
            type: 'string',
            nullable: true,
            title: 'Rechtsgrundlage Erstattung',
            maxLength: 256
        },
        social_law_notification_legal_basis: {
            type: 'string',
            nullable: true,
            title: 'Rechtsgrundlage Mitteilungspflicht',
            maxLength: 256
        },
        social_law_reclaim_file_reference: {
            type: 'string',
            nullable: true,
            title: 'Aktenzeichen',
            maxLength: 256
        },
        social_law_reclaim_legal_norm: {
            type: 'string',
            nullable: true,
            title: 'Rechtsnorm',
            maxLength: 256
        },
        social_law_reclaim_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Rückforderungsbetrag'
        },
        social_law_reclaim_payment_deadline: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: ' Datum Zahlungsfrist'
        },
        social_law_reclaim_notice_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum des Bescheids'
        },
        social_law_reclaim_payment_terms: {
            type: 'string',
            nullable: true,
            title: 'Zahlungsmodalitäten',
            maxLength: 512
        },
        social_law_objection_file_reference: {
            type: 'string',
            nullable: true,
            title: 'Aktenzeichen (des angegriffenen Bescheids)',
            maxLength: 256
        },
        social_law_objection_challenged_notice: {
            type: 'string',
            nullable: true,
            title: 'Angegriffener Bescheid',
            maxLength: 256
        },
        social_law_objection_reasoning: {
            type: 'string',
            nullable: true,
            title: 'Widerspruchsbegründung',
            maxLength: 256
        },
        social_law_objection_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum des Widerspruchs'
        },
        social_law_objection_suspension_request: {
            type: 'string',
            nullable: true,
            title: 'Antrag auf Aussetzung der Vollziehung',
            maxLength: 256
        },
        social_law_objection_evidence: {
            type: 'string',
            nullable: true,
            title: 'Beweismittel',
            maxLength: 512
        },
        social_law_notice_of_objection_file_reference: {
            type: 'string',
            nullable: true,
            title: 'Aktenzeichen',
            maxLength: 256
        },
        social_law_notice_of_objection_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Widerspruchbescheid Datum'
        },
        social_law_notice_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Bescheid Datum'
        },
        social_law_application_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Antrag Datum'
        },
        social_law_application_arrival_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Eingang Antrag Datum'
        },
        social_law_summary_grounds_opposition: {
            type: 'string',
            nullable: true,
            title: 'Begründung des Widerspruchs',
            maxLength: 256
        },
        social_law_lawsuit_file_reference: {
            type: 'string',
            nullable: true,
            title: 'Aktenzeichen',
            maxLength: 256
        },
        social_law_lawsuit_subject: {
            type: 'string',
            nullable: true,
            title: 'Gegenstand des Verfahrens',
            maxLength: 512
        },
        social_law_lawsuit_filing_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum der Klageerhebung'
        },
        social_law_lawsuit_evidence_requests: {
            type: 'string',
            nullable: true,
            title: 'Beweisanträge',
            maxLength: 512
        },
        social_law_lawsuit_attachment_list: {
            type: 'string',
            nullable: true,
            title: 'Anlagenliste',
            maxLength: 512
        },
        social_law_lawsuit_court_file_number: {
            type: 'string',
            nullable: true,
            title: 'BG-Nummer',
            maxLength: 256
        },
        social_law_lawsuit_legal_basis: {
            type: 'string',
            nullable: true,
            title: 'Rechtliche Grundlage der Klage',
            maxLength: 256
        },
        social_law_lawsuit_type: {
            type: 'string',
            nullable: true,
            title: 'Art der Klage',
            maxLength: 256
        },
        social_law_lawsuit_main_request: {
            type: 'string',
            nullable: true,
            title: 'Hauptantrag',
            maxLength: 512
        },
        social_law_lawsuit_alternative_request: {
            type: 'string',
            nullable: true,
            title: 'Hilfsantrag',
            maxLength: 512
        },
        social_law_lawsuit_cost_request: {
            type: 'string',
            nullable: true,
            title: 'Kostenantrag',
            maxLength: 256
        },
        social_law_lawsuit_original_decision_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum des ursprünglichen Bescheids'
        },
        social_law_lawsuit_objection_decision_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum des Widerspruchsbescheids'
        },
        social_law_lawsuit_objection_filing_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum der Widerspruchseinlegung'
        },
        social_law_lawsuit_delivery_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Zustellungsdatum'
        },
        social_law_lawsuit_dispute_value: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Streitwert'
        },
        social_law_lawsuit_disputed_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Streitiger Betrag'
        },
        social_law_lawsuit_monthly_benefit_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Monatliche Leistung'
        },
        social_law_lawsuit_income_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Einkommensbetrag'
        },
        social_law_interim_protection_file_reference: {
            type: 'string',
            nullable: true,
            title: 'Aktenzeichen',
            maxLength: 256
        },
        social_law_interim_protection_request_text: {
            type: 'string',
            nullable: true,
            title: 'Antragstext',
            maxLength: 256
        },
        social_law_interim_protection_urgency_reason: {
            type: 'string',
            nullable: true,
            title: 'Dringlichkeitsbegründung',
            maxLength: 512
        },
        social_law_interim_protection_request_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum des Antrags'
        },
        social_law_interim_protection_affidavit: {
            type: 'boolean',
            nullable: true,
            title: 'Eidesstattliche Versicherung'
        },
        social_law_interim_protection_attachment_list: {
            type: 'string',
            nullable: true,
            title: 'Anlagenliste',
            maxLength: 512
        },
        social_law_medical_file_reference: {
            type: 'string',
            nullable: true,
            title: 'Aktenzeichen',
            maxLength: 256
        },
        social_law_medical_examination_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Untersuchungsdatum'
        },
        social_law_medical_diagnosis: {
            type: 'string',
            nullable: true,
            title: 'Medizinische Diagnose',
            maxLength: 512
        },
        social_law_medical_work_capacity_relation: {
            type: 'string',
            nullable: true,
            title: 'Bezug zur Leistungsfähigkeit',
            maxLength: 512
        },
        social_law_medical_prognosis: {
            type: 'string',
            nullable: true,
            title: 'Prognose',
            maxLength: 512
        },
        social_law_medical_limitations: {
            type: 'string',
            nullable: true,
            title: 'Einschränkungen',
            maxLength: 512
        },
        social_law_medical_icd_code: {
            type: 'string',
            nullable: true,
            title: 'ICD-Code',
            maxLength: 256
        },
        social_law_needs_file_reference: {
            type: 'string',
            nullable: true,
            title: 'Aktenzeichen',
            maxLength: 256
        },
        social_law_needs_type: {
            type: 'string',
            nullable: true,
            title: 'Art des Bedarfs',
            maxLength: 256
        },
        social_law_needs_proof_basis: {
            type: 'string',
            nullable: true,
            title: 'Nachweisgrundlage',
            maxLength: 512
        },
        social_law_needs_cost_breakdown: {
            type: 'string',
            nullable: true,
            title: 'Kostenaufstellung',
            maxLength: 512
        },
        social_law_needs_proof_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Bedarfsnachweis'
        },
        social_law_disability_file_reference: {
            type: 'string',
            nullable: true,
            title: 'Aktenzeichen',
            maxLength: 256
        },
        social_law_disability_degree: {
            type: 'string',
            nullable: true,
            title: 'Grad der Behinderung (GdB)',
            maxLength: 256
        },
        social_law_disability_card_issue_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Ausstellungsdatum'
        },
        social_law_disability_card_markers: {
            type: 'string',
            nullable: true,
            title: 'Merkzeichen',
            maxLength: 256
        },
        social_law_disability_card_validity_period: {
            type: 'string',
            nullable: true,
            title: 'Gültigkeitsdauer',
            maxLength: 256
        },
        social_law_hearing_file_reference: {
            type: 'string',
            nullable: true,
            title: 'Aktenzeichen',
            maxLength: 256
        },
        social_law_hearing_planned_administrative_act: {
            type: 'string',
            nullable: true,
            title: 'Geplanter Verwaltungsakt',
            maxLength: 512
        },
        social_law_hearing_letter_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Anhörungsschreiben'
        },
        social_law_appointment_file_reference: {
            type: 'string',
            nullable: true,
            title: 'Aktenzeichen',
            maxLength: 256
        },
        social_law_appointment_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Termin (Datum)'
        },
        social_law_appointment_time: {
            type: 'string',
            nullable: true,
            title: 'Termin (Uhrzeit)',
            maxLength: 256
        },
        social_law_appointment_purpose: {
            type: 'string',
            nullable: true,
            title: 'Zweck des Termins',
            maxLength: 512
        },
        social_law_appointment_required_documents: {
            type: 'string',
            nullable: true,
            title: 'Mitzubringende Unterlagen',
            maxLength: 512
        },
        debt_collection_law_invoice_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Rechnungsdatum'
        },
        debt_collection_law_invoice_number: {
            type: 'string',
            nullable: true,
            title: 'Rechnungsnummer',
            maxLength: 100
        },
        debt_collection_law_invoice_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Rechnungsbetrag'
        },
        debt_collection_law_invoice_ground: {
            type: 'string',
            nullable: true,
            title: 'Rechnungsgrund',
            maxLength: 100
        },
        debt_collection_law_invoice_recipient: {
            type: 'string',
            nullable: true,
            title: 'Rechnungsadressat',
            maxLength: 100
        },
        debt_collection_law_invoice_tax_number: {
            type: 'string',
            nullable: true,
            title: 'Steuernummer',
            maxLength: 100
        },
        debt_collection_law_case_value: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Gegenstandswert'
        },
        debt_collection_law_business_fee: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: '1,3 Geschäftsgebühr (Nr. 2300 VV RVG)'
        },
        debt_collection_law_lumps_sum_expenses: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Auslagenpauschale (Nr. 7002 VV RVG)'
        },
        debt_collection_law_subtotal_lawyer_fees: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Zwischensumme Netto'
        },
        debt_collection_law_sales_tax: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Umsatzsteuer (19%)'
        },
        debt_collection_law_total_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Gesamtbetrag'
        },
        tenancy_law_rental_object_size_sqm: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Größe Mietobjekt Quadratmeter'
        },
        tenancy_law_rental_agreement_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Mietvertragsdatum'
        },
        tenancy_law_last_signature_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum letzte Unterschrift Mietvertrag'
        },
        tenancy_law_net_rent: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Nettomiete'
        },
        tenancy_law_gross_rent: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Bruttomiete'
        },
        tenancy_law_total_rent: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Gesamtmiete'
        },
        tenancy_law_unlimited_term_tenancy: {
            type: 'boolean',
            nullable: true,
            title: 'Unbefristeter Mietvertrag'
        },
        tenancy_law_fixed_term_tenancy: {
            type: 'boolean',
            nullable: true,
            title: 'Befristeter Mietvertrag'
        },
        tenancy_law_rental_agreement_duration: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Dauer Mietvertrag'
        },
        tenancy_law_rental_agreement_validity_start: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Mietvertragsbeginn'
        },
        tenancy_law_rental_agreement_validity_end: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Mietvertragsende'
        },
        tenancy_law_staggered_rental_agreement: {
            type: 'boolean',
            nullable: true,
            title: 'Staffelmietvereinbarung'
        },
        tenancy_law_value_security_clause: {
            type: 'boolean',
            nullable: true,
            title: 'Wertsicherungsklausel'
        },
        tenancy_law_tenant_extension_option: {
            type: 'boolean',
            nullable: true,
            title: 'Verlängerungsoption zugunsten Mieter'
        },
        tenancy_law_extension_option_count: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Anzahl Verlängerungsoptionen'
        },
        tenancy_law_extension_option_duration: {
            type: 'string',
            nullable: true,
            title: 'Dauer Verlängerungsoption',
            maxLength: 128
        },
        tenancy_law_security_deposit_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Kautionshöhe'
        },
        tenancy_law_security_deposit_additional_regulations: {
            type: 'string',
            nullable: true,
            title: 'Zusätzliche Regelungen zur Kaution'
        },
        tenancy_law_cash_deposit_agreed: {
            type: 'boolean',
            nullable: true,
            title: 'Barkaution vertraglich vereinbart'
        },
        tenancy_law_cash_deposit_payment_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Barkaution Datum Zahlung'
        },
        tenancy_law_bank_guarantee: {
            type: 'boolean',
            nullable: true,
            title: 'Bankbürgschaft'
        },
        tenancy_law_operating_costs_agreement: {
            type: 'string',
            nullable: true,
            title: 'Betriebskostenvereinbarung',
            maxLength: 128
        },
        tenancy_law_advance_payment_service_charges: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Nebenkostenvorauszahlungshöhe'
        },
        tenancy_law_adress_rental_property: {
            type: 'string',
            nullable: true,
            title: 'Adresse des Mietobjekts',
            maxLength: 128
        },
        tenancy_law_description_of_rental_property: {
            type: 'string',
            nullable: true,
            title: 'Beschreibung des Mietobjekts',
            maxLength: 128
        },
        tenancy_law_location_in_rental_property: {
            type: 'string',
            nullable: true,
            title: 'Lage im Mietobjekt',
            maxLength: 128
        },
        tenancy_law_garage_available: {
            type: 'boolean',
            nullable: true,
            title: 'Garage vorhanden'
        },
        tenancy_law_garage_costs: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Kosten Garage'
        },
        tenancy_law_parking_space_available: {
            type: 'boolean',
            nullable: true,
            title: 'Stellplatz vorhanden'
        },
        tenancy_law_parking_space_costs: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Kosten des Stellplatzes'
        },
        tenancy_law_start_of_lease: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Beginn des Pachtvertrags'
        },
        tenancy_law_duration_of_lease: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Dauer des Pachtvertrags'
        },
        tenancy_law_repayment_period_start: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Beginn des Abrechnungszeitraums'
        },
        tenancy_law_repayment_period_end: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Ende des Abrechnungszeitraums'
        },
        tenancy_law_total_cost_service_charge: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Gesamtkosten Nebenkostenabrechnung'
        },
        tenancy_law_cost_shares: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Umlageschlüssel'
        },
        tenancy_law_cost_share: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Kostenanteil Mieter'
        },
        tenancy_law_advance_payment_service_charge: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Vorauszahlungen Nebenkostenabrechnung'
        },
        tenancy_law_repayment: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Nachzahlung/Guthaben'
        },
        tenancy_law_handover_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Übergabedatum'
        },
        tenancy_law_handover_counter: {
            type: 'string',
            nullable: true,
            title: 'Zählerstand',
            maxLength: 128
        },
        tenancy_law_counter_number: {
            type: 'string',
            nullable: true,
            title: 'Zählerstandnummer',
            maxLength: 128
        },
        tenancy_law_handover_defects: {
            type: 'string',
            nullable: true,
            title: 'Mängel',
            maxLength: 128
        },
        tenancy_law_expert_report_damage_number: {
            type: 'string',
            nullable: true,
            title: 'Schadennummer',
            maxLength: 100
        },
        tenancy_law_expert_report_object_address: {
            type: 'string',
            nullable: true,
            title: 'Objekt Adresse',
            maxLength: 200
        },
        tenancy_law_expert_report_subject: {
            type: 'string',
            nullable: true,
            title: 'Gegenstand',
            maxLength: 200
        },
        tenancy_law_expert_report_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Gutachten'
        },
        tenancy_law_expert_report_purpose: {
            type: 'string',
            nullable: true,
            title: 'Zweck des Gutachtens'
        },
        tenancy_law_expert_report_commission_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Beauftragung Datum'
        },
        tenancy_law_expert_report_inspection_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Ortsbesichtigung Datum'
        },
        tenancy_law_expert_report_damage_description: {
            type: 'string',
            nullable: true,
            title: 'Schaden'
        },
        tenancy_law_expert_report_repair_duration: {
            type: 'string',
            nullable: true,
            title: 'Dauer Schadenbeseitigung',
            maxLength: 100
        },
        tenancy_law_tenant_warned: {
            type: 'boolean',
            nullable: true,
            title: 'Mieter abgemahnt'
        },
        tenancy_law_warning_letter_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Mahnschreiben'
        },
        tenancy_law_landlord_termination_given: {
            type: 'boolean',
            nullable: true,
            title: 'Kündigung durch Vermieter erfolgt'
        },
        tenancy_law_termination_declared_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Kündigungserklärung'
        },
        tenancy_law_termination_notice_period: {
            type: 'string',
            nullable: true,
            title: 'Kündigungsfrist',
            maxLength: 128
        },
        tenancy_law_termination_letter_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Kündigungsschreiben vom'
        },
        tenancy_law_tenancy_terminated: {
            type: 'boolean',
            nullable: true,
            title: 'Mietverhältnis beendet'
        },
        tenancy_law_tenancy_termination_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Beendigung Mietverhältnisses'
        },
        tenancy_law_property_return_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Rückgabe des Objekts Datum'
        },
        tenancy_law_court_proceedings_pending: {
            type: 'boolean',
            nullable: true,
            title: 'Gerichtliches Verfahren anhängig'
        },
        tenancy_law_competent_court: {
            type: 'string',
            nullable: true,
            title: 'Zuständiges Gericht',
            maxLength: 128
        },
        tenancy_law_court_case_number: {
            type: 'string',
            nullable: true,
            title: 'Gerichtliches Aktenzeichen',
            maxLength: 128
        },
        tenancy_law_last_rent_increase_letter_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum letztes Mieterhöhungsschreiben'
        },
        tenancy_law_rent_increase_effective_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Mieterhöhung wirksam geworden zum'
        },
        residential_property_law_contract_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Wegvertragsdatum'
        },
        residential_property_law_land_register_number: {
            type: 'string',
            nullable: true,
            title: 'Grundbuch Nr.',
            maxLength: 100
        },
        residential_property_law_land_register_city: {
            type: 'string',
            nullable: true,
            title: 'Grundbuch Stadt',
            maxLength: 100
        },
        residential_property_law_land_register_plot_of_land: {
            type: 'string',
            nullable: true,
            title: 'Grundbuch Flurstück',
            maxLength: 100
        },
        residential_property_law_land_register_address: {
            type: 'string',
            nullable: true,
            title: 'Grundbuch Lage',
            maxLength: 100
        },
        residential_property_law_co_ownership_shares: {
            type: 'string',
            nullable: true,
            title: 'Miteigentumsanteile',
            maxLength: 100
        },
        residential_property_law_inventory: {
            type: 'string',
            nullable: true,
            title: 'Bestandsverzeichnis',
            maxLength: 100
        },
        inheritance_law_certificate_of_inheritance_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Erbscheins'
        },
        inheritance_law_certificate_of_inheritance_number: {
            type: 'string',
            nullable: true,
            title: 'Nummer des Erbscheins',
            maxLength: 128
        },
        inheritance_law_certificate_of_inheritance_date_death: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Todesdatum'
        },
        inheritance_law_certificate_of_inheritance_place_of_death: {
            type: 'string',
            nullable: true,
            title: 'Todesort',
            maxLength: 128
        },
        inheritance_law_certificate_of_inheritance_applicable_law: {
            type: 'string',
            nullable: true,
            title: 'Anwendbares Recht',
            maxLength: 128
        },
        inheritance_law_inheritance_contract_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum des Erbvertrags'
        },
        inheritance_law_death_certificate_number: {
            type: 'string',
            nullable: true,
            title: 'Nummer Sterbeurkunde',
            maxLength: 128
        },
        inheritance_law_death_certificate_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Sterbeurkunde'
        },
        inheritance_law_death_certificate_place: {
            type: 'string',
            nullable: true,
            title: 'Ort Sterbeurkunde',
            maxLength: 128
        },
        inheritance_law_death_certificate_date_death: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Todesdatum'
        },
        inheritance_law_death_certificate_time_death: {
            type: 'string',
            format: 'time',
            nullable: true,
            title: 'Uhrzeit des Todes'
        },
        inheritance_law_death_certificate_place_death: {
            type: 'string',
            nullable: true,
            title: 'Ort des Todes',
            maxLength: 128
        },
        inheritance_law_testament_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum des Testaments'
        },
        inheritance_law_estate_inventory_status: {
            type: 'string',
            nullable: true,
            title: 'Güterstand',
            maxLength: 128
        },
        inheritance_law_estate_inventory_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Nachlassverzeichnis'
        },
        inheritance_law_estate_inventory_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Nettonachlass'
        },
        inheritance_law_patient_enrollment_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Patientenverfügung'
        },
        inheritance_law_lasting_power_of_attorney_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Vorsorgevollmacht'
        },
        real_estate_law_land_register_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Grundbuchauszugdatum'
        },
        real_estate_law_encumbrance_restrictions: {
            type: 'string',
            nullable: true,
            title: 'Lasten und Beschränkungen',
            maxLength: 128
        },
        real_estate_law_basic_debts_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Grundschulden'
        },
        real_estate_law_land_register_number: {
            type: 'string',
            nullable: true,
            title: 'Grundbuch Nr.',
            maxLength: 100
        },
        real_estate_law_land_register_city: {
            type: 'string',
            nullable: true,
            title: 'Grundbuch Stadt',
            maxLength: 100
        },
        real_estate_law_land_register_plot_of_land: {
            type: 'string',
            nullable: true,
            title: 'Grundbuch Flurstück',
            maxLength: 100
        },
        real_estate_law_land_register_address: {
            type: 'string',
            nullable: true,
            title: 'Grundbuch Lage',
            maxLength: 100
        },
        real_estate_law_plot_size: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Grundstücksgröße'
        },
        real_estate_law_purchase_contract_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Kaufvertragsdatum'
        },
        real_estate_law_purchase_contract_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Kaufvertragsbetrag'
        },
        real_estate_law_purchase_contract_description: {
            type: 'string',
            nullable: true,
            title: 'Kaufvertrag Objektbeschreibung',
            maxLength: 128
        },
        real_estate_law_purchase_contract_registration_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Kaufvertragsbeurkundungsdatum'
        },
        real_estate_law_purchase_contract_registration_number: {
            type: 'string',
            nullable: true,
            title: 'Urkundenrollennummer',
            maxLength: 100
        },
        real_estate_law_brokerage_fee: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Makler Provision'
        },
        real_estate_law_property_brokered_by_agent: {
            type: 'boolean',
            nullable: true,
            title: 'Objekt durch Makler vermittelt'
        },
        real_estate_law_purchase_object_rented: {
            type: 'boolean',
            nullable: true,
            title: 'Kaufobjekt vermietet'
        },
        real_estate_law_encumbrances_section_ii: {
            type: 'string',
            nullable: true,
            title: 'Belastungen Abt. II Grundbuch'
        },
        real_estate_law_encumbrances_section_iii: {
            type: 'string',
            nullable: true,
            title: 'Belastungen Abt. III Grundbuch'
        },
        real_estate_law_building_restrictions_clause: {
            type: 'string',
            nullable: true,
            title: 'Regelungen zu Baulasten'
        },
        real_estate_law_contaminated_sites_clause: {
            type: 'string',
            nullable: true,
            title: 'Regelung zu Altlasten'
        },
        real_estate_law_legal_defects_clause: {
            type: 'string',
            nullable: true,
            title: 'Klausel zu Rechtsmängeln'
        },
        real_estate_law_purchase_price_loan_financed: {
            type: 'boolean',
            nullable: true,
            title: 'Kaufpreis durch Darlehen finanziert'
        },
        real_estate_law_withdrawal_instruction_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Widerrufsbelehrung Datum'
        },
        real_estate_law_building_permit_validity_duration: {
            type: 'string',
            nullable: true,
            title: 'Gültigkeitsdauer',
            maxLength: 100
        },
        real_estate_law_building_permit_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Baugenehmigungsdatum'
        },
        real_estate_law_building_permit_number: {
            type: 'string',
            nullable: true,
            title: 'Genehmigungsnummer',
            maxLength: 100
        },
        real_estate_law_co_ownership_share: {
            type: 'string',
            nullable: true,
            title: 'Miteigentumsanteil',
            maxLength: 100
        },
        real_estate_law_division_declaration_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Teilungserklärung'
        },
        real_estate_law_plan_designation: {
            type: 'string',
            nullable: true,
            title: 'Planbezeichnung',
            maxLength: 100
        },
        real_estate_law_plan_scale: {
            type: 'string',
            nullable: true,
            title: 'Maßstab',
            maxLength: 100
        },
        real_estate_law_plan_author: {
            type: 'string',
            nullable: true,
            title: 'Planverfasser',
            maxLength: 100
        },
        real_estate_law_building_usage: {
            type: 'string',
            nullable: true,
            title: 'Gebäudenutzung',
            maxLength: 100
        },
        real_estate_law_building_dimensions: {
            type: 'string',
            nullable: true,
            title: 'Baukörperabmessung',
            maxLength: 100
        },
        real_estate_law_monument_protection_order_number: {
            type: 'string',
            nullable: true,
            title: 'Bescheid - Nr.',
            maxLength: 100
        },
        real_estate_law_monument_protection_order_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum des Denkmalschutzbescheides'
        },
        real_estate_law_monument_protection_basis: {
            type: 'string',
            nullable: true,
            title: 'Schutzgrundlage',
            maxLength: 100
        },
        real_estate_law_monument_registration_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Eintragungsdatum'
        },
        real_estate_law_monument_protection_requirements: {
            type: 'string',
            nullable: true,
            title: 'Auflagen'
        },
        real_estate_law_loan_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Darlehenssumme'
        },
        real_estate_law_interest_rate: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,3}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Zinssatz'
        },
        real_estate_law_installment_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Ratenhöhe'
        },
        real_estate_law_full_repayment_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Vollständige Rückzahlung'
        },
        real_estate_law_loan_security: {
            type: 'string',
            nullable: true,
            title: 'Darlehnsabsicherung',
            maxLength: 100
        },
        real_estate_law_repayment_rate: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,3}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Tilgungssatz'
        },
        real_estate_law_broker_commission_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Provisionshöhe'
        },
        real_estate_law_broker_scope_of_work: {
            type: 'string',
            nullable: true,
            title: 'Tätigkeitsumfang'
        },
        real_estate_law_broker_termination_periods: {
            type: 'string',
            nullable: true,
            title: 'Kündigungsfristen',
            maxLength: 100
        },
        real_estate_law_broker_contract_type: {
            type: 'string',
            nullable: true,
            title: 'Art des Maklervertrags',
            maxLength: 100
        },
        real_estate_law_brokerage_contract_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Maklervertrag Datum'
        },
        real_estate_law_exclusive_brokerage_contract: {
            type: 'boolean',
            nullable: true,
            title: 'Alleinauftrag'
        },
        real_estate_law_commission_percentage: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,3}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Provisionshöhe in %'
        },
        migration_law_residence_permit_issue_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Ausstellungsdatum'
        },
        migration_law_residence_permit_valid_until: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Gültig bis'
        },
        migration_law_residence_permit_type: {
            type: 'string',
            nullable: true,
            title: 'Titelart',
            maxLength: 100
        },
        migration_law_residence_permit_purpose: {
            type: 'string',
            nullable: true,
            title: 'Zweck des Aufenthalts',
            maxLength: 200
        },
        migration_law_residence_permit_issuing_authority: {
            type: 'string',
            nullable: true,
            title: 'Behörde',
            maxLength: 100
        },
        migration_law_residence_permit_conditions: {
            type: 'string',
            nullable: true,
            title: 'Auflagen / Nebenbestimmungen'
        },
        migration_law_residence_permit_passport_number: {
            type: 'string',
            nullable: true,
            title: 'Passnummer',
            maxLength: 50
        },
        migration_law_residence_permit_national_id_number: {
            type: 'string',
            nullable: true,
            title: 'Nationale Identitätsnummer',
            maxLength: 50
        },
        migration_law_fictional_certificate_issue_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Ausgestellt am'
        },
        migration_law_fictional_certificate_valid_until: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Gültig bis'
        },
        migration_law_fictional_certificate_legal_basis: {
            type: 'string',
            nullable: true,
            title: 'Rechtsgrundlage',
            maxLength: 100
        },
        migration_law_fictional_certificate_fiction_type: {
            type: 'string',
            nullable: true,
            title: 'Art der Fiktion',
            maxLength: 100
        },
        migration_law_fictional_certificate_reason_for_issuance: {
            type: 'string',
            nullable: true,
            title: 'Zweck der Erteilung',
            maxLength: 200
        },
        migration_law_fictional_certificate_authority: {
            type: 'string',
            nullable: true,
            title: 'Behörde',
            maxLength: 100
        },
        migration_law_toleration_issue_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Ausgestellt am'
        },
        migration_law_toleration_valid_until: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Gültig bis'
        },
        migration_law_toleration_reason: {
            type: 'string',
            nullable: true,
            title: 'Grund der Duldung',
            maxLength: 200
        },
        migration_law_toleration_legal_basis: {
            type: 'string',
            nullable: true,
            title: 'Rechtsgrundlage',
            maxLength: 100
        },
        migration_law_toleration_restrictions: {
            type: 'string',
            nullable: true,
            title: 'Beschränkungen'
        },
        migration_law_toleration_issuing_authority: {
            type: 'string',
            nullable: true,
            title: 'Behörde',
            maxLength: 100
        },
        migration_law_asylum_seeker_certificate_issue_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Ausstellungsdatum'
        },
        migration_law_asylum_seeker_certificate_valid_until: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Gültig bis'
        },
        migration_law_asylum_seeker_certificate_application_number: {
            type: 'string',
            nullable: true,
            title: 'Asylantragsnummer',
            maxLength: 100
        },
        migration_law_asylum_seeker_certificate_first_registration_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Erstregistrierung'
        },
        migration_law_asylum_seeker_certificate_residence_obligation: {
            type: 'string',
            nullable: true,
            title: 'Wohnsitzauflage',
            maxLength: 200
        },
        migration_law_asylum_seeker_certificate_issuing_authority: {
            type: 'string',
            nullable: true,
            title: 'Behörde',
            maxLength: 100
        },
        migration_law_asylum_seeker_certificate_work_permission: {
            type: 'string',
            nullable: true,
            title: 'Arbeitserlaubnis',
            maxLength: 100
        },
        migration_law_rejection_notice_case_number: {
            type: 'string',
            nullable: true,
            title: 'Aktenzeichen',
            maxLength: 100
        },
        migration_law_rejection_notice_decision_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum des Bescheids'
        },
        migration_law_rejection_notice_subject: {
            type: 'string',
            nullable: true,
            title: 'Betreff',
            maxLength: 200
        },
        migration_law_rejection_notice_legal_remedy_deadline: {
            type: 'string',
            nullable: true,
            title: 'Rechtsbehelf / Frist',
            maxLength: 200
        },
        migration_law_rejection_notice_reasoning: {
            type: 'string',
            nullable: true,
            title: 'Begründung'
        },
        migration_law_rejection_notice_legal_grounds: {
            type: 'string',
            nullable: true,
            title: 'Gesetzesgrundlagen',
            maxLength: 200
        },
        migration_law_rejection_notice_officer_name: {
            type: 'string',
            nullable: true,
            title: 'Name des Sachbearbeiters',
            maxLength: 100
        },
        migration_law_rejection_notice_signature_seal: {
            type: 'string',
            nullable: true,
            title: 'Unterschrift / Dienstsiegel',
            maxLength: 100
        },
        migration_law_approval_notice_case_number: {
            type: 'string',
            nullable: true,
            title: 'Aktenzeichen',
            maxLength: 100
        },
        migration_law_approval_notice_decision_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum des Bescheids'
        },
        migration_law_approval_notice_permit_type: {
            type: 'string',
            nullable: true,
            title: 'Art des Aufenthaltstitels',
            maxLength: 100
        },
        migration_law_approval_notice_validity_period: {
            type: 'string',
            nullable: true,
            title: 'Gültigkeitszeitraum',
            maxLength: 100
        },
        migration_law_approval_notice_conditions: {
            type: 'string',
            nullable: true,
            title: 'Auflagen'
        },
        migration_law_approval_notice_pickup_deadline: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Abholfrist'
        },
        migration_law_approval_notice_issuing_authority: {
            type: 'string',
            nullable: true,
            title: 'Ausstellende Behörde',
            maxLength: 100
        },
        migration_law_hearing_letter_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum des Schreibens'
        },
        migration_law_hearing_letter_response_deadline: {
            type: 'string',
            nullable: true,
            title: 'Frist zur Stellungnahme',
            maxLength: 100
        },
        migration_law_hearing_letter_intended_measure_justification: {
            type: 'string',
            nullable: true,
            title: 'Begründung der beabsichtigten Maßnahme'
        },
        migration_law_hearing_letter_legal_advice: {
            type: 'string',
            nullable: true,
            title: 'Rechtsbehelfshinweis'
        },
        migration_law_hearing_letter_requested_documents: {
            type: 'string',
            nullable: true,
            title: 'Dokumente beizufügen'
        },
        migration_law_cooperation_letter_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum des Schreibens'
        },
        migration_law_cooperation_letter_file_number: {
            type: 'string',
            nullable: true,
            title: 'Aktenzeichen',
            maxLength: 100
        },
        migration_law_cooperation_letter_specified_obligations: {
            type: 'string',
            nullable: true,
            title: 'Benannte Mitwirkungspflichten'
        },
        migration_law_cooperation_letter_non_cooperation_consequences: {
            type: 'string',
            nullable: true,
            title: 'Rechtsfolgen bei Nichtmitwirkung'
        },
        migration_law_cooperation_letter_deadlines: {
            type: 'string',
            nullable: true,
            title: 'Fristen',
            maxLength: 200
        },
        migration_law_cooperation_letter_attachments: {
            type: 'string',
            nullable: true,
            title: 'Anlagen / Formulare'
        },
        migration_law_other_letters_issuing_authority: {
            type: 'string',
            nullable: true,
            title: 'Absenderbehörde',
            maxLength: 100
        },
        migration_law_other_letters_file_number: {
            type: 'string',
            nullable: true,
            title: 'Aktenzeichen / Geschäftszeichen',
            maxLength: 100
        },
        migration_law_other_letters_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum des Schreibens'
        },
        migration_law_other_letters_subject: {
            type: 'string',
            nullable: true,
            title: 'Betreff',
            maxLength: 200
        },
        migration_law_other_letters_matter_purpose: {
            type: 'string',
            nullable: true,
            title: 'Anliegen / Inhalt des Schreibens'
        },
        migration_law_other_letters_legal_basis: {
            type: 'string',
            nullable: true,
            title: 'Rechtsgrundlage (sofern genannt)',
            maxLength: 200
        },
        migration_law_other_letters_deadlines: {
            type: 'string',
            nullable: true,
            title: 'Fristen',
            maxLength: 200
        },
        migration_law_other_letters_action_required: {
            type: 'string',
            nullable: true,
            title: 'Handlungsaufforderung'
        },
        civil_law_file_reference: {
            type: 'string',
            nullable: true,
            title: 'Aktenzeichen',
            maxLength: 100
        },
        civil_law_document_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Dokumentdatum'
        },
        civil_law_subject_line: {
            type: 'string',
            nullable: true,
            title: 'Betreff',
            maxLength: 255
        },
        civil_law_contract_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Vertragsdatum'
        },
        civil_law_contract_start_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Vertragsbeginn'
        },
        civil_law_contract_end_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Vertragsende'
        },
        civil_law_contract_duration: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Vertragslaufzeit in Monaten'
        },
        civil_law_contract_value: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Vertragswert'
        },
        civil_law_contract_object: {
            type: 'string',
            nullable: true,
            title: 'Vertragsgegenstand',
            maxLength: 255
        },
        civil_law_termination_notice_period: {
            type: 'string',
            nullable: true,
            title: 'Kündigungsfrist',
            maxLength: 100
        },
        civil_law_notarial_certification_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Notarielle Beurkundung Datum'
        },
        civil_law_purchase_price: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Kaufpreis'
        },
        civil_law_purchase_price_components: {
            type: 'string',
            nullable: true,
            title: 'Bestandteile Kaufpreis'
        },
        civil_law_accessories_sold_separately: {
            type: 'boolean',
            nullable: true,
            title: 'Zubehör separat veräußert?'
        },
        civil_law_purchase_contract_file_reference: {
            type: 'string',
            nullable: true,
            title: 'Kaufvertragsaktenzeichen',
            maxLength: 100
        },
        civil_law_handover_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Übergabedatum'
        },
        civil_law_purchase_price_paid: {
            type: 'boolean',
            nullable: true,
            title: 'Kaufpreis bezahlt'
        },
        civil_law_purchase_price_payment_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Zahlung Kaufpreis'
        },
        civil_law_purchase_price_paid_boolean: {
            type: 'boolean',
            nullable: true,
            title: 'Kaufpreis bezahlt'
        },
        civil_law_purchase_price_paid_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Kaufpreis bezahlt'
        },
        civil_law_purchase_price_paid_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Höhe bezahlten Kaufpreises'
        },
        civil_law_purchase_object: {
            type: 'string',
            nullable: true,
            title: 'Kaufgegenstand',
            maxLength: 255
        },
        civil_law_purchase_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Kaufdatum'
        },
        civil_law_delivery_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Lieferdatum'
        },
        civil_law_warranty_period: {
            type: 'string',
            nullable: true,
            title: 'Gewährleistungsfrist',
            maxLength: 100
        },
        civil_law_defects: {
            type: 'string',
            nullable: true,
            title: 'Mängel'
        },
        civil_law_defects_present: {
            type: 'boolean',
            nullable: true,
            title: 'Sachmängel vorhanden'
        },
        civil_law_vehicle_make: {
            type: 'string',
            nullable: true,
            title: 'Fahrzeugmarke',
            maxLength: 100
        },
        civil_law_vehicle_model: {
            type: 'string',
            nullable: true,
            title: 'Fahrzeugmodell',
            maxLength: 100
        },
        civil_law_vehicle_year: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Baujahr'
        },
        civil_law_vehicle_mileage: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Kilometerstand'
        },
        civil_law_vehicle_vin: {
            type: 'string',
            nullable: true,
            title: 'Fahrgestellnummer',
            maxLength: 50
        },
        civil_law_damage_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Schadenshöhe'
        },
        civil_law_damage_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Schadensdatum'
        },
        civil_law_damage_description: {
            type: 'string',
            nullable: true,
            title: 'Schadensbeschreibung'
        },
        civil_law_damage_cause: {
            type: 'string',
            nullable: true,
            title: 'Schadensursache',
            maxLength: 255
        },
        civil_law_liability_percentage: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,3}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Haftungsquote in Prozent'
        },
        civil_law_insurance_claim_number: {
            type: 'string',
            nullable: true,
            title: 'Versicherungsschadensnummer',
            maxLength: 100
        },
        civil_law_court_name: {
            type: 'string',
            nullable: true,
            title: 'Gericht',
            maxLength: 255
        },
        civil_law_case_number: {
            type: 'string',
            nullable: true,
            title: 'Geschäftsnummer',
            maxLength: 100
        },
        civil_law_hearing_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Verhandlungstermin'
        },
        civil_law_judgment_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Urteilsdatum'
        },
        civil_law_claim_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Streitwert'
        },
        civil_law_court_costs: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Gerichtskosten'
        },
        civil_law_payment_due_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Fälligkeitsdatum'
        },
        civil_law_interest_rate: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,3}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Zinssatz'
        },
        civil_law_default_interest: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Verzugszinsen'
        },
        general_law_file_ref: {
            type: 'string',
            title: 'Aktenzeichen',
            maxLength: 100
        },
        general_law_subject: {
            type: 'string',
            title: 'Betreff'
        },
        general_law_doc_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Dokumentendatum'
        },
        general_law_prior_ref: {
            type: 'string',
            title: 'Zeichen unseres Schreibens',
            maxLength: 200
        },
        general_law_appendices: {
            type: 'string',
            title: 'Anlagen'
        },
        general_law_invoice_number: {
            type: 'string',
            title: 'Rechnungsnummer',
            maxLength: 100
        },
        general_law_invoice_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Rechnungsdatum'
        },
        general_law_due_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Fälligkeitsdatum'
        },
        general_law_amount_total: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Gesamtbetrag'
        },
        general_law_amount_net: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Nettobetrag'
        },
        general_law_vat: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'MwSt / Umsatzsteuer'
        },
        general_law_payment_terms: {
            type: 'string',
            title: 'Zahlungsbedingungen'
        },
        general_law_court_name: {
            type: 'string',
            title: 'Gericht',
            maxLength: 200
        },
        general_law_case_number: {
            type: 'string',
            title: 'Geschäftsnummer',
            maxLength: 100
        },
        general_law_hearing_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Verhandlungstermin'
        },
        general_law_judgment_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Urteilsdatum'
        },
        general_law_court_costs: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Gerichtskosten'
        },
        medicine_law_medical_report_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum des Berichts'
        },
        medicine_law_medical_report_treatment_period: {
            type: 'string',
            nullable: true,
            title: 'Zeitraum der Behandlung',
            maxLength: 200
        },
        medicine_law_medical_report_diagnosis_icd_code: {
            type: 'string',
            nullable: true,
            title: 'Diagnose ICD-Code',
            maxLength: 50
        },
        medicine_law_medical_report_diagnosis_short_text: {
            type: 'string',
            nullable: true,
            title: 'Diagnose Kurztext',
            maxLength: 200
        },
        medicine_law_medical_report_treatment_measures: {
            type: 'string',
            nullable: true,
            title: 'Therapie Behandlungsmaßnahmen'
        },
        medicine_law_medical_report_surgery_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'OP-Datum'
        },
        medicine_law_medical_report_complications: {
            type: 'string',
            nullable: true,
            title: 'Komplikationen'
        },
        medicine_law_medical_report_further_treatment: {
            type: 'string',
            nullable: true,
            title: 'Weitere Behandlung'
        },
        medicine_law_hospital_records_admission_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Aufnahmedatum'
        },
        medicine_law_hospital_records_discharge_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Entlassungsdatum'
        },
        medicine_law_hospital_records_station: {
            type: 'string',
            nullable: true,
            title: 'Station',
            maxLength: 100
        },
        medicine_law_hospital_records_diagnoses_icd_codes: {
            type: 'string',
            nullable: true,
            title: 'Diagnosen ICD-Codes'
        },
        medicine_law_hospital_records_operations: {
            type: 'string',
            nullable: true,
            title: 'Operationen'
        },
        medicine_law_hospital_records_operation_date: {
            type: 'string',
            nullable: true,
            title: 'Operation Datum'
        },
        medicine_law_hospital_records_medication_during_stay: {
            type: 'string',
            nullable: true,
            title: 'Medikation während Aufenthalt'
        },
        medicine_law_hospital_records_documented_complications: {
            type: 'string',
            nullable: true,
            title: 'Dokumentierte Komplikationen'
        },
        medicine_law_hospital_records_discharge_prognosis: {
            type: 'string',
            nullable: true,
            title: 'Prognose'
        },
        medicine_law_medical_expertise_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum des Gutachtens'
        },
        medicine_law_medical_expertise_question_posed: {
            type: 'string',
            nullable: true,
            title: 'Fragestellung des Gutachtens'
        },
        medicine_law_medical_expertise_medical_assessment: {
            type: 'string',
            nullable: true,
            title: 'Medizinische Einschätzung'
        },
        medicine_law_medical_expertise_justification: {
            type: 'string',
            nullable: true,
            title: 'Begründung des Ergebnisses'
        },
        medicine_law_medical_expertise_result: {
            type: 'string',
            nullable: true,
            title: 'Ergebnis des Gutachtens'
        },
        medicine_law_laboratory_results_examination_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum der Untersuchung'
        },
        medicine_law_laboratory_results_examination_type: {
            type: 'string',
            nullable: true,
            title: 'Art der Untersuchung',
            maxLength: 200
        },
        medicine_law_laboratory_results: {
            type: 'string',
            nullable: true,
            title: 'Befund'
        },
        medicine_law_laboratory_results_relevant_deviations: {
            type: 'string',
            nullable: true,
            title: 'Relevante Abweichungen'
        },
        medicine_law_laboratory_results_further_investigation_recommendation: {
            type: 'string',
            nullable: true,
            title: 'Empfehlung zur weiteren Abklärung'
        },
        medicine_law_health_insurance_letter_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum des Schreibens'
        },
        medicine_law_health_insurance_letter_reference_to_application: {
            type: 'string',
            nullable: true,
            title: 'Bezug auf Schreiben'
        },
        medicine_law_health_insurance_letter_decision: {
            type: 'string',
            nullable: true,
            title: 'Entscheidung der Krankenkasse',
            maxLength: 100
        },
        medicine_law_health_insurance_letter_decision_justification: {
            type: 'string',
            nullable: true,
            title: 'Begründung der Entscheidung'
        },
        medicine_law_health_insurance_letter_legal_remedy_instruction: {
            type: 'string',
            nullable: true,
            title: 'Rechtsbehelfsbelehrung'
        },
        medicine_law_medical_bill_invoice_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Rechnungsdatum'
        },
        medicine_law_medical_bill_invoice_number: {
            type: 'string',
            nullable: true,
            title: 'Rechnungsnummer',
            maxLength: 100
        },
        medicine_law_medical_bill_service_period: {
            type: 'string',
            nullable: true,
            title: 'Zeitraum der Leistung',
            maxLength: 200
        },
        medicine_law_medical_bill_services_list: {
            type: 'string',
            nullable: true,
            title: 'Auflistung der Leistungen'
        },
        medicine_law_medical_bill_total_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Gesamtsumme der Rechnung'
        },
        medicine_law_medical_bill_cost_bearer: {
            type: 'string',
            nullable: true,
            title: 'Kostenträger',
            maxLength: 100
        },
        medicine_law_medical_bill_payment_deadline: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Zahlungsfrist'
        },
        field: {
            type: 'string',
            title: 'Rechtsgebiet',
            maxLength: 100
        },
        topic: {
            type: 'string',
            title: 'Rechtsthema',
            maxLength: 100
        },
        external_case_id: {
            type: 'string',
            nullable: true,
            maxLength: 100
        }
    },
    required: ['created_at', 'updated_at']
} as const;

export const $LawDataRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        labor_law_beginning_of_employment: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Beginn des Arbeitsverhältnisses'
        },
        labor_law_end_of_employment: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Ende des Arbeitsverhältnisses'
        },
        labor_law_job_title: {
            type: 'string',
            title: 'Berufsbezeichnung',
            maxLength: 100
        },
        labor_law_yearly_gross_salary: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Gehalt, jährlich, brutto'
        },
        labor_law_monthly_gross_salary: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Gehalt, monatlich, brutto'
        },
        labor_law_monthly_working_days: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Arbeitsstunden pro Monat'
        },
        labor_law_vacation_days: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Urlaubstage'
        },
        labor_law_work_hours_per_week: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Arbeitsstunden pro Woche'
        },
        labor_law_is_employee_in_probation_period: {
            type: 'boolean',
            nullable: true,
            title: 'Arbeitnehmer in Probezeit'
        },
        labor_law_employee_probation_period_end_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Ende der Probezeit'
        },
        labor_law_place_of_work: {
            type: 'string',
            title: 'Arbeitsort',
            maxLength: 100
        },
        labor_law_different_place_of_work: {
            type: 'string',
            title: 'Abweichender Arbeitsort',
            maxLength: 100
        },
        labor_law_fixed_term_contract: {
            type: 'boolean',
            nullable: true,
            title: 'Befristetes Arbeitsverhältnis'
        },
        labor_law_fixed_term_contract_duration: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Ende befristetes Arbeitsverhältnis'
        },
        labor_law_special_payments: {
            type: 'string',
            title: 'Sonderzahlungen',
            maxLength: 100
        },
        labor_law_special_payments_amount: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Höhe der Sonderzahlungen'
        },
        labor_law_special_protection_against_dismissal: {
            type: 'boolean',
            nullable: true,
            title: 'Sonderkündigungsschutz'
        },
        labor_law_work_council: {
            type: 'boolean',
            nullable: true,
            title: 'Betriebsrat'
        },
        labor_law_collective_agreement: {
            type: 'boolean',
            nullable: true,
            title: 'Tarifvertrag'
        },
        labor_law_company_agreement: {
            type: 'boolean',
            nullable: true,
            title: 'Betriebsvereinbarung'
        },
        labor_law_notice_period: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Kündigungsfrist in Monaten'
        },
        labor_law_signature_of_employer: {
            type: 'boolean',
            nullable: true,
            title: 'Unterschrift Arbeitgeber'
        },
        labor_law_local_transfer_clause: {
            type: 'boolean',
            nullable: true,
            title: 'Örtliche Versetzungsklausel'
        },
        labor_law_VSOP: {
            type: 'boolean',
            nullable: true,
            title: 'VSOP'
        },
        labor_law_LTI: {
            type: 'boolean',
            nullable: true,
            title: 'LTI'
        },
        labor_law_termination_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Kündigung durch Arbeitgeber'
        },
        labor_law_termination_date_effective: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Kündigung erfolgt zu welchem Datum'
        },
        labor_law_termination_employer_more_than_10_employees: {
            type: 'boolean',
            nullable: true,
            title: 'Arbeitgeber hat mehr als 10 Mitarbeiter'
        },
        labor_law_termination_access_to_termination_to_employee: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Zugang Kündigung beim Arbeitnehmer'
        },
        labor_law_notice_period_observed: {
            type: 'boolean',
            nullable: true,
            title: 'Kündigungsfrist eingehalten'
        },
        labor_law_termination_without_notice: {
            type: 'boolean',
            nullable: true,
            title: 'Fristlose Kündigung'
        },
        labor_law_reason_for_termination_given: {
            type: 'boolean',
            nullable: true,
            title: 'Kündigungsgrund angegeben'
        },
        labor_law_exemption_revocable: {
            type: 'boolean',
            nullable: true,
            title: 'Freistellung widerruflich'
        },
        labor_law_exemption_irrevocable: {
            type: 'boolean',
            nullable: true,
            title: 'Freistellung unwiderruflich'
        },
        labor_law_return_of_company_property: {
            type: 'boolean',
            nullable: true,
            title: 'Rückgabe Firmeneigentum'
        },
        labor_law_termination_operational_reasons: {
            type: 'boolean',
            nullable: true,
            title: '1a KSchG dringende betriebliche Kündigung'
        },
        labor_law_company_hearing: {
            type: 'boolean',
            nullable: true,
            title: 'Betriebsanhörung durchgeführt'
        },
        labor_law_reaction_company_hering: {
            type: 'string',
            nullable: true,
            title: 'Reaktion des Betriebsrats'
        },
        labor_law_termination_authorization: {
            type: 'string',
            nullable: true,
            title: 'Befugnis zur Kündigung'
        },
        labor_law_warning_letter_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Abmahnung'
        },
        labor_law_warning_letter_access_to_warning_letter_to_employee: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Zugang Abmahnung beim Arbeitnehmer'
        },
        labor_law_warning_letter_incident_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum des Vorfalls der zur Abmahnung geführt hat'
        },
        labor_law_warning_letter_incident_time: {
            type: 'string',
            format: 'time',
            nullable: true,
            title: 'Uhrzeit des Vorfalls der zur Abmahnung geführt hat'
        },
        labor_law_warning_letter_incident_location: {
            type: 'string',
            title: 'Ort des Vorfalls der zur Abmahnung geführt hat',
            maxLength: 100
        },
        labor_law_warning_letter_reason: {
            type: 'string',
            title: 'Grund der Abmahnung'
        },
        labor_law_termination_agreement_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Aufhebungsvertrag'
        },
        labor_law_settlement_agreement_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Abwicklungsvertrag'
        },
        labor_law_termination_agreement_termination_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Beendigung Arbeitsverhältnis'
        },
        labor_law_termination_is_agreement_severance_pay: {
            type: 'boolean',
            nullable: true,
            title: 'Abfindung vereinbart'
        },
        labor_law_termination_agreement_severance_pay_amount: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Höhe der Abfindung'
        },
        labor_law_special_sentence: {
            type: 'boolean',
            nullable: true,
            title: 'Zur Vermeidung Kündigung aus dringenden betrieblichen Gründen'
        },
        labor_law_sprinter_clause: {
            type: 'boolean',
            nullable: true,
            title: 'Sprinterklausel'
        },
        labor_law_percent_sprinter_clause: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Prozent Sprinterklausel'
        },
        labor_law_certificate_clause: {
            type: 'boolean',
            nullable: true,
            title: 'Zeugnisklausel'
        },
        labor_law_grade_certificate_clause: {
            type: 'string',
            title: 'Note Zeugnisklausel'
        },
        labor_law_child_allowances: {
            type: 'boolean',
            nullable: true,
            title: 'Kinderfreibeträge'
        },
        labor_law_married: {
            type: 'boolean',
            nullable: true,
            title: 'Verheiratet'
        },
        labor_law_dependent_children: {
            type: 'boolean',
            nullable: true,
            title: 'Unterhaltspflichtige Kinder'
        },
        labor_law_amount_dependent_children: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Anzahl unterhaltspflichtiger Kinder'
        },
        labor_law_years_of_employment: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Jahre der Betriebszugehörigkeit'
        },
        labor_law_total_gross_salary: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Gesamtgehalt Brutto'
        },
        labor_law_severance_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Abfindungssumme'
        },
        labor_law_works_council_membership: {
            type: 'boolean',
            nullable: true,
            title: 'Mitgliedschaft Betriebsrat'
        },
        labor_law_pregnancy: {
            type: 'boolean',
            nullable: true,
            title: 'Schwangerschaft'
        },
        labor_law_disability: {
            type: 'boolean',
            nullable: true,
            title: 'Behinderung'
        },
        labor_law_special_personal_circumstances: {
            type: 'boolean',
            nullable: true,
            title: 'Besondere persönliche Umstände'
        },
        traffic_law_place_of_accident: {
            type: 'string',
            minLength: 1,
            title: 'Unfallort',
            maxLength: 100
        },
        traffic_law_date_of_accident: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Unfalltag'
        },
        traffic_law_time_of_accident: {
            type: 'string',
            format: 'time',
            nullable: true,
            title: 'Uhrzeit Unfall'
        },
        traffic_law_driving_ban_duration: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Fahrverbot Dauer'
        },
        traffic_law_driving_ban: {
            type: 'boolean',
            nullable: true,
            title: 'Fahrverbot verhängt'
        },
        traffic_law_licenseplate: {
            type: 'string',
            minLength: 1,
            title: 'KFZ-Kennzeichen',
            maxLength: 100
        },
        traffic_law_vehicle_type_and_brand: {
            type: 'string',
            minLength: 1,
            title: 'Fahrzeugtyp und Marke',
            maxLength: 100
        },
        traffic_law_amount_of_fine: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Bußgeldhöhe'
        },
        traffic_law_date_of_fine: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Bußgeldbescheid'
        },
        traffic_law_speed_allowed: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Erlaubte Geschwindigkeit'
        },
        traffic_law_speed_driven: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Gefahrene Geschwindigkeit'
        },
        traffic_law_speed_too_high: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Überschreitung Geschwindigkeit'
        },
        traffic_law_points_for_offense: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Punkte'
        },
        traffic_law_date_of_offense: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum der Tat'
        },
        traffic_law_time_of_offense: {
            type: 'string',
            format: 'time',
            nullable: true,
            title: 'Uhrzeit der Tat'
        },
        traffic_law_place_of_offense: {
            type: 'string',
            minLength: 1,
            title: 'Ort der Tat',
            maxLength: 100
        },
        traffic_law_violation_type: {
            type: 'string',
            minLength: 1,
            title: 'Tatvorwurf',
            maxLength: 100
        },
        traffic_law_violated_section: {
            type: 'string',
            minLength: 1,
            title: 'Verletzte Vorschrift',
            maxLength: 100
        },
        traffic_law_file_number: {
            type: 'string',
            minLength: 1,
            title: 'Aktenzeichen',
            maxLength: 100
        },
        traffic_law_driver_logbook_required: {
            type: 'boolean',
            nullable: true,
            title: 'Fahrtenbuch erforderlich'
        },
        traffic_law_licenseplate_at_fault_driver: {
            type: 'string',
            minLength: 1,
            title: 'KFZ-Kennzeichen des Unfallverursachers',
            maxLength: 100
        },
        traffic_law_licenseplate_victim_driver: {
            type: 'string',
            minLength: 1,
            title: 'KFZ-Kennzeichen des Unfallgeschädigten',
            maxLength: 100
        },
        traffic_law_injured: {
            type: 'boolean',
            nullable: true,
            title: 'Verletzte'
        },
        traffic_law_other_damages: {
            type: 'boolean',
            nullable: true,
            title: 'Andere Sachschäden'
        },
        traffic_law_mark_and_type_of_at_fault_driver: {
            type: 'string',
            minLength: 1,
            title: 'Unfallverursacher - Marke, Typ des Fahrzeugs',
            maxLength: 100
        },
        traffic_law_mark_and_type_of_victim_driver: {
            type: 'string',
            minLength: 1,
            title: 'Unfallgeschädigter - Marke, Typ des Fahrzeugs',
            maxLength: 100
        },
        traffic_law_at_fault_driver_insurer: {
            type: 'string',
            minLength: 1,
            title: 'Unfallverursacher - Versicherer',
            maxLength: 100
        },
        traffic_law_victim_driver_insurer: {
            type: 'string',
            minLength: 1,
            title: 'Unfallgeschädigter - Versicherer',
            maxLength: 100
        },
        traffic_law_at_fault_driver_insurance_number: {
            type: 'string',
            minLength: 1,
            title: 'Unfallverursacher - Vers.-Nr.',
            maxLength: 100
        },
        traffic_law_victim_driver_insurance_number: {
            type: 'string',
            minLength: 1,
            title: 'Unfallgeschädigter - Vers.-Nr.',
            maxLength: 100
        },
        traffic_law_at_fault_driver_green_card_number: {
            type: 'string',
            minLength: 1,
            title: 'Unfallverursacher - Nr. der Grünen Karte',
            maxLength: 100
        },
        traffic_law_victim_driver_green_card_number: {
            type: 'string',
            minLength: 1,
            title: 'Unfallgeschädigter - Nr. der Grünen Karte',
            maxLength: 100
        },
        traffic_law_at_fault_driver_insurance_expiry_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Unfallverursacher - Vers.-Schein gültig bis'
        },
        traffic_law_victim_driver_insurance_expiry_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Unfallgeschädigter - Vers.-Schein gültig bis'
        },
        traffic_law_at_fault_driver_drivers_license_issued_by: {
            type: 'string',
            minLength: 1,
            title: 'Unfallverursacher - Führerschein ausgestellt durch',
            maxLength: 100
        },
        traffic_law_victim_driver_drivers_license_issued_by: {
            type: 'string',
            minLength: 1,
            title: 'Unfallgeschädigter - Führerschein ausgestellt durch',
            maxLength: 100
        },
        traffic_law_at_fault_driver_drivers_license_valid_until: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Unfallverursacher - Führerschein gültig bis'
        },
        traffic_law_victim_driver_license_valid_until: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Unfallgeschädigter - Führerschein gültig bis'
        },
        traffic_law_date_of_report: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Sachverständigengutachten'
        },
        traffic_law_place_of_inspection: {
            type: 'string',
            minLength: 1,
            title: 'Besichtigungsort',
            maxLength: 100
        },
        traffic_law_date_of_inspection: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Besichtigungsdatum'
        },
        traffic_law_time_of_inspection: {
            type: 'string',
            format: 'time',
            nullable: true,
            title: 'Besichtigungszeit'
        },
        traffic_law_insurance_holder: {
            type: 'string',
            minLength: 1,
            title: 'Versicherungsnehmer',
            maxLength: 100
        },
        traffic_law_insurance: {
            type: 'string',
            minLength: 1,
            title: 'Versicherung',
            maxLength: 100
        },
        traffic_law_police_case_number: {
            type: 'string',
            minLength: 1,
            title: 'Polizeiliches Aktenzeichen',
            maxLength: 100
        },
        traffic_law_repair_costs_without_vat: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Reparaturkosten Netto'
        },
        traffic_law_repair_costs_with_vat: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Reparaturkosten Brutto'
        },
        traffic_law_replacement_value: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Wiederbeschaffungswert'
        },
        traffic_law_differencial_tax: {
            type: 'boolean',
            nullable: true,
            title: 'Differenzsteuer'
        },
        traffic_law_regular_tax: {
            type: 'boolean',
            nullable: true,
            title: 'Regelsteuer'
        },
        traffic_law_merantile_value_loss: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Merkantile Wertminderung'
        },
        traffic_law_loss_of_use_per_day: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Nutzungsausfallentschädigung pro Tag'
        },
        traffic_law_repair_duration: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Reparaturdauer Tage'
        },
        traffic_law_residual_value: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Restwert Brutto'
        },
        traffic_law_reregistration_cost: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Ummeldekosten'
        },
        traffic_law_damage_scope: {
            type: 'string',
            minLength: 1,
            title: 'Schadensumfang'
        },
        traffic_law_expert_report_number: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Gutachten Nummer'
        },
        traffic_law_insurance_policy_number: {
            type: 'string',
            minLength: 1,
            title: 'Versicherungsscheinnummer',
            maxLength: 100
        },
        traffic_law_damage_number: {
            type: 'string',
            minLength: 1,
            title: 'Schadensnummer',
            maxLength: 100
        },
        traffic_law_expert_cost: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Sachverständigenkosten'
        },
        traffic_law_cost_per_scale: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Kostenpauschale'
        },
        traffic_law_loss_amount_repair_case: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Restschaden Reparaturschaden'
        },
        traffic_law_loss_amount_total_damage_case: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Restschaden Totalschaden'
        },
        traffic_law_replacement_cost: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Wiederbeschaffungsaufwand'
        },
        traffic_law_date_of_infraction: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum der Ordnungswidrigkeit'
        },
        traffic_law_time_of_infraction: {
            type: 'string',
            format: 'time',
            nullable: true,
            title: 'Uhrzeit der Ordnungswidrigkeit'
        },
        traffic_law_place_of_infraction: {
            type: 'string',
            minLength: 1,
            title: 'Ort der Ordnungswidrigkeit',
            maxLength: 100
        },
        traffic_law_offense_infraction_description: {
            type: 'string',
            minLength: 1,
            title: 'Tatbestand'
        },
        traffic_law_legal_basis_infraction: {
            type: 'string',
            minLength: 1,
            title: 'Gesetzliche Grundlage'
        },
        traffic_law_evidence_infraction: {
            type: 'string',
            minLength: 1,
            title: 'Beweismittel'
        },
        traffic_law_warning_fee_infraction: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Verwarnungsgeldbetrag'
        },
        traffic_law_payment_deadline: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Zahlungsfrist'
        },
        traffic_law_prosecution_number: {
            type: 'string',
            minLength: 1,
            title: 'Geschäftsnummer',
            maxLength: 100
        },
        traffic_law_place_of_issue: {
            type: 'string',
            minLength: 1,
            title: 'Ort der Ausstellung',
            maxLength: 100
        },
        traffic_law_date_of_issue: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum der Ausstellung'
        },
        traffic_law_time_of_issue: {
            type: 'string',
            format: 'time',
            nullable: true,
            title: 'Tag der Ausstellung'
        },
        traffic_law_charges: {
            type: 'string',
            minLength: 1,
            title: 'Tatvorwurf'
        },
        traffic_law_legal_basis: {
            type: 'string',
            minLength: 1,
            title: 'Gesetzliche Grundlage'
        },
        traffic_law_fine: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Geldstrafe'
        },
        traffic_law_daily_rate: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Höhe des Tagessatzes'
        },
        traffic_law_number_of_daily_rates: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Anzahl der Tagessätze'
        },
        traffic_law_procedure_costs: {
            type: 'string',
            minLength: 1,
            title: 'Verfahrenskosten'
        },
        traffic_law_date_of_crime: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum der Tat'
        },
        traffic_law_time_of_crime: {
            type: 'string',
            format: 'time',
            nullable: true,
            title: 'Uhrzeit der Tat'
        },
        traffic_law_place_of_crime: {
            type: 'string',
            minLength: 1,
            title: 'Ort der Tat',
            maxLength: 100
        },
        traffic_law_blood_alcohol_concentration: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Blutalkoholkonzentration'
        },
        traffic_law_appeal_instruction: {
            type: 'string',
            minLength: 1,
            title: 'Rechtsbehelfsbelehrung'
        },
        traffic_law_vehicle_age_months: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Fahrzeugalter in Monaten'
        },
        traffic_law_vehicle_mileage: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Fahrzeugleistung in km'
        },
        traffic_law_accident_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Unfallverursacher - Vers.-Schein gültig bis'
        },
        traffic_law_expert_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Unfallverursacher - Sachverständigengutachten'
        },
        traffic_law_net_replacement_value: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Nettowiederbeschaffungswert'
        },
        traffic_law_gross_replacement_value: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Bruttowiederbeschaffungswert'
        },
        traffic_law_net_gross_replacement_value: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Netto-Brutto-Wiederbeschaffungswert'
        },
        traffic_law_gross_gross_replacement_value: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Brutto-Brutto-Wiederbeschaffungswert'
        },
        traffic_law_calculated_total_damage_costs: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Gesamtschadenshöhe'
        },
        traffic_law_calculated_total_days: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Gesamttage'
        },
        traffic_law_repair_damage: {
            type: 'boolean',
            nullable: true,
            title: 'Reparaturschaden'
        },
        traffic_law_total_damage: {
            type: 'boolean',
            nullable: true,
            title: 'Totalschaden'
        },
        criminal_law_legal_classification_of_offense: {
            type: 'string',
            nullable: true,
            title: 'Vergehen auf der Grundlage von',
            maxLength: 128
        },
        criminal_law_date_of_offense: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum der Tat'
        },
        criminal_law_time_of_offense: {
            type: 'string',
            format: 'time',
            nullable: true,
            title: 'Uhrzeit der Tat'
        },
        criminal_law_place_of_offense: {
            type: 'string',
            nullable: true,
            title: 'Ort der Tat',
            maxLength: 128
        },
        criminal_law_penalty_infromation: {
            type: 'string',
            nullable: true,
            title: 'Strafe',
            maxLength: 128
        },
        criminal_law_number_of_daily_rates: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Tagessatz'
        },
        criminal_law_amount_of_daily_rates: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Betrag des Tagessatzes'
        },
        criminal_law_evidence: {
            type: 'string',
            nullable: true,
            title: 'Beweis',
            maxLength: 128
        },
        criminal_law_probation: {
            type: 'boolean',
            nullable: true,
            title: 'Bewährung'
        },
        criminal_law_prison_sentence: {
            type: 'boolean',
            nullable: true,
            title: 'Freiheitsstrafe'
        },
        criminal_law_duration_of_prison_sentence: {
            type: 'string',
            nullable: true,
            title: 'Dauer der Freiheitsstrafe',
            maxLength: 128
        },
        criminal_law_police_file_number: {
            type: 'string',
            nullable: true,
            title: 'Vorgangsnummer',
            maxLength: 128
        },
        criminal_law_report_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum der Anzeigenerstattung'
        },
        criminal_law_report_time: {
            type: 'string',
            format: 'time',
            nullable: true,
            title: 'Uhrzeit der Anzeigenerstattung'
        },
        criminal_law_offense_type: {
            type: 'string',
            nullable: true,
            title: 'Art des Delikts',
            maxLength: 256
        },
        criminal_law_incident_description: {
            type: 'string',
            nullable: true,
            title: 'Sachverhalt'
        },
        criminal_law_physical_evidence: {
            type: 'string',
            nullable: true,
            title: 'Beschreibung der Beweismittel'
        },
        criminal_law_evidence_location: {
            type: 'string',
            nullable: true,
            title: 'Standort der Beweismittel',
            maxLength: 256
        },
        criminal_law_damage_description: {
            type: 'string',
            nullable: true,
            title: 'Beschreibung des Schadens'
        },
        criminal_law_damage_value: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Schadenshöhe in EUR'
        },
        criminal_law_prosecution_file_number: {
            type: 'string',
            nullable: true,
            title: 'Aktenzeichen der Staatsanwaltschaft',
            maxLength: 128
        },
        criminal_law_charge_description: {
            type: 'string',
            nullable: true,
            title: 'Anklagesatz'
        },
        criminal_law_means_of_evidence: {
            type: 'string',
            nullable: true,
            title: 'Beweismittel'
        },
        criminal_law_applicable_laws: {
            type: 'string',
            nullable: true,
            title: 'Anwendbare Vorschriften'
        },
        criminal_law_preliminary_proceedings_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum der Einleitung des Ermittlungsverfahrens'
        },
        criminal_law_indictment_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum der Anklageschrift'
        },
        criminal_law_indictment_delivery_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum der Zustellung der Anklageschrift'
        },
        family_law_divorce_settlement_agreement: {
            type: 'boolean',
            nullable: true,
            title: 'Scheidungsfolgenvereinbarung'
        },
        family_law_marriage_contract_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Ehevertragsdatum'
        },
        family_law_average_net_income: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Durchschnittliches Nettoeinkommen'
        },
        family_law_children: {
            type: 'boolean',
            nullable: true,
            title: 'Kinder vorhanden'
        },
        family_law_registry_office_location: {
            type: 'string',
            nullable: true,
            title: 'Standesamt Ort',
            maxLength: 100
        },
        family_law_date_of_marriage: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Eheschließungsdatum'
        },
        family_law_marriage_register_number: {
            type: 'string',
            nullable: true,
            title: 'Eheregisternummer',
            maxLength: 100
        },
        family_law_separation_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Trennungsdatumdatum'
        },
        family_law_birth_register_number: {
            type: 'string',
            nullable: true,
            title: 'Geburtsurkundennummer',
            maxLength: 100
        },
        family_law_birth_register_office_location: {
            type: 'string',
            nullable: true,
            title: 'Standesamt Geburtsurkunde',
            maxLength: 100
        },
        social_law_application_file_reference: {
            type: 'string',
            nullable: true,
            title: 'Aktenzeichen',
            maxLength: 256
        },
        social_law_legal_basis: {
            type: 'string',
            nullable: true,
            title: 'Rechtsgrundlage',
            maxLength: 256
        },
        social_law_benefit_type: {
            type: 'string',
            nullable: true,
            title: 'Leistungsart',
            maxLength: 256
        },
        social_law_own_income_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Höhe eigenes Einkommen'
        },
        social_law_social_benefit_type: {
            type: 'string',
            nullable: true,
            title: 'Art der Sozialleistung',
            maxLength: 256
        },
        social_law_residence_status: {
            type: 'string',
            nullable: true,
            title: 'Aufenthaltsstatus',
            maxLength: 256
        },
        social_law_income_type: {
            type: 'string',
            nullable: true,
            title: 'Art des Einkommens',
            maxLength: 256
        },
        social_law_asset_type: {
            type: 'string',
            nullable: true,
            title: 'Art des Vermögens',
            maxLength: 256
        },
        social_law_approval_file_reference: {
            type: 'string',
            nullable: true,
            title: 'Aktenzeichen',
            maxLength: 256
        },
        social_law_approval_notice_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum des Bescheids'
        },
        social_law_approval_legal_basis: {
            type: 'string',
            nullable: true,
            title: 'Rechtsgrundlage der Entscheidung',
            maxLength: 256
        },
        social_law_approval_internal_reference: {
            type: 'string',
            nullable: true,
            title: 'Interne Referenznummer der Behörde',
            maxLength: 256
        },
        social_law_approved_benefit_type: {
            type: 'string',
            nullable: true,
            title: 'Bewilligte Leistung (Art)',
            maxLength: 256
        },
        social_law_approved_benefit_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Bewilligte Leistung (Betrag)'
        },
        social_law_approved_benefit_period: {
            type: 'string',
            nullable: true,
            title: 'Bewilligte Leistung (Zeitraum)',
            maxLength: 256
        },
        social_law_follow_up_application_notes: {
            type: 'string',
            nullable: true,
            title: 'Hinweise zu Folgeanträgen',
            maxLength: 512
        },
        social_law_approval_period_start: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Bewilligungszeitraum Beginn'
        },
        social_law_approval_period_end: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Bewilligungszeitraum Ende'
        },
        social_law_regelbedarf_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Regelbedarf'
        },
        social_law_housing_costs_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Kosten für Unterkunft und Heizung'
        },
        social_law_total_need_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Gesamtbedarf'
        },
        social_law_monthly_payment_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Monatliche Leistung'
        },
        social_law_employment_income: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Erwerbseinkommen'
        },
        social_law_other_income: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Sonstiges Einkommen'
        },
        social_law_creditable_income: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Anrechenbares Einkommen'
        },
        social_law_change_file_reference: {
            type: 'string',
            nullable: true,
            title: 'Aktenzeichen',
            maxLength: 256
        },
        social_law_change_notification_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum der Mitteilung'
        },
        social_law_affected_benefit: {
            type: 'string',
            nullable: true,
            title: 'Betroffene Leistung',
            maxLength: 256
        },
        social_law_change_description: {
            type: 'string',
            nullable: true,
            title: 'Beschreibung der Änderung',
            maxLength: 256
        },
        social_law_change_reason: {
            type: 'string',
            nullable: true,
            title: 'Grund der Änderung',
            maxLength: 256
        },
        social_law_attachment_list: {
            type: 'string',
            nullable: true,
            title: 'Anlagenliste',
            maxLength: 512
        },
        social_law_rejection_file_reference: {
            type: 'string',
            nullable: true,
            title: 'Aktenzeichen',
            maxLength: 256
        },
        social_law_rejection_legal_norm: {
            type: 'string',
            nullable: true,
            title: 'Rechtsnorm',
            maxLength: 256
        },
        social_law_rejection_reason: {
            type: 'string',
            nullable: true,
            title: 'Ablehnungsgrund',
            maxLength: 512
        },
        social_law_rejection_notice_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum des Bescheids'
        },
        social_law_revocation_file_reference: {
            type: 'string',
            nullable: true,
            title: 'Aktenzeichen',
            maxLength: 256
        },
        social_law_revocation_legal_norm: {
            type: 'string',
            nullable: true,
            title: 'Rechtsnorm',
            maxLength: 256
        },
        social_law_revocation_reason: {
            type: 'string',
            nullable: true,
            title: 'Begründung der Aufhebung',
            maxLength: 512
        },
        social_law_revocation_notice_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum des Bescheids'
        },
        social_law_revocation_reclaim_notes: {
            type: 'string',
            nullable: true,
            title: 'Hinweise zu Rückforderungen',
            maxLength: 512
        },
        social_law_revocation_benefit_type: {
            type: 'string',
            nullable: true,
            title: 'Leistungsart',
            maxLength: 256
        },
        social_law_revocation_period_start: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Aufhebungszeitraum Beginn'
        },
        social_law_revocation_period_end: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Aufhebungszeitraum Ende'
        },
        social_law_original_decision_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum des ursprünglichen Bescheids'
        },
        social_law_total_reclaim_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Gesamtforderung'
        },
        social_law_income_source: {
            type: 'string',
            nullable: true,
            title: 'Einkommensquelle',
            maxLength: 256
        },
        social_law_income_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Einkommensbetrag'
        },
        social_law_income_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum der Einnahme'
        },
        social_law_income_provider: {
            type: 'string',
            nullable: true,
            title: 'Einkommensgeber',
            maxLength: 256
        },
        social_law_notification_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum der Kenntnisnahme'
        },
        social_law_notification_source: {
            type: 'string',
            nullable: true,
            title: 'Quelle der Kenntnisnahme',
            maxLength: 256
        },
        social_law_violation_type: {
            type: 'string',
            nullable: true,
            title: 'Art der Pflichtverletzung',
            maxLength: 256
        },
        social_law_income_legal_basis: {
            type: 'string',
            nullable: true,
            title: 'Rechtsgrundlage Einkommensberücksichtigung',
            maxLength: 256
        },
        social_law_reclaim_legal_basis: {
            type: 'string',
            nullable: true,
            title: 'Rechtsgrundlage Erstattung',
            maxLength: 256
        },
        social_law_notification_legal_basis: {
            type: 'string',
            nullable: true,
            title: 'Rechtsgrundlage Mitteilungspflicht',
            maxLength: 256
        },
        social_law_reclaim_file_reference: {
            type: 'string',
            nullable: true,
            title: 'Aktenzeichen',
            maxLength: 256
        },
        social_law_reclaim_legal_norm: {
            type: 'string',
            nullable: true,
            title: 'Rechtsnorm',
            maxLength: 256
        },
        social_law_reclaim_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Rückforderungsbetrag'
        },
        social_law_reclaim_payment_deadline: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: ' Datum Zahlungsfrist'
        },
        social_law_reclaim_notice_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum des Bescheids'
        },
        social_law_reclaim_payment_terms: {
            type: 'string',
            nullable: true,
            title: 'Zahlungsmodalitäten',
            maxLength: 512
        },
        social_law_objection_file_reference: {
            type: 'string',
            nullable: true,
            title: 'Aktenzeichen (des angegriffenen Bescheids)',
            maxLength: 256
        },
        social_law_objection_challenged_notice: {
            type: 'string',
            nullable: true,
            title: 'Angegriffener Bescheid',
            maxLength: 256
        },
        social_law_objection_reasoning: {
            type: 'string',
            nullable: true,
            title: 'Widerspruchsbegründung',
            maxLength: 256
        },
        social_law_objection_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum des Widerspruchs'
        },
        social_law_objection_suspension_request: {
            type: 'string',
            nullable: true,
            title: 'Antrag auf Aussetzung der Vollziehung',
            maxLength: 256
        },
        social_law_objection_evidence: {
            type: 'string',
            nullable: true,
            title: 'Beweismittel',
            maxLength: 512
        },
        social_law_notice_of_objection_file_reference: {
            type: 'string',
            nullable: true,
            title: 'Aktenzeichen',
            maxLength: 256
        },
        social_law_notice_of_objection_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Widerspruchbescheid Datum'
        },
        social_law_notice_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Bescheid Datum'
        },
        social_law_application_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Antrag Datum'
        },
        social_law_application_arrival_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Eingang Antrag Datum'
        },
        social_law_summary_grounds_opposition: {
            type: 'string',
            nullable: true,
            title: 'Begründung des Widerspruchs',
            maxLength: 256
        },
        social_law_lawsuit_file_reference: {
            type: 'string',
            nullable: true,
            title: 'Aktenzeichen',
            maxLength: 256
        },
        social_law_lawsuit_subject: {
            type: 'string',
            nullable: true,
            title: 'Gegenstand des Verfahrens',
            maxLength: 512
        },
        social_law_lawsuit_filing_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum der Klageerhebung'
        },
        social_law_lawsuit_evidence_requests: {
            type: 'string',
            nullable: true,
            title: 'Beweisanträge',
            maxLength: 512
        },
        social_law_lawsuit_attachment_list: {
            type: 'string',
            nullable: true,
            title: 'Anlagenliste',
            maxLength: 512
        },
        social_law_lawsuit_court_file_number: {
            type: 'string',
            nullable: true,
            title: 'BG-Nummer',
            maxLength: 256
        },
        social_law_lawsuit_legal_basis: {
            type: 'string',
            nullable: true,
            title: 'Rechtliche Grundlage der Klage',
            maxLength: 256
        },
        social_law_lawsuit_type: {
            type: 'string',
            nullable: true,
            title: 'Art der Klage',
            maxLength: 256
        },
        social_law_lawsuit_main_request: {
            type: 'string',
            nullable: true,
            title: 'Hauptantrag',
            maxLength: 512
        },
        social_law_lawsuit_alternative_request: {
            type: 'string',
            nullable: true,
            title: 'Hilfsantrag',
            maxLength: 512
        },
        social_law_lawsuit_cost_request: {
            type: 'string',
            nullable: true,
            title: 'Kostenantrag',
            maxLength: 256
        },
        social_law_lawsuit_original_decision_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum des ursprünglichen Bescheids'
        },
        social_law_lawsuit_objection_decision_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum des Widerspruchsbescheids'
        },
        social_law_lawsuit_objection_filing_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum der Widerspruchseinlegung'
        },
        social_law_lawsuit_delivery_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Zustellungsdatum'
        },
        social_law_lawsuit_dispute_value: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Streitwert'
        },
        social_law_lawsuit_disputed_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Streitiger Betrag'
        },
        social_law_lawsuit_monthly_benefit_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Monatliche Leistung'
        },
        social_law_lawsuit_income_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Einkommensbetrag'
        },
        social_law_interim_protection_file_reference: {
            type: 'string',
            nullable: true,
            title: 'Aktenzeichen',
            maxLength: 256
        },
        social_law_interim_protection_request_text: {
            type: 'string',
            nullable: true,
            title: 'Antragstext',
            maxLength: 256
        },
        social_law_interim_protection_urgency_reason: {
            type: 'string',
            nullable: true,
            title: 'Dringlichkeitsbegründung',
            maxLength: 512
        },
        social_law_interim_protection_request_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum des Antrags'
        },
        social_law_interim_protection_affidavit: {
            type: 'boolean',
            nullable: true,
            title: 'Eidesstattliche Versicherung'
        },
        social_law_interim_protection_attachment_list: {
            type: 'string',
            nullable: true,
            title: 'Anlagenliste',
            maxLength: 512
        },
        social_law_medical_file_reference: {
            type: 'string',
            nullable: true,
            title: 'Aktenzeichen',
            maxLength: 256
        },
        social_law_medical_examination_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Untersuchungsdatum'
        },
        social_law_medical_diagnosis: {
            type: 'string',
            nullable: true,
            title: 'Medizinische Diagnose',
            maxLength: 512
        },
        social_law_medical_work_capacity_relation: {
            type: 'string',
            nullable: true,
            title: 'Bezug zur Leistungsfähigkeit',
            maxLength: 512
        },
        social_law_medical_prognosis: {
            type: 'string',
            nullable: true,
            title: 'Prognose',
            maxLength: 512
        },
        social_law_medical_limitations: {
            type: 'string',
            nullable: true,
            title: 'Einschränkungen',
            maxLength: 512
        },
        social_law_medical_icd_code: {
            type: 'string',
            nullable: true,
            title: 'ICD-Code',
            maxLength: 256
        },
        social_law_needs_file_reference: {
            type: 'string',
            nullable: true,
            title: 'Aktenzeichen',
            maxLength: 256
        },
        social_law_needs_type: {
            type: 'string',
            nullable: true,
            title: 'Art des Bedarfs',
            maxLength: 256
        },
        social_law_needs_proof_basis: {
            type: 'string',
            nullable: true,
            title: 'Nachweisgrundlage',
            maxLength: 512
        },
        social_law_needs_cost_breakdown: {
            type: 'string',
            nullable: true,
            title: 'Kostenaufstellung',
            maxLength: 512
        },
        social_law_needs_proof_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Bedarfsnachweis'
        },
        social_law_disability_file_reference: {
            type: 'string',
            nullable: true,
            title: 'Aktenzeichen',
            maxLength: 256
        },
        social_law_disability_degree: {
            type: 'string',
            nullable: true,
            title: 'Grad der Behinderung (GdB)',
            maxLength: 256
        },
        social_law_disability_card_issue_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Ausstellungsdatum'
        },
        social_law_disability_card_markers: {
            type: 'string',
            nullable: true,
            title: 'Merkzeichen',
            maxLength: 256
        },
        social_law_disability_card_validity_period: {
            type: 'string',
            nullable: true,
            title: 'Gültigkeitsdauer',
            maxLength: 256
        },
        social_law_hearing_file_reference: {
            type: 'string',
            nullable: true,
            title: 'Aktenzeichen',
            maxLength: 256
        },
        social_law_hearing_planned_administrative_act: {
            type: 'string',
            nullable: true,
            title: 'Geplanter Verwaltungsakt',
            maxLength: 512
        },
        social_law_hearing_letter_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Anhörungsschreiben'
        },
        social_law_appointment_file_reference: {
            type: 'string',
            nullable: true,
            title: 'Aktenzeichen',
            maxLength: 256
        },
        social_law_appointment_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Termin (Datum)'
        },
        social_law_appointment_time: {
            type: 'string',
            nullable: true,
            title: 'Termin (Uhrzeit)',
            maxLength: 256
        },
        social_law_appointment_purpose: {
            type: 'string',
            nullable: true,
            title: 'Zweck des Termins',
            maxLength: 512
        },
        social_law_appointment_required_documents: {
            type: 'string',
            nullable: true,
            title: 'Mitzubringende Unterlagen',
            maxLength: 512
        },
        debt_collection_law_invoice_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Rechnungsdatum'
        },
        debt_collection_law_invoice_number: {
            type: 'string',
            nullable: true,
            title: 'Rechnungsnummer',
            maxLength: 100
        },
        debt_collection_law_invoice_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Rechnungsbetrag'
        },
        debt_collection_law_invoice_ground: {
            type: 'string',
            nullable: true,
            title: 'Rechnungsgrund',
            maxLength: 100
        },
        debt_collection_law_invoice_recipient: {
            type: 'string',
            nullable: true,
            title: 'Rechnungsadressat',
            maxLength: 100
        },
        debt_collection_law_invoice_tax_number: {
            type: 'string',
            nullable: true,
            title: 'Steuernummer',
            maxLength: 100
        },
        debt_collection_law_case_value: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Gegenstandswert'
        },
        debt_collection_law_business_fee: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: '1,3 Geschäftsgebühr (Nr. 2300 VV RVG)'
        },
        debt_collection_law_lumps_sum_expenses: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Auslagenpauschale (Nr. 7002 VV RVG)'
        },
        debt_collection_law_subtotal_lawyer_fees: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Zwischensumme Netto'
        },
        debt_collection_law_sales_tax: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Umsatzsteuer (19%)'
        },
        debt_collection_law_total_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Gesamtbetrag'
        },
        tenancy_law_rental_object_size_sqm: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Größe Mietobjekt Quadratmeter'
        },
        tenancy_law_rental_agreement_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Mietvertragsdatum'
        },
        tenancy_law_last_signature_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum letzte Unterschrift Mietvertrag'
        },
        tenancy_law_net_rent: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Nettomiete'
        },
        tenancy_law_gross_rent: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Bruttomiete'
        },
        tenancy_law_total_rent: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Gesamtmiete'
        },
        tenancy_law_unlimited_term_tenancy: {
            type: 'boolean',
            nullable: true,
            title: 'Unbefristeter Mietvertrag'
        },
        tenancy_law_fixed_term_tenancy: {
            type: 'boolean',
            nullable: true,
            title: 'Befristeter Mietvertrag'
        },
        tenancy_law_rental_agreement_duration: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Dauer Mietvertrag'
        },
        tenancy_law_rental_agreement_validity_start: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Mietvertragsbeginn'
        },
        tenancy_law_rental_agreement_validity_end: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Mietvertragsende'
        },
        tenancy_law_staggered_rental_agreement: {
            type: 'boolean',
            nullable: true,
            title: 'Staffelmietvereinbarung'
        },
        tenancy_law_value_security_clause: {
            type: 'boolean',
            nullable: true,
            title: 'Wertsicherungsklausel'
        },
        tenancy_law_tenant_extension_option: {
            type: 'boolean',
            nullable: true,
            title: 'Verlängerungsoption zugunsten Mieter'
        },
        tenancy_law_extension_option_count: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Anzahl Verlängerungsoptionen'
        },
        tenancy_law_extension_option_duration: {
            type: 'string',
            nullable: true,
            title: 'Dauer Verlängerungsoption',
            maxLength: 128
        },
        tenancy_law_security_deposit_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Kautionshöhe'
        },
        tenancy_law_security_deposit_additional_regulations: {
            type: 'string',
            nullable: true,
            title: 'Zusätzliche Regelungen zur Kaution'
        },
        tenancy_law_cash_deposit_agreed: {
            type: 'boolean',
            nullable: true,
            title: 'Barkaution vertraglich vereinbart'
        },
        tenancy_law_cash_deposit_payment_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Barkaution Datum Zahlung'
        },
        tenancy_law_bank_guarantee: {
            type: 'boolean',
            nullable: true,
            title: 'Bankbürgschaft'
        },
        tenancy_law_operating_costs_agreement: {
            type: 'string',
            nullable: true,
            title: 'Betriebskostenvereinbarung',
            maxLength: 128
        },
        tenancy_law_advance_payment_service_charges: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Nebenkostenvorauszahlungshöhe'
        },
        tenancy_law_adress_rental_property: {
            type: 'string',
            nullable: true,
            title: 'Adresse des Mietobjekts',
            maxLength: 128
        },
        tenancy_law_description_of_rental_property: {
            type: 'string',
            nullable: true,
            title: 'Beschreibung des Mietobjekts',
            maxLength: 128
        },
        tenancy_law_location_in_rental_property: {
            type: 'string',
            nullable: true,
            title: 'Lage im Mietobjekt',
            maxLength: 128
        },
        tenancy_law_garage_available: {
            type: 'boolean',
            nullable: true,
            title: 'Garage vorhanden'
        },
        tenancy_law_garage_costs: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Kosten Garage'
        },
        tenancy_law_parking_space_available: {
            type: 'boolean',
            nullable: true,
            title: 'Stellplatz vorhanden'
        },
        tenancy_law_parking_space_costs: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Kosten des Stellplatzes'
        },
        tenancy_law_start_of_lease: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Beginn des Pachtvertrags'
        },
        tenancy_law_duration_of_lease: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Dauer des Pachtvertrags'
        },
        tenancy_law_repayment_period_start: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Beginn des Abrechnungszeitraums'
        },
        tenancy_law_repayment_period_end: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Ende des Abrechnungszeitraums'
        },
        tenancy_law_total_cost_service_charge: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Gesamtkosten Nebenkostenabrechnung'
        },
        tenancy_law_cost_shares: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Umlageschlüssel'
        },
        tenancy_law_cost_share: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Kostenanteil Mieter'
        },
        tenancy_law_advance_payment_service_charge: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Vorauszahlungen Nebenkostenabrechnung'
        },
        tenancy_law_repayment: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Nachzahlung/Guthaben'
        },
        tenancy_law_handover_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Übergabedatum'
        },
        tenancy_law_handover_counter: {
            type: 'string',
            nullable: true,
            title: 'Zählerstand',
            maxLength: 128
        },
        tenancy_law_counter_number: {
            type: 'string',
            nullable: true,
            title: 'Zählerstandnummer',
            maxLength: 128
        },
        tenancy_law_handover_defects: {
            type: 'string',
            nullable: true,
            title: 'Mängel',
            maxLength: 128
        },
        tenancy_law_expert_report_damage_number: {
            type: 'string',
            nullable: true,
            title: 'Schadennummer',
            maxLength: 100
        },
        tenancy_law_expert_report_object_address: {
            type: 'string',
            nullable: true,
            title: 'Objekt Adresse',
            maxLength: 200
        },
        tenancy_law_expert_report_subject: {
            type: 'string',
            nullable: true,
            title: 'Gegenstand',
            maxLength: 200
        },
        tenancy_law_expert_report_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Gutachten'
        },
        tenancy_law_expert_report_purpose: {
            type: 'string',
            nullable: true,
            title: 'Zweck des Gutachtens'
        },
        tenancy_law_expert_report_commission_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Beauftragung Datum'
        },
        tenancy_law_expert_report_inspection_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Ortsbesichtigung Datum'
        },
        tenancy_law_expert_report_damage_description: {
            type: 'string',
            nullable: true,
            title: 'Schaden'
        },
        tenancy_law_expert_report_repair_duration: {
            type: 'string',
            nullable: true,
            title: 'Dauer Schadenbeseitigung',
            maxLength: 100
        },
        tenancy_law_tenant_warned: {
            type: 'boolean',
            nullable: true,
            title: 'Mieter abgemahnt'
        },
        tenancy_law_warning_letter_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Mahnschreiben'
        },
        tenancy_law_landlord_termination_given: {
            type: 'boolean',
            nullable: true,
            title: 'Kündigung durch Vermieter erfolgt'
        },
        tenancy_law_termination_declared_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Kündigungserklärung'
        },
        tenancy_law_termination_notice_period: {
            type: 'string',
            nullable: true,
            title: 'Kündigungsfrist',
            maxLength: 128
        },
        tenancy_law_termination_letter_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Kündigungsschreiben vom'
        },
        tenancy_law_tenancy_terminated: {
            type: 'boolean',
            nullable: true,
            title: 'Mietverhältnis beendet'
        },
        tenancy_law_tenancy_termination_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Beendigung Mietverhältnisses'
        },
        tenancy_law_property_return_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Rückgabe des Objekts Datum'
        },
        tenancy_law_court_proceedings_pending: {
            type: 'boolean',
            nullable: true,
            title: 'Gerichtliches Verfahren anhängig'
        },
        tenancy_law_competent_court: {
            type: 'string',
            nullable: true,
            title: 'Zuständiges Gericht',
            maxLength: 128
        },
        tenancy_law_court_case_number: {
            type: 'string',
            nullable: true,
            title: 'Gerichtliches Aktenzeichen',
            maxLength: 128
        },
        tenancy_law_last_rent_increase_letter_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum letztes Mieterhöhungsschreiben'
        },
        tenancy_law_rent_increase_effective_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Mieterhöhung wirksam geworden zum'
        },
        residential_property_law_contract_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Wegvertragsdatum'
        },
        residential_property_law_land_register_number: {
            type: 'string',
            nullable: true,
            title: 'Grundbuch Nr.',
            maxLength: 100
        },
        residential_property_law_land_register_city: {
            type: 'string',
            nullable: true,
            title: 'Grundbuch Stadt',
            maxLength: 100
        },
        residential_property_law_land_register_plot_of_land: {
            type: 'string',
            nullable: true,
            title: 'Grundbuch Flurstück',
            maxLength: 100
        },
        residential_property_law_land_register_address: {
            type: 'string',
            nullable: true,
            title: 'Grundbuch Lage',
            maxLength: 100
        },
        residential_property_law_co_ownership_shares: {
            type: 'string',
            nullable: true,
            title: 'Miteigentumsanteile',
            maxLength: 100
        },
        residential_property_law_inventory: {
            type: 'string',
            nullable: true,
            title: 'Bestandsverzeichnis',
            maxLength: 100
        },
        inheritance_law_certificate_of_inheritance_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Erbscheins'
        },
        inheritance_law_certificate_of_inheritance_number: {
            type: 'string',
            nullable: true,
            title: 'Nummer des Erbscheins',
            maxLength: 128
        },
        inheritance_law_certificate_of_inheritance_date_death: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Todesdatum'
        },
        inheritance_law_certificate_of_inheritance_place_of_death: {
            type: 'string',
            nullable: true,
            title: 'Todesort',
            maxLength: 128
        },
        inheritance_law_certificate_of_inheritance_applicable_law: {
            type: 'string',
            nullable: true,
            title: 'Anwendbares Recht',
            maxLength: 128
        },
        inheritance_law_inheritance_contract_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum des Erbvertrags'
        },
        inheritance_law_death_certificate_number: {
            type: 'string',
            nullable: true,
            title: 'Nummer Sterbeurkunde',
            maxLength: 128
        },
        inheritance_law_death_certificate_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Sterbeurkunde'
        },
        inheritance_law_death_certificate_place: {
            type: 'string',
            nullable: true,
            title: 'Ort Sterbeurkunde',
            maxLength: 128
        },
        inheritance_law_death_certificate_date_death: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Todesdatum'
        },
        inheritance_law_death_certificate_time_death: {
            type: 'string',
            format: 'time',
            nullable: true,
            title: 'Uhrzeit des Todes'
        },
        inheritance_law_death_certificate_place_death: {
            type: 'string',
            nullable: true,
            title: 'Ort des Todes',
            maxLength: 128
        },
        inheritance_law_testament_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum des Testaments'
        },
        inheritance_law_estate_inventory_status: {
            type: 'string',
            nullable: true,
            title: 'Güterstand',
            maxLength: 128
        },
        inheritance_law_estate_inventory_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Nachlassverzeichnis'
        },
        inheritance_law_estate_inventory_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Nettonachlass'
        },
        inheritance_law_patient_enrollment_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Patientenverfügung'
        },
        inheritance_law_lasting_power_of_attorney_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Vorsorgevollmacht'
        },
        real_estate_law_land_register_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Grundbuchauszugdatum'
        },
        real_estate_law_encumbrance_restrictions: {
            type: 'string',
            nullable: true,
            title: 'Lasten und Beschränkungen',
            maxLength: 128
        },
        real_estate_law_basic_debts_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Grundschulden'
        },
        real_estate_law_land_register_number: {
            type: 'string',
            nullable: true,
            title: 'Grundbuch Nr.',
            maxLength: 100
        },
        real_estate_law_land_register_city: {
            type: 'string',
            nullable: true,
            title: 'Grundbuch Stadt',
            maxLength: 100
        },
        real_estate_law_land_register_plot_of_land: {
            type: 'string',
            nullable: true,
            title: 'Grundbuch Flurstück',
            maxLength: 100
        },
        real_estate_law_land_register_address: {
            type: 'string',
            nullable: true,
            title: 'Grundbuch Lage',
            maxLength: 100
        },
        real_estate_law_plot_size: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Grundstücksgröße'
        },
        real_estate_law_purchase_contract_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Kaufvertragsdatum'
        },
        real_estate_law_purchase_contract_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Kaufvertragsbetrag'
        },
        real_estate_law_purchase_contract_description: {
            type: 'string',
            nullable: true,
            title: 'Kaufvertrag Objektbeschreibung',
            maxLength: 128
        },
        real_estate_law_purchase_contract_registration_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Kaufvertragsbeurkundungsdatum'
        },
        real_estate_law_purchase_contract_registration_number: {
            type: 'string',
            nullable: true,
            title: 'Urkundenrollennummer',
            maxLength: 100
        },
        real_estate_law_brokerage_fee: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Makler Provision'
        },
        real_estate_law_property_brokered_by_agent: {
            type: 'boolean',
            nullable: true,
            title: 'Objekt durch Makler vermittelt'
        },
        real_estate_law_purchase_object_rented: {
            type: 'boolean',
            nullable: true,
            title: 'Kaufobjekt vermietet'
        },
        real_estate_law_encumbrances_section_ii: {
            type: 'string',
            nullable: true,
            title: 'Belastungen Abt. II Grundbuch'
        },
        real_estate_law_encumbrances_section_iii: {
            type: 'string',
            nullable: true,
            title: 'Belastungen Abt. III Grundbuch'
        },
        real_estate_law_building_restrictions_clause: {
            type: 'string',
            nullable: true,
            title: 'Regelungen zu Baulasten'
        },
        real_estate_law_contaminated_sites_clause: {
            type: 'string',
            nullable: true,
            title: 'Regelung zu Altlasten'
        },
        real_estate_law_legal_defects_clause: {
            type: 'string',
            nullable: true,
            title: 'Klausel zu Rechtsmängeln'
        },
        real_estate_law_purchase_price_loan_financed: {
            type: 'boolean',
            nullable: true,
            title: 'Kaufpreis durch Darlehen finanziert'
        },
        real_estate_law_withdrawal_instruction_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Widerrufsbelehrung Datum'
        },
        real_estate_law_building_permit_validity_duration: {
            type: 'string',
            nullable: true,
            title: 'Gültigkeitsdauer',
            maxLength: 100
        },
        real_estate_law_building_permit_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Baugenehmigungsdatum'
        },
        real_estate_law_building_permit_number: {
            type: 'string',
            nullable: true,
            title: 'Genehmigungsnummer',
            maxLength: 100
        },
        real_estate_law_co_ownership_share: {
            type: 'string',
            nullable: true,
            title: 'Miteigentumsanteil',
            maxLength: 100
        },
        real_estate_law_division_declaration_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Teilungserklärung'
        },
        real_estate_law_plan_designation: {
            type: 'string',
            nullable: true,
            title: 'Planbezeichnung',
            maxLength: 100
        },
        real_estate_law_plan_scale: {
            type: 'string',
            nullable: true,
            title: 'Maßstab',
            maxLength: 100
        },
        real_estate_law_plan_author: {
            type: 'string',
            nullable: true,
            title: 'Planverfasser',
            maxLength: 100
        },
        real_estate_law_building_usage: {
            type: 'string',
            nullable: true,
            title: 'Gebäudenutzung',
            maxLength: 100
        },
        real_estate_law_building_dimensions: {
            type: 'string',
            nullable: true,
            title: 'Baukörperabmessung',
            maxLength: 100
        },
        real_estate_law_monument_protection_order_number: {
            type: 'string',
            nullable: true,
            title: 'Bescheid - Nr.',
            maxLength: 100
        },
        real_estate_law_monument_protection_order_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum des Denkmalschutzbescheides'
        },
        real_estate_law_monument_protection_basis: {
            type: 'string',
            nullable: true,
            title: 'Schutzgrundlage',
            maxLength: 100
        },
        real_estate_law_monument_registration_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Eintragungsdatum'
        },
        real_estate_law_monument_protection_requirements: {
            type: 'string',
            nullable: true,
            title: 'Auflagen'
        },
        real_estate_law_loan_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Darlehenssumme'
        },
        real_estate_law_interest_rate: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,3}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Zinssatz'
        },
        real_estate_law_installment_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Ratenhöhe'
        },
        real_estate_law_full_repayment_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Vollständige Rückzahlung'
        },
        real_estate_law_loan_security: {
            type: 'string',
            nullable: true,
            title: 'Darlehnsabsicherung',
            maxLength: 100
        },
        real_estate_law_repayment_rate: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,3}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Tilgungssatz'
        },
        real_estate_law_broker_commission_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Provisionshöhe'
        },
        real_estate_law_broker_scope_of_work: {
            type: 'string',
            nullable: true,
            title: 'Tätigkeitsumfang'
        },
        real_estate_law_broker_termination_periods: {
            type: 'string',
            nullable: true,
            title: 'Kündigungsfristen',
            maxLength: 100
        },
        real_estate_law_broker_contract_type: {
            type: 'string',
            nullable: true,
            title: 'Art des Maklervertrags',
            maxLength: 100
        },
        real_estate_law_brokerage_contract_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Maklervertrag Datum'
        },
        real_estate_law_exclusive_brokerage_contract: {
            type: 'boolean',
            nullable: true,
            title: 'Alleinauftrag'
        },
        real_estate_law_commission_percentage: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,3}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Provisionshöhe in %'
        },
        migration_law_residence_permit_issue_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Ausstellungsdatum'
        },
        migration_law_residence_permit_valid_until: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Gültig bis'
        },
        migration_law_residence_permit_type: {
            type: 'string',
            nullable: true,
            title: 'Titelart',
            maxLength: 100
        },
        migration_law_residence_permit_purpose: {
            type: 'string',
            nullable: true,
            title: 'Zweck des Aufenthalts',
            maxLength: 200
        },
        migration_law_residence_permit_issuing_authority: {
            type: 'string',
            nullable: true,
            title: 'Behörde',
            maxLength: 100
        },
        migration_law_residence_permit_conditions: {
            type: 'string',
            nullable: true,
            title: 'Auflagen / Nebenbestimmungen'
        },
        migration_law_residence_permit_passport_number: {
            type: 'string',
            nullable: true,
            title: 'Passnummer',
            maxLength: 50
        },
        migration_law_residence_permit_national_id_number: {
            type: 'string',
            nullable: true,
            title: 'Nationale Identitätsnummer',
            maxLength: 50
        },
        migration_law_fictional_certificate_issue_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Ausgestellt am'
        },
        migration_law_fictional_certificate_valid_until: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Gültig bis'
        },
        migration_law_fictional_certificate_legal_basis: {
            type: 'string',
            nullable: true,
            title: 'Rechtsgrundlage',
            maxLength: 100
        },
        migration_law_fictional_certificate_fiction_type: {
            type: 'string',
            nullable: true,
            title: 'Art der Fiktion',
            maxLength: 100
        },
        migration_law_fictional_certificate_reason_for_issuance: {
            type: 'string',
            nullable: true,
            title: 'Zweck der Erteilung',
            maxLength: 200
        },
        migration_law_fictional_certificate_authority: {
            type: 'string',
            nullable: true,
            title: 'Behörde',
            maxLength: 100
        },
        migration_law_toleration_issue_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Ausgestellt am'
        },
        migration_law_toleration_valid_until: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Gültig bis'
        },
        migration_law_toleration_reason: {
            type: 'string',
            nullable: true,
            title: 'Grund der Duldung',
            maxLength: 200
        },
        migration_law_toleration_legal_basis: {
            type: 'string',
            nullable: true,
            title: 'Rechtsgrundlage',
            maxLength: 100
        },
        migration_law_toleration_restrictions: {
            type: 'string',
            nullable: true,
            title: 'Beschränkungen'
        },
        migration_law_toleration_issuing_authority: {
            type: 'string',
            nullable: true,
            title: 'Behörde',
            maxLength: 100
        },
        migration_law_asylum_seeker_certificate_issue_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Ausstellungsdatum'
        },
        migration_law_asylum_seeker_certificate_valid_until: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Gültig bis'
        },
        migration_law_asylum_seeker_certificate_application_number: {
            type: 'string',
            nullable: true,
            title: 'Asylantragsnummer',
            maxLength: 100
        },
        migration_law_asylum_seeker_certificate_first_registration_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Erstregistrierung'
        },
        migration_law_asylum_seeker_certificate_residence_obligation: {
            type: 'string',
            nullable: true,
            title: 'Wohnsitzauflage',
            maxLength: 200
        },
        migration_law_asylum_seeker_certificate_issuing_authority: {
            type: 'string',
            nullable: true,
            title: 'Behörde',
            maxLength: 100
        },
        migration_law_asylum_seeker_certificate_work_permission: {
            type: 'string',
            nullable: true,
            title: 'Arbeitserlaubnis',
            maxLength: 100
        },
        migration_law_rejection_notice_case_number: {
            type: 'string',
            nullable: true,
            title: 'Aktenzeichen',
            maxLength: 100
        },
        migration_law_rejection_notice_decision_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum des Bescheids'
        },
        migration_law_rejection_notice_subject: {
            type: 'string',
            nullable: true,
            title: 'Betreff',
            maxLength: 200
        },
        migration_law_rejection_notice_legal_remedy_deadline: {
            type: 'string',
            nullable: true,
            title: 'Rechtsbehelf / Frist',
            maxLength: 200
        },
        migration_law_rejection_notice_reasoning: {
            type: 'string',
            nullable: true,
            title: 'Begründung'
        },
        migration_law_rejection_notice_legal_grounds: {
            type: 'string',
            nullable: true,
            title: 'Gesetzesgrundlagen',
            maxLength: 200
        },
        migration_law_rejection_notice_officer_name: {
            type: 'string',
            nullable: true,
            title: 'Name des Sachbearbeiters',
            maxLength: 100
        },
        migration_law_rejection_notice_signature_seal: {
            type: 'string',
            nullable: true,
            title: 'Unterschrift / Dienstsiegel',
            maxLength: 100
        },
        migration_law_approval_notice_case_number: {
            type: 'string',
            nullable: true,
            title: 'Aktenzeichen',
            maxLength: 100
        },
        migration_law_approval_notice_decision_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum des Bescheids'
        },
        migration_law_approval_notice_permit_type: {
            type: 'string',
            nullable: true,
            title: 'Art des Aufenthaltstitels',
            maxLength: 100
        },
        migration_law_approval_notice_validity_period: {
            type: 'string',
            nullable: true,
            title: 'Gültigkeitszeitraum',
            maxLength: 100
        },
        migration_law_approval_notice_conditions: {
            type: 'string',
            nullable: true,
            title: 'Auflagen'
        },
        migration_law_approval_notice_pickup_deadline: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Abholfrist'
        },
        migration_law_approval_notice_issuing_authority: {
            type: 'string',
            nullable: true,
            title: 'Ausstellende Behörde',
            maxLength: 100
        },
        migration_law_hearing_letter_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum des Schreibens'
        },
        migration_law_hearing_letter_response_deadline: {
            type: 'string',
            nullable: true,
            title: 'Frist zur Stellungnahme',
            maxLength: 100
        },
        migration_law_hearing_letter_intended_measure_justification: {
            type: 'string',
            nullable: true,
            title: 'Begründung der beabsichtigten Maßnahme'
        },
        migration_law_hearing_letter_legal_advice: {
            type: 'string',
            nullable: true,
            title: 'Rechtsbehelfshinweis'
        },
        migration_law_hearing_letter_requested_documents: {
            type: 'string',
            nullable: true,
            title: 'Dokumente beizufügen'
        },
        migration_law_cooperation_letter_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum des Schreibens'
        },
        migration_law_cooperation_letter_file_number: {
            type: 'string',
            nullable: true,
            title: 'Aktenzeichen',
            maxLength: 100
        },
        migration_law_cooperation_letter_specified_obligations: {
            type: 'string',
            nullable: true,
            title: 'Benannte Mitwirkungspflichten'
        },
        migration_law_cooperation_letter_non_cooperation_consequences: {
            type: 'string',
            nullable: true,
            title: 'Rechtsfolgen bei Nichtmitwirkung'
        },
        migration_law_cooperation_letter_deadlines: {
            type: 'string',
            nullable: true,
            title: 'Fristen',
            maxLength: 200
        },
        migration_law_cooperation_letter_attachments: {
            type: 'string',
            nullable: true,
            title: 'Anlagen / Formulare'
        },
        migration_law_other_letters_issuing_authority: {
            type: 'string',
            nullable: true,
            title: 'Absenderbehörde',
            maxLength: 100
        },
        migration_law_other_letters_file_number: {
            type: 'string',
            nullable: true,
            title: 'Aktenzeichen / Geschäftszeichen',
            maxLength: 100
        },
        migration_law_other_letters_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum des Schreibens'
        },
        migration_law_other_letters_subject: {
            type: 'string',
            nullable: true,
            title: 'Betreff',
            maxLength: 200
        },
        migration_law_other_letters_matter_purpose: {
            type: 'string',
            nullable: true,
            title: 'Anliegen / Inhalt des Schreibens'
        },
        migration_law_other_letters_legal_basis: {
            type: 'string',
            nullable: true,
            title: 'Rechtsgrundlage (sofern genannt)',
            maxLength: 200
        },
        migration_law_other_letters_deadlines: {
            type: 'string',
            nullable: true,
            title: 'Fristen',
            maxLength: 200
        },
        migration_law_other_letters_action_required: {
            type: 'string',
            nullable: true,
            title: 'Handlungsaufforderung'
        },
        civil_law_file_reference: {
            type: 'string',
            nullable: true,
            title: 'Aktenzeichen',
            maxLength: 100
        },
        civil_law_document_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Dokumentdatum'
        },
        civil_law_subject_line: {
            type: 'string',
            nullable: true,
            title: 'Betreff',
            maxLength: 255
        },
        civil_law_contract_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Vertragsdatum'
        },
        civil_law_contract_start_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Vertragsbeginn'
        },
        civil_law_contract_end_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Vertragsende'
        },
        civil_law_contract_duration: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Vertragslaufzeit in Monaten'
        },
        civil_law_contract_value: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Vertragswert'
        },
        civil_law_contract_object: {
            type: 'string',
            nullable: true,
            title: 'Vertragsgegenstand',
            maxLength: 255
        },
        civil_law_termination_notice_period: {
            type: 'string',
            nullable: true,
            title: 'Kündigungsfrist',
            maxLength: 100
        },
        civil_law_notarial_certification_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Notarielle Beurkundung Datum'
        },
        civil_law_purchase_price: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Kaufpreis'
        },
        civil_law_purchase_price_components: {
            type: 'string',
            nullable: true,
            title: 'Bestandteile Kaufpreis'
        },
        civil_law_accessories_sold_separately: {
            type: 'boolean',
            nullable: true,
            title: 'Zubehör separat veräußert?'
        },
        civil_law_purchase_contract_file_reference: {
            type: 'string',
            nullable: true,
            title: 'Kaufvertragsaktenzeichen',
            maxLength: 100
        },
        civil_law_handover_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Übergabedatum'
        },
        civil_law_purchase_price_paid: {
            type: 'boolean',
            nullable: true,
            title: 'Kaufpreis bezahlt'
        },
        civil_law_purchase_price_payment_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Zahlung Kaufpreis'
        },
        civil_law_purchase_price_paid_boolean: {
            type: 'boolean',
            nullable: true,
            title: 'Kaufpreis bezahlt'
        },
        civil_law_purchase_price_paid_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Kaufpreis bezahlt'
        },
        civil_law_purchase_price_paid_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Höhe bezahlten Kaufpreises'
        },
        civil_law_purchase_object: {
            type: 'string',
            nullable: true,
            title: 'Kaufgegenstand',
            maxLength: 255
        },
        civil_law_purchase_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Kaufdatum'
        },
        civil_law_delivery_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Lieferdatum'
        },
        civil_law_warranty_period: {
            type: 'string',
            nullable: true,
            title: 'Gewährleistungsfrist',
            maxLength: 100
        },
        civil_law_defects: {
            type: 'string',
            nullable: true,
            title: 'Mängel'
        },
        civil_law_defects_present: {
            type: 'boolean',
            nullable: true,
            title: 'Sachmängel vorhanden'
        },
        civil_law_vehicle_make: {
            type: 'string',
            nullable: true,
            title: 'Fahrzeugmarke',
            maxLength: 100
        },
        civil_law_vehicle_model: {
            type: 'string',
            nullable: true,
            title: 'Fahrzeugmodell',
            maxLength: 100
        },
        civil_law_vehicle_year: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Baujahr'
        },
        civil_law_vehicle_mileage: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Kilometerstand'
        },
        civil_law_vehicle_vin: {
            type: 'string',
            nullable: true,
            title: 'Fahrgestellnummer',
            maxLength: 50
        },
        civil_law_damage_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Schadenshöhe'
        },
        civil_law_damage_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Schadensdatum'
        },
        civil_law_damage_description: {
            type: 'string',
            nullable: true,
            title: 'Schadensbeschreibung'
        },
        civil_law_damage_cause: {
            type: 'string',
            nullable: true,
            title: 'Schadensursache',
            maxLength: 255
        },
        civil_law_liability_percentage: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,3}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Haftungsquote in Prozent'
        },
        civil_law_insurance_claim_number: {
            type: 'string',
            nullable: true,
            title: 'Versicherungsschadensnummer',
            maxLength: 100
        },
        civil_law_court_name: {
            type: 'string',
            nullable: true,
            title: 'Gericht',
            maxLength: 255
        },
        civil_law_case_number: {
            type: 'string',
            nullable: true,
            title: 'Geschäftsnummer',
            maxLength: 100
        },
        civil_law_hearing_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Verhandlungstermin'
        },
        civil_law_judgment_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Urteilsdatum'
        },
        civil_law_claim_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Streitwert'
        },
        civil_law_court_costs: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Gerichtskosten'
        },
        civil_law_payment_due_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Fälligkeitsdatum'
        },
        civil_law_interest_rate: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,3}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Zinssatz'
        },
        civil_law_default_interest: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Verzugszinsen'
        },
        general_law_file_ref: {
            type: 'string',
            minLength: 1,
            title: 'Aktenzeichen',
            maxLength: 100
        },
        general_law_subject: {
            type: 'string',
            minLength: 1,
            title: 'Betreff'
        },
        general_law_doc_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Dokumentendatum'
        },
        general_law_prior_ref: {
            type: 'string',
            minLength: 1,
            title: 'Zeichen unseres Schreibens',
            maxLength: 200
        },
        general_law_appendices: {
            type: 'string',
            minLength: 1,
            title: 'Anlagen'
        },
        general_law_invoice_number: {
            type: 'string',
            minLength: 1,
            title: 'Rechnungsnummer',
            maxLength: 100
        },
        general_law_invoice_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Rechnungsdatum'
        },
        general_law_due_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Fälligkeitsdatum'
        },
        general_law_amount_total: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Gesamtbetrag'
        },
        general_law_amount_net: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Nettobetrag'
        },
        general_law_vat: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'MwSt / Umsatzsteuer'
        },
        general_law_payment_terms: {
            type: 'string',
            minLength: 1,
            title: 'Zahlungsbedingungen'
        },
        general_law_court_name: {
            type: 'string',
            minLength: 1,
            title: 'Gericht',
            maxLength: 200
        },
        general_law_case_number: {
            type: 'string',
            minLength: 1,
            title: 'Geschäftsnummer',
            maxLength: 100
        },
        general_law_hearing_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Verhandlungstermin'
        },
        general_law_judgment_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Urteilsdatum'
        },
        general_law_court_costs: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Gerichtskosten'
        },
        medicine_law_medical_report_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum des Berichts'
        },
        medicine_law_medical_report_treatment_period: {
            type: 'string',
            nullable: true,
            title: 'Zeitraum der Behandlung',
            maxLength: 200
        },
        medicine_law_medical_report_diagnosis_icd_code: {
            type: 'string',
            nullable: true,
            title: 'Diagnose ICD-Code',
            maxLength: 50
        },
        medicine_law_medical_report_diagnosis_short_text: {
            type: 'string',
            nullable: true,
            title: 'Diagnose Kurztext',
            maxLength: 200
        },
        medicine_law_medical_report_treatment_measures: {
            type: 'string',
            nullable: true,
            title: 'Therapie Behandlungsmaßnahmen'
        },
        medicine_law_medical_report_surgery_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'OP-Datum'
        },
        medicine_law_medical_report_complications: {
            type: 'string',
            nullable: true,
            title: 'Komplikationen'
        },
        medicine_law_medical_report_further_treatment: {
            type: 'string',
            nullable: true,
            title: 'Weitere Behandlung'
        },
        medicine_law_hospital_records_admission_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Aufnahmedatum'
        },
        medicine_law_hospital_records_discharge_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Entlassungsdatum'
        },
        medicine_law_hospital_records_station: {
            type: 'string',
            nullable: true,
            title: 'Station',
            maxLength: 100
        },
        medicine_law_hospital_records_diagnoses_icd_codes: {
            type: 'string',
            nullable: true,
            title: 'Diagnosen ICD-Codes'
        },
        medicine_law_hospital_records_operations: {
            type: 'string',
            nullable: true,
            title: 'Operationen'
        },
        medicine_law_hospital_records_operation_date: {
            type: 'string',
            nullable: true,
            title: 'Operation Datum'
        },
        medicine_law_hospital_records_medication_during_stay: {
            type: 'string',
            nullable: true,
            title: 'Medikation während Aufenthalt'
        },
        medicine_law_hospital_records_documented_complications: {
            type: 'string',
            nullable: true,
            title: 'Dokumentierte Komplikationen'
        },
        medicine_law_hospital_records_discharge_prognosis: {
            type: 'string',
            nullable: true,
            title: 'Prognose'
        },
        medicine_law_medical_expertise_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum des Gutachtens'
        },
        medicine_law_medical_expertise_question_posed: {
            type: 'string',
            nullable: true,
            title: 'Fragestellung des Gutachtens'
        },
        medicine_law_medical_expertise_medical_assessment: {
            type: 'string',
            nullable: true,
            title: 'Medizinische Einschätzung'
        },
        medicine_law_medical_expertise_justification: {
            type: 'string',
            nullable: true,
            title: 'Begründung des Ergebnisses'
        },
        medicine_law_medical_expertise_result: {
            type: 'string',
            nullable: true,
            title: 'Ergebnis des Gutachtens'
        },
        medicine_law_laboratory_results_examination_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum der Untersuchung'
        },
        medicine_law_laboratory_results_examination_type: {
            type: 'string',
            nullable: true,
            title: 'Art der Untersuchung',
            maxLength: 200
        },
        medicine_law_laboratory_results: {
            type: 'string',
            nullable: true,
            title: 'Befund'
        },
        medicine_law_laboratory_results_relevant_deviations: {
            type: 'string',
            nullable: true,
            title: 'Relevante Abweichungen'
        },
        medicine_law_laboratory_results_further_investigation_recommendation: {
            type: 'string',
            nullable: true,
            title: 'Empfehlung zur weiteren Abklärung'
        },
        medicine_law_health_insurance_letter_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum des Schreibens'
        },
        medicine_law_health_insurance_letter_reference_to_application: {
            type: 'string',
            nullable: true,
            title: 'Bezug auf Schreiben'
        },
        medicine_law_health_insurance_letter_decision: {
            type: 'string',
            nullable: true,
            title: 'Entscheidung der Krankenkasse',
            maxLength: 100
        },
        medicine_law_health_insurance_letter_decision_justification: {
            type: 'string',
            nullable: true,
            title: 'Begründung der Entscheidung'
        },
        medicine_law_health_insurance_letter_legal_remedy_instruction: {
            type: 'string',
            nullable: true,
            title: 'Rechtsbehelfsbelehrung'
        },
        medicine_law_medical_bill_invoice_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Rechnungsdatum'
        },
        medicine_law_medical_bill_invoice_number: {
            type: 'string',
            nullable: true,
            title: 'Rechnungsnummer',
            maxLength: 100
        },
        medicine_law_medical_bill_service_period: {
            type: 'string',
            nullable: true,
            title: 'Zeitraum der Leistung',
            maxLength: 200
        },
        medicine_law_medical_bill_services_list: {
            type: 'string',
            nullable: true,
            title: 'Auflistung der Leistungen'
        },
        medicine_law_medical_bill_total_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Gesamtsumme der Rechnung'
        },
        medicine_law_medical_bill_cost_bearer: {
            type: 'string',
            nullable: true,
            title: 'Kostenträger',
            maxLength: 100
        },
        medicine_law_medical_bill_payment_deadline: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Zahlungsfrist'
        },
        field: {
            type: 'string',
            title: 'Rechtsgebiet',
            maxLength: 100
        },
        topic: {
            type: 'string',
            title: 'Rechtsthema',
            maxLength: 100
        },
        external_case_id: {
            type: 'string',
            nullable: true,
            maxLength: 100
        }
    }
} as const;

export const $LawFieldEnum = {
    enum: ['Allgemein', 'Arbeitsrecht', 'Asylrecht', 'Ausländerrecht', 'Bankrecht', 'Baurecht', 'Beamtenrecht', 'Bewertungen löschen', 'Casino', 'Coaching', 'Compliance', 'Corona Überbrückungshilfe', 'Datenleck', 'Erbrecht', 'Familienrecht', 'Gesellschaftsrecht', 'Gewerblicher Rechtsschutz/Urheberrecht', 'Hochschulrecht', 'Immobilienrecht', 'Inkasso', 'IT Recht', 'Insolvenzberatung', 'Markenrecht', 'Medien-und Presserecht', 'Medizinrecht', 'Mietrecht', 'Migrationsrecht', 'Musikrecht', 'Notariat', 'Personenschäden', 'Schufa', 'Schulrecht', 'Social Media Recht', 'Sozialrecht', 'Steuerberatung', 'Steuerrecht', 'Strafrecht', 'Tesla_Widerruf', 'Tierrecht', 'Verkehrsrecht', 'Versicherungsrecht', 'Verwaltungsrecht', 'Wegrecht', 'Zivilrecht'],
    type: 'string',
    description: `* \`Allgemein\` - Allgemein
* \`Arbeitsrecht\` - Arbeitsrecht
* \`Asylrecht\` - Asylrecht
* \`Ausländerrecht\` - Ausländerrecht
* \`Bankrecht\` - Bankrecht
* \`Baurecht\` - Baurecht
* \`Beamtenrecht\` - Beamtenrecht
* \`Bewertungen löschen\` - Bewertungen löschen
* \`Casino\` - Casino
* \`Coaching\` - Coaching
* \`Compliance\` - Compliance
* \`Corona Überbrückungshilfe\` - Corona Überbrückungshilfe
* \`Datenleck\` - Datenleck
* \`Erbrecht\` - Erbrecht
* \`Familienrecht\` - Familienrecht
* \`Gesellschaftsrecht\` - Gesellschaftsrecht
* \`Gewerblicher Rechtsschutz/Urheberrecht\` - Gewerblicher Rechtsschutz/Urheberrecht
* \`Hochschulrecht\` - Hochschulrecht
* \`Immobilienrecht\` - Immobilienrecht
* \`Inkasso\` - Inkasso
* \`IT Recht\` - IT Recht
* \`Insolvenzberatung\` - Insolvenzberatung
* \`Markenrecht\` - Markenrecht
* \`Medien-und Presserecht\` - Medien-und Presserecht
* \`Medizinrecht\` - Medizinrecht
* \`Mietrecht\` - Mietrecht
* \`Migrationsrecht\` - Migrationsrecht
* \`Musikrecht\` - Musikrecht
* \`Notariat\` - Notariat
* \`Personenschäden\` - Personenschäden
* \`Schufa\` - Schufa
* \`Schulrecht\` - Schulrecht
* \`Social Media Recht\` - Social Media Recht
* \`Sozialrecht\` - Sozialrecht
* \`Steuerberatung\` - Steuerberatung
* \`Steuerrecht\` - Steuerrecht
* \`Strafrecht\` - Strafrecht
* \`Tesla_Widerruf\` - Tesla_Widerruf
* \`Tierrecht\` - Tierrecht
* \`Verkehrsrecht\` - Verkehrsrecht
* \`Versicherungsrecht\` - Versicherungsrecht
* \`Verwaltungsrecht\` - Verwaltungsrecht
* \`Wegrecht\` - Wegrecht
* \`Zivilrecht\` - Zivilrecht`
} as const;

export const $LawFields = {
    type: 'object',
    properties: {
        data: {
            type: 'object',
            additionalProperties: {
                type: 'array',
                items: {
                    type: 'string'
                }
            }
        }
    },
    required: ['data']
} as const;

export const $LawFirmSoftwareDataRequest = {
    type: 'object',
    properties: {
        fileData: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/FileDataRequest'
            }
        },
        entities_with_relationships: {
            type: 'array',
            items: {
                type: 'string',
                format: 'uuid'
            }
        }
    },
    required: ['entities_with_relationships']
} as const;

export const $LawTopicEnum = {
    enum: ['AGB', 'Abfindung', 'Abmahnung', 'Abmahnung Wettbewerbsrecht', 'Abschiebungshaft', 'Abschlussarbeit', 'Abstandsregelung nicht eingehalten', 'Account hacking', 'Allgemein', 'Allgemeines Prüfungsrecht', 'Anderes', 'Arbeitsamt/ALG/Sperrzeit', 'Arbeitsunfall', 'Arbeitsvertrag', 'Arbeitszeugnis', 'Aufbau Compliancesystem', 'Aufenthaltserlaubnis', 'Aufhebungsvertrag', 'Auftragsdatenverarbeitung', 'Auseinandersetzung Erbengemeinschaft', 'Auskunft prüfen', 'Ausweisung', 'Autokauf', 'Bankkonto leergeräumt', 'Bankrecht', 'Baumangel', 'Bauvertrag', 'Behandlungsfehler Allgemein', 'Behandlungsfehler Querschnittslähmung', 'Behandlungsfehler Schlaganfall', 'Beißvorfall', 'Beratung zu Erbfall', 'Beschlagnahme Allgemein', 'Beschlagnahme Tierquälerei', 'Betreuungsrecht', 'Betrug Geldanlage', 'Betäubungsmittel', 'Burgschild Inkasso', 'Bußgeldbescheid', 'Bürgergeld', 'Coaching', 'Datenschutz', 'Datenschutz Schadensersatz', 'Datenschutzverstoß', 'Domains', 'Ehevertrag', 'Eigentumsdelikte', 'Einbürgerung', 'Einreisesperre', 'Eintrag löschen', 'Erbauseinandersetzung', 'Erbausschlagung', 'Erben/Schenken', 'Erbengemeinschaft', 'Erbschein', 'Erbscheinsantrag', 'Erbvertrag', 'Exmatrikulation', 'Fahren ohne Führerschein', 'Fahren unter Alkohol - / Drogeneinfluss', 'Fahrer - / Unfallflucht', 'Fahrverbot / Führerscheinentzug', 'Falschaussage/ Meineid', 'Familie Vorsorge', 'Forderung löschen', 'Geburtsfehler', 'Geburtsfehler Mutter', 'Geschwindigkeitsüberschreitung', 'Gesetzliche Erbfolge', 'Gewerblicher Rechtsschutz', 'Grundschuld', 'Gründung', 'Handy am Steuer', 'Hauskauf', 'Härtefallantrag', 'Immobilien', 'Immobilienübertragung', 'Kaufvertragsprüfung', 'Körperverletzung', 'Kündigung', 'Lohnzahlung', 'Maklerangelegenheit', 'Markenanmeldung', 'Markenverteidigung', 'Markenüberwachung', 'Mieterhöhung', 'Mietkaution', 'Mietminderung', 'Mietvertrag', 'Nebenkostenabrechnung', 'Niederlassungserlaubnis', 'Nutzerbewertungen Verfasser', 'Patientenverfügung/Vorsorgevollmacht', 'Personenverwechselung', 'Pflege-/Krankenversicherung', 'Pflichtteil', 'Pflichtteil Geltendmachung', 'Pflichtteil abwehren', 'Plagiatsvorwurf', 'Remonstration', 'Rente', 'Rotlichtverstoß', 'Räumungsklage', 'Schadensersatz', 'Scheidung', 'Schenkung', 'Schenkung Immobilie', 'Schulplatz einklagen', 'Schwerbehinderung', 'Sexualdelikt', 'Software Hardware', 'Sonstige Beglaubigung', 'Sorgerecht und Umgangsrecht', 'Testament', 'Testament/Erbvertrag', 'Tierkauf', 'Tierärztliche Behandlungsfehler', 'Trennung', 'Tuning', 'Täuschungsversuch', 'Tötungsdelikte', 'Unfall Querschnittslähmung', 'Unfall mit Personenschaden', 'Unterhalt', 'Unternehmen', 'Unternehmensauflösung', 'Unternehmensgründung', 'Unternehmenskauf', 'Urheberrecht', 'Urlaub', 'Vaterschaftsanerkennung', 'Vererben', 'Verkehrsunfall', 'Vermögensauseinandersetzung', 'Vermögensdelikte', 'Verstoß gegen die Anschnallpflicht', 'Vertragsprüfung', 'Vertragsrecht', 'Visum', 'Vorfälligkeitsentschädigung', 'Vorsorge', 'Vorsorgevollmacht/Patientenverfügung', 'Waffendelikte', 'Wettbewerbsrecht', 'Widerrufsrechte', 'Widerspruch/ Klage', 'Wucherzinsen Darlehen', 'Zugewinnausgleich', 'Zweiradunfall', 'unbezahlte Rechnungen', 'unerlaubtes Glücksspiel', 'Überstunden', 'Übertragung zu Lebzeiten'],
    type: 'string',
    description: `* \`AGB\` - AGB
* \`Abfindung\` - Abfindung
* \`Abmahnung\` - Abmahnung
* \`Abmahnung Wettbewerbsrecht\` - Abmahnung Wettbewerbsrecht
* \`Abschiebungshaft\` - Abschiebungshaft
* \`Abschlussarbeit\` - Abschlussarbeit
* \`Abstandsregelung nicht eingehalten\` - Abstandsregelung nicht eingehalten
* \`Account hacking\` - Account hacking
* \`Allgemein\` - Allgemein
* \`Allgemeines Prüfungsrecht\` - Allgemeines Prüfungsrecht
* \`Anderes\` - Anderes
* \`Arbeitsamt/ALG/Sperrzeit\` - Arbeitsamt/ALG/Sperrzeit
* \`Arbeitsunfall\` - Arbeitsunfall
* \`Arbeitsvertrag\` - Arbeitsvertrag
* \`Arbeitszeugnis\` - Arbeitszeugnis
* \`Aufbau Compliancesystem\` - Aufbau Compliancesystem
* \`Aufenthaltserlaubnis\` - Aufenthaltserlaubnis
* \`Aufhebungsvertrag\` - Aufhebungsvertrag
* \`Auftragsdatenverarbeitung\` - Auftragsdatenverarbeitung
* \`Auseinandersetzung Erbengemeinschaft\` - Auseinandersetzung Erbengemeinschaft
* \`Auskunft prüfen\` - Auskunft prüfen
* \`Ausweisung\` - Ausweisung
* \`Autokauf\` - Autokauf
* \`Bankkonto leergeräumt\` - Bankkonto leergeräumt
* \`Bankrecht\` - Bankrecht
* \`Baumangel\` - Baumangel
* \`Bauvertrag\` - Bauvertrag
* \`Behandlungsfehler Allgemein\` - Behandlungsfehler Allgemein
* \`Behandlungsfehler Querschnittslähmung\` - Behandlungsfehler Querschnittslähmung
* \`Behandlungsfehler Schlaganfall\` - Behandlungsfehler Schlaganfall
* \`Beißvorfall\` - Beißvorfall
* \`Beratung zu Erbfall\` - Beratung zu Erbfall
* \`Beschlagnahme Allgemein\` - Beschlagnahme Allgemein
* \`Beschlagnahme Tierquälerei\` - Beschlagnahme Tierquälerei
* \`Betreuungsrecht\` - Betreuungsrecht
* \`Betrug Geldanlage\` - Betrug Geldanlage
* \`Betäubungsmittel\` - Betäubungsmittel
* \`Burgschild Inkasso\` - Burgschild Inkasso
* \`Bußgeldbescheid\` - Bußgeldbescheid
* \`Bürgergeld\` - Bürgergeld
* \`Coaching\` - Coaching
* \`Datenschutz\` - Datenschutz
* \`Datenschutz Schadensersatz\` - Datenschutz Schadensersatz
* \`Datenschutzverstoß\` - Datenschutzverstoß
* \`Domains\` - Domains
* \`Ehevertrag\` - Ehevertrag
* \`Eigentumsdelikte\` - Eigentumsdelikte
* \`Einbürgerung\` - Einbürgerung
* \`Einreisesperre\` - Einreisesperre
* \`Eintrag löschen\` - Eintrag löschen
* \`Erbauseinandersetzung\` - Erbauseinandersetzung
* \`Erbausschlagung\` - Erbausschlagung
* \`Erben/Schenken\` - Erben/Schenken
* \`Erbengemeinschaft\` - Erbengemeinschaft
* \`Erbschein\` - Erbschein
* \`Erbscheinsantrag\` - Erbscheinsantrag
* \`Erbvertrag\` - Erbvertrag
* \`Exmatrikulation\` - Exmatrikulation
* \`Fahren ohne Führerschein\` - Fahren ohne Führerschein
* \`Fahren unter Alkohol - / Drogeneinfluss\` - Fahren unter Alkohol - / Drogeneinfluss
* \`Fahrer - / Unfallflucht\` - Fahrer - / Unfallflucht
* \`Fahrverbot / Führerscheinentzug\` - Fahrverbot / Führerscheinentzug
* \`Falschaussage/ Meineid\` - Falschaussage/ Meineid
* \`Familie Vorsorge\` - Familie Vorsorge
* \`Forderung löschen\` - Forderung löschen
* \`Geburtsfehler\` - Geburtsfehler
* \`Geburtsfehler Mutter\` - Geburtsfehler Mutter
* \`Geschwindigkeitsüberschreitung\` - Geschwindigkeitsüberschreitung
* \`Gesetzliche Erbfolge\` - Gesetzliche Erbfolge
* \`Gewerblicher Rechtsschutz\` - Gewerblicher Rechtsschutz
* \`Grundschuld\` - Grundschuld
* \`Gründung\` - Gründung
* \`Handy am Steuer\` - Handy am Steuer
* \`Hauskauf\` - Hauskauf
* \`Härtefallantrag\` - Härtefallantrag
* \`Immobilien\` - Immobilien
* \`Immobilienübertragung\` - Immobilienübertragung
* \`Kaufvertragsprüfung\` - Kaufvertragsprüfung
* \`Körperverletzung\` - Körperverletzung
* \`Kündigung\` - Kündigung
* \`Lohnzahlung\` - Lohnzahlung
* \`Maklerangelegenheit\` - Maklerangelegenheit
* \`Markenanmeldung\` - Markenanmeldung
* \`Markenverteidigung\` - Markenverteidigung
* \`Markenüberwachung\` - Markenüberwachung
* \`Mieterhöhung\` - Mieterhöhung
* \`Mietkaution\` - Mietkaution
* \`Mietminderung\` - Mietminderung
* \`Mietvertrag\` - Mietvertrag
* \`Nebenkostenabrechnung\` - Nebenkostenabrechnung
* \`Niederlassungserlaubnis\` - Niederlassungserlaubnis
* \`Nutzerbewertungen Verfasser\` - Nutzerbewertungen Verfasser
* \`Patientenverfügung/Vorsorgevollmacht\` - Patientenverfügung/Vorsorgevollmacht
* \`Personenverwechselung\` - Personenverwechselung
* \`Pflege-/Krankenversicherung\` - Pflege-/Krankenversicherung
* \`Pflichtteil\` - Pflichtteil
* \`Pflichtteil Geltendmachung\` - Pflichtteil Geltendmachung
* \`Pflichtteil abwehren\` - Pflichtteil abwehren
* \`Plagiatsvorwurf\` - Plagiatsvorwurf
* \`Remonstration\` - Remonstration
* \`Rente\` - Rente
* \`Rotlichtverstoß\` - Rotlichtverstoß
* \`Räumungsklage\` - Räumungsklage
* \`Schadensersatz\` - Schadensersatz
* \`Scheidung\` - Scheidung
* \`Schenkung\` - Schenkung
* \`Schenkung Immobilie\` - Schenkung Immobilie
* \`Schulplatz einklagen\` - Schulplatz einklagen
* \`Schwerbehinderung\` - Schwerbehinderung
* \`Sexualdelikt\` - Sexualdelikt
* \`Software Hardware\` - Software Hardware
* \`Sonstige Beglaubigung\` - Sonstige Beglaubigung
* \`Sorgerecht und Umgangsrecht\` - Sorgerecht und Umgangsrecht
* \`Testament\` - Testament
* \`Testament/Erbvertrag\` - Testament/Erbvertrag
* \`Tierkauf\` - Tierkauf
* \`Tierärztliche Behandlungsfehler\` - Tierärztliche Behandlungsfehler
* \`Trennung\` - Trennung
* \`Tuning\` - Tuning
* \`Täuschungsversuch\` - Täuschungsversuch
* \`Tötungsdelikte\` - Tötungsdelikte
* \`Unfall Querschnittslähmung\` - Unfall Querschnittslähmung
* \`Unfall mit Personenschaden\` - Unfall mit Personenschaden
* \`Unterhalt\` - Unterhalt
* \`Unternehmen\` - Unternehmen
* \`Unternehmensauflösung\` - Unternehmensauflösung
* \`Unternehmensgründung\` - Unternehmensgründung
* \`Unternehmenskauf\` - Unternehmenskauf
* \`Urheberrecht\` - Urheberrecht
* \`Urlaub\` - Urlaub
* \`Vaterschaftsanerkennung\` - Vaterschaftsanerkennung
* \`Vererben\` - Vererben
* \`Verkehrsunfall\` - Verkehrsunfall
* \`Vermögensauseinandersetzung\` - Vermögensauseinandersetzung
* \`Vermögensdelikte\` - Vermögensdelikte
* \`Verstoß gegen die Anschnallpflicht\` - Verstoß gegen die Anschnallpflicht
* \`Vertragsprüfung\` - Vertragsprüfung
* \`Vertragsrecht\` - Vertragsrecht
* \`Visum\` - Visum
* \`Vorfälligkeitsentschädigung\` - Vorfälligkeitsentschädigung
* \`Vorsorge\` - Vorsorge
* \`Vorsorgevollmacht/Patientenverfügung\` - Vorsorgevollmacht/Patientenverfügung
* \`Waffendelikte\` - Waffendelikte
* \`Wettbewerbsrecht\` - Wettbewerbsrecht
* \`Widerrufsrechte\` - Widerrufsrechte
* \`Widerspruch/ Klage\` - Widerspruch/ Klage
* \`Wucherzinsen Darlehen\` - Wucherzinsen Darlehen
* \`Zugewinnausgleich\` - Zugewinnausgleich
* \`Zweiradunfall\` - Zweiradunfall
* \`unbezahlte Rechnungen\` - unbezahlte Rechnungen
* \`unerlaubtes Glücksspiel\` - unerlaubtes Glücksspiel
* \`Überstunden\` - Überstunden
* \`Übertragung zu Lebzeiten\` - Übertragung zu Lebzeiten`
} as const;

export const $LawfirmSettings = {
    type: 'object',
    description: 'Serializer for LawFirm integration settings in Organisation model.',
    properties: {
        is_law_firm_software_exportation_enabled: {
            type: 'boolean'
        }
    }
} as const;

export const $LawfirmSettingsRequest = {
    type: 'object',
    description: 'Serializer for LawFirm integration settings in Organisation model.',
    properties: {
        is_law_firm_software_exportation_enabled: {
            type: 'boolean'
        }
    }
} as const;

export const $LawyerFeedback = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        }
    },
    required: ['uuid']
} as const;

export const $LocationTypeEnum = {
    enum: ['ONLINE', 'TELEPHONE', 'IN_PERSON'],
    type: 'string',
    description: `* \`ONLINE\` - Online-Termin
* \`TELEPHONE\` - Telefon-Termin
* \`IN_PERSON\` - Termin vor Ort`
} as const;

export const $LocationTypesEnum = {
    enum: ['ONLINE', 'TELEPHONE', 'IN_PERSON'],
    type: 'string',
    description: `* \`ONLINE\` - Online-Termin
* \`TELEPHONE\` - Telefon-Termin
* \`IN_PERSON\` - Termin vor Ort`
} as const;

export const $MessageTypeEnum = {
    enum: ['INFO', 'WARNING', 'ERROR', 'SUCCESS'],
    type: 'string',
    description: `* \`INFO\` - Info
* \`WARNING\` - Warning
* \`ERROR\` - Error
* \`SUCCESS\` - Success`
} as const;

export const $NextStateEnum = {
    enum: ['CREATED', 'CLIENT_INFO_GATHERING', 'PRE_CASE_CONTEXT_GATHERING', 'CASE_CONTEXT_GATHERING', 'POST_CASE_CONTEXT_GATHERING', 'LEGAL_DOMAIN_CLASSIFICATION', 'WORKFLOW_ASSIGNMENT', 'READY_FOR_ONBOARDING_STEP_1', 'READY_FOR_ONBOARDING_STEP_2', 'DATA_COLLECTION', 'ALL_DATA_COLLECTED', 'DOCUMENT_DRAFTING', 'ALL_DOCUMENTS_DRAFTED', 'READY_FOR_EXPORT', 'EXPORTED', 'ABORTED'],
    type: 'string',
    description: `* \`CREATED\` - Created
* \`CLIENT_INFO_GATHERING\` - Client Info Gathering
* \`PRE_CASE_CONTEXT_GATHERING\` - Pre Case Context Gathering
* \`CASE_CONTEXT_GATHERING\` - Case Context Gathering
* \`POST_CASE_CONTEXT_GATHERING\` - Post Case Context Gathering
* \`LEGAL_DOMAIN_CLASSIFICATION\` - Legal Domain Classification
* \`WORKFLOW_ASSIGNMENT\` - Workflow Assignment
* \`READY_FOR_ONBOARDING_STEP_1\` - Ready For Onboarding Step 1
* \`READY_FOR_ONBOARDING_STEP_2\` - Ready For Onboarding Step 2
* \`DATA_COLLECTION\` - Data Collection
* \`ALL_DATA_COLLECTED\` - All Data Collected
* \`DOCUMENT_DRAFTING\` - Document Drafting
* \`ALL_DOCUMENTS_DRAFTED\` - All Documents Drafted
* \`READY_FOR_EXPORT\` - Ready For Export
* \`EXPORTED\` - Exported
* \`ABORTED\` - Aborted`
} as const;

export const $NotificationSettings = {
    type: 'object',
    description: 'Serializer for NotificationSettings.',
    properties: {
        params: {
            type: 'array',
            items: {
                type: 'object',
                additionalProperties: {}
            },
            description: 'List of available notification settings parameters'
        }
    },
    required: ['params']
} as const;

export const $NullEnum = {
    enum: [
        null
    ]
} as const;

export const $OperationTypeEnum = {
    enum: ['merge', 'split', 'reorganize'],
    type: 'string',
    description: `* \`merge\` - Merge
* \`split\` - Split
* \`reorganize\` - Reorganize`
} as const;

export const $OrganizationAiContext = {
    type: 'object',
    title: 'OrganizationAiContext',
    properties: {
        uuid: {
            type: 'string'
        },
        name: {
            type: 'string'
        },
        customer_number: {
            type: 'string'
        },
        law_firm: {
            type: 'boolean'
        },
        law_fields: {
            type: 'string'
        },
        street: {
            type: 'string',
            nullable: true
        },
        street_number: {
            type: 'string',
            nullable: true
        },
        zip: {
            type: 'string',
            nullable: true
        },
        city: {
            type: 'string',
            nullable: true
        },
        country: {
            type: 'string',
            nullable: true
        },
        phone: {
            type: 'string',
            nullable: true
        },
        email: {
            type: 'string',
            nullable: true
        },
        description: {
            type: 'string',
            nullable: true
        }
    },
    required: ['uuid', 'name', 'customer_number', 'law_firm', 'law_fields']
} as const;

export const $PDFFormSubmissionBase = {
    type: 'object',
    description: 'PDF form submission serializer for all user roles.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        submission_status: {
            allOf: [
                {
                    '$ref': '#/components/schemas/SubmissionStatusEnum'
                }
            ],
            description: `Current status of the form submission

* \`in_progress\` - In Progress
* \`completed\` - Completed`
        },
        form_fields: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/SubmissionFormField'
            }
        },
        progress_percentage: {
            type: 'integer',
            readOnly: true,
            description: 'Completion percentage (0-100)'
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        completed_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true,
            nullable: true,
            description: 'When the form was completed'
        },
        processed_pdf: {
            type: 'string',
            readOnly: true
        },
        flattened_pdf: {
            type: 'string',
            readOnly: true,
            nullable: true
        },
        template_name: {
            type: 'string',
            readOnly: true,
            description: 'Snapshot of template name at submission creation time'
        },
        template_description: {
            type: 'string',
            readOnly: true,
            description: 'Snapshot of template description at submission creation time'
        },
        is_standalone: {
            type: 'boolean',
            readOnly: true,
            description: 'Standalone submission that creates a new case (like questionnaires from settings)'
        },
        is_external: {
            type: 'boolean',
            readOnly: true,
            description: 'External submission linked to existing case for third-party completion'
        },
        org: {
            allOf: [
                {
                    '$ref': '#/components/schemas/ClientOrganisation'
                }
            ],
            readOnly: true
        },
        images: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/ImageproxyImagePreset'
            },
            readOnly: true
        }
    },
    required: ['completed_at', 'created_at', 'flattened_pdf', 'form_fields', 'images', 'is_external', 'is_standalone', 'org', 'processed_pdf', 'progress_percentage', 'template_description', 'template_name', 'uuid']
} as const;

export const $PDFFormSubmissionBaseRequest = {
    type: 'object',
    description: 'PDF form submission serializer for all user roles.',
    properties: {
        submission_status: {
            allOf: [
                {
                    '$ref': '#/components/schemas/SubmissionStatusEnum'
                }
            ],
            description: `Current status of the form submission

* \`in_progress\` - In Progress
* \`completed\` - Completed`
        },
        form_fields: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/SubmissionFormFieldRequest'
            }
        }
    },
    required: ['form_fields']
} as const;

export const $PDFFormTemplate = {
    type: 'object',
    description: 'Base serializer for PDF form templates.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        name: {
            type: 'string',
            maxLength: 255
        },
        description: {
            type: 'string'
        },
        original_pdf: {
            type: 'string',
            format: 'uri',
            description: 'Original PDF template uploaded by user (preserved, never modified)'
        },
        processed_pdf: {
            type: 'string',
            format: 'uri',
            readOnly: true,
            nullable: true,
            description: 'Processed PDF with annotations stripped for clean display'
        },
        form_fields: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/FormField'
            }
        },
        template_creation_token: {
            type: 'string',
            readOnly: true,
            nullable: true,
            description: 'Token used to create standalone form submissions via public URLs'
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        created_by: {
            allOf: [
                {
                    '$ref': '#/components/schemas/CustomerUser'
                }
            ],
            readOnly: true
        },
        updated_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        modified_by: {
            allOf: [
                {
                    '$ref': '#/components/schemas/CustomerUser'
                }
            ],
            readOnly: true
        }
    },
    required: ['created_at', 'created_by', 'modified_by', 'name', 'original_pdf', 'processed_pdf', 'template_creation_token', 'updated_at', 'uuid']
} as const;

export const $PDFFormTemplateRequest = {
    type: 'object',
    description: 'Base serializer for PDF form templates.',
    properties: {
        name: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        },
        description: {
            type: 'string'
        },
        original_pdf: {
            type: 'string',
            format: 'binary',
            description: 'Original PDF template uploaded by user (preserved, never modified)'
        },
        form_fields: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/FormFieldRequest'
            }
        }
    },
    required: ['name', 'original_pdf']
} as const;

export const $PageStateRequest = {
    type: 'object',
    description: 'Serializer for individual page state.',
    properties: {
        uuid: {
            type: 'string',
            minLength: 1,
            description: 'Frontend-generated page identifier'
        },
        document_uuid: {
            type: 'string',
            format: 'uuid',
            description: 'UUID of the document this page belongs to'
        },
        page_number: {
            type: 'integer',
            description: 'Page number within the document group'
        },
        filename: {
            type: 'string',
            minLength: 1,
            description: 'Original filename of the page',
            maxLength: 255
        }
    },
    required: ['document_uuid', 'filename', 'page_number', 'uuid']
} as const;

export const $PaginatedCaseAppointmentsList = {
    type: 'object',
    required: ['count', 'results'],
    properties: {
        count: {
            type: 'integer',
            example: 123
        },
        next: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=400&limit=100'
        },
        previous: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=200&limit=100'
        },
        results: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/CaseAppointments'
            }
        }
    }
} as const;

export const $PaginatedDocumentList = {
    type: 'object',
    required: ['count', 'results'],
    properties: {
        count: {
            type: 'integer',
            example: 123
        },
        next: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=400&limit=100'
        },
        previous: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=200&limit=100'
        },
        results: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/Document'
            }
        }
    }
} as const;

export const $PaginatedDocumentPlaceholderList = {
    type: 'object',
    required: ['count', 'results'],
    properties: {
        count: {
            type: 'integer',
            example: 123
        },
        next: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=400&limit=100'
        },
        previous: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=200&limit=100'
        },
        results: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/DocumentPlaceholder'
            }
        }
    }
} as const;

export const $PaginatedGenericMetricEventList = {
    type: 'object',
    required: ['count', 'results'],
    properties: {
        count: {
            type: 'integer',
            example: 123
        },
        next: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=400&limit=100'
        },
        previous: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=200&limit=100'
        },
        results: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/GenericMetricEvent'
            }
        }
    }
} as const;

export const $PaginatedSessionGroupList = {
    type: 'object',
    required: ['count', 'results'],
    properties: {
        count: {
            type: 'integer',
            example: 123
        },
        next: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=400&limit=100'
        },
        previous: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=200&limit=100'
        },
        results: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/SessionGroup'
            }
        }
    }
} as const;

export const $PaginatedSuperUserHubSpotCompanyList = {
    type: 'object',
    required: ['count', 'results'],
    properties: {
        count: {
            type: 'integer',
            example: 123
        },
        next: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=400&limit=100'
        },
        previous: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=200&limit=100'
        },
        results: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/SuperUserHubSpotCompany'
            }
        }
    }
} as const;

export const $PaginatedSuperUserHubSpotContactList = {
    type: 'object',
    required: ['count', 'results'],
    properties: {
        count: {
            type: 'integer',
            example: 123
        },
        next: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=400&limit=100'
        },
        previous: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=200&limit=100'
        },
        results: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/SuperUserHubSpotContact'
            }
        }
    }
} as const;

export const $PaginatedTAIChatSessionList = {
    type: 'object',
    required: ['count', 'results'],
    properties: {
        count: {
            type: 'integer',
            example: 123
        },
        next: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=400&limit=100'
        },
        previous: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=200&limit=100'
        },
        results: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/TAIChatSession'
            }
        }
    }
} as const;

export const $PaginatedTAccountList = {
    type: 'object',
    required: ['count', 'results'],
    properties: {
        count: {
            type: 'integer',
            example: 123
        },
        next: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=400&limit=100'
        },
        previous: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=200&limit=100'
        },
        results: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/TAccount'
            }
        }
    }
} as const;

export const $PaginatedTActionAutoCommitSettingsList = {
    type: 'object',
    required: ['count', 'results'],
    properties: {
        count: {
            type: 'integer',
            example: 123
        },
        next: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=400&limit=100'
        },
        previous: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=200&limit=100'
        },
        results: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/TActionAutoCommitSettings'
            }
        }
    }
} as const;

export const $PaginatedTActiveAnnouncementList = {
    type: 'object',
    required: ['count', 'results'],
    properties: {
        count: {
            type: 'integer',
            example: 123
        },
        next: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=400&limit=100'
        },
        previous: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=200&limit=100'
        },
        results: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/TActiveAnnouncement'
            }
        }
    }
} as const;

export const $PaginatedTActivityList = {
    type: 'object',
    required: ['count', 'results'],
    properties: {
        count: {
            type: 'integer',
            example: 123
        },
        next: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=400&limit=100'
        },
        previous: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=200&limit=100'
        },
        results: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/TActivity'
            }
        }
    }
} as const;

export const $PaginatedTAgentActionList = {
    type: 'object',
    required: ['count', 'results'],
    properties: {
        count: {
            type: 'integer',
            example: 123
        },
        next: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=400&limit=100'
        },
        previous: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=200&limit=100'
        },
        results: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/TAgentAction'
            }
        }
    }
} as const;

export const $PaginatedTAiAnalysisList = {
    type: 'object',
    required: ['count', 'results'],
    properties: {
        count: {
            type: 'integer',
            example: 123
        },
        next: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=400&limit=100'
        },
        previous: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=200&limit=100'
        },
        results: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/TAiAnalysis'
            }
        }
    }
} as const;

export const $PaginatedTAiAugmentationList = {
    type: 'object',
    required: ['count', 'results'],
    properties: {
        count: {
            type: 'integer',
            example: 123
        },
        next: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=400&limit=100'
        },
        previous: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=200&limit=100'
        },
        results: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/TAiAugmentation'
            }
        }
    }
} as const;

export const $PaginatedTAiChatQuestionTemplateList = {
    type: 'object',
    required: ['count', 'results'],
    properties: {
        count: {
            type: 'integer',
            example: 123
        },
        next: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=400&limit=100'
        },
        previous: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=200&limit=100'
        },
        results: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/TAiChatQuestionTemplate'
            }
        }
    }
} as const;

export const $PaginatedTAiSettingsList = {
    type: 'object',
    required: ['count', 'results'],
    properties: {
        count: {
            type: 'integer',
            example: 123
        },
        next: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=400&limit=100'
        },
        previous: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=200&limit=100'
        },
        results: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/TAiSettings'
            }
        }
    }
} as const;

export const $PaginatedTAnnouncementList = {
    type: 'object',
    required: ['count', 'results'],
    properties: {
        count: {
            type: 'integer',
            example: 123
        },
        next: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=400&limit=100'
        },
        previous: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=200&limit=100'
        },
        results: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/TAnnouncement'
            }
        }
    }
} as const;

export const $PaginatedTAppointmentList = {
    type: 'object',
    required: ['count', 'results'],
    properties: {
        count: {
            type: 'integer',
            example: 123
        },
        next: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=400&limit=100'
        },
        previous: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=200&limit=100'
        },
        results: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/TAppointment'
            }
        }
    }
} as const;

export const $PaginatedTAppointmentProposalList = {
    type: 'object',
    required: ['count', 'results'],
    properties: {
        count: {
            type: 'integer',
            example: 123
        },
        next: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=400&limit=100'
        },
        previous: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=200&limit=100'
        },
        results: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/TAppointmentProposal'
            }
        }
    }
} as const;

export const $PaginatedTCalendarList = {
    type: 'object',
    required: ['count', 'results'],
    properties: {
        count: {
            type: 'integer',
            example: 123
        },
        next: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=400&limit=100'
        },
        previous: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=200&limit=100'
        },
        results: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/TCalendar'
            }
        }
    }
} as const;

export const $PaginatedTCallList = {
    type: 'object',
    required: ['count', 'results'],
    properties: {
        count: {
            type: 'integer',
            example: 123
        },
        next: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=400&limit=100'
        },
        previous: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=200&limit=100'
        },
        results: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/TCall'
            }
        }
    }
} as const;

export const $PaginatedTCaseCreatorTempDocumentList = {
    type: 'object',
    required: ['count', 'results'],
    properties: {
        count: {
            type: 'integer',
            example: 123
        },
        next: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=400&limit=100'
        },
        previous: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=200&limit=100'
        },
        results: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/TCaseCreatorTempDocument'
            }
        }
    }
} as const;

export const $PaginatedTCaseLifecycleStateList = {
    type: 'object',
    required: ['count', 'results'],
    properties: {
        count: {
            type: 'integer',
            example: 123
        },
        next: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=400&limit=100'
        },
        previous: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=200&limit=100'
        },
        results: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/TCaseLifecycleState'
            }
        }
    }
} as const;

export const $PaginatedTCaseLifecycleStateReasoningList = {
    type: 'object',
    required: ['count', 'results'],
    properties: {
        count: {
            type: 'integer',
            example: 123
        },
        next: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=400&limit=100'
        },
        previous: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=200&limit=100'
        },
        results: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/TCaseLifecycleStateReasoning'
            }
        }
    }
} as const;

export const $PaginatedTCaseLifecycleWorkflowList = {
    type: 'object',
    required: ['count', 'results'],
    properties: {
        count: {
            type: 'integer',
            example: 123
        },
        next: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=400&limit=100'
        },
        previous: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=200&limit=100'
        },
        results: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/TCaseLifecycleWorkflow'
            }
        }
    }
} as const;

export const $PaginatedTCaseList = {
    type: 'object',
    required: ['count', 'results'],
    properties: {
        count: {
            type: 'integer',
            example: 123
        },
        next: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=400&limit=100'
        },
        previous: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=200&limit=100'
        },
        results: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/TCase'
            }
        }
    }
} as const;

export const $PaginatedTChatPreferenceList = {
    type: 'object',
    required: ['count', 'results'],
    properties: {
        count: {
            type: 'integer',
            example: 123
        },
        next: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=400&limit=100'
        },
        previous: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=200&limit=100'
        },
        results: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/TChatPreference'
            }
        }
    }
} as const;

export const $PaginatedTDeliveryEventList = {
    type: 'object',
    required: ['count', 'results'],
    properties: {
        count: {
            type: 'integer',
            example: 123
        },
        next: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=400&limit=100'
        },
        previous: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=200&limit=100'
        },
        results: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/TDeliveryEvent'
            }
        }
    }
} as const;

export const $PaginatedTDocumentList = {
    type: 'object',
    required: ['count', 'results'],
    properties: {
        count: {
            type: 'integer',
            example: 123
        },
        next: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=400&limit=100'
        },
        previous: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=200&limit=100'
        },
        results: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/TDocument'
            }
        }
    }
} as const;

export const $PaginatedTDocumentTemplateList = {
    type: 'object',
    required: ['count', 'results'],
    properties: {
        count: {
            type: 'integer',
            example: 123
        },
        next: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=400&limit=100'
        },
        previous: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=200&limit=100'
        },
        results: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/TDocumentTemplate'
            }
        }
    }
} as const;

export const $PaginatedTEmailList = {
    type: 'object',
    required: ['count', 'results'],
    properties: {
        count: {
            type: 'integer',
            example: 123
        },
        next: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=400&limit=100'
        },
        previous: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=200&limit=100'
        },
        results: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/TEmail'
            }
        }
    }
} as const;

export const $PaginatedTEmailTemplateList = {
    type: 'object',
    required: ['count', 'results'],
    properties: {
        count: {
            type: 'integer',
            example: 123
        },
        next: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=400&limit=100'
        },
        previous: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=200&limit=100'
        },
        results: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/TEmailTemplate'
            }
        }
    }
} as const;

export const $PaginatedTEntityList = {
    type: 'object',
    required: ['count', 'results'],
    properties: {
        count: {
            type: 'integer',
            example: 123
        },
        next: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=400&limit=100'
        },
        previous: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=200&limit=100'
        },
        results: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/TEntity'
            }
        }
    }
} as const;

export const $PaginatedTFeedbackList = {
    type: 'object',
    required: ['count', 'results'],
    properties: {
        count: {
            type: 'integer',
            example: 123
        },
        next: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=400&limit=100'
        },
        previous: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=200&limit=100'
        },
        results: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/TFeedback'
            }
        }
    }
} as const;

export const $PaginatedTFormList = {
    type: 'object',
    required: ['count', 'results'],
    properties: {
        count: {
            type: 'integer',
            example: 123
        },
        next: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=400&limit=100'
        },
        previous: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=200&limit=100'
        },
        results: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/TForm'
            }
        }
    }
} as const;

export const $PaginatedTGenericDataMapperList = {
    type: 'object',
    required: ['count', 'results'],
    properties: {
        count: {
            type: 'integer',
            example: 123
        },
        next: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=400&limit=100'
        },
        previous: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=200&limit=100'
        },
        results: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/TGenericDataMapper'
            }
        }
    }
} as const;

export const $PaginatedTInboundEmailList = {
    type: 'object',
    required: ['count', 'results'],
    properties: {
        count: {
            type: 'integer',
            example: 123
        },
        next: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=400&limit=100'
        },
        previous: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=200&limit=100'
        },
        results: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/TInboundEmail'
            }
        }
    }
} as const;

export const $PaginatedTLawyerFeedbackList = {
    type: 'object',
    required: ['count', 'results'],
    properties: {
        count: {
            type: 'integer',
            example: 123
        },
        next: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=400&limit=100'
        },
        previous: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=200&limit=100'
        },
        results: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/TLawyerFeedback'
            }
        }
    }
} as const;

export const $PaginatedTOrganisationList = {
    type: 'object',
    required: ['count', 'results'],
    properties: {
        count: {
            type: 'integer',
            example: 123
        },
        next: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=400&limit=100'
        },
        previous: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=200&limit=100'
        },
        results: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/TOrganisation'
            }
        }
    }
} as const;

export const $PaginatedTPDFFormSubmissionList = {
    type: 'object',
    required: ['count', 'results'],
    properties: {
        count: {
            type: 'integer',
            example: 123
        },
        next: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=400&limit=100'
        },
        previous: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=200&limit=100'
        },
        results: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/TPDFFormSubmission'
            }
        }
    }
} as const;

export const $PaginatedTPDFFormTemplateList = {
    type: 'object',
    required: ['count', 'results'],
    properties: {
        count: {
            type: 'integer',
            example: 123
        },
        next: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=400&limit=100'
        },
        previous: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=200&limit=100'
        },
        results: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/TPDFFormTemplate'
            }
        }
    }
} as const;

export const $PaginatedTPhoneForwardingRuleList = {
    type: 'object',
    required: ['count', 'results'],
    properties: {
        count: {
            type: 'integer',
            example: 123
        },
        next: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=400&limit=100'
        },
        previous: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=200&limit=100'
        },
        results: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/TPhoneForwardingRule'
            }
        }
    }
} as const;

export const $PaginatedTPhoneNumberList = {
    type: 'object',
    required: ['count', 'results'],
    properties: {
        count: {
            type: 'integer',
            example: 123
        },
        next: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=400&limit=100'
        },
        previous: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=200&limit=100'
        },
        results: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/TPhoneNumber'
            }
        }
    }
} as const;

export const $PaginatedTQuestionnaireList = {
    type: 'object',
    required: ['count', 'results'],
    properties: {
        count: {
            type: 'integer',
            example: 123
        },
        next: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=400&limit=100'
        },
        previous: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=200&limit=100'
        },
        results: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/TQuestionnaire'
            }
        }
    }
} as const;

export const $PaginatedTQuestionnaireSubmissionList = {
    type: 'object',
    required: ['count', 'results'],
    properties: {
        count: {
            type: 'integer',
            example: 123
        },
        next: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=400&limit=100'
        },
        previous: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=200&limit=100'
        },
        results: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/TQuestionnaireSubmission'
            }
        }
    }
} as const;

export const $PaginatedTRetellAgentList = {
    type: 'object',
    required: ['count', 'results'],
    properties: {
        count: {
            type: 'integer',
            example: 123
        },
        next: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=400&limit=100'
        },
        previous: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=200&limit=100'
        },
        results: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/TRetellAgent'
            }
        }
    }
} as const;

export const $PaginatedTSavedResponseList = {
    type: 'object',
    required: ['count', 'results'],
    properties: {
        count: {
            type: 'integer',
            example: 123
        },
        next: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=400&limit=100'
        },
        previous: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=200&limit=100'
        },
        results: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/TSavedResponse'
            }
        }
    }
} as const;

export const $PaginatedTServiceList = {
    type: 'object',
    required: ['count', 'results'],
    properties: {
        count: {
            type: 'integer',
            example: 123
        },
        next: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=400&limit=100'
        },
        previous: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=200&limit=100'
        },
        results: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/TService'
            }
        }
    }
} as const;

export const $PaginatedTStripeCustomerList = {
    type: 'object',
    required: ['count', 'results'],
    properties: {
        count: {
            type: 'integer',
            example: 123
        },
        next: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=400&limit=100'
        },
        previous: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=200&limit=100'
        },
        results: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/TStripeCustomer'
            }
        }
    }
} as const;

export const $PaginatedTStripeInvoiceList = {
    type: 'object',
    required: ['count', 'results'],
    properties: {
        count: {
            type: 'integer',
            example: 123
        },
        next: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=400&limit=100'
        },
        previous: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=200&limit=100'
        },
        results: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/TStripeInvoice'
            }
        }
    }
} as const;

export const $PaginatedTUserList = {
    type: 'object',
    required: ['count', 'results'],
    properties: {
        count: {
            type: 'integer',
            example: 123
        },
        next: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=400&limit=100'
        },
        previous: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=200&limit=100'
        },
        results: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/TUser'
            }
        }
    }
} as const;

export const $PaginatedTWordDocumentTemplateList = {
    type: 'object',
    required: ['count', 'results'],
    properties: {
        count: {
            type: 'integer',
            example: 123
        },
        next: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=400&limit=100'
        },
        previous: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=200&limit=100'
        },
        results: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/TWordDocumentTemplate'
            }
        }
    }
} as const;

export const $PaginatedUnifiedDocumentTemplateList = {
    type: 'object',
    required: ['count', 'results'],
    properties: {
        count: {
            type: 'integer',
            example: 123
        },
        next: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=400&limit=100'
        },
        previous: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=200&limit=100'
        },
        results: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/UnifiedDocumentTemplate'
            }
        }
    }
} as const;

export const $PaginatedWordDocumentTemplateList = {
    type: 'object',
    required: ['count', 'results'],
    properties: {
        count: {
            type: 'integer',
            example: 123
        },
        next: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=400&limit=100'
        },
        previous: {
            type: 'string',
            nullable: true,
            format: 'uri',
            example: 'http://api.example.org/accounts/?offset=200&limit=100'
        },
        results: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/WordDocumentTemplate'
            }
        }
    }
} as const;

export const $PatchedAIChatSessionRequest = {
    type: 'object',
    properties: {
        title: {
            type: 'string',
            maxLength: 255
        },
        description: {
            type: 'string'
        },
        session_type: {
            '$ref': '#/components/schemas/AIChatSessionTypeEnum'
        },
        case_uuid: {
            type: 'string',
            format: 'uuid',
            writeOnly: true
        },
        session_group_uuid: {
            type: 'string',
            format: 'uuid',
            writeOnly: true,
            nullable: true
        },
        human_rating: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,1}(?:\\.\\d{0,1})?$',
            nullable: true
        }
    }
} as const;

export const $PatchedAiChatQuestionTemplateRequest = {
    type: 'object',
    properties: {
        law_field: {
            title: 'Rechtsgebiet',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawFieldEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        law_topic: {
            title: 'Rechtsthema',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawTopicEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        prompt: {
            type: 'string',
            minLength: 1
        },
        title: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        },
        description: {
            type: 'string'
        }
    }
} as const;

export const $PatchedAssignWorkflowRequestRequest = {
    type: 'object',
    description: 'Serializer for assigning a workflow to a case.',
    properties: {
        workflow_uuid: {
            type: 'string',
            format: 'uuid',
            nullable: true,
            description: 'UUID of the workflow to assign to the case. Set to null to remove workflow assignment.'
        }
    }
} as const;

export const $PatchedCaseCreatorTempDocumentRequest = {
    type: 'object',
    properties: {
        original_filename: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        },
        file: {
            type: 'string',
            format: 'binary'
        }
    }
} as const;

export const $PatchedChatPreferenceRequest = {
    type: 'object',
    description: 'Serializer for the ChatPreference model.',
    properties: {
        title: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        },
        content: {
            type: 'string',
            minLength: 1
        },
        scope: {
            '$ref': '#/components/schemas/ScopeEnum'
        },
        source: {
            nullable: true,
            oneOf: [
                {
                    '$ref': '#/components/schemas/SourceEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                },
                {
                    '$ref': '#/components/schemas/NullEnum'
                }
            ]
        },
        org: {
            type: 'integer',
            nullable: true
        },
        created_by_user: {
            type: 'integer',
            nullable: true
        },
        user: {
            type: 'integer',
            nullable: true
        },
        case: {
            type: 'integer',
            nullable: true
        },
        message_uuid: {
            type: 'string',
            format: 'uuid',
            nullable: true,
            description: 'UUID of the AI chat message this preference was created from'
        },
        is_active: {
            type: 'boolean'
        },
        sentiment: {
            type: 'string',
            nullable: true,
            description: 'Sentiment classification (like, dislike, neutral, etc.)',
            maxLength: 32
        },
        confidence: {
            type: 'number',
            format: 'double',
            nullable: true,
            description: 'Confidence score for the sentiment classification (0.0-1.0)'
        },
        entity: {
            type: 'string',
            nullable: true,
            description: 'Entity or topic this preference relates to',
            maxLength: 255
        },
        frequency_positive: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            description: 'Number of positive interactions with this preference'
        },
        frequency_negative: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            description: 'Number of negative interactions with this preference'
        },
        last_accessed: {
            type: 'string',
            format: 'date-time',
            nullable: true,
            description: 'Last time this preference was accessed/used'
        }
    }
} as const;

export const $PatchedClientAiAnalysisRequest = {
    type: 'object',
    properties: {
        case_uuid: {
            type: 'string',
            format: 'uuid'
        },
        document_uuid: {
            type: 'string',
            format: 'uuid'
        }
    }
} as const;

export const $PatchedClientAiAugmentationRequest = {
    type: 'object',
    properties: {
        value: {
            oneOf: [
                {
                    type: 'string'
                },
                {
                    type: 'integer'
                },
                {
                    type: 'boolean'
                },
                {
                    type: 'string',
                    format: 'date'
                },
                {
                    type: 'object',
                    additionalProperties: {}
                },
                {
                    type: 'array',
                    items: {}
                }
            ]
        },
        referenced_document_pages: {
            type: 'array',
            items: {
                type: 'integer'
            }
        },
        explanation: {
            type: 'string',
            minLength: 1
        }
    }
} as const;

export const $PatchedClientEntityRequest = {
    type: 'object',
    description: 'Entity representation for clients.',
    properties: {
        entity_type: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EntityTypeEnum'
                }
            ],
            title: 'Personentyp'
        },
        title: {
            title: 'Anrede',
            oneOf: [
                {
                    '$ref': '#/components/schemas/TitleEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        first_name: {
            type: 'string',
            title: 'Vorname',
            maxLength: 128
        },
        last_name: {
            type: 'string',
            title: 'Nachname',
            maxLength: 128
        },
        email: {
            type: 'string',
            format: 'email',
            title: 'E-Mail',
            maxLength: 128
        },
        phone: {
            type: 'string',
            title: 'Telefon',
            maxLength: 128
        },
        street: {
            type: 'string',
            title: 'Straße',
            maxLength: 128
        },
        street_number: {
            type: 'string',
            title: 'Hausnummer',
            maxLength: 16
        },
        address_line_2: {
            type: 'string',
            title: 'Adresszusatz',
            maxLength: 128
        },
        zip: {
            type: 'string',
            title: 'PLZ',
            maxLength: 12
        },
        city: {
            type: 'string',
            title: 'Ort',
            maxLength: 100
        },
        date_of_birth: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Geburtsdatum'
        },
        legal_insurance: {
            type: 'boolean',
            nullable: true,
            title: 'Rechtsschutzversicherung'
        },
        legal_insurance_number: {
            type: 'string',
            title: 'Nummer der Rechtsschutzversicherung',
            maxLength: 128
        },
        legal_insurance_name: {
            type: 'string',
            title: 'Name der Rechtsschutzversicherung',
            maxLength: 128
        },
        legal_insurance_deductible_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Höhe der Selbstbeteiligung der Rechtsschutzversicherung'
        },
        company_name: {
            type: 'string',
            title: 'Firmenname',
            maxLength: 128
        },
        company_legal_form: {
            title: 'Rechtsform',
            oneOf: [
                {
                    '$ref': '#/components/schemas/CompanyLegalFormEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        company_register_number: {
            type: 'string',
            title: 'Handelsregisternummer',
            maxLength: 128
        },
        company_register_court: {
            type: 'string',
            title: 'Amtsgericht',
            maxLength: 128
        },
        company_vat_id: {
            type: 'string',
            title: 'USt. ID',
            maxLength: 128
        },
        company_tax_id: {
            type: 'string',
            title: 'Steuernummer',
            maxLength: 128
        },
        bank_name: {
            type: 'string',
            title: 'Bankname',
            maxLength: 128
        },
        iban: {
            type: 'string',
            maxLength: 34
        },
        bic: {
            type: 'string',
            maxLength: 11
        },
        institution_name: {
            type: 'string',
            title: 'Name der Institution',
            maxLength: 128
        }
    }
} as const;

export const $PatchedClientQuestionnaireSubmissionRequest = {
    type: 'object',
    description: 'Questionnaire submission representation for clients.',
    properties: {
        schema: {},
        closed: {
            type: 'boolean'
        }
    }
} as const;

export const $PatchedCreatePDFFormTemplateRequest = {
    type: 'object',
    description: 'Serializer for creating new PDF form templates.',
    properties: {
        name: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        },
        description: {
            type: 'string'
        },
        original_pdf: {
            type: 'string',
            format: 'binary',
            description: 'Original PDF template uploaded by user (preserved, never modified)'
        }
    }
} as const;

export const $PatchedCustomerAccountRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        account_id: {
            type: 'string',
            minLength: 1,
            maxLength: 28
        }
    }
} as const;

export const $PatchedCustomerActionAutoCommitSettingsRequest = {
    type: 'object',
    description: 'ActionAutoCommitSettings representation for customers.',
    properties: {
        auto_commit_settings_key: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        },
        can_auto_commit: {
            type: 'boolean'
        },
        additional_user_instructions: {
            type: 'string'
        },
        confidence_threshold: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648
        }
    }
} as const;

export const $PatchedCustomerActivityRequest = {
    type: 'object',
    description: 'Activity serializer for customer role.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        seen_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        activity_type: {
            '$ref': '#/components/schemas/ActivityTypeEnum'
        }
    }
} as const;

export const $PatchedCustomerAdminAccountRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        account_id: {
            type: 'string',
            minLength: 1,
            maxLength: 28
        }
    }
} as const;

export const $PatchedCustomerAdminActionAutoCommitSettingsRequest = {
    type: 'object',
    description: 'ActionAutoCommitSettings representation for customer admins.',
    properties: {
        auto_commit_settings_key: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        },
        can_auto_commit: {
            type: 'boolean'
        },
        additional_user_instructions: {
            type: 'string'
        },
        confidence_threshold: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648
        }
    }
} as const;

export const $PatchedCustomerAdminActivityRequest = {
    type: 'object',
    description: 'Activity serializer for customer admin role.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        seen_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        activity_type: {
            '$ref': '#/components/schemas/ActivityTypeEnum'
        }
    }
} as const;

export const $PatchedCustomerAdminAiAnalysisRequest = {
    type: 'object',
    properties: {
        case_uuid: {
            type: 'string',
            format: 'uuid'
        },
        document_uuid: {
            type: 'string',
            format: 'uuid'
        }
    }
} as const;

export const $PatchedCustomerAdminAiAugmentationRequest = {
    type: 'object',
    properties: {
        value: {
            oneOf: [
                {
                    type: 'string'
                },
                {
                    type: 'integer'
                },
                {
                    type: 'boolean'
                },
                {
                    type: 'string',
                    format: 'date'
                },
                {
                    type: 'object',
                    additionalProperties: {}
                },
                {
                    type: 'array',
                    items: {}
                }
            ]
        },
        referenced_document_pages: {
            type: 'array',
            items: {
                type: 'integer'
            }
        },
        explanation: {
            type: 'string',
            minLength: 1
        }
    }
} as const;

export const $PatchedCustomerAdminAiSettingsRequest = {
    type: 'object',
    description: 'AI Settings representation for customer admins.',
    properties: {
        entity_extraction_instructions: {
            type: 'string',
            description: 'Instructions for AI agents when performing entity extraction'
        },
        auto_commit_settings: {
            type: 'string'
        },
        notification_settings: {
            type: 'string'
        },
        ai_workflows_enabled: {
            type: 'boolean',
            description: 'Enable or disable AI workflows for this organisation. When disabled, AI workflows will not be executed for cases in this organisation.'
        },
        send_notifications_bundled: {
            type: 'boolean',
            description: 'Whether to send notifications bundled or individually'
        },
        bundled_notifications_max_delay: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            description: 'Maximum delay in seconds before sending bundled notifications'
        },
        on_case_pre_case_context_gathering_instructions: {
            type: 'string',
            title: 'Pre Case Context Gathering Instructions',
            description: 'Instructions for AI agents during pre case context gathering'
        },
        on_case_post_case_context_gathering_instructions: {
            type: 'string',
            title: 'Post Case Context Gathering Instructions',
            description: 'Instructions for AI agents during post case context gathering'
        }
    }
} as const;

export const $PatchedCustomerAdminAppointmentProposalRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        case_uuid: {
            type: 'string',
            writeOnly: true,
            minLength: 1
        },
        start: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        location_type: {
            '$ref': '#/components/schemas/LocationTypeEnum'
        },
        message: {
            type: 'string',
            nullable: true
        },
        service_uuid: {
            type: 'string',
            format: 'uuid',
            writeOnly: true
        },
        calendar_uuid: {
            type: 'string',
            format: 'uuid',
            writeOnly: true
        }
    }
} as const;

export const $PatchedCustomerAdminCalendarRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        active: {
            type: 'boolean',
            title: 'Dieser Kalender ist buchbar'
        },
        name: {
            type: 'string',
            minLength: 1,
            maxLength: 32
        },
        description: {
            type: 'string',
            title: 'Titel',
            maxLength: 32
        },
        long_description: {
            type: 'string',
            title: 'Beschreibung',
            maxLength: 400
        },
        avatar: {
            type: 'string',
            format: 'binary',
            nullable: true,
            title: 'Profilbild'
        },
        services: {
            type: 'array',
            items: {
                type: 'integer'
            }
        },
        slug: {
            type: 'string',
            minLength: 1,
            maxLength: 64,
            pattern: '^[-a-zA-Z0-9_]+$'
        },
        deactivated: {
            type: 'boolean'
        },
        profile: {
            type: 'integer'
        },
        calendar_id: {
            type: 'string',
            minLength: 1,
            maxLength: 64
        },
        calendar_name: {
            type: 'string',
            minLength: 1,
            maxLength: 64
        },
        calendar_readonly: {
            type: 'boolean'
        },
        calendar_deleted: {
            type: 'boolean'
        },
        calendar_primary: {
            type: 'boolean'
        },
        calendar_integrated_conferencing_available: {
            type: 'boolean'
        },
        calendar_attachments_available: {
            type: 'boolean'
        },
        permission_level: {
            type: 'string',
            minLength: 1,
            maxLength: 32
        }
    }
} as const;

export const $PatchedCustomerAdminCaseLifecycleStateRequest = {
    type: 'object',
    description: 'Case Lifecycle State representation for customer admins.',
    properties: {
        workflow_uuid: {
            type: 'string',
            format: 'uuid',
            writeOnly: true,
            nullable: true,
            description: 'UUID of the workflow to assign to the case. Set to null to remove workflow assignment.'
        },
        is_agent_active: {
            type: 'boolean'
        }
    }
} as const;

export const $PatchedCustomerAdminCaseLifecycleWorkflowRequest = {
    type: 'object',
    description: 'Case Lifecycle Workflow representation for customer admins.',
    properties: {
        name: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        },
        law_field: {
            title: 'Rechtsgebiet',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawFieldEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        law_topic: {
            title: 'Rechtsthema',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawTopicEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        on_case_ready_for_onboarding_step_1_instructions: {
            type: 'string',
            title: 'Case Ready for Onboarding Step 1 Instructions',
            description: 'Instructions for AI agents when handling a new case - Step 1'
        },
        on_case_ready_for_onboarding_step_1_auto_commit_settings: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/CustomerAdminActionAutoCommitSettingsRequest'
            }
        },
        on_case_ready_for_onboarding_step_2_instructions: {
            type: 'string',
            title: 'Case Ready for Onboarding Step 2 Instructions',
            description: 'Instructions for AI agents when handling a new case - Step 2'
        },
        on_case_ready_for_onboarding_step_2_auto_commit_settings: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/CustomerAdminActionAutoCommitSettingsRequest'
            }
        },
        on_all_data_collected_instructions: {
            type: 'string',
            title: 'All Data Collected Instructions',
            description: 'Instructions for AI agents when all data for a case has been collected'
        },
        on_all_data_collected_auto_commit_settings: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/CustomerAdminActionAutoCommitSettingsRequest'
            }
        },
        on_all_documents_drafted_auto_commit_settings: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/CustomerAdminActionAutoCommitSettingsRequest'
            }
        }
    }
} as const;

export const $PatchedCustomerAdminCaseRequest = {
    type: 'object',
    description: 'Case representation for customer admins.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        created_at: {
            type: 'string',
            format: 'date-time'
        },
        note: {
            type: 'string',
            nullable: true,
            title: 'Interne Notizen',
            maxLength: 1024
        },
        type: {
            '$ref': '#/components/schemas/CaseType'
        },
        state: {
            allOf: [
                {
                    '$ref': '#/components/schemas/StateEnum'
                }
            ],
            title: 'Status'
        },
        inquiry: {
            type: 'string',
            title: 'Inhalt der Anfrage'
        },
        data: {
            '$ref': '#/components/schemas/CustomerAdminCaseDataRequest'
        },
        client_document_email_reminder_sent_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        client_document_email_reminder_opt_out: {
            type: 'boolean'
        },
        send_outstanding_document_email_reminder: {
            type: 'boolean',
            title: 'Automatisierte E-Mail Erinnerungen für angeforderte Dokumente aktiv'
        },
        sent_to_actaport_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        actaport_case_id: {
            type: 'string',
            nullable: true,
            minLength: 1,
            maxLength: 48
        },
        sent_to_advoware_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        advoware_case_id: {
            type: 'string',
            nullable: true,
            minLength: 1,
            maxLength: 48
        },
        sent_to_iusta_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        iusta_data: {},
        is_selected_for_export_to: {},
        exported_to: {},
        export_data: {},
        sent_to_ra_micro_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        sent_to_advolux_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        last_activity_at: {
            type: 'string',
            format: 'date-time'
        },
        last_activity_seen_at: {
            type: 'string',
            format: 'date-time'
        },
        clerk_id: {
            type: 'string',
            format: 'uuid',
            writeOnly: true,
            nullable: true
        },
        jupus_case_number: {
            type: 'string',
            nullable: true,
            minLength: 1,
            maxLength: 24
        },
        kleos_case_id: {
            type: 'string',
            nullable: true,
            minLength: 1,
            maxLength: 48
        }
    }
} as const;

export const $PatchedCustomerAdminDocumentTemplateRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        name: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        },
        description: {
            type: 'string',
            minLength: 1
        },
        system_prompt: {
            type: 'string',
            minLength: 1
        },
        document_template: {
            type: 'string'
        },
        law_field: {
            title: 'Rechtsgebiet',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawFieldEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        law_topic: {
            title: 'Rechtsthema',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawTopicEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        is_jupus_template: {
            type: 'boolean'
        }
    }
} as const;

export const $PatchedCustomerAdminEmailTemplateRequest = {
    type: 'object',
    properties: {
        type: {
            '$ref': '#/components/schemas/EmailTemplateType'
        },
        name: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        },
        subject: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        },
        html: {
            type: 'string',
            minLength: 1
        },
        default: {
            type: 'boolean'
        },
        law_field: {
            title: 'Rechtsgebiet',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawFieldEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        law_topic: {
            title: 'Rechtsthema',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawTopicEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        questionnaire_uuids: {
            type: 'array',
            items: {
                type: 'string',
                format: 'uuid'
            },
            writeOnly: true
        },
        form_uuids: {
            type: 'array',
            items: {
                type: 'string',
                format: 'uuid'
            },
            writeOnly: true
        }
    }
} as const;

export const $PatchedCustomerAdminEntityRequest = {
    type: 'object',
    description: 'Entity representation for customer admins.',
    properties: {
        entity_type: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EntityTypeEnum'
                }
            ],
            title: 'Personentyp'
        },
        title: {
            title: 'Anrede',
            oneOf: [
                {
                    '$ref': '#/components/schemas/TitleEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        first_name: {
            type: 'string',
            title: 'Vorname',
            maxLength: 128
        },
        last_name: {
            type: 'string',
            title: 'Nachname',
            maxLength: 128
        },
        email: {
            type: 'string',
            format: 'email',
            title: 'E-Mail',
            maxLength: 128
        },
        phone: {
            type: 'string',
            title: 'Telefon',
            maxLength: 128
        },
        street: {
            type: 'string',
            title: 'Straße',
            maxLength: 128
        },
        street_number: {
            type: 'string',
            title: 'Hausnummer',
            maxLength: 16
        },
        address_line_2: {
            type: 'string',
            title: 'Adresszusatz',
            maxLength: 128
        },
        zip: {
            type: 'string',
            title: 'PLZ',
            maxLength: 12
        },
        city: {
            type: 'string',
            title: 'Ort',
            maxLength: 100
        },
        date_of_birth: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Geburtsdatum'
        },
        legal_insurance: {
            type: 'boolean',
            nullable: true,
            title: 'Rechtsschutzversicherung'
        },
        legal_insurance_number: {
            type: 'string',
            title: 'Nummer der Rechtsschutzversicherung',
            maxLength: 128
        },
        legal_insurance_name: {
            type: 'string',
            title: 'Name der Rechtsschutzversicherung',
            maxLength: 128
        },
        legal_insurance_deductible_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Höhe der Selbstbeteiligung der Rechtsschutzversicherung'
        },
        company_name: {
            type: 'string',
            title: 'Firmenname',
            maxLength: 128
        },
        company_legal_form: {
            title: 'Rechtsform',
            oneOf: [
                {
                    '$ref': '#/components/schemas/CompanyLegalFormEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        company_register_number: {
            type: 'string',
            title: 'Handelsregisternummer',
            maxLength: 128
        },
        company_register_court: {
            type: 'string',
            title: 'Amtsgericht',
            maxLength: 128
        },
        company_vat_id: {
            type: 'string',
            title: 'USt. ID',
            maxLength: 128
        },
        company_tax_id: {
            type: 'string',
            title: 'Steuernummer',
            maxLength: 128
        },
        bank_name: {
            type: 'string',
            title: 'Bankname',
            maxLength: 128
        },
        iban: {
            type: 'string',
            maxLength: 34
        },
        bic: {
            type: 'string',
            maxLength: 11
        },
        institution_name: {
            type: 'string',
            title: 'Name der Institution',
            maxLength: 128
        }
    }
} as const;

export const $PatchedCustomerAdminFormRequest = {
    type: 'object',
    description: 'Form representation for customer admins.',
    properties: {
        title: {
            type: 'string',
            maxLength: 255
        },
        description: {
            type: 'string'
        }
    }
} as const;

export const $PatchedCustomerAdminOrganisationRequest = {
    type: 'object',
    description: 'Organisation representation for customer admins.',
    properties: {
        name: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'Name der Kanzlei',
            maxLength: 128
        },
        logo: {
            type: 'string',
            format: 'binary',
            nullable: true
        },
        description: {
            type: 'string',
            title: 'Beschreibung',
            maxLength: 400
        },
        short_id: {
            type: 'string',
            minLength: 1,
            maxLength: 8
        },
        street: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'Straße',
            maxLength: 96
        },
        street_number: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'Haus',
            maxLength: 12
        },
        zip: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'PLZ',
            maxLength: 5
        },
        city: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'Stadt',
            maxLength: 64
        },
        country: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'Land',
            maxLength: 96
        },
        latitude: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'Breitengrad'
        },
        longitude: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'Längengrad'
        },
        phone: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'Telefonnummer',
            maxLength: 24
        },
        email: {
            type: 'string',
            format: 'email',
            nullable: true,
            minLength: 1,
            maxLength: 96
        },
        enable_inbound_email_replies: {
            type: 'boolean',
            title: 'Aktiv'
        },
        email_text_color: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EmailTextColorEnum'
                }
            ],
            title: 'Textfarbe'
        },
        email_text_font: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EmailTextFontEnum'
                }
            ],
            title: 'Schriftart'
        },
        email_text_size: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EmailTextSizeEnum'
                }
            ],
            title: 'Schriftgröße',
            minimum: -2147483648,
            maximum: 2147483647
        },
        email_signature: {
            type: 'string',
            title: 'E-Mail Signatur'
        },
        email_blocked_senders: {
            title: 'Blockierte Absender'
        },
        email_spam_filter_active: {
            type: 'boolean',
            title: 'Spamfilter aktiv'
        },
        track_email_delivery_events: {
            type: 'boolean',
            title: 'E-Mail Zustell-Events tracken'
        },
        track_opened_click_email_delivery_events: {
            type: 'boolean',
            title: 'E-Mail Öffnungs- und Klick-Events tracken'
        },
        receive_questionnaire_closed_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn ein Fragebogen abgeschlossen wird'
        },
        receive_document_signed_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn ein Dokument abgeschlossen wird'
        },
        receive_new_case_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn eine neue Anfrage erstellt wird'
        },
        receive_new_case_email_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn eine neue E-Mail zu einer Anfrage eingeht'
        },
        receive_new_appointment_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn ein neuer Terminvorschlag erstellt wird'
        },
        send_document_email_reminders: {
            type: 'boolean',
            title: 'Automatisierte E-Mail Erinnerungen aktiv'
        },
        send_document_email_reminders_every_x_days: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            title: 'E-Mail Erinnerungen alle x Tage senden'
        },
        max_reminders: {
            type: 'integer',
            maximum: 2147483647,
            minimum: 1,
            title: 'Maximale Anzahl Erinnerungen pro Dokument',
            description: 'Maximum number of reminders that can be sent per document or questionnaire'
        },
        send_email_client_confirmation_on_new_case: {
            type: 'boolean',
            title: 'E-Mail Bestätigung bei neuer Anfrage senden'
        },
        send_email_client_confirmation_on_new_case_via_email: {
            type: 'boolean',
            title: 'E-Mail Bestätigung bei neuer Anfrage per E-Mail senden'
        },
        receive_clerk_change_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn ein Sachbearbeiter zugewiesen wird'
        },
        receive_email_bounce_notifications: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn eine E-Mail nicht zugestellt werden konnte'
        },
        is_ra_micro_export_integration_enabled: {
            type: 'boolean'
        },
        ra_micro_export_integration_type: {
            nullable: true,
            title: 'Integration Type',
            oneOf: [
                {
                    '$ref': '#/components/schemas/RaMicroExportIntegrationTypeEnum'
                },
                {
                    '$ref': '#/components/schemas/NullEnum'
                }
            ]
        },
        ra_micro_oma_email_id: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'OMA Email ID',
            maxLength: 64
        },
        ra_micro_oma_email: {
            type: 'string',
            format: 'email',
            nullable: true,
            minLength: 1,
            title: 'OMA Email',
            maxLength: 96
        },
        webhook_urls: {
            type: 'string',
            nullable: true,
            maxLength: 256
        },
        email_egress_address: {
            type: 'string',
            format: 'email',
            nullable: true,
            minLength: 1,
            title: 'Email',
            maxLength: 96
        },
        is_datev_export_integration_enabled: {
            type: 'boolean'
        },
        has_churned: {
            type: 'boolean',
            title: 'Hat gekündigt'
        }
    }
} as const;

export const $PatchedCustomerAdminPhoneNumberRequest = {
    type: 'object',
    description: 'PhoneNumber representation for customer admins.',
    properties: {
        active: {
            type: 'boolean'
        },
        phone_number: {
            type: 'string',
            nullable: true,
            minLength: 1,
            maxLength: 32
        },
        law_fields: {
            title: 'Rechtsgebiete'
        },
        description: {
            type: 'string',
            title: 'Bezeichnung',
            description: 'Hier können Sie eine interne Bezeichnung für die Rufnummer hinterlegen.',
            maxLength: 255
        },
        lawfirm_name: {
            type: 'string',
            title: 'Kanzleiname',
            description: 'Geben Sie hier den Namen Ihrer Kanzlei ein, wie er in der Begrüßungsansage genannt werden soll.',
            maxLength: 255
        },
        address: {
            type: 'string',
            title: 'Adresse',
            description: 'Hier können Sie die Adresse Ihrer Kanzlei hinterlegen. Bei Nachfrage geben wir diese an den Anrufer weiter. Wenn Sie keine unangekündigten Mandantenbesuch wünschen, dann geben Sie hier bitte einen entsprechenden Hinweis.',
            maxLength: 1024
        },
        opening_hours: {
            type: 'string',
            title: 'Öffnungszeiten',
            description: 'Hier können Sie Ihre Öffnungszeiten Ihrer Kanzlei hinterlegen. Bei Nachfrage geben wir diese an den Anrufer weiter.',
            maxLength: 1024
        },
        lawyer_names: {
            type: 'string',
            title: 'Anwälte/Sachbearbeiter',
            description: 'Hier können Sie die Namen Ihrer Anwälte oder Sachbearbeiter hinterlegen. Dies hilft uns dabei, den Namen des Anrufers besser zu erkennen. Bitte tragen Sie nur den Namen ein und keine weitere Bezeichnung wie zum Beispiel Anwalt oder Sachbearbeiter.',
            maxLength: 1024
        },
        has_free_initial_consultation: {
            type: 'boolean',
            title: 'Kostenlose Erstberatung',
            description: 'Bieten Sie eine kostenlose Erstberatung an? Wenn ja, dann aktivieren Sie diese Option und wir geben dies an den Anrufer weiter.'
        },
        original_phone_number: {
            type: 'string',
            title: 'Telefonnummer',
            description: 'Wenn Sie die von uns generierte Nummer intern weiterleiten, geben Sie hier unbedingt die Originalnummer an, welche von den Mandanten angerufen wird. So stellen Sie sicher, dass wir die Anrufe korrekt zuordnen können.',
            maxLength: 255
        },
        can_record_calls: {
            type: 'boolean',
            title: 'Anrufe aufzeichnen',
            description: 'Durch das Aktivieren dieser Option Stellen wir Ihnen auf der Detailseite eines Anrufs einen Mitschnitt des Namen bzw. der E-Mail-Addresse zur Verfügung. Die Aufzeichnung von Anrufen ist in Deutschland nur mit Zustimmung des Anrufers gestattet. Wir weisen Sie darauf hin, dass Sie diese Zustimmung von dem Anrufer einholen müssen.'
        },
        is_in_answering_machine_mode: {
            type: 'boolean',
            title: 'Reiner Anrufbeantworter'
        },
        begin_message: {
            type: 'string',
            title: 'Begrüßung',
            description: 'Hier können Sie eine Begrüßung für den Anrufbeantworter hinterlegen. Diese wird am Anfang des Anrufes abgespielt.',
            maxLength: 1024
        },
        end_message: {
            type: 'string',
            title: 'Abschiedsnachricht',
            description: 'Hier können Sie eine Abschiedsnachricht für den Anrufbeantworter hinterlegen. Diese wird am Ende des Anrufes abgespielt.',
            maxLength: 1024
        }
    }
} as const;

export const $PatchedCustomerAdminQuestionnaireRequest = {
    type: 'object',
    description: 'Questionnaire representation for customer admins.',
    properties: {
        title: {
            type: 'string',
            minLength: 1,
            maxLength: 64
        },
        description: {
            type: 'string'
        },
        schema: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/QuestionnaireSectionRequest'
            }
        },
        law_field: {
            title: 'Rechtsgebiet',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawFieldEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        law_topic: {
            title: 'Rechtsthema',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawTopicEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        }
    }
} as const;

export const $PatchedCustomerAdminQuestionnaireSubmissionRequest = {
    type: 'object',
    description: 'Questionnaire submission representation for customer admins.',
    properties: {
        schema: {},
        closed: {
            type: 'boolean'
        }
    }
} as const;

export const $PatchedCustomerAdminServiceRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        org: {
            type: 'integer'
        },
        active: {
            type: 'boolean',
            title: 'Diese Leistung ist buchbar'
        },
        name: {
            type: 'string',
            minLength: 1,
            title: 'Titel',
            maxLength: 32
        },
        description: {
            type: 'string',
            minLength: 1,
            title: 'Beschreibung',
            maxLength: 400
        },
        duration_mins: {
            type: 'integer'
        },
        buffer_mins: {
            type: 'integer'
        },
        price: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,6}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Preis'
        },
        currency: {
            type: 'string',
            minLength: 1,
            title: 'Währung',
            maxLength: 8
        },
        unit: {
            type: 'string',
            minLength: 1,
            title: 'Einheit',
            maxLength: 32
        },
        show_price: {
            type: 'boolean',
            title: 'Preis anzeigen',
            description: 'Wenn aktiviert, wird der Preis der Leistung während der Buchung des Termins angezeigt.'
        },
        slug: {
            type: 'string',
            minLength: 1,
            maxLength: 64,
            pattern: '^[-a-zA-Z0-9_]+$'
        },
        online_appointment_enabled: {
            type: 'boolean',
            title: 'Online-Termin'
        },
        telephone_appointment_enabled: {
            type: 'boolean',
            title: 'Telefon-Termin'
        },
        in_person_appointment_enabled: {
            type: 'boolean',
            title: 'Termin vor Ort'
        }
    }
} as const;

export const $PatchedCustomerAdminUserRequest = {
    type: 'object',
    description: 'User representation for customer admins.',
    properties: {
        email: {
            type: 'string',
            format: 'email',
            minLength: 1,
            maxLength: 254
        },
        first_name: {
            type: 'string',
            title: 'Vorname',
            maxLength: 150
        },
        last_name: {
            type: 'string',
            title: 'Nachname',
            maxLength: 150
        },
        avatar: {
            type: 'string',
            format: 'binary',
            nullable: true
        },
        role: {
            nullable: true,
            oneOf: [
                {
                    '$ref': '#/components/schemas/Role5ccEnum'
                },
                {
                    '$ref': '#/components/schemas/NullEnum'
                }
            ]
        },
        email_signature: {
            type: 'string',
            title: 'E-Mail Signatur'
        },
        case_dashboard_widgets: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/CaseDashboardWidgetsEnum'
            }
        },
        global_ai_chat_intro_seen: {
            type: 'boolean',
            description: 'Whether the user has seen and accepted the global AI chat intro page'
        },
        global_ai_chat_badge_dismissed: {
            type: 'boolean',
            description: 'Whether the user has clicked on Global AI Chat navigation item (badge should be hidden)'
        }
    }
} as const;

export const $PatchedCustomerAdminWordDocumentTemplateRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        name: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        },
        description: {
            type: 'string',
            minLength: 1
        },
        system_prompt: {
            type: 'string',
            minLength: 1
        },
        docx_template: {
            type: 'string',
            format: 'binary',
            nullable: true,
            description: 'Active template used for document generation (can be original, AI-generated, or custom upload)'
        },
        law_field: {
            title: 'Rechtsgebiet',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawFieldEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        law_topic: {
            title: 'Rechtsthema',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawTopicEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        is_jupus_template: {
            type: 'boolean'
        },
        replaceable_variables: {
            nullable: true
        },
        status: {
            allOf: [
                {
                    '$ref': '#/components/schemas/WordTemplateStatus'
                }
            ],
            description: `Current status of the template in the review workflow

* \`draft\` - Draft
* \`in_review\` - In Review
* \`approved\` - Approved`
        }
    }
} as const;

export const $PatchedCustomerAiAnalysisRequest = {
    type: 'object',
    properties: {
        case_uuid: {
            type: 'string',
            format: 'uuid'
        },
        document_uuid: {
            type: 'string',
            format: 'uuid'
        }
    }
} as const;

export const $PatchedCustomerAiAugmentationRequest = {
    type: 'object',
    properties: {
        value: {
            oneOf: [
                {
                    type: 'string'
                },
                {
                    type: 'integer'
                },
                {
                    type: 'boolean'
                },
                {
                    type: 'string',
                    format: 'date'
                },
                {
                    type: 'object',
                    additionalProperties: {}
                },
                {
                    type: 'array',
                    items: {}
                }
            ]
        },
        referenced_document_pages: {
            type: 'array',
            items: {
                type: 'integer'
            }
        },
        explanation: {
            type: 'string',
            minLength: 1
        }
    }
} as const;

export const $PatchedCustomerAiSettingsRequest = {
    type: 'object',
    description: 'AI Settings representation for customers.',
    properties: {
        entity_extraction_instructions: {
            type: 'string',
            description: 'Instructions for AI agents when performing entity extraction'
        },
        auto_commit_settings: {
            type: 'string'
        },
        notification_settings: {
            type: 'string'
        },
        ai_workflows_enabled: {
            type: 'boolean',
            description: 'Enable or disable AI workflows for this organisation. When disabled, AI workflows will not be executed for cases in this organisation.'
        },
        send_notifications_bundled: {
            type: 'boolean',
            description: 'Whether to send notifications bundled or individually'
        },
        bundled_notifications_max_delay: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            description: 'Maximum delay in seconds before sending bundled notifications'
        },
        on_case_pre_case_context_gathering_instructions: {
            type: 'string',
            title: 'Pre Case Context Gathering Instructions',
            description: 'Instructions for AI agents during pre case context gathering'
        },
        on_case_post_case_context_gathering_instructions: {
            type: 'string',
            title: 'Post Case Context Gathering Instructions',
            description: 'Instructions for AI agents during post case context gathering'
        }
    }
} as const;

export const $PatchedCustomerAppointmentProposalRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        case_uuid: {
            type: 'string',
            writeOnly: true,
            minLength: 1
        },
        start: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        location_type: {
            '$ref': '#/components/schemas/LocationTypeEnum'
        },
        message: {
            type: 'string',
            nullable: true
        },
        service_uuid: {
            type: 'string',
            format: 'uuid',
            writeOnly: true
        },
        calendar_uuid: {
            type: 'string',
            format: 'uuid',
            writeOnly: true
        }
    }
} as const;

export const $PatchedCustomerAppointmentRequest = {
    type: 'object',
    description: 'Appointment representation for customers.',
    properties: {
        service: {
            '$ref': '#/components/schemas/CustomerServiceRequest'
        },
        calendar: {
            '$ref': '#/components/schemas/CustomerCalendarRequest'
        },
        start: {
            type: 'string',
            format: 'date-time'
        },
        location_types: {
            '$ref': '#/components/schemas/LocationTypesEnum'
        },
        case: {
            type: 'integer',
            writeOnly: true
        }
    }
} as const;

export const $PatchedCustomerCalendarRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        active: {
            type: 'boolean',
            title: 'Dieser Kalender ist buchbar'
        },
        name: {
            type: 'string',
            minLength: 1,
            maxLength: 32
        },
        description: {
            type: 'string',
            title: 'Titel',
            maxLength: 32
        },
        long_description: {
            type: 'string',
            title: 'Beschreibung',
            maxLength: 400
        },
        avatar: {
            type: 'string',
            format: 'binary',
            nullable: true,
            title: 'Profilbild'
        },
        services: {
            type: 'array',
            items: {
                type: 'integer'
            }
        },
        slug: {
            type: 'string',
            minLength: 1,
            maxLength: 64,
            pattern: '^[-a-zA-Z0-9_]+$'
        },
        deactivated: {
            type: 'boolean'
        },
        profile: {
            type: 'integer'
        },
        calendar_id: {
            type: 'string',
            minLength: 1,
            maxLength: 64
        },
        calendar_name: {
            type: 'string',
            minLength: 1,
            maxLength: 64
        },
        calendar_readonly: {
            type: 'boolean'
        },
        calendar_deleted: {
            type: 'boolean'
        },
        calendar_primary: {
            type: 'boolean'
        },
        calendar_integrated_conferencing_available: {
            type: 'boolean'
        },
        calendar_attachments_available: {
            type: 'boolean'
        },
        permission_level: {
            type: 'string',
            minLength: 1,
            maxLength: 32
        }
    }
} as const;

export const $PatchedCustomerCallRequest = {
    type: 'object',
    description: 'Call representation for customers.',
    properties: {
        result: {
            '$ref': '#/components/schemas/CustomerCallResultRequest'
        },
        note: {
            type: 'string',
            nullable: true,
            title: 'Interne Notizen',
            maxLength: 1024
        },
        clerk_id: {
            type: 'string',
            format: 'uuid',
            writeOnly: true,
            nullable: true
        },
        forward: {
            allOf: [
                {
                    '$ref': '#/components/schemas/ForwardRequest'
                }
            ],
            nullable: true
        }
    }
} as const;

export const $PatchedCustomerCaseLifecycleStateRequest = {
    type: 'object',
    description: 'Case Lifecycle State representation for customers.',
    properties: {
        workflow_uuid: {
            type: 'string',
            format: 'uuid',
            writeOnly: true,
            nullable: true,
            description: 'UUID of the workflow to assign to the case. Set to null to remove workflow assignment.'
        },
        is_agent_active: {
            type: 'boolean'
        }
    }
} as const;

export const $PatchedCustomerCaseLifecycleWorkflowRequest = {
    type: 'object',
    description: 'Case Lifecycle Workflow representation for customers.',
    properties: {
        name: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        },
        law_field: {
            title: 'Rechtsgebiet',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawFieldEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        law_topic: {
            title: 'Rechtsthema',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawTopicEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        on_case_ready_for_onboarding_step_1_instructions: {
            type: 'string',
            title: 'Case Ready for Onboarding Step 1 Instructions',
            description: 'Instructions for AI agents when handling a new case - Step 1'
        },
        on_case_ready_for_onboarding_step_1_auto_commit_settings: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/CustomerActionAutoCommitSettingsRequest'
            }
        },
        on_case_ready_for_onboarding_step_2_instructions: {
            type: 'string',
            title: 'Case Ready for Onboarding Step 2 Instructions',
            description: 'Instructions for AI agents when handling a new case - Step 2'
        },
        on_case_ready_for_onboarding_step_2_auto_commit_settings: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/CustomerActionAutoCommitSettingsRequest'
            }
        },
        on_all_data_collected_instructions: {
            type: 'string',
            title: 'All Data Collected Instructions',
            description: 'Instructions for AI agents when all data for a case has been collected'
        },
        on_all_data_collected_auto_commit_settings: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/CustomerActionAutoCommitSettingsRequest'
            }
        },
        on_all_documents_drafted_auto_commit_settings: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/CustomerActionAutoCommitSettingsRequest'
            }
        }
    }
} as const;

export const $PatchedCustomerCaseRequest = {
    type: 'object',
    description: 'Case representation for customers.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        created_at: {
            type: 'string',
            format: 'date-time'
        },
        note: {
            type: 'string',
            nullable: true,
            title: 'Interne Notizen',
            maxLength: 1024
        },
        type: {
            '$ref': '#/components/schemas/CaseType'
        },
        state: {
            allOf: [
                {
                    '$ref': '#/components/schemas/StateEnum'
                }
            ],
            title: 'Status'
        },
        inquiry: {
            type: 'string',
            title: 'Inhalt der Anfrage'
        },
        data: {
            '$ref': '#/components/schemas/CustomerCaseDataRequest'
        },
        client_document_email_reminder_sent_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        client_document_email_reminder_opt_out: {
            type: 'boolean'
        },
        send_outstanding_document_email_reminder: {
            type: 'boolean',
            title: 'Automatisierte E-Mail Erinnerungen für angeforderte Dokumente aktiv'
        },
        sent_to_actaport_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        actaport_case_id: {
            type: 'string',
            nullable: true,
            minLength: 1,
            maxLength: 48
        },
        sent_to_advoware_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        advoware_case_id: {
            type: 'string',
            nullable: true,
            minLength: 1,
            maxLength: 48
        },
        sent_to_iusta_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        iusta_data: {},
        is_selected_for_export_to: {},
        exported_to: {},
        export_data: {},
        sent_to_ra_micro_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        sent_to_advolux_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        last_activity_at: {
            type: 'string',
            format: 'date-time'
        },
        last_activity_seen_at: {
            type: 'string',
            format: 'date-time'
        },
        clerk_id: {
            type: 'string',
            format: 'uuid',
            writeOnly: true,
            nullable: true
        },
        jupus_case_number: {
            type: 'string',
            nullable: true,
            minLength: 1,
            maxLength: 24
        },
        kleos_case_id: {
            type: 'string',
            nullable: true,
            minLength: 1,
            maxLength: 48
        }
    }
} as const;

export const $PatchedCustomerDocumentTemplateRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        name: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        },
        description: {
            type: 'string',
            minLength: 1
        },
        system_prompt: {
            type: 'string',
            minLength: 1
        },
        document_template: {
            type: 'string'
        },
        law_field: {
            title: 'Rechtsgebiet',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawFieldEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        law_topic: {
            title: 'Rechtsthema',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawTopicEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        is_jupus_template: {
            type: 'boolean'
        }
    }
} as const;

export const $PatchedCustomerEmailTemplateRequest = {
    type: 'object',
    properties: {
        type: {
            '$ref': '#/components/schemas/EmailTemplateType'
        },
        name: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        },
        subject: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        },
        html: {
            type: 'string',
            minLength: 1
        },
        default: {
            type: 'boolean'
        },
        law_field: {
            title: 'Rechtsgebiet',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawFieldEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        law_topic: {
            title: 'Rechtsthema',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawTopicEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        questionnaire_uuids: {
            type: 'array',
            items: {
                type: 'string',
                format: 'uuid'
            },
            writeOnly: true
        },
        form_uuids: {
            type: 'array',
            items: {
                type: 'string',
                format: 'uuid'
            },
            writeOnly: true
        }
    }
} as const;

export const $PatchedCustomerEntityRequest = {
    type: 'object',
    description: 'Entity representation for customers.',
    properties: {
        entity_type: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EntityTypeEnum'
                }
            ],
            title: 'Personentyp'
        },
        title: {
            title: 'Anrede',
            oneOf: [
                {
                    '$ref': '#/components/schemas/TitleEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        first_name: {
            type: 'string',
            title: 'Vorname',
            maxLength: 128
        },
        last_name: {
            type: 'string',
            title: 'Nachname',
            maxLength: 128
        },
        email: {
            type: 'string',
            format: 'email',
            title: 'E-Mail',
            maxLength: 128
        },
        phone: {
            type: 'string',
            title: 'Telefon',
            maxLength: 128
        },
        street: {
            type: 'string',
            title: 'Straße',
            maxLength: 128
        },
        street_number: {
            type: 'string',
            title: 'Hausnummer',
            maxLength: 16
        },
        address_line_2: {
            type: 'string',
            title: 'Adresszusatz',
            maxLength: 128
        },
        zip: {
            type: 'string',
            title: 'PLZ',
            maxLength: 12
        },
        city: {
            type: 'string',
            title: 'Ort',
            maxLength: 100
        },
        date_of_birth: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Geburtsdatum'
        },
        legal_insurance: {
            type: 'boolean',
            nullable: true,
            title: 'Rechtsschutzversicherung'
        },
        legal_insurance_number: {
            type: 'string',
            title: 'Nummer der Rechtsschutzversicherung',
            maxLength: 128
        },
        legal_insurance_name: {
            type: 'string',
            title: 'Name der Rechtsschutzversicherung',
            maxLength: 128
        },
        legal_insurance_deductible_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Höhe der Selbstbeteiligung der Rechtsschutzversicherung'
        },
        company_name: {
            type: 'string',
            title: 'Firmenname',
            maxLength: 128
        },
        company_legal_form: {
            title: 'Rechtsform',
            oneOf: [
                {
                    '$ref': '#/components/schemas/CompanyLegalFormEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        company_register_number: {
            type: 'string',
            title: 'Handelsregisternummer',
            maxLength: 128
        },
        company_register_court: {
            type: 'string',
            title: 'Amtsgericht',
            maxLength: 128
        },
        company_vat_id: {
            type: 'string',
            title: 'USt. ID',
            maxLength: 128
        },
        company_tax_id: {
            type: 'string',
            title: 'Steuernummer',
            maxLength: 128
        },
        bank_name: {
            type: 'string',
            title: 'Bankname',
            maxLength: 128
        },
        iban: {
            type: 'string',
            maxLength: 34
        },
        bic: {
            type: 'string',
            maxLength: 11
        },
        institution_name: {
            type: 'string',
            title: 'Name der Institution',
            maxLength: 128
        }
    }
} as const;

export const $PatchedCustomerFormRequest = {
    type: 'object',
    description: 'Form representation for customers.',
    properties: {
        title: {
            type: 'string',
            maxLength: 255
        },
        description: {
            type: 'string'
        }
    }
} as const;

export const $PatchedCustomerLawyerFeedbackRequest = {
    type: 'object',
    properties: {
        rating: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,1}(?:\\.\\d{0,1})?$'
        },
        feedback: {
            type: 'string',
            maxLength: 1024
        },
        call_uuid: {
            type: 'string',
            format: 'uuid',
            writeOnly: true
        }
    }
} as const;

export const $PatchedCustomerOrganisationRequest = {
    type: 'object',
    description: 'Organisation representation for customers.',
    properties: {
        name: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'Name der Kanzlei',
            maxLength: 128
        },
        logo: {
            type: 'string',
            format: 'binary',
            nullable: true
        },
        description: {
            type: 'string',
            title: 'Beschreibung',
            maxLength: 400
        },
        short_id: {
            type: 'string',
            minLength: 1,
            maxLength: 8
        },
        street: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'Straße',
            maxLength: 96
        },
        street_number: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'Haus',
            maxLength: 12
        },
        zip: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'PLZ',
            maxLength: 5
        },
        city: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'Stadt',
            maxLength: 64
        },
        country: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'Land',
            maxLength: 96
        },
        phone: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'Telefonnummer',
            maxLength: 24
        },
        email: {
            type: 'string',
            format: 'email',
            nullable: true,
            minLength: 1,
            maxLength: 96
        },
        enable_inbound_email_replies: {
            type: 'boolean',
            title: 'Aktiv'
        },
        email_text_color: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EmailTextColorEnum'
                }
            ],
            title: 'Textfarbe'
        },
        email_text_font: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EmailTextFontEnum'
                }
            ],
            title: 'Schriftart'
        },
        email_text_size: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EmailTextSizeEnum'
                }
            ],
            title: 'Schriftgröße',
            minimum: -2147483648,
            maximum: 2147483647
        },
        email_signature: {
            type: 'string',
            title: 'E-Mail Signatur'
        },
        email_blocked_senders: {
            title: 'Blockierte Absender'
        },
        email_spam_filter_active: {
            type: 'boolean',
            title: 'Spamfilter aktiv'
        },
        track_email_delivery_events: {
            type: 'boolean',
            title: 'E-Mail Zustell-Events tracken'
        },
        track_opened_click_email_delivery_events: {
            type: 'boolean',
            title: 'E-Mail Öffnungs- und Klick-Events tracken'
        },
        receive_questionnaire_closed_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn ein Fragebogen abgeschlossen wird'
        },
        receive_document_signed_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn ein Dokument abgeschlossen wird'
        },
        receive_new_case_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn eine neue Anfrage erstellt wird'
        },
        receive_new_case_email_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn eine neue E-Mail zu einer Anfrage eingeht'
        },
        receive_new_appointment_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn ein neuer Terminvorschlag erstellt wird'
        },
        send_document_email_reminders: {
            type: 'boolean',
            title: 'Automatisierte E-Mail Erinnerungen aktiv'
        },
        send_document_email_reminders_every_x_days: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            title: 'E-Mail Erinnerungen alle x Tage senden'
        },
        max_reminders: {
            type: 'integer',
            maximum: 2147483647,
            minimum: 1,
            title: 'Maximale Anzahl Erinnerungen pro Dokument',
            description: 'Maximum number of reminders that can be sent per document or questionnaire'
        },
        send_email_client_confirmation_on_new_case: {
            type: 'boolean',
            title: 'E-Mail Bestätigung bei neuer Anfrage senden'
        },
        send_email_client_confirmation_on_new_case_via_email: {
            type: 'boolean',
            title: 'E-Mail Bestätigung bei neuer Anfrage per E-Mail senden'
        },
        receive_clerk_change_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn ein Sachbearbeiter zugewiesen wird'
        },
        receive_email_bounce_notifications: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn eine E-Mail nicht zugestellt werden konnte'
        },
        is_ra_micro_export_integration_enabled: {
            type: 'boolean'
        },
        webhook_urls: {
            type: 'string',
            nullable: true,
            maxLength: 256
        },
        email_egress_address: {
            type: 'string',
            format: 'email',
            nullable: true,
            minLength: 1,
            title: 'Email',
            maxLength: 96
        },
        enable_cases: {
            type: 'boolean',
            title: 'Anfragen aktivieren (normale JUPUS Plattform)'
        },
        is_datev_export_integration_enabled: {
            type: 'boolean'
        },
        receive_monthly_updates_summary: {
            type: 'boolean',
            title: 'Monatliche Zusammenfassung per E-Mail erhalten'
        }
    }
} as const;

export const $PatchedCustomerQuestionnaireRequest = {
    type: 'object',
    description: 'Questionnaire representation for customers.',
    properties: {
        title: {
            type: 'string',
            minLength: 1,
            maxLength: 64
        },
        description: {
            type: 'string'
        },
        schema: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/QuestionnaireSectionRequest'
            }
        },
        law_field: {
            title: 'Rechtsgebiet',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawFieldEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        law_topic: {
            title: 'Rechtsthema',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawTopicEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        }
    }
} as const;

export const $PatchedCustomerQuestionnaireSubmissionRequest = {
    type: 'object',
    description: 'Questionnaire submission representation for customers.',
    properties: {
        schema: {},
        closed: {
            type: 'boolean'
        }
    }
} as const;

export const $PatchedCustomerServiceRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        org: {
            type: 'integer'
        },
        active: {
            type: 'boolean',
            title: 'Diese Leistung ist buchbar'
        },
        name: {
            type: 'string',
            minLength: 1,
            title: 'Titel',
            maxLength: 32
        },
        description: {
            type: 'string',
            minLength: 1,
            title: 'Beschreibung',
            maxLength: 400
        },
        duration_mins: {
            type: 'integer'
        },
        buffer_mins: {
            type: 'integer'
        },
        price: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,6}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Preis'
        },
        currency: {
            type: 'string',
            minLength: 1,
            title: 'Währung',
            maxLength: 8
        },
        unit: {
            type: 'string',
            minLength: 1,
            title: 'Einheit',
            maxLength: 32
        },
        show_price: {
            type: 'boolean',
            title: 'Preis anzeigen',
            description: 'Wenn aktiviert, wird der Preis der Leistung während der Buchung des Termins angezeigt.'
        },
        slug: {
            type: 'string',
            minLength: 1,
            maxLength: 64,
            pattern: '^[-a-zA-Z0-9_]+$'
        }
    }
} as const;

export const $PatchedCustomerUserRequest = {
    type: 'object',
    description: 'User representation for customers.',
    properties: {
        email: {
            type: 'string',
            format: 'email',
            minLength: 1,
            maxLength: 254
        },
        first_name: {
            type: 'string',
            title: 'Vorname',
            maxLength: 150
        },
        last_name: {
            type: 'string',
            title: 'Nachname',
            maxLength: 150
        },
        avatar: {
            type: 'string',
            format: 'binary',
            nullable: true
        },
        email_signature: {
            type: 'string',
            title: 'E-Mail Signatur'
        },
        case_dashboard_widgets: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/CaseDashboardWidgetsEnum'
            }
        },
        global_ai_chat_intro_seen: {
            type: 'boolean',
            description: 'Whether the user has seen and accepted the global AI chat intro page'
        },
        global_ai_chat_badge_dismissed: {
            type: 'boolean',
            description: 'Whether the user has clicked on Global AI Chat navigation item (badge should be hidden)'
        }
    }
} as const;

export const $PatchedCustomerWordDocumentTemplateRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        name: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        },
        description: {
            type: 'string',
            minLength: 1
        },
        system_prompt: {
            type: 'string',
            minLength: 1
        },
        docx_template: {
            type: 'string',
            format: 'binary',
            nullable: true,
            description: 'Active template used for document generation (can be original, AI-generated, or custom upload)'
        },
        law_field: {
            title: 'Rechtsgebiet',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawFieldEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        law_topic: {
            title: 'Rechtsthema',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawTopicEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        is_jupus_template: {
            type: 'boolean'
        },
        replaceable_variables: {
            nullable: true
        },
        status: {
            allOf: [
                {
                    '$ref': '#/components/schemas/WordTemplateStatus'
                }
            ],
            description: `Current status of the template in the review workflow

* \`draft\` - Draft
* \`in_review\` - In Review
* \`approved\` - Approved`
        }
    }
} as const;

export const $PatchedDeliveryEventRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        }
    }
} as const;

export const $PatchedDocumentPlaceholderUpdateRequest = {
    type: 'object',
    properties: {
        german_label: {
            type: 'string',
            nullable: true,
            maxLength: 255
        },
        english_label: {
            type: 'string',
            nullable: true,
            maxLength: 255
        }
    }
} as const;

export const $PatchedEmailRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        }
    }
} as const;

export const $PatchedFeedbackRequest = {
    type: 'object',
    properties: {
        url: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        },
        rating: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,1}(?:\\.\\d{0,1})?$'
        },
        feature: {
            '$ref': '#/components/schemas/FeatureEnum'
        },
        comment: {
            type: 'string'
        },
        related_data: {
            '$ref': '#/components/schemas/FeedbackRelatedData'
        }
    }
} as const;

export const $PatchedGenericMetricEventRequest = {
    type: 'object',
    description: 'Serializer for generic metric events from frontend.',
    properties: {
        event_name: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EventNameEnum'
                }
            ],
            description: `Name of the event to track

* \`Logout\` - Logout
* \`Login\` - Login
* \`Bot Display\` - Bot Display
* \`Bot Session Started\` - Bot Session Started
* \`Bot Session Ended\` - Bot Session Ended
* \`Questionnaire Sent\` - Questionnaire Sent
* \`Questionnaire Completed\` - Questionnaire Completed
* \`PDFDocument Sent\` - Form Sent
* \`PDFDocument Completed\` - Form Completed
* \`Email Sent\` - Email Sent
* \`Email Received\` - Email Received
* \`Email Template Edited\` - Email Template Edited
* \`Case Created\` - Case Created
* \`Case Rejected\` - Case Rejected
* \`Case Accepted\` - Case Completed
* \`Case In Progress\` - Case In Progress
* \`Case Deleted\` - Case Deleted
* \`Case Exported\` - Case Exported
* \`Calculator Opened\` - Calculator Opened
* \`Calculator Saved\` - Calculator Saved
* \`Appointment Account Authorized\` - Appointment Account Authorized
* \`Appointment Account Revoked\` - Appointment Account Revoked
* \`Appointment Service Created\` - Appointment Service Created
* \`Appointment Service Edited\` - Appointment Service Edited
* \`Appointment Service Enabled\` - Appointment Service Enabled
* \`Appointment Service Disabled\` - Appointment Service Disabled
* \`Appointment Service Soft Deleted\` - Appointment Service Soft Deleted
* \`Appointment Service Recovered\` - Appointment Service Recovered
* \`Appointment Calendar Created\` - Appointment Calendar Created
* \`Appointment Calendar Edited\` - Appointment Calendar Edited
* \`Appointment Calendar Enabled\` - Appointment Calendar Enabled
* \`Appointment Calendar Disabled\` - Appointment Calendar Disabled
* \`Appointment Lawfields Edited\` - Appointment Lawfields Edited
* \`Appointment Setup Completed\` - Appointment Setup Completed
* \`Appointment Created\` - Appointment Created
* \`Appointment Proposal Created\` - Appointment Proposal Created
* \`Appointment Settings Edited\` - Appointment Settings Edited
* \`Call Started\` - Call Started
* \`Call Ended\` - Call Ended
* \`Call Automated Rating Received\` - Call Automated Rating
* \`Call Human Rating Received\` - Call Human Rating
* \`Call Lawer Rating Received\` - Call Lawer Rating
* \`Phone Forwarding Rule Created\` - Phone Forwarding Rule Created
* \`Phone Forwarding Rule Updated\` - Phone Forwarding Rule Updated
* \`Entity Extraction Instructions Set\` - Entity Extraction Instructions Set
* \`AI Token Used\` - Ai Token Used
* \`AI Embedding Token Used\` - Ai Embedding Token Used
* \`AI Function Voice Call Used\` - Ai Function Voice Call Used
* \`AI Function Document Analysis Used\` - Ai Function Document Analysis Used
* \`AI Function Document Title Generation Used\` - Ai Function Document Title Generation Used
* \`AI Function Questionnaire Title Generation Used\` - Ai Function Questionnaire Title Generation Used
* \`AI Function Email Extraction Used\` - Ai Function Email Extraction Used
* \`AI Function Gender Detection Used\` - Ai Function Gender Detection Used
* \`AI Function Document Type Classification Used\` - Ai Function Document Type Classification Used
* \`AI Function Document Analysis Entity Classification Used\` - Ai Function Document Analysis Entity Classification Used
* \`AI Function Document Generation Used\` - Ai Function Document Generation Used
* \`AI Function Inquiry Summary Used\` - Ai Function Inquiry Summary Used
* \`AI Function Used Case Chat\` - Ai Function Used Case Chat
* \`AI Function Used Update Case Chat Document Context\` - Ai Function Used Update Case Chat Document Context
* \`AI Function Used Update Case Chat Document Context Alternative Queries\` - Ai Function Used Update Case Chat Document Context Alternative Queries
* \`AI Function Used Update Case Chat Document Context Alternative Queries Create Embeddings\` - Ai Function Used Update Case Chat Document Context Alternative Queries Create Embeddings
* \`AI Function Case Create Document Entities Extraction Used\` - Ai Function Case Create Document Entities Extraction Used
* \`AI Function Universal Entity Extraction Used\` - Ai Function Universal Entity Extraction Used
* \`AI Function Document Template Generation Used\` - Ai Function Document Template Generation Used
* \`User Feedback\` - User Feedback
* \`Help Link Clicked\` - Help Link Clicked
* \`AI Function Document Summarization Used\` - Ai Function Document Summarization Used
* \`AI Function Document Raptor Summarization Used\` - Ai Function Document Raptor Summarization Used
* \`AI Function Used Rate AI Chat Session\` - Ai Function Used Rate Ai Chat Session
* \`AI Chat Session Rating\` - Ai Chat Session Rating
* \`AI Chat Session Human Rating\` - Ai Chat Session Human Rating
* \`Global AI Chat Folder Created\` - Global Ai Chat Folder Created
* \`Global AI Chat Folder Updated\` - Global Ai Chat Folder Updated
* \`Global AI Chat Folder Deleted\` - Global Ai Chat Folder Deleted
* \`Global AI Chat Session Created\` - Global Ai Chat Session Created
* \`Global AI Chat Session Deleted\` - Global Ai Chat Session Deleted
* \`Global AI Chat Visited\` - Global Ai Chat Visited
* \`AI Function Used Global Chat\` - Ai Function Used Global Chat
* \`Global Chat Case Specific Info Requested\` - Global Chat Case Specific Info Requested
* \`AI Function Template Description Generation Used\` - Ai Function Template Description Generation Used
* \`AI Function Memory Title Generation Used\` - Ai Function Memory Title Generation Used
* \`AI Function Used Chat Memory Embedding\` - Ai Function Used Chat Memory Embedding
* \`AI Function Used Chat Memory Importance Evaluation\` - Ai Function Used Chat Memory Importance
* \`AI Function Used Rate Memory Evaluation\` - Ai Function Used Rate Memory Evaluation
* \`AI Function Used Prompt Enhancement\` - Ai Function Used Prompt Enhancement
* \`AI Function Used Preference Suggestion Analysis\` - Ai Function Used Preference Suggestion Analysis
* \`AI Function Used Feedback Preference Suggestion\` - Ai Function Used Feedback Preference Suggestion
* \`AI Function Used Chat Preference Embedding\` - Ai Function Used Chat Preference Embedding
* \`AI Function Used Chat Preference Importance Evaluation\` - Ai Function Used Chat Preference Importance
* \`Snippet Button Clicked in Document Generator\` - Snippet Button Clicked In Document Generator
* \`Snippet Selected in Document Generator\` - Snippet Selected In Document Generator
* \`Document Metadata Enrichment Started\` - Document Metadata Enrichment Started
* \`Document Metadata Enrichment Finished\` - Document Metadata Enrichment Finished
* \`Document Metadata Enrichment Retry\` - Document Metadata Enrichment Retry
* \`Document OCR Started\` - Document Ocr Started
* \`Document OCR Finished\` - Document Ocr Finished
* \`Document Embeddings Started\` - Document Embeddings Started
* \`Document Embeddings Finished\` - Document Embeddings Finished
* \`Document Summary Started\` - Document Summary Started
* \`Document Summary Finished\` - Document Summary Finished
* \`Document Analysis Started\` - Document Analysis Started
* \`Document Analysis Finished\` - Document Analysis Finished
* \`Document Entity Extraction Started\` - Document Entity Extraction Started
* \`Document Entity Extraction Finished\` - Document Entity Extraction Finished
* \`Document Raptor Summaries Started\` - Document Raptor Summaries Started
* \`Document Raptor Summaries Finished\` - Document Raptor Summaries Finished
* \`Document Inline Edit Started\` - Document Inline Edit Started
* \`Document Rename AI Clicked\` - Document Rename Ai Clicked
* \`Document Rename AI Completed\` - Document Rename Ai Completed
* \`Document Rename AI Failed\` - Document Rename Ai Failed
* \`Document Rename Saved\` - Document Rename Saved
* \`Document Rename Cancelled\` - Document Rename Cancelled
* \`Document Preview Opened\` - Document Preview Opened
* \`Document Preview Closed\` - Document Preview Closed
* \`Document Downloaded\` - Document Downloaded
* \`Document Deleted\` - Document Deleted
* \`Document Organize Pages Opened\` - Document Organize Pages Opened
* \`Documents Bulk Selected\` - Documents Bulk Selected
* \`Documents Bulk Deselected\` - Documents Bulk Deselected
* \`Documents Bulk Rename Started\` - Documents Bulk Rename Started
* \`Documents Bulk Rename Completed\` - Documents Bulk Rename Completed
* \`Documents Bulk Rename Failed\` - Documents Bulk Rename Failed
* \`Documents Bulk Merge Started\` - Documents Bulk Merge Started
* \`Documents Bulk Download Started\` - Documents Bulk Download Started
* \`Documents Bulk Download Completed\` - Documents Bulk Download Completed
* \`Documents Bulk Download Failed\` - Documents Bulk Download Failed
* \`Documents Bulk Delete Started\` - Documents Bulk Delete Started
* \`Documents Bulk Delete Completed\` - Documents Bulk Delete Completed
* \`Documents Bulk Delete Failed\` - Documents Bulk Delete Failed
* \`PDF Organize View Opened\` - Pdf Organize View Opened
* \`PDF Organize View Closed\` - Pdf Organize View Closed
* \`PDF Organize Changes Saved\` - Pdf Organize Changes Saved
* \`PDF Organize Changes Discarded\` - Pdf Organize Changes Discarded
* \`PDF Organize Download Started\` - Pdf Organize Download Started
* \`PDF Organize Download Completed\` - Pdf Organize Download Completed
* \`PDF Organize Download Failed\` - Pdf Organize Download Failed
* \`PDF Document Merged\` - Pdf Document Merged
* \`PDF Documents Merged All\` - Pdf Documents Merged All
* \`PDF Document Split Manual\` - Pdf Document Split Manual
* \`PDF Document Split AI Started\` - Pdf Document Split Ai Started
* \`PDF Document Split AI Completed\` - Pdf Document Split Ai Completed
* \`PDF Document Split AI Failed\` - Pdf Document Split Ai Failed
* \`PDF Document Duplicated\` - Pdf Document Duplicated
* \`PDF Document Group Deleted\` - Pdf Document Group Deleted
* \`PDF Document Group Created\` - Pdf Document Group Created
* \`PDF Document Group Renamed\` - Pdf Document Group Renamed
* \`PDF Document Title AI Generated\` - Pdf Document Title Ai Generated
* \`PDF Pages Moved\` - Pdf Pages Moved
* \`PDF Pages Deleted\` - Pdf Pages Deleted
* \`PDF Pages Rotated\` - Pdf Pages Rotated
* \`PDF Pages Reordered\` - Pdf Pages Reordered
* \`PDF Pages Merged\` - Pdf Pages Merged
* \`PDF Add Documents Opened\` - Pdf Add Documents Opened
* \`PDF Documents Added\` - Pdf Documents Added
* \`PDF Viewer Edit Page Clicked\` - Pdf Viewer Edit Page Clicked
* \`PDF Viewer Organize Pages Clicked\` - Pdf Viewer Organize Pages Clicked
* \`PDF Viewer Download Clicked\` - Pdf Viewer Download Clicked
* \`PDF Viewer Reset Edits Started\` - Pdf Viewer Reset Edits Started
* \`PDF Viewer Reset Edits Completed\` - Pdf Viewer Reset Edits Completed
* \`PDF Viewer Reset Edits Cancelled\` - Pdf Viewer Reset Edits Cancelled
* \`Image Editor Opened\` - Image Editor Opened
* \`Image Editor Closed\` - Image Editor Closed
* \`Image Editor Mode Changed\` - Image Editor Mode Changed
* \`Image Editor Changes Applied\` - Image Editor Changes Applied
* \`Image Editor Changes Discarded\` - Image Editor Changes Discarded
* \`Image Editor Crop Region Added\` - Image Editor Crop Region Added
* \`Image Editor Crop Region Removed\` - Image Editor Crop Region Removed
* \`Image Editor Crop Applied\` - Image Editor Crop Applied
* \`Image Editor Crop Reset\` - Image Editor Crop Reset
* \`Image Editor Rotated\` - Image Editor Rotated
* \`Image Editor Rotation Reset\` - Image Editor Rotation Reset
* \`Image Editor Adjustment Changed\` - Image Editor Adjustment Changed
* \`Image Editor Adjustments Reset\` - Image Editor Adjustments Reset
* \`Image Editor Trim Applied\` - Image Editor Trim Applied
* \`Image Editor Trim Reset\` - Image Editor Trim Reset
* \`Actaport Document Imported\` - Actaport Document Imported
* \`Actaport Document Import Failed\` - Actaport Document Import Failed
* \`Actaport Document Exported\` - Actaport Document Exported
* \`Actaport Document Export Failed\` - Actaport Document Export Failed
* \`Actaport Documents Refresh\` - Actaport Documents Refresh
* \`Actaport API Rate Limit Hit\` - Actaport Api Rate Limit Hit
* \`PDF Form Template Created\` - Pdf Form Template Created
* \`PDF Form Template Duplicated\` - Pdf Form Template Duplicated
* \`PDF Form Template Updated\` - Pdf Form Template Updated
* \`PDF Form Template Deleted\` - Pdf Form Template Deleted
* \`PDF Form Template Edit Started\` - Pdf Form Template Edit Started
* \`PDF Form Template Edit Saved\` - Pdf Form Template Edit Saved
* \`PDF Form Template Edit Abandoned\` - Pdf Form Template Edit Abandoned
* \`PDF Form Template Field Added\` - Pdf Form Template Field Added
* \`PDF Form Template Field Removed\` - Pdf Form Template Field Removed
* \`PDF Form Template Previewed\` - Pdf Form Template Previewed
* \`PDF Form Template Used\` - Pdf Form Template Used
* \`PDF Form Submission Created\` - Pdf Form Submission Created
* \`PDF Form Submission Completed\` - Pdf Form Submission Completed
* \`PDF Form Submission Sent\` - Pdf Form Submission Sent
* \`PDF Form Flattened\` - Pdf Form Flattened
* \`Self Questionnaire Created\` - Self Questionnaire Created
* \`Self Questionnaire Updated\` - Self Questionnaire Updated
* \`Self Questionnaire Published\` - Self Questionnaire Published
* \`Self Questionnaire AI Generated\` - Self Questionnaire Ai Generated
* \`Self Questionnaire Copy\` - Self Questionnaire Copy
* \`Self Questionnaire Submission Partial Updated\` - Self Questionnaire Submission Partial Updated
* \`Self Questionnaire Submission Completed\` - Self Questionnaire Submission Completed`
        },
        properties: {
            description: 'Additional properties for the event'
        }
    }
} as const;

export const $PatchedInboundEmailRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        }
    }
} as const;

export const $PatchedPDFFormSubmissionBaseRequest = {
    type: 'object',
    description: 'PDF form submission serializer for all user roles.',
    properties: {
        submission_status: {
            allOf: [
                {
                    '$ref': '#/components/schemas/SubmissionStatusEnum'
                }
            ],
            description: `Current status of the form submission

* \`in_progress\` - In Progress
* \`completed\` - Completed`
        },
        form_fields: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/SubmissionFormFieldRequest'
            }
        }
    }
} as const;

export const $PatchedPhoneForwardingRuleRequest = {
    type: 'object',
    description: 'Base serializer for PhoneForwardingRule model.',
    properties: {
        title: {
            type: 'string',
            title: 'Rule Title',
            description: 'A descriptive name for this forwarding rule',
            maxLength: 255
        },
        rule_type: {
            allOf: [
                {
                    '$ref': '#/components/schemas/RuleTypeEnum'
                }
            ],
            description: `The type of condition this rule uses

* \`phonenumber\` - Phone Number
* \`entity\` - Entity Type
* \`text\` - Text Context`
        },
        active: {
            type: 'boolean',
            description: 'Whether this rule is currently active'
        },
        from_numbers: {
            title: 'From Phone Numbers',
            description: 'List of phone numbers to match (for phone number rules)'
        },
        from_entity_types: {
            description: 'List of entity types to match (for entity rules)'
        },
        from_text_context: {
            type: 'string',
            description: 'Text context to match (for text rules)',
            maxLength: 255
        },
        target_phone_number: {
            type: 'string',
            description: 'Phone number to forward calls to',
            maxLength: 32
        },
        forwarding_message: {
            type: 'string',
            description: 'Message to play before forwarding the call',
            maxLength: 255
        },
        phone_number_uuids: {
            type: 'array',
            items: {
                type: 'string',
                format: 'uuid'
            },
            description: 'List of phone number UUIDs to associate with this rule'
        }
    }
} as const;

export const $PatchedSavedResponseRequest = {
    type: 'object',
    description: 'Serializer for the SavedResponse model.',
    properties: {
        title: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        },
        content: {
            type: 'string',
            minLength: 1
        },
        session_type: {
            '$ref': '#/components/schemas/AIChatSessionTypeEnum'
        }
    }
} as const;

export const $PatchedSessionGroupRequest = {
    type: 'object',
    properties: {
        name: {
            type: 'string',
            minLength: 1,
            description: 'Name of the session group/folder',
            maxLength: 255
        },
        description: {
            type: 'string',
            description: 'Optional description of the session group'
        },
        instructions: {
            type: 'string',
            description: 'Custom instructions for all chats in this group'
        }
    }
} as const;

export const $PatchedSuperUserAccountRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        account_id: {
            type: 'string',
            minLength: 1,
            maxLength: 28
        }
    }
} as const;

export const $PatchedSuperUserActionAutoCommitSettingsRequest = {
    type: 'object',
    description: 'ActionAutoCommitSettings representation for superusers.',
    properties: {
        auto_commit_settings_key: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        },
        can_auto_commit: {
            type: 'boolean'
        },
        additional_user_instructions: {
            type: 'string'
        },
        confidence_threshold: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648
        }
    }
} as const;

export const $PatchedSuperUserActivityRequest = {
    type: 'object',
    description: 'Activity serializer for superuser role.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        seen_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        activity_type: {
            '$ref': '#/components/schemas/ActivityTypeEnum'
        }
    }
} as const;

export const $PatchedSuperUserAiAnalysisRequest = {
    type: 'object',
    properties: {
        case_uuid: {
            type: 'string',
            format: 'uuid'
        },
        document_uuid: {
            type: 'string',
            format: 'uuid'
        }
    }
} as const;

export const $PatchedSuperUserAiAugmentationRequest = {
    type: 'object',
    properties: {
        value: {
            oneOf: [
                {
                    type: 'string'
                },
                {
                    type: 'integer'
                },
                {
                    type: 'boolean'
                },
                {
                    type: 'string',
                    format: 'date'
                },
                {
                    type: 'object',
                    additionalProperties: {}
                },
                {
                    type: 'array',
                    items: {}
                }
            ]
        },
        referenced_document_pages: {
            type: 'array',
            items: {
                type: 'integer'
            }
        },
        explanation: {
            type: 'string',
            minLength: 1
        }
    }
} as const;

export const $PatchedSuperUserAiSettingsRequest = {
    type: 'object',
    description: 'AI Settings representation for superusers.',
    properties: {
        entity_extraction_instructions: {
            type: 'string',
            description: 'Instructions for AI agents when performing entity extraction'
        },
        auto_commit_settings: {
            type: 'string'
        },
        notification_settings: {
            type: 'string'
        },
        ai_workflows_enabled: {
            type: 'boolean',
            description: 'Enable or disable AI workflows for this organisation. When disabled, AI workflows will not be executed for cases in this organisation.'
        },
        send_notifications_bundled: {
            type: 'boolean',
            description: 'Whether to send notifications bundled or individually'
        },
        bundled_notifications_max_delay: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            description: 'Maximum delay in seconds before sending bundled notifications'
        },
        on_case_pre_case_context_gathering_instructions: {
            type: 'string',
            title: 'Pre Case Context Gathering Instructions',
            description: 'Instructions for AI agents during pre case context gathering'
        },
        on_case_post_case_context_gathering_instructions: {
            type: 'string',
            title: 'Post Case Context Gathering Instructions',
            description: 'Instructions for AI agents during post case context gathering'
        }
    }
} as const;

export const $PatchedSuperUserAnnouncementRequest = {
    type: 'object',
    description: `Full announcement serializer for superusers.

Provides access to all fields for managing announcements.`,
    properties: {
        message: {
            type: 'string',
            minLength: 1,
            description: 'The announcement message to display'
        },
        message_type: {
            allOf: [
                {
                    '$ref': '#/components/schemas/MessageTypeEnum'
                }
            ],
            description: `The type of announcement (determines color/styling)

* \`INFO\` - Info
* \`WARNING\` - Warning
* \`ERROR\` - Error
* \`SUCCESS\` - Success`
        },
        is_active: {
            type: 'boolean',
            title: 'Active',
            description: 'Whether this announcement should be displayed'
        },
        start_date: {
            type: 'string',
            format: 'date-time',
            nullable: true,
            description: 'Optional start date for the announcement'
        },
        end_date: {
            type: 'string',
            format: 'date-time',
            nullable: true,
            description: 'Optional end date for the announcement'
        },
        dismissible: {
            type: 'boolean',
            description: 'Whether users can dismiss this announcement'
        }
    }
} as const;

export const $PatchedSuperUserAppointmentProposalRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        case_uuid: {
            type: 'string',
            writeOnly: true,
            minLength: 1
        },
        start: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        location_type: {
            '$ref': '#/components/schemas/LocationTypeEnum'
        },
        message: {
            type: 'string',
            nullable: true
        },
        service_uuid: {
            type: 'string',
            format: 'uuid',
            writeOnly: true
        },
        calendar_uuid: {
            type: 'string',
            format: 'uuid',
            writeOnly: true
        }
    }
} as const;

export const $PatchedSuperUserCalendarRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        active: {
            type: 'boolean',
            title: 'Dieser Kalender ist buchbar'
        },
        name: {
            type: 'string',
            minLength: 1,
            maxLength: 32
        },
        description: {
            type: 'string',
            title: 'Titel',
            maxLength: 32
        },
        long_description: {
            type: 'string',
            title: 'Beschreibung',
            maxLength: 400
        },
        avatar: {
            type: 'string',
            format: 'binary',
            nullable: true,
            title: 'Profilbild'
        },
        services: {
            type: 'array',
            items: {
                type: 'integer'
            }
        },
        slug: {
            type: 'string',
            minLength: 1,
            maxLength: 64,
            pattern: '^[-a-zA-Z0-9_]+$'
        },
        deactivated: {
            type: 'boolean'
        },
        profile: {
            type: 'integer'
        },
        calendar_id: {
            type: 'string',
            minLength: 1,
            maxLength: 64
        },
        calendar_name: {
            type: 'string',
            minLength: 1,
            maxLength: 64
        },
        calendar_readonly: {
            type: 'boolean'
        },
        calendar_deleted: {
            type: 'boolean'
        },
        calendar_primary: {
            type: 'boolean'
        },
        calendar_integrated_conferencing_available: {
            type: 'boolean'
        },
        calendar_attachments_available: {
            type: 'boolean'
        },
        permission_level: {
            type: 'string',
            minLength: 1,
            maxLength: 32
        }
    }
} as const;

export const $PatchedSuperUserCallRequest = {
    type: 'object',
    description: 'Call representation for super users.',
    properties: {
        user_phone_number: {
            type: 'string',
            minLength: 1,
            maxLength: 24
        },
        phone_number_uuid: {
            type: 'string',
            format: 'uuid'
        },
        retell_call_id: {
            type: 'string',
            maxLength: 64
        },
        twilio_call_sid: {
            type: 'string',
            maxLength: 64
        },
        call_start_time: {
            type: 'string',
            format: 'date-time'
        },
        call_end_time: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        data: {},
        result: {
            '$ref': '#/components/schemas/SuperUserCallResultRequest'
        },
        agent_rating: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,1}(?:\\.\\d{0,1})?$',
            nullable: true
        },
        agent_rating_by_human: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,1}(?:\\.\\d{0,1})?$',
            nullable: true
        },
        system_rating: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,1}(?:\\.\\d{0,1})?$',
            nullable: true
        },
        system_rating_by_human: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,1}(?:\\.\\d{0,1})?$',
            nullable: true
        },
        system_rating_summary: {
            type: 'string'
        },
        system_rating_summary_by_human: {
            type: 'string'
        },
        was_name_asked: {
            type: 'boolean',
            nullable: true
        },
        was_name_mentioned: {
            type: 'boolean',
            nullable: true
        },
        is_name_correct: {
            type: 'boolean',
            nullable: true
        },
        was_email_asked: {
            type: 'boolean',
            nullable: true
        },
        was_email_mentioned: {
            type: 'boolean',
            nullable: true
        },
        is_email_correct: {
            type: 'boolean',
            nullable: true
        },
        was_phone_asked: {
            type: 'boolean',
            nullable: true
        },
        was_phone_mentioned: {
            type: 'boolean',
            nullable: true
        },
        is_phone_correct: {
            type: 'boolean',
            nullable: true
        },
        needed_to_ask_for_case_number: {
            type: 'boolean',
            nullable: true
        },
        was_case_number_asked: {
            type: 'boolean',
            nullable: true
        },
        is_case_number_correct: {
            type: 'boolean',
            nullable: true
        },
        is_lawfield_correct: {
            type: 'boolean',
            nullable: true
        },
        is_lawtopic_correct: {
            type: 'boolean',
            nullable: true
        },
        is_classification_correct: {
            type: 'boolean',
            nullable: true
        },
        did_caller_hang_up_early: {
            type: 'boolean',
            nullable: true
        },
        did_caller_hang_up_early_due_to_conversation: {
            type: 'boolean',
            nullable: true
        },
        did_caller_speak_in_single_words: {
            type: 'boolean',
            nullable: true
        },
        is_inquiry_helpful: {
            type: 'boolean',
            nullable: true
        },
        can_customer_derive_value: {
            type: 'boolean',
            nullable: true
        },
        did_call_have_background_noise: {
            type: 'boolean',
            nullable: true
        },
        was_caller_annoyed: {
            type: 'boolean',
            nullable: true
        },
        consumed_tokens: {
            type: 'integer',
            maximum: 2147483647,
            minimum: 0
        },
        total_cost: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$'
        },
        duration: {
            type: 'integer',
            maximum: 2147483647,
            minimum: 0
        },
        had_caller_accent: {
            type: 'boolean',
            nullable: true
        },
        note: {
            type: 'string',
            nullable: true,
            title: 'Interne Notizen',
            maxLength: 1024
        },
        clerk_id: {
            type: 'string',
            format: 'uuid',
            writeOnly: true,
            nullable: true
        },
        forward: {
            allOf: [
                {
                    '$ref': '#/components/schemas/ForwardRequest'
                }
            ],
            nullable: true
        }
    }
} as const;

export const $PatchedSuperUserCaseLifecycleStateRequest = {
    type: 'object',
    description: 'Case Lifecycle State representation for superusers.',
    properties: {
        workflow_uuid: {
            type: 'string',
            format: 'uuid',
            writeOnly: true,
            nullable: true,
            description: 'UUID of the workflow to assign to the case. Set to null to remove workflow assignment.'
        },
        is_agent_active: {
            type: 'boolean'
        }
    }
} as const;

export const $PatchedSuperUserCaseLifecycleWorkflowRequest = {
    type: 'object',
    description: 'Case Lifecycle Workflow representation for superusers.',
    properties: {
        name: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        },
        law_field: {
            title: 'Rechtsgebiet',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawFieldEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        law_topic: {
            title: 'Rechtsthema',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawTopicEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        on_case_ready_for_onboarding_step_1_instructions: {
            type: 'string',
            title: 'Case Ready for Onboarding Step 1 Instructions',
            description: 'Instructions for AI agents when handling a new case - Step 1'
        },
        on_case_ready_for_onboarding_step_1_auto_commit_settings: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/SuperUserActionAutoCommitSettingsRequest'
            }
        },
        on_case_ready_for_onboarding_step_2_instructions: {
            type: 'string',
            title: 'Case Ready for Onboarding Step 2 Instructions',
            description: 'Instructions for AI agents when handling a new case - Step 2'
        },
        on_case_ready_for_onboarding_step_2_auto_commit_settings: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/SuperUserActionAutoCommitSettingsRequest'
            }
        },
        on_all_data_collected_instructions: {
            type: 'string',
            title: 'All Data Collected Instructions',
            description: 'Instructions for AI agents when all data for a case has been collected'
        },
        on_all_data_collected_auto_commit_settings: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/SuperUserActionAutoCommitSettingsRequest'
            }
        },
        on_all_documents_drafted_auto_commit_settings: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/SuperUserActionAutoCommitSettingsRequest'
            }
        }
    }
} as const;

export const $PatchedSuperUserCaseRequest = {
    type: 'object',
    description: 'Case representation for super users.',
    properties: {
        created_at: {
            type: 'string',
            format: 'date-time'
        },
        note: {
            type: 'string',
            nullable: true,
            title: 'Interne Notizen',
            maxLength: 1024
        },
        type: {
            '$ref': '#/components/schemas/CaseType'
        },
        state: {
            allOf: [
                {
                    '$ref': '#/components/schemas/StateEnum'
                }
            ],
            title: 'Status'
        },
        inquiry: {
            type: 'string',
            title: 'Inhalt der Anfrage'
        },
        data: {
            '$ref': '#/components/schemas/SuperUserCaseDataRequest'
        },
        client_document_email_reminder_sent_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        client_document_email_reminder_opt_out: {
            type: 'boolean'
        },
        send_outstanding_document_email_reminder: {
            type: 'boolean',
            title: 'Automatisierte E-Mail Erinnerungen für angeforderte Dokumente aktiv'
        },
        sent_to_actaport_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        actaport_case_id: {
            type: 'string',
            nullable: true,
            minLength: 1,
            maxLength: 48
        },
        sent_to_advoware_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        advoware_case_id: {
            type: 'string',
            nullable: true,
            minLength: 1,
            maxLength: 48
        },
        sent_to_iusta_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        iusta_data: {},
        is_selected_for_export_to: {},
        exported_to: {},
        export_data: {},
        sent_to_ra_micro_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        sent_to_advolux_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        last_activity_at: {
            type: 'string',
            format: 'date-time'
        },
        last_activity_seen_at: {
            type: 'string',
            format: 'date-time'
        },
        user_access_token: {
            type: 'string',
            minLength: 1,
            maxLength: 256
        },
        kleos_case_id: {
            type: 'string',
            nullable: true,
            minLength: 1,
            maxLength: 48
        },
        kleos_reference: {
            type: 'string',
            nullable: true,
            minLength: 1,
            maxLength: 48
        },
        clerk_id: {
            type: 'string',
            format: 'uuid',
            writeOnly: true,
            nullable: true
        },
        jupus_case_number: {
            type: 'string',
            nullable: true,
            minLength: 1,
            maxLength: 24
        }
    }
} as const;

export const $PatchedSuperUserCreatePDFFormTemplateRequest = {
    type: 'object',
    description: 'Serializer for superusers to create PDF form templates with org selection.',
    properties: {
        name: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        },
        description: {
            type: 'string'
        },
        original_pdf: {
            type: 'string',
            format: 'binary',
            description: 'Original PDF template uploaded by user (preserved, never modified)'
        },
        org_uuid: {
            type: 'string',
            format: 'uuid',
            writeOnly: true
        }
    }
} as const;

export const $PatchedSuperUserDocumentTemplateRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        name: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        },
        description: {
            type: 'string',
            minLength: 1
        },
        system_prompt: {
            type: 'string',
            minLength: 1
        },
        document_template: {
            type: 'string'
        },
        law_field: {
            title: 'Rechtsgebiet',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawFieldEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        law_topic: {
            title: 'Rechtsthema',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawTopicEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        is_jupus_template: {
            type: 'boolean'
        }
    }
} as const;

export const $PatchedSuperUserEmailTemplateRequest = {
    type: 'object',
    properties: {
        type: {
            '$ref': '#/components/schemas/EmailTemplateType'
        },
        name: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        },
        subject: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        },
        html: {
            type: 'string',
            minLength: 1
        },
        default: {
            type: 'boolean'
        },
        law_field: {
            title: 'Rechtsgebiet',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawFieldEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        law_topic: {
            title: 'Rechtsthema',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawTopicEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        questionnaire_uuids: {
            type: 'array',
            items: {
                type: 'string',
                format: 'uuid'
            },
            writeOnly: true
        },
        form_uuids: {
            type: 'array',
            items: {
                type: 'string',
                format: 'uuid'
            },
            writeOnly: true
        }
    }
} as const;

export const $PatchedSuperUserEntityRequest = {
    type: 'object',
    description: 'Entity representation for super users.',
    properties: {
        entity_type: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EntityTypeEnum'
                }
            ],
            title: 'Personentyp'
        },
        title: {
            title: 'Anrede',
            oneOf: [
                {
                    '$ref': '#/components/schemas/TitleEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        first_name: {
            type: 'string',
            title: 'Vorname',
            maxLength: 128
        },
        last_name: {
            type: 'string',
            title: 'Nachname',
            maxLength: 128
        },
        email: {
            type: 'string',
            format: 'email',
            title: 'E-Mail',
            maxLength: 128
        },
        phone: {
            type: 'string',
            title: 'Telefon',
            maxLength: 128
        },
        street: {
            type: 'string',
            title: 'Straße',
            maxLength: 128
        },
        street_number: {
            type: 'string',
            title: 'Hausnummer',
            maxLength: 16
        },
        address_line_2: {
            type: 'string',
            title: 'Adresszusatz',
            maxLength: 128
        },
        zip: {
            type: 'string',
            title: 'PLZ',
            maxLength: 12
        },
        city: {
            type: 'string',
            title: 'Ort',
            maxLength: 100
        },
        date_of_birth: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Geburtsdatum'
        },
        legal_insurance: {
            type: 'boolean',
            nullable: true,
            title: 'Rechtsschutzversicherung'
        },
        legal_insurance_number: {
            type: 'string',
            title: 'Nummer der Rechtsschutzversicherung',
            maxLength: 128
        },
        legal_insurance_name: {
            type: 'string',
            title: 'Name der Rechtsschutzversicherung',
            maxLength: 128
        },
        legal_insurance_deductible_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Höhe der Selbstbeteiligung der Rechtsschutzversicherung'
        },
        company_name: {
            type: 'string',
            title: 'Firmenname',
            maxLength: 128
        },
        company_legal_form: {
            title: 'Rechtsform',
            oneOf: [
                {
                    '$ref': '#/components/schemas/CompanyLegalFormEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        company_register_number: {
            type: 'string',
            title: 'Handelsregisternummer',
            maxLength: 128
        },
        company_register_court: {
            type: 'string',
            title: 'Amtsgericht',
            maxLength: 128
        },
        company_vat_id: {
            type: 'string',
            title: 'USt. ID',
            maxLength: 128
        },
        company_tax_id: {
            type: 'string',
            title: 'Steuernummer',
            maxLength: 128
        },
        bank_name: {
            type: 'string',
            title: 'Bankname',
            maxLength: 128
        },
        iban: {
            type: 'string',
            maxLength: 34
        },
        bic: {
            type: 'string',
            maxLength: 11
        },
        institution_name: {
            type: 'string',
            title: 'Name der Institution',
            maxLength: 128
        }
    }
} as const;

export const $PatchedSuperUserFeedbackRequest = {
    type: 'object',
    properties: {
        url: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        },
        rating: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,1}(?:\\.\\d{0,1})?$'
        },
        feature: {
            '$ref': '#/components/schemas/FeatureEnum'
        },
        comment: {
            type: 'string'
        },
        related_data: {
            '$ref': '#/components/schemas/FeedbackRelatedData'
        }
    }
} as const;

export const $PatchedSuperUserFormRequest = {
    type: 'object',
    description: 'Form representation for superusers.',
    properties: {
        organisation_uuid: {
            type: 'string',
            format: 'uuid'
        },
        tag: {
            oneOf: [
                {
                    '$ref': '#/components/schemas/FormTag'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        title: {
            type: 'string',
            maxLength: 255
        },
        description: {
            type: 'string'
        },
        file: {
            type: 'string',
            format: 'binary',
            nullable: true
        }
    }
} as const;

export const $PatchedSuperUserLawyerFeedbackRequest = {
    type: 'object',
    properties: {
        rating: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,1}(?:\\.\\d{0,1})?$'
        },
        feedback: {
            type: 'string',
            maxLength: 1024
        },
        call_uuid: {
            type: 'string',
            format: 'uuid',
            writeOnly: true
        }
    }
} as const;

export const $PatchedSuperUserOrganisationRequest = {
    type: 'object',
    description: 'Organisation representation for superusers.',
    properties: {
        name: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'Name der Kanzlei',
            maxLength: 128
        },
        logo: {
            type: 'string',
            format: 'binary',
            nullable: true
        },
        description: {
            type: 'string',
            title: 'Beschreibung',
            maxLength: 400
        },
        slug: {
            type: 'string',
            minLength: 1,
            maxLength: 64,
            pattern: '^[-a-zA-Z0-9_]+$'
        },
        law_fields: {},
        law_firm: {
            type: 'boolean'
        },
        short_id: {
            type: 'string',
            minLength: 1,
            maxLength: 8
        },
        street: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'Straße',
            maxLength: 96
        },
        street_number: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'Haus',
            maxLength: 12
        },
        zip: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'PLZ',
            maxLength: 5
        },
        city: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'Stadt',
            maxLength: 64
        },
        country: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'Land',
            maxLength: 96
        },
        latitude: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'Breitengrad'
        },
        longitude: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'Längengrad'
        },
        phone: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'Telefonnummer',
            maxLength: 24
        },
        email: {
            type: 'string',
            format: 'email',
            nullable: true,
            minLength: 1,
            maxLength: 96
        },
        inbound_email_slug: {
            type: 'string',
            minLength: 1,
            maxLength: 64
        },
        enable_inbound_email_replies: {
            type: 'boolean',
            title: 'Aktiv'
        },
        seats: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            title: 'Sitze'
        },
        appointments_seats: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            title: 'Terminbuchungen Sitze'
        },
        email_text_color: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EmailTextColorEnum'
                }
            ],
            title: 'Textfarbe'
        },
        email_text_font: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EmailTextFontEnum'
                }
            ],
            title: 'Schriftart'
        },
        email_text_size: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EmailTextSizeEnum'
                }
            ],
            title: 'Schriftgröße',
            minimum: -2147483648,
            maximum: 2147483647
        },
        email_signature: {
            type: 'string',
            title: 'E-Mail Signatur'
        },
        email_blocked_senders: {
            title: 'Blockierte Absender'
        },
        email_spam_filter_active: {
            type: 'boolean',
            title: 'Spamfilter aktiv'
        },
        track_email_delivery_events: {
            type: 'boolean',
            title: 'E-Mail Zustell-Events tracken'
        },
        track_opened_click_email_delivery_events: {
            type: 'boolean',
            title: 'E-Mail Öffnungs- und Klick-Events tracken'
        },
        receive_questionnaire_closed_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn ein Fragebogen abgeschlossen wird'
        },
        receive_document_signed_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn ein Dokument abgeschlossen wird'
        },
        receive_new_case_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn eine neue Anfrage erstellt wird'
        },
        receive_new_case_email_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn eine neue E-Mail zu einer Anfrage eingeht'
        },
        receive_new_appointment_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn ein neuer Terminvorschlag erstellt wird'
        },
        send_document_email_reminders: {
            type: 'boolean',
            title: 'Automatisierte E-Mail Erinnerungen aktiv'
        },
        send_document_email_reminders_every_x_days: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            title: 'E-Mail Erinnerungen alle x Tage senden'
        },
        max_reminders: {
            type: 'integer',
            maximum: 2147483647,
            minimum: 1,
            title: 'Maximale Anzahl Erinnerungen pro Dokument',
            description: 'Maximum number of reminders that can be sent per document or questionnaire'
        },
        send_email_client_confirmation_on_new_case: {
            type: 'boolean',
            title: 'E-Mail Bestätigung bei neuer Anfrage senden'
        },
        send_email_client_confirmation_on_new_case_via_email: {
            type: 'boolean',
            title: 'E-Mail Bestätigung bei neuer Anfrage per E-Mail senden'
        },
        receive_clerk_change_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn ein Sachbearbeiter zugewiesen wird'
        },
        receive_email_bounce_notifications: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn eine E-Mail nicht zugestellt werden konnte'
        },
        is_actaport_export_integration_enabled: {
            type: 'boolean',
            title: 'Actaport Integration aktivieren'
        },
        questionnaire_creation_token: {
            type: 'string',
            minLength: 1,
            maxLength: 48
        },
        ai_enabled: {
            type: 'boolean',
            title: 'KI Aktiv'
        },
        enable_ai_workflows: {
            type: 'boolean',
            title: 'KI-Workflows aktivieren'
        },
        is_iusta_egress_integration_enabled: {
            type: 'boolean',
            title: 'Iusta Integration aktivieren'
        },
        is_ra_micro_export_integration_enabled: {
            type: 'boolean'
        },
        ra_micro_export_integration_type: {
            nullable: true,
            title: 'Integration Type',
            oneOf: [
                {
                    '$ref': '#/components/schemas/RaMicroExportIntegrationTypeEnum'
                },
                {
                    '$ref': '#/components/schemas/NullEnum'
                }
            ]
        },
        ra_micro_oma_email_id: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'OMA Email ID',
            maxLength: 64
        },
        ra_micro_oma_email: {
            type: 'string',
            format: 'email',
            nullable: true,
            minLength: 1,
            title: 'OMA Email',
            maxLength: 96
        },
        is_advolux_export_integration_enabled: {
            type: 'boolean'
        },
        is_webhooks_egress_integration_enabled: {
            type: 'boolean'
        },
        webhook_urls: {
            type: 'string',
            nullable: true,
            maxLength: 256
        },
        is_email_egress_integration_enabled: {
            type: 'boolean'
        },
        email_egress_address: {
            type: 'string',
            format: 'email',
            nullable: true,
            minLength: 1,
            title: 'Email',
            maxLength: 96
        },
        is_kleos_integration_enabled: {
            type: 'boolean'
        },
        is_advoware_export_integration_enabled: {
            type: 'boolean',
            title: 'Advoware Integration aktivieren'
        },
        is_law_firm_software_exportation_enabled: {
            type: 'boolean'
        },
        enable_appointments: {
            type: 'boolean',
            title: 'Terminbuchung aktivieren'
        },
        enable_voice: {
            type: 'boolean',
            title: 'KI-Anrufbeantworter aktivieren'
        },
        enable_cases: {
            type: 'boolean',
            title: 'Anfragen aktivieren (normale JUPUS Plattform)'
        },
        stripe_customer_uuid: {
            type: 'string',
            format: 'uuid',
            nullable: true
        },
        is_hubspot_egress_integration_enabled: {
            type: 'boolean'
        },
        is_haveibeenpwned_integration_enabled: {
            type: 'boolean'
        },
        is_jurnodes_export_integration_enabled: {
            type: 'boolean',
            title: 'Jur|nodes Integration aktivieren'
        },
        is_datev_export_integration_enabled: {
            type: 'boolean'
        },
        bot_title: {
            type: 'string',
            maxLength: 64
        },
        bot_embed_uuid: {
            type: 'string',
            format: 'uuid'
        },
        bot_starttime: {
            type: 'string',
            minLength: 1,
            maxLength: 8
        },
        bot_attention_message: {
            type: 'string',
            maxLength: 64
        },
        bot_title_background_color: {
            type: 'string',
            minLength: 1,
            title: 'Hintergrundfarbe',
            maxLength: 64
        },
        bot_title_text_color: {
            type: 'string',
            minLength: 1,
            title: 'Textfarbe',
            maxLength: 64
        },
        bot_chat_bubble_operator_color: {
            type: 'string',
            minLength: 1,
            title: 'Hintergrundfarbe',
            maxLength: 64
        },
        bot_message_input_text_color: {
            type: 'string',
            minLength: 1,
            title: 'Textfarbe',
            maxLength: 64
        },
        bot_custom_font_family: {
            type: 'string',
            title: 'Schriftart',
            maxLength: 64
        },
        bot_chat_auto_open: {
            type: 'boolean',
            title: 'Chat automatisch öffnen'
        },
        bot_chat_auto_open_delay: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            title: 'Zeit, nach der der Chat automatisch geöffnet wird (in Millisekunden)'
        },
        bot_chat_target_element: {
            type: 'string',
            title: 'Element, in dem der Chat-Button eingebunden werden soll',
            maxLength: 64
        },
        bot_button_auto_show: {
            type: 'boolean',
            title: 'Button automatisch anzeigen'
        },
        bot_button_auto_show_delay: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            title: 'Zeit, nach der der Button automatisch angezeigt wird (in Millisekunden)'
        },
        bot_button_position: {
            allOf: [
                {
                    '$ref': '#/components/schemas/BotButtonPositionEnum'
                }
            ],
            title: 'Die Position des Buttons zum Starten des Chats'
        },
        bot_chat_bubble_operator_text_color: {
            type: 'string',
            minLength: 1,
            title: 'Textfarbe',
            maxLength: 64
        },
        bot_button_background_color: {
            type: 'string',
            minLength: 1,
            title: 'Hintergrundfarbe',
            maxLength: 64
        },
        bot_button_text_color: {
            type: 'string',
            minLength: 1,
            title: 'Textfarbe',
            maxLength: 64
        },
        bot_chat_bubble_contact_color: {
            type: 'string',
            minLength: 1,
            title: 'Hintergrundfarbe',
            maxLength: 64
        },
        bot_chat_bubble_contact_text_color: {
            type: 'string',
            minLength: 1,
            title: 'Textfarbe',
            maxLength: 64
        },
        bot_floating_custom: {
            type: 'string',
            title: 'Widget Button custom CSS'
        },
        bot_footer_content: {
            type: 'string',
            minLength: 1,
            title: 'Footer CSS'
        },
        bot_background_color: {
            type: 'string',
            minLength: 1,
            title: 'Hintergrundfarbe',
            maxLength: 64
        },
        bot_message_input_background_color: {
            type: 'string',
            minLength: 1,
            title: 'Hintergrundfarbe',
            maxLength: 64
        },
        bot_start_without_bot: {},
        bot_start_without_bot_buttons: {},
        bot_floating_custom_button_background_color: {
            type: 'string',
            minLength: 1,
            title: 'Hintergrundfarbe',
            maxLength: 64
        },
        bot_floating_custom_button_text_color: {
            type: 'string',
            minLength: 1,
            title: 'Textfarbe',
            maxLength: 64
        },
        bot_floating_custom_button_width: {
            type: 'integer',
            maximum: 2147483647,
            minimum: 0,
            title: 'Breite (Pixel)'
        },
        bot_floating_custom_button_height: {
            type: 'integer',
            maximum: 2147483647,
            minimum: 0,
            title: 'Höhe (Pixel)'
        },
        bot_floating_custom_button_text: {
            type: 'string',
            minLength: 1,
            title: 'Text',
            maxLength: 64
        },
        receive_monthly_updates_summary: {
            type: 'boolean',
            title: 'Monatliche Zusammenfassung per E-Mail erhalten'
        },
        hubspot_company_uuid: {
            type: 'string',
            format: 'uuid',
            nullable: true
        },
        has_churned: {
            type: 'boolean',
            title: 'Hat gekündigt'
        },
        enable_law_specific_data: {
            type: 'boolean',
            title: 'Rechtsspezifische Daten & Dokumentengenerator aktivieren'
        },
        is_new_ui_switch_enabled: {
            type: 'boolean'
        },
        is_forced_to_use_new_ui: {
            type: 'boolean'
        },
        is_phonebot_self_service_customer: {
            type: 'boolean',
            title: 'Phonebot Self-Service Kunde'
        },
        phonebot_self_service_plan: {
            nullable: true,
            oneOf: [
                {
                    '$ref': '#/components/schemas/PhonebotSelfServicePlanEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                },
                {
                    '$ref': '#/components/schemas/NullEnum'
                }
            ]
        },
        phonebot_trial_ends_at: {
            type: 'string',
            format: 'date',
            nullable: true
        }
    }
} as const;

export const $PatchedSuperUserPDFFormSubmissionRequest = {
    type: 'object',
    description: 'Serializer for superusers - full access to all fields.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        submission_status: {
            allOf: [
                {
                    '$ref': '#/components/schemas/SubmissionStatusEnum'
                }
            ],
            description: `Current status of the form submission

* \`in_progress\` - In Progress
* \`completed\` - Completed`
        },
        template_name: {
            type: 'string',
            minLength: 1,
            description: 'Snapshot of template name at submission creation time',
            maxLength: 255
        },
        template_description: {
            type: 'string',
            description: 'Snapshot of template description at submission creation time'
        },
        form_fields: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/SubmissionFormFieldRequest'
            }
        },
        progress_percentage: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            description: 'Completion percentage (0-100)'
        },
        completed_at: {
            type: 'string',
            format: 'date-time',
            nullable: true,
            description: 'When the form was completed'
        },
        created_by: {
            type: 'integer',
            nullable: true
        },
        org: {
            type: 'integer'
        },
        template: {
            '$ref': '#/components/schemas/PDFFormTemplateRequest'
        },
        is_standalone: {
            type: 'boolean',
            description: 'Standalone submission that creates a new case (like questionnaires from settings)'
        },
        is_external: {
            type: 'boolean',
            description: 'External submission linked to existing case for third-party completion'
        }
    }
} as const;

export const $PatchedSuperUserPhoneNumberRequest = {
    type: 'object',
    description: 'PhoneNumber representation for superusers.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        active: {
            type: 'boolean'
        },
        law_fields: {
            title: 'Rechtsgebiete'
        },
        description: {
            type: 'string',
            title: 'Bezeichnung',
            description: 'Hier können Sie eine interne Bezeichnung für die Rufnummer hinterlegen.',
            maxLength: 255
        },
        lawfirm_name: {
            type: 'string',
            title: 'Kanzleiname',
            description: 'Geben Sie hier den Namen Ihrer Kanzlei ein, wie er in der Begrüßungsansage genannt werden soll.',
            maxLength: 255
        },
        address: {
            type: 'string',
            title: 'Adresse',
            description: 'Hier können Sie die Adresse Ihrer Kanzlei hinterlegen. Bei Nachfrage geben wir diese an den Anrufer weiter. Wenn Sie keine unangekündigten Mandantenbesuch wünschen, dann geben Sie hier bitte einen entsprechenden Hinweis.',
            maxLength: 1024
        },
        opening_hours: {
            type: 'string',
            title: 'Öffnungszeiten',
            description: 'Hier können Sie Ihre Öffnungszeiten Ihrer Kanzlei hinterlegen. Bei Nachfrage geben wir diese an den Anrufer weiter.',
            maxLength: 1024
        },
        lawyer_names: {
            type: 'string',
            title: 'Anwälte/Sachbearbeiter',
            description: 'Hier können Sie die Namen Ihrer Anwälte oder Sachbearbeiter hinterlegen. Dies hilft uns dabei, den Namen des Anrufers besser zu erkennen. Bitte tragen Sie nur den Namen ein und keine weitere Bezeichnung wie zum Beispiel Anwalt oder Sachbearbeiter.',
            maxLength: 1024
        },
        has_free_initial_consultation: {
            type: 'boolean',
            title: 'Kostenlose Erstberatung',
            description: 'Bieten Sie eine kostenlose Erstberatung an? Wenn ja, dann aktivieren Sie diese Option und wir geben dies an den Anrufer weiter.'
        },
        original_phone_number: {
            type: 'string',
            title: 'Telefonnummer',
            description: 'Wenn Sie die von uns generierte Nummer intern weiterleiten, geben Sie hier unbedingt die Originalnummer an, welche von den Mandanten angerufen wird. So stellen Sie sicher, dass wir die Anrufe korrekt zuordnen können.',
            maxLength: 255
        },
        can_record_calls: {
            type: 'boolean',
            title: 'Anrufe aufzeichnen',
            description: 'Durch das Aktivieren dieser Option Stellen wir Ihnen auf der Detailseite eines Anrufs einen Mitschnitt des Namen bzw. der E-Mail-Addresse zur Verfügung. Die Aufzeichnung von Anrufen ist in Deutschland nur mit Zustimmung des Anrufers gestattet. Wir weisen Sie darauf hin, dass Sie diese Zustimmung von dem Anrufer einholen müssen.'
        },
        is_in_answering_machine_mode: {
            type: 'boolean',
            title: 'Reiner Anrufbeantworter'
        },
        agent_uuid: {
            type: 'string',
            writeOnly: true,
            minLength: 1
        },
        org_uuid: {
            type: 'string',
            writeOnly: true,
            minLength: 1
        },
        begin_message: {
            type: 'string',
            title: 'Begrüßung',
            description: 'Hier können Sie eine Begrüßung für den Anrufbeantworter hinterlegen. Diese wird am Anfang des Anrufes abgespielt.',
            maxLength: 1024
        },
        end_message: {
            type: 'string',
            title: 'Abschiedsnachricht',
            description: 'Hier können Sie eine Abschiedsnachricht für den Anrufbeantworter hinterlegen. Diese wird am Ende des Anrufes abgespielt.',
            maxLength: 1024
        }
    }
} as const;

export const $PatchedSuperUserQuestionnaireRequest = {
    type: 'object',
    description: 'Questionnaire representation for superusers.',
    properties: {
        title: {
            type: 'string',
            minLength: 1,
            maxLength: 64
        },
        description: {
            type: 'string'
        },
        category: {
            oneOf: [
                {
                    '$ref': '#/components/schemas/CategoryEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        law_field: {
            title: 'Rechtsgebiet',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawFieldEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        law_topic: {
            title: 'Rechtsthema',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawTopicEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        schema: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/QuestionnaireSectionRequest'
            }
        },
        org_uuid: {
            type: 'string',
            format: 'uuid',
            writeOnly: true,
            nullable: true
        },
        is_jupus_template: {
            type: 'boolean',
            description: 'True if this questionnaire is a Jupus template that can be copied by organizations'
        }
    }
} as const;

export const $PatchedSuperUserQuestionnaireSubmissionRequest = {
    type: 'object',
    description: 'Questionnaire submission representation for superusers.',
    properties: {
        schema: {},
        closed: {
            type: 'boolean'
        }
    }
} as const;

export const $PatchedSuperUserServiceRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        active: {
            type: 'boolean',
            title: 'Diese Leistung ist buchbar'
        },
        name: {
            type: 'string',
            minLength: 1,
            title: 'Titel',
            maxLength: 32
        },
        description: {
            type: 'string',
            minLength: 1,
            title: 'Beschreibung',
            maxLength: 400
        },
        duration_mins: {
            type: 'integer'
        },
        buffer_mins: {
            type: 'integer'
        },
        price: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,6}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Preis'
        },
        currency: {
            type: 'string',
            minLength: 1,
            title: 'Währung',
            maxLength: 8
        },
        unit: {
            type: 'string',
            minLength: 1,
            title: 'Einheit',
            maxLength: 32
        },
        show_price: {
            type: 'boolean',
            title: 'Preis anzeigen',
            description: 'Wenn aktiviert, wird der Preis der Leistung während der Buchung des Termins angezeigt.'
        },
        slug: {
            type: 'string',
            minLength: 1,
            maxLength: 64,
            pattern: '^[-a-zA-Z0-9_]+$'
        },
        online_appointment_enabled: {
            type: 'boolean',
            title: 'Online-Termin'
        },
        telephone_appointment_enabled: {
            type: 'boolean',
            title: 'Telefon-Termin'
        },
        in_person_appointment_enabled: {
            type: 'boolean',
            title: 'Termin vor Ort'
        }
    }
} as const;

export const $PatchedSuperUserUserRequest = {
    type: 'object',
    description: 'User representation for superusers.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        email: {
            type: 'string',
            format: 'email',
            minLength: 1,
            maxLength: 254
        },
        first_name: {
            type: 'string',
            title: 'Vorname',
            maxLength: 150
        },
        last_name: {
            type: 'string',
            title: 'Nachname',
            maxLength: 150
        },
        avatar: {
            type: 'string',
            format: 'binary',
            nullable: true
        },
        role: {
            nullable: true,
            oneOf: [
                {
                    '$ref': '#/components/schemas/Role5ccEnum'
                },
                {
                    '$ref': '#/components/schemas/NullEnum'
                }
            ]
        },
        is_active: {
            type: 'boolean',
            title: 'Aktiv',
            description: 'Legt fest, ob dieser Benutzer aktiv ist. Kann deaktiviert werden, anstatt Benutzer zu löschen.'
        },
        is_staff: {
            type: 'boolean',
            title: 'Mitarbeiter-Status',
            description: 'Legt fest, ob sich der Benutzer an der Administrationsseite anmelden kann.'
        },
        is_superuser: {
            type: 'boolean',
            title: 'Administrator-Status',
            description: 'Legt fest, dass der Benutzer alle Berechtigungen hat, ohne diese einzeln zuweisen zu müssen.'
        },
        is_payments_superuser: {
            type: 'boolean'
        },
        email_signature: {
            type: 'string',
            title: 'E-Mail Signatur'
        },
        notifications_receive_monthly_summary: {
            type: 'boolean'
        },
        case_dashboard_widgets: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/CaseDashboardWidgetsEnum'
            }
        },
        global_ai_chat_intro_seen: {
            type: 'boolean',
            description: 'Whether the user has seen and accepted the global AI chat intro page'
        },
        global_ai_chat_badge_dismissed: {
            type: 'boolean',
            description: 'Whether the user has clicked on Global AI Chat navigation item (badge should be hidden)'
        }
    }
} as const;

export const $PatchedSuperUserWordDocumentTemplateRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        name: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        },
        description: {
            type: 'string',
            minLength: 1
        },
        system_prompt: {
            type: 'string',
            minLength: 1
        },
        docx_template: {
            type: 'string',
            format: 'binary',
            nullable: true,
            description: 'Active template used for document generation (can be original, AI-generated, or custom upload)'
        },
        ai_docx_template: {
            type: 'string',
            format: 'binary',
            nullable: true,
            description: 'AI-generated template with placeholders created from docx_template'
        },
        law_field: {
            title: 'Rechtsgebiet',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawFieldEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        law_topic: {
            title: 'Rechtsthema',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawTopicEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        is_jupus_template: {
            type: 'boolean'
        },
        replaceable_variables: {
            nullable: true
        },
        status: {
            allOf: [
                {
                    '$ref': '#/components/schemas/WordTemplateStatus'
                }
            ],
            description: `Current status of the template in the review workflow

* \`draft\` - Draft
* \`in_review\` - In Review
* \`approved\` - Approved`
        },
        ai_extraction_metadata: {
            description: 'Stores AI extraction confidence scores and metadata'
        }
    }
} as const;

export const $PatchedTAIChatSessionRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/PatchedAIChatSessionRequest'
        }
    ]
} as const;

export const $PatchedTAccountRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/PatchedCustomerAccountRequest'
        },
        {
            '$ref': '#/components/schemas/PatchedCustomerAdminAccountRequest'
        },
        {
            '$ref': '#/components/schemas/PatchedSuperUserAccountRequest'
        }
    ]
} as const;

export const $PatchedTActionAutoCommitSettingsRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/PatchedCustomerActionAutoCommitSettingsRequest'
        },
        {
            '$ref': '#/components/schemas/PatchedCustomerAdminActionAutoCommitSettingsRequest'
        },
        {
            '$ref': '#/components/schemas/PatchedSuperUserActionAutoCommitSettingsRequest'
        }
    ]
} as const;

export const $PatchedTActivityRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/PatchedCustomerActivityRequest'
        },
        {
            '$ref': '#/components/schemas/PatchedCustomerAdminActivityRequest'
        },
        {
            '$ref': '#/components/schemas/PatchedSuperUserActivityRequest'
        }
    ]
} as const;

export const $PatchedTAgentActionRequest = {
    oneOf: []
} as const;

export const $PatchedTAiAnalysisRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/PatchedClientAiAnalysisRequest'
        },
        {
            '$ref': '#/components/schemas/PatchedCustomerAiAnalysisRequest'
        },
        {
            '$ref': '#/components/schemas/PatchedCustomerAdminAiAnalysisRequest'
        },
        {
            '$ref': '#/components/schemas/PatchedSuperUserAiAnalysisRequest'
        }
    ]
} as const;

export const $PatchedTAiAugmentationRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/PatchedClientAiAugmentationRequest'
        },
        {
            '$ref': '#/components/schemas/PatchedCustomerAiAugmentationRequest'
        },
        {
            '$ref': '#/components/schemas/PatchedCustomerAdminAiAugmentationRequest'
        },
        {
            '$ref': '#/components/schemas/PatchedSuperUserAiAugmentationRequest'
        }
    ]
} as const;

export const $PatchedTAiChatQuestionTemplateRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/PatchedAiChatQuestionTemplateRequest'
        }
    ]
} as const;

export const $PatchedTAiSettingsRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/PatchedCustomerAiSettingsRequest'
        },
        {
            '$ref': '#/components/schemas/PatchedCustomerAdminAiSettingsRequest'
        },
        {
            '$ref': '#/components/schemas/PatchedSuperUserAiSettingsRequest'
        }
    ]
} as const;

export const $PatchedTAnnouncementRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/PatchedSuperUserAnnouncementRequest'
        }
    ]
} as const;

export const $PatchedTAppointmentProposalRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/PatchedCustomerAppointmentProposalRequest'
        },
        {
            '$ref': '#/components/schemas/PatchedCustomerAdminAppointmentProposalRequest'
        },
        {
            '$ref': '#/components/schemas/PatchedSuperUserAppointmentProposalRequest'
        }
    ]
} as const;

export const $PatchedTAppointmentRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/PatchedCustomerAppointmentRequest'
        },
        {
            '$ref': '#/components/schemas/PatchedCustomerAdminAccountRequest'
        },
        {
            '$ref': '#/components/schemas/PatchedSuperUserAccountRequest'
        }
    ]
} as const;

export const $PatchedTCalendarRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/PatchedCustomerCalendarRequest'
        },
        {
            '$ref': '#/components/schemas/PatchedCustomerAdminCalendarRequest'
        },
        {
            '$ref': '#/components/schemas/PatchedSuperUserCalendarRequest'
        }
    ]
} as const;

export const $PatchedTCallRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/PatchedCustomerCallRequest'
        },
        {
            '$ref': '#/components/schemas/PatchedSuperUserCallRequest'
        }
    ]
} as const;

export const $PatchedTCaseCreatorTempDocumentRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/PatchedCaseCreatorTempDocumentRequest'
        }
    ]
} as const;

export const $PatchedTCaseLifecycleStateRequestRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/PatchedCustomerCaseLifecycleStateRequest'
        },
        {
            '$ref': '#/components/schemas/PatchedCustomerAdminCaseLifecycleStateRequest'
        },
        {
            '$ref': '#/components/schemas/PatchedSuperUserCaseLifecycleStateRequest'
        }
    ]
} as const;

export const $PatchedTCaseLifecycleWorkflowRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/PatchedCustomerCaseLifecycleWorkflowRequest'
        },
        {
            '$ref': '#/components/schemas/PatchedCustomerAdminCaseLifecycleWorkflowRequest'
        },
        {
            '$ref': '#/components/schemas/PatchedSuperUserCaseLifecycleWorkflowRequest'
        }
    ]
} as const;

export const $PatchedTCaseRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/PatchedCustomerCaseRequest'
        },
        {
            '$ref': '#/components/schemas/PatchedCustomerAdminCaseRequest'
        },
        {
            '$ref': '#/components/schemas/PatchedSuperUserCaseRequest'
        }
    ]
} as const;

export const $PatchedTChatPreferenceRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/PatchedChatPreferenceRequest'
        }
    ]
} as const;

export const $PatchedTDocumentRequest = {
    oneOf: []
} as const;

export const $PatchedTDocumentTemplateRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/PatchedCustomerDocumentTemplateRequest'
        },
        {
            '$ref': '#/components/schemas/PatchedCustomerAdminDocumentTemplateRequest'
        },
        {
            '$ref': '#/components/schemas/PatchedSuperUserDocumentTemplateRequest'
        }
    ]
} as const;

export const $PatchedTEmailTemplateRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/PatchedCustomerEmailTemplateRequest'
        },
        {
            '$ref': '#/components/schemas/PatchedCustomerAdminEmailTemplateRequest'
        },
        {
            '$ref': '#/components/schemas/PatchedSuperUserEmailTemplateRequest'
        }
    ]
} as const;

export const $PatchedTEntityRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/PatchedClientEntityRequest'
        },
        {
            '$ref': '#/components/schemas/PatchedCustomerEntityRequest'
        },
        {
            '$ref': '#/components/schemas/PatchedCustomerAdminEntityRequest'
        },
        {
            '$ref': '#/components/schemas/PatchedSuperUserEntityRequest'
        }
    ]
} as const;

export const $PatchedTFeedbackRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/PatchedFeedbackRequest'
        },
        {
            '$ref': '#/components/schemas/PatchedSuperUserFeedbackRequest'
        }
    ]
} as const;

export const $PatchedTFormRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/PatchedCustomerFormRequest'
        },
        {
            '$ref': '#/components/schemas/PatchedCustomerAdminFormRequest'
        },
        {
            '$ref': '#/components/schemas/PatchedSuperUserFormRequest'
        }
    ]
} as const;

export const $PatchedTLawyerFeedbackRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/PatchedCustomerLawyerFeedbackRequest'
        },
        {
            '$ref': '#/components/schemas/PatchedSuperUserLawyerFeedbackRequest'
        }
    ]
} as const;

export const $PatchedTOrganisationRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/PatchedCustomerOrganisationRequest'
        },
        {
            '$ref': '#/components/schemas/PatchedCustomerAdminOrganisationRequest'
        },
        {
            '$ref': '#/components/schemas/PatchedSuperUserOrganisationRequest'
        }
    ]
} as const;

export const $PatchedTPDFFormSubmissionRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/PatchedPDFFormSubmissionBaseRequest'
        },
        {
            '$ref': '#/components/schemas/PatchedSuperUserPDFFormSubmissionRequest'
        }
    ]
} as const;

export const $PatchedTPDFFormTemplateRequestRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/PatchedCreatePDFFormTemplateRequest'
        },
        {
            '$ref': '#/components/schemas/PatchedSuperUserCreatePDFFormTemplateRequest'
        }
    ]
} as const;

export const $PatchedTPhoneNumberRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/PatchedCustomerAdminPhoneNumberRequest'
        },
        {
            '$ref': '#/components/schemas/PatchedSuperUserPhoneNumberRequest'
        }
    ]
} as const;

export const $PatchedTQuestionnaireRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/PatchedCustomerQuestionnaireRequest'
        },
        {
            '$ref': '#/components/schemas/PatchedCustomerAdminQuestionnaireRequest'
        },
        {
            '$ref': '#/components/schemas/PatchedSuperUserQuestionnaireRequest'
        }
    ]
} as const;

export const $PatchedTQuestionnaireSubmissionRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/PatchedClientQuestionnaireSubmissionRequest'
        },
        {
            '$ref': '#/components/schemas/PatchedCustomerQuestionnaireSubmissionRequest'
        },
        {
            '$ref': '#/components/schemas/PatchedCustomerAdminQuestionnaireSubmissionRequest'
        },
        {
            '$ref': '#/components/schemas/PatchedSuperUserQuestionnaireSubmissionRequest'
        }
    ]
} as const;

export const $PatchedTRetellAgentRequest = {
    oneOf: []
} as const;

export const $PatchedTSavedResponseRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/PatchedSavedResponseRequest'
        }
    ]
} as const;

export const $PatchedTServiceRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/PatchedCustomerServiceRequest'
        },
        {
            '$ref': '#/components/schemas/PatchedCustomerAdminServiceRequest'
        },
        {
            '$ref': '#/components/schemas/PatchedSuperUserServiceRequest'
        }
    ]
} as const;

export const $PatchedTStripeCustomerRequest = {
    oneOf: []
} as const;

export const $PatchedTStripeInvoiceRequest = {
    oneOf: []
} as const;

export const $PatchedTUserRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/PatchedCustomerUserRequest'
        },
        {
            '$ref': '#/components/schemas/PatchedCustomerAdminUserRequest'
        },
        {
            '$ref': '#/components/schemas/PatchedSuperUserUserRequest'
        }
    ]
} as const;

export const $PatchedTWordDocumentTemplateRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/PatchedCustomerWordDocumentTemplateRequest'
        },
        {
            '$ref': '#/components/schemas/PatchedCustomerAdminWordDocumentTemplateRequest'
        },
        {
            '$ref': '#/components/schemas/PatchedSuperUserWordDocumentTemplateRequest'
        }
    ]
} as const;

export const $PatchedUnifiedDocumentTemplateRequest = {
    type: 'object',
    description: `Unified serializer that normalizes both Form (MASTER) and PDFFormTemplate models
into a common format for the frontend.`,
    properties: {
        template_type: {
            type: 'string',
            minLength: 1
        },
        title: {
            type: 'string'
        },
        description: {
            type: 'string'
        }
    }
} as const;

export const $PatchedUpdateValidationDataRequestRequest = {
    type: 'object',
    description: 'Serializer for updating validation data request.',
    properties: {
        placeholder_values: {
            description: 'Dictionary of placeholder key-value pairs to update'
        },
        use_ai_template: {
            type: 'boolean',
            default: false,
            description: 'Use AI-generated template'
        }
    }
} as const;

export const $PhoneForwardingRule = {
    type: 'object',
    description: 'Base serializer for PhoneForwardingRule model.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        title: {
            type: 'string',
            title: 'Rule Title',
            description: 'A descriptive name for this forwarding rule',
            maxLength: 255
        },
        rule_type: {
            allOf: [
                {
                    '$ref': '#/components/schemas/RuleTypeEnum'
                }
            ],
            description: `The type of condition this rule uses

* \`phonenumber\` - Phone Number
* \`entity\` - Entity Type
* \`text\` - Text Context`
        },
        active: {
            type: 'boolean',
            description: 'Whether this rule is currently active'
        },
        from_numbers: {
            title: 'From Phone Numbers',
            description: 'List of phone numbers to match (for phone number rules)'
        },
        from_entity_types: {
            description: 'List of entity types to match (for entity rules)'
        },
        from_text_context: {
            type: 'string',
            description: 'Text context to match (for text rules)',
            maxLength: 255
        },
        target_phone_number: {
            type: 'string',
            description: 'Phone number to forward calls to',
            maxLength: 32
        },
        forwarding_message: {
            type: 'string',
            description: 'Message to play before forwarding the call',
            maxLength: 255
        },
        phone_number_uuids: {
            type: 'array',
            items: {
                type: 'string',
                format: 'uuid'
            },
            description: 'List of phone number UUIDs to associate with this rule'
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        updated_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        }
    },
    required: ['created_at', 'rule_type', 'updated_at', 'uuid']
} as const;

export const $PhoneForwardingRuleList = {
    type: 'object',
    description: 'Simplified serializer for listing phone forwarding rules.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        title: {
            type: 'string',
            title: 'Rule Title',
            description: 'A descriptive name for this forwarding rule',
            maxLength: 255
        },
        rule_type: {
            allOf: [
                {
                    '$ref': '#/components/schemas/RuleTypeEnum'
                }
            ],
            description: `The type of condition this rule uses

* \`phonenumber\` - Phone Number
* \`entity\` - Entity Type
* \`text\` - Text Context`
        },
        active: {
            type: 'boolean',
            description: 'Whether this rule is currently active'
        },
        from_numbers: {
            title: 'From Phone Numbers',
            description: 'List of phone numbers to match (for phone number rules)'
        },
        from_entity_types: {
            description: 'List of entity types to match (for entity rules)'
        },
        from_text_context: {
            type: 'string',
            description: 'Text context to match (for text rules)',
            maxLength: 255
        },
        target_phone_number: {
            type: 'string',
            description: 'Phone number to forward calls to',
            maxLength: 32
        },
        forwarding_message: {
            type: 'string',
            description: 'Message to play before forwarding the call',
            maxLength: 255
        },
        phone_number_uuids: {
            type: 'array',
            items: {
                type: 'string',
                format: 'uuid'
            },
            readOnly: true,
            description: 'List of phone number UUIDs associated with this rule'
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        updated_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        condition_summary: {
            type: 'string',
            readOnly: true
        }
    },
    required: ['condition_summary', 'created_at', 'phone_number_uuids', 'rule_type', 'updated_at', 'uuid']
} as const;

export const $PhoneForwardingRuleListRequest = {
    type: 'object',
    description: 'Simplified serializer for listing phone forwarding rules.',
    properties: {
        title: {
            type: 'string',
            title: 'Rule Title',
            description: 'A descriptive name for this forwarding rule',
            maxLength: 255
        },
        rule_type: {
            allOf: [
                {
                    '$ref': '#/components/schemas/RuleTypeEnum'
                }
            ],
            description: `The type of condition this rule uses

* \`phonenumber\` - Phone Number
* \`entity\` - Entity Type
* \`text\` - Text Context`
        },
        active: {
            type: 'boolean',
            description: 'Whether this rule is currently active'
        },
        from_numbers: {
            title: 'From Phone Numbers',
            description: 'List of phone numbers to match (for phone number rules)'
        },
        from_entity_types: {
            description: 'List of entity types to match (for entity rules)'
        },
        from_text_context: {
            type: 'string',
            description: 'Text context to match (for text rules)',
            maxLength: 255
        },
        target_phone_number: {
            type: 'string',
            description: 'Phone number to forward calls to',
            maxLength: 32
        },
        forwarding_message: {
            type: 'string',
            description: 'Message to play before forwarding the call',
            maxLength: 255
        }
    },
    required: ['rule_type']
} as const;

export const $PhoneForwardingRuleRequest = {
    type: 'object',
    description: 'Base serializer for PhoneForwardingRule model.',
    properties: {
        title: {
            type: 'string',
            title: 'Rule Title',
            description: 'A descriptive name for this forwarding rule',
            maxLength: 255
        },
        rule_type: {
            allOf: [
                {
                    '$ref': '#/components/schemas/RuleTypeEnum'
                }
            ],
            description: `The type of condition this rule uses

* \`phonenumber\` - Phone Number
* \`entity\` - Entity Type
* \`text\` - Text Context`
        },
        active: {
            type: 'boolean',
            description: 'Whether this rule is currently active'
        },
        from_numbers: {
            title: 'From Phone Numbers',
            description: 'List of phone numbers to match (for phone number rules)'
        },
        from_entity_types: {
            description: 'List of entity types to match (for entity rules)'
        },
        from_text_context: {
            type: 'string',
            description: 'Text context to match (for text rules)',
            maxLength: 255
        },
        target_phone_number: {
            type: 'string',
            description: 'Phone number to forward calls to',
            maxLength: 32
        },
        forwarding_message: {
            type: 'string',
            description: 'Message to play before forwarding the call',
            maxLength: 255
        },
        phone_number_uuids: {
            type: 'array',
            items: {
                type: 'string',
                format: 'uuid'
            },
            description: 'List of phone number UUIDs to associate with this rule'
        }
    },
    required: ['rule_type']
} as const;

export const $PhonebotSelfServicePlanEnum = {
    enum: ['phone_beginner_plan', 'phone_professional_plan', 'phone_professional_plus_plan', 'phone_enterprise_plan'],
    type: 'string',
    description: `* \`phone_beginner_plan\` - Phone Beginner
* \`phone_professional_plan\` - Phone Professional
* \`phone_professional_plus_plan\` - Phone Professional Plus
* \`phone_enterprise_plan\` - Phone Enterprise`
} as const;

export const $Placeholder = {
    type: 'object',
    properties: {
        key: {
            '$ref': '#/components/schemas/PlaceholderKeyEnum'
        },
        placeholder: {
            type: 'string'
        },
        label: {
            type: 'string'
        },
        html: {
            type: 'string'
        },
        is_context_aware: {
            type: 'boolean'
        },
        demo_context_dict: {
            nullable: true
        },
        rendered_demo_context_html: {
            type: 'string',
            nullable: true
        },
        variant: {
            type: 'string'
        },
        description: {
            type: 'string'
        }
    },
    required: ['description', 'html', 'is_context_aware', 'key', 'label', 'placeholder', 'variant']
} as const;

export const $PlaceholderKeyEnum = {
    enum: ['clerk_first_name', 'clerk_last_name', 'lawfirm_name', 'client_first_name', 'client_formal_greeting', 'client_last_name', 'client_title', 'clerk_signature', 'full_signature', 'lawfirm_signature', 'appointment_key_facts', 'appointment_proposal_message', 'appointment_proposal_url', 'appointment_url', 'questionnaires_and_documents'],
    type: 'string',
    description: `* \`clerk_first_name\` - clerk_first_name
* \`clerk_last_name\` - clerk_last_name
* \`lawfirm_name\` - lawfirm_name
* \`client_first_name\` - client_first_name
* \`client_formal_greeting\` - client_formal_greeting
* \`client_last_name\` - client_last_name
* \`client_title\` - client_title
* \`clerk_signature\` - clerk_signature
* \`full_signature\` - full_signature
* \`lawfirm_signature\` - lawfirm_signature
* \`appointment_key_facts\` - appointment_key_facts
* \`appointment_proposal_message\` - appointment_proposal_message
* \`appointment_proposal_url\` - appointment_proposal_url
* \`appointment_url\` - appointment_url
* \`questionnaires_and_documents\` - questionnaires_and_documents`
} as const;

export const $PlaceholderSuggestion = {
    type: 'object',
    title: 'PlaceholderSuggestion',
    properties: {
        suggested_value: {
            type: 'string'
        },
        score: {
            type: 'number'
        }
    },
    required: ['suggested_value', 'score']
} as const;

export const $PlaceholderValueRequest = {
    type: 'object',
    properties: {
        placeholder: {
            type: 'string',
            minLength: 1
        },
        value: {
            type: 'string',
            minLength: 1
        }
    },
    required: ['placeholder', 'value']
} as const;

export const $PlaceholderValueSuggestions = {
    type: 'object',
    title: 'PlaceholderValueSuggestions',
    properties: {
        placeholder_variable: {
            type: 'string'
        },
        german_label: {
            type: 'string',
            nullable: true
        },
        english_label: {
            type: 'string',
            nullable: true
        },
        suggestions: {
            '$ref': '#/components/schemas/PlaceholderSuggestion'
        }
    },
    required: ['placeholder_variable', 'suggestions']
} as const;

export const $PlatformSyncStatusEnum = {
    enum: ['only_jupus', 'only_actaport', 'in_both', 'syncing'],
    type: 'string',
    description: `* \`only_jupus\` - Only in Jupus
* \`only_actaport\` - Only in Actaport
* \`in_both\` - In Both
* \`syncing\` - Syncing`
} as const;

export const $PreferenceSuggestionData = {
    type: 'object',
    title: 'PreferenceSuggestionData',
    properties: {
        id: {
            type: 'string'
        },
        title: {
            type: 'string'
        },
        content: {
            type: 'string'
        },
        reasoning: {
            type: 'string'
        },
        suggested_scope: {
            type: 'string'
        },
        state: {
            type: 'string'
        },
        created_preference_uuid: {
            type: 'string',
            nullable: true
        }
    },
    required: ['id', 'title', 'content', 'reasoning', 'suggested_scope', 'state']
} as const;

export const $PreferenceSuggestionDataRequest = {
    type: 'object',
    description: 'Serializer for preference suggestion data in feedback responses.',
    properties: {
        title: {
            type: 'string',
            minLength: 1,
            description: 'Suggested title for the preference'
        },
        content: {
            type: 'string',
            minLength: 1,
            description: 'Suggested content for the preference'
        },
        reasoning: {
            type: 'string',
            minLength: 1,
            description: 'AI reasoning for why this should be a preference'
        },
        suggested_scope: {
            type: 'string',
            minLength: 1,
            description: 'Suggested scope (USER, ORGANIZATION, CASE)'
        },
        source: {
            type: 'string',
            minLength: 1,
            description: 'Source of the suggestion (FEEDBACK)'
        }
    },
    required: ['content', 'reasoning', 'source', 'suggested_scope', 'title']
} as const;

export const $QuestionnaireGenerateRequest = {
    type: 'object',
    properties: {
        file: {
            type: 'string',
            format: 'binary',
            nullable: true
        },
        prompt: {
            type: 'string',
            nullable: true,
            minLength: 1
        }
    }
} as const;

export const $QuestionnaireQuestion = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string'
        },
        help: {
            type: 'string'
        },
        type: {
            '$ref': '#/components/schemas/QuestionnaireQuestionTypeEnum'
        },
        tag: {
            nullable: true,
            oneOf: [
                {
                    '$ref': '#/components/schemas/QuestionnaireQuestionTagEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                },
                {
                    '$ref': '#/components/schemas/NullEnum'
                }
            ]
        },
        tag_relationship: {
            nullable: true,
            oneOf: [
                {
                    '$ref': '#/components/schemas/TagRelationshipEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                },
                {
                    '$ref': '#/components/schemas/NullEnum'
                }
            ]
        },
        tag_number: {
            type: 'integer',
            maximum: 10,
            minimum: 1,
            nullable: true
        },
        label: {
            type: 'string'
        },
        value: {
            type: 'string',
            nullable: true
        },
        choices: {
            type: 'array',
            items: {
                type: 'string'
            }
        },
        jump_to: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/JumpTo'
            },
            nullable: true
        },
        optional: {
            type: 'boolean'
        },
        starts_ai_analysis: {
            type: 'boolean'
        }
    },
    required: ['help', 'jump_to', 'label', 'optional', 'starts_ai_analysis', 'tag', 'tag_number', 'tag_relationship', 'type', 'uuid', 'value']
} as const;

export const $QuestionnaireQuestionRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            minLength: 1
        },
        help: {
            type: 'string'
        },
        type: {
            '$ref': '#/components/schemas/QuestionnaireQuestionTypeEnum'
        },
        tag: {
            nullable: true,
            oneOf: [
                {
                    '$ref': '#/components/schemas/QuestionnaireQuestionTagEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                },
                {
                    '$ref': '#/components/schemas/NullEnum'
                }
            ]
        },
        tag_relationship: {
            nullable: true,
            oneOf: [
                {
                    '$ref': '#/components/schemas/TagRelationshipEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                },
                {
                    '$ref': '#/components/schemas/NullEnum'
                }
            ]
        },
        tag_number: {
            type: 'integer',
            maximum: 10,
            minimum: 1,
            nullable: true
        },
        label: {
            type: 'string',
            minLength: 1
        },
        value: {
            type: 'string',
            nullable: true
        },
        choices: {
            type: 'array',
            items: {
                type: 'string'
            }
        },
        jump_to: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/JumpToRequest'
            },
            nullable: true
        },
        optional: {
            type: 'boolean'
        },
        starts_ai_analysis: {
            type: 'boolean'
        }
    },
    required: ['help', 'jump_to', 'label', 'optional', 'starts_ai_analysis', 'tag', 'tag_number', 'tag_relationship', 'type', 'uuid', 'value']
} as const;

export const $QuestionnaireQuestionTagEnum = {
    enum: ['entities.field.address_line_2', 'entities.field.bank_name', 'entities.field.bic', 'entities.field.city', 'entities.field.company_legal_form', 'entities.field.company_name', 'entities.field.company_register_court', 'entities.field.company_register_number', 'entities.field.company_tax_id', 'entities.field.company_vat_id', 'entities.field.date_of_birth', 'entities.field.date_of_death', 'entities.field.email', 'entities.field.entity_type', 'entities.field.fax', 'entities.field.first_name', 'entities.field.iban', 'entities.field.institution_name', 'entities.field.is_entitled_to_deduct_vat', 'entities.field.is_valid_email', 'entities.field.is_valid_phone_number', 'entities.field.last_name', 'entities.field.legal_insurance_deductible_amount', 'entities.field.legal_insurance', 'entities.field.legal_insurance_name', 'entities.field.legal_insurance_number', 'entities.field.marital_status', 'entities.field.phone', 'entities.field.specific_title', 'entities.field.street', 'entities.field.street_number', 'entities.field.title', 'entities.field.website', 'entities.field.zip', 'law.civil_law_accessories_sold_separately', 'law.civil_law_case_number', 'law.civil_law_claim_amount', 'law.civil_law_contract_date', 'law.civil_law_contract_duration', 'law.civil_law_contract_end_date', 'law.civil_law_contract', 'law.civil_law_contract_object', 'law.civil_law_contract_start_date', 'law.civil_law_contract_value', 'law.civil_law_correspondence', 'law.civil_law_court_costs', 'law.civil_law_court_document', 'law.civil_law_court_name', 'law.civil_law_damage_amount', 'law.civil_law_damage_cause', 'law.civil_law_damage_claim', 'law.civil_law_damage_date', 'law.civil_law_damage_description', 'law.civil_law_default_interest', 'law.civil_law_defects', 'law.civil_law_defects_present', 'law.civil_law_delivery_date', 'law.civil_law_document_date', 'law.civil_law_file_reference', 'law.civil_law_handover_date', 'law.civil_law_hearing_date', 'law.civil_law_insurance_claim_number', 'law.civil_law_interest_rate', 'law.civil_law_judgment_date', 'law.civil_law_liability_percentage', 'law.civil_law_notarial_certification_date', 'law.civil_law_payment_due_date', 'law.civil_law_purchase_agreement', 'law.civil_law_purchase_contract_file_reference', 'law.civil_law_purchase_date', 'law.civil_law_purchase_object', 'law.civil_law_purchase_price_components', 'law.civil_law_purchase_price', 'law.civil_law_purchase_price_paid_amount', 'law.civil_law_purchase_price_paid_boolean', 'law.civil_law_purchase_price_paid_date', 'law.civil_law_purchase_price_paid', 'law.civil_law_purchase_price_payment_date', 'law.civil_law_subject_line', 'law.civil_law_termination_notice_period', 'law.civil_law_vehicle_make', 'law.civil_law_vehicle_mileage', 'law.civil_law_vehicle_model', 'law.civil_law_vehicle_vin', 'law.civil_law_vehicle_year', 'law.civil_law_warranty_period', 'law.criminal_law_amount_of_daily_rates', 'law.criminal_law_applicable_laws', 'law.criminal_law_charge_description', 'law.criminal_law_complaint', 'law.criminal_law_criminal_warrant', 'law.criminal_law_damage_description', 'law.criminal_law_damage_value', 'law.criminal_law_date_of_offense', 'law.criminal_law_duration_of_prison_sentence', 'law.criminal_law_evidence_location', 'law.criminal_law_evidence', 'law.criminal_law_incident_description', 'law.criminal_law_indictment_date', 'law.criminal_law_indictment_delivery_date', 'law.criminal_law_indictment', 'law.criminal_law_legal_classification_of_offense', 'law.criminal_law_means_of_evidence', 'law.criminal_law_number_of_daily_rates', 'law.criminal_law_offense_type', 'law.criminal_law_penalty_infromation', 'law.criminal_law_physical_evidence', 'law.criminal_law_place_of_offense', 'law.criminal_law_police_file_number', 'law.criminal_law_preliminary_proceedings_date', 'law.criminal_law_prison_sentence', 'law.criminal_law_probation', 'law.criminal_law_prosecution_file_number', 'law.criminal_law_report_date', 'law.criminal_law_report_time', 'law.criminal_law_time_of_offense', 'law.debt_collection_law_business_fee', 'law.debt_collection_law_case_value', 'law.debt_collection_law_invoice_amount', 'law.debt_collection_law_invoice_date', 'law.debt_collection_law_invoice_ground', 'law.debt_collection_law_invoice_lawyer', 'law.debt_collection_law_invoice', 'law.debt_collection_law_invoice_number', 'law.debt_collection_law_invoice_recipient', 'law.debt_collection_law_invoice_tax_number', 'law.debt_collection_law_lumps_sum_expenses', 'law.debt_collection_law_sales_tax', 'law.debt_collection_law_subtotal_lawyer_fees', 'law.debt_collection_law_total_amount', 'law.external_case_id', 'law.family_law_average_net_income', 'law.family_law_birth_certificate', 'law.family_law_birth_register_number', 'law.family_law_birth_register_office_location', 'law.family_law_children', 'law.family_law_date_of_marriage', 'law.family_law_divorce_application', 'law.family_law_divorce_settlement_agreement', 'law.family_law_marriage_certificate', 'law.family_law_marriage_contract_date', 'law.family_law_marriage_contract', 'law.family_law_marriage_register_number', 'law.family_law_registry_office_location', 'law.family_law_separation_date', 'law.field', 'law.general_law_amount_net', 'law.general_law_amount_total', 'law.general_law_appendices', 'law.general_law_case_number', 'law.general_law_court_costs', 'law.general_law_court_name', 'law.general_law_doc_date', 'law.general_law_due_date', 'law.general_law_file_ref', 'law.general_law_hearing_date', 'law.general_law_invoice_date', 'law.general_law_invoice_number', 'law.general_law_judgment_date', 'law.general_law_correspondence', 'law.general_law_court_document', 'law.general_law_invoice', 'law.general_law_payment_terms', 'law.general_law_prior_ref', 'law.general_law_subject', 'law.general_law_vat', 'law.generic_document', 'law.inheritance_law_certificate_of_inheritance_applicable_law', 'law.inheritance_law_certificate_of_inheritance_date_death', 'law.inheritance_law_certificate_of_inheritance_date', 'law.inheritance_law_certificate_of_inheritance', 'law.inheritance_law_certificate_of_inheritance_number', 'law.inheritance_law_certificate_of_inheritance_place_of_death', 'law.inheritance_law_death_certificate_date_death', 'law.inheritance_law_death_certificate_date', 'law.inheritance_law_death_certificate', 'law.inheritance_law_death_certificate_number', 'law.inheritance_law_death_certificate_place_death', 'law.inheritance_law_death_certificate_place', 'law.inheritance_law_death_certificate_time_death', 'law.inheritance_law_estate_inventory_amount', 'law.inheritance_law_estate_inventory_date', 'law.inheritance_law_estate_inventory_status', 'law.inheritance_law_inheritance_contract_date', 'law.inheritance_law_inheritance_contract', 'law.inheritance_law_lasting_power_of_attorney_date', 'law.inheritance_law_lasting_power_of_attorney', 'law.inheritance_law_list_of_estate', 'law.inheritance_law_living_will', 'law.inheritance_law_patient_enrollment_date', 'law.inheritance_law_testament_date', 'law.inheritance_law_will', 'law.labor_law_amount_dependent_children', 'law.labor_law_beginning_of_employment', 'law.labor_law_certificate_clause', 'law.labor_law_child_allowances', 'law.labor_law_collective_agreement', 'law.labor_law_company_agreement', 'law.labor_law_company_hearing', 'law.labor_law_dependent_children', 'law.labor_law_different_place_of_work', 'law.labor_law_disability', 'law.labor_law_employee_probation_period_end_date', 'law.labor_law_end_of_employment', 'law.labor_law_exemption_irrevocable', 'law.labor_law_exemption_revocable', 'law.labor_law_fixed_term_contract_duration', 'law.labor_law_fixed_term_contract', 'law.labor_law_grade_certificate_clause', 'law.labor_law_is_employee_in_probation_period', 'law.labor_law_job_title', 'law.labor_law_local_transfer_clause', 'law.labor_law_LTI', 'law.labor_law_married', 'law.labor_law_monthly_gross_salary', 'law.labor_law_monthly_working_days', 'law.labor_law_notice_period', 'law.labor_law_notice_period_observed', 'law.labor_law_payslip', 'law.labor_law_percent_sprinter_clause', 'law.labor_law_place_of_work', 'law.labor_law_pregnancy', 'law.labor_law_reaction_company_hering', 'law.labor_law_reason_for_termination_given', 'law.labor_law_return_of_company_property', 'law.labor_law_settlement_agreement_date', 'law.labor_law_settlement_agreement', 'law.labor_law_severance_amount', 'law.labor_law_signature_of_employer', 'law.labor_law_special_documents', 'law.labor_law_special_payments_amount', 'law.labor_law_special_payments', 'law.labor_law_special_personal_circumstances', 'law.labor_law_special_protection_against_dismissal', 'law.labor_law_special_sentence', 'law.labor_law_sprinter_clause', 'law.labor_law_termination_access_to_termination_to_employee', 'law.labor_law_termination_agreement_date', 'law.labor_law_termination_agreement', 'law.labor_law_termination_agreement_severance_pay_amount', 'law.labor_law_termination_agreement_termination_date', 'law.labor_law_termination_authorization', 'law.labor_law_termination_date_effective', 'law.labor_law_termination_date', 'law.labor_law_termination_employer_more_than_10_employees', 'law.labor_law_termination_is_agreement_severance_pay', 'law.labor_law_termination', 'law.labor_law_termination_operational_reasons', 'law.labor_law_termination_without_notice', 'law.labor_law_total_gross_salary', 'law.labor_law_vacation_days', 'law.labor_law_visum', 'law.labor_law_VSOP', 'law.labor_law_warning_letter_access_to_warning_letter_to_employee', 'law.labor_law_warning_letter_date', 'law.labor_law_warning_letter_incident_date', 'law.labor_law_warning_letter_incident_location', 'law.labor_law_warning_letter_incident_time', 'law.labor_law_warning_letter', 'law.labor_law_warning_letter_reason', 'law.labor_law_work_contract', 'law.labor_law_work_council', 'law.labor_law_work_hours_per_week', 'law.labor_law_works_council_membership', 'law.labor_law_yearly_gross_salary', 'law.labor_law_years_of_employment', 'law.medicine_law_health_insurance_letter_date', 'law.medicine_law_health_insurance_letter_decision_justification', 'law.medicine_law_health_insurance_letter_decision', 'law.medicine_law_health_insurance_letter_legal_remedy_instruction', 'law.medicine_law_health_insurance_letter', 'law.medicine_law_health_insurance_letter_reference_to_application', 'law.medicine_law_hospital_records_admission_date', 'law.medicine_law_hospital_records_diagnoses_icd_codes', 'law.medicine_law_hospital_records_discharge_date', 'law.medicine_law_hospital_records_discharge_prognosis', 'law.medicine_law_hospital_records_documented_complications', 'law.medicine_law_hospital_records', 'law.medicine_law_hospital_records_medication_during_stay', 'law.medicine_law_hospital_records_operation_date', 'law.medicine_law_hospital_records_operations', 'law.medicine_law_hospital_records_station', 'law.medicine_law_laboratory_results_examination_date', 'law.medicine_law_laboratory_results_examination_type', 'law.medicine_law_laboratory_results_further_investigation_recommendation', 'law.medicine_law_laboratory_results', 'law.medicine_law_laboratory_results_relevant_deviations', 'law.medicine_law_medical_bill_cost_bearer', 'law.medicine_law_medical_bill_invoice_date', 'law.medicine_law_medical_bill_invoice_number', 'law.medicine_law_medical_bill', 'law.medicine_law_medical_bill_payment_deadline', 'law.medicine_law_medical_bill_service_period', 'law.medicine_law_medical_bill_services_list', 'law.medicine_law_medical_bill_total_amount', 'law.medicine_law_medical_expertise_date', 'law.medicine_law_medical_expertise_justification', 'law.medicine_law_medical_expertise', 'law.medicine_law_medical_expertise_medical_assessment', 'law.medicine_law_medical_expertise_question_posed', 'law.medicine_law_medical_expertise_result', 'law.medicine_law_medical_report_complications', 'law.medicine_law_medical_report_date', 'law.medicine_law_medical_report_diagnosis_icd_code', 'law.medicine_law_medical_report_diagnosis_short_text', 'law.medicine_law_medical_report_further_treatment', 'law.medicine_law_medical_report', 'law.medicine_law_medical_report_surgery_date', 'law.medicine_law_medical_report_treatment_measures', 'law.medicine_law_medical_report_treatment_period', 'law.migration_law_approval_notice_case_number', 'law.migration_law_approval_notice_conditions', 'law.migration_law_approval_notice_decision_date', 'law.migration_law_approval_notice_issuing_authority', 'law.migration_law_approval_notice', 'law.migration_law_approval_notice_permit_type', 'law.migration_law_approval_notice_pickup_deadline', 'law.migration_law_approval_notice_validity_period', 'law.migration_law_asylum_seeker_certificate_application_number', 'law.migration_law_asylum_seeker_certificate_first_registration_date', 'law.migration_law_asylum_seeker_certificate_issue_date', 'law.migration_law_asylum_seeker_certificate_issuing_authority', 'law.migration_law_asylum_seeker_certificate', 'law.migration_law_asylum_seeker_certificate_residence_obligation', 'law.migration_law_asylum_seeker_certificate_valid_until', 'law.migration_law_asylum_seeker_certificate_work_permission', 'law.migration_law_cooperation_letter_attachments', 'law.migration_law_cooperation_letter_date', 'law.migration_law_cooperation_letter_deadlines', 'law.migration_law_cooperation_letter_file_number', 'law.migration_law_cooperation_letter', 'law.migration_law_cooperation_letter_non_cooperation_consequences', 'law.migration_law_cooperation_letter_specified_obligations', 'law.migration_law_fictional_certificate_authority', 'law.migration_law_fictional_certificate_fiction_type', 'law.migration_law_fictional_certificate_issue_date', 'law.migration_law_fictional_certificate_legal_basis', 'law.migration_law_fictional_certificate', 'law.migration_law_fictional_certificate_reason_for_issuance', 'law.migration_law_fictional_certificate_valid_until', 'law.migration_law_hearing_letter_date', 'law.migration_law_hearing_letter_intended_measure_justification', 'law.migration_law_hearing_letter_legal_advice', 'law.migration_law_hearing_letter', 'law.migration_law_hearing_letter_requested_documents', 'law.migration_law_hearing_letter_response_deadline', 'law.migration_law_other_letters_action_required', 'law.migration_law_other_letters_date', 'law.migration_law_other_letters_deadlines', 'law.migration_law_other_letters_file_number', 'law.migration_law_other_letters_issuing_authority', 'law.migration_law_other_letters_legal_basis', 'law.migration_law_other_letters', 'law.migration_law_other_letters_matter_purpose', 'law.migration_law_other_letters_subject', 'law.migration_law_rejection_notice_case_number', 'law.migration_law_rejection_notice_decision_date', 'law.migration_law_rejection_notice_legal_grounds', 'law.migration_law_rejection_notice_legal_remedy_deadline', 'law.migration_law_rejection_notice', 'law.migration_law_rejection_notice_officer_name', 'law.migration_law_rejection_notice_reasoning', 'law.migration_law_rejection_notice_signature_seal', 'law.migration_law_rejection_notice_subject', 'law.migration_law_residence_permit_conditions', 'law.migration_law_residence_permit_issue_date', 'law.migration_law_residence_permit_issuing_authority', 'law.migration_law_residence_permit', 'law.migration_law_residence_permit_national_id_number', 'law.migration_law_residence_permit_passport_number', 'law.migration_law_residence_permit_purpose', 'law.migration_law_residence_permit_type', 'law.migration_law_residence_permit_valid_until', 'law.migration_law_toleration_issue_date', 'law.migration_law_toleration_issuing_authority', 'law.migration_law_toleration_legal_basis', 'law.migration_law_toleration', 'law.migration_law_toleration_reason', 'law.migration_law_toleration_restrictions', 'law.migration_law_toleration_valid_until', 'law.real_estate_law_basic_debts_amount', 'law.real_estate_law_broker_commission_amount', 'law.real_estate_law_broker_contract_type', 'law.real_estate_law_broker_scope_of_work', 'law.real_estate_law_broker_termination_periods', 'law.real_estate_law_brokerage_contract_date', 'law.real_estate_law_brokerage_contract', 'law.real_estate_law_brokerage_fee', 'law.real_estate_law_building_dimensions', 'law.real_estate_law_building_permit_date', 'law.real_estate_law_building_permit', 'law.real_estate_law_building_permit_number', 'law.real_estate_law_building_permit_validity_duration', 'law.real_estate_law_building_plan', 'law.real_estate_law_building_restrictions_clause', 'law.real_estate_law_building_usage', 'law.real_estate_law_co_ownership_share', 'law.real_estate_law_commission_percentage', 'law.real_estate_law_contaminated_sites_clause', 'law.real_estate_law_declaration_of_division', 'law.real_estate_law_division_declaration_date', 'law.real_estate_law_encumbrance_restrictions', 'law.real_estate_law_encumbrances_section_ii', 'law.real_estate_law_encumbrances_section_iii', 'law.real_estate_law_exclusive_brokerage_contract', 'law.real_estate_law_full_repayment_date', 'law.real_estate_law_installment_amount', 'law.real_estate_law_interest_rate', 'law.real_estate_law_land_register_address', 'law.real_estate_law_land_register_city', 'law.real_estate_law_land_register_date', 'law.real_estate_law_land_register', 'law.real_estate_law_land_register_number', 'law.real_estate_law_land_register_plot_of_land', 'law.real_estate_law_legal_defects_clause', 'law.real_estate_law_loan_agreement', 'law.real_estate_law_loan_amount', 'law.real_estate_law_loan_security', 'law.real_estate_law_monument_protection_basis', 'law.real_estate_law_monument_protection_notice', 'law.real_estate_law_monument_protection_order_date', 'law.real_estate_law_monument_protection_order_number', 'law.real_estate_law_monument_protection_requirements', 'law.real_estate_law_monument_registration_date', 'law.real_estate_law_plan_author', 'law.real_estate_law_plan_designation', 'law.real_estate_law_plan_scale', 'law.real_estate_law_plot_size', 'law.real_estate_law_property_brokered_by_agent', 'law.real_estate_law_purchase_contract_amount', 'law.real_estate_law_purchase_contract_date', 'law.real_estate_law_purchase_contract_description', 'law.real_estate_law_purchase_contract', 'law.real_estate_law_purchase_contract_registration_date', 'law.real_estate_law_purchase_contract_registration_number', 'law.real_estate_law_purchase_object_rented', 'law.real_estate_law_purchase_price_loan_financed', 'law.real_estate_law_repayment_rate', 'law.real_estate_law_withdrawal_instruction_date', 'law.residential_property_law_co_ownership_shares', 'law.residential_property_law_contract_date', 'law.residential_property_law_contract', 'law.residential_property_law_inventory', 'law.residential_property_law_land_register_address', 'law.residential_property_law_land_register_city', 'law.residential_property_law_land_register_number', 'law.residential_property_law_land_register_plot_of_land', 'law.social_law_affected_benefit', 'law.social_law_application_arrival_date', 'law.social_law_application_date', 'law.social_law_application_file_reference', 'law.social_law_application_form', 'law.social_law_appointment_date', 'law.social_law_appointment_file_reference', 'law.social_law_appointment_invitation', 'law.social_law_appointment_purpose', 'law.social_law_appointment_required_documents', 'law.social_law_appointment_time', 'law.social_law_approval_file_reference', 'law.social_law_approval_internal_reference', 'law.social_law_approval_legal_basis', 'law.social_law_approval_notice_date', 'law.social_law_approval_notice', 'law.social_law_approval_period_end', 'law.social_law_approval_period_start', 'law.social_law_approved_benefit_amount', 'law.social_law_approved_benefit_period', 'law.social_law_approved_benefit_type', 'law.social_law_asset_type', 'law.social_law_attachment_list', 'law.social_law_benefit_type', 'law.social_law_change_description', 'law.social_law_change_file_reference', 'law.social_law_change_notification_date', 'law.social_law_change_notification', 'law.social_law_change_reason', 'law.social_law_creditable_income', 'law.social_law_disability_card_issue_date', 'law.social_law_disability_card', 'law.social_law_disability_card_markers', 'law.social_law_disability_card_validity_period', 'law.social_law_disability_degree', 'law.social_law_disability_file_reference', 'law.social_law_employment_income', 'law.social_law_follow_up_application_notes', 'law.social_law_hearing_file_reference', 'law.social_law_hearing_letter_date', 'law.social_law_hearing_letter', 'law.social_law_hearing_planned_administrative_act', 'law.social_law_housing_costs_amount', 'law.social_law_income_amount', 'law.social_law_income_date', 'law.social_law_income_legal_basis', 'law.social_law_income_provider', 'law.social_law_income_source', 'law.social_law_income_type', 'law.social_law_interim_legal_protection', 'law.social_law_interim_protection_affidavit', 'law.social_law_interim_protection_attachment_list', 'law.social_law_interim_protection_file_reference', 'law.social_law_interim_protection_request_date', 'law.social_law_interim_protection_request_text', 'law.social_law_interim_protection_urgency_reason', 'law.social_law_lawsuit_alternative_request', 'law.social_law_lawsuit_attachment_list', 'law.social_law_lawsuit_cost_request', 'law.social_law_lawsuit_court_file_number', 'law.social_law_lawsuit_delivery_date', 'law.social_law_lawsuit_dispute_value', 'law.social_law_lawsuit_disputed_amount', 'law.social_law_lawsuit_evidence_requests', 'law.social_law_lawsuit_file_reference', 'law.social_law_lawsuit_filing_date', 'law.social_law_lawsuit_income_amount', 'law.social_law_lawsuit_legal_basis', 'law.social_law_lawsuit_main_request', 'law.social_law_lawsuit', 'law.social_law_lawsuit_monthly_benefit_amount', 'law.social_law_lawsuit_objection_decision_date', 'law.social_law_lawsuit_objection_filing_date', 'law.social_law_lawsuit_original_decision_date', 'law.social_law_lawsuit_subject', 'law.social_law_lawsuit_type', 'law.social_law_legal_basis', 'law.social_law_medical_certificate', 'law.social_law_medical_diagnosis', 'law.social_law_medical_examination_date', 'law.social_law_medical_file_reference', 'law.social_law_medical_icd_code', 'law.social_law_medical_limitations', 'law.social_law_medical_prognosis', 'law.social_law_medical_work_capacity_relation', 'law.social_law_monthly_payment_amount', 'law.social_law_needs_cost_breakdown', 'law.social_law_needs_file_reference', 'law.social_law_needs_proof_basis', 'law.social_law_needs_proof_date', 'law.social_law_needs_proof', 'law.social_law_needs_type', 'law.social_law_notice_date', 'law.social_law_notice_of_objection_date', 'law.social_law_notice_of_objection_file_reference', 'law.social_law_notice_of_objection', 'law.social_law_notification_date', 'law.social_law_notification_legal_basis', 'law.social_law_notification_source', 'law.social_law_objection_challenged_notice', 'law.social_law_objection_date', 'law.social_law_objection_evidence', 'law.social_law_objection_file_reference', 'law.social_law_objection', 'law.social_law_objection_reasoning', 'law.social_law_objection_suspension_request', 'law.social_law_original_decision_date', 'law.social_law_other_income', 'law.social_law_own_income_amount', 'law.social_law_reclaim_amount', 'law.social_law_reclaim_file_reference', 'law.social_law_reclaim_legal_basis', 'law.social_law_reclaim_legal_norm', 'law.social_law_reclaim_notice_date', 'law.social_law_reclaim_notice', 'law.social_law_reclaim_payment_deadline', 'law.social_law_reclaim_payment_terms', 'law.social_law_regelbedarf_amount', 'law.social_law_rejection_file_reference', 'law.social_law_rejection_legal_norm', 'law.social_law_rejection_notice_date', 'law.social_law_rejection_notice', 'law.social_law_rejection_reason', 'law.social_law_residence_status', 'law.social_law_revocation_benefit_type', 'law.social_law_revocation_file_reference', 'law.social_law_revocation_legal_norm', 'law.social_law_revocation_notice_date', 'law.social_law_revocation_notice', 'law.social_law_revocation_period_end', 'law.social_law_revocation_period_start', 'law.social_law_revocation_reason', 'law.social_law_revocation_reclaim_notes', 'law.social_law_social_benefit_type', 'law.social_law_summary_grounds_opposition', 'law.social_law_total_need_amount', 'law.social_law_total_reclaim_amount', 'law.social_law_violation_type', 'law.tenancy_law_adress_rental_property', 'law.tenancy_law_advance_payment_service_charge', 'law.tenancy_law_advance_payment_service_charges', 'law.tenancy_law_bank_guarantee', 'law.tenancy_law_cash_deposit_agreed', 'law.tenancy_law_cash_deposit_payment_date', 'law.tenancy_law_competent_court', 'law.tenancy_law_cost_share', 'law.tenancy_law_cost_shares', 'law.tenancy_law_counter_number', 'law.tenancy_law_court_case_number', 'law.tenancy_law_court_proceedings_pending', 'law.tenancy_law_description_of_rental_property', 'law.tenancy_law_duration_of_lease', 'law.tenancy_law_expert_report_commission_date', 'law.tenancy_law_expert_report_damage_description', 'law.tenancy_law_expert_report_damage_number', 'law.tenancy_law_expert_report_date', 'law.tenancy_law_expert_report_inspection_date', 'law.tenancy_law_expert_report', 'law.tenancy_law_expert_report_object_address', 'law.tenancy_law_expert_report_purpose', 'law.tenancy_law_expert_report_repair_duration', 'law.tenancy_law_expert_report_subject', 'law.tenancy_law_extension_option_count', 'law.tenancy_law_extension_option_duration', 'law.tenancy_law_fixed_term_tenancy', 'law.tenancy_law_garage_available', 'law.tenancy_law_garage_costs', 'law.tenancy_law_general_status_documents', 'law.tenancy_law_gross_rent', 'law.tenancy_law_handover_counter', 'law.tenancy_law_handover_date', 'law.tenancy_law_handover_defects', 'law.tenancy_law_handover_protocol', 'law.tenancy_law_landlord_termination_given', 'law.tenancy_law_last_rent_increase_letter_date', 'law.tenancy_law_last_signature_date', 'law.tenancy_law_lease_agreement', 'law.tenancy_law_location_in_rental_property', 'law.tenancy_law_net_rent', 'law.tenancy_law_operating_costs_agreement', 'law.tenancy_law_parking_space_available', 'law.tenancy_law_parking_space_costs', 'law.tenancy_law_property_return_date', 'law.tenancy_law_rent_increase_effective_date', 'law.tenancy_law_rent_increase_notice', 'law.tenancy_law_rental_agreement_date', 'law.tenancy_law_rental_agreement_duration', 'law.tenancy_law_rental_agreement', 'law.tenancy_law_rental_agreement_validity_end', 'law.tenancy_law_rental_agreement_validity_start', 'law.tenancy_law_rental_object_size_sqm', 'law.tenancy_law_repayment', 'law.tenancy_law_repayment_period_end', 'law.tenancy_law_repayment_period_start', 'law.tenancy_law_security_deposit_additional_regulations', 'law.tenancy_law_security_deposit_amount', 'law.tenancy_law_service_charge_settlement', 'law.tenancy_law_staggered_rental_agreement', 'law.tenancy_law_start_of_lease', 'law.tenancy_law_tenancy_terminated', 'law.tenancy_law_tenancy_termination_date', 'law.tenancy_law_tenant_extension_option', 'law.tenancy_law_tenant_warned', 'law.tenancy_law_termination_declared_date', 'law.tenancy_law_termination_letter_date', 'law.tenancy_law_termination_notice', 'law.tenancy_law_termination_notice_period', 'law.tenancy_law_total_cost_service_charge', 'law.tenancy_law_total_rent', 'law.tenancy_law_unlimited_term_tenancy', 'law.tenancy_law_value_security_clause', 'law.tenancy_law_warning_letter_date', 'law.tenancy_law_warning_letter', 'law.topic', 'law.traffic_law_accident_date', 'law.traffic_law_accident_report', 'law.traffic_law_amount_of_fine', 'law.traffic_law_appeal_instruction', 'law.traffic_law_at_fault_driver_drivers_license_issued_by', 'law.traffic_law_at_fault_driver_drivers_license_valid_until', 'law.traffic_law_at_fault_driver_green_card_number', 'law.traffic_law_at_fault_driver_insurance_expiry_date', 'law.traffic_law_at_fault_driver_insurance_number', 'law.traffic_law_at_fault_driver_insurer', 'law.traffic_law_blood_alcohol_concentration', 'law.traffic_law_calculated_total_damage_costs', 'law.traffic_law_calculated_total_days', 'law.traffic_law_charges', 'law.traffic_law_cost_per_scale', 'law.traffic_law_daily_rate', 'law.traffic_law_damage_number', 'law.traffic_law_damage_scope', 'law.traffic_law_date_of_accident', 'law.traffic_law_date_of_crime', 'law.traffic_law_date_of_fine', 'law.traffic_law_date_of_infraction', 'law.traffic_law_date_of_inspection', 'law.traffic_law_date_of_issue', 'law.traffic_law_date_of_offense', 'law.traffic_law_date_of_report', 'law.traffic_law_differencial_tax', 'law.traffic_law_driver_logbook_required', 'law.traffic_law_driving_ban_duration', 'law.traffic_law_driving_ban', 'law.traffic_law_evidence_infraction', 'law.traffic_law_expert_cost', 'law.traffic_law_expert_date', 'law.traffic_law_expert_report', 'law.traffic_law_expert_report_number', 'law.traffic_law_file_number', 'law.traffic_law_fine', 'law.traffic_law_fine_notice', 'law.traffic_law_gross_gross_replacement_value', 'law.traffic_law_gross_replacement_value', 'law.traffic_law_injured', 'law.traffic_law_insurance_holder', 'law.traffic_law_insurance', 'law.traffic_law_insurance_policy_number', 'law.traffic_law_legal_basis_infraction', 'law.traffic_law_legal_basis', 'law.traffic_law_licenseplate_at_fault_driver', 'law.traffic_law_licenseplate', 'law.traffic_law_licenseplate_victim_driver', 'law.traffic_law_loss_amount_repair_case', 'law.traffic_law_loss_amount_total_damage_case', 'law.traffic_law_loss_of_use_per_day', 'law.traffic_law_mark_and_type_of_at_fault_driver', 'law.traffic_law_mark_and_type_of_victim_driver', 'law.traffic_law_merantile_value_loss', 'law.traffic_law_net_gross_replacement_value', 'law.traffic_law_net_replacement_value', 'law.traffic_law_number_of_daily_rates', 'law.traffic_law_offense_infraction_description', 'law.traffic_law_other_damages', 'law.traffic_law_payment_deadline', 'law.traffic_law_penalty_order', 'law.traffic_law_place_of_accident', 'law.traffic_law_place_of_crime', 'law.traffic_law_place_of_infraction', 'law.traffic_law_place_of_inspection', 'law.traffic_law_place_of_issue', 'law.traffic_law_place_of_offense', 'law.traffic_law_points_for_offense', 'law.traffic_law_police_case_number', 'law.traffic_law_procedure_costs', 'law.traffic_law_prosecution_number', 'law.traffic_law_regular_tax', 'law.traffic_law_repair_costs_with_vat', 'law.traffic_law_repair_costs_without_vat', 'law.traffic_law_repair_damage', 'law.traffic_law_repair_duration', 'law.traffic_law_replacement_cost', 'law.traffic_law_replacement_value', 'law.traffic_law_reregistration_cost', 'law.traffic_law_residual_value', 'law.traffic_law_speed_allowed', 'law.traffic_law_speed_driven', 'law.traffic_law_speed_too_high', 'law.traffic_law_time_of_accident', 'law.traffic_law_time_of_crime', 'law.traffic_law_time_of_infraction', 'law.traffic_law_time_of_inspection', 'law.traffic_law_time_of_issue', 'law.traffic_law_time_of_offense', 'law.traffic_law_total_damage', 'law.traffic_law_vehicle_age_months', 'law.traffic_law_vehicle_mileage', 'law.traffic_law_vehicle_type_and_brand', 'law.traffic_law_victim_driver_drivers_license_issued_by', 'law.traffic_law_victim_driver_green_card_number', 'law.traffic_law_victim_driver_insurance_expiry_date', 'law.traffic_law_victim_driver_insurance_number', 'law.traffic_law_victim_driver_insurer', 'law.traffic_law_victim_driver_license_valid_until', 'law.traffic_law_violated_section', 'law.traffic_law_violation_type', 'law.traffic_law_warning_fee_infraction', 'law.traffic_law_warning_notice'],
    type: 'string',
    description: `* \`entities.field.address_line_2\` - Adresszusatz
* \`entities.field.bank_name\` - Bankname
* \`entities.field.bic\` - BIC
* \`entities.field.city\` - Ort
* \`entities.field.company_legal_form\` - Rechtsform
* \`entities.field.company_name\` - Firmenname
* \`entities.field.company_register_court\` - Amtsgericht
* \`entities.field.company_register_number\` - Handelsregisternummer
* \`entities.field.company_tax_id\` - Steuernummer
* \`entities.field.company_vat_id\` - USt. ID
* \`entities.field.date_of_birth\` - Geburtsdatum
* \`entities.field.date_of_death\` - Sterbedatum
* \`entities.field.email\` - E-Mail
* \`entities.field.entity_type\` - Personentyp
* \`entities.field.fax\` - Fax
* \`entities.field.first_name\` - Vorname
* \`entities.field.iban\` - IBAN
* \`entities.field.institution_name\` - Name der Institution
* \`entities.field.is_entitled_to_deduct_vat\` - Vorsteuerabzugsberechtigt
* \`entities.field.is_valid_email\` - Gültige E-Mail
* \`entities.field.is_valid_phone_number\` - Gültige Telefonnummer
* \`entities.field.last_name\` - Nachname
* \`entities.field.legal_insurance_deductible_amount\` - Höhe der Selbstbeteiligung der Rechtsschutzversicherung
* \`entities.field.legal_insurance\` - Rechtsschutzversicherung
* \`entities.field.legal_insurance_name\` - Name der Rechtsschutzversicherung
* \`entities.field.legal_insurance_number\` - Nummer der Rechtsschutzversicherung
* \`entities.field.marital_status\` - Familienstand
* \`entities.field.phone\` - Telefon
* \`entities.field.specific_title\` - Titel
* \`entities.field.street\` - Straße
* \`entities.field.street_number\` - Hausnummer
* \`entities.field.title\` - Anrede
* \`entities.field.website\` - Website
* \`entities.field.zip\` - PLZ
* \`law.civil_law_accessories_sold_separately\` - Zubehör separat veräußert?
* \`law.civil_law_case_number\` - Geschäftsnummer
* \`law.civil_law_claim_amount\` - Streitwert
* \`law.civil_law_contract_date\` - Vertragsdatum
* \`law.civil_law_contract_duration\` - Vertragslaufzeit in Monaten
* \`law.civil_law_contract_end_date\` - Vertragsende
* \`law.civil_law_contract\` - Vertrag
* \`law.civil_law_contract_object\` - Vertragsgegenstand
* \`law.civil_law_contract_start_date\` - Vertragsbeginn
* \`law.civil_law_contract_value\` - Vertragswert
* \`law.civil_law_correspondence\` - Schriftverkehr
* \`law.civil_law_court_costs\` - Gerichtskosten
* \`law.civil_law_court_document\` - Gerichtsdokument
* \`law.civil_law_court_name\` - Gericht
* \`law.civil_law_damage_amount\` - Schadenshöhe
* \`law.civil_law_damage_cause\` - Schadensursache
* \`law.civil_law_damage_claim\` - Schadensersatzforderung
* \`law.civil_law_damage_date\` - Schadensdatum
* \`law.civil_law_damage_description\` - Schadensbeschreibung
* \`law.civil_law_default_interest\` - Verzugszinsen
* \`law.civil_law_defects\` - Mängel
* \`law.civil_law_defects_present\` - Sachmängel vorhanden
* \`law.civil_law_delivery_date\` - Lieferdatum
* \`law.civil_law_document_date\` - Dokumentdatum
* \`law.civil_law_file_reference\` - Aktenzeichen
* \`law.civil_law_handover_date\` - Übergabedatum
* \`law.civil_law_hearing_date\` - Verhandlungstermin
* \`law.civil_law_insurance_claim_number\` - Versicherungsschadensnummer
* \`law.civil_law_interest_rate\` - Zinssatz
* \`law.civil_law_judgment_date\` - Urteilsdatum
* \`law.civil_law_liability_percentage\` - Haftungsquote in Prozent
* \`law.civil_law_notarial_certification_date\` - Notarielle Beurkundung Datum
* \`law.civil_law_payment_due_date\` - Fälligkeitsdatum
* \`law.civil_law_purchase_agreement\` - Kaufvertrag
* \`law.civil_law_purchase_contract_file_reference\` - Kaufvertragsaktenzeichen
* \`law.civil_law_purchase_date\` - Kaufdatum
* \`law.civil_law_purchase_object\` - Kaufgegenstand
* \`law.civil_law_purchase_price_components\` - Bestandteile Kaufpreis
* \`law.civil_law_purchase_price\` - Kaufpreis
* \`law.civil_law_purchase_price_paid_amount\` - Höhe bezahlten Kaufpreises
* \`law.civil_law_purchase_price_paid_boolean\` - Kaufpreis bezahlt
* \`law.civil_law_purchase_price_paid_date\` - Datum Kaufpreis bezahlt
* \`law.civil_law_purchase_price_paid\` - Kaufpreis bezahlt
* \`law.civil_law_purchase_price_payment_date\` - Datum Zahlung Kaufpreis
* \`law.civil_law_subject_line\` - Betreff
* \`law.civil_law_termination_notice_period\` - Kündigungsfrist
* \`law.civil_law_vehicle_make\` - Fahrzeugmarke
* \`law.civil_law_vehicle_mileage\` - Kilometerstand
* \`law.civil_law_vehicle_model\` - Fahrzeugmodell
* \`law.civil_law_vehicle_vin\` - Fahrgestellnummer
* \`law.civil_law_vehicle_year\` - Baujahr
* \`law.civil_law_warranty_period\` - Gewährleistungsfrist
* \`law.criminal_law_amount_of_daily_rates\` - Betrag des Tagessatzes
* \`law.criminal_law_applicable_laws\` - Anwendbare Vorschriften
* \`law.criminal_law_charge_description\` - Anklagesatz
* \`law.criminal_law_complaint\` - Anzeige
* \`law.criminal_law_criminal_warrant\` - Strafbefehl
* \`law.criminal_law_damage_description\` - Beschreibung des Schadens
* \`law.criminal_law_damage_value\` - Schadenshöhe in EUR
* \`law.criminal_law_date_of_offense\` - Datum der Tat
* \`law.criminal_law_duration_of_prison_sentence\` - Dauer der Freiheitsstrafe
* \`law.criminal_law_evidence_location\` - Standort der Beweismittel
* \`law.criminal_law_evidence\` - Beweis
* \`law.criminal_law_incident_description\` - Sachverhalt
* \`law.criminal_law_indictment_date\` - Datum der Anklageschrift
* \`law.criminal_law_indictment_delivery_date\` - Datum der Zustellung der Anklageschrift
* \`law.criminal_law_indictment\` - Anklageschrift
* \`law.criminal_law_legal_classification_of_offense\` - Vergehen auf der Grundlage von
* \`law.criminal_law_means_of_evidence\` - Beweismittel
* \`law.criminal_law_number_of_daily_rates\` - Tagessatz
* \`law.criminal_law_offense_type\` - Art des Delikts
* \`law.criminal_law_penalty_infromation\` - Strafe
* \`law.criminal_law_physical_evidence\` - Beschreibung der Beweismittel
* \`law.criminal_law_place_of_offense\` - Ort der Tat
* \`law.criminal_law_police_file_number\` - Vorgangsnummer
* \`law.criminal_law_preliminary_proceedings_date\` - Datum der Einleitung des Ermittlungsverfahrens
* \`law.criminal_law_prison_sentence\` - Freiheitsstrafe
* \`law.criminal_law_probation\` - Bewährung
* \`law.criminal_law_prosecution_file_number\` - Aktenzeichen der Staatsanwaltschaft
* \`law.criminal_law_report_date\` - Datum der Anzeigenerstattung
* \`law.criminal_law_report_time\` - Uhrzeit der Anzeigenerstattung
* \`law.criminal_law_time_of_offense\` - Uhrzeit der Tat
* \`law.debt_collection_law_business_fee\` - 1,3 Geschäftsgebühr (Nr. 2300 VV RVG)
* \`law.debt_collection_law_case_value\` - Gegenstandswert
* \`law.debt_collection_law_invoice_amount\` - Rechnungsbetrag
* \`law.debt_collection_law_invoice_date\` - Rechnungsdatum
* \`law.debt_collection_law_invoice_ground\` - Rechnungsgrund
* \`law.debt_collection_law_invoice_lawyer\` - Rechnung Anwalt
* \`law.debt_collection_law_invoice\` - Rechnung
* \`law.debt_collection_law_invoice_number\` - Rechnungsnummer
* \`law.debt_collection_law_invoice_recipient\` - Rechnungsadressat
* \`law.debt_collection_law_invoice_tax_number\` - Steuernummer
* \`law.debt_collection_law_lumps_sum_expenses\` - Auslagenpauschale (Nr. 7002 VV RVG)
* \`law.debt_collection_law_sales_tax\` - Umsatzsteuer (19%)
* \`law.debt_collection_law_subtotal_lawyer_fees\` - Zwischensumme Netto
* \`law.debt_collection_law_total_amount\` - Gesamtbetrag
* \`law.external_case_id\` - external case id
* \`law.family_law_average_net_income\` - Durchschnittliches Nettoeinkommen
* \`law.family_law_birth_certificate\` - Geburtsurkunden
* \`law.family_law_birth_register_number\` - Geburtsurkundennummer
* \`law.family_law_birth_register_office_location\` - Standesamt Geburtsurkunde
* \`law.family_law_children\` - Kinder vorhanden
* \`law.family_law_date_of_marriage\` - Eheschließungsdatum
* \`law.family_law_divorce_application\` - Ehescheidungsantrag
* \`law.family_law_divorce_settlement_agreement\` - Scheidungsfolgenvereinbarung
* \`law.family_law_marriage_certificate\` - Eheurkunde
* \`law.family_law_marriage_contract_date\` - Ehevertragsdatum
* \`law.family_law_marriage_contract\` - Ehevertrag
* \`law.family_law_marriage_register_number\` - Eheregisternummer
* \`law.family_law_registry_office_location\` - Standesamt Ort
* \`law.family_law_separation_date\` - Trennungsdatumdatum
* \`law.field\` - Rechtsgebiet
* \`law.general_law_amount_net\` - Nettobetrag
* \`law.general_law_amount_total\` - Gesamtbetrag
* \`law.general_law_appendices\` - Anlagen
* \`law.general_law_case_number\` - Geschäftsnummer
* \`law.general_law_court_costs\` - Gerichtskosten
* \`law.general_law_court_name\` - Gericht
* \`law.general_law_doc_date\` - Dokumentendatum
* \`law.general_law_due_date\` - Fälligkeitsdatum
* \`law.general_law_file_ref\` - Aktenzeichen
* \`law.general_law_hearing_date\` - Verhandlungstermin
* \`law.general_law_invoice_date\` - Rechnungsdatum
* \`law.general_law_invoice_number\` - Rechnungsnummer
* \`law.general_law_judgment_date\` - Urteilsdatum
* \`law.general_law_correspondence\` - Schriftverkehr
* \`law.general_law_court_document\` - Gerichtsdokument
* \`law.general_law_invoice\` - Rechnung
* \`law.general_law_payment_terms\` - Zahlungsbedingungen
* \`law.general_law_prior_ref\` - Zeichen unseres Schreibens
* \`law.general_law_subject\` - Betreff
* \`law.general_law_vat\` - MwSt / Umsatzsteuer
* \`law.generic_document\` - Anderes Dokument
* \`law.inheritance_law_certificate_of_inheritance_applicable_law\` - Anwendbares Recht
* \`law.inheritance_law_certificate_of_inheritance_date_death\` - Todesdatum
* \`law.inheritance_law_certificate_of_inheritance_date\` - Datum Erbscheins
* \`law.inheritance_law_certificate_of_inheritance\` - Erbschein
* \`law.inheritance_law_certificate_of_inheritance_number\` - Nummer des Erbscheins
* \`law.inheritance_law_certificate_of_inheritance_place_of_death\` - Todesort
* \`law.inheritance_law_death_certificate_date_death\` - Todesdatum
* \`law.inheritance_law_death_certificate_date\` - Datum Sterbeurkunde
* \`law.inheritance_law_death_certificate\` - Sterbeurkunde
* \`law.inheritance_law_death_certificate_number\` - Nummer Sterbeurkunde
* \`law.inheritance_law_death_certificate_place_death\` - Ort des Todes
* \`law.inheritance_law_death_certificate_place\` - Ort Sterbeurkunde
* \`law.inheritance_law_death_certificate_time_death\` - Uhrzeit des Todes
* \`law.inheritance_law_estate_inventory_amount\` - Nettonachlass
* \`law.inheritance_law_estate_inventory_date\` - Datum Nachlassverzeichnis
* \`law.inheritance_law_estate_inventory_status\` - Güterstand
* \`law.inheritance_law_inheritance_contract_date\` - Datum des Erbvertrags
* \`law.inheritance_law_inheritance_contract\` - Erbvertrag
* \`law.inheritance_law_lasting_power_of_attorney_date\` - Datum Vorsorgevollmacht
* \`law.inheritance_law_lasting_power_of_attorney\` - Vorsorgevollmacht
* \`law.inheritance_law_list_of_estate\` - Nachlassverzeichnis
* \`law.inheritance_law_living_will\` - Patientenverfügung
* \`law.inheritance_law_patient_enrollment_date\` - Datum Patientenverfügung
* \`law.inheritance_law_testament_date\` - Datum des Testaments
* \`law.inheritance_law_will\` - Testament
* \`law.labor_law_amount_dependent_children\` - Anzahl unterhaltspflichtiger Kinder
* \`law.labor_law_beginning_of_employment\` - Datum Beginn des Arbeitsverhältnisses
* \`law.labor_law_certificate_clause\` - Zeugnisklausel
* \`law.labor_law_child_allowances\` - Kinderfreibeträge
* \`law.labor_law_collective_agreement\` - Tarifvertrag
* \`law.labor_law_company_agreement\` - Betriebsvereinbarung
* \`law.labor_law_company_hearing\` - Betriebsanhörung durchgeführt
* \`law.labor_law_dependent_children\` - Unterhaltspflichtige Kinder
* \`law.labor_law_different_place_of_work\` - Abweichender Arbeitsort
* \`law.labor_law_disability\` - Behinderung
* \`law.labor_law_employee_probation_period_end_date\` - Datum Ende der Probezeit
* \`law.labor_law_end_of_employment\` - Datum Ende des Arbeitsverhältnisses
* \`law.labor_law_exemption_irrevocable\` - Freistellung unwiderruflich
* \`law.labor_law_exemption_revocable\` - Freistellung widerruflich
* \`law.labor_law_fixed_term_contract_duration\` - Ende befristetes Arbeitsverhältnis
* \`law.labor_law_fixed_term_contract\` - Befristetes Arbeitsverhältnis
* \`law.labor_law_grade_certificate_clause\` - Note Zeugnisklausel
* \`law.labor_law_is_employee_in_probation_period\` - Arbeitnehmer in Probezeit
* \`law.labor_law_job_title\` - Berufsbezeichnung
* \`law.labor_law_local_transfer_clause\` - Örtliche Versetzungsklausel
* \`law.labor_law_LTI\` - LTI
* \`law.labor_law_married\` - Verheiratet
* \`law.labor_law_monthly_gross_salary\` - Gehalt, monatlich, brutto
* \`law.labor_law_monthly_working_days\` - Arbeitsstunden pro Monat
* \`law.labor_law_notice_period\` - Kündigungsfrist in Monaten
* \`law.labor_law_notice_period_observed\` - Kündigungsfrist eingehalten
* \`law.labor_law_payslip\` - Lohnabrechnung
* \`law.labor_law_percent_sprinter_clause\` - Prozent Sprinterklausel
* \`law.labor_law_place_of_work\` - Arbeitsort
* \`law.labor_law_pregnancy\` - Schwangerschaft
* \`law.labor_law_reaction_company_hering\` - Reaktion des Betriebsrats
* \`law.labor_law_reason_for_termination_given\` - Kündigungsgrund angegeben
* \`law.labor_law_return_of_company_property\` - Rückgabe Firmeneigentum
* \`law.labor_law_settlement_agreement_date\` - Datum Abwicklungsvertrag
* \`law.labor_law_settlement_agreement\` - Abwicklungsvertrag
* \`law.labor_law_severance_amount\` - Abfindungssumme
* \`law.labor_law_signature_of_employer\` - Unterschrift Arbeitgeber
* \`law.labor_law_special_documents\` - Besondere Dokumente
* \`law.labor_law_special_payments_amount\` - Höhe der Sonderzahlungen
* \`law.labor_law_special_payments\` - Sonderzahlungen
* \`law.labor_law_special_personal_circumstances\` - Besondere persönliche Umstände
* \`law.labor_law_special_protection_against_dismissal\` - Sonderkündigungsschutz
* \`law.labor_law_special_sentence\` - zur Vermeidung Kündigung aus dringenden betrieblichen Gründen
* \`law.labor_law_sprinter_clause\` - Sprinterklausel
* \`law.labor_law_termination_access_to_termination_to_employee\` - Datum Zugang Kündigung beim Arbeitnehmer
* \`law.labor_law_termination_agreement_date\` - Datum Aufhebungsvertrag
* \`law.labor_law_termination_agreement\` - Aufhebungsvertrag
* \`law.labor_law_termination_agreement_severance_pay_amount\` - Höhe der Abfindung
* \`law.labor_law_termination_agreement_termination_date\` - Datum Beendigung Arbeitsverhältnis
* \`law.labor_law_termination_authorization\` - Befugnis zur Kündigung
* \`law.labor_law_termination_date_effective\` - Kündigung erfolgt zu welchem Datum
* \`law.labor_law_termination_date\` - Datum Kündigung durch Arbeitgeber
* \`law.labor_law_termination_employer_more_than_10_employees\` - Arbeitgeber hat mehr als 10 Mitarbeiter
* \`law.labor_law_termination_is_agreement_severance_pay\` - Abfindung vereinbart
* \`law.labor_law_termination\` - Kündigung
* \`law.labor_law_termination_operational_reasons\` - 1a KSchG dringende betriebliche Kündigung
* \`law.labor_law_termination_without_notice\` - fristlose Kündigung
* \`law.labor_law_total_gross_salary\` - Gesamtgehalt Brutto
* \`law.labor_law_vacation_days\` - Urlaubstage
* \`law.labor_law_visum\` - Visum / Aufenthaltstitel
* \`law.labor_law_VSOP\` - VSOP
* \`law.labor_law_warning_letter_access_to_warning_letter_to_employee\` - Datum Zugang Abmahnung beim Arbeitnehmer
* \`law.labor_law_warning_letter_date\` - Datum Abmahnung
* \`law.labor_law_warning_letter_incident_date\` - Datum des Vorfalls der zur Abmahnung geführt hat
* \`law.labor_law_warning_letter_incident_location\` - Ort des Vorfalls der zur Abmahnung geführt hat
* \`law.labor_law_warning_letter_incident_time\` - Uhrzeit des Vorfalls der zur Abmahnung geführt hat
* \`law.labor_law_warning_letter\` - Abmahnung
* \`law.labor_law_warning_letter_reason\` - Grund der Abmahnung
* \`law.labor_law_work_contract\` - Arbeitsvertrag
* \`law.labor_law_work_council\` - Betriebsrat
* \`law.labor_law_work_hours_per_week\` - Arbeitsstunden pro Woche
* \`law.labor_law_works_council_membership\` - Mitgliedschaft Betriebsrat
* \`law.labor_law_yearly_gross_salary\` - Gehalt, jährlich, brutto
* \`law.labor_law_years_of_employment\` - Jahre der Betriebszugehörigkeit
* \`law.medicine_law_health_insurance_letter_date\` - Datum des Schreibens
* \`law.medicine_law_health_insurance_letter_decision_justification\` - Begründung der Entscheidung
* \`law.medicine_law_health_insurance_letter_decision\` - Entscheidung der Krankenkasse
* \`law.medicine_law_health_insurance_letter_legal_remedy_instruction\` - Rechtsbehelfsbelehrung
* \`law.medicine_law_health_insurance_letter\` - Schreiben von Krankenkasse
* \`law.medicine_law_health_insurance_letter_reference_to_application\` - Bezug auf Schreiben
* \`law.medicine_law_hospital_records_admission_date\` - Aufnahmedatum
* \`law.medicine_law_hospital_records_diagnoses_icd_codes\` - Diagnosen ICD-Codes
* \`law.medicine_law_hospital_records_discharge_date\` - Entlassungsdatum
* \`law.medicine_law_hospital_records_discharge_prognosis\` - Prognose
* \`law.medicine_law_hospital_records_documented_complications\` - Dokumentierte Komplikationen
* \`law.medicine_law_hospital_records\` - Krankenhausakte
* \`law.medicine_law_hospital_records_medication_during_stay\` - Medikation während Aufenthalt
* \`law.medicine_law_hospital_records_operation_date\` - Operation Datum
* \`law.medicine_law_hospital_records_operations\` - Operationen
* \`law.medicine_law_hospital_records_station\` - Station
* \`law.medicine_law_laboratory_results_examination_date\` - Datum der Untersuchung
* \`law.medicine_law_laboratory_results_examination_type\` - Art der Untersuchung
* \`law.medicine_law_laboratory_results_further_investigation_recommendation\` - Empfehlung zur weiteren Abklärung
* \`law.medicine_law_laboratory_results\` - Befund
* \`law.medicine_law_laboratory_results_relevant_deviations\` - Relevante Abweichungen
* \`law.medicine_law_medical_bill_cost_bearer\` - Kostenträger
* \`law.medicine_law_medical_bill_invoice_date\` - Rechnungsdatum
* \`law.medicine_law_medical_bill_invoice_number\` - Rechnungsnummer
* \`law.medicine_law_medical_bill\` - Arztrechnung
* \`law.medicine_law_medical_bill_payment_deadline\` - Zahlungsfrist
* \`law.medicine_law_medical_bill_service_period\` - Zeitraum der Leistung
* \`law.medicine_law_medical_bill_services_list\` - Auflistung der Leistungen
* \`law.medicine_law_medical_bill_total_amount\` - Gesamtsumme der Rechnung
* \`law.medicine_law_medical_expertise_date\` - Datum des Gutachtens
* \`law.medicine_law_medical_expertise_justification\` - Begründung des Ergebnisses
* \`law.medicine_law_medical_expertise\` - Medizinisches Gutachten
* \`law.medicine_law_medical_expertise_medical_assessment\` - Medizinische Einschätzung
* \`law.medicine_law_medical_expertise_question_posed\` - Fragestellung des Gutachtens
* \`law.medicine_law_medical_expertise_result\` - Ergebnis des Gutachtens
* \`law.medicine_law_medical_report_complications\` - Komplikationen
* \`law.medicine_law_medical_report_date\` - Datum des Berichts
* \`law.medicine_law_medical_report_diagnosis_icd_code\` - Diagnose ICD-Code
* \`law.medicine_law_medical_report_diagnosis_short_text\` - Diagnose Kurztext
* \`law.medicine_law_medical_report_further_treatment\` - Weitere Behandlung
* \`law.medicine_law_medical_report\` - Arztbericht
* \`law.medicine_law_medical_report_surgery_date\` - OP-Datum
* \`law.medicine_law_medical_report_treatment_measures\` - Therapie Behandlungsmaßnahmen
* \`law.medicine_law_medical_report_treatment_period\` - Zeitraum der Behandlung
* \`law.migration_law_approval_notice_case_number\` - Aktenzeichen
* \`law.migration_law_approval_notice_conditions\` - Auflagen
* \`law.migration_law_approval_notice_decision_date\` - Datum des Bescheids
* \`law.migration_law_approval_notice_issuing_authority\` - Ausstellende Behörde
* \`law.migration_law_approval_notice\` - Bewilligungsbescheid
* \`law.migration_law_approval_notice_permit_type\` - Art des Aufenthaltstitels
* \`law.migration_law_approval_notice_pickup_deadline\` - Abholfrist
* \`law.migration_law_approval_notice_validity_period\` - Gültigkeitszeitraum
* \`law.migration_law_asylum_seeker_certificate_application_number\` - Asylantragsnummer
* \`law.migration_law_asylum_seeker_certificate_first_registration_date\` - Erstregistrierung
* \`law.migration_law_asylum_seeker_certificate_issue_date\` - Ausstellungsdatum
* \`law.migration_law_asylum_seeker_certificate_issuing_authority\` - Behörde
* \`law.migration_law_asylum_seeker_certificate\` - Bescheinigung über die Aufenthaltsgestattung
* \`law.migration_law_asylum_seeker_certificate_residence_obligation\` - Wohnsitzauflage
* \`law.migration_law_asylum_seeker_certificate_valid_until\` - Gültig bis
* \`law.migration_law_asylum_seeker_certificate_work_permission\` - Arbeitserlaubnis
* \`law.migration_law_cooperation_letter_attachments\` - Anlagen / Formulare
* \`law.migration_law_cooperation_letter_date\` - Datum des Schreibens
* \`law.migration_law_cooperation_letter_deadlines\` - Fristen
* \`law.migration_law_cooperation_letter_file_number\` - Aktenzeichen
* \`law.migration_law_cooperation_letter\` - Mitwirkungspflichtschreiben
* \`law.migration_law_cooperation_letter_non_cooperation_consequences\` - Rechtsfolgen bei Nichtmitwirkung
* \`law.migration_law_cooperation_letter_specified_obligations\` - Benannte Mitwirkungspflichten
* \`law.migration_law_fictional_certificate_authority\` - Behörde
* \`law.migration_law_fictional_certificate_fiction_type\` - Art der Fiktion
* \`law.migration_law_fictional_certificate_issue_date\` - Ausgestellt am
* \`law.migration_law_fictional_certificate_legal_basis\` - Rechtsgrundlage
* \`law.migration_law_fictional_certificate\` - Fiktionsbescheinigung
* \`law.migration_law_fictional_certificate_reason_for_issuance\` - Zweck der Erteilung
* \`law.migration_law_fictional_certificate_valid_until\` - Gültig bis
* \`law.migration_law_hearing_letter_date\` - Datum des Schreibens
* \`law.migration_law_hearing_letter_intended_measure_justification\` - Begründung der beabsichtigten Maßnahme
* \`law.migration_law_hearing_letter_legal_advice\` - Rechtsbehelfshinweis
* \`law.migration_law_hearing_letter\` - Anhörungsschreiben
* \`law.migration_law_hearing_letter_requested_documents\` - Dokumente beizufügen
* \`law.migration_law_hearing_letter_response_deadline\` - Frist zur Stellungnahme
* \`law.migration_law_other_letters_action_required\` - Handlungsaufforderung
* \`law.migration_law_other_letters_date\` - Datum des Schreibens
* \`law.migration_law_other_letters_deadlines\` - Fristen
* \`law.migration_law_other_letters_file_number\` - Aktenzeichen / Geschäftszeichen
* \`law.migration_law_other_letters_issuing_authority\` - Absenderbehörde
* \`law.migration_law_other_letters_legal_basis\` - Rechtsgrundlage (sofern genannt)
* \`law.migration_law_other_letters\` - Sonstige Schreiben der Ausländerbehörde
* \`law.migration_law_other_letters_matter_purpose\` - Anliegen / Inhalt des Schreibens
* \`law.migration_law_other_letters_subject\` - Betreff
* \`law.migration_law_rejection_notice_case_number\` - Aktenzeichen
* \`law.migration_law_rejection_notice_decision_date\` - Datum des Bescheids
* \`law.migration_law_rejection_notice_legal_grounds\` - Gesetzesgrundlagen
* \`law.migration_law_rejection_notice_legal_remedy_deadline\` - Rechtsbehelf / Frist
* \`law.migration_law_rejection_notice\` - Ablehnungsbescheid
* \`law.migration_law_rejection_notice_officer_name\` - Name des Sachbearbeiters
* \`law.migration_law_rejection_notice_reasoning\` - Begründung
* \`law.migration_law_rejection_notice_signature_seal\` - Unterschrift / Dienstsiegel
* \`law.migration_law_rejection_notice_subject\` - Betreff
* \`law.migration_law_residence_permit_conditions\` - Auflagen / Nebenbestimmungen
* \`law.migration_law_residence_permit_issue_date\` - Ausstellungsdatum
* \`law.migration_law_residence_permit_issuing_authority\` - Behörde
* \`law.migration_law_residence_permit\` - Aufenthaltstitel
* \`law.migration_law_residence_permit_national_id_number\` - Nationale Identitätsnummer
* \`law.migration_law_residence_permit_passport_number\` - Passnummer
* \`law.migration_law_residence_permit_purpose\` - Zweck des Aufenthalts
* \`law.migration_law_residence_permit_type\` - Titelart
* \`law.migration_law_residence_permit_valid_until\` - Gültig bis
* \`law.migration_law_toleration_issue_date\` - Ausgestellt am
* \`law.migration_law_toleration_issuing_authority\` - Behörde
* \`law.migration_law_toleration_legal_basis\` - Rechtsgrundlage
* \`law.migration_law_toleration\` - Duldung
* \`law.migration_law_toleration_reason\` - Grund der Duldung
* \`law.migration_law_toleration_restrictions\` - Beschränkungen
* \`law.migration_law_toleration_valid_until\` - Gültig bis
* \`law.real_estate_law_basic_debts_amount\` - Grundschulden
* \`law.real_estate_law_broker_commission_amount\` - Provisionshöhe
* \`law.real_estate_law_broker_contract_type\` - Art des Maklervertrags
* \`law.real_estate_law_broker_scope_of_work\` - Tätigkeitsumfang
* \`law.real_estate_law_broker_termination_periods\` - Kündigungsfristen
* \`law.real_estate_law_brokerage_contract_date\` - Maklervertrag Datum
* \`law.real_estate_law_brokerage_contract\` - Maklervertrag
* \`law.real_estate_law_brokerage_fee\` - Makler Provision
* \`law.real_estate_law_building_dimensions\` - Baukörperabmessung
* \`law.real_estate_law_building_permit_date\` - Baugenehmigungsdatum
* \`law.real_estate_law_building_permit\` - Baugenehmigung
* \`law.real_estate_law_building_permit_number\` - Genehmigungsnummer
* \`law.real_estate_law_building_permit_validity_duration\` - Gültigkeitsdauer
* \`law.real_estate_law_building_plan\` - Bauplan
* \`law.real_estate_law_building_restrictions_clause\` - Regelungen zu Baulasten
* \`law.real_estate_law_building_usage\` - Gebäudenutzung
* \`law.real_estate_law_co_ownership_share\` - Miteigentumsanteil
* \`law.real_estate_law_commission_percentage\` - Provisionshöhe in %
* \`law.real_estate_law_contaminated_sites_clause\` - Regelung zu Altlasten
* \`law.real_estate_law_declaration_of_division\` - Teilungserklärung
* \`law.real_estate_law_division_declaration_date\` - Datum Teilungserklärung
* \`law.real_estate_law_encumbrance_restrictions\` - Lasten und Beschränkungen
* \`law.real_estate_law_encumbrances_section_ii\` - Belastungen Abt. II Grundbuch
* \`law.real_estate_law_encumbrances_section_iii\` - Belastungen Abt. III Grundbuch
* \`law.real_estate_law_exclusive_brokerage_contract\` - Alleinauftrag
* \`law.real_estate_law_full_repayment_date\` - vollständige Rückzahlung
* \`law.real_estate_law_installment_amount\` - Ratenhöhe
* \`law.real_estate_law_interest_rate\` - Zinssatz
* \`law.real_estate_law_land_register_address\` - Grundbuch Lage
* \`law.real_estate_law_land_register_city\` - Grundbuch Stadt
* \`law.real_estate_law_land_register_date\` - Grundbuchauszugdatum
* \`law.real_estate_law_land_register\` - Grundbuchauszug
* \`law.real_estate_law_land_register_number\` - Grundbuch Nr.
* \`law.real_estate_law_land_register_plot_of_land\` - Grundbuch Flurstück
* \`law.real_estate_law_legal_defects_clause\` - Klausel zu Rechtsmängeln
* \`law.real_estate_law_loan_agreement\` - Immobiliendarlehensvertrag
* \`law.real_estate_law_loan_amount\` - Darlehenssumme
* \`law.real_estate_law_loan_security\` - Darlehnsabsicherung
* \`law.real_estate_law_monument_protection_basis\` - Schutzgrundlage
* \`law.real_estate_law_monument_protection_notice\` - Denkmalschutzbescheid
* \`law.real_estate_law_monument_protection_order_date\` - Datum des Denkmalschutzbescheides
* \`law.real_estate_law_monument_protection_order_number\` - Bescheid - Nr.
* \`law.real_estate_law_monument_protection_requirements\` - Auflagen
* \`law.real_estate_law_monument_registration_date\` - Eintragungsdatum
* \`law.real_estate_law_plan_author\` - Planverfasser
* \`law.real_estate_law_plan_designation\` - Planbezeichnung
* \`law.real_estate_law_plan_scale\` - Maßstab
* \`law.real_estate_law_plot_size\` - Grundstücksgröße
* \`law.real_estate_law_property_brokered_by_agent\` - Objekt durch Makler vermittelt
* \`law.real_estate_law_purchase_contract_amount\` - Kaufvertragsbetrag
* \`law.real_estate_law_purchase_contract_date\` - Kaufvertragsdatum
* \`law.real_estate_law_purchase_contract_description\` - Kaufvertrag Objektbeschreibung
* \`law.real_estate_law_purchase_contract\` - Kaufvertrag
* \`law.real_estate_law_purchase_contract_registration_date\` - Kaufvertragsbeurkundungsdatum
* \`law.real_estate_law_purchase_contract_registration_number\` - Urkundenrollennummer
* \`law.real_estate_law_purchase_object_rented\` - Kaufobjekt vermietet
* \`law.real_estate_law_purchase_price_loan_financed\` - Kaufpreis durch Darlehen finanziert
* \`law.real_estate_law_repayment_rate\` - Tilgungssatz
* \`law.real_estate_law_withdrawal_instruction_date\` - Widerrufsbelehrung Datum
* \`law.residential_property_law_co_ownership_shares\` - Miteigentumsanteile
* \`law.residential_property_law_contract_date\` - Wegvertragsdatum
* \`law.residential_property_law_contract\` - Wegvertrag
* \`law.residential_property_law_inventory\` - Bestandsverzeichnis
* \`law.residential_property_law_land_register_address\` - Grundbuch Lage
* \`law.residential_property_law_land_register_city\` - Grundbuch Stadt
* \`law.residential_property_law_land_register_number\` - Grundbuch Nr.
* \`law.residential_property_law_land_register_plot_of_land\` - Grundbuch Flurstück
* \`law.social_law_affected_benefit\` - Betroffene Leistung
* \`law.social_law_application_arrival_date\` - Eingang Antrag Datum
* \`law.social_law_application_date\` - Antrag Datum
* \`law.social_law_application_file_reference\` - Aktenzeichen
* \`law.social_law_application_form\` - Antragsformular
* \`law.social_law_appointment_date\` - Termin (Datum)
* \`law.social_law_appointment_file_reference\` - Aktenzeichen
* \`law.social_law_appointment_invitation\` - Einladungstermin
* \`law.social_law_appointment_purpose\` - Zweck des Termins
* \`law.social_law_appointment_required_documents\` - Mitzubringende Unterlagen
* \`law.social_law_appointment_time\` - Termin (Uhrzeit)
* \`law.social_law_approval_file_reference\` - Aktenzeichen
* \`law.social_law_approval_internal_reference\` - Interne Referenznummer der Behörde
* \`law.social_law_approval_legal_basis\` - Rechtsgrundlage der Entscheidung
* \`law.social_law_approval_notice_date\` - Datum des Bescheids
* \`law.social_law_approval_notice\` - Bewilligungsbescheid
* \`law.social_law_approval_period_end\` - Bewilligungszeitraum Ende
* \`law.social_law_approval_period_start\` - Bewilligungszeitraum Beginn
* \`law.social_law_approved_benefit_amount\` - Bewilligte Leistung (Betrag)
* \`law.social_law_approved_benefit_period\` - Bewilligte Leistung (Zeitraum)
* \`law.social_law_approved_benefit_type\` - Bewilligte Leistung (Art)
* \`law.social_law_asset_type\` - Art des Vermögens
* \`law.social_law_attachment_list\` - Anlagenliste
* \`law.social_law_benefit_type\` - Leistungsart
* \`law.social_law_change_description\` - Beschreibung der Änderung
* \`law.social_law_change_file_reference\` - Aktenzeichen
* \`law.social_law_change_notification_date\` - Datum der Mitteilung
* \`law.social_law_change_notification\` - Änderungsmitteilung
* \`law.social_law_change_reason\` - Grund der Änderung
* \`law.social_law_creditable_income\` - Anrechenbares Einkommen
* \`law.social_law_disability_card_issue_date\` - Ausstellungsdatum
* \`law.social_law_disability_card\` - Schwerbehindertenausweis
* \`law.social_law_disability_card_markers\` - Merkzeichen
* \`law.social_law_disability_card_validity_period\` - Gültigkeitsdauer
* \`law.social_law_disability_degree\` - Grad der Behinderung (GdB)
* \`law.social_law_disability_file_reference\` - Aktenzeichen
* \`law.social_law_employment_income\` - Erwerbseinkommen
* \`law.social_law_follow_up_application_notes\` - Hinweise zu Folgeanträgen
* \`law.social_law_hearing_file_reference\` - Aktenzeichen
* \`law.social_law_hearing_letter_date\` - Datum Anhörungsschreiben
* \`law.social_law_hearing_letter\` - Anhörungsschreiben
* \`law.social_law_hearing_planned_administrative_act\` - Geplanter Verwaltungsakt
* \`law.social_law_housing_costs_amount\` - Kosten für Unterkunft und Heizung
* \`law.social_law_income_amount\` - Einkommensbetrag
* \`law.social_law_income_date\` - Datum der Einnahme
* \`law.social_law_income_legal_basis\` - Rechtsgrundlage Einkommensberücksichtigung
* \`law.social_law_income_provider\` - Einkommensgeber
* \`law.social_law_income_source\` - Einkommensquelle
* \`law.social_law_income_type\` - Art des Einkommens
* \`law.social_law_interim_legal_protection\` - Antrag auf einstweiligen Rechtsschutz
* \`law.social_law_interim_protection_affidavit\` - Eidesstattliche Versicherung
* \`law.social_law_interim_protection_attachment_list\` - Anlagenliste
* \`law.social_law_interim_protection_file_reference\` - Aktenzeichen
* \`law.social_law_interim_protection_request_date\` - Datum des Antrags
* \`law.social_law_interim_protection_request_text\` - Antragstext
* \`law.social_law_interim_protection_urgency_reason\` - Dringlichkeitsbegründung
* \`law.social_law_lawsuit_alternative_request\` - Hilfsantrag
* \`law.social_law_lawsuit_attachment_list\` - Anlagenliste
* \`law.social_law_lawsuit_cost_request\` - Kostenantrag
* \`law.social_law_lawsuit_court_file_number\` - BG-Nummer
* \`law.social_law_lawsuit_delivery_date\` - Zustellungsdatum
* \`law.social_law_lawsuit_dispute_value\` - Streitwert
* \`law.social_law_lawsuit_disputed_amount\` - Streitiger Betrag
* \`law.social_law_lawsuit_evidence_requests\` - Beweisanträge
* \`law.social_law_lawsuit_file_reference\` - Aktenzeichen
* \`law.social_law_lawsuit_filing_date\` - Datum der Klageerhebung
* \`law.social_law_lawsuit_income_amount\` - Einkommensbetrag
* \`law.social_law_lawsuit_legal_basis\` - Rechtliche Grundlage der Klage
* \`law.social_law_lawsuit_main_request\` - Hauptantrag
* \`law.social_law_lawsuit\` - Klage (Sozialgericht)
* \`law.social_law_lawsuit_monthly_benefit_amount\` - Monatliche Leistung
* \`law.social_law_lawsuit_objection_decision_date\` - Datum des Widerspruchsbescheids
* \`law.social_law_lawsuit_objection_filing_date\` - Datum der Widerspruchseinlegung
* \`law.social_law_lawsuit_original_decision_date\` - Datum des ursprünglichen Bescheids
* \`law.social_law_lawsuit_subject\` - Gegenstand des Verfahrens
* \`law.social_law_lawsuit_type\` - Art der Klage
* \`law.social_law_legal_basis\` - Rechtsgrundlage
* \`law.social_law_medical_certificate\` - Ärztliches Attest / Medizinisches Gutachten
* \`law.social_law_medical_diagnosis\` - Medizinische Diagnose
* \`law.social_law_medical_examination_date\` - Untersuchungsdatum
* \`law.social_law_medical_file_reference\` - Aktenzeichen
* \`law.social_law_medical_icd_code\` - ICD-Code
* \`law.social_law_medical_limitations\` - Einschränkungen
* \`law.social_law_medical_prognosis\` - Prognose
* \`law.social_law_medical_work_capacity_relation\` - Bezug zur Leistungsfähigkeit
* \`law.social_law_monthly_payment_amount\` - Monatliche Leistung
* \`law.social_law_needs_cost_breakdown\` - Kostenaufstellung
* \`law.social_law_needs_file_reference\` - Aktenzeichen
* \`law.social_law_needs_proof_basis\` - Nachweisgrundlage
* \`law.social_law_needs_proof_date\` - Datum Bedarfsnachweis
* \`law.social_law_needs_proof\` - Bedarfsnachweis
* \`law.social_law_needs_type\` - Art des Bedarfs
* \`law.social_law_notice_date\` - Bescheid Datum
* \`law.social_law_notice_of_objection_date\` - Widerspruchbescheid Datum
* \`law.social_law_notice_of_objection_file_reference\` - Aktenzeichen
* \`law.social_law_notice_of_objection\` - Widerspruchbescheid
* \`law.social_law_notification_date\` - Datum der Kenntnisnahme
* \`law.social_law_notification_legal_basis\` - Rechtsgrundlage Mitteilungspflicht
* \`law.social_law_notification_source\` - Quelle der Kenntnisnahme
* \`law.social_law_objection_challenged_notice\` - Angegriffener Bescheid
* \`law.social_law_objection_date\` - Datum des Widerspruchs
* \`law.social_law_objection_evidence\` - Beweismittel
* \`law.social_law_objection_file_reference\` - Aktenzeichen (des angegriffenen Bescheids)
* \`law.social_law_objection\` - Widerspruch
* \`law.social_law_objection_reasoning\` - Widerspruchsbegründung
* \`law.social_law_objection_suspension_request\` - Antrag auf Aussetzung der Vollziehung
* \`law.social_law_original_decision_date\` - Datum des ursprünglichen Bescheids
* \`law.social_law_other_income\` - Sonstiges Einkommen
* \`law.social_law_own_income_amount\` - Höhe eigenes Einkommen
* \`law.social_law_reclaim_amount\` - Rückforderungsbetrag
* \`law.social_law_reclaim_file_reference\` - Aktenzeichen
* \`law.social_law_reclaim_legal_basis\` - Rechtsgrundlage Erstattung
* \`law.social_law_reclaim_legal_norm\` - Rechtsnorm
* \`law.social_law_reclaim_notice_date\` - Datum des Bescheids
* \`law.social_law_reclaim_notice\` - Rückforderungsbescheid
* \`law.social_law_reclaim_payment_deadline\` -  Datum Zahlungsfrist
* \`law.social_law_reclaim_payment_terms\` - Zahlungsmodalitäten
* \`law.social_law_regelbedarf_amount\` - Regelbedarf
* \`law.social_law_rejection_file_reference\` - Aktenzeichen
* \`law.social_law_rejection_legal_norm\` - Rechtsnorm
* \`law.social_law_rejection_notice_date\` - Datum des Bescheids
* \`law.social_law_rejection_notice\` - Ablehnungsbescheid
* \`law.social_law_rejection_reason\` - Ablehnungsgrund
* \`law.social_law_residence_status\` - Aufenthaltsstatus
* \`law.social_law_revocation_benefit_type\` - Leistungsart
* \`law.social_law_revocation_file_reference\` - Aktenzeichen
* \`law.social_law_revocation_legal_norm\` - Rechtsnorm
* \`law.social_law_revocation_notice_date\` - Datum des Bescheids
* \`law.social_law_revocation_notice\` - Aufhebungsbescheid
* \`law.social_law_revocation_period_end\` - Aufhebungszeitraum Ende
* \`law.social_law_revocation_period_start\` - Aufhebungszeitraum Beginn
* \`law.social_law_revocation_reason\` - Begründung der Aufhebung
* \`law.social_law_revocation_reclaim_notes\` - Hinweise zu Rückforderungen
* \`law.social_law_social_benefit_type\` - Art der Sozialleistung
* \`law.social_law_summary_grounds_opposition\` - Begründung des Widerspruchs
* \`law.social_law_total_need_amount\` - Gesamtbedarf
* \`law.social_law_total_reclaim_amount\` - Gesamtforderung
* \`law.social_law_violation_type\` - Art der Pflichtverletzung
* \`law.tenancy_law_adress_rental_property\` - Adresse des Mietobjekts
* \`law.tenancy_law_advance_payment_service_charge\` - Vorauszahlungen Nebenkostenabrechnung
* \`law.tenancy_law_advance_payment_service_charges\` - Nebenkostenvorauszahlungshöhe
* \`law.tenancy_law_bank_guarantee\` - Bankbürgschaft
* \`law.tenancy_law_cash_deposit_agreed\` - Barkaution vertraglich vereinbart
* \`law.tenancy_law_cash_deposit_payment_date\` - Barkaution Datum Zahlung
* \`law.tenancy_law_competent_court\` - Zuständiges Gericht
* \`law.tenancy_law_cost_share\` - Kostenanteil Mieter
* \`law.tenancy_law_cost_shares\` - Umlageschlüssel
* \`law.tenancy_law_counter_number\` - Zählerstandnummer
* \`law.tenancy_law_court_case_number\` - Gerichtliches Aktenzeichen
* \`law.tenancy_law_court_proceedings_pending\` - Gerichtliches Verfahren anhängig
* \`law.tenancy_law_description_of_rental_property\` - Beschreibung des Mietobjekts
* \`law.tenancy_law_duration_of_lease\` - Dauer des Pachtvertrags
* \`law.tenancy_law_expert_report_commission_date\` - Beauftragung Datum
* \`law.tenancy_law_expert_report_damage_description\` - Schaden
* \`law.tenancy_law_expert_report_damage_number\` - Schadennummer
* \`law.tenancy_law_expert_report_date\` - Datum Gutachten
* \`law.tenancy_law_expert_report_inspection_date\` - Ortsbesichtigung Datum
* \`law.tenancy_law_expert_report\` - Sachverständigengutachten
* \`law.tenancy_law_expert_report_object_address\` - Objekt Adresse
* \`law.tenancy_law_expert_report_purpose\` - Zweck des Gutachtens
* \`law.tenancy_law_expert_report_repair_duration\` - Dauer Schadenbeseitigung
* \`law.tenancy_law_expert_report_subject\` - Gegenstand
* \`law.tenancy_law_extension_option_count\` - Anzahl Verlängerungsoptionen
* \`law.tenancy_law_extension_option_duration\` - Dauer Verlängerungsoption
* \`law.tenancy_law_fixed_term_tenancy\` - Befristeter Mietvertrag
* \`law.tenancy_law_garage_available\` - Garage vorhanden
* \`law.tenancy_law_garage_costs\` - Kosten Garage
* \`law.tenancy_law_general_status_documents\` - Allgemeine Angaben zum Mietverhältnis
* \`law.tenancy_law_gross_rent\` - Bruttomiete
* \`law.tenancy_law_handover_counter\` - Zählerstand
* \`law.tenancy_law_handover_date\` - Übergabedatum
* \`law.tenancy_law_handover_defects\` - Mängel
* \`law.tenancy_law_handover_protocol\` - Übergabeprotokoll
* \`law.tenancy_law_landlord_termination_given\` - Kündigung durch Vermieter erfolgt
* \`law.tenancy_law_last_rent_increase_letter_date\` - Datum letztes Mieterhöhungsschreiben
* \`law.tenancy_law_last_signature_date\` - Datum letzte Unterschrift Mietvertrag
* \`law.tenancy_law_lease_agreement\` - Pachtvertrag
* \`law.tenancy_law_location_in_rental_property\` - Lage im Mietobjekt
* \`law.tenancy_law_net_rent\` - Nettomiete
* \`law.tenancy_law_operating_costs_agreement\` - Betriebskostenvereinbarung
* \`law.tenancy_law_parking_space_available\` - Stellplatz vorhanden
* \`law.tenancy_law_parking_space_costs\` - Kosten des Stellplatzes
* \`law.tenancy_law_property_return_date\` - Rückgabe des Objekts Datum
* \`law.tenancy_law_rent_increase_effective_date\` - Mieterhöhung wirksam geworden zum
* \`law.tenancy_law_rent_increase_notice\` - Mieterhöhungsschreiben
* \`law.tenancy_law_rental_agreement_date\` - Mietvertragsdatum
* \`law.tenancy_law_rental_agreement_duration\` - Dauer Mietvertrag
* \`law.tenancy_law_rental_agreement\` - Mietvertrag
* \`law.tenancy_law_rental_agreement_validity_end\` - Mietvertragsende
* \`law.tenancy_law_rental_agreement_validity_start\` - Mietvertragsbeginn
* \`law.tenancy_law_rental_object_size_sqm\` - Größe Mietobjekt Quadratmeter
* \`law.tenancy_law_repayment\` - Nachzahlung/Guthaben
* \`law.tenancy_law_repayment_period_end\` - Ende des Abrechnungszeitraums
* \`law.tenancy_law_repayment_period_start\` - Beginn des Abrechnungszeitraums
* \`law.tenancy_law_security_deposit_additional_regulations\` - Zusätzliche Regelungen zur Kaution
* \`law.tenancy_law_security_deposit_amount\` - Kautionshöhe
* \`law.tenancy_law_service_charge_settlement\` - Nebenkostenabrechnung
* \`law.tenancy_law_staggered_rental_agreement\` - Staffelmietvereinbarung
* \`law.tenancy_law_start_of_lease\` - Beginn des Pachtvertrags
* \`law.tenancy_law_tenancy_terminated\` - Mietverhältnis beendet
* \`law.tenancy_law_tenancy_termination_date\` - Datum Beendigung Mietverhältnisses
* \`law.tenancy_law_tenant_extension_option\` - Verlängerungsoption zugunsten Mieter
* \`law.tenancy_law_tenant_warned\` - Mieter abgemahnt
* \`law.tenancy_law_termination_declared_date\` - Datum Kündigungserklärung
* \`law.tenancy_law_termination_letter_date\` - Kündigungsschreiben vom
* \`law.tenancy_law_termination_notice\` - Kündigung
* \`law.tenancy_law_termination_notice_period\` - Kündigungsfrist
* \`law.tenancy_law_total_cost_service_charge\` - Gesamtkosten Nebenkostenabrechnung
* \`law.tenancy_law_total_rent\` - Gesamtmiete
* \`law.tenancy_law_unlimited_term_tenancy\` - Unbefristeter Mietvertrag
* \`law.tenancy_law_value_security_clause\` - Wertsicherungsklausel
* \`law.tenancy_law_warning_letter_date\` - Datum Mahnschreiben
* \`law.tenancy_law_warning_letter\` - Abmahnung
* \`law.topic\` - Rechtsthema
* \`law.traffic_law_accident_date\` - Unfallverursacher - Vers.-Schein gültig bis
* \`law.traffic_law_accident_report\` - Unfallbericht
* \`law.traffic_law_amount_of_fine\` - Bußgeldhöhe
* \`law.traffic_law_appeal_instruction\` - Rechtsbehelfsbelehrung
* \`law.traffic_law_at_fault_driver_drivers_license_issued_by\` - Unfallverursacher - Führerschein ausgestellt durch
* \`law.traffic_law_at_fault_driver_drivers_license_valid_until\` - Unfallverursacher - Führerschein gültig bis
* \`law.traffic_law_at_fault_driver_green_card_number\` - Unfallverursacher - Nr. der Grünen Karte
* \`law.traffic_law_at_fault_driver_insurance_expiry_date\` - Unfallverursacher - Vers.-Schein gültig bis
* \`law.traffic_law_at_fault_driver_insurance_number\` - Unfallverursacher - Vers.-Nr.
* \`law.traffic_law_at_fault_driver_insurer\` - Unfallverursacher - Versicherer
* \`law.traffic_law_blood_alcohol_concentration\` - Blutalkoholkonzentration
* \`law.traffic_law_calculated_total_damage_costs\` - Gesamtschadenshöhe
* \`law.traffic_law_calculated_total_days\` - Gesamttage
* \`law.traffic_law_charges\` - Tatvorwurf
* \`law.traffic_law_cost_per_scale\` - Kostenpauschale
* \`law.traffic_law_daily_rate\` - Höhe des Tagessatzes
* \`law.traffic_law_damage_number\` - Schadensnummer
* \`law.traffic_law_damage_scope\` - Schadensumfang
* \`law.traffic_law_date_of_accident\` - Unfalltag
* \`law.traffic_law_date_of_crime\` - Datum der Tat
* \`law.traffic_law_date_of_fine\` - Datum Bußgeldbescheid
* \`law.traffic_law_date_of_infraction\` - Datum der Ordnungswidrigkeit
* \`law.traffic_law_date_of_inspection\` - Besichtigungsdatum
* \`law.traffic_law_date_of_issue\` - Datum der Ausstellung
* \`law.traffic_law_date_of_offense\` - Datum der Tat
* \`law.traffic_law_date_of_report\` - Datum Sachverständigengutachten
* \`law.traffic_law_differencial_tax\` - Differenzsteuer
* \`law.traffic_law_driver_logbook_required\` - Fahrtenbuch erforderlich
* \`law.traffic_law_driving_ban_duration\` - Fahrverbot Dauer
* \`law.traffic_law_driving_ban\` - Fahrverbot verhängt
* \`law.traffic_law_evidence_infraction\` - Beweismittel
* \`law.traffic_law_expert_cost\` - Sachverständigenkosten
* \`law.traffic_law_expert_date\` - Unfallverursacher - Sachverständigengutachten
* \`law.traffic_law_expert_report\` - Sachverständigengutachten
* \`law.traffic_law_expert_report_number\` - Gutachten Nummer
* \`law.traffic_law_file_number\` - Aktenzeichen
* \`law.traffic_law_fine\` - Geldstrafe
* \`law.traffic_law_fine_notice\` - Bußgeldbescheid
* \`law.traffic_law_gross_gross_replacement_value\` - Brutto-Brutto-Wiederbeschaffungswert
* \`law.traffic_law_gross_replacement_value\` - Bruttowiederbeschaffungswert
* \`law.traffic_law_injured\` - Verletzte
* \`law.traffic_law_insurance_holder\` - Versicherungsnehmer
* \`law.traffic_law_insurance\` - Versicherung
* \`law.traffic_law_insurance_policy_number\` - Versicherungsscheinnummer
* \`law.traffic_law_legal_basis_infraction\` - Gesetzliche Grundlage
* \`law.traffic_law_legal_basis\` - Gesetzliche Grundlage
* \`law.traffic_law_licenseplate_at_fault_driver\` - KFZ-Kennzeichen des Unfallverursachers
* \`law.traffic_law_licenseplate\` - KFZ-Kennzeichen
* \`law.traffic_law_licenseplate_victim_driver\` - KFZ-Kennzeichen des Unfallgeschädigten
* \`law.traffic_law_loss_amount_repair_case\` - Restschaden Reparaturschaden
* \`law.traffic_law_loss_amount_total_damage_case\` - Restschaden Totalschaden
* \`law.traffic_law_loss_of_use_per_day\` - Nutzungsausfallentschädigung pro Tag
* \`law.traffic_law_mark_and_type_of_at_fault_driver\` - Unfallverursacher - Marke, Typ des Fahrzeugs
* \`law.traffic_law_mark_and_type_of_victim_driver\` - Unfallgeschädigter - Marke, Typ des Fahrzeugs
* \`law.traffic_law_merantile_value_loss\` - Merkantile Wertminderung
* \`law.traffic_law_net_gross_replacement_value\` - Netto-Brutto-Wiederbeschaffungswert
* \`law.traffic_law_net_replacement_value\` - Nettowiederbeschaffungswert
* \`law.traffic_law_number_of_daily_rates\` - Anzahl der Tagessätze
* \`law.traffic_law_offense_infraction_description\` - Tatbestand
* \`law.traffic_law_other_damages\` - Andere Sachschäden
* \`law.traffic_law_payment_deadline\` - Zahlungsfrist
* \`law.traffic_law_penalty_order\` - Strafbefehl
* \`law.traffic_law_place_of_accident\` - Unfallort
* \`law.traffic_law_place_of_crime\` - Ort der Tat
* \`law.traffic_law_place_of_infraction\` - Ort der Ordnungswidrigkeit
* \`law.traffic_law_place_of_inspection\` - Besichtigungsort
* \`law.traffic_law_place_of_issue\` - Ort der Ausstellung
* \`law.traffic_law_place_of_offense\` - Ort der Tat
* \`law.traffic_law_points_for_offense\` - Punkte
* \`law.traffic_law_police_case_number\` - Polizeiliches Aktenzeichen
* \`law.traffic_law_procedure_costs\` - Verfahrenskosten
* \`law.traffic_law_prosecution_number\` - Geschäftsnummer
* \`law.traffic_law_regular_tax\` - Regelsteuer
* \`law.traffic_law_repair_costs_with_vat\` - Reparaturkosten Brutto
* \`law.traffic_law_repair_costs_without_vat\` - Reparaturkosten Netto
* \`law.traffic_law_repair_damage\` - Reparaturschaden
* \`law.traffic_law_repair_duration\` - Reparaturdauer Tage
* \`law.traffic_law_replacement_cost\` - Wiederbeschaffungsaufwand
* \`law.traffic_law_replacement_value\` - Wiederbeschaffungswert
* \`law.traffic_law_reregistration_cost\` - Ummeldekosten
* \`law.traffic_law_residual_value\` - Restwert Brutto
* \`law.traffic_law_speed_allowed\` - Erlaubte Geschwindigkeit
* \`law.traffic_law_speed_driven\` - Gefahrene Geschwindigkeit
* \`law.traffic_law_speed_too_high\` - Überschreitung Geschwindigkeit
* \`law.traffic_law_time_of_accident\` - Uhrzeit Unfall
* \`law.traffic_law_time_of_crime\` - Uhrzeit der Tat
* \`law.traffic_law_time_of_infraction\` - Uhrzeit der Ordnungswidrigkeit
* \`law.traffic_law_time_of_inspection\` - Besichtigungszeit
* \`law.traffic_law_time_of_issue\` - Tag der Ausstellung
* \`law.traffic_law_time_of_offense\` - Uhrzeit der Tat
* \`law.traffic_law_total_damage\` - Totalschaden
* \`law.traffic_law_vehicle_age_months\` - Fahrzeugalter in Monaten
* \`law.traffic_law_vehicle_mileage\` - Fahrzeugleistung in km
* \`law.traffic_law_vehicle_type_and_brand\` - Fahrzeugtyp und Marke
* \`law.traffic_law_victim_driver_drivers_license_issued_by\` - Unfallgeschädigter - Führerschein ausgestellt durch
* \`law.traffic_law_victim_driver_green_card_number\` - Unfallgeschädigter - Nr. der Grünen Karte
* \`law.traffic_law_victim_driver_insurance_expiry_date\` - Unfallgeschädigter - Vers.-Schein gültig bis
* \`law.traffic_law_victim_driver_insurance_number\` - Unfallgeschädigter - Vers.-Nr.
* \`law.traffic_law_victim_driver_insurer\` - Unfallgeschädigter - Versicherer
* \`law.traffic_law_victim_driver_license_valid_until\` - Unfallgeschädigter - Führerschein gültig bis
* \`law.traffic_law_violated_section\` - Verletzte Vorschrift
* \`law.traffic_law_violation_type\` - Tatvorwurf
* \`law.traffic_law_warning_fee_infraction\` - Verwarnungsgeldbetrag
* \`law.traffic_law_warning_notice\` - Verwarnungsgeldbescheid`
} as const;

export const $QuestionnaireQuestionTypeEnum = {
    enum: ['multiselect', 'select', 'textarea', 'filefield', 'multifilefield', 'timefield', 'decimalnumberinput', 'datefield', 'textinput', 'numberinput', 'emailinput', 'phoneinput', 'urlinput', 'yesno'],
    type: 'string',
    description: `* \`multiselect\` - Multiple choice
* \`select\` - Single choice
* \`textarea\` - Long text
* \`filefield\` - File input
* \`multifilefield\` - Multi file input
* \`timefield\` - Time field
* \`decimalnumberinput\` - Decimal number
* \`datefield\` - Date
* \`textinput\` - Short text
* \`numberinput\` - Number
* \`emailinput\` - Email
* \`phoneinput\` - Phone
* \`urlinput\` - URL
* \`yesno\` - Yes/No`
} as const;

export const $QuestionnaireSection = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string'
        },
        items: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/QuestionnaireQuestion'
            }
        },
        title: {
            type: 'string'
        },
        type: {
            allOf: [
                {
                    '$ref': '#/components/schemas/QuestionnaireSectionTypeEnum'
                }
            ],
            default: 'law_specific'
        },
        participant_type: {
            type: 'string',
            nullable: true
        },
        repeatable: {
            type: 'boolean',
            default: false
        },
        min_repetitions: {
            type: 'integer',
            maximum: 100,
            minimum: 1,
            nullable: true
        },
        max_repetitions: {
            type: 'integer',
            maximum: 100,
            minimum: 1,
            nullable: true
        }
    },
    required: ['items', 'title', 'uuid']
} as const;

export const $QuestionnaireSectionRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            minLength: 1
        },
        items: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/QuestionnaireQuestionRequest'
            }
        },
        title: {
            type: 'string',
            minLength: 1
        },
        type: {
            allOf: [
                {
                    '$ref': '#/components/schemas/QuestionnaireSectionTypeEnum'
                }
            ],
            default: 'law_specific'
        },
        participant_type: {
            type: 'string',
            nullable: true
        },
        repeatable: {
            type: 'boolean',
            default: false
        },
        min_repetitions: {
            type: 'integer',
            maximum: 100,
            minimum: 1,
            nullable: true
        },
        max_repetitions: {
            type: 'integer',
            maximum: 100,
            minimum: 1,
            nullable: true
        }
    },
    required: ['items', 'title', 'uuid']
} as const;

export const $QuestionnaireSectionTypeEnum = {
    enum: ['law_specific', 'participant'],
    type: 'string',
    description: `* \`law_specific\` - Law-specific
* \`participant\` - Participant`
} as const;

export const $QuestionnaireSubmission = {
    type: 'object',
    description: 'Serializer for questionnaire submission responses.',
    properties: {
        id: {
            type: 'integer',
            readOnly: true
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        org_id: {
            type: 'integer',
            readOnly: true
        },
        user_id: {
            type: 'integer',
            nullable: true,
            readOnly: true
        },
        case_id: {
            type: 'integer',
            nullable: true,
            readOnly: true
        },
        short_id: {
            type: 'string',
            readOnly: true
        },
        third_party_access_token: {
            type: 'string',
            readOnly: true
        },
        token: {
            type: 'string',
            readOnly: true
        },
        is_third_party_questionnaire: {
            type: 'boolean',
            readOnly: true
        }
    },
    required: ['case_id', 'created_at', 'id', 'is_third_party_questionnaire', 'org_id', 'short_id', 'third_party_access_token', 'token', 'user_id']
} as const;

export const $RaMicroApiDataRequest = {
    type: 'object',
    properties: {
        entities_with_relationships: {
            type: 'array',
            items: {
                type: 'string',
                format: 'uuid'
            }
        },
        fileData: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/FileDataRequest'
            }
        }
    },
    required: ['entities_with_relationships']
} as const;

export const $RaMicroDataRequest = {
    type: 'object',
    properties: {
        entities_with_relationships: {
            type: 'array',
            items: {
                type: 'string',
                format: 'uuid'
            }
        }
    },
    required: ['entities_with_relationships']
} as const;

export const $RaMicroExportIntegrationTypeEnum = {
    enum: ['DOWNLOAD', 'OMA_EMAIL'],
    type: 'string',
    description: `* \`DOWNLOAD\` - Oma Download
* \`OMA_EMAIL\` - Oma Email`
} as const;

export const $RatingNegativeVariantEnum = {
    enum: ['INSTRUCTIONS_NOT_FOLLOWED', 'PAYLOAD_NOT_CORRECT', 'ACTION_NOT_NEEDED', 'OTHER'],
    type: 'string',
    description: `* \`INSTRUCTIONS_NOT_FOLLOWED\` - Instructions Not Followed
* \`PAYLOAD_NOT_CORRECT\` - Payload Not Correct
* \`ACTION_NOT_NEEDED\` - Action Not Needed
* \`OTHER\` - Other`
} as const;

export const $RelationshipTypeEnum = {
    enum: ['entities.opponent', 'entities.client', 'entities.other', 'entities.labor_law_employee', 'entities.labor_law_employer', 'entities.witness', 'entities.at_fault_driver', 'entities.victim_driver', 'entities.accused', 'entities.defendant', 'entities.plaintiff', 'entities.complaint', 'entities.victim', 'entities.vehicle_expert', 'entities.agency', 'entities.foreigners_authority', 'entities.vehicle_owner', 'entities.insurance', 'entities.driver', 'entities.police_officer', 'entities.police_station', 'entities.judge', 'entities.court', 'entities.prosecutor', 'entities.public_prosecutor', 'entities.opposing_counsel', 'entities.co_plaintiff', 'entities.probation_officer', 'entities.tenant', 'entities.landlord', 'entities.subtenant', 'entities.owner', 'entities.property_management', 'entities.real_estate_agent', 'entities.guarantor', 'entities.co_owner', 'entities.co_tenant', 'entities.tenants_association', 'entities.property_owners_association', 'entities.complainant', 'entities.applicant', 'entities.respondent', 'entities.principal_client', 'entities.child', 'entities.officiant', 'entities.wife', 'entities.husband', 'entities.legal_representative', 'entities.korrespondence_lawyer', 'entities.opposing_lawyer', 'entities.lawyer', 'entities.legal_expenses_insurance', 'entities.liability_insurance', 'entities.first_instance_court', 'entities.second_instance_court', 'entities.third_instance_court', 'entities.contact_person', 'entities.third_party_debtor', 'entities.road_traffic_office', 'entities.debt_collection_agency', 'entities.expert', 'entities.tax_office', 'entities.land_registry', 'entities.bank', 'entities.buyer', 'entities.dunning_court', 'entities.enforcement_court', 'entities.general_prosecutor', 'entities.seller', 'entities.expert_committee', 'entities.municipality', 'entities.administrator', 'entities.register_court', 'entities.probate_court', 'entities.registry_office', 'entities.hereditary_leaseholder', 'entities.legal_aid_court', 'entities.secondary_client', 'entities.secondary_opponent', 'entities.court_complaint', 'entities.fine_authority', 'entities.resident_registration_office', 'entities.investigator', 'entities.bailiff', 'entities.insolvency_court', 'entities.integration_office', 'entities.execution_organ', 'entities.debtor', 'entities.creditor', 'entities.lessee', 'entities.lessor', 'entities.principal', 'entities.authorized_representative', 'entities.testator', 'entities.heir', 'entities.preliminary_heir', 'entities.subsequent_heir', 'entities.curator_of_the_estate', 'entities.executor_of_the_will', 'entities.estate_administrator', 'entities.compulsory_portion_beneficiary', 'entities.notary', 'entities.trustee', 'entities.insolvency_administrator', 'entities.defendant_representative', 'entities.plaintiff_representative', 'entities.community_of_homeowners', 'entities.fractional_owner', 'entities.joint_debtor', 'entities.joint_creditor', 'entities.application_respondent', 'entities.hereditary_building_grantor', 'entities.professional_liability_insurance', 'entities.building_owners_association', 'entities.landlord_association', 'entities.landlord_community', 'entities.special_property_manager', 'entities.house_manager', 'entities.appellant', 'entities.appellee', 'entities.counter_claimant', 'entities.counter_defendant', 'entities.doctor', 'entities.legal_guardian', 'entities.guardian', 'entities.caretaker', 'entities.youth_welfare_office', 'entities.foster_parent', 'entities.parent', 'entities.maintenance_obligor', 'entities.beneficiary', 'entities.administrative_assistant', 'entities.case_worker', 'entities.managing_director', 'entities.shareholder', 'entities.supervisory_board', 'entities.commercial_agent', 'entities.limited_partner', 'entities.authorized_signatory', 'entities.social_security_office', 'entities.employment_agency', 'entities.job_center', 'entities.pension_insurance', 'entities.health_insurance', 'entities.disability_office', 'entities.social_court', 'entities.medical_service', 'entities.rehabilitation_provider', 'entities.patient', 'entities.medical_institution', 'entities.legal_assistant', 'entities.tax_authority', 'entities.affected_person'],
    type: 'string',
    description: `* \`entities.opponent\` - Opponent
* \`entities.client\` - Client
* \`entities.other\` - Other
* \`entities.labor_law_employee\` - Labor Law Employee
* \`entities.labor_law_employer\` - Labor Law Employer
* \`entities.witness\` - Witness
* \`entities.at_fault_driver\` - At Fault Driver
* \`entities.victim_driver\` - Victim Driver
* \`entities.accused\` - Accused
* \`entities.defendant\` - Defendant
* \`entities.plaintiff\` - Plaintiff
* \`entities.complaint\` - Complaint
* \`entities.victim\` - Victim
* \`entities.vehicle_expert\` - Vehicle Expert
* \`entities.agency\` - Agency
* \`entities.foreigners_authority\` - Foreigners Authority
* \`entities.vehicle_owner\` - Vehicle Owner
* \`entities.insurance\` - Insurance
* \`entities.driver\` - Driver
* \`entities.police_officer\` - Police Officer
* \`entities.police_station\` - Police Station
* \`entities.judge\` - Judge
* \`entities.court\` - Court
* \`entities.prosecutor\` - Prosecutor
* \`entities.public_prosecutor\` - Public Prosecutor
* \`entities.opposing_counsel\` - Opposing Counsel
* \`entities.co_plaintiff\` - Co Plaintiff
* \`entities.probation_officer\` - Probation Officer
* \`entities.tenant\` - Tenant
* \`entities.landlord\` - Landlord
* \`entities.subtenant\` - Subtenant
* \`entities.owner\` - Owner
* \`entities.property_management\` - Property Management
* \`entities.real_estate_agent\` - Real Estate Agent
* \`entities.guarantor\` - Guarantor
* \`entities.co_owner\` - Co Owner
* \`entities.co_tenant\` - Co Tenant
* \`entities.tenants_association\` - Tenants Association
* \`entities.property_owners_association\` - Property Owners Association
* \`entities.complainant\` - Complainant
* \`entities.applicant\` - Applicant
* \`entities.respondent\` - Respondent
* \`entities.principal_client\` - Principal Client
* \`entities.child\` - Child
* \`entities.officiant\` - Officiant
* \`entities.wife\` - Wife
* \`entities.husband\` - Husband
* \`entities.legal_representative\` - Legal Representative
* \`entities.korrespondence_lawyer\` - Korrespondence Lawyer
* \`entities.opposing_lawyer\` - Opposing Lawyer
* \`entities.lawyer\` - Lawyer
* \`entities.legal_expenses_insurance\` - Legal Expenses Insurance
* \`entities.liability_insurance\` - Liability Insurance
* \`entities.first_instance_court\` - First Instance Court
* \`entities.second_instance_court\` - Second Instance Court
* \`entities.third_instance_court\` - Third Instance Court
* \`entities.contact_person\` - Contact Person
* \`entities.third_party_debtor\` - Third Party Debtor
* \`entities.road_traffic_office\` - Road Traffic Office
* \`entities.debt_collection_agency\` - Debt Collection Agency
* \`entities.expert\` - Expert
* \`entities.tax_office\` - Tax Office
* \`entities.land_registry\` - Land Registry
* \`entities.bank\` - Bank
* \`entities.buyer\` - Buyer
* \`entities.dunning_court\` - Dunning Court
* \`entities.enforcement_court\` - Enforcement Court
* \`entities.general_prosecutor\` - General Prosecutor
* \`entities.seller\` - Seller
* \`entities.expert_committee\` - Expert Committee
* \`entities.municipality\` - Municipality
* \`entities.administrator\` - Administrator
* \`entities.register_court\` - Register Court
* \`entities.probate_court\` - Probate Court
* \`entities.registry_office\` - Registry Office
* \`entities.hereditary_leaseholder\` - Hereditary Leaseholder
* \`entities.legal_aid_court\` - Legal Aid Court
* \`entities.secondary_client\` - Secondary Client
* \`entities.secondary_opponent\` - Secondary Opponent
* \`entities.court_complaint\` - Court Complaint
* \`entities.fine_authority\` - Fine Authority
* \`entities.resident_registration_office\` - Resident Registration Office
* \`entities.investigator\` - Investigator
* \`entities.bailiff\` - Bailiff
* \`entities.insolvency_court\` - Insolvency Court
* \`entities.integration_office\` - Integration Office
* \`entities.execution_organ\` - Execution Organ
* \`entities.debtor\` - Debtor
* \`entities.creditor\` - Creditor
* \`entities.lessee\` - Lessee
* \`entities.lessor\` - Lessor
* \`entities.principal\` - Principal
* \`entities.authorized_representative\` - Authorized Representative
* \`entities.testator\` - Testator
* \`entities.heir\` - Heir
* \`entities.preliminary_heir\` - Preliminary Heir
* \`entities.subsequent_heir\` - Subsequent Heir
* \`entities.curator_of_the_estate\` - Curator Of The Estate
* \`entities.executor_of_the_will\` - Executor Of The Will
* \`entities.estate_administrator\` - Estate Administrator
* \`entities.compulsory_portion_beneficiary\` - Compulsory Portion Beneficiary
* \`entities.notary\` - Notary
* \`entities.trustee\` - Trustee
* \`entities.insolvency_administrator\` - Insolvency Administrator
* \`entities.defendant_representative\` - Defendant Representative
* \`entities.plaintiff_representative\` - Plaintiff Representative
* \`entities.community_of_homeowners\` - Community Of Homeowners
* \`entities.fractional_owner\` - Fractional Owner
* \`entities.joint_debtor\` - Joint Debtor
* \`entities.joint_creditor\` - Joint Creditor
* \`entities.application_respondent\` - Application Respondent
* \`entities.hereditary_building_grantor\` - Hereditary Building Grantor
* \`entities.professional_liability_insurance\` - Professional Liability Insurance
* \`entities.building_owners_association\` - Building Owners Association
* \`entities.landlord_association\` - Landlord Association
* \`entities.landlord_community\` - Landlord Community
* \`entities.special_property_manager\` - Special Property Manager
* \`entities.house_manager\` - House Manager
* \`entities.appellant\` - Appellant
* \`entities.appellee\` - Appellee
* \`entities.counter_claimant\` - Counter Claimant
* \`entities.counter_defendant\` - Counter Defendant
* \`entities.doctor\` - Doctor
* \`entities.legal_guardian\` - Legal Guardian
* \`entities.guardian\` - Guardian
* \`entities.caretaker\` - Caretaker
* \`entities.youth_welfare_office\` - Youth Welfare Office
* \`entities.foster_parent\` - Foster Parent
* \`entities.parent\` - Parent
* \`entities.maintenance_obligor\` - Maintenance Obligor
* \`entities.beneficiary\` - Beneficiary
* \`entities.administrative_assistant\` - Administrative Assistant
* \`entities.case_worker\` - Case Worker
* \`entities.managing_director\` - Managing Director
* \`entities.shareholder\` - Shareholder
* \`entities.supervisory_board\` - Supervisory Board
* \`entities.commercial_agent\` - Commercial Agent
* \`entities.limited_partner\` - Limited Partner
* \`entities.authorized_signatory\` - Authorized Signatory
* \`entities.social_security_office\` - Social Security Office
* \`entities.employment_agency\` - Employment Agency
* \`entities.job_center\` - Job Center
* \`entities.pension_insurance\` - Pension Insurance
* \`entities.health_insurance\` - Health Insurance
* \`entities.disability_office\` - Disability Office
* \`entities.social_court\` - Social Court
* \`entities.medical_service\` - Medical Service
* \`entities.rehabilitation_provider\` - Rehabilitation Provider
* \`entities.patient\` - Patient
* \`entities.medical_institution\` - Medical Institution
* \`entities.legal_assistant\` - Legal Assistant
* \`entities.tax_authority\` - Tax Authority
* \`entities.affected_person\` - Affected Person`
} as const;

export const $ReorganizationOperationRequest = {
    type: 'object',
    description: 'Serializer for a single reorganization operation.',
    properties: {
        operation_type: {
            allOf: [
                {
                    '$ref': '#/components/schemas/OperationTypeEnum'
                }
            ],
            description: `Type of reorganization operation

* \`merge\` - Merge
* \`split\` - Split
* \`reorganize\` - Reorganize`
        },
        old_document_uuids: {
            type: 'array',
            items: {
                type: 'string',
                format: 'uuid'
            },
            description: 'UUIDs of documents to be reorganized',
            minItems: 1
        },
        new_document_data: {
            type: 'object',
            additionalProperties: {},
            description: 'Data for the new documents after reorganization'
        }
    },
    required: ['new_document_data', 'old_document_uuids', 'operation_type']
} as const;

export const $ReplaceableVariables = {
    type: 'object',
    title: 'ReplaceableVariables',
    properties: {
        placeholders: {
            '$ref': '#/components/schemas/PlaceholderValueSuggestions',
            nullable: true
        },
        blocks: {
            '$ref': '#/components/schemas/BlockEvaluation',
            nullable: true
        }
    }
} as const;

export const $RequestForm = {
    type: 'object',
    description: 'Serializer for form data in request/form endpoint.',
    properties: {
        id: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        title: {
            type: 'string',
            maxLength: 255
        },
        description: {
            type: 'string'
        },
        tag: {
            oneOf: [
                {
                    '$ref': '#/components/schemas/FormTag'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        documentProperties: {
            allOf: [
                {
                    '$ref': '#/components/schemas/DocumentProperties'
                }
            ],
            readOnly: true
        }
    },
    required: ['documentProperties', 'id']
} as const;

export const $ResourceTypeEnum = {
    enum: ['document', 'word_template'],
    type: 'string',
    description: `* \`document\` - Document
* \`word_template\` - Word Template`
} as const;

export const $Role5ccEnum = {
    enum: ['LAWYER', 'ADMIN', 'CLERK', 'CLIENT'],
    type: 'string',
    description: `* \`LAWYER\` - Anwalt
* \`ADMIN\` - Kanzlei-Administrator
* \`CLERK\` - Sachbearbeiter
* \`CLIENT\` - Mandant`
} as const;

export const $RuleTypeEnum = {
    enum: ['phonenumber', 'entity', 'text'],
    type: 'string',
    description: `* \`phonenumber\` - Phone Number
* \`entity\` - Entity Type
* \`text\` - Text Context`
} as const;

export const $SavedResponse = {
    type: 'object',
    description: 'Serializer for the SavedResponse model.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        title: {
            type: 'string',
            maxLength: 255
        },
        content: {
            type: 'string'
        },
        session_type: {
            '$ref': '#/components/schemas/AIChatSessionTypeEnum'
        },
        org: {
            type: 'integer',
            readOnly: true
        },
        created_by_user: {
            type: 'integer',
            readOnly: true
        },
        created_by_user_name: {
            type: 'string',
            readOnly: true
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        updated_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        }
    },
    required: ['content', 'created_at', 'created_by_user', 'created_by_user_name', 'org', 'session_type', 'title', 'updated_at', 'uuid']
} as const;

export const $SavedResponseRequest = {
    type: 'object',
    description: 'Serializer for the SavedResponse model.',
    properties: {
        title: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        },
        content: {
            type: 'string',
            minLength: 1
        },
        session_type: {
            '$ref': '#/components/schemas/AIChatSessionTypeEnum'
        }
    },
    required: ['content', 'session_type', 'title']
} as const;

export const $SchemaExternalIntegrationCaseCreationRequest = {
    type: 'object',
    properties: {
        integrationType: {
            '$ref': '#/components/schemas/IntegrationTypeEnum'
        },
        mandateId: {
            type: 'integer'
        },
        integrationSpecificData: {
            '$ref': '#/components/schemas/IntegrationSpecificDataRequest'
        }
    },
    required: ['integrationSpecificData', 'integrationType', 'mandateId']
} as const;

export const $ScopeEnum = {
    enum: ['ORGANIZATION', 'USER', 'CASE'],
    type: 'string',
    description: `* \`ORGANIZATION\` - Organization
* \`USER\` - User
* \`CASE\` - Case`
} as const;

export const $SendCaseEmailRequestRequest = {
    type: 'object',
    description: 'Serializer for sending an email related to a case.',
    properties: {
        subject: {
            type: 'string',
            minLength: 1
        },
        body: {
            type: 'string',
            minLength: 1
        },
        attachments: {
            type: 'array',
            items: {}
        },
        auto_reject: {
            type: 'boolean',
            default: false
        }
    },
    required: ['body', 'subject']
} as const;

export const $SendCaseEmailResponse = {
    type: 'object',
    description: 'Response serializer for the sent email.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        from_email: {
            type: 'integer',
            readOnly: true
        },
        to: {
            type: 'array',
            items: {
                type: 'integer'
            },
            readOnly: true
        },
        cc: {
            type: 'array',
            items: {
                type: 'integer'
            },
            readOnly: true
        },
        bcc: {
            type: 'array',
            items: {
                type: 'integer'
            },
            readOnly: true
        },
        subject: {
            type: 'string',
            maxLength: 255
        },
        text: {
            type: 'string'
        },
        html: {
            type: 'string'
        },
        direction: {
            type: 'string',
            readOnly: true
        },
        source: {
            type: 'string',
            readOnly: true
        },
        sent_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        }
    },
    required: ['bcc', 'cc', 'direction', 'from_email', 'sent_at', 'source', 'subject', 'to', 'uuid']
} as const;

export const $SendToActaportError = {
    type: 'object',
    description: 'Error response serializer for send-to-actaport endpoint.',
    properties: {
        error: {
            type: 'string',
            description: 'Error message'
        }
    },
    required: ['error']
} as const;

export const $SendToActaportResponse = {
    type: 'object',
    description: 'Response serializer for send-to-actaport endpoint.',
    properties: {
        status: {
            allOf: [
                {
                    '$ref': '#/components/schemas/SendToActaportResponseStatusEnum'
                }
            ],
            description: `Status of the sync operation

* \`syncing\` - syncing
* \`already_synced\` - already_synced`
        }
    },
    required: ['status']
} as const;

export const $SendToActaportResponseStatusEnum = {
    enum: ['syncing', 'already_synced'],
    type: 'string',
    description: `* \`syncing\` - syncing
* \`already_synced\` - already_synced`
} as const;

export const $SessionGroup = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        updated_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        name: {
            type: 'string',
            description: 'Name of the session group/folder',
            maxLength: 255
        },
        description: {
            type: 'string',
            description: 'Optional description of the session group'
        },
        instructions: {
            type: 'string',
            description: 'Custom instructions for all chats in this group'
        },
        org: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        created_by_user: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        chat_sessions_count: {
            type: 'string',
            readOnly: true
        },
        documents: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/Document'
            },
            readOnly: true
        }
    },
    required: ['chat_sessions_count', 'created_at', 'created_by_user', 'documents', 'name', 'org', 'updated_at', 'uuid']
} as const;

export const $SessionGroupRequest = {
    type: 'object',
    properties: {
        name: {
            type: 'string',
            minLength: 1,
            description: 'Name of the session group/folder',
            maxLength: 255
        },
        description: {
            type: 'string',
            description: 'Optional description of the session group'
        },
        instructions: {
            type: 'string',
            description: 'Custom instructions for all chats in this group'
        }
    },
    required: ['name']
} as const;

export const $SessionStateEnum = {
    enum: ['READY', 'UPDATING_CONTEXT', 'SEARCHING_DOCUMENTS', 'REASONING'],
    type: 'string',
    description: `* \`READY\` - Ready
* \`UPDATING_CONTEXT\` - Updating Context
* \`SEARCHING_DOCUMENTS\` - Searching Documents
* \`REASONING\` - Reasoning`
} as const;

export const $ShallowCaseData = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        client: {
            '$ref': '#/components/schemas/ShallowEntity'
        },
        opponent: {
            '$ref': '#/components/schemas/ShallowEntity'
        },
        law: {
            '$ref': '#/components/schemas/ShallowLawData'
        }
    },
    required: ['client', 'law', 'opponent']
} as const;

export const $ShallowCaseDataRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        client: {
            '$ref': '#/components/schemas/ShallowEntityRequest'
        },
        opponent: {
            '$ref': '#/components/schemas/ShallowEntityRequest'
        },
        law: {
            '$ref': '#/components/schemas/ShallowLawDataRequest'
        }
    },
    required: ['client', 'law', 'opponent']
} as const;

export const $ShallowEntity = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        entity_type: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EntityTypeEnum'
                }
            ],
            title: 'Personentyp'
        },
        title: {
            title: 'Anrede',
            oneOf: [
                {
                    '$ref': '#/components/schemas/TitleEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        first_name: {
            type: 'string',
            title: 'Vorname',
            maxLength: 128
        },
        last_name: {
            type: 'string',
            title: 'Nachname',
            maxLength: 128
        },
        email: {
            type: 'string',
            format: 'email',
            title: 'E-Mail',
            maxLength: 128
        },
        phone: {
            type: 'string',
            title: 'Telefon',
            maxLength: 128
        },
        is_valid_email: {
            type: 'boolean',
            nullable: true,
            title: 'Gültige E-Mail'
        },
        is_valid_phone_number: {
            type: 'boolean',
            nullable: true,
            title: 'Gültige Telefonnummer'
        },
        street: {
            type: 'string',
            title: 'Straße',
            maxLength: 128
        },
        street_number: {
            type: 'string',
            title: 'Hausnummer',
            maxLength: 16
        },
        zip: {
            type: 'string',
            title: 'PLZ',
            maxLength: 12
        },
        city: {
            type: 'string',
            title: 'Ort',
            maxLength: 100
        },
        date_of_birth: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Geburtsdatum'
        },
        legal_insurance: {
            type: 'boolean',
            nullable: true,
            title: 'Rechtsschutzversicherung'
        },
        legal_insurance_number: {
            type: 'string',
            title: 'Nummer der Rechtsschutzversicherung',
            maxLength: 128
        },
        legal_insurance_name: {
            type: 'string',
            title: 'Name der Rechtsschutzversicherung',
            maxLength: 128
        },
        legal_insurance_deductible_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Höhe der Selbstbeteiligung der Rechtsschutzversicherung'
        },
        is_company: {
            type: 'string',
            readOnly: true
        },
        company_name: {
            type: 'string',
            title: 'Firmenname',
            maxLength: 128
        },
        company_legal_form: {
            title: 'Rechtsform',
            oneOf: [
                {
                    '$ref': '#/components/schemas/CompanyLegalFormEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        company_register_number: {
            type: 'string',
            title: 'Handelsregisternummer',
            maxLength: 128
        },
        company_register_court: {
            type: 'string',
            title: 'Amtsgericht',
            maxLength: 128
        },
        company_vat_id: {
            type: 'string',
            title: 'USt. ID',
            maxLength: 128
        },
        company_tax_id: {
            type: 'string',
            title: 'Steuernummer',
            maxLength: 128
        },
        bank_name: {
            type: 'string',
            title: 'Bankname',
            maxLength: 128
        },
        iban: {
            type: 'string',
            maxLength: 34
        },
        bic: {
            type: 'string',
            maxLength: 11
        },
        institution_name: {
            type: 'string',
            title: 'Name der Institution',
            maxLength: 128
        },
        changes: {
            type: 'array',
            items: {
                type: 'integer'
            }
        }
    },
    required: ['changes', 'entity_type', 'is_company']
} as const;

export const $ShallowEntityRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        entity_type: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EntityTypeEnum'
                }
            ],
            title: 'Personentyp'
        },
        title: {
            title: 'Anrede',
            oneOf: [
                {
                    '$ref': '#/components/schemas/TitleEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        first_name: {
            type: 'string',
            title: 'Vorname',
            maxLength: 128
        },
        last_name: {
            type: 'string',
            title: 'Nachname',
            maxLength: 128
        },
        email: {
            type: 'string',
            format: 'email',
            title: 'E-Mail',
            maxLength: 128
        },
        phone: {
            type: 'string',
            title: 'Telefon',
            maxLength: 128
        },
        is_valid_email: {
            type: 'boolean',
            nullable: true,
            title: 'Gültige E-Mail'
        },
        is_valid_phone_number: {
            type: 'boolean',
            nullable: true,
            title: 'Gültige Telefonnummer'
        },
        street: {
            type: 'string',
            title: 'Straße',
            maxLength: 128
        },
        street_number: {
            type: 'string',
            title: 'Hausnummer',
            maxLength: 16
        },
        zip: {
            type: 'string',
            title: 'PLZ',
            maxLength: 12
        },
        city: {
            type: 'string',
            title: 'Ort',
            maxLength: 100
        },
        date_of_birth: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Geburtsdatum'
        },
        legal_insurance: {
            type: 'boolean',
            nullable: true,
            title: 'Rechtsschutzversicherung'
        },
        legal_insurance_number: {
            type: 'string',
            title: 'Nummer der Rechtsschutzversicherung',
            maxLength: 128
        },
        legal_insurance_name: {
            type: 'string',
            title: 'Name der Rechtsschutzversicherung',
            maxLength: 128
        },
        legal_insurance_deductible_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Höhe der Selbstbeteiligung der Rechtsschutzversicherung'
        },
        company_name: {
            type: 'string',
            title: 'Firmenname',
            maxLength: 128
        },
        company_legal_form: {
            title: 'Rechtsform',
            oneOf: [
                {
                    '$ref': '#/components/schemas/CompanyLegalFormEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        company_register_number: {
            type: 'string',
            title: 'Handelsregisternummer',
            maxLength: 128
        },
        company_register_court: {
            type: 'string',
            title: 'Amtsgericht',
            maxLength: 128
        },
        company_vat_id: {
            type: 'string',
            title: 'USt. ID',
            maxLength: 128
        },
        company_tax_id: {
            type: 'string',
            title: 'Steuernummer',
            maxLength: 128
        },
        bank_name: {
            type: 'string',
            title: 'Bankname',
            maxLength: 128
        },
        iban: {
            type: 'string',
            maxLength: 34
        },
        bic: {
            type: 'string',
            maxLength: 11
        },
        institution_name: {
            type: 'string',
            title: 'Name der Institution',
            maxLength: 128
        },
        changes: {
            type: 'array',
            items: {
                type: 'integer'
            }
        }
    },
    required: ['changes', 'entity_type']
} as const;

export const $ShallowLawData = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        updated_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        labor_law_beginning_of_employment: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Beginn des Arbeitsverhältnisses'
        },
        labor_law_end_of_employment: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Ende des Arbeitsverhältnisses'
        },
        labor_law_job_title: {
            type: 'string',
            title: 'Berufsbezeichnung',
            maxLength: 100
        },
        labor_law_yearly_gross_salary: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Gehalt, jährlich, brutto'
        },
        labor_law_monthly_gross_salary: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Gehalt, monatlich, brutto'
        },
        labor_law_monthly_working_days: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Arbeitsstunden pro Monat'
        },
        labor_law_vacation_days: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Urlaubstage'
        },
        labor_law_work_hours_per_week: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Arbeitsstunden pro Woche'
        },
        labor_law_is_employee_in_probation_period: {
            type: 'boolean',
            nullable: true,
            title: 'Arbeitnehmer in Probezeit'
        },
        labor_law_employee_probation_period_end_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Ende der Probezeit'
        },
        labor_law_place_of_work: {
            type: 'string',
            title: 'Arbeitsort',
            maxLength: 100
        },
        labor_law_different_place_of_work: {
            type: 'string',
            title: 'Abweichender Arbeitsort',
            maxLength: 100
        },
        labor_law_fixed_term_contract: {
            type: 'boolean',
            nullable: true,
            title: 'Befristetes Arbeitsverhältnis'
        },
        labor_law_fixed_term_contract_duration: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Ende befristetes Arbeitsverhältnis'
        },
        labor_law_special_payments: {
            type: 'string',
            title: 'Sonderzahlungen',
            maxLength: 100
        },
        labor_law_special_payments_amount: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Höhe der Sonderzahlungen'
        },
        labor_law_special_protection_against_dismissal: {
            type: 'boolean',
            nullable: true,
            title: 'Sonderkündigungsschutz'
        },
        labor_law_work_council: {
            type: 'boolean',
            nullable: true,
            title: 'Betriebsrat'
        },
        labor_law_collective_agreement: {
            type: 'boolean',
            nullable: true,
            title: 'Tarifvertrag'
        },
        labor_law_company_agreement: {
            type: 'boolean',
            nullable: true,
            title: 'Betriebsvereinbarung'
        },
        labor_law_notice_period: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Kündigungsfrist in Monaten'
        },
        labor_law_signature_of_employer: {
            type: 'boolean',
            nullable: true,
            title: 'Unterschrift Arbeitgeber'
        },
        labor_law_local_transfer_clause: {
            type: 'boolean',
            nullable: true,
            title: 'Örtliche Versetzungsklausel'
        },
        labor_law_VSOP: {
            type: 'boolean',
            nullable: true,
            title: 'VSOP'
        },
        labor_law_LTI: {
            type: 'boolean',
            nullable: true,
            title: 'LTI'
        },
        labor_law_termination_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Kündigung durch Arbeitgeber'
        },
        labor_law_termination_date_effective: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Kündigung erfolgt zu welchem Datum'
        },
        labor_law_termination_employer_more_than_10_employees: {
            type: 'boolean',
            nullable: true,
            title: 'Arbeitgeber hat mehr als 10 Mitarbeiter'
        },
        labor_law_termination_access_to_termination_to_employee: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Zugang Kündigung beim Arbeitnehmer'
        },
        labor_law_notice_period_observed: {
            type: 'boolean',
            nullable: true,
            title: 'Kündigungsfrist eingehalten'
        },
        labor_law_termination_without_notice: {
            type: 'boolean',
            nullable: true,
            title: 'Fristlose Kündigung'
        },
        labor_law_reason_for_termination_given: {
            type: 'boolean',
            nullable: true,
            title: 'Kündigungsgrund angegeben'
        },
        labor_law_exemption_revocable: {
            type: 'boolean',
            nullable: true,
            title: 'Freistellung widerruflich'
        },
        labor_law_exemption_irrevocable: {
            type: 'boolean',
            nullable: true,
            title: 'Freistellung unwiderruflich'
        },
        labor_law_return_of_company_property: {
            type: 'boolean',
            nullable: true,
            title: 'Rückgabe Firmeneigentum'
        },
        labor_law_termination_operational_reasons: {
            type: 'boolean',
            nullable: true,
            title: '1a KSchG dringende betriebliche Kündigung'
        },
        labor_law_company_hearing: {
            type: 'boolean',
            nullable: true,
            title: 'Betriebsanhörung durchgeführt'
        },
        labor_law_reaction_company_hering: {
            type: 'string',
            nullable: true,
            title: 'Reaktion des Betriebsrats'
        },
        labor_law_termination_authorization: {
            type: 'string',
            nullable: true,
            title: 'Befugnis zur Kündigung'
        },
        labor_law_warning_letter_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Abmahnung'
        },
        labor_law_warning_letter_access_to_warning_letter_to_employee: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Zugang Abmahnung beim Arbeitnehmer'
        },
        labor_law_warning_letter_incident_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum des Vorfalls der zur Abmahnung geführt hat'
        },
        labor_law_warning_letter_incident_time: {
            type: 'string',
            format: 'time',
            nullable: true,
            title: 'Uhrzeit des Vorfalls der zur Abmahnung geführt hat'
        },
        labor_law_warning_letter_incident_location: {
            type: 'string',
            title: 'Ort des Vorfalls der zur Abmahnung geführt hat',
            maxLength: 100
        },
        labor_law_warning_letter_reason: {
            type: 'string',
            title: 'Grund der Abmahnung'
        },
        labor_law_termination_agreement_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Aufhebungsvertrag'
        },
        labor_law_settlement_agreement_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Abwicklungsvertrag'
        },
        labor_law_termination_agreement_termination_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Beendigung Arbeitsverhältnis'
        },
        labor_law_termination_is_agreement_severance_pay: {
            type: 'boolean',
            nullable: true,
            title: 'Abfindung vereinbart'
        },
        labor_law_termination_agreement_severance_pay_amount: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Höhe der Abfindung'
        },
        labor_law_special_sentence: {
            type: 'boolean',
            nullable: true,
            title: 'Zur Vermeidung Kündigung aus dringenden betrieblichen Gründen'
        },
        labor_law_sprinter_clause: {
            type: 'boolean',
            nullable: true,
            title: 'Sprinterklausel'
        },
        labor_law_percent_sprinter_clause: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Prozent Sprinterklausel'
        },
        labor_law_certificate_clause: {
            type: 'boolean',
            nullable: true,
            title: 'Zeugnisklausel'
        },
        labor_law_grade_certificate_clause: {
            type: 'string',
            title: 'Note Zeugnisklausel'
        },
        labor_law_child_allowances: {
            type: 'boolean',
            nullable: true,
            title: 'Kinderfreibeträge'
        },
        labor_law_married: {
            type: 'boolean',
            nullable: true,
            title: 'Verheiratet'
        },
        labor_law_dependent_children: {
            type: 'boolean',
            nullable: true,
            title: 'Unterhaltspflichtige Kinder'
        },
        labor_law_amount_dependent_children: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Anzahl unterhaltspflichtiger Kinder'
        },
        labor_law_years_of_employment: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Jahre der Betriebszugehörigkeit'
        },
        labor_law_total_gross_salary: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Gesamtgehalt Brutto'
        },
        labor_law_severance_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Abfindungssumme'
        },
        labor_law_works_council_membership: {
            type: 'boolean',
            nullable: true,
            title: 'Mitgliedschaft Betriebsrat'
        },
        labor_law_pregnancy: {
            type: 'boolean',
            nullable: true,
            title: 'Schwangerschaft'
        },
        labor_law_disability: {
            type: 'boolean',
            nullable: true,
            title: 'Behinderung'
        },
        labor_law_special_personal_circumstances: {
            type: 'boolean',
            nullable: true,
            title: 'Besondere persönliche Umstände'
        },
        traffic_law_place_of_accident: {
            type: 'string',
            title: 'Unfallort',
            maxLength: 100
        },
        traffic_law_date_of_accident: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Unfalltag'
        },
        traffic_law_time_of_accident: {
            type: 'string',
            format: 'time',
            nullable: true,
            title: 'Uhrzeit Unfall'
        },
        traffic_law_driving_ban_duration: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Fahrverbot Dauer'
        },
        traffic_law_driving_ban: {
            type: 'boolean',
            nullable: true,
            title: 'Fahrverbot verhängt'
        },
        traffic_law_licenseplate: {
            type: 'string',
            title: 'KFZ-Kennzeichen',
            maxLength: 100
        },
        traffic_law_vehicle_type_and_brand: {
            type: 'string',
            title: 'Fahrzeugtyp und Marke',
            maxLength: 100
        },
        traffic_law_amount_of_fine: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Bußgeldhöhe'
        },
        traffic_law_date_of_fine: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Bußgeldbescheid'
        },
        traffic_law_speed_allowed: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Erlaubte Geschwindigkeit'
        },
        traffic_law_speed_driven: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Gefahrene Geschwindigkeit'
        },
        traffic_law_speed_too_high: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Überschreitung Geschwindigkeit'
        },
        traffic_law_points_for_offense: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Punkte'
        },
        traffic_law_date_of_offense: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum der Tat'
        },
        traffic_law_time_of_offense: {
            type: 'string',
            format: 'time',
            nullable: true,
            title: 'Uhrzeit der Tat'
        },
        traffic_law_place_of_offense: {
            type: 'string',
            title: 'Ort der Tat',
            maxLength: 100
        },
        traffic_law_violation_type: {
            type: 'string',
            title: 'Tatvorwurf',
            maxLength: 100
        },
        traffic_law_violated_section: {
            type: 'string',
            title: 'Verletzte Vorschrift',
            maxLength: 100
        },
        traffic_law_file_number: {
            type: 'string',
            title: 'Aktenzeichen',
            maxLength: 100
        },
        traffic_law_driver_logbook_required: {
            type: 'boolean',
            nullable: true,
            title: 'Fahrtenbuch erforderlich'
        },
        traffic_law_licenseplate_at_fault_driver: {
            type: 'string',
            title: 'KFZ-Kennzeichen des Unfallverursachers',
            maxLength: 100
        },
        traffic_law_licenseplate_victim_driver: {
            type: 'string',
            title: 'KFZ-Kennzeichen des Unfallgeschädigten',
            maxLength: 100
        },
        traffic_law_injured: {
            type: 'boolean',
            nullable: true,
            title: 'Verletzte'
        },
        traffic_law_other_damages: {
            type: 'boolean',
            nullable: true,
            title: 'Andere Sachschäden'
        },
        traffic_law_mark_and_type_of_at_fault_driver: {
            type: 'string',
            title: 'Unfallverursacher - Marke, Typ des Fahrzeugs',
            maxLength: 100
        },
        traffic_law_mark_and_type_of_victim_driver: {
            type: 'string',
            title: 'Unfallgeschädigter - Marke, Typ des Fahrzeugs',
            maxLength: 100
        },
        traffic_law_at_fault_driver_insurer: {
            type: 'string',
            title: 'Unfallverursacher - Versicherer',
            maxLength: 100
        },
        traffic_law_victim_driver_insurer: {
            type: 'string',
            title: 'Unfallgeschädigter - Versicherer',
            maxLength: 100
        },
        traffic_law_at_fault_driver_insurance_number: {
            type: 'string',
            title: 'Unfallverursacher - Vers.-Nr.',
            maxLength: 100
        },
        traffic_law_victim_driver_insurance_number: {
            type: 'string',
            title: 'Unfallgeschädigter - Vers.-Nr.',
            maxLength: 100
        },
        traffic_law_at_fault_driver_green_card_number: {
            type: 'string',
            title: 'Unfallverursacher - Nr. der Grünen Karte',
            maxLength: 100
        },
        traffic_law_victim_driver_green_card_number: {
            type: 'string',
            title: 'Unfallgeschädigter - Nr. der Grünen Karte',
            maxLength: 100
        },
        traffic_law_at_fault_driver_insurance_expiry_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Unfallverursacher - Vers.-Schein gültig bis'
        },
        traffic_law_victim_driver_insurance_expiry_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Unfallgeschädigter - Vers.-Schein gültig bis'
        },
        traffic_law_at_fault_driver_drivers_license_issued_by: {
            type: 'string',
            title: 'Unfallverursacher - Führerschein ausgestellt durch',
            maxLength: 100
        },
        traffic_law_victim_driver_drivers_license_issued_by: {
            type: 'string',
            title: 'Unfallgeschädigter - Führerschein ausgestellt durch',
            maxLength: 100
        },
        traffic_law_at_fault_driver_drivers_license_valid_until: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Unfallverursacher - Führerschein gültig bis'
        },
        traffic_law_victim_driver_license_valid_until: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Unfallgeschädigter - Führerschein gültig bis'
        },
        traffic_law_date_of_report: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Sachverständigengutachten'
        },
        traffic_law_place_of_inspection: {
            type: 'string',
            title: 'Besichtigungsort',
            maxLength: 100
        },
        traffic_law_date_of_inspection: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Besichtigungsdatum'
        },
        traffic_law_time_of_inspection: {
            type: 'string',
            format: 'time',
            nullable: true,
            title: 'Besichtigungszeit'
        },
        traffic_law_insurance_holder: {
            type: 'string',
            title: 'Versicherungsnehmer',
            maxLength: 100
        },
        traffic_law_insurance: {
            type: 'string',
            title: 'Versicherung',
            maxLength: 100
        },
        traffic_law_police_case_number: {
            type: 'string',
            title: 'Polizeiliches Aktenzeichen',
            maxLength: 100
        },
        traffic_law_repair_costs_without_vat: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Reparaturkosten Netto'
        },
        traffic_law_repair_costs_with_vat: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Reparaturkosten Brutto'
        },
        traffic_law_replacement_value: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Wiederbeschaffungswert'
        },
        traffic_law_differencial_tax: {
            type: 'boolean',
            nullable: true,
            title: 'Differenzsteuer'
        },
        traffic_law_regular_tax: {
            type: 'boolean',
            nullable: true,
            title: 'Regelsteuer'
        },
        traffic_law_merantile_value_loss: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Merkantile Wertminderung'
        },
        traffic_law_loss_of_use_per_day: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Nutzungsausfallentschädigung pro Tag'
        },
        traffic_law_repair_duration: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Reparaturdauer Tage'
        },
        traffic_law_residual_value: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Restwert Brutto'
        },
        traffic_law_reregistration_cost: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Ummeldekosten'
        },
        traffic_law_damage_scope: {
            type: 'string',
            title: 'Schadensumfang'
        },
        traffic_law_expert_report_number: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Gutachten Nummer'
        },
        traffic_law_insurance_policy_number: {
            type: 'string',
            title: 'Versicherungsscheinnummer',
            maxLength: 100
        },
        traffic_law_damage_number: {
            type: 'string',
            title: 'Schadensnummer',
            maxLength: 100
        },
        traffic_law_expert_cost: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Sachverständigenkosten'
        },
        traffic_law_cost_per_scale: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Kostenpauschale'
        },
        traffic_law_loss_amount_repair_case: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Restschaden Reparaturschaden'
        },
        traffic_law_loss_amount_total_damage_case: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Restschaden Totalschaden'
        },
        traffic_law_replacement_cost: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Wiederbeschaffungsaufwand'
        },
        traffic_law_date_of_infraction: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum der Ordnungswidrigkeit'
        },
        traffic_law_time_of_infraction: {
            type: 'string',
            format: 'time',
            nullable: true,
            title: 'Uhrzeit der Ordnungswidrigkeit'
        },
        traffic_law_place_of_infraction: {
            type: 'string',
            title: 'Ort der Ordnungswidrigkeit',
            maxLength: 100
        },
        traffic_law_offense_infraction_description: {
            type: 'string',
            title: 'Tatbestand'
        },
        traffic_law_legal_basis_infraction: {
            type: 'string',
            title: 'Gesetzliche Grundlage'
        },
        traffic_law_evidence_infraction: {
            type: 'string',
            title: 'Beweismittel'
        },
        traffic_law_warning_fee_infraction: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Verwarnungsgeldbetrag'
        },
        traffic_law_payment_deadline: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Zahlungsfrist'
        },
        traffic_law_prosecution_number: {
            type: 'string',
            title: 'Geschäftsnummer',
            maxLength: 100
        },
        traffic_law_place_of_issue: {
            type: 'string',
            title: 'Ort der Ausstellung',
            maxLength: 100
        },
        traffic_law_date_of_issue: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum der Ausstellung'
        },
        traffic_law_time_of_issue: {
            type: 'string',
            format: 'time',
            nullable: true,
            title: 'Tag der Ausstellung'
        },
        traffic_law_charges: {
            type: 'string',
            title: 'Tatvorwurf'
        },
        traffic_law_legal_basis: {
            type: 'string',
            title: 'Gesetzliche Grundlage'
        },
        traffic_law_fine: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Geldstrafe'
        },
        traffic_law_daily_rate: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Höhe des Tagessatzes'
        },
        traffic_law_number_of_daily_rates: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Anzahl der Tagessätze'
        },
        traffic_law_procedure_costs: {
            type: 'string',
            title: 'Verfahrenskosten'
        },
        traffic_law_date_of_crime: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum der Tat'
        },
        traffic_law_time_of_crime: {
            type: 'string',
            format: 'time',
            nullable: true,
            title: 'Uhrzeit der Tat'
        },
        traffic_law_place_of_crime: {
            type: 'string',
            title: 'Ort der Tat',
            maxLength: 100
        },
        traffic_law_blood_alcohol_concentration: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Blutalkoholkonzentration'
        },
        traffic_law_appeal_instruction: {
            type: 'string',
            title: 'Rechtsbehelfsbelehrung'
        },
        traffic_law_vehicle_age_months: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Fahrzeugalter in Monaten'
        },
        traffic_law_vehicle_mileage: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Fahrzeugleistung in km'
        },
        traffic_law_accident_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Unfallverursacher - Vers.-Schein gültig bis'
        },
        traffic_law_expert_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Unfallverursacher - Sachverständigengutachten'
        },
        traffic_law_net_replacement_value: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Nettowiederbeschaffungswert'
        },
        traffic_law_gross_replacement_value: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Bruttowiederbeschaffungswert'
        },
        traffic_law_net_gross_replacement_value: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Netto-Brutto-Wiederbeschaffungswert'
        },
        traffic_law_gross_gross_replacement_value: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Brutto-Brutto-Wiederbeschaffungswert'
        },
        traffic_law_calculated_total_damage_costs: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Gesamtschadenshöhe'
        },
        traffic_law_calculated_total_days: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Gesamttage'
        },
        traffic_law_repair_damage: {
            type: 'boolean',
            nullable: true,
            title: 'Reparaturschaden'
        },
        traffic_law_total_damage: {
            type: 'boolean',
            nullable: true,
            title: 'Totalschaden'
        },
        criminal_law_legal_classification_of_offense: {
            type: 'string',
            nullable: true,
            title: 'Vergehen auf der Grundlage von',
            maxLength: 128
        },
        criminal_law_date_of_offense: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum der Tat'
        },
        criminal_law_time_of_offense: {
            type: 'string',
            format: 'time',
            nullable: true,
            title: 'Uhrzeit der Tat'
        },
        criminal_law_place_of_offense: {
            type: 'string',
            nullable: true,
            title: 'Ort der Tat',
            maxLength: 128
        },
        criminal_law_penalty_infromation: {
            type: 'string',
            nullable: true,
            title: 'Strafe',
            maxLength: 128
        },
        criminal_law_number_of_daily_rates: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Tagessatz'
        },
        criminal_law_amount_of_daily_rates: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Betrag des Tagessatzes'
        },
        criminal_law_evidence: {
            type: 'string',
            nullable: true,
            title: 'Beweis',
            maxLength: 128
        },
        criminal_law_probation: {
            type: 'boolean',
            nullable: true,
            title: 'Bewährung'
        },
        criminal_law_prison_sentence: {
            type: 'boolean',
            nullable: true,
            title: 'Freiheitsstrafe'
        },
        criminal_law_duration_of_prison_sentence: {
            type: 'string',
            nullable: true,
            title: 'Dauer der Freiheitsstrafe',
            maxLength: 128
        },
        criminal_law_police_file_number: {
            type: 'string',
            nullable: true,
            title: 'Vorgangsnummer',
            maxLength: 128
        },
        criminal_law_report_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum der Anzeigenerstattung'
        },
        criminal_law_report_time: {
            type: 'string',
            format: 'time',
            nullable: true,
            title: 'Uhrzeit der Anzeigenerstattung'
        },
        criminal_law_offense_type: {
            type: 'string',
            nullable: true,
            title: 'Art des Delikts',
            maxLength: 256
        },
        criminal_law_incident_description: {
            type: 'string',
            nullable: true,
            title: 'Sachverhalt'
        },
        criminal_law_physical_evidence: {
            type: 'string',
            nullable: true,
            title: 'Beschreibung der Beweismittel'
        },
        criminal_law_evidence_location: {
            type: 'string',
            nullable: true,
            title: 'Standort der Beweismittel',
            maxLength: 256
        },
        criminal_law_damage_description: {
            type: 'string',
            nullable: true,
            title: 'Beschreibung des Schadens'
        },
        criminal_law_damage_value: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Schadenshöhe in EUR'
        },
        criminal_law_prosecution_file_number: {
            type: 'string',
            nullable: true,
            title: 'Aktenzeichen der Staatsanwaltschaft',
            maxLength: 128
        },
        criminal_law_charge_description: {
            type: 'string',
            nullable: true,
            title: 'Anklagesatz'
        },
        criminal_law_means_of_evidence: {
            type: 'string',
            nullable: true,
            title: 'Beweismittel'
        },
        criminal_law_applicable_laws: {
            type: 'string',
            nullable: true,
            title: 'Anwendbare Vorschriften'
        },
        criminal_law_preliminary_proceedings_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum der Einleitung des Ermittlungsverfahrens'
        },
        criminal_law_indictment_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum der Anklageschrift'
        },
        criminal_law_indictment_delivery_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum der Zustellung der Anklageschrift'
        },
        family_law_divorce_settlement_agreement: {
            type: 'boolean',
            nullable: true,
            title: 'Scheidungsfolgenvereinbarung'
        },
        family_law_marriage_contract_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Ehevertragsdatum'
        },
        family_law_average_net_income: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Durchschnittliches Nettoeinkommen'
        },
        family_law_children: {
            type: 'boolean',
            nullable: true,
            title: 'Kinder vorhanden'
        },
        family_law_registry_office_location: {
            type: 'string',
            nullable: true,
            title: 'Standesamt Ort',
            maxLength: 100
        },
        family_law_date_of_marriage: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Eheschließungsdatum'
        },
        family_law_marriage_register_number: {
            type: 'string',
            nullable: true,
            title: 'Eheregisternummer',
            maxLength: 100
        },
        family_law_separation_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Trennungsdatumdatum'
        },
        family_law_birth_register_number: {
            type: 'string',
            nullable: true,
            title: 'Geburtsurkundennummer',
            maxLength: 100
        },
        family_law_birth_register_office_location: {
            type: 'string',
            nullable: true,
            title: 'Standesamt Geburtsurkunde',
            maxLength: 100
        },
        social_law_application_file_reference: {
            type: 'string',
            nullable: true,
            title: 'Aktenzeichen',
            maxLength: 256
        },
        social_law_legal_basis: {
            type: 'string',
            nullable: true,
            title: 'Rechtsgrundlage',
            maxLength: 256
        },
        social_law_benefit_type: {
            type: 'string',
            nullable: true,
            title: 'Leistungsart',
            maxLength: 256
        },
        social_law_own_income_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Höhe eigenes Einkommen'
        },
        social_law_social_benefit_type: {
            type: 'string',
            nullable: true,
            title: 'Art der Sozialleistung',
            maxLength: 256
        },
        social_law_residence_status: {
            type: 'string',
            nullable: true,
            title: 'Aufenthaltsstatus',
            maxLength: 256
        },
        social_law_income_type: {
            type: 'string',
            nullable: true,
            title: 'Art des Einkommens',
            maxLength: 256
        },
        social_law_asset_type: {
            type: 'string',
            nullable: true,
            title: 'Art des Vermögens',
            maxLength: 256
        },
        social_law_approval_file_reference: {
            type: 'string',
            nullable: true,
            title: 'Aktenzeichen',
            maxLength: 256
        },
        social_law_approval_notice_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum des Bescheids'
        },
        social_law_approval_legal_basis: {
            type: 'string',
            nullable: true,
            title: 'Rechtsgrundlage der Entscheidung',
            maxLength: 256
        },
        social_law_approval_internal_reference: {
            type: 'string',
            nullable: true,
            title: 'Interne Referenznummer der Behörde',
            maxLength: 256
        },
        social_law_approved_benefit_type: {
            type: 'string',
            nullable: true,
            title: 'Bewilligte Leistung (Art)',
            maxLength: 256
        },
        social_law_approved_benefit_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Bewilligte Leistung (Betrag)'
        },
        social_law_approved_benefit_period: {
            type: 'string',
            nullable: true,
            title: 'Bewilligte Leistung (Zeitraum)',
            maxLength: 256
        },
        social_law_follow_up_application_notes: {
            type: 'string',
            nullable: true,
            title: 'Hinweise zu Folgeanträgen',
            maxLength: 512
        },
        social_law_approval_period_start: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Bewilligungszeitraum Beginn'
        },
        social_law_approval_period_end: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Bewilligungszeitraum Ende'
        },
        social_law_regelbedarf_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Regelbedarf'
        },
        social_law_housing_costs_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Kosten für Unterkunft und Heizung'
        },
        social_law_total_need_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Gesamtbedarf'
        },
        social_law_monthly_payment_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Monatliche Leistung'
        },
        social_law_employment_income: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Erwerbseinkommen'
        },
        social_law_other_income: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Sonstiges Einkommen'
        },
        social_law_creditable_income: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Anrechenbares Einkommen'
        },
        social_law_change_file_reference: {
            type: 'string',
            nullable: true,
            title: 'Aktenzeichen',
            maxLength: 256
        },
        social_law_change_notification_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum der Mitteilung'
        },
        social_law_affected_benefit: {
            type: 'string',
            nullable: true,
            title: 'Betroffene Leistung',
            maxLength: 256
        },
        social_law_change_description: {
            type: 'string',
            nullable: true,
            title: 'Beschreibung der Änderung',
            maxLength: 256
        },
        social_law_change_reason: {
            type: 'string',
            nullable: true,
            title: 'Grund der Änderung',
            maxLength: 256
        },
        social_law_attachment_list: {
            type: 'string',
            nullable: true,
            title: 'Anlagenliste',
            maxLength: 512
        },
        social_law_rejection_file_reference: {
            type: 'string',
            nullable: true,
            title: 'Aktenzeichen',
            maxLength: 256
        },
        social_law_rejection_legal_norm: {
            type: 'string',
            nullable: true,
            title: 'Rechtsnorm',
            maxLength: 256
        },
        social_law_rejection_reason: {
            type: 'string',
            nullable: true,
            title: 'Ablehnungsgrund',
            maxLength: 512
        },
        social_law_rejection_notice_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum des Bescheids'
        },
        social_law_revocation_file_reference: {
            type: 'string',
            nullable: true,
            title: 'Aktenzeichen',
            maxLength: 256
        },
        social_law_revocation_legal_norm: {
            type: 'string',
            nullable: true,
            title: 'Rechtsnorm',
            maxLength: 256
        },
        social_law_revocation_reason: {
            type: 'string',
            nullable: true,
            title: 'Begründung der Aufhebung',
            maxLength: 512
        },
        social_law_revocation_notice_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum des Bescheids'
        },
        social_law_revocation_reclaim_notes: {
            type: 'string',
            nullable: true,
            title: 'Hinweise zu Rückforderungen',
            maxLength: 512
        },
        social_law_revocation_benefit_type: {
            type: 'string',
            nullable: true,
            title: 'Leistungsart',
            maxLength: 256
        },
        social_law_revocation_period_start: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Aufhebungszeitraum Beginn'
        },
        social_law_revocation_period_end: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Aufhebungszeitraum Ende'
        },
        social_law_original_decision_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum des ursprünglichen Bescheids'
        },
        social_law_total_reclaim_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Gesamtforderung'
        },
        social_law_income_source: {
            type: 'string',
            nullable: true,
            title: 'Einkommensquelle',
            maxLength: 256
        },
        social_law_income_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Einkommensbetrag'
        },
        social_law_income_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum der Einnahme'
        },
        social_law_income_provider: {
            type: 'string',
            nullable: true,
            title: 'Einkommensgeber',
            maxLength: 256
        },
        social_law_notification_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum der Kenntnisnahme'
        },
        social_law_notification_source: {
            type: 'string',
            nullable: true,
            title: 'Quelle der Kenntnisnahme',
            maxLength: 256
        },
        social_law_violation_type: {
            type: 'string',
            nullable: true,
            title: 'Art der Pflichtverletzung',
            maxLength: 256
        },
        social_law_income_legal_basis: {
            type: 'string',
            nullable: true,
            title: 'Rechtsgrundlage Einkommensberücksichtigung',
            maxLength: 256
        },
        social_law_reclaim_legal_basis: {
            type: 'string',
            nullable: true,
            title: 'Rechtsgrundlage Erstattung',
            maxLength: 256
        },
        social_law_notification_legal_basis: {
            type: 'string',
            nullable: true,
            title: 'Rechtsgrundlage Mitteilungspflicht',
            maxLength: 256
        },
        social_law_reclaim_file_reference: {
            type: 'string',
            nullable: true,
            title: 'Aktenzeichen',
            maxLength: 256
        },
        social_law_reclaim_legal_norm: {
            type: 'string',
            nullable: true,
            title: 'Rechtsnorm',
            maxLength: 256
        },
        social_law_reclaim_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Rückforderungsbetrag'
        },
        social_law_reclaim_payment_deadline: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: ' Datum Zahlungsfrist'
        },
        social_law_reclaim_notice_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum des Bescheids'
        },
        social_law_reclaim_payment_terms: {
            type: 'string',
            nullable: true,
            title: 'Zahlungsmodalitäten',
            maxLength: 512
        },
        social_law_objection_file_reference: {
            type: 'string',
            nullable: true,
            title: 'Aktenzeichen (des angegriffenen Bescheids)',
            maxLength: 256
        },
        social_law_objection_challenged_notice: {
            type: 'string',
            nullable: true,
            title: 'Angegriffener Bescheid',
            maxLength: 256
        },
        social_law_objection_reasoning: {
            type: 'string',
            nullable: true,
            title: 'Widerspruchsbegründung',
            maxLength: 256
        },
        social_law_objection_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum des Widerspruchs'
        },
        social_law_objection_suspension_request: {
            type: 'string',
            nullable: true,
            title: 'Antrag auf Aussetzung der Vollziehung',
            maxLength: 256
        },
        social_law_objection_evidence: {
            type: 'string',
            nullable: true,
            title: 'Beweismittel',
            maxLength: 512
        },
        social_law_notice_of_objection_file_reference: {
            type: 'string',
            nullable: true,
            title: 'Aktenzeichen',
            maxLength: 256
        },
        social_law_notice_of_objection_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Widerspruchbescheid Datum'
        },
        social_law_notice_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Bescheid Datum'
        },
        social_law_application_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Antrag Datum'
        },
        social_law_application_arrival_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Eingang Antrag Datum'
        },
        social_law_summary_grounds_opposition: {
            type: 'string',
            nullable: true,
            title: 'Begründung des Widerspruchs',
            maxLength: 256
        },
        social_law_lawsuit_file_reference: {
            type: 'string',
            nullable: true,
            title: 'Aktenzeichen',
            maxLength: 256
        },
        social_law_lawsuit_subject: {
            type: 'string',
            nullable: true,
            title: 'Gegenstand des Verfahrens',
            maxLength: 512
        },
        social_law_lawsuit_filing_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum der Klageerhebung'
        },
        social_law_lawsuit_evidence_requests: {
            type: 'string',
            nullable: true,
            title: 'Beweisanträge',
            maxLength: 512
        },
        social_law_lawsuit_attachment_list: {
            type: 'string',
            nullable: true,
            title: 'Anlagenliste',
            maxLength: 512
        },
        social_law_lawsuit_court_file_number: {
            type: 'string',
            nullable: true,
            title: 'BG-Nummer',
            maxLength: 256
        },
        social_law_lawsuit_legal_basis: {
            type: 'string',
            nullable: true,
            title: 'Rechtliche Grundlage der Klage',
            maxLength: 256
        },
        social_law_lawsuit_type: {
            type: 'string',
            nullable: true,
            title: 'Art der Klage',
            maxLength: 256
        },
        social_law_lawsuit_main_request: {
            type: 'string',
            nullable: true,
            title: 'Hauptantrag',
            maxLength: 512
        },
        social_law_lawsuit_alternative_request: {
            type: 'string',
            nullable: true,
            title: 'Hilfsantrag',
            maxLength: 512
        },
        social_law_lawsuit_cost_request: {
            type: 'string',
            nullable: true,
            title: 'Kostenantrag',
            maxLength: 256
        },
        social_law_lawsuit_original_decision_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum des ursprünglichen Bescheids'
        },
        social_law_lawsuit_objection_decision_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum des Widerspruchsbescheids'
        },
        social_law_lawsuit_objection_filing_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum der Widerspruchseinlegung'
        },
        social_law_lawsuit_delivery_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Zustellungsdatum'
        },
        social_law_lawsuit_dispute_value: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Streitwert'
        },
        social_law_lawsuit_disputed_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Streitiger Betrag'
        },
        social_law_lawsuit_monthly_benefit_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Monatliche Leistung'
        },
        social_law_lawsuit_income_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Einkommensbetrag'
        },
        social_law_interim_protection_file_reference: {
            type: 'string',
            nullable: true,
            title: 'Aktenzeichen',
            maxLength: 256
        },
        social_law_interim_protection_request_text: {
            type: 'string',
            nullable: true,
            title: 'Antragstext',
            maxLength: 256
        },
        social_law_interim_protection_urgency_reason: {
            type: 'string',
            nullable: true,
            title: 'Dringlichkeitsbegründung',
            maxLength: 512
        },
        social_law_interim_protection_request_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum des Antrags'
        },
        social_law_interim_protection_affidavit: {
            type: 'boolean',
            nullable: true,
            title: 'Eidesstattliche Versicherung'
        },
        social_law_interim_protection_attachment_list: {
            type: 'string',
            nullable: true,
            title: 'Anlagenliste',
            maxLength: 512
        },
        social_law_medical_file_reference: {
            type: 'string',
            nullable: true,
            title: 'Aktenzeichen',
            maxLength: 256
        },
        social_law_medical_examination_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Untersuchungsdatum'
        },
        social_law_medical_diagnosis: {
            type: 'string',
            nullable: true,
            title: 'Medizinische Diagnose',
            maxLength: 512
        },
        social_law_medical_work_capacity_relation: {
            type: 'string',
            nullable: true,
            title: 'Bezug zur Leistungsfähigkeit',
            maxLength: 512
        },
        social_law_medical_prognosis: {
            type: 'string',
            nullable: true,
            title: 'Prognose',
            maxLength: 512
        },
        social_law_medical_limitations: {
            type: 'string',
            nullable: true,
            title: 'Einschränkungen',
            maxLength: 512
        },
        social_law_medical_icd_code: {
            type: 'string',
            nullable: true,
            title: 'ICD-Code',
            maxLength: 256
        },
        social_law_needs_file_reference: {
            type: 'string',
            nullable: true,
            title: 'Aktenzeichen',
            maxLength: 256
        },
        social_law_needs_type: {
            type: 'string',
            nullable: true,
            title: 'Art des Bedarfs',
            maxLength: 256
        },
        social_law_needs_proof_basis: {
            type: 'string',
            nullable: true,
            title: 'Nachweisgrundlage',
            maxLength: 512
        },
        social_law_needs_cost_breakdown: {
            type: 'string',
            nullable: true,
            title: 'Kostenaufstellung',
            maxLength: 512
        },
        social_law_needs_proof_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Bedarfsnachweis'
        },
        social_law_disability_file_reference: {
            type: 'string',
            nullable: true,
            title: 'Aktenzeichen',
            maxLength: 256
        },
        social_law_disability_degree: {
            type: 'string',
            nullable: true,
            title: 'Grad der Behinderung (GdB)',
            maxLength: 256
        },
        social_law_disability_card_issue_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Ausstellungsdatum'
        },
        social_law_disability_card_markers: {
            type: 'string',
            nullable: true,
            title: 'Merkzeichen',
            maxLength: 256
        },
        social_law_disability_card_validity_period: {
            type: 'string',
            nullable: true,
            title: 'Gültigkeitsdauer',
            maxLength: 256
        },
        social_law_hearing_file_reference: {
            type: 'string',
            nullable: true,
            title: 'Aktenzeichen',
            maxLength: 256
        },
        social_law_hearing_planned_administrative_act: {
            type: 'string',
            nullable: true,
            title: 'Geplanter Verwaltungsakt',
            maxLength: 512
        },
        social_law_hearing_letter_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Anhörungsschreiben'
        },
        social_law_appointment_file_reference: {
            type: 'string',
            nullable: true,
            title: 'Aktenzeichen',
            maxLength: 256
        },
        social_law_appointment_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Termin (Datum)'
        },
        social_law_appointment_time: {
            type: 'string',
            nullable: true,
            title: 'Termin (Uhrzeit)',
            maxLength: 256
        },
        social_law_appointment_purpose: {
            type: 'string',
            nullable: true,
            title: 'Zweck des Termins',
            maxLength: 512
        },
        social_law_appointment_required_documents: {
            type: 'string',
            nullable: true,
            title: 'Mitzubringende Unterlagen',
            maxLength: 512
        },
        debt_collection_law_invoice_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Rechnungsdatum'
        },
        debt_collection_law_invoice_number: {
            type: 'string',
            nullable: true,
            title: 'Rechnungsnummer',
            maxLength: 100
        },
        debt_collection_law_invoice_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Rechnungsbetrag'
        },
        debt_collection_law_invoice_ground: {
            type: 'string',
            nullable: true,
            title: 'Rechnungsgrund',
            maxLength: 100
        },
        debt_collection_law_invoice_recipient: {
            type: 'string',
            nullable: true,
            title: 'Rechnungsadressat',
            maxLength: 100
        },
        debt_collection_law_invoice_tax_number: {
            type: 'string',
            nullable: true,
            title: 'Steuernummer',
            maxLength: 100
        },
        debt_collection_law_case_value: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Gegenstandswert'
        },
        debt_collection_law_business_fee: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: '1,3 Geschäftsgebühr (Nr. 2300 VV RVG)'
        },
        debt_collection_law_lumps_sum_expenses: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Auslagenpauschale (Nr. 7002 VV RVG)'
        },
        debt_collection_law_subtotal_lawyer_fees: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Zwischensumme Netto'
        },
        debt_collection_law_sales_tax: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Umsatzsteuer (19%)'
        },
        debt_collection_law_total_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Gesamtbetrag'
        },
        tenancy_law_rental_object_size_sqm: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Größe Mietobjekt Quadratmeter'
        },
        tenancy_law_rental_agreement_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Mietvertragsdatum'
        },
        tenancy_law_last_signature_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum letzte Unterschrift Mietvertrag'
        },
        tenancy_law_net_rent: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Nettomiete'
        },
        tenancy_law_gross_rent: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Bruttomiete'
        },
        tenancy_law_total_rent: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Gesamtmiete'
        },
        tenancy_law_unlimited_term_tenancy: {
            type: 'boolean',
            nullable: true,
            title: 'Unbefristeter Mietvertrag'
        },
        tenancy_law_fixed_term_tenancy: {
            type: 'boolean',
            nullable: true,
            title: 'Befristeter Mietvertrag'
        },
        tenancy_law_rental_agreement_duration: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Dauer Mietvertrag'
        },
        tenancy_law_rental_agreement_validity_start: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Mietvertragsbeginn'
        },
        tenancy_law_rental_agreement_validity_end: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Mietvertragsende'
        },
        tenancy_law_staggered_rental_agreement: {
            type: 'boolean',
            nullable: true,
            title: 'Staffelmietvereinbarung'
        },
        tenancy_law_value_security_clause: {
            type: 'boolean',
            nullable: true,
            title: 'Wertsicherungsklausel'
        },
        tenancy_law_tenant_extension_option: {
            type: 'boolean',
            nullable: true,
            title: 'Verlängerungsoption zugunsten Mieter'
        },
        tenancy_law_extension_option_count: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Anzahl Verlängerungsoptionen'
        },
        tenancy_law_extension_option_duration: {
            type: 'string',
            nullable: true,
            title: 'Dauer Verlängerungsoption',
            maxLength: 128
        },
        tenancy_law_security_deposit_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Kautionshöhe'
        },
        tenancy_law_security_deposit_additional_regulations: {
            type: 'string',
            nullable: true,
            title: 'Zusätzliche Regelungen zur Kaution'
        },
        tenancy_law_cash_deposit_agreed: {
            type: 'boolean',
            nullable: true,
            title: 'Barkaution vertraglich vereinbart'
        },
        tenancy_law_cash_deposit_payment_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Barkaution Datum Zahlung'
        },
        tenancy_law_bank_guarantee: {
            type: 'boolean',
            nullable: true,
            title: 'Bankbürgschaft'
        },
        tenancy_law_operating_costs_agreement: {
            type: 'string',
            nullable: true,
            title: 'Betriebskostenvereinbarung',
            maxLength: 128
        },
        tenancy_law_advance_payment_service_charges: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Nebenkostenvorauszahlungshöhe'
        },
        tenancy_law_adress_rental_property: {
            type: 'string',
            nullable: true,
            title: 'Adresse des Mietobjekts',
            maxLength: 128
        },
        tenancy_law_description_of_rental_property: {
            type: 'string',
            nullable: true,
            title: 'Beschreibung des Mietobjekts',
            maxLength: 128
        },
        tenancy_law_location_in_rental_property: {
            type: 'string',
            nullable: true,
            title: 'Lage im Mietobjekt',
            maxLength: 128
        },
        tenancy_law_garage_available: {
            type: 'boolean',
            nullable: true,
            title: 'Garage vorhanden'
        },
        tenancy_law_garage_costs: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Kosten Garage'
        },
        tenancy_law_parking_space_available: {
            type: 'boolean',
            nullable: true,
            title: 'Stellplatz vorhanden'
        },
        tenancy_law_parking_space_costs: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Kosten des Stellplatzes'
        },
        tenancy_law_start_of_lease: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Beginn des Pachtvertrags'
        },
        tenancy_law_duration_of_lease: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Dauer des Pachtvertrags'
        },
        tenancy_law_repayment_period_start: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Beginn des Abrechnungszeitraums'
        },
        tenancy_law_repayment_period_end: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Ende des Abrechnungszeitraums'
        },
        tenancy_law_total_cost_service_charge: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Gesamtkosten Nebenkostenabrechnung'
        },
        tenancy_law_cost_shares: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Umlageschlüssel'
        },
        tenancy_law_cost_share: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Kostenanteil Mieter'
        },
        tenancy_law_advance_payment_service_charge: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Vorauszahlungen Nebenkostenabrechnung'
        },
        tenancy_law_repayment: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Nachzahlung/Guthaben'
        },
        tenancy_law_handover_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Übergabedatum'
        },
        tenancy_law_handover_counter: {
            type: 'string',
            nullable: true,
            title: 'Zählerstand',
            maxLength: 128
        },
        tenancy_law_counter_number: {
            type: 'string',
            nullable: true,
            title: 'Zählerstandnummer',
            maxLength: 128
        },
        tenancy_law_handover_defects: {
            type: 'string',
            nullable: true,
            title: 'Mängel',
            maxLength: 128
        },
        tenancy_law_expert_report_damage_number: {
            type: 'string',
            nullable: true,
            title: 'Schadennummer',
            maxLength: 100
        },
        tenancy_law_expert_report_object_address: {
            type: 'string',
            nullable: true,
            title: 'Objekt Adresse',
            maxLength: 200
        },
        tenancy_law_expert_report_subject: {
            type: 'string',
            nullable: true,
            title: 'Gegenstand',
            maxLength: 200
        },
        tenancy_law_expert_report_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Gutachten'
        },
        tenancy_law_expert_report_purpose: {
            type: 'string',
            nullable: true,
            title: 'Zweck des Gutachtens'
        },
        tenancy_law_expert_report_commission_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Beauftragung Datum'
        },
        tenancy_law_expert_report_inspection_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Ortsbesichtigung Datum'
        },
        tenancy_law_expert_report_damage_description: {
            type: 'string',
            nullable: true,
            title: 'Schaden'
        },
        tenancy_law_expert_report_repair_duration: {
            type: 'string',
            nullable: true,
            title: 'Dauer Schadenbeseitigung',
            maxLength: 100
        },
        tenancy_law_tenant_warned: {
            type: 'boolean',
            nullable: true,
            title: 'Mieter abgemahnt'
        },
        tenancy_law_warning_letter_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Mahnschreiben'
        },
        tenancy_law_landlord_termination_given: {
            type: 'boolean',
            nullable: true,
            title: 'Kündigung durch Vermieter erfolgt'
        },
        tenancy_law_termination_declared_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Kündigungserklärung'
        },
        tenancy_law_termination_notice_period: {
            type: 'string',
            nullable: true,
            title: 'Kündigungsfrist',
            maxLength: 128
        },
        tenancy_law_termination_letter_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Kündigungsschreiben vom'
        },
        tenancy_law_tenancy_terminated: {
            type: 'boolean',
            nullable: true,
            title: 'Mietverhältnis beendet'
        },
        tenancy_law_tenancy_termination_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Beendigung Mietverhältnisses'
        },
        tenancy_law_property_return_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Rückgabe des Objekts Datum'
        },
        tenancy_law_court_proceedings_pending: {
            type: 'boolean',
            nullable: true,
            title: 'Gerichtliches Verfahren anhängig'
        },
        tenancy_law_competent_court: {
            type: 'string',
            nullable: true,
            title: 'Zuständiges Gericht',
            maxLength: 128
        },
        tenancy_law_court_case_number: {
            type: 'string',
            nullable: true,
            title: 'Gerichtliches Aktenzeichen',
            maxLength: 128
        },
        tenancy_law_last_rent_increase_letter_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum letztes Mieterhöhungsschreiben'
        },
        tenancy_law_rent_increase_effective_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Mieterhöhung wirksam geworden zum'
        },
        residential_property_law_contract_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Wegvertragsdatum'
        },
        residential_property_law_land_register_number: {
            type: 'string',
            nullable: true,
            title: 'Grundbuch Nr.',
            maxLength: 100
        },
        residential_property_law_land_register_city: {
            type: 'string',
            nullable: true,
            title: 'Grundbuch Stadt',
            maxLength: 100
        },
        residential_property_law_land_register_plot_of_land: {
            type: 'string',
            nullable: true,
            title: 'Grundbuch Flurstück',
            maxLength: 100
        },
        residential_property_law_land_register_address: {
            type: 'string',
            nullable: true,
            title: 'Grundbuch Lage',
            maxLength: 100
        },
        residential_property_law_co_ownership_shares: {
            type: 'string',
            nullable: true,
            title: 'Miteigentumsanteile',
            maxLength: 100
        },
        residential_property_law_inventory: {
            type: 'string',
            nullable: true,
            title: 'Bestandsverzeichnis',
            maxLength: 100
        },
        inheritance_law_certificate_of_inheritance_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Erbscheins'
        },
        inheritance_law_certificate_of_inheritance_number: {
            type: 'string',
            nullable: true,
            title: 'Nummer des Erbscheins',
            maxLength: 128
        },
        inheritance_law_certificate_of_inheritance_date_death: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Todesdatum'
        },
        inheritance_law_certificate_of_inheritance_place_of_death: {
            type: 'string',
            nullable: true,
            title: 'Todesort',
            maxLength: 128
        },
        inheritance_law_certificate_of_inheritance_applicable_law: {
            type: 'string',
            nullable: true,
            title: 'Anwendbares Recht',
            maxLength: 128
        },
        inheritance_law_inheritance_contract_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum des Erbvertrags'
        },
        inheritance_law_death_certificate_number: {
            type: 'string',
            nullable: true,
            title: 'Nummer Sterbeurkunde',
            maxLength: 128
        },
        inheritance_law_death_certificate_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Sterbeurkunde'
        },
        inheritance_law_death_certificate_place: {
            type: 'string',
            nullable: true,
            title: 'Ort Sterbeurkunde',
            maxLength: 128
        },
        inheritance_law_death_certificate_date_death: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Todesdatum'
        },
        inheritance_law_death_certificate_time_death: {
            type: 'string',
            format: 'time',
            nullable: true,
            title: 'Uhrzeit des Todes'
        },
        inheritance_law_death_certificate_place_death: {
            type: 'string',
            nullable: true,
            title: 'Ort des Todes',
            maxLength: 128
        },
        inheritance_law_testament_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum des Testaments'
        },
        inheritance_law_estate_inventory_status: {
            type: 'string',
            nullable: true,
            title: 'Güterstand',
            maxLength: 128
        },
        inheritance_law_estate_inventory_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Nachlassverzeichnis'
        },
        inheritance_law_estate_inventory_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Nettonachlass'
        },
        inheritance_law_patient_enrollment_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Patientenverfügung'
        },
        inheritance_law_lasting_power_of_attorney_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Vorsorgevollmacht'
        },
        real_estate_law_land_register_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Grundbuchauszugdatum'
        },
        real_estate_law_encumbrance_restrictions: {
            type: 'string',
            nullable: true,
            title: 'Lasten und Beschränkungen',
            maxLength: 128
        },
        real_estate_law_basic_debts_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Grundschulden'
        },
        real_estate_law_land_register_number: {
            type: 'string',
            nullable: true,
            title: 'Grundbuch Nr.',
            maxLength: 100
        },
        real_estate_law_land_register_city: {
            type: 'string',
            nullable: true,
            title: 'Grundbuch Stadt',
            maxLength: 100
        },
        real_estate_law_land_register_plot_of_land: {
            type: 'string',
            nullable: true,
            title: 'Grundbuch Flurstück',
            maxLength: 100
        },
        real_estate_law_land_register_address: {
            type: 'string',
            nullable: true,
            title: 'Grundbuch Lage',
            maxLength: 100
        },
        real_estate_law_plot_size: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Grundstücksgröße'
        },
        real_estate_law_purchase_contract_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Kaufvertragsdatum'
        },
        real_estate_law_purchase_contract_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Kaufvertragsbetrag'
        },
        real_estate_law_purchase_contract_description: {
            type: 'string',
            nullable: true,
            title: 'Kaufvertrag Objektbeschreibung',
            maxLength: 128
        },
        real_estate_law_purchase_contract_registration_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Kaufvertragsbeurkundungsdatum'
        },
        real_estate_law_purchase_contract_registration_number: {
            type: 'string',
            nullable: true,
            title: 'Urkundenrollennummer',
            maxLength: 100
        },
        real_estate_law_brokerage_fee: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Makler Provision'
        },
        real_estate_law_property_brokered_by_agent: {
            type: 'boolean',
            nullable: true,
            title: 'Objekt durch Makler vermittelt'
        },
        real_estate_law_purchase_object_rented: {
            type: 'boolean',
            nullable: true,
            title: 'Kaufobjekt vermietet'
        },
        real_estate_law_encumbrances_section_ii: {
            type: 'string',
            nullable: true,
            title: 'Belastungen Abt. II Grundbuch'
        },
        real_estate_law_encumbrances_section_iii: {
            type: 'string',
            nullable: true,
            title: 'Belastungen Abt. III Grundbuch'
        },
        real_estate_law_building_restrictions_clause: {
            type: 'string',
            nullable: true,
            title: 'Regelungen zu Baulasten'
        },
        real_estate_law_contaminated_sites_clause: {
            type: 'string',
            nullable: true,
            title: 'Regelung zu Altlasten'
        },
        real_estate_law_legal_defects_clause: {
            type: 'string',
            nullable: true,
            title: 'Klausel zu Rechtsmängeln'
        },
        real_estate_law_purchase_price_loan_financed: {
            type: 'boolean',
            nullable: true,
            title: 'Kaufpreis durch Darlehen finanziert'
        },
        real_estate_law_withdrawal_instruction_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Widerrufsbelehrung Datum'
        },
        real_estate_law_building_permit_validity_duration: {
            type: 'string',
            nullable: true,
            title: 'Gültigkeitsdauer',
            maxLength: 100
        },
        real_estate_law_building_permit_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Baugenehmigungsdatum'
        },
        real_estate_law_building_permit_number: {
            type: 'string',
            nullable: true,
            title: 'Genehmigungsnummer',
            maxLength: 100
        },
        real_estate_law_co_ownership_share: {
            type: 'string',
            nullable: true,
            title: 'Miteigentumsanteil',
            maxLength: 100
        },
        real_estate_law_division_declaration_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Teilungserklärung'
        },
        real_estate_law_plan_designation: {
            type: 'string',
            nullable: true,
            title: 'Planbezeichnung',
            maxLength: 100
        },
        real_estate_law_plan_scale: {
            type: 'string',
            nullable: true,
            title: 'Maßstab',
            maxLength: 100
        },
        real_estate_law_plan_author: {
            type: 'string',
            nullable: true,
            title: 'Planverfasser',
            maxLength: 100
        },
        real_estate_law_building_usage: {
            type: 'string',
            nullable: true,
            title: 'Gebäudenutzung',
            maxLength: 100
        },
        real_estate_law_building_dimensions: {
            type: 'string',
            nullable: true,
            title: 'Baukörperabmessung',
            maxLength: 100
        },
        real_estate_law_monument_protection_order_number: {
            type: 'string',
            nullable: true,
            title: 'Bescheid - Nr.',
            maxLength: 100
        },
        real_estate_law_monument_protection_order_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum des Denkmalschutzbescheides'
        },
        real_estate_law_monument_protection_basis: {
            type: 'string',
            nullable: true,
            title: 'Schutzgrundlage',
            maxLength: 100
        },
        real_estate_law_monument_registration_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Eintragungsdatum'
        },
        real_estate_law_monument_protection_requirements: {
            type: 'string',
            nullable: true,
            title: 'Auflagen'
        },
        real_estate_law_loan_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Darlehenssumme'
        },
        real_estate_law_interest_rate: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,3}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Zinssatz'
        },
        real_estate_law_installment_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Ratenhöhe'
        },
        real_estate_law_full_repayment_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Vollständige Rückzahlung'
        },
        real_estate_law_loan_security: {
            type: 'string',
            nullable: true,
            title: 'Darlehnsabsicherung',
            maxLength: 100
        },
        real_estate_law_repayment_rate: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,3}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Tilgungssatz'
        },
        real_estate_law_broker_commission_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Provisionshöhe'
        },
        real_estate_law_broker_scope_of_work: {
            type: 'string',
            nullable: true,
            title: 'Tätigkeitsumfang'
        },
        real_estate_law_broker_termination_periods: {
            type: 'string',
            nullable: true,
            title: 'Kündigungsfristen',
            maxLength: 100
        },
        real_estate_law_broker_contract_type: {
            type: 'string',
            nullable: true,
            title: 'Art des Maklervertrags',
            maxLength: 100
        },
        real_estate_law_brokerage_contract_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Maklervertrag Datum'
        },
        real_estate_law_exclusive_brokerage_contract: {
            type: 'boolean',
            nullable: true,
            title: 'Alleinauftrag'
        },
        real_estate_law_commission_percentage: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,3}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Provisionshöhe in %'
        },
        migration_law_residence_permit_issue_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Ausstellungsdatum'
        },
        migration_law_residence_permit_valid_until: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Gültig bis'
        },
        migration_law_residence_permit_type: {
            type: 'string',
            nullable: true,
            title: 'Titelart',
            maxLength: 100
        },
        migration_law_residence_permit_purpose: {
            type: 'string',
            nullable: true,
            title: 'Zweck des Aufenthalts',
            maxLength: 200
        },
        migration_law_residence_permit_issuing_authority: {
            type: 'string',
            nullable: true,
            title: 'Behörde',
            maxLength: 100
        },
        migration_law_residence_permit_conditions: {
            type: 'string',
            nullable: true,
            title: 'Auflagen / Nebenbestimmungen'
        },
        migration_law_residence_permit_passport_number: {
            type: 'string',
            nullable: true,
            title: 'Passnummer',
            maxLength: 50
        },
        migration_law_residence_permit_national_id_number: {
            type: 'string',
            nullable: true,
            title: 'Nationale Identitätsnummer',
            maxLength: 50
        },
        migration_law_fictional_certificate_issue_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Ausgestellt am'
        },
        migration_law_fictional_certificate_valid_until: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Gültig bis'
        },
        migration_law_fictional_certificate_legal_basis: {
            type: 'string',
            nullable: true,
            title: 'Rechtsgrundlage',
            maxLength: 100
        },
        migration_law_fictional_certificate_fiction_type: {
            type: 'string',
            nullable: true,
            title: 'Art der Fiktion',
            maxLength: 100
        },
        migration_law_fictional_certificate_reason_for_issuance: {
            type: 'string',
            nullable: true,
            title: 'Zweck der Erteilung',
            maxLength: 200
        },
        migration_law_fictional_certificate_authority: {
            type: 'string',
            nullable: true,
            title: 'Behörde',
            maxLength: 100
        },
        migration_law_toleration_issue_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Ausgestellt am'
        },
        migration_law_toleration_valid_until: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Gültig bis'
        },
        migration_law_toleration_reason: {
            type: 'string',
            nullable: true,
            title: 'Grund der Duldung',
            maxLength: 200
        },
        migration_law_toleration_legal_basis: {
            type: 'string',
            nullable: true,
            title: 'Rechtsgrundlage',
            maxLength: 100
        },
        migration_law_toleration_restrictions: {
            type: 'string',
            nullable: true,
            title: 'Beschränkungen'
        },
        migration_law_toleration_issuing_authority: {
            type: 'string',
            nullable: true,
            title: 'Behörde',
            maxLength: 100
        },
        migration_law_asylum_seeker_certificate_issue_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Ausstellungsdatum'
        },
        migration_law_asylum_seeker_certificate_valid_until: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Gültig bis'
        },
        migration_law_asylum_seeker_certificate_application_number: {
            type: 'string',
            nullable: true,
            title: 'Asylantragsnummer',
            maxLength: 100
        },
        migration_law_asylum_seeker_certificate_first_registration_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Erstregistrierung'
        },
        migration_law_asylum_seeker_certificate_residence_obligation: {
            type: 'string',
            nullable: true,
            title: 'Wohnsitzauflage',
            maxLength: 200
        },
        migration_law_asylum_seeker_certificate_issuing_authority: {
            type: 'string',
            nullable: true,
            title: 'Behörde',
            maxLength: 100
        },
        migration_law_asylum_seeker_certificate_work_permission: {
            type: 'string',
            nullable: true,
            title: 'Arbeitserlaubnis',
            maxLength: 100
        },
        migration_law_rejection_notice_case_number: {
            type: 'string',
            nullable: true,
            title: 'Aktenzeichen',
            maxLength: 100
        },
        migration_law_rejection_notice_decision_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum des Bescheids'
        },
        migration_law_rejection_notice_subject: {
            type: 'string',
            nullable: true,
            title: 'Betreff',
            maxLength: 200
        },
        migration_law_rejection_notice_legal_remedy_deadline: {
            type: 'string',
            nullable: true,
            title: 'Rechtsbehelf / Frist',
            maxLength: 200
        },
        migration_law_rejection_notice_reasoning: {
            type: 'string',
            nullable: true,
            title: 'Begründung'
        },
        migration_law_rejection_notice_legal_grounds: {
            type: 'string',
            nullable: true,
            title: 'Gesetzesgrundlagen',
            maxLength: 200
        },
        migration_law_rejection_notice_officer_name: {
            type: 'string',
            nullable: true,
            title: 'Name des Sachbearbeiters',
            maxLength: 100
        },
        migration_law_rejection_notice_signature_seal: {
            type: 'string',
            nullable: true,
            title: 'Unterschrift / Dienstsiegel',
            maxLength: 100
        },
        migration_law_approval_notice_case_number: {
            type: 'string',
            nullable: true,
            title: 'Aktenzeichen',
            maxLength: 100
        },
        migration_law_approval_notice_decision_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum des Bescheids'
        },
        migration_law_approval_notice_permit_type: {
            type: 'string',
            nullable: true,
            title: 'Art des Aufenthaltstitels',
            maxLength: 100
        },
        migration_law_approval_notice_validity_period: {
            type: 'string',
            nullable: true,
            title: 'Gültigkeitszeitraum',
            maxLength: 100
        },
        migration_law_approval_notice_conditions: {
            type: 'string',
            nullable: true,
            title: 'Auflagen'
        },
        migration_law_approval_notice_pickup_deadline: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Abholfrist'
        },
        migration_law_approval_notice_issuing_authority: {
            type: 'string',
            nullable: true,
            title: 'Ausstellende Behörde',
            maxLength: 100
        },
        migration_law_hearing_letter_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum des Schreibens'
        },
        migration_law_hearing_letter_response_deadline: {
            type: 'string',
            nullable: true,
            title: 'Frist zur Stellungnahme',
            maxLength: 100
        },
        migration_law_hearing_letter_intended_measure_justification: {
            type: 'string',
            nullable: true,
            title: 'Begründung der beabsichtigten Maßnahme'
        },
        migration_law_hearing_letter_legal_advice: {
            type: 'string',
            nullable: true,
            title: 'Rechtsbehelfshinweis'
        },
        migration_law_hearing_letter_requested_documents: {
            type: 'string',
            nullable: true,
            title: 'Dokumente beizufügen'
        },
        migration_law_cooperation_letter_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum des Schreibens'
        },
        migration_law_cooperation_letter_file_number: {
            type: 'string',
            nullable: true,
            title: 'Aktenzeichen',
            maxLength: 100
        },
        migration_law_cooperation_letter_specified_obligations: {
            type: 'string',
            nullable: true,
            title: 'Benannte Mitwirkungspflichten'
        },
        migration_law_cooperation_letter_non_cooperation_consequences: {
            type: 'string',
            nullable: true,
            title: 'Rechtsfolgen bei Nichtmitwirkung'
        },
        migration_law_cooperation_letter_deadlines: {
            type: 'string',
            nullable: true,
            title: 'Fristen',
            maxLength: 200
        },
        migration_law_cooperation_letter_attachments: {
            type: 'string',
            nullable: true,
            title: 'Anlagen / Formulare'
        },
        migration_law_other_letters_issuing_authority: {
            type: 'string',
            nullable: true,
            title: 'Absenderbehörde',
            maxLength: 100
        },
        migration_law_other_letters_file_number: {
            type: 'string',
            nullable: true,
            title: 'Aktenzeichen / Geschäftszeichen',
            maxLength: 100
        },
        migration_law_other_letters_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum des Schreibens'
        },
        migration_law_other_letters_subject: {
            type: 'string',
            nullable: true,
            title: 'Betreff',
            maxLength: 200
        },
        migration_law_other_letters_matter_purpose: {
            type: 'string',
            nullable: true,
            title: 'Anliegen / Inhalt des Schreibens'
        },
        migration_law_other_letters_legal_basis: {
            type: 'string',
            nullable: true,
            title: 'Rechtsgrundlage (sofern genannt)',
            maxLength: 200
        },
        migration_law_other_letters_deadlines: {
            type: 'string',
            nullable: true,
            title: 'Fristen',
            maxLength: 200
        },
        migration_law_other_letters_action_required: {
            type: 'string',
            nullable: true,
            title: 'Handlungsaufforderung'
        },
        civil_law_file_reference: {
            type: 'string',
            nullable: true,
            title: 'Aktenzeichen',
            maxLength: 100
        },
        civil_law_document_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Dokumentdatum'
        },
        civil_law_subject_line: {
            type: 'string',
            nullable: true,
            title: 'Betreff',
            maxLength: 255
        },
        civil_law_contract_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Vertragsdatum'
        },
        civil_law_contract_start_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Vertragsbeginn'
        },
        civil_law_contract_end_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Vertragsende'
        },
        civil_law_contract_duration: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Vertragslaufzeit in Monaten'
        },
        civil_law_contract_value: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Vertragswert'
        },
        civil_law_contract_object: {
            type: 'string',
            nullable: true,
            title: 'Vertragsgegenstand',
            maxLength: 255
        },
        civil_law_termination_notice_period: {
            type: 'string',
            nullable: true,
            title: 'Kündigungsfrist',
            maxLength: 100
        },
        civil_law_notarial_certification_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Notarielle Beurkundung Datum'
        },
        civil_law_purchase_price: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Kaufpreis'
        },
        civil_law_purchase_price_components: {
            type: 'string',
            nullable: true,
            title: 'Bestandteile Kaufpreis'
        },
        civil_law_accessories_sold_separately: {
            type: 'boolean',
            nullable: true,
            title: 'Zubehör separat veräußert?'
        },
        civil_law_purchase_contract_file_reference: {
            type: 'string',
            nullable: true,
            title: 'Kaufvertragsaktenzeichen',
            maxLength: 100
        },
        civil_law_handover_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Übergabedatum'
        },
        civil_law_purchase_price_paid: {
            type: 'boolean',
            nullable: true,
            title: 'Kaufpreis bezahlt'
        },
        civil_law_purchase_price_payment_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Zahlung Kaufpreis'
        },
        civil_law_purchase_price_paid_boolean: {
            type: 'boolean',
            nullable: true,
            title: 'Kaufpreis bezahlt'
        },
        civil_law_purchase_price_paid_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Kaufpreis bezahlt'
        },
        civil_law_purchase_price_paid_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Höhe bezahlten Kaufpreises'
        },
        civil_law_purchase_object: {
            type: 'string',
            nullable: true,
            title: 'Kaufgegenstand',
            maxLength: 255
        },
        civil_law_purchase_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Kaufdatum'
        },
        civil_law_delivery_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Lieferdatum'
        },
        civil_law_warranty_period: {
            type: 'string',
            nullable: true,
            title: 'Gewährleistungsfrist',
            maxLength: 100
        },
        civil_law_defects: {
            type: 'string',
            nullable: true,
            title: 'Mängel'
        },
        civil_law_defects_present: {
            type: 'boolean',
            nullable: true,
            title: 'Sachmängel vorhanden'
        },
        civil_law_vehicle_make: {
            type: 'string',
            nullable: true,
            title: 'Fahrzeugmarke',
            maxLength: 100
        },
        civil_law_vehicle_model: {
            type: 'string',
            nullable: true,
            title: 'Fahrzeugmodell',
            maxLength: 100
        },
        civil_law_vehicle_year: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Baujahr'
        },
        civil_law_vehicle_mileage: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Kilometerstand'
        },
        civil_law_vehicle_vin: {
            type: 'string',
            nullable: true,
            title: 'Fahrgestellnummer',
            maxLength: 50
        },
        civil_law_damage_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Schadenshöhe'
        },
        civil_law_damage_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Schadensdatum'
        },
        civil_law_damage_description: {
            type: 'string',
            nullable: true,
            title: 'Schadensbeschreibung'
        },
        civil_law_damage_cause: {
            type: 'string',
            nullable: true,
            title: 'Schadensursache',
            maxLength: 255
        },
        civil_law_liability_percentage: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,3}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Haftungsquote in Prozent'
        },
        civil_law_insurance_claim_number: {
            type: 'string',
            nullable: true,
            title: 'Versicherungsschadensnummer',
            maxLength: 100
        },
        civil_law_court_name: {
            type: 'string',
            nullable: true,
            title: 'Gericht',
            maxLength: 255
        },
        civil_law_case_number: {
            type: 'string',
            nullable: true,
            title: 'Geschäftsnummer',
            maxLength: 100
        },
        civil_law_hearing_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Verhandlungstermin'
        },
        civil_law_judgment_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Urteilsdatum'
        },
        civil_law_claim_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Streitwert'
        },
        civil_law_court_costs: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Gerichtskosten'
        },
        civil_law_payment_due_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Fälligkeitsdatum'
        },
        civil_law_interest_rate: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,3}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Zinssatz'
        },
        civil_law_default_interest: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Verzugszinsen'
        },
        general_law_file_ref: {
            type: 'string',
            title: 'Aktenzeichen',
            maxLength: 100
        },
        general_law_subject: {
            type: 'string',
            title: 'Betreff'
        },
        general_law_doc_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Dokumentendatum'
        },
        general_law_prior_ref: {
            type: 'string',
            title: 'Zeichen unseres Schreibens',
            maxLength: 200
        },
        general_law_appendices: {
            type: 'string',
            title: 'Anlagen'
        },
        general_law_invoice_number: {
            type: 'string',
            title: 'Rechnungsnummer',
            maxLength: 100
        },
        general_law_invoice_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Rechnungsdatum'
        },
        general_law_due_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Fälligkeitsdatum'
        },
        general_law_amount_total: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Gesamtbetrag'
        },
        general_law_amount_net: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Nettobetrag'
        },
        general_law_vat: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'MwSt / Umsatzsteuer'
        },
        general_law_payment_terms: {
            type: 'string',
            title: 'Zahlungsbedingungen'
        },
        general_law_court_name: {
            type: 'string',
            title: 'Gericht',
            maxLength: 200
        },
        general_law_case_number: {
            type: 'string',
            title: 'Geschäftsnummer',
            maxLength: 100
        },
        general_law_hearing_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Verhandlungstermin'
        },
        general_law_judgment_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Urteilsdatum'
        },
        general_law_court_costs: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Gerichtskosten'
        },
        medicine_law_medical_report_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum des Berichts'
        },
        medicine_law_medical_report_treatment_period: {
            type: 'string',
            nullable: true,
            title: 'Zeitraum der Behandlung',
            maxLength: 200
        },
        medicine_law_medical_report_diagnosis_icd_code: {
            type: 'string',
            nullable: true,
            title: 'Diagnose ICD-Code',
            maxLength: 50
        },
        medicine_law_medical_report_diagnosis_short_text: {
            type: 'string',
            nullable: true,
            title: 'Diagnose Kurztext',
            maxLength: 200
        },
        medicine_law_medical_report_treatment_measures: {
            type: 'string',
            nullable: true,
            title: 'Therapie Behandlungsmaßnahmen'
        },
        medicine_law_medical_report_surgery_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'OP-Datum'
        },
        medicine_law_medical_report_complications: {
            type: 'string',
            nullable: true,
            title: 'Komplikationen'
        },
        medicine_law_medical_report_further_treatment: {
            type: 'string',
            nullable: true,
            title: 'Weitere Behandlung'
        },
        medicine_law_hospital_records_admission_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Aufnahmedatum'
        },
        medicine_law_hospital_records_discharge_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Entlassungsdatum'
        },
        medicine_law_hospital_records_station: {
            type: 'string',
            nullable: true,
            title: 'Station',
            maxLength: 100
        },
        medicine_law_hospital_records_diagnoses_icd_codes: {
            type: 'string',
            nullable: true,
            title: 'Diagnosen ICD-Codes'
        },
        medicine_law_hospital_records_operations: {
            type: 'string',
            nullable: true,
            title: 'Operationen'
        },
        medicine_law_hospital_records_operation_date: {
            type: 'string',
            nullable: true,
            title: 'Operation Datum'
        },
        medicine_law_hospital_records_medication_during_stay: {
            type: 'string',
            nullable: true,
            title: 'Medikation während Aufenthalt'
        },
        medicine_law_hospital_records_documented_complications: {
            type: 'string',
            nullable: true,
            title: 'Dokumentierte Komplikationen'
        },
        medicine_law_hospital_records_discharge_prognosis: {
            type: 'string',
            nullable: true,
            title: 'Prognose'
        },
        medicine_law_medical_expertise_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum des Gutachtens'
        },
        medicine_law_medical_expertise_question_posed: {
            type: 'string',
            nullable: true,
            title: 'Fragestellung des Gutachtens'
        },
        medicine_law_medical_expertise_medical_assessment: {
            type: 'string',
            nullable: true,
            title: 'Medizinische Einschätzung'
        },
        medicine_law_medical_expertise_justification: {
            type: 'string',
            nullable: true,
            title: 'Begründung des Ergebnisses'
        },
        medicine_law_medical_expertise_result: {
            type: 'string',
            nullable: true,
            title: 'Ergebnis des Gutachtens'
        },
        medicine_law_laboratory_results_examination_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum der Untersuchung'
        },
        medicine_law_laboratory_results_examination_type: {
            type: 'string',
            nullable: true,
            title: 'Art der Untersuchung',
            maxLength: 200
        },
        medicine_law_laboratory_results: {
            type: 'string',
            nullable: true,
            title: 'Befund'
        },
        medicine_law_laboratory_results_relevant_deviations: {
            type: 'string',
            nullable: true,
            title: 'Relevante Abweichungen'
        },
        medicine_law_laboratory_results_further_investigation_recommendation: {
            type: 'string',
            nullable: true,
            title: 'Empfehlung zur weiteren Abklärung'
        },
        medicine_law_health_insurance_letter_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum des Schreibens'
        },
        medicine_law_health_insurance_letter_reference_to_application: {
            type: 'string',
            nullable: true,
            title: 'Bezug auf Schreiben'
        },
        medicine_law_health_insurance_letter_decision: {
            type: 'string',
            nullable: true,
            title: 'Entscheidung der Krankenkasse',
            maxLength: 100
        },
        medicine_law_health_insurance_letter_decision_justification: {
            type: 'string',
            nullable: true,
            title: 'Begründung der Entscheidung'
        },
        medicine_law_health_insurance_letter_legal_remedy_instruction: {
            type: 'string',
            nullable: true,
            title: 'Rechtsbehelfsbelehrung'
        },
        medicine_law_medical_bill_invoice_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Rechnungsdatum'
        },
        medicine_law_medical_bill_invoice_number: {
            type: 'string',
            nullable: true,
            title: 'Rechnungsnummer',
            maxLength: 100
        },
        medicine_law_medical_bill_service_period: {
            type: 'string',
            nullable: true,
            title: 'Zeitraum der Leistung',
            maxLength: 200
        },
        medicine_law_medical_bill_services_list: {
            type: 'string',
            nullable: true,
            title: 'Auflistung der Leistungen'
        },
        medicine_law_medical_bill_total_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Gesamtsumme der Rechnung'
        },
        medicine_law_medical_bill_cost_bearer: {
            type: 'string',
            nullable: true,
            title: 'Kostenträger',
            maxLength: 100
        },
        medicine_law_medical_bill_payment_deadline: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Zahlungsfrist'
        },
        field: {
            type: 'string',
            title: 'Rechtsgebiet',
            maxLength: 100
        },
        topic: {
            type: 'string',
            title: 'Rechtsthema',
            maxLength: 100
        },
        external_case_id: {
            type: 'string',
            nullable: true,
            maxLength: 100
        }
    },
    required: ['created_at', 'updated_at']
} as const;

export const $ShallowLawDataRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        labor_law_beginning_of_employment: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Beginn des Arbeitsverhältnisses'
        },
        labor_law_end_of_employment: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Ende des Arbeitsverhältnisses'
        },
        labor_law_job_title: {
            type: 'string',
            title: 'Berufsbezeichnung',
            maxLength: 100
        },
        labor_law_yearly_gross_salary: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Gehalt, jährlich, brutto'
        },
        labor_law_monthly_gross_salary: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Gehalt, monatlich, brutto'
        },
        labor_law_monthly_working_days: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Arbeitsstunden pro Monat'
        },
        labor_law_vacation_days: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Urlaubstage'
        },
        labor_law_work_hours_per_week: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Arbeitsstunden pro Woche'
        },
        labor_law_is_employee_in_probation_period: {
            type: 'boolean',
            nullable: true,
            title: 'Arbeitnehmer in Probezeit'
        },
        labor_law_employee_probation_period_end_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Ende der Probezeit'
        },
        labor_law_place_of_work: {
            type: 'string',
            title: 'Arbeitsort',
            maxLength: 100
        },
        labor_law_different_place_of_work: {
            type: 'string',
            title: 'Abweichender Arbeitsort',
            maxLength: 100
        },
        labor_law_fixed_term_contract: {
            type: 'boolean',
            nullable: true,
            title: 'Befristetes Arbeitsverhältnis'
        },
        labor_law_fixed_term_contract_duration: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Ende befristetes Arbeitsverhältnis'
        },
        labor_law_special_payments: {
            type: 'string',
            title: 'Sonderzahlungen',
            maxLength: 100
        },
        labor_law_special_payments_amount: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Höhe der Sonderzahlungen'
        },
        labor_law_special_protection_against_dismissal: {
            type: 'boolean',
            nullable: true,
            title: 'Sonderkündigungsschutz'
        },
        labor_law_work_council: {
            type: 'boolean',
            nullable: true,
            title: 'Betriebsrat'
        },
        labor_law_collective_agreement: {
            type: 'boolean',
            nullable: true,
            title: 'Tarifvertrag'
        },
        labor_law_company_agreement: {
            type: 'boolean',
            nullable: true,
            title: 'Betriebsvereinbarung'
        },
        labor_law_notice_period: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Kündigungsfrist in Monaten'
        },
        labor_law_signature_of_employer: {
            type: 'boolean',
            nullable: true,
            title: 'Unterschrift Arbeitgeber'
        },
        labor_law_local_transfer_clause: {
            type: 'boolean',
            nullable: true,
            title: 'Örtliche Versetzungsklausel'
        },
        labor_law_VSOP: {
            type: 'boolean',
            nullable: true,
            title: 'VSOP'
        },
        labor_law_LTI: {
            type: 'boolean',
            nullable: true,
            title: 'LTI'
        },
        labor_law_termination_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Kündigung durch Arbeitgeber'
        },
        labor_law_termination_date_effective: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Kündigung erfolgt zu welchem Datum'
        },
        labor_law_termination_employer_more_than_10_employees: {
            type: 'boolean',
            nullable: true,
            title: 'Arbeitgeber hat mehr als 10 Mitarbeiter'
        },
        labor_law_termination_access_to_termination_to_employee: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Zugang Kündigung beim Arbeitnehmer'
        },
        labor_law_notice_period_observed: {
            type: 'boolean',
            nullable: true,
            title: 'Kündigungsfrist eingehalten'
        },
        labor_law_termination_without_notice: {
            type: 'boolean',
            nullable: true,
            title: 'Fristlose Kündigung'
        },
        labor_law_reason_for_termination_given: {
            type: 'boolean',
            nullable: true,
            title: 'Kündigungsgrund angegeben'
        },
        labor_law_exemption_revocable: {
            type: 'boolean',
            nullable: true,
            title: 'Freistellung widerruflich'
        },
        labor_law_exemption_irrevocable: {
            type: 'boolean',
            nullable: true,
            title: 'Freistellung unwiderruflich'
        },
        labor_law_return_of_company_property: {
            type: 'boolean',
            nullable: true,
            title: 'Rückgabe Firmeneigentum'
        },
        labor_law_termination_operational_reasons: {
            type: 'boolean',
            nullable: true,
            title: '1a KSchG dringende betriebliche Kündigung'
        },
        labor_law_company_hearing: {
            type: 'boolean',
            nullable: true,
            title: 'Betriebsanhörung durchgeführt'
        },
        labor_law_reaction_company_hering: {
            type: 'string',
            nullable: true,
            title: 'Reaktion des Betriebsrats'
        },
        labor_law_termination_authorization: {
            type: 'string',
            nullable: true,
            title: 'Befugnis zur Kündigung'
        },
        labor_law_warning_letter_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Abmahnung'
        },
        labor_law_warning_letter_access_to_warning_letter_to_employee: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Zugang Abmahnung beim Arbeitnehmer'
        },
        labor_law_warning_letter_incident_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum des Vorfalls der zur Abmahnung geführt hat'
        },
        labor_law_warning_letter_incident_time: {
            type: 'string',
            format: 'time',
            nullable: true,
            title: 'Uhrzeit des Vorfalls der zur Abmahnung geführt hat'
        },
        labor_law_warning_letter_incident_location: {
            type: 'string',
            title: 'Ort des Vorfalls der zur Abmahnung geführt hat',
            maxLength: 100
        },
        labor_law_warning_letter_reason: {
            type: 'string',
            title: 'Grund der Abmahnung'
        },
        labor_law_termination_agreement_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Aufhebungsvertrag'
        },
        labor_law_settlement_agreement_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Abwicklungsvertrag'
        },
        labor_law_termination_agreement_termination_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Beendigung Arbeitsverhältnis'
        },
        labor_law_termination_is_agreement_severance_pay: {
            type: 'boolean',
            nullable: true,
            title: 'Abfindung vereinbart'
        },
        labor_law_termination_agreement_severance_pay_amount: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Höhe der Abfindung'
        },
        labor_law_special_sentence: {
            type: 'boolean',
            nullable: true,
            title: 'Zur Vermeidung Kündigung aus dringenden betrieblichen Gründen'
        },
        labor_law_sprinter_clause: {
            type: 'boolean',
            nullable: true,
            title: 'Sprinterklausel'
        },
        labor_law_percent_sprinter_clause: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Prozent Sprinterklausel'
        },
        labor_law_certificate_clause: {
            type: 'boolean',
            nullable: true,
            title: 'Zeugnisklausel'
        },
        labor_law_grade_certificate_clause: {
            type: 'string',
            title: 'Note Zeugnisklausel'
        },
        labor_law_child_allowances: {
            type: 'boolean',
            nullable: true,
            title: 'Kinderfreibeträge'
        },
        labor_law_married: {
            type: 'boolean',
            nullable: true,
            title: 'Verheiratet'
        },
        labor_law_dependent_children: {
            type: 'boolean',
            nullable: true,
            title: 'Unterhaltspflichtige Kinder'
        },
        labor_law_amount_dependent_children: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Anzahl unterhaltspflichtiger Kinder'
        },
        labor_law_years_of_employment: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Jahre der Betriebszugehörigkeit'
        },
        labor_law_total_gross_salary: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Gesamtgehalt Brutto'
        },
        labor_law_severance_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Abfindungssumme'
        },
        labor_law_works_council_membership: {
            type: 'boolean',
            nullable: true,
            title: 'Mitgliedschaft Betriebsrat'
        },
        labor_law_pregnancy: {
            type: 'boolean',
            nullable: true,
            title: 'Schwangerschaft'
        },
        labor_law_disability: {
            type: 'boolean',
            nullable: true,
            title: 'Behinderung'
        },
        labor_law_special_personal_circumstances: {
            type: 'boolean',
            nullable: true,
            title: 'Besondere persönliche Umstände'
        },
        traffic_law_place_of_accident: {
            type: 'string',
            minLength: 1,
            title: 'Unfallort',
            maxLength: 100
        },
        traffic_law_date_of_accident: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Unfalltag'
        },
        traffic_law_time_of_accident: {
            type: 'string',
            format: 'time',
            nullable: true,
            title: 'Uhrzeit Unfall'
        },
        traffic_law_driving_ban_duration: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Fahrverbot Dauer'
        },
        traffic_law_driving_ban: {
            type: 'boolean',
            nullable: true,
            title: 'Fahrverbot verhängt'
        },
        traffic_law_licenseplate: {
            type: 'string',
            minLength: 1,
            title: 'KFZ-Kennzeichen',
            maxLength: 100
        },
        traffic_law_vehicle_type_and_brand: {
            type: 'string',
            minLength: 1,
            title: 'Fahrzeugtyp und Marke',
            maxLength: 100
        },
        traffic_law_amount_of_fine: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Bußgeldhöhe'
        },
        traffic_law_date_of_fine: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Bußgeldbescheid'
        },
        traffic_law_speed_allowed: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Erlaubte Geschwindigkeit'
        },
        traffic_law_speed_driven: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Gefahrene Geschwindigkeit'
        },
        traffic_law_speed_too_high: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Überschreitung Geschwindigkeit'
        },
        traffic_law_points_for_offense: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Punkte'
        },
        traffic_law_date_of_offense: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum der Tat'
        },
        traffic_law_time_of_offense: {
            type: 'string',
            format: 'time',
            nullable: true,
            title: 'Uhrzeit der Tat'
        },
        traffic_law_place_of_offense: {
            type: 'string',
            minLength: 1,
            title: 'Ort der Tat',
            maxLength: 100
        },
        traffic_law_violation_type: {
            type: 'string',
            minLength: 1,
            title: 'Tatvorwurf',
            maxLength: 100
        },
        traffic_law_violated_section: {
            type: 'string',
            minLength: 1,
            title: 'Verletzte Vorschrift',
            maxLength: 100
        },
        traffic_law_file_number: {
            type: 'string',
            minLength: 1,
            title: 'Aktenzeichen',
            maxLength: 100
        },
        traffic_law_driver_logbook_required: {
            type: 'boolean',
            nullable: true,
            title: 'Fahrtenbuch erforderlich'
        },
        traffic_law_licenseplate_at_fault_driver: {
            type: 'string',
            minLength: 1,
            title: 'KFZ-Kennzeichen des Unfallverursachers',
            maxLength: 100
        },
        traffic_law_licenseplate_victim_driver: {
            type: 'string',
            minLength: 1,
            title: 'KFZ-Kennzeichen des Unfallgeschädigten',
            maxLength: 100
        },
        traffic_law_injured: {
            type: 'boolean',
            nullable: true,
            title: 'Verletzte'
        },
        traffic_law_other_damages: {
            type: 'boolean',
            nullable: true,
            title: 'Andere Sachschäden'
        },
        traffic_law_mark_and_type_of_at_fault_driver: {
            type: 'string',
            minLength: 1,
            title: 'Unfallverursacher - Marke, Typ des Fahrzeugs',
            maxLength: 100
        },
        traffic_law_mark_and_type_of_victim_driver: {
            type: 'string',
            minLength: 1,
            title: 'Unfallgeschädigter - Marke, Typ des Fahrzeugs',
            maxLength: 100
        },
        traffic_law_at_fault_driver_insurer: {
            type: 'string',
            minLength: 1,
            title: 'Unfallverursacher - Versicherer',
            maxLength: 100
        },
        traffic_law_victim_driver_insurer: {
            type: 'string',
            minLength: 1,
            title: 'Unfallgeschädigter - Versicherer',
            maxLength: 100
        },
        traffic_law_at_fault_driver_insurance_number: {
            type: 'string',
            minLength: 1,
            title: 'Unfallverursacher - Vers.-Nr.',
            maxLength: 100
        },
        traffic_law_victim_driver_insurance_number: {
            type: 'string',
            minLength: 1,
            title: 'Unfallgeschädigter - Vers.-Nr.',
            maxLength: 100
        },
        traffic_law_at_fault_driver_green_card_number: {
            type: 'string',
            minLength: 1,
            title: 'Unfallverursacher - Nr. der Grünen Karte',
            maxLength: 100
        },
        traffic_law_victim_driver_green_card_number: {
            type: 'string',
            minLength: 1,
            title: 'Unfallgeschädigter - Nr. der Grünen Karte',
            maxLength: 100
        },
        traffic_law_at_fault_driver_insurance_expiry_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Unfallverursacher - Vers.-Schein gültig bis'
        },
        traffic_law_victim_driver_insurance_expiry_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Unfallgeschädigter - Vers.-Schein gültig bis'
        },
        traffic_law_at_fault_driver_drivers_license_issued_by: {
            type: 'string',
            minLength: 1,
            title: 'Unfallverursacher - Führerschein ausgestellt durch',
            maxLength: 100
        },
        traffic_law_victim_driver_drivers_license_issued_by: {
            type: 'string',
            minLength: 1,
            title: 'Unfallgeschädigter - Führerschein ausgestellt durch',
            maxLength: 100
        },
        traffic_law_at_fault_driver_drivers_license_valid_until: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Unfallverursacher - Führerschein gültig bis'
        },
        traffic_law_victim_driver_license_valid_until: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Unfallgeschädigter - Führerschein gültig bis'
        },
        traffic_law_date_of_report: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Sachverständigengutachten'
        },
        traffic_law_place_of_inspection: {
            type: 'string',
            minLength: 1,
            title: 'Besichtigungsort',
            maxLength: 100
        },
        traffic_law_date_of_inspection: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Besichtigungsdatum'
        },
        traffic_law_time_of_inspection: {
            type: 'string',
            format: 'time',
            nullable: true,
            title: 'Besichtigungszeit'
        },
        traffic_law_insurance_holder: {
            type: 'string',
            minLength: 1,
            title: 'Versicherungsnehmer',
            maxLength: 100
        },
        traffic_law_insurance: {
            type: 'string',
            minLength: 1,
            title: 'Versicherung',
            maxLength: 100
        },
        traffic_law_police_case_number: {
            type: 'string',
            minLength: 1,
            title: 'Polizeiliches Aktenzeichen',
            maxLength: 100
        },
        traffic_law_repair_costs_without_vat: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Reparaturkosten Netto'
        },
        traffic_law_repair_costs_with_vat: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Reparaturkosten Brutto'
        },
        traffic_law_replacement_value: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Wiederbeschaffungswert'
        },
        traffic_law_differencial_tax: {
            type: 'boolean',
            nullable: true,
            title: 'Differenzsteuer'
        },
        traffic_law_regular_tax: {
            type: 'boolean',
            nullable: true,
            title: 'Regelsteuer'
        },
        traffic_law_merantile_value_loss: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Merkantile Wertminderung'
        },
        traffic_law_loss_of_use_per_day: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Nutzungsausfallentschädigung pro Tag'
        },
        traffic_law_repair_duration: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Reparaturdauer Tage'
        },
        traffic_law_residual_value: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Restwert Brutto'
        },
        traffic_law_reregistration_cost: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Ummeldekosten'
        },
        traffic_law_damage_scope: {
            type: 'string',
            minLength: 1,
            title: 'Schadensumfang'
        },
        traffic_law_expert_report_number: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Gutachten Nummer'
        },
        traffic_law_insurance_policy_number: {
            type: 'string',
            minLength: 1,
            title: 'Versicherungsscheinnummer',
            maxLength: 100
        },
        traffic_law_damage_number: {
            type: 'string',
            minLength: 1,
            title: 'Schadensnummer',
            maxLength: 100
        },
        traffic_law_expert_cost: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Sachverständigenkosten'
        },
        traffic_law_cost_per_scale: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Kostenpauschale'
        },
        traffic_law_loss_amount_repair_case: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Restschaden Reparaturschaden'
        },
        traffic_law_loss_amount_total_damage_case: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Restschaden Totalschaden'
        },
        traffic_law_replacement_cost: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Wiederbeschaffungsaufwand'
        },
        traffic_law_date_of_infraction: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum der Ordnungswidrigkeit'
        },
        traffic_law_time_of_infraction: {
            type: 'string',
            format: 'time',
            nullable: true,
            title: 'Uhrzeit der Ordnungswidrigkeit'
        },
        traffic_law_place_of_infraction: {
            type: 'string',
            minLength: 1,
            title: 'Ort der Ordnungswidrigkeit',
            maxLength: 100
        },
        traffic_law_offense_infraction_description: {
            type: 'string',
            minLength: 1,
            title: 'Tatbestand'
        },
        traffic_law_legal_basis_infraction: {
            type: 'string',
            minLength: 1,
            title: 'Gesetzliche Grundlage'
        },
        traffic_law_evidence_infraction: {
            type: 'string',
            minLength: 1,
            title: 'Beweismittel'
        },
        traffic_law_warning_fee_infraction: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Verwarnungsgeldbetrag'
        },
        traffic_law_payment_deadline: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Zahlungsfrist'
        },
        traffic_law_prosecution_number: {
            type: 'string',
            minLength: 1,
            title: 'Geschäftsnummer',
            maxLength: 100
        },
        traffic_law_place_of_issue: {
            type: 'string',
            minLength: 1,
            title: 'Ort der Ausstellung',
            maxLength: 100
        },
        traffic_law_date_of_issue: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum der Ausstellung'
        },
        traffic_law_time_of_issue: {
            type: 'string',
            format: 'time',
            nullable: true,
            title: 'Tag der Ausstellung'
        },
        traffic_law_charges: {
            type: 'string',
            minLength: 1,
            title: 'Tatvorwurf'
        },
        traffic_law_legal_basis: {
            type: 'string',
            minLength: 1,
            title: 'Gesetzliche Grundlage'
        },
        traffic_law_fine: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Geldstrafe'
        },
        traffic_law_daily_rate: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Höhe des Tagessatzes'
        },
        traffic_law_number_of_daily_rates: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Anzahl der Tagessätze'
        },
        traffic_law_procedure_costs: {
            type: 'string',
            minLength: 1,
            title: 'Verfahrenskosten'
        },
        traffic_law_date_of_crime: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum der Tat'
        },
        traffic_law_time_of_crime: {
            type: 'string',
            format: 'time',
            nullable: true,
            title: 'Uhrzeit der Tat'
        },
        traffic_law_place_of_crime: {
            type: 'string',
            minLength: 1,
            title: 'Ort der Tat',
            maxLength: 100
        },
        traffic_law_blood_alcohol_concentration: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Blutalkoholkonzentration'
        },
        traffic_law_appeal_instruction: {
            type: 'string',
            minLength: 1,
            title: 'Rechtsbehelfsbelehrung'
        },
        traffic_law_vehicle_age_months: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Fahrzeugalter in Monaten'
        },
        traffic_law_vehicle_mileage: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Fahrzeugleistung in km'
        },
        traffic_law_accident_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Unfallverursacher - Vers.-Schein gültig bis'
        },
        traffic_law_expert_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Unfallverursacher - Sachverständigengutachten'
        },
        traffic_law_net_replacement_value: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Nettowiederbeschaffungswert'
        },
        traffic_law_gross_replacement_value: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Bruttowiederbeschaffungswert'
        },
        traffic_law_net_gross_replacement_value: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Netto-Brutto-Wiederbeschaffungswert'
        },
        traffic_law_gross_gross_replacement_value: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Brutto-Brutto-Wiederbeschaffungswert'
        },
        traffic_law_calculated_total_damage_costs: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Gesamtschadenshöhe'
        },
        traffic_law_calculated_total_days: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Gesamttage'
        },
        traffic_law_repair_damage: {
            type: 'boolean',
            nullable: true,
            title: 'Reparaturschaden'
        },
        traffic_law_total_damage: {
            type: 'boolean',
            nullable: true,
            title: 'Totalschaden'
        },
        criminal_law_legal_classification_of_offense: {
            type: 'string',
            nullable: true,
            title: 'Vergehen auf der Grundlage von',
            maxLength: 128
        },
        criminal_law_date_of_offense: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum der Tat'
        },
        criminal_law_time_of_offense: {
            type: 'string',
            format: 'time',
            nullable: true,
            title: 'Uhrzeit der Tat'
        },
        criminal_law_place_of_offense: {
            type: 'string',
            nullable: true,
            title: 'Ort der Tat',
            maxLength: 128
        },
        criminal_law_penalty_infromation: {
            type: 'string',
            nullable: true,
            title: 'Strafe',
            maxLength: 128
        },
        criminal_law_number_of_daily_rates: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Tagessatz'
        },
        criminal_law_amount_of_daily_rates: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Betrag des Tagessatzes'
        },
        criminal_law_evidence: {
            type: 'string',
            nullable: true,
            title: 'Beweis',
            maxLength: 128
        },
        criminal_law_probation: {
            type: 'boolean',
            nullable: true,
            title: 'Bewährung'
        },
        criminal_law_prison_sentence: {
            type: 'boolean',
            nullable: true,
            title: 'Freiheitsstrafe'
        },
        criminal_law_duration_of_prison_sentence: {
            type: 'string',
            nullable: true,
            title: 'Dauer der Freiheitsstrafe',
            maxLength: 128
        },
        criminal_law_police_file_number: {
            type: 'string',
            nullable: true,
            title: 'Vorgangsnummer',
            maxLength: 128
        },
        criminal_law_report_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum der Anzeigenerstattung'
        },
        criminal_law_report_time: {
            type: 'string',
            format: 'time',
            nullable: true,
            title: 'Uhrzeit der Anzeigenerstattung'
        },
        criminal_law_offense_type: {
            type: 'string',
            nullable: true,
            title: 'Art des Delikts',
            maxLength: 256
        },
        criminal_law_incident_description: {
            type: 'string',
            nullable: true,
            title: 'Sachverhalt'
        },
        criminal_law_physical_evidence: {
            type: 'string',
            nullable: true,
            title: 'Beschreibung der Beweismittel'
        },
        criminal_law_evidence_location: {
            type: 'string',
            nullable: true,
            title: 'Standort der Beweismittel',
            maxLength: 256
        },
        criminal_law_damage_description: {
            type: 'string',
            nullable: true,
            title: 'Beschreibung des Schadens'
        },
        criminal_law_damage_value: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Schadenshöhe in EUR'
        },
        criminal_law_prosecution_file_number: {
            type: 'string',
            nullable: true,
            title: 'Aktenzeichen der Staatsanwaltschaft',
            maxLength: 128
        },
        criminal_law_charge_description: {
            type: 'string',
            nullable: true,
            title: 'Anklagesatz'
        },
        criminal_law_means_of_evidence: {
            type: 'string',
            nullable: true,
            title: 'Beweismittel'
        },
        criminal_law_applicable_laws: {
            type: 'string',
            nullable: true,
            title: 'Anwendbare Vorschriften'
        },
        criminal_law_preliminary_proceedings_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum der Einleitung des Ermittlungsverfahrens'
        },
        criminal_law_indictment_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum der Anklageschrift'
        },
        criminal_law_indictment_delivery_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum der Zustellung der Anklageschrift'
        },
        family_law_divorce_settlement_agreement: {
            type: 'boolean',
            nullable: true,
            title: 'Scheidungsfolgenvereinbarung'
        },
        family_law_marriage_contract_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Ehevertragsdatum'
        },
        family_law_average_net_income: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Durchschnittliches Nettoeinkommen'
        },
        family_law_children: {
            type: 'boolean',
            nullable: true,
            title: 'Kinder vorhanden'
        },
        family_law_registry_office_location: {
            type: 'string',
            nullable: true,
            title: 'Standesamt Ort',
            maxLength: 100
        },
        family_law_date_of_marriage: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Eheschließungsdatum'
        },
        family_law_marriage_register_number: {
            type: 'string',
            nullable: true,
            title: 'Eheregisternummer',
            maxLength: 100
        },
        family_law_separation_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Trennungsdatumdatum'
        },
        family_law_birth_register_number: {
            type: 'string',
            nullable: true,
            title: 'Geburtsurkundennummer',
            maxLength: 100
        },
        family_law_birth_register_office_location: {
            type: 'string',
            nullable: true,
            title: 'Standesamt Geburtsurkunde',
            maxLength: 100
        },
        social_law_application_file_reference: {
            type: 'string',
            nullable: true,
            title: 'Aktenzeichen',
            maxLength: 256
        },
        social_law_legal_basis: {
            type: 'string',
            nullable: true,
            title: 'Rechtsgrundlage',
            maxLength: 256
        },
        social_law_benefit_type: {
            type: 'string',
            nullable: true,
            title: 'Leistungsart',
            maxLength: 256
        },
        social_law_own_income_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Höhe eigenes Einkommen'
        },
        social_law_social_benefit_type: {
            type: 'string',
            nullable: true,
            title: 'Art der Sozialleistung',
            maxLength: 256
        },
        social_law_residence_status: {
            type: 'string',
            nullable: true,
            title: 'Aufenthaltsstatus',
            maxLength: 256
        },
        social_law_income_type: {
            type: 'string',
            nullable: true,
            title: 'Art des Einkommens',
            maxLength: 256
        },
        social_law_asset_type: {
            type: 'string',
            nullable: true,
            title: 'Art des Vermögens',
            maxLength: 256
        },
        social_law_approval_file_reference: {
            type: 'string',
            nullable: true,
            title: 'Aktenzeichen',
            maxLength: 256
        },
        social_law_approval_notice_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum des Bescheids'
        },
        social_law_approval_legal_basis: {
            type: 'string',
            nullable: true,
            title: 'Rechtsgrundlage der Entscheidung',
            maxLength: 256
        },
        social_law_approval_internal_reference: {
            type: 'string',
            nullable: true,
            title: 'Interne Referenznummer der Behörde',
            maxLength: 256
        },
        social_law_approved_benefit_type: {
            type: 'string',
            nullable: true,
            title: 'Bewilligte Leistung (Art)',
            maxLength: 256
        },
        social_law_approved_benefit_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Bewilligte Leistung (Betrag)'
        },
        social_law_approved_benefit_period: {
            type: 'string',
            nullable: true,
            title: 'Bewilligte Leistung (Zeitraum)',
            maxLength: 256
        },
        social_law_follow_up_application_notes: {
            type: 'string',
            nullable: true,
            title: 'Hinweise zu Folgeanträgen',
            maxLength: 512
        },
        social_law_approval_period_start: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Bewilligungszeitraum Beginn'
        },
        social_law_approval_period_end: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Bewilligungszeitraum Ende'
        },
        social_law_regelbedarf_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Regelbedarf'
        },
        social_law_housing_costs_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Kosten für Unterkunft und Heizung'
        },
        social_law_total_need_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Gesamtbedarf'
        },
        social_law_monthly_payment_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Monatliche Leistung'
        },
        social_law_employment_income: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Erwerbseinkommen'
        },
        social_law_other_income: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Sonstiges Einkommen'
        },
        social_law_creditable_income: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Anrechenbares Einkommen'
        },
        social_law_change_file_reference: {
            type: 'string',
            nullable: true,
            title: 'Aktenzeichen',
            maxLength: 256
        },
        social_law_change_notification_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum der Mitteilung'
        },
        social_law_affected_benefit: {
            type: 'string',
            nullable: true,
            title: 'Betroffene Leistung',
            maxLength: 256
        },
        social_law_change_description: {
            type: 'string',
            nullable: true,
            title: 'Beschreibung der Änderung',
            maxLength: 256
        },
        social_law_change_reason: {
            type: 'string',
            nullable: true,
            title: 'Grund der Änderung',
            maxLength: 256
        },
        social_law_attachment_list: {
            type: 'string',
            nullable: true,
            title: 'Anlagenliste',
            maxLength: 512
        },
        social_law_rejection_file_reference: {
            type: 'string',
            nullable: true,
            title: 'Aktenzeichen',
            maxLength: 256
        },
        social_law_rejection_legal_norm: {
            type: 'string',
            nullable: true,
            title: 'Rechtsnorm',
            maxLength: 256
        },
        social_law_rejection_reason: {
            type: 'string',
            nullable: true,
            title: 'Ablehnungsgrund',
            maxLength: 512
        },
        social_law_rejection_notice_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum des Bescheids'
        },
        social_law_revocation_file_reference: {
            type: 'string',
            nullable: true,
            title: 'Aktenzeichen',
            maxLength: 256
        },
        social_law_revocation_legal_norm: {
            type: 'string',
            nullable: true,
            title: 'Rechtsnorm',
            maxLength: 256
        },
        social_law_revocation_reason: {
            type: 'string',
            nullable: true,
            title: 'Begründung der Aufhebung',
            maxLength: 512
        },
        social_law_revocation_notice_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum des Bescheids'
        },
        social_law_revocation_reclaim_notes: {
            type: 'string',
            nullable: true,
            title: 'Hinweise zu Rückforderungen',
            maxLength: 512
        },
        social_law_revocation_benefit_type: {
            type: 'string',
            nullable: true,
            title: 'Leistungsart',
            maxLength: 256
        },
        social_law_revocation_period_start: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Aufhebungszeitraum Beginn'
        },
        social_law_revocation_period_end: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Aufhebungszeitraum Ende'
        },
        social_law_original_decision_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum des ursprünglichen Bescheids'
        },
        social_law_total_reclaim_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Gesamtforderung'
        },
        social_law_income_source: {
            type: 'string',
            nullable: true,
            title: 'Einkommensquelle',
            maxLength: 256
        },
        social_law_income_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Einkommensbetrag'
        },
        social_law_income_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum der Einnahme'
        },
        social_law_income_provider: {
            type: 'string',
            nullable: true,
            title: 'Einkommensgeber',
            maxLength: 256
        },
        social_law_notification_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum der Kenntnisnahme'
        },
        social_law_notification_source: {
            type: 'string',
            nullable: true,
            title: 'Quelle der Kenntnisnahme',
            maxLength: 256
        },
        social_law_violation_type: {
            type: 'string',
            nullable: true,
            title: 'Art der Pflichtverletzung',
            maxLength: 256
        },
        social_law_income_legal_basis: {
            type: 'string',
            nullable: true,
            title: 'Rechtsgrundlage Einkommensberücksichtigung',
            maxLength: 256
        },
        social_law_reclaim_legal_basis: {
            type: 'string',
            nullable: true,
            title: 'Rechtsgrundlage Erstattung',
            maxLength: 256
        },
        social_law_notification_legal_basis: {
            type: 'string',
            nullable: true,
            title: 'Rechtsgrundlage Mitteilungspflicht',
            maxLength: 256
        },
        social_law_reclaim_file_reference: {
            type: 'string',
            nullable: true,
            title: 'Aktenzeichen',
            maxLength: 256
        },
        social_law_reclaim_legal_norm: {
            type: 'string',
            nullable: true,
            title: 'Rechtsnorm',
            maxLength: 256
        },
        social_law_reclaim_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Rückforderungsbetrag'
        },
        social_law_reclaim_payment_deadline: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: ' Datum Zahlungsfrist'
        },
        social_law_reclaim_notice_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum des Bescheids'
        },
        social_law_reclaim_payment_terms: {
            type: 'string',
            nullable: true,
            title: 'Zahlungsmodalitäten',
            maxLength: 512
        },
        social_law_objection_file_reference: {
            type: 'string',
            nullable: true,
            title: 'Aktenzeichen (des angegriffenen Bescheids)',
            maxLength: 256
        },
        social_law_objection_challenged_notice: {
            type: 'string',
            nullable: true,
            title: 'Angegriffener Bescheid',
            maxLength: 256
        },
        social_law_objection_reasoning: {
            type: 'string',
            nullable: true,
            title: 'Widerspruchsbegründung',
            maxLength: 256
        },
        social_law_objection_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum des Widerspruchs'
        },
        social_law_objection_suspension_request: {
            type: 'string',
            nullable: true,
            title: 'Antrag auf Aussetzung der Vollziehung',
            maxLength: 256
        },
        social_law_objection_evidence: {
            type: 'string',
            nullable: true,
            title: 'Beweismittel',
            maxLength: 512
        },
        social_law_notice_of_objection_file_reference: {
            type: 'string',
            nullable: true,
            title: 'Aktenzeichen',
            maxLength: 256
        },
        social_law_notice_of_objection_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Widerspruchbescheid Datum'
        },
        social_law_notice_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Bescheid Datum'
        },
        social_law_application_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Antrag Datum'
        },
        social_law_application_arrival_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Eingang Antrag Datum'
        },
        social_law_summary_grounds_opposition: {
            type: 'string',
            nullable: true,
            title: 'Begründung des Widerspruchs',
            maxLength: 256
        },
        social_law_lawsuit_file_reference: {
            type: 'string',
            nullable: true,
            title: 'Aktenzeichen',
            maxLength: 256
        },
        social_law_lawsuit_subject: {
            type: 'string',
            nullable: true,
            title: 'Gegenstand des Verfahrens',
            maxLength: 512
        },
        social_law_lawsuit_filing_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum der Klageerhebung'
        },
        social_law_lawsuit_evidence_requests: {
            type: 'string',
            nullable: true,
            title: 'Beweisanträge',
            maxLength: 512
        },
        social_law_lawsuit_attachment_list: {
            type: 'string',
            nullable: true,
            title: 'Anlagenliste',
            maxLength: 512
        },
        social_law_lawsuit_court_file_number: {
            type: 'string',
            nullable: true,
            title: 'BG-Nummer',
            maxLength: 256
        },
        social_law_lawsuit_legal_basis: {
            type: 'string',
            nullable: true,
            title: 'Rechtliche Grundlage der Klage',
            maxLength: 256
        },
        social_law_lawsuit_type: {
            type: 'string',
            nullable: true,
            title: 'Art der Klage',
            maxLength: 256
        },
        social_law_lawsuit_main_request: {
            type: 'string',
            nullable: true,
            title: 'Hauptantrag',
            maxLength: 512
        },
        social_law_lawsuit_alternative_request: {
            type: 'string',
            nullable: true,
            title: 'Hilfsantrag',
            maxLength: 512
        },
        social_law_lawsuit_cost_request: {
            type: 'string',
            nullable: true,
            title: 'Kostenantrag',
            maxLength: 256
        },
        social_law_lawsuit_original_decision_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum des ursprünglichen Bescheids'
        },
        social_law_lawsuit_objection_decision_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum des Widerspruchsbescheids'
        },
        social_law_lawsuit_objection_filing_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum der Widerspruchseinlegung'
        },
        social_law_lawsuit_delivery_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Zustellungsdatum'
        },
        social_law_lawsuit_dispute_value: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Streitwert'
        },
        social_law_lawsuit_disputed_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Streitiger Betrag'
        },
        social_law_lawsuit_monthly_benefit_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Monatliche Leistung'
        },
        social_law_lawsuit_income_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Einkommensbetrag'
        },
        social_law_interim_protection_file_reference: {
            type: 'string',
            nullable: true,
            title: 'Aktenzeichen',
            maxLength: 256
        },
        social_law_interim_protection_request_text: {
            type: 'string',
            nullable: true,
            title: 'Antragstext',
            maxLength: 256
        },
        social_law_interim_protection_urgency_reason: {
            type: 'string',
            nullable: true,
            title: 'Dringlichkeitsbegründung',
            maxLength: 512
        },
        social_law_interim_protection_request_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum des Antrags'
        },
        social_law_interim_protection_affidavit: {
            type: 'boolean',
            nullable: true,
            title: 'Eidesstattliche Versicherung'
        },
        social_law_interim_protection_attachment_list: {
            type: 'string',
            nullable: true,
            title: 'Anlagenliste',
            maxLength: 512
        },
        social_law_medical_file_reference: {
            type: 'string',
            nullable: true,
            title: 'Aktenzeichen',
            maxLength: 256
        },
        social_law_medical_examination_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Untersuchungsdatum'
        },
        social_law_medical_diagnosis: {
            type: 'string',
            nullable: true,
            title: 'Medizinische Diagnose',
            maxLength: 512
        },
        social_law_medical_work_capacity_relation: {
            type: 'string',
            nullable: true,
            title: 'Bezug zur Leistungsfähigkeit',
            maxLength: 512
        },
        social_law_medical_prognosis: {
            type: 'string',
            nullable: true,
            title: 'Prognose',
            maxLength: 512
        },
        social_law_medical_limitations: {
            type: 'string',
            nullable: true,
            title: 'Einschränkungen',
            maxLength: 512
        },
        social_law_medical_icd_code: {
            type: 'string',
            nullable: true,
            title: 'ICD-Code',
            maxLength: 256
        },
        social_law_needs_file_reference: {
            type: 'string',
            nullable: true,
            title: 'Aktenzeichen',
            maxLength: 256
        },
        social_law_needs_type: {
            type: 'string',
            nullable: true,
            title: 'Art des Bedarfs',
            maxLength: 256
        },
        social_law_needs_proof_basis: {
            type: 'string',
            nullable: true,
            title: 'Nachweisgrundlage',
            maxLength: 512
        },
        social_law_needs_cost_breakdown: {
            type: 'string',
            nullable: true,
            title: 'Kostenaufstellung',
            maxLength: 512
        },
        social_law_needs_proof_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Bedarfsnachweis'
        },
        social_law_disability_file_reference: {
            type: 'string',
            nullable: true,
            title: 'Aktenzeichen',
            maxLength: 256
        },
        social_law_disability_degree: {
            type: 'string',
            nullable: true,
            title: 'Grad der Behinderung (GdB)',
            maxLength: 256
        },
        social_law_disability_card_issue_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Ausstellungsdatum'
        },
        social_law_disability_card_markers: {
            type: 'string',
            nullable: true,
            title: 'Merkzeichen',
            maxLength: 256
        },
        social_law_disability_card_validity_period: {
            type: 'string',
            nullable: true,
            title: 'Gültigkeitsdauer',
            maxLength: 256
        },
        social_law_hearing_file_reference: {
            type: 'string',
            nullable: true,
            title: 'Aktenzeichen',
            maxLength: 256
        },
        social_law_hearing_planned_administrative_act: {
            type: 'string',
            nullable: true,
            title: 'Geplanter Verwaltungsakt',
            maxLength: 512
        },
        social_law_hearing_letter_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Anhörungsschreiben'
        },
        social_law_appointment_file_reference: {
            type: 'string',
            nullable: true,
            title: 'Aktenzeichen',
            maxLength: 256
        },
        social_law_appointment_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Termin (Datum)'
        },
        social_law_appointment_time: {
            type: 'string',
            nullable: true,
            title: 'Termin (Uhrzeit)',
            maxLength: 256
        },
        social_law_appointment_purpose: {
            type: 'string',
            nullable: true,
            title: 'Zweck des Termins',
            maxLength: 512
        },
        social_law_appointment_required_documents: {
            type: 'string',
            nullable: true,
            title: 'Mitzubringende Unterlagen',
            maxLength: 512
        },
        debt_collection_law_invoice_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Rechnungsdatum'
        },
        debt_collection_law_invoice_number: {
            type: 'string',
            nullable: true,
            title: 'Rechnungsnummer',
            maxLength: 100
        },
        debt_collection_law_invoice_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Rechnungsbetrag'
        },
        debt_collection_law_invoice_ground: {
            type: 'string',
            nullable: true,
            title: 'Rechnungsgrund',
            maxLength: 100
        },
        debt_collection_law_invoice_recipient: {
            type: 'string',
            nullable: true,
            title: 'Rechnungsadressat',
            maxLength: 100
        },
        debt_collection_law_invoice_tax_number: {
            type: 'string',
            nullable: true,
            title: 'Steuernummer',
            maxLength: 100
        },
        debt_collection_law_case_value: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Gegenstandswert'
        },
        debt_collection_law_business_fee: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: '1,3 Geschäftsgebühr (Nr. 2300 VV RVG)'
        },
        debt_collection_law_lumps_sum_expenses: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Auslagenpauschale (Nr. 7002 VV RVG)'
        },
        debt_collection_law_subtotal_lawyer_fees: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Zwischensumme Netto'
        },
        debt_collection_law_sales_tax: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Umsatzsteuer (19%)'
        },
        debt_collection_law_total_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Gesamtbetrag'
        },
        tenancy_law_rental_object_size_sqm: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Größe Mietobjekt Quadratmeter'
        },
        tenancy_law_rental_agreement_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Mietvertragsdatum'
        },
        tenancy_law_last_signature_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum letzte Unterschrift Mietvertrag'
        },
        tenancy_law_net_rent: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Nettomiete'
        },
        tenancy_law_gross_rent: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Bruttomiete'
        },
        tenancy_law_total_rent: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Gesamtmiete'
        },
        tenancy_law_unlimited_term_tenancy: {
            type: 'boolean',
            nullable: true,
            title: 'Unbefristeter Mietvertrag'
        },
        tenancy_law_fixed_term_tenancy: {
            type: 'boolean',
            nullable: true,
            title: 'Befristeter Mietvertrag'
        },
        tenancy_law_rental_agreement_duration: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Dauer Mietvertrag'
        },
        tenancy_law_rental_agreement_validity_start: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Mietvertragsbeginn'
        },
        tenancy_law_rental_agreement_validity_end: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Mietvertragsende'
        },
        tenancy_law_staggered_rental_agreement: {
            type: 'boolean',
            nullable: true,
            title: 'Staffelmietvereinbarung'
        },
        tenancy_law_value_security_clause: {
            type: 'boolean',
            nullable: true,
            title: 'Wertsicherungsklausel'
        },
        tenancy_law_tenant_extension_option: {
            type: 'boolean',
            nullable: true,
            title: 'Verlängerungsoption zugunsten Mieter'
        },
        tenancy_law_extension_option_count: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Anzahl Verlängerungsoptionen'
        },
        tenancy_law_extension_option_duration: {
            type: 'string',
            nullable: true,
            title: 'Dauer Verlängerungsoption',
            maxLength: 128
        },
        tenancy_law_security_deposit_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Kautionshöhe'
        },
        tenancy_law_security_deposit_additional_regulations: {
            type: 'string',
            nullable: true,
            title: 'Zusätzliche Regelungen zur Kaution'
        },
        tenancy_law_cash_deposit_agreed: {
            type: 'boolean',
            nullable: true,
            title: 'Barkaution vertraglich vereinbart'
        },
        tenancy_law_cash_deposit_payment_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Barkaution Datum Zahlung'
        },
        tenancy_law_bank_guarantee: {
            type: 'boolean',
            nullable: true,
            title: 'Bankbürgschaft'
        },
        tenancy_law_operating_costs_agreement: {
            type: 'string',
            nullable: true,
            title: 'Betriebskostenvereinbarung',
            maxLength: 128
        },
        tenancy_law_advance_payment_service_charges: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Nebenkostenvorauszahlungshöhe'
        },
        tenancy_law_adress_rental_property: {
            type: 'string',
            nullable: true,
            title: 'Adresse des Mietobjekts',
            maxLength: 128
        },
        tenancy_law_description_of_rental_property: {
            type: 'string',
            nullable: true,
            title: 'Beschreibung des Mietobjekts',
            maxLength: 128
        },
        tenancy_law_location_in_rental_property: {
            type: 'string',
            nullable: true,
            title: 'Lage im Mietobjekt',
            maxLength: 128
        },
        tenancy_law_garage_available: {
            type: 'boolean',
            nullable: true,
            title: 'Garage vorhanden'
        },
        tenancy_law_garage_costs: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Kosten Garage'
        },
        tenancy_law_parking_space_available: {
            type: 'boolean',
            nullable: true,
            title: 'Stellplatz vorhanden'
        },
        tenancy_law_parking_space_costs: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Kosten des Stellplatzes'
        },
        tenancy_law_start_of_lease: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Beginn des Pachtvertrags'
        },
        tenancy_law_duration_of_lease: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Dauer des Pachtvertrags'
        },
        tenancy_law_repayment_period_start: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Beginn des Abrechnungszeitraums'
        },
        tenancy_law_repayment_period_end: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Ende des Abrechnungszeitraums'
        },
        tenancy_law_total_cost_service_charge: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Gesamtkosten Nebenkostenabrechnung'
        },
        tenancy_law_cost_shares: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Umlageschlüssel'
        },
        tenancy_law_cost_share: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Kostenanteil Mieter'
        },
        tenancy_law_advance_payment_service_charge: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Vorauszahlungen Nebenkostenabrechnung'
        },
        tenancy_law_repayment: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Nachzahlung/Guthaben'
        },
        tenancy_law_handover_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Übergabedatum'
        },
        tenancy_law_handover_counter: {
            type: 'string',
            nullable: true,
            title: 'Zählerstand',
            maxLength: 128
        },
        tenancy_law_counter_number: {
            type: 'string',
            nullable: true,
            title: 'Zählerstandnummer',
            maxLength: 128
        },
        tenancy_law_handover_defects: {
            type: 'string',
            nullable: true,
            title: 'Mängel',
            maxLength: 128
        },
        tenancy_law_expert_report_damage_number: {
            type: 'string',
            nullable: true,
            title: 'Schadennummer',
            maxLength: 100
        },
        tenancy_law_expert_report_object_address: {
            type: 'string',
            nullable: true,
            title: 'Objekt Adresse',
            maxLength: 200
        },
        tenancy_law_expert_report_subject: {
            type: 'string',
            nullable: true,
            title: 'Gegenstand',
            maxLength: 200
        },
        tenancy_law_expert_report_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Gutachten'
        },
        tenancy_law_expert_report_purpose: {
            type: 'string',
            nullable: true,
            title: 'Zweck des Gutachtens'
        },
        tenancy_law_expert_report_commission_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Beauftragung Datum'
        },
        tenancy_law_expert_report_inspection_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Ortsbesichtigung Datum'
        },
        tenancy_law_expert_report_damage_description: {
            type: 'string',
            nullable: true,
            title: 'Schaden'
        },
        tenancy_law_expert_report_repair_duration: {
            type: 'string',
            nullable: true,
            title: 'Dauer Schadenbeseitigung',
            maxLength: 100
        },
        tenancy_law_tenant_warned: {
            type: 'boolean',
            nullable: true,
            title: 'Mieter abgemahnt'
        },
        tenancy_law_warning_letter_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Mahnschreiben'
        },
        tenancy_law_landlord_termination_given: {
            type: 'boolean',
            nullable: true,
            title: 'Kündigung durch Vermieter erfolgt'
        },
        tenancy_law_termination_declared_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Kündigungserklärung'
        },
        tenancy_law_termination_notice_period: {
            type: 'string',
            nullable: true,
            title: 'Kündigungsfrist',
            maxLength: 128
        },
        tenancy_law_termination_letter_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Kündigungsschreiben vom'
        },
        tenancy_law_tenancy_terminated: {
            type: 'boolean',
            nullable: true,
            title: 'Mietverhältnis beendet'
        },
        tenancy_law_tenancy_termination_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Beendigung Mietverhältnisses'
        },
        tenancy_law_property_return_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Rückgabe des Objekts Datum'
        },
        tenancy_law_court_proceedings_pending: {
            type: 'boolean',
            nullable: true,
            title: 'Gerichtliches Verfahren anhängig'
        },
        tenancy_law_competent_court: {
            type: 'string',
            nullable: true,
            title: 'Zuständiges Gericht',
            maxLength: 128
        },
        tenancy_law_court_case_number: {
            type: 'string',
            nullable: true,
            title: 'Gerichtliches Aktenzeichen',
            maxLength: 128
        },
        tenancy_law_last_rent_increase_letter_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum letztes Mieterhöhungsschreiben'
        },
        tenancy_law_rent_increase_effective_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Mieterhöhung wirksam geworden zum'
        },
        residential_property_law_contract_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Wegvertragsdatum'
        },
        residential_property_law_land_register_number: {
            type: 'string',
            nullable: true,
            title: 'Grundbuch Nr.',
            maxLength: 100
        },
        residential_property_law_land_register_city: {
            type: 'string',
            nullable: true,
            title: 'Grundbuch Stadt',
            maxLength: 100
        },
        residential_property_law_land_register_plot_of_land: {
            type: 'string',
            nullable: true,
            title: 'Grundbuch Flurstück',
            maxLength: 100
        },
        residential_property_law_land_register_address: {
            type: 'string',
            nullable: true,
            title: 'Grundbuch Lage',
            maxLength: 100
        },
        residential_property_law_co_ownership_shares: {
            type: 'string',
            nullable: true,
            title: 'Miteigentumsanteile',
            maxLength: 100
        },
        residential_property_law_inventory: {
            type: 'string',
            nullable: true,
            title: 'Bestandsverzeichnis',
            maxLength: 100
        },
        inheritance_law_certificate_of_inheritance_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Erbscheins'
        },
        inheritance_law_certificate_of_inheritance_number: {
            type: 'string',
            nullable: true,
            title: 'Nummer des Erbscheins',
            maxLength: 128
        },
        inheritance_law_certificate_of_inheritance_date_death: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Todesdatum'
        },
        inheritance_law_certificate_of_inheritance_place_of_death: {
            type: 'string',
            nullable: true,
            title: 'Todesort',
            maxLength: 128
        },
        inheritance_law_certificate_of_inheritance_applicable_law: {
            type: 'string',
            nullable: true,
            title: 'Anwendbares Recht',
            maxLength: 128
        },
        inheritance_law_inheritance_contract_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum des Erbvertrags'
        },
        inheritance_law_death_certificate_number: {
            type: 'string',
            nullable: true,
            title: 'Nummer Sterbeurkunde',
            maxLength: 128
        },
        inheritance_law_death_certificate_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Sterbeurkunde'
        },
        inheritance_law_death_certificate_place: {
            type: 'string',
            nullable: true,
            title: 'Ort Sterbeurkunde',
            maxLength: 128
        },
        inheritance_law_death_certificate_date_death: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Todesdatum'
        },
        inheritance_law_death_certificate_time_death: {
            type: 'string',
            format: 'time',
            nullable: true,
            title: 'Uhrzeit des Todes'
        },
        inheritance_law_death_certificate_place_death: {
            type: 'string',
            nullable: true,
            title: 'Ort des Todes',
            maxLength: 128
        },
        inheritance_law_testament_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum des Testaments'
        },
        inheritance_law_estate_inventory_status: {
            type: 'string',
            nullable: true,
            title: 'Güterstand',
            maxLength: 128
        },
        inheritance_law_estate_inventory_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Nachlassverzeichnis'
        },
        inheritance_law_estate_inventory_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Nettonachlass'
        },
        inheritance_law_patient_enrollment_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Patientenverfügung'
        },
        inheritance_law_lasting_power_of_attorney_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Vorsorgevollmacht'
        },
        real_estate_law_land_register_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Grundbuchauszugdatum'
        },
        real_estate_law_encumbrance_restrictions: {
            type: 'string',
            nullable: true,
            title: 'Lasten und Beschränkungen',
            maxLength: 128
        },
        real_estate_law_basic_debts_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Grundschulden'
        },
        real_estate_law_land_register_number: {
            type: 'string',
            nullable: true,
            title: 'Grundbuch Nr.',
            maxLength: 100
        },
        real_estate_law_land_register_city: {
            type: 'string',
            nullable: true,
            title: 'Grundbuch Stadt',
            maxLength: 100
        },
        real_estate_law_land_register_plot_of_land: {
            type: 'string',
            nullable: true,
            title: 'Grundbuch Flurstück',
            maxLength: 100
        },
        real_estate_law_land_register_address: {
            type: 'string',
            nullable: true,
            title: 'Grundbuch Lage',
            maxLength: 100
        },
        real_estate_law_plot_size: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Grundstücksgröße'
        },
        real_estate_law_purchase_contract_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Kaufvertragsdatum'
        },
        real_estate_law_purchase_contract_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Kaufvertragsbetrag'
        },
        real_estate_law_purchase_contract_description: {
            type: 'string',
            nullable: true,
            title: 'Kaufvertrag Objektbeschreibung',
            maxLength: 128
        },
        real_estate_law_purchase_contract_registration_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Kaufvertragsbeurkundungsdatum'
        },
        real_estate_law_purchase_contract_registration_number: {
            type: 'string',
            nullable: true,
            title: 'Urkundenrollennummer',
            maxLength: 100
        },
        real_estate_law_brokerage_fee: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Makler Provision'
        },
        real_estate_law_property_brokered_by_agent: {
            type: 'boolean',
            nullable: true,
            title: 'Objekt durch Makler vermittelt'
        },
        real_estate_law_purchase_object_rented: {
            type: 'boolean',
            nullable: true,
            title: 'Kaufobjekt vermietet'
        },
        real_estate_law_encumbrances_section_ii: {
            type: 'string',
            nullable: true,
            title: 'Belastungen Abt. II Grundbuch'
        },
        real_estate_law_encumbrances_section_iii: {
            type: 'string',
            nullable: true,
            title: 'Belastungen Abt. III Grundbuch'
        },
        real_estate_law_building_restrictions_clause: {
            type: 'string',
            nullable: true,
            title: 'Regelungen zu Baulasten'
        },
        real_estate_law_contaminated_sites_clause: {
            type: 'string',
            nullable: true,
            title: 'Regelung zu Altlasten'
        },
        real_estate_law_legal_defects_clause: {
            type: 'string',
            nullable: true,
            title: 'Klausel zu Rechtsmängeln'
        },
        real_estate_law_purchase_price_loan_financed: {
            type: 'boolean',
            nullable: true,
            title: 'Kaufpreis durch Darlehen finanziert'
        },
        real_estate_law_withdrawal_instruction_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Widerrufsbelehrung Datum'
        },
        real_estate_law_building_permit_validity_duration: {
            type: 'string',
            nullable: true,
            title: 'Gültigkeitsdauer',
            maxLength: 100
        },
        real_estate_law_building_permit_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Baugenehmigungsdatum'
        },
        real_estate_law_building_permit_number: {
            type: 'string',
            nullable: true,
            title: 'Genehmigungsnummer',
            maxLength: 100
        },
        real_estate_law_co_ownership_share: {
            type: 'string',
            nullable: true,
            title: 'Miteigentumsanteil',
            maxLength: 100
        },
        real_estate_law_division_declaration_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Teilungserklärung'
        },
        real_estate_law_plan_designation: {
            type: 'string',
            nullable: true,
            title: 'Planbezeichnung',
            maxLength: 100
        },
        real_estate_law_plan_scale: {
            type: 'string',
            nullable: true,
            title: 'Maßstab',
            maxLength: 100
        },
        real_estate_law_plan_author: {
            type: 'string',
            nullable: true,
            title: 'Planverfasser',
            maxLength: 100
        },
        real_estate_law_building_usage: {
            type: 'string',
            nullable: true,
            title: 'Gebäudenutzung',
            maxLength: 100
        },
        real_estate_law_building_dimensions: {
            type: 'string',
            nullable: true,
            title: 'Baukörperabmessung',
            maxLength: 100
        },
        real_estate_law_monument_protection_order_number: {
            type: 'string',
            nullable: true,
            title: 'Bescheid - Nr.',
            maxLength: 100
        },
        real_estate_law_monument_protection_order_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum des Denkmalschutzbescheides'
        },
        real_estate_law_monument_protection_basis: {
            type: 'string',
            nullable: true,
            title: 'Schutzgrundlage',
            maxLength: 100
        },
        real_estate_law_monument_registration_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Eintragungsdatum'
        },
        real_estate_law_monument_protection_requirements: {
            type: 'string',
            nullable: true,
            title: 'Auflagen'
        },
        real_estate_law_loan_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Darlehenssumme'
        },
        real_estate_law_interest_rate: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,3}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Zinssatz'
        },
        real_estate_law_installment_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Ratenhöhe'
        },
        real_estate_law_full_repayment_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Vollständige Rückzahlung'
        },
        real_estate_law_loan_security: {
            type: 'string',
            nullable: true,
            title: 'Darlehnsabsicherung',
            maxLength: 100
        },
        real_estate_law_repayment_rate: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,3}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Tilgungssatz'
        },
        real_estate_law_broker_commission_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Provisionshöhe'
        },
        real_estate_law_broker_scope_of_work: {
            type: 'string',
            nullable: true,
            title: 'Tätigkeitsumfang'
        },
        real_estate_law_broker_termination_periods: {
            type: 'string',
            nullable: true,
            title: 'Kündigungsfristen',
            maxLength: 100
        },
        real_estate_law_broker_contract_type: {
            type: 'string',
            nullable: true,
            title: 'Art des Maklervertrags',
            maxLength: 100
        },
        real_estate_law_brokerage_contract_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Maklervertrag Datum'
        },
        real_estate_law_exclusive_brokerage_contract: {
            type: 'boolean',
            nullable: true,
            title: 'Alleinauftrag'
        },
        real_estate_law_commission_percentage: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,3}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Provisionshöhe in %'
        },
        migration_law_residence_permit_issue_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Ausstellungsdatum'
        },
        migration_law_residence_permit_valid_until: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Gültig bis'
        },
        migration_law_residence_permit_type: {
            type: 'string',
            nullable: true,
            title: 'Titelart',
            maxLength: 100
        },
        migration_law_residence_permit_purpose: {
            type: 'string',
            nullable: true,
            title: 'Zweck des Aufenthalts',
            maxLength: 200
        },
        migration_law_residence_permit_issuing_authority: {
            type: 'string',
            nullable: true,
            title: 'Behörde',
            maxLength: 100
        },
        migration_law_residence_permit_conditions: {
            type: 'string',
            nullable: true,
            title: 'Auflagen / Nebenbestimmungen'
        },
        migration_law_residence_permit_passport_number: {
            type: 'string',
            nullable: true,
            title: 'Passnummer',
            maxLength: 50
        },
        migration_law_residence_permit_national_id_number: {
            type: 'string',
            nullable: true,
            title: 'Nationale Identitätsnummer',
            maxLength: 50
        },
        migration_law_fictional_certificate_issue_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Ausgestellt am'
        },
        migration_law_fictional_certificate_valid_until: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Gültig bis'
        },
        migration_law_fictional_certificate_legal_basis: {
            type: 'string',
            nullable: true,
            title: 'Rechtsgrundlage',
            maxLength: 100
        },
        migration_law_fictional_certificate_fiction_type: {
            type: 'string',
            nullable: true,
            title: 'Art der Fiktion',
            maxLength: 100
        },
        migration_law_fictional_certificate_reason_for_issuance: {
            type: 'string',
            nullable: true,
            title: 'Zweck der Erteilung',
            maxLength: 200
        },
        migration_law_fictional_certificate_authority: {
            type: 'string',
            nullable: true,
            title: 'Behörde',
            maxLength: 100
        },
        migration_law_toleration_issue_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Ausgestellt am'
        },
        migration_law_toleration_valid_until: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Gültig bis'
        },
        migration_law_toleration_reason: {
            type: 'string',
            nullable: true,
            title: 'Grund der Duldung',
            maxLength: 200
        },
        migration_law_toleration_legal_basis: {
            type: 'string',
            nullable: true,
            title: 'Rechtsgrundlage',
            maxLength: 100
        },
        migration_law_toleration_restrictions: {
            type: 'string',
            nullable: true,
            title: 'Beschränkungen'
        },
        migration_law_toleration_issuing_authority: {
            type: 'string',
            nullable: true,
            title: 'Behörde',
            maxLength: 100
        },
        migration_law_asylum_seeker_certificate_issue_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Ausstellungsdatum'
        },
        migration_law_asylum_seeker_certificate_valid_until: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Gültig bis'
        },
        migration_law_asylum_seeker_certificate_application_number: {
            type: 'string',
            nullable: true,
            title: 'Asylantragsnummer',
            maxLength: 100
        },
        migration_law_asylum_seeker_certificate_first_registration_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Erstregistrierung'
        },
        migration_law_asylum_seeker_certificate_residence_obligation: {
            type: 'string',
            nullable: true,
            title: 'Wohnsitzauflage',
            maxLength: 200
        },
        migration_law_asylum_seeker_certificate_issuing_authority: {
            type: 'string',
            nullable: true,
            title: 'Behörde',
            maxLength: 100
        },
        migration_law_asylum_seeker_certificate_work_permission: {
            type: 'string',
            nullable: true,
            title: 'Arbeitserlaubnis',
            maxLength: 100
        },
        migration_law_rejection_notice_case_number: {
            type: 'string',
            nullable: true,
            title: 'Aktenzeichen',
            maxLength: 100
        },
        migration_law_rejection_notice_decision_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum des Bescheids'
        },
        migration_law_rejection_notice_subject: {
            type: 'string',
            nullable: true,
            title: 'Betreff',
            maxLength: 200
        },
        migration_law_rejection_notice_legal_remedy_deadline: {
            type: 'string',
            nullable: true,
            title: 'Rechtsbehelf / Frist',
            maxLength: 200
        },
        migration_law_rejection_notice_reasoning: {
            type: 'string',
            nullable: true,
            title: 'Begründung'
        },
        migration_law_rejection_notice_legal_grounds: {
            type: 'string',
            nullable: true,
            title: 'Gesetzesgrundlagen',
            maxLength: 200
        },
        migration_law_rejection_notice_officer_name: {
            type: 'string',
            nullable: true,
            title: 'Name des Sachbearbeiters',
            maxLength: 100
        },
        migration_law_rejection_notice_signature_seal: {
            type: 'string',
            nullable: true,
            title: 'Unterschrift / Dienstsiegel',
            maxLength: 100
        },
        migration_law_approval_notice_case_number: {
            type: 'string',
            nullable: true,
            title: 'Aktenzeichen',
            maxLength: 100
        },
        migration_law_approval_notice_decision_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum des Bescheids'
        },
        migration_law_approval_notice_permit_type: {
            type: 'string',
            nullable: true,
            title: 'Art des Aufenthaltstitels',
            maxLength: 100
        },
        migration_law_approval_notice_validity_period: {
            type: 'string',
            nullable: true,
            title: 'Gültigkeitszeitraum',
            maxLength: 100
        },
        migration_law_approval_notice_conditions: {
            type: 'string',
            nullable: true,
            title: 'Auflagen'
        },
        migration_law_approval_notice_pickup_deadline: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Abholfrist'
        },
        migration_law_approval_notice_issuing_authority: {
            type: 'string',
            nullable: true,
            title: 'Ausstellende Behörde',
            maxLength: 100
        },
        migration_law_hearing_letter_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum des Schreibens'
        },
        migration_law_hearing_letter_response_deadline: {
            type: 'string',
            nullable: true,
            title: 'Frist zur Stellungnahme',
            maxLength: 100
        },
        migration_law_hearing_letter_intended_measure_justification: {
            type: 'string',
            nullable: true,
            title: 'Begründung der beabsichtigten Maßnahme'
        },
        migration_law_hearing_letter_legal_advice: {
            type: 'string',
            nullable: true,
            title: 'Rechtsbehelfshinweis'
        },
        migration_law_hearing_letter_requested_documents: {
            type: 'string',
            nullable: true,
            title: 'Dokumente beizufügen'
        },
        migration_law_cooperation_letter_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum des Schreibens'
        },
        migration_law_cooperation_letter_file_number: {
            type: 'string',
            nullable: true,
            title: 'Aktenzeichen',
            maxLength: 100
        },
        migration_law_cooperation_letter_specified_obligations: {
            type: 'string',
            nullable: true,
            title: 'Benannte Mitwirkungspflichten'
        },
        migration_law_cooperation_letter_non_cooperation_consequences: {
            type: 'string',
            nullable: true,
            title: 'Rechtsfolgen bei Nichtmitwirkung'
        },
        migration_law_cooperation_letter_deadlines: {
            type: 'string',
            nullable: true,
            title: 'Fristen',
            maxLength: 200
        },
        migration_law_cooperation_letter_attachments: {
            type: 'string',
            nullable: true,
            title: 'Anlagen / Formulare'
        },
        migration_law_other_letters_issuing_authority: {
            type: 'string',
            nullable: true,
            title: 'Absenderbehörde',
            maxLength: 100
        },
        migration_law_other_letters_file_number: {
            type: 'string',
            nullable: true,
            title: 'Aktenzeichen / Geschäftszeichen',
            maxLength: 100
        },
        migration_law_other_letters_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum des Schreibens'
        },
        migration_law_other_letters_subject: {
            type: 'string',
            nullable: true,
            title: 'Betreff',
            maxLength: 200
        },
        migration_law_other_letters_matter_purpose: {
            type: 'string',
            nullable: true,
            title: 'Anliegen / Inhalt des Schreibens'
        },
        migration_law_other_letters_legal_basis: {
            type: 'string',
            nullable: true,
            title: 'Rechtsgrundlage (sofern genannt)',
            maxLength: 200
        },
        migration_law_other_letters_deadlines: {
            type: 'string',
            nullable: true,
            title: 'Fristen',
            maxLength: 200
        },
        migration_law_other_letters_action_required: {
            type: 'string',
            nullable: true,
            title: 'Handlungsaufforderung'
        },
        civil_law_file_reference: {
            type: 'string',
            nullable: true,
            title: 'Aktenzeichen',
            maxLength: 100
        },
        civil_law_document_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Dokumentdatum'
        },
        civil_law_subject_line: {
            type: 'string',
            nullable: true,
            title: 'Betreff',
            maxLength: 255
        },
        civil_law_contract_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Vertragsdatum'
        },
        civil_law_contract_start_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Vertragsbeginn'
        },
        civil_law_contract_end_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Vertragsende'
        },
        civil_law_contract_duration: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Vertragslaufzeit in Monaten'
        },
        civil_law_contract_value: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Vertragswert'
        },
        civil_law_contract_object: {
            type: 'string',
            nullable: true,
            title: 'Vertragsgegenstand',
            maxLength: 255
        },
        civil_law_termination_notice_period: {
            type: 'string',
            nullable: true,
            title: 'Kündigungsfrist',
            maxLength: 100
        },
        civil_law_notarial_certification_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Notarielle Beurkundung Datum'
        },
        civil_law_purchase_price: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Kaufpreis'
        },
        civil_law_purchase_price_components: {
            type: 'string',
            nullable: true,
            title: 'Bestandteile Kaufpreis'
        },
        civil_law_accessories_sold_separately: {
            type: 'boolean',
            nullable: true,
            title: 'Zubehör separat veräußert?'
        },
        civil_law_purchase_contract_file_reference: {
            type: 'string',
            nullable: true,
            title: 'Kaufvertragsaktenzeichen',
            maxLength: 100
        },
        civil_law_handover_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Übergabedatum'
        },
        civil_law_purchase_price_paid: {
            type: 'boolean',
            nullable: true,
            title: 'Kaufpreis bezahlt'
        },
        civil_law_purchase_price_payment_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Zahlung Kaufpreis'
        },
        civil_law_purchase_price_paid_boolean: {
            type: 'boolean',
            nullable: true,
            title: 'Kaufpreis bezahlt'
        },
        civil_law_purchase_price_paid_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum Kaufpreis bezahlt'
        },
        civil_law_purchase_price_paid_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Höhe bezahlten Kaufpreises'
        },
        civil_law_purchase_object: {
            type: 'string',
            nullable: true,
            title: 'Kaufgegenstand',
            maxLength: 255
        },
        civil_law_purchase_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Kaufdatum'
        },
        civil_law_delivery_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Lieferdatum'
        },
        civil_law_warranty_period: {
            type: 'string',
            nullable: true,
            title: 'Gewährleistungsfrist',
            maxLength: 100
        },
        civil_law_defects: {
            type: 'string',
            nullable: true,
            title: 'Mängel'
        },
        civil_law_defects_present: {
            type: 'boolean',
            nullable: true,
            title: 'Sachmängel vorhanden'
        },
        civil_law_vehicle_make: {
            type: 'string',
            nullable: true,
            title: 'Fahrzeugmarke',
            maxLength: 100
        },
        civil_law_vehicle_model: {
            type: 'string',
            nullable: true,
            title: 'Fahrzeugmodell',
            maxLength: 100
        },
        civil_law_vehicle_year: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Baujahr'
        },
        civil_law_vehicle_mileage: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            nullable: true,
            title: 'Kilometerstand'
        },
        civil_law_vehicle_vin: {
            type: 'string',
            nullable: true,
            title: 'Fahrgestellnummer',
            maxLength: 50
        },
        civil_law_damage_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Schadenshöhe'
        },
        civil_law_damage_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Schadensdatum'
        },
        civil_law_damage_description: {
            type: 'string',
            nullable: true,
            title: 'Schadensbeschreibung'
        },
        civil_law_damage_cause: {
            type: 'string',
            nullable: true,
            title: 'Schadensursache',
            maxLength: 255
        },
        civil_law_liability_percentage: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,3}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Haftungsquote in Prozent'
        },
        civil_law_insurance_claim_number: {
            type: 'string',
            nullable: true,
            title: 'Versicherungsschadensnummer',
            maxLength: 100
        },
        civil_law_court_name: {
            type: 'string',
            nullable: true,
            title: 'Gericht',
            maxLength: 255
        },
        civil_law_case_number: {
            type: 'string',
            nullable: true,
            title: 'Geschäftsnummer',
            maxLength: 100
        },
        civil_law_hearing_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Verhandlungstermin'
        },
        civil_law_judgment_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Urteilsdatum'
        },
        civil_law_claim_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Streitwert'
        },
        civil_law_court_costs: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Gerichtskosten'
        },
        civil_law_payment_due_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Fälligkeitsdatum'
        },
        civil_law_interest_rate: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,3}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Zinssatz'
        },
        civil_law_default_interest: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Verzugszinsen'
        },
        general_law_file_ref: {
            type: 'string',
            minLength: 1,
            title: 'Aktenzeichen',
            maxLength: 100
        },
        general_law_subject: {
            type: 'string',
            minLength: 1,
            title: 'Betreff'
        },
        general_law_doc_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Dokumentendatum'
        },
        general_law_prior_ref: {
            type: 'string',
            minLength: 1,
            title: 'Zeichen unseres Schreibens',
            maxLength: 200
        },
        general_law_appendices: {
            type: 'string',
            minLength: 1,
            title: 'Anlagen'
        },
        general_law_invoice_number: {
            type: 'string',
            minLength: 1,
            title: 'Rechnungsnummer',
            maxLength: 100
        },
        general_law_invoice_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Rechnungsdatum'
        },
        general_law_due_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Fälligkeitsdatum'
        },
        general_law_amount_total: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Gesamtbetrag'
        },
        general_law_amount_net: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Nettobetrag'
        },
        general_law_vat: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'MwSt / Umsatzsteuer'
        },
        general_law_payment_terms: {
            type: 'string',
            minLength: 1,
            title: 'Zahlungsbedingungen'
        },
        general_law_court_name: {
            type: 'string',
            minLength: 1,
            title: 'Gericht',
            maxLength: 200
        },
        general_law_case_number: {
            type: 'string',
            minLength: 1,
            title: 'Geschäftsnummer',
            maxLength: 100
        },
        general_law_hearing_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Verhandlungstermin'
        },
        general_law_judgment_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Urteilsdatum'
        },
        general_law_court_costs: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Gerichtskosten'
        },
        medicine_law_medical_report_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum des Berichts'
        },
        medicine_law_medical_report_treatment_period: {
            type: 'string',
            nullable: true,
            title: 'Zeitraum der Behandlung',
            maxLength: 200
        },
        medicine_law_medical_report_diagnosis_icd_code: {
            type: 'string',
            nullable: true,
            title: 'Diagnose ICD-Code',
            maxLength: 50
        },
        medicine_law_medical_report_diagnosis_short_text: {
            type: 'string',
            nullable: true,
            title: 'Diagnose Kurztext',
            maxLength: 200
        },
        medicine_law_medical_report_treatment_measures: {
            type: 'string',
            nullable: true,
            title: 'Therapie Behandlungsmaßnahmen'
        },
        medicine_law_medical_report_surgery_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'OP-Datum'
        },
        medicine_law_medical_report_complications: {
            type: 'string',
            nullable: true,
            title: 'Komplikationen'
        },
        medicine_law_medical_report_further_treatment: {
            type: 'string',
            nullable: true,
            title: 'Weitere Behandlung'
        },
        medicine_law_hospital_records_admission_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Aufnahmedatum'
        },
        medicine_law_hospital_records_discharge_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Entlassungsdatum'
        },
        medicine_law_hospital_records_station: {
            type: 'string',
            nullable: true,
            title: 'Station',
            maxLength: 100
        },
        medicine_law_hospital_records_diagnoses_icd_codes: {
            type: 'string',
            nullable: true,
            title: 'Diagnosen ICD-Codes'
        },
        medicine_law_hospital_records_operations: {
            type: 'string',
            nullable: true,
            title: 'Operationen'
        },
        medicine_law_hospital_records_operation_date: {
            type: 'string',
            nullable: true,
            title: 'Operation Datum'
        },
        medicine_law_hospital_records_medication_during_stay: {
            type: 'string',
            nullable: true,
            title: 'Medikation während Aufenthalt'
        },
        medicine_law_hospital_records_documented_complications: {
            type: 'string',
            nullable: true,
            title: 'Dokumentierte Komplikationen'
        },
        medicine_law_hospital_records_discharge_prognosis: {
            type: 'string',
            nullable: true,
            title: 'Prognose'
        },
        medicine_law_medical_expertise_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum des Gutachtens'
        },
        medicine_law_medical_expertise_question_posed: {
            type: 'string',
            nullable: true,
            title: 'Fragestellung des Gutachtens'
        },
        medicine_law_medical_expertise_medical_assessment: {
            type: 'string',
            nullable: true,
            title: 'Medizinische Einschätzung'
        },
        medicine_law_medical_expertise_justification: {
            type: 'string',
            nullable: true,
            title: 'Begründung des Ergebnisses'
        },
        medicine_law_medical_expertise_result: {
            type: 'string',
            nullable: true,
            title: 'Ergebnis des Gutachtens'
        },
        medicine_law_laboratory_results_examination_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum der Untersuchung'
        },
        medicine_law_laboratory_results_examination_type: {
            type: 'string',
            nullable: true,
            title: 'Art der Untersuchung',
            maxLength: 200
        },
        medicine_law_laboratory_results: {
            type: 'string',
            nullable: true,
            title: 'Befund'
        },
        medicine_law_laboratory_results_relevant_deviations: {
            type: 'string',
            nullable: true,
            title: 'Relevante Abweichungen'
        },
        medicine_law_laboratory_results_further_investigation_recommendation: {
            type: 'string',
            nullable: true,
            title: 'Empfehlung zur weiteren Abklärung'
        },
        medicine_law_health_insurance_letter_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Datum des Schreibens'
        },
        medicine_law_health_insurance_letter_reference_to_application: {
            type: 'string',
            nullable: true,
            title: 'Bezug auf Schreiben'
        },
        medicine_law_health_insurance_letter_decision: {
            type: 'string',
            nullable: true,
            title: 'Entscheidung der Krankenkasse',
            maxLength: 100
        },
        medicine_law_health_insurance_letter_decision_justification: {
            type: 'string',
            nullable: true,
            title: 'Begründung der Entscheidung'
        },
        medicine_law_health_insurance_letter_legal_remedy_instruction: {
            type: 'string',
            nullable: true,
            title: 'Rechtsbehelfsbelehrung'
        },
        medicine_law_medical_bill_invoice_date: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Rechnungsdatum'
        },
        medicine_law_medical_bill_invoice_number: {
            type: 'string',
            nullable: true,
            title: 'Rechnungsnummer',
            maxLength: 100
        },
        medicine_law_medical_bill_service_period: {
            type: 'string',
            nullable: true,
            title: 'Zeitraum der Leistung',
            maxLength: 200
        },
        medicine_law_medical_bill_services_list: {
            type: 'string',
            nullable: true,
            title: 'Auflistung der Leistungen'
        },
        medicine_law_medical_bill_total_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Gesamtsumme der Rechnung'
        },
        medicine_law_medical_bill_cost_bearer: {
            type: 'string',
            nullable: true,
            title: 'Kostenträger',
            maxLength: 100
        },
        medicine_law_medical_bill_payment_deadline: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Zahlungsfrist'
        },
        field: {
            type: 'string',
            title: 'Rechtsgebiet',
            maxLength: 100
        },
        topic: {
            type: 'string',
            title: 'Rechtsthema',
            maxLength: 100
        },
        external_case_id: {
            type: 'string',
            nullable: true,
            maxLength: 100
        }
    }
} as const;

export const $SourceEnum = {
    enum: ['AI_CHAT', 'DOCUMENT_GENERATION', 'ALL'],
    type: 'string',
    description: `* \`AI_CHAT\` - AI Chat
* \`DOCUMENT_GENERATION\` - Document Generation
* \`ALL\` - All`
} as const;

export const $StateEnum = {
    enum: ['NEW', 'IN_PROGRESS', 'COMPLETED', 'REJECTED'],
    type: 'string',
    description: `* \`NEW\` - neu
* \`IN_PROGRESS\` - in Bearbeitung
* \`COMPLETED\` - abgeschlossen
* \`REJECTED\` - abgelehnt`
} as const;

export const $StripeInvoiceExportRequestRequest = {
    type: 'object',
    properties: {
        month: {
            type: 'integer',
            maximum: 12,
            minimum: 1
        },
        year: {
            type: 'integer',
            maximum: 2025,
            minimum: 2000
        }
    },
    required: ['month', 'year']
} as const;

export const $StripeInvoiceExportResponse = {
    type: 'object',
    properties: {
        success: {
            type: 'boolean'
        },
        error: {
            type: 'string',
            default: ''
        },
        url: {
            type: 'string',
            format: 'uri',
            default: ''
        }
    },
    required: ['success']
} as const;

export const $SubmissionFormField = {
    type: 'object',
    description: 'Serializer for form fields in PDF form submissions.',
    properties: {
        uuid: {
            type: 'string'
        },
        type: {
            '$ref': '#/components/schemas/FormFieldTypeEnum'
        },
        tag: {
            type: 'string',
            nullable: true
        },
        tag_relationship: {
            nullable: true,
            oneOf: [
                {
                    '$ref': '#/components/schemas/TagRelationshipEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                },
                {
                    '$ref': '#/components/schemas/NullEnum'
                }
            ]
        },
        placeholder: {
            type: 'string'
        },
        required: {
            type: 'boolean'
        },
        assigned_to: {
            '$ref': '#/components/schemas/AssignedToEnum'
        },
        coordinates: {
            '$ref': '#/components/schemas/FormFieldCoordinates'
        },
        value: {
            type: 'string'
        },
        signed_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        }
    },
    required: ['assigned_to', 'coordinates', 'required', 'type']
} as const;

export const $SubmissionFormFieldRequest = {
    type: 'object',
    description: 'Serializer for form fields in PDF form submissions.',
    properties: {
        uuid: {
            type: 'string',
            minLength: 1
        },
        type: {
            '$ref': '#/components/schemas/FormFieldTypeEnum'
        },
        tag: {
            type: 'string',
            nullable: true
        },
        tag_relationship: {
            nullable: true,
            oneOf: [
                {
                    '$ref': '#/components/schemas/TagRelationshipEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                },
                {
                    '$ref': '#/components/schemas/NullEnum'
                }
            ]
        },
        placeholder: {
            type: 'string'
        },
        required: {
            type: 'boolean'
        },
        assigned_to: {
            '$ref': '#/components/schemas/AssignedToEnum'
        },
        coordinates: {
            '$ref': '#/components/schemas/FormFieldCoordinatesRequest'
        },
        value: {
            type: 'string'
        },
        signed_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        }
    },
    required: ['assigned_to', 'coordinates', 'required', 'type']
} as const;

export const $SubmissionStatusEnum = {
    enum: ['in_progress', 'completed'],
    type: 'string',
    description: `* \`in_progress\` - In Progress
* \`completed\` - Completed`
} as const;

export const $SubmitRequestRequest = {
    type: 'object',
    description: 'Serializer for submitting request responses.',
    properties: {
        annotation_data: {
            type: 'array',
            items: {
                type: 'object',
                additionalProperties: {}
            },
            description: 'Annotation data for the form fields'
        },
        signatures: {
            type: 'object',
            additionalProperties: {},
            description: 'Signature data for the form'
        }
    }
} as const;

export const $SuperUserAccount = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        account_id: {
            type: 'string',
            maxLength: 28
        }
    },
    required: ['account_id']
} as const;

export const $SuperUserAccountRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        account_id: {
            type: 'string',
            minLength: 1,
            maxLength: 28
        }
    },
    required: ['account_id']
} as const;

export const $SuperUserActionAutoCommitSettings = {
    type: 'object',
    description: 'ActionAutoCommitSettings representation for superusers.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        auto_commit_settings_key: {
            type: 'string',
            maxLength: 255
        },
        can_auto_commit: {
            type: 'boolean'
        },
        additional_user_instructions: {
            type: 'string'
        },
        confidence_threshold: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648
        }
    },
    required: ['auto_commit_settings_key', 'uuid']
} as const;

export const $SuperUserActionAutoCommitSettingsRequest = {
    type: 'object',
    description: 'ActionAutoCommitSettings representation for superusers.',
    properties: {
        auto_commit_settings_key: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        },
        can_auto_commit: {
            type: 'boolean'
        },
        additional_user_instructions: {
            type: 'string'
        },
        confidence_threshold: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648
        }
    },
    required: ['auto_commit_settings_key']
} as const;

export const $SuperUserActivity = {
    type: 'object',
    description: 'Activity serializer for superuser role.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        seen_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        activity_type: {
            '$ref': '#/components/schemas/ActivityTypeEnum'
        },
        case_uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        case_client_display_name: {
            type: 'string',
            readOnly: true
        },
        case_client_initials: {
            type: 'string',
            readOnly: true
        },
        case_client_email: {
            type: 'string',
            readOnly: true
        },
        clerk_uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true,
            nullable: true
        },
        clerk_first_name: {
            type: 'string',
            readOnly: true,
            nullable: true
        },
        clerk_last_name: {
            type: 'string',
            readOnly: true,
            nullable: true
        },
        document_title: {
            type: 'string',
            readOnly: true,
            nullable: true
        },
        questionnaire_title: {
            type: 'string',
            readOnly: true,
            nullable: true
        },
        email_from: {
            type: 'string',
            format: 'email',
            readOnly: true,
            nullable: true
        },
        email_to: {
            type: 'string',
            readOnly: true
        },
        appointment_start: {
            type: 'string',
            format: 'date-time',
            readOnly: true,
            nullable: true
        },
        appointment_is_confirmed: {
            type: 'boolean',
            readOnly: true,
            nullable: true
        }
    },
    required: ['activity_type', 'appointment_is_confirmed', 'appointment_start', 'case_client_display_name', 'case_client_email', 'case_client_initials', 'case_uuid', 'clerk_first_name', 'clerk_last_name', 'clerk_uuid', 'created_at', 'document_title', 'email_from', 'email_to', 'questionnaire_title']
} as const;

export const $SuperUserActivityRequest = {
    type: 'object',
    description: 'Activity serializer for superuser role.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        seen_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        activity_type: {
            '$ref': '#/components/schemas/ActivityTypeEnum'
        }
    },
    required: ['activity_type']
} as const;

export const $SuperUserAgentAction = {
    type: 'object',
    description: 'AgentAction representation for superusers.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        updated_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        agent: {
            type: 'string',
            readOnly: true
        },
        agent_trace_id: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        calling_agent: {
            type: 'string',
            readOnly: true,
            nullable: true
        },
        calling_agent_trace_id: {
            type: 'string',
            format: 'uuid',
            readOnly: true,
            nullable: true
        },
        action_type: {
            allOf: [
                {
                    '$ref': '#/components/schemas/ActionTypeEnum'
                }
            ],
            readOnly: true
        },
        delivery_mode: {
            allOf: [
                {
                    '$ref': '#/components/schemas/DeliveryModeEnum'
                }
            ],
            readOnly: true
        },
        reasoning_translation: {
            type: 'string',
            readOnly: true
        },
        reasoning_commit_decision_translation: {
            type: 'string',
            readOnly: true
        },
        payload: {
            type: 'string',
            readOnly: true
        },
        revert_payload: {
            type: 'string',
            readOnly: true
        },
        is_commitable: {
            type: 'boolean',
            readOnly: true
        },
        is_committed: {
            type: 'boolean',
            readOnly: true
        },
        is_committing: {
            type: 'boolean',
            readOnly: true
        },
        commit_return_value: {
            readOnly: true,
            nullable: true
        },
        commited_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true,
            nullable: true
        },
        commited_by_uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        has_commit_error: {
            type: 'boolean',
            readOnly: true,
            nullable: true
        },
        commit_error: {
            type: 'string',
            readOnly: true,
            nullable: true
        },
        is_revertable: {
            type: 'boolean',
            readOnly: true
        },
        is_reverted: {
            type: 'boolean',
            readOnly: true
        },
        is_reverting: {
            type: 'boolean',
            readOnly: true
        },
        revert_return_value: {
            readOnly: true,
            nullable: true
        },
        reverted_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true,
            nullable: true
        },
        reverted_by_uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        has_revert_error: {
            type: 'boolean',
            readOnly: true,
            nullable: true
        },
        revert_error: {
            type: 'string',
            readOnly: true,
            nullable: true
        },
        case_uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        org_uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        rating: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,1}(?:\\.\\d{0,1})?$',
            readOnly: true,
            nullable: true
        },
        langfuse_trace_url: {
            type: 'string',
            readOnly: true
        }
    },
    required: ['action_type', 'agent', 'agent_trace_id', 'calling_agent', 'calling_agent_trace_id', 'case_uuid', 'commit_error', 'commit_return_value', 'commited_at', 'commited_by_uuid', 'created_at', 'delivery_mode', 'has_commit_error', 'has_revert_error', 'is_commitable', 'is_committed', 'is_committing', 'is_revertable', 'is_reverted', 'is_reverting', 'langfuse_trace_url', 'org_uuid', 'payload', 'rating', 'reasoning_commit_decision_translation', 'reasoning_translation', 'revert_error', 'revert_payload', 'revert_return_value', 'reverted_at', 'reverted_by_uuid', 'updated_at', 'uuid']
} as const;

export const $SuperUserAiAnalysis = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        mapper_key: {
            type: 'string',
            readOnly: true
        },
        ai_augments_mapper_keys: {
            readOnly: true
        },
        started_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true,
            nullable: true
        },
        finished_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true,
            nullable: true
        },
        is_finished: {
            type: 'boolean',
            readOnly: true
        },
        case_uuid: {
            type: 'string',
            format: 'uuid'
        },
        document_uuid: {
            type: 'string',
            format: 'uuid'
        }
    },
    required: ['ai_augments_mapper_keys', 'case_uuid', 'document_uuid', 'finished_at', 'is_finished', 'mapper_key', 'started_at', 'uuid']
} as const;

export const $SuperUserAiAnalysisRequest = {
    type: 'object',
    properties: {
        case_uuid: {
            type: 'string',
            format: 'uuid'
        },
        document_uuid: {
            type: 'string',
            format: 'uuid'
        }
    },
    required: ['case_uuid', 'document_uuid']
} as const;

export const $SuperUserAiAugmentation = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        augmentation_variant: {
            allOf: [
                {
                    '$ref': '#/components/schemas/AugmentationVariantEnum'
                }
            ],
            readOnly: true
        },
        document: {
            '$ref': '#/components/schemas/Document'
        },
        value: {
            oneOf: [
                {
                    type: 'string'
                },
                {
                    type: 'integer'
                },
                {
                    type: 'boolean'
                },
                {
                    type: 'string',
                    format: 'date'
                },
                {
                    type: 'object',
                    additionalProperties: {}
                },
                {
                    type: 'array',
                    items: {}
                }
            ]
        },
        analysis_mapper_key: {
            type: 'string',
            readOnly: true,
            nullable: true
        },
        augmented_mapper_key: {
            type: 'string',
            readOnly: true
        },
        referenced_document_pages: {
            type: 'array',
            items: {
                type: 'integer'
            }
        },
        explanation: {
            type: 'string'
        }
    },
    required: ['analysis_mapper_key', 'augmentation_variant', 'augmented_mapper_key', 'document', 'explanation', 'referenced_document_pages', 'uuid', 'value']
} as const;

export const $SuperUserAiAugmentationRequest = {
    type: 'object',
    properties: {
        value: {
            oneOf: [
                {
                    type: 'string'
                },
                {
                    type: 'integer'
                },
                {
                    type: 'boolean'
                },
                {
                    type: 'string',
                    format: 'date'
                },
                {
                    type: 'object',
                    additionalProperties: {}
                },
                {
                    type: 'array',
                    items: {}
                }
            ]
        },
        referenced_document_pages: {
            type: 'array',
            items: {
                type: 'integer'
            }
        },
        explanation: {
            type: 'string',
            minLength: 1
        }
    },
    required: ['explanation', 'referenced_document_pages', 'value']
} as const;

export const $SuperUserAiSettings = {
    type: 'object',
    description: 'AI Settings representation for superusers.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        entity_extraction_instructions: {
            type: 'string',
            description: 'Instructions for AI agents when performing entity extraction'
        },
        organisation: {
            type: 'integer',
            readOnly: true
        },
        auto_commit_settings: {
            type: 'string'
        },
        notification_settings: {
            type: 'string'
        },
        ai_workflows_enabled: {
            type: 'boolean',
            description: 'Enable or disable AI workflows for this organisation. When disabled, AI workflows will not be executed for cases in this organisation.'
        },
        send_notifications_bundled: {
            type: 'boolean',
            description: 'Whether to send notifications bundled or individually'
        },
        bundled_notifications_max_delay: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            description: 'Maximum delay in seconds before sending bundled notifications'
        },
        on_case_pre_case_context_gathering_instructions: {
            type: 'string',
            title: 'Pre Case Context Gathering Instructions',
            description: 'Instructions for AI agents during pre case context gathering'
        },
        on_case_post_case_context_gathering_instructions: {
            type: 'string',
            title: 'Post Case Context Gathering Instructions',
            description: 'Instructions for AI agents during post case context gathering'
        }
    },
    required: ['organisation', 'uuid']
} as const;

export const $SuperUserAiSettingsRequest = {
    type: 'object',
    description: 'AI Settings representation for superusers.',
    properties: {
        entity_extraction_instructions: {
            type: 'string',
            description: 'Instructions for AI agents when performing entity extraction'
        },
        auto_commit_settings: {
            type: 'string'
        },
        notification_settings: {
            type: 'string'
        },
        ai_workflows_enabled: {
            type: 'boolean',
            description: 'Enable or disable AI workflows for this organisation. When disabled, AI workflows will not be executed for cases in this organisation.'
        },
        send_notifications_bundled: {
            type: 'boolean',
            description: 'Whether to send notifications bundled or individually'
        },
        bundled_notifications_max_delay: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            description: 'Maximum delay in seconds before sending bundled notifications'
        },
        on_case_pre_case_context_gathering_instructions: {
            type: 'string',
            title: 'Pre Case Context Gathering Instructions',
            description: 'Instructions for AI agents during pre case context gathering'
        },
        on_case_post_case_context_gathering_instructions: {
            type: 'string',
            title: 'Post Case Context Gathering Instructions',
            description: 'Instructions for AI agents during post case context gathering'
        }
    }
} as const;

export const $SuperUserAnnouncement = {
    type: 'object',
    description: `Full announcement serializer for superusers.

Provides access to all fields for managing announcements.`,
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        message: {
            type: 'string',
            description: 'The announcement message to display'
        },
        message_type: {
            allOf: [
                {
                    '$ref': '#/components/schemas/MessageTypeEnum'
                }
            ],
            description: `The type of announcement (determines color/styling)

* \`INFO\` - Info
* \`WARNING\` - Warning
* \`ERROR\` - Error
* \`SUCCESS\` - Success`
        },
        is_active: {
            type: 'boolean',
            title: 'Active',
            description: 'Whether this announcement should be displayed'
        },
        start_date: {
            type: 'string',
            format: 'date-time',
            nullable: true,
            description: 'Optional start date for the announcement'
        },
        end_date: {
            type: 'string',
            format: 'date-time',
            nullable: true,
            description: 'Optional end date for the announcement'
        },
        dismissible: {
            type: 'boolean',
            description: 'Whether users can dismiss this announcement'
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        updated_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        }
    },
    required: ['created_at', 'message', 'updated_at', 'uuid']
} as const;

export const $SuperUserAnnouncementRequest = {
    type: 'object',
    description: `Full announcement serializer for superusers.

Provides access to all fields for managing announcements.`,
    properties: {
        message: {
            type: 'string',
            minLength: 1,
            description: 'The announcement message to display'
        },
        message_type: {
            allOf: [
                {
                    '$ref': '#/components/schemas/MessageTypeEnum'
                }
            ],
            description: `The type of announcement (determines color/styling)

* \`INFO\` - Info
* \`WARNING\` - Warning
* \`ERROR\` - Error
* \`SUCCESS\` - Success`
        },
        is_active: {
            type: 'boolean',
            title: 'Active',
            description: 'Whether this announcement should be displayed'
        },
        start_date: {
            type: 'string',
            format: 'date-time',
            nullable: true,
            description: 'Optional start date for the announcement'
        },
        end_date: {
            type: 'string',
            format: 'date-time',
            nullable: true,
            description: 'Optional end date for the announcement'
        },
        dismissible: {
            type: 'boolean',
            description: 'Whether users can dismiss this announcement'
        }
    },
    required: ['message']
} as const;

export const $SuperUserAppointment = {
    type: 'object',
    description: 'Appointment representation for superusers.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        service: {
            allOf: [
                {
                    '$ref': '#/components/schemas/SuperUserService'
                }
            ],
            readOnly: true
        },
        calendar: {
            allOf: [
                {
                    '$ref': '#/components/schemas/SuperUserCalendar'
                }
            ],
            readOnly: true
        },
        start: {
            type: 'string',
            format: 'date-time'
        },
        end: {
            type: 'string',
            format: 'date-time'
        },
        location_types: {
            '$ref': '#/components/schemas/LocationTypesEnum'
        },
        location: {},
        conferencing: {},
        description: {
            type: 'string',
            maxLength: 8192
        },
        status: {
            '$ref': '#/components/schemas/AppointmentStatusEnum'
        },
        summary: {
            type: 'string',
            maxLength: 128
        }
    },
    required: ['calendar', 'end', 'service', 'start', 'status', 'summary']
} as const;

export const $SuperUserAppointmentProposal = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        service: {
            allOf: [
                {
                    '$ref': '#/components/schemas/SuperUserService'
                }
            ],
            readOnly: true
        },
        calendar: {
            allOf: [
                {
                    '$ref': '#/components/schemas/SuperUserCalendar'
                }
            ],
            readOnly: true
        },
        start: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        location_type: {
            '$ref': '#/components/schemas/LocationTypeEnum'
        },
        booked: {
            type: 'boolean',
            readOnly: true
        },
        slug: {
            type: 'string',
            readOnly: true,
            pattern: '^[-a-zA-Z0-9_]+$'
        },
        message: {
            type: 'string',
            nullable: true
        },
        channel: {
            type: 'string',
            readOnly: true,
            nullable: true
        }
    },
    required: ['booked', 'calendar', 'channel', 'location_type', 'service', 'slug', 'start']
} as const;

export const $SuperUserAppointmentProposalRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        case_uuid: {
            type: 'string',
            writeOnly: true,
            minLength: 1
        },
        start: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        location_type: {
            '$ref': '#/components/schemas/LocationTypeEnum'
        },
        message: {
            type: 'string',
            nullable: true
        },
        service_uuid: {
            type: 'string',
            format: 'uuid',
            writeOnly: true
        },
        calendar_uuid: {
            type: 'string',
            format: 'uuid',
            writeOnly: true
        }
    },
    required: ['calendar_uuid', 'case_uuid', 'location_type', 'service_uuid', 'start']
} as const;

export const $SuperUserAssignWorkflowResponse = {
    type: 'object',
    description: 'Super user workflow assignment response.',
    properties: {
        assigned_workflow: {
            allOf: [
                {
                    '$ref': '#/components/schemas/SuperUserCaseLifecycleWorkflow'
                }
            ],
            nullable: true,
            description: 'Assigned workflow details, null if no workflow is assigned'
        }
    },
    required: ['assigned_workflow']
} as const;

export const $SuperUserCalendar = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        active: {
            type: 'boolean',
            title: 'Dieser Kalender ist buchbar'
        },
        name: {
            type: 'string',
            maxLength: 32
        },
        description: {
            type: 'string',
            title: 'Titel',
            maxLength: 32
        },
        long_description: {
            type: 'string',
            title: 'Beschreibung',
            maxLength: 400
        },
        avatar: {
            type: 'string',
            format: 'uri',
            nullable: true,
            title: 'Profilbild'
        },
        services: {
            type: 'array',
            items: {
                type: 'integer'
            }
        },
        slug: {
            type: 'string',
            maxLength: 64,
            pattern: '^[-a-zA-Z0-9_]+$'
        },
        deactivated: {
            type: 'boolean'
        },
        profile: {
            type: 'integer'
        },
        account: {
            allOf: [
                {
                    '$ref': '#/components/schemas/SuperUserAccount'
                }
            ],
            readOnly: true
        },
        calendar_id: {
            type: 'string',
            maxLength: 64
        },
        calendar_name: {
            type: 'string',
            maxLength: 64
        },
        calendar_readonly: {
            type: 'boolean'
        },
        calendar_deleted: {
            type: 'boolean'
        },
        calendar_primary: {
            type: 'boolean'
        },
        calendar_integrated_conferencing_available: {
            type: 'boolean'
        },
        calendar_attachments_available: {
            type: 'boolean'
        },
        permission_level: {
            type: 'string',
            maxLength: 32
        }
    },
    required: ['account', 'calendar_id', 'calendar_name', 'permission_level', 'profile']
} as const;

export const $SuperUserCalendarRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        active: {
            type: 'boolean',
            title: 'Dieser Kalender ist buchbar'
        },
        name: {
            type: 'string',
            minLength: 1,
            maxLength: 32
        },
        description: {
            type: 'string',
            title: 'Titel',
            maxLength: 32
        },
        long_description: {
            type: 'string',
            title: 'Beschreibung',
            maxLength: 400
        },
        avatar: {
            type: 'string',
            format: 'binary',
            nullable: true,
            title: 'Profilbild'
        },
        services: {
            type: 'array',
            items: {
                type: 'integer'
            }
        },
        slug: {
            type: 'string',
            minLength: 1,
            maxLength: 64,
            pattern: '^[-a-zA-Z0-9_]+$'
        },
        deactivated: {
            type: 'boolean'
        },
        profile: {
            type: 'integer'
        },
        calendar_id: {
            type: 'string',
            minLength: 1,
            maxLength: 64
        },
        calendar_name: {
            type: 'string',
            minLength: 1,
            maxLength: 64
        },
        calendar_readonly: {
            type: 'boolean'
        },
        calendar_deleted: {
            type: 'boolean'
        },
        calendar_primary: {
            type: 'boolean'
        },
        calendar_integrated_conferencing_available: {
            type: 'boolean'
        },
        calendar_attachments_available: {
            type: 'boolean'
        },
        permission_level: {
            type: 'string',
            minLength: 1,
            maxLength: 32
        }
    },
    required: ['calendar_id', 'calendar_name', 'permission_level', 'profile']
} as const;

export const $SuperUserCall = {
    type: 'object',
    description: 'Call representation for super users.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        user_phone_number: {
            type: 'string',
            maxLength: 24
        },
        phone_number_uuid: {
            type: 'string',
            format: 'uuid'
        },
        phone_number: {
            allOf: [
                {
                    '$ref': '#/components/schemas/SuperUserPhoneNumber'
                }
            ],
            readOnly: true
        },
        retell_call_id: {
            type: 'string',
            maxLength: 64
        },
        audio_recording_url: {
            type: 'string',
            nullable: true,
            description: 'Return the URL of the audio recording of the call.',
            readOnly: true
        },
        langfuse_traces_url: {
            type: 'string',
            description: 'Return the URL of the langfuse traces of the call.',
            readOnly: true
        },
        retell_dashboard_url: {
            type: 'string',
            description: 'Return the URL of the retell dashboard of the call.',
            readOnly: true
        },
        twilio_console_url: {
            type: 'string',
            description: 'Return the URL of the twilio console of the call.',
            readOnly: true
        },
        transcript: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/CallTranscriptMessage'
            },
            readOnly: true
        },
        twilio_call_sid: {
            type: 'string',
            maxLength: 64
        },
        call_start_time: {
            type: 'string',
            format: 'date-time'
        },
        call_end_time: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        data: {},
        result: {
            '$ref': '#/components/schemas/SuperUserCallResult'
        },
        user_feedback: {
            allOf: [
                {
                    '$ref': '#/components/schemas/SuperUserCallUserFeedback'
                }
            ],
            readOnly: true,
            nullable: true
        },
        lawyer_feedback: {
            allOf: [
                {
                    '$ref': '#/components/schemas/SuperUserLawyerFeedback'
                }
            ],
            readOnly: true
        },
        agent_rating: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,1}(?:\\.\\d{0,1})?$',
            nullable: true
        },
        agent_rating_by_human: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,1}(?:\\.\\d{0,1})?$',
            nullable: true
        },
        system_rating: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,1}(?:\\.\\d{0,1})?$',
            nullable: true
        },
        system_rating_by_human: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,1}(?:\\.\\d{0,1})?$',
            nullable: true
        },
        system_rating_summary: {
            type: 'string'
        },
        system_rating_summary_by_human: {
            type: 'string'
        },
        was_name_asked: {
            type: 'boolean',
            nullable: true
        },
        was_name_mentioned: {
            type: 'boolean',
            nullable: true
        },
        is_name_correct: {
            type: 'boolean',
            nullable: true
        },
        was_email_asked: {
            type: 'boolean',
            nullable: true
        },
        was_email_mentioned: {
            type: 'boolean',
            nullable: true
        },
        is_email_correct: {
            type: 'boolean',
            nullable: true
        },
        was_phone_asked: {
            type: 'boolean',
            nullable: true
        },
        was_phone_mentioned: {
            type: 'boolean',
            nullable: true
        },
        is_phone_correct: {
            type: 'boolean',
            nullable: true
        },
        needed_to_ask_for_case_number: {
            type: 'boolean',
            nullable: true
        },
        was_case_number_asked: {
            type: 'boolean',
            nullable: true
        },
        is_case_number_correct: {
            type: 'boolean',
            nullable: true
        },
        is_lawfield_correct: {
            type: 'boolean',
            nullable: true
        },
        is_lawtopic_correct: {
            type: 'boolean',
            nullable: true
        },
        is_classification_correct: {
            type: 'boolean',
            nullable: true
        },
        did_caller_hang_up_early: {
            type: 'boolean',
            nullable: true
        },
        did_caller_hang_up_early_due_to_conversation: {
            type: 'boolean',
            nullable: true
        },
        did_caller_speak_in_single_words: {
            type: 'boolean',
            nullable: true
        },
        is_inquiry_helpful: {
            type: 'boolean',
            nullable: true
        },
        can_customer_derive_value: {
            type: 'boolean',
            nullable: true
        },
        did_call_have_background_noise: {
            type: 'boolean',
            nullable: true
        },
        was_caller_annoyed: {
            type: 'boolean',
            nullable: true
        },
        consumed_tokens: {
            type: 'integer',
            maximum: 2147483647,
            minimum: 0
        },
        total_cost: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$'
        },
        duration: {
            type: 'integer',
            maximum: 2147483647,
            minimum: 0
        },
        case_uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        case_id: {
            type: 'integer',
            readOnly: true
        },
        case: {
            allOf: [
                {
                    '$ref': '#/components/schemas/SuperUserCaseInfo'
                }
            ],
            readOnly: true
        },
        is_rated: {
            type: 'boolean',
            readOnly: true
        },
        had_caller_accent: {
            type: 'boolean',
            nullable: true
        },
        note: {
            type: 'string',
            nullable: true,
            title: 'Interne Notizen',
            maxLength: 1024
        },
        clerk: {
            allOf: [
                {
                    '$ref': '#/components/schemas/SuperUserOrganisationUser'
                }
            ],
            readOnly: true
        },
        forward: {
            allOf: [
                {
                    '$ref': '#/components/schemas/Forward'
                }
            ],
            nullable: true
        }
    },
    required: ['audio_recording_url', 'case', 'case_id', 'case_uuid', 'clerk', 'is_rated', 'langfuse_traces_url', 'lawyer_feedback', 'phone_number', 'phone_number_uuid', 'retell_dashboard_url', 'transcript', 'twilio_console_url', 'user_feedback', 'user_phone_number', 'uuid']
} as const;

export const $SuperUserCallRequest = {
    type: 'object',
    description: 'Call representation for super users.',
    properties: {
        user_phone_number: {
            type: 'string',
            minLength: 1,
            maxLength: 24
        },
        phone_number_uuid: {
            type: 'string',
            format: 'uuid'
        },
        retell_call_id: {
            type: 'string',
            maxLength: 64
        },
        twilio_call_sid: {
            type: 'string',
            maxLength: 64
        },
        call_start_time: {
            type: 'string',
            format: 'date-time'
        },
        call_end_time: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        data: {},
        result: {
            '$ref': '#/components/schemas/SuperUserCallResultRequest'
        },
        agent_rating: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,1}(?:\\.\\d{0,1})?$',
            nullable: true
        },
        agent_rating_by_human: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,1}(?:\\.\\d{0,1})?$',
            nullable: true
        },
        system_rating: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,1}(?:\\.\\d{0,1})?$',
            nullable: true
        },
        system_rating_by_human: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,1}(?:\\.\\d{0,1})?$',
            nullable: true
        },
        system_rating_summary: {
            type: 'string'
        },
        system_rating_summary_by_human: {
            type: 'string'
        },
        was_name_asked: {
            type: 'boolean',
            nullable: true
        },
        was_name_mentioned: {
            type: 'boolean',
            nullable: true
        },
        is_name_correct: {
            type: 'boolean',
            nullable: true
        },
        was_email_asked: {
            type: 'boolean',
            nullable: true
        },
        was_email_mentioned: {
            type: 'boolean',
            nullable: true
        },
        is_email_correct: {
            type: 'boolean',
            nullable: true
        },
        was_phone_asked: {
            type: 'boolean',
            nullable: true
        },
        was_phone_mentioned: {
            type: 'boolean',
            nullable: true
        },
        is_phone_correct: {
            type: 'boolean',
            nullable: true
        },
        needed_to_ask_for_case_number: {
            type: 'boolean',
            nullable: true
        },
        was_case_number_asked: {
            type: 'boolean',
            nullable: true
        },
        is_case_number_correct: {
            type: 'boolean',
            nullable: true
        },
        is_lawfield_correct: {
            type: 'boolean',
            nullable: true
        },
        is_lawtopic_correct: {
            type: 'boolean',
            nullable: true
        },
        is_classification_correct: {
            type: 'boolean',
            nullable: true
        },
        did_caller_hang_up_early: {
            type: 'boolean',
            nullable: true
        },
        did_caller_hang_up_early_due_to_conversation: {
            type: 'boolean',
            nullable: true
        },
        did_caller_speak_in_single_words: {
            type: 'boolean',
            nullable: true
        },
        is_inquiry_helpful: {
            type: 'boolean',
            nullable: true
        },
        can_customer_derive_value: {
            type: 'boolean',
            nullable: true
        },
        did_call_have_background_noise: {
            type: 'boolean',
            nullable: true
        },
        was_caller_annoyed: {
            type: 'boolean',
            nullable: true
        },
        consumed_tokens: {
            type: 'integer',
            maximum: 2147483647,
            minimum: 0
        },
        total_cost: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$'
        },
        duration: {
            type: 'integer',
            maximum: 2147483647,
            minimum: 0
        },
        had_caller_accent: {
            type: 'boolean',
            nullable: true
        },
        note: {
            type: 'string',
            nullable: true,
            title: 'Interne Notizen',
            maxLength: 1024
        },
        clerk_id: {
            type: 'string',
            format: 'uuid',
            writeOnly: true,
            nullable: true
        },
        forward: {
            allOf: [
                {
                    '$ref': '#/components/schemas/ForwardRequest'
                }
            ],
            nullable: true
        }
    },
    required: ['phone_number_uuid', 'user_phone_number']
} as const;

export const $SuperUserCallResult = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        classification: {
            '$ref': '#/components/schemas/ClassificationEnum'
        },
        inquiry: {
            type: 'string'
        },
        data: {
            '$ref': '#/components/schemas/ShallowCaseData'
        },
        first_name_recording_start_seconds: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true
        },
        first_name_recording_end_seconds: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true
        },
        last_name_recording_start_seconds: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true
        },
        last_name_recording_end_seconds: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true
        },
        email_recording_start_seconds: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true
        },
        email_recording_end_seconds: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true
        },
        phone_number_recording_start_seconds: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true
        },
        phone_number_recording_end_seconds: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true
        }
    },
    required: ['classification', 'data', 'uuid']
} as const;

export const $SuperUserCallResultRequest = {
    type: 'object',
    properties: {
        classification: {
            '$ref': '#/components/schemas/ClassificationEnum'
        },
        inquiry: {
            type: 'string'
        },
        data: {
            '$ref': '#/components/schemas/ShallowCaseDataRequest'
        },
        first_name_recording_start_seconds: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true
        },
        first_name_recording_end_seconds: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true
        },
        last_name_recording_start_seconds: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true
        },
        last_name_recording_end_seconds: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true
        },
        email_recording_start_seconds: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true
        },
        email_recording_end_seconds: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true
        },
        phone_number_recording_start_seconds: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true
        },
        phone_number_recording_end_seconds: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true
        }
    },
    required: ['classification', 'data']
} as const;

export const $SuperUserCallUserFeedback = {
    type: 'object',
    description: 'Call user feedback representation for super users.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        rating: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,1}(?:\\.\\d{0,1})?$',
            nullable: true
        },
        feedback: {
            type: 'string',
            maxLength: 1024
        },
        would_call_again: {
            type: 'boolean'
        },
        email: {
            type: 'string',
            format: 'email',
            maxLength: 255
        },
        phone: {
            type: 'string',
            maxLength: 255
        },
        first_name: {
            type: 'string',
            maxLength: 255
        },
        last_name: {
            type: 'string',
            maxLength: 255
        },
        is_submitted: {
            type: 'boolean'
        }
    },
    required: ['uuid']
} as const;

export const $SuperUserCallUserFeedbackRequest = {
    type: 'object',
    description: 'Call user feedback representation for super users.',
    properties: {
        rating: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,1}(?:\\.\\d{0,1})?$',
            nullable: true
        },
        feedback: {
            type: 'string',
            maxLength: 1024
        },
        would_call_again: {
            type: 'boolean'
        },
        email: {
            type: 'string',
            format: 'email',
            maxLength: 255
        },
        phone: {
            type: 'string',
            maxLength: 255
        },
        first_name: {
            type: 'string',
            maxLength: 255
        },
        last_name: {
            type: 'string',
            maxLength: 255
        },
        is_submitted: {
            type: 'boolean'
        }
    }
} as const;

export const $SuperUserCase = {
    type: 'object',
    description: 'Case representation for super users.',
    properties: {
        id: {
            type: 'integer',
            readOnly: true
        },
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        questionnaire_submissions: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/SuperUserQuestionnaireSubmission'
            },
            readOnly: true
        },
        form_requests: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/SuperUserRequest'
            },
            readOnly: true
        },
        org: {
            allOf: [
                {
                    '$ref': '#/components/schemas/SuperUserOrganisation'
                }
            ],
            readOnly: true
        },
        modified_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        created_at: {
            type: 'string',
            format: 'date-time'
        },
        note: {
            type: 'string',
            nullable: true,
            title: 'Interne Notizen',
            maxLength: 1024
        },
        type: {
            '$ref': '#/components/schemas/CaseType'
        },
        state: {
            allOf: [
                {
                    '$ref': '#/components/schemas/StateEnum'
                }
            ],
            title: 'Status'
        },
        inquiry: {
            type: 'string',
            title: 'Inhalt der Anfrage'
        },
        data: {
            '$ref': '#/components/schemas/SuperUserCaseData'
        },
        client_document_email_reminder_sent_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        client_document_email_reminder_opt_out: {
            type: 'boolean'
        },
        send_outstanding_document_email_reminder: {
            type: 'boolean',
            title: 'Automatisierte E-Mail Erinnerungen für angeforderte Dokumente aktiv'
        },
        sent_to_actaport_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        actaport_case_id: {
            type: 'string',
            nullable: true,
            maxLength: 48
        },
        sent_to_advoware_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        advoware_case_id: {
            type: 'string',
            nullable: true,
            maxLength: 48
        },
        sent_to_iusta_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        iusta_data: {},
        is_selected_for_export_to: {},
        exported_to: {},
        export_data: {},
        sent_to_ra_micro_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        sent_to_advolux_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        last_activity_at: {
            type: 'string',
            format: 'date-time'
        },
        last_activity_seen_at: {
            type: 'string',
            format: 'date-time'
        },
        user_access_token: {
            type: 'string',
            maxLength: 256
        },
        kleos_case_id: {
            type: 'string',
            nullable: true,
            maxLength: 48
        },
        kleos_reference: {
            type: 'string',
            nullable: true,
            maxLength: 48
        },
        pdf_form_submissions: {
            type: 'string',
            readOnly: true
        },
        virtual_documents: {
            type: 'string',
            readOnly: true
        },
        clerk: {
            allOf: [
                {
                    '$ref': '#/components/schemas/SuperUserOrganisationUser'
                }
            ],
            readOnly: true
        },
        services: {
            type: 'string',
            readOnly: true
        },
        chat_sessions: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/AIChatSession'
            },
            readOnly: true
        },
        activities: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/Activity'
            },
            readOnly: true
        },
        case_lifecycle_state: {
            allOf: [
                {
                    '$ref': '#/components/schemas/SuperUserCaseLifecycleState'
                }
            ],
            readOnly: true
        },
        jupus_case_number: {
            type: 'string',
            nullable: true,
            maxLength: 24
        }
    },
    required: ['activities', 'case_lifecycle_state', 'chat_sessions', 'clerk', 'form_requests', 'id', 'modified_at', 'org', 'pdf_form_submissions', 'questionnaire_submissions', 'services', 'uuid', 'virtual_documents']
} as const;

export const $SuperUserCaseData = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        client: {
            '$ref': '#/components/schemas/Entity'
        },
        opponent: {
            '$ref': '#/components/schemas/Entity'
        },
        law: {
            '$ref': '#/components/schemas/LawData'
        },
        entities: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/SuperUserEntityWithRelationship'
            },
            readOnly: true
        },
        changes: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/SuperUserCaseDataChange'
            },
            readOnly: true
        },
        mappers: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/GenericDataMapper'
            },
            readOnly: true
        }
    },
    required: ['changes', 'client', 'entities', 'law', 'mappers', 'opponent']
} as const;

export const $SuperUserCaseDataChange = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        mapper_key: {
            type: 'string',
            maxLength: 255
        },
        old_value: {
            oneOf: [
                {
                    type: 'string'
                },
                {
                    type: 'integer'
                },
                {
                    type: 'boolean'
                },
                {
                    type: 'string',
                    format: 'date'
                },
                {
                    type: 'object',
                    additionalProperties: {}
                },
                {
                    type: 'array',
                    items: {}
                }
            ]
        },
        new_value: {
            oneOf: [
                {
                    type: 'string'
                },
                {
                    type: 'integer'
                },
                {
                    type: 'boolean'
                },
                {
                    type: 'string',
                    format: 'date'
                },
                {
                    type: 'object',
                    additionalProperties: {}
                },
                {
                    type: 'array',
                    items: {}
                }
            ]
        },
        change_source: {
            '$ref': '#/components/schemas/ChangeSourceEnum'
        },
        user: {
            '$ref': '#/components/schemas/SuperUserOrganisationUser'
        },
        ai_augmentation: {
            '$ref': '#/components/schemas/SuperUserAiAugmentation'
        }
    },
    required: ['ai_augmentation', 'change_source', 'created_at', 'mapper_key', 'new_value', 'old_value', 'user']
} as const;

export const $SuperUserCaseDataChangeRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        mapper_key: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        },
        old_value: {
            oneOf: [
                {
                    type: 'string'
                },
                {
                    type: 'integer'
                },
                {
                    type: 'boolean'
                },
                {
                    type: 'string',
                    format: 'date'
                },
                {
                    type: 'object',
                    additionalProperties: {}
                },
                {
                    type: 'array',
                    items: {}
                }
            ]
        },
        new_value: {
            oneOf: [
                {
                    type: 'string'
                },
                {
                    type: 'integer'
                },
                {
                    type: 'boolean'
                },
                {
                    type: 'string',
                    format: 'date'
                },
                {
                    type: 'object',
                    additionalProperties: {}
                },
                {
                    type: 'array',
                    items: {}
                }
            ]
        },
        change_source: {
            '$ref': '#/components/schemas/ChangeSourceEnum'
        },
        ai_augmentation: {
            '$ref': '#/components/schemas/SuperUserAiAugmentationRequest'
        }
    },
    required: ['ai_augmentation', 'change_source', 'mapper_key', 'new_value', 'old_value']
} as const;

export const $SuperUserCaseDataRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        client: {
            '$ref': '#/components/schemas/EntityRequest'
        },
        opponent: {
            '$ref': '#/components/schemas/EntityRequest'
        },
        law: {
            '$ref': '#/components/schemas/LawDataRequest'
        }
    },
    required: ['client', 'law', 'opponent']
} as const;

export const $SuperUserCaseInfo = {
    type: 'object',
    description: 'Minimal case info for calls that are connected to cases (SuperUser version)',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        pk: {
            type: 'integer'
        },
        note: {
            type: 'string',
            nullable: true
        },
        clerk: {
            allOf: [
                {
                    '$ref': '#/components/schemas/SuperUserOrganisationUser'
                }
            ],
            readOnly: true
        },
        law_field: {
            type: 'string'
        },
        law_topic: {
            type: 'string'
        }
    },
    required: ['clerk', 'law_field', 'law_topic', 'note', 'pk', 'uuid']
} as const;

export const $SuperUserCaseInfoRequest = {
    type: 'object',
    description: 'Minimal case info for calls that are connected to cases (SuperUser version)',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        pk: {
            type: 'integer'
        },
        note: {
            type: 'string',
            nullable: true
        },
        law_field: {
            type: 'string'
        },
        law_topic: {
            type: 'string'
        }
    },
    required: ['law_field', 'law_topic', 'note', 'pk', 'uuid']
} as const;

export const $SuperUserCaseLifecycleState = {
    type: 'object',
    description: 'Case Lifecycle State representation for superusers.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        current_state: {
            allOf: [
                {
                    '$ref': '#/components/schemas/CurrentStateEnum'
                }
            ],
            readOnly: true
        },
        assigned_workflow: {
            allOf: [
                {
                    '$ref': '#/components/schemas/SuperUserCaseLifecycleWorkflow'
                }
            ],
            readOnly: true
        },
        state_transition_results: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/CaseLifecycleStateTransitionResult'
            },
            readOnly: true
        },
        is_agent_active: {
            type: 'boolean'
        },
        rating: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,1}(?:\\.\\d{0,1})?$',
            readOnly: true,
            nullable: true
        },
        langfuse_session_url: {
            type: 'string',
            readOnly: true
        }
    },
    required: ['assigned_workflow', 'current_state', 'langfuse_session_url', 'rating', 'state_transition_results', 'uuid']
} as const;

export const $SuperUserCaseLifecycleStateRequest = {
    type: 'object',
    description: 'Case Lifecycle State representation for superusers.',
    properties: {
        workflow_uuid: {
            type: 'string',
            format: 'uuid',
            writeOnly: true,
            nullable: true,
            description: 'UUID of the workflow to assign to the case. Set to null to remove workflow assignment.'
        },
        is_agent_active: {
            type: 'boolean'
        }
    }
} as const;

export const $SuperUserCaseLifecycleWorkflow = {
    type: 'object',
    description: 'Case Lifecycle Workflow representation for superusers.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        name: {
            type: 'string',
            maxLength: 255
        },
        law_field: {
            title: 'Rechtsgebiet',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawFieldEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        law_topic: {
            title: 'Rechtsthema',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawTopicEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        on_case_ready_for_onboarding_step_1_instructions: {
            type: 'string',
            title: 'Case Ready for Onboarding Step 1 Instructions',
            description: 'Instructions for AI agents when handling a new case - Step 1'
        },
        on_case_ready_for_onboarding_step_1_auto_commit_settings: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/SuperUserActionAutoCommitSettings'
            }
        },
        on_case_ready_for_onboarding_step_2_instructions: {
            type: 'string',
            title: 'Case Ready for Onboarding Step 2 Instructions',
            description: 'Instructions for AI agents when handling a new case - Step 2'
        },
        on_case_ready_for_onboarding_step_2_auto_commit_settings: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/SuperUserActionAutoCommitSettings'
            }
        },
        on_all_data_collected_instructions: {
            type: 'string',
            title: 'All Data Collected Instructions',
            description: 'Instructions for AI agents when all data for a case has been collected'
        },
        on_all_data_collected_auto_commit_settings: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/SuperUserActionAutoCommitSettings'
            }
        },
        on_all_documents_drafted_auto_commit_settings: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/SuperUserActionAutoCommitSettings'
            }
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        updated_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        org: {
            type: 'integer',
            readOnly: true,
            title: 'Organisation'
        }
    },
    required: ['created_at', 'name', 'org', 'updated_at', 'uuid']
} as const;

export const $SuperUserCaseLifecycleWorkflowRequest = {
    type: 'object',
    description: 'Case Lifecycle Workflow representation for superusers.',
    properties: {
        name: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        },
        law_field: {
            title: 'Rechtsgebiet',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawFieldEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        law_topic: {
            title: 'Rechtsthema',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawTopicEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        on_case_ready_for_onboarding_step_1_instructions: {
            type: 'string',
            title: 'Case Ready for Onboarding Step 1 Instructions',
            description: 'Instructions for AI agents when handling a new case - Step 1'
        },
        on_case_ready_for_onboarding_step_1_auto_commit_settings: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/SuperUserActionAutoCommitSettingsRequest'
            }
        },
        on_case_ready_for_onboarding_step_2_instructions: {
            type: 'string',
            title: 'Case Ready for Onboarding Step 2 Instructions',
            description: 'Instructions for AI agents when handling a new case - Step 2'
        },
        on_case_ready_for_onboarding_step_2_auto_commit_settings: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/SuperUserActionAutoCommitSettingsRequest'
            }
        },
        on_all_data_collected_instructions: {
            type: 'string',
            title: 'All Data Collected Instructions',
            description: 'Instructions for AI agents when all data for a case has been collected'
        },
        on_all_data_collected_auto_commit_settings: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/SuperUserActionAutoCommitSettingsRequest'
            }
        },
        on_all_documents_drafted_auto_commit_settings: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/SuperUserActionAutoCommitSettingsRequest'
            }
        }
    },
    required: ['name']
} as const;

export const $SuperUserCaseRequest = {
    type: 'object',
    description: 'Case representation for super users.',
    properties: {
        created_at: {
            type: 'string',
            format: 'date-time'
        },
        note: {
            type: 'string',
            nullable: true,
            title: 'Interne Notizen',
            maxLength: 1024
        },
        type: {
            '$ref': '#/components/schemas/CaseType'
        },
        state: {
            allOf: [
                {
                    '$ref': '#/components/schemas/StateEnum'
                }
            ],
            title: 'Status'
        },
        inquiry: {
            type: 'string',
            title: 'Inhalt der Anfrage'
        },
        data: {
            '$ref': '#/components/schemas/SuperUserCaseDataRequest'
        },
        client_document_email_reminder_sent_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        client_document_email_reminder_opt_out: {
            type: 'boolean'
        },
        send_outstanding_document_email_reminder: {
            type: 'boolean',
            title: 'Automatisierte E-Mail Erinnerungen für angeforderte Dokumente aktiv'
        },
        sent_to_actaport_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        actaport_case_id: {
            type: 'string',
            nullable: true,
            minLength: 1,
            maxLength: 48
        },
        sent_to_advoware_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        advoware_case_id: {
            type: 'string',
            nullable: true,
            minLength: 1,
            maxLength: 48
        },
        sent_to_iusta_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        iusta_data: {},
        is_selected_for_export_to: {},
        exported_to: {},
        export_data: {},
        sent_to_ra_micro_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        sent_to_advolux_at: {
            type: 'string',
            format: 'date-time',
            nullable: true
        },
        last_activity_at: {
            type: 'string',
            format: 'date-time'
        },
        last_activity_seen_at: {
            type: 'string',
            format: 'date-time'
        },
        user_access_token: {
            type: 'string',
            minLength: 1,
            maxLength: 256
        },
        kleos_case_id: {
            type: 'string',
            nullable: true,
            minLength: 1,
            maxLength: 48
        },
        kleos_reference: {
            type: 'string',
            nullable: true,
            minLength: 1,
            maxLength: 48
        },
        clerk_id: {
            type: 'string',
            format: 'uuid',
            writeOnly: true,
            nullable: true
        },
        jupus_case_number: {
            type: 'string',
            nullable: true,
            minLength: 1,
            maxLength: 24
        }
    }
} as const;

export const $SuperUserCreatePDFFormTemplateRequest = {
    type: 'object',
    description: 'Serializer for superusers to create PDF form templates with org selection.',
    properties: {
        name: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        },
        description: {
            type: 'string'
        },
        original_pdf: {
            type: 'string',
            format: 'binary',
            description: 'Original PDF template uploaded by user (preserved, never modified)'
        },
        org_uuid: {
            type: 'string',
            format: 'uuid',
            writeOnly: true
        }
    },
    required: ['name', 'org_uuid', 'original_pdf']
} as const;

export const $SuperUserDeliveryEvent = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        email: {
            type: 'integer',
            readOnly: true
        },
        event: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EventEnum'
                }
            ],
            readOnly: true
        },
        event_description: {
            type: 'string',
            readOnly: true,
            nullable: true
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        updated_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        }
    },
    required: ['created_at', 'email', 'event', 'event_description', 'updated_at', 'uuid']
} as const;

export const $SuperUserDocumentTemplate = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        name: {
            type: 'string',
            maxLength: 255
        },
        description: {
            type: 'string'
        },
        system_prompt: {
            type: 'string'
        },
        document_template: {
            type: 'string'
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        updated_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        law_field: {
            title: 'Rechtsgebiet',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawFieldEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        law_topic: {
            title: 'Rechtsthema',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawTopicEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        document: {
            allOf: [
                {
                    '$ref': '#/components/schemas/Document'
                }
            ],
            readOnly: true
        },
        is_jupus_template: {
            type: 'boolean'
        }
    },
    required: ['created_at', 'description', 'document', 'is_jupus_template', 'name', 'system_prompt', 'updated_at']
} as const;

export const $SuperUserDocumentTemplateRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        name: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        },
        description: {
            type: 'string',
            minLength: 1
        },
        system_prompt: {
            type: 'string',
            minLength: 1
        },
        document_template: {
            type: 'string'
        },
        law_field: {
            title: 'Rechtsgebiet',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawFieldEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        law_topic: {
            title: 'Rechtsthema',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawTopicEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        is_jupus_template: {
            type: 'boolean'
        }
    },
    required: ['description', 'is_jupus_template', 'name', 'system_prompt']
} as const;

export const $SuperUserEmail = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        from_email: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EmailAddress'
                }
            ],
            readOnly: true
        },
        to: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/EmailAddress'
            },
            readOnly: true
        },
        cc: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/EmailAddress'
            },
            readOnly: true
        },
        bcc: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/EmailAddress'
            },
            readOnly: true
        },
        subject: {
            type: 'string',
            maxLength: 255
        },
        text: {
            type: 'string'
        },
        html: {
            type: 'string'
        },
        direction: {
            type: 'string',
            readOnly: true
        },
        source: {
            type: 'string',
            readOnly: true
        },
        sent_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        pdf_url: {
            type: 'string',
            readOnly: true
        },
        relevant_delivery_event: {
            allOf: [
                {
                    '$ref': '#/components/schemas/SuperUserDeliveryEvent'
                }
            ],
            readOnly: true
        },
        email_service: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EmailServiceEnum'
                }
            ],
            readOnly: true
        }
    },
    required: ['bcc', 'cc', 'direction', 'email_service', 'from_email', 'pdf_url', 'relevant_delivery_event', 'sent_at', 'source', 'subject', 'to', 'uuid']
} as const;

export const $SuperUserEmailTemplate = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        type: {
            '$ref': '#/components/schemas/EmailTemplateType'
        },
        name: {
            type: 'string',
            maxLength: 255
        },
        subject: {
            type: 'string',
            maxLength: 255
        },
        html: {
            type: 'string'
        },
        questionnaires: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/SuperUserQuestionnaire'
            },
            readOnly: true
        },
        forms: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/SuperUserForm'
            },
            readOnly: true
        },
        pdf_form_templates: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/PDFFormTemplate'
            },
            readOnly: true
        },
        default: {
            type: 'boolean'
        },
        law_field: {
            title: 'Rechtsgebiet',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawFieldEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        law_topic: {
            title: 'Rechtsthema',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawTopicEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        updated_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        }
    },
    required: ['default', 'forms', 'html', 'name', 'pdf_form_templates', 'questionnaires', 'subject', 'type', 'updated_at', 'uuid']
} as const;

export const $SuperUserEmailTemplateRequest = {
    type: 'object',
    properties: {
        type: {
            '$ref': '#/components/schemas/EmailTemplateType'
        },
        name: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        },
        subject: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        },
        html: {
            type: 'string',
            minLength: 1
        },
        default: {
            type: 'boolean'
        },
        law_field: {
            title: 'Rechtsgebiet',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawFieldEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        law_topic: {
            title: 'Rechtsthema',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawTopicEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        questionnaire_uuids: {
            type: 'array',
            items: {
                type: 'string',
                format: 'uuid'
            },
            writeOnly: true
        },
        form_uuids: {
            type: 'array',
            items: {
                type: 'string',
                format: 'uuid'
            },
            writeOnly: true
        }
    },
    required: ['default', 'form_uuids', 'html', 'name', 'questionnaire_uuids', 'subject', 'type']
} as const;

export const $SuperUserEntity = {
    type: 'object',
    description: 'Entity representation for super users.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        entity_type: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EntityTypeEnum'
                }
            ],
            title: 'Personentyp'
        },
        title: {
            title: 'Anrede',
            oneOf: [
                {
                    '$ref': '#/components/schemas/TitleEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        first_name: {
            type: 'string',
            title: 'Vorname',
            maxLength: 128
        },
        last_name: {
            type: 'string',
            title: 'Nachname',
            maxLength: 128
        },
        email: {
            type: 'string',
            format: 'email',
            title: 'E-Mail',
            maxLength: 128
        },
        phone: {
            type: 'string',
            title: 'Telefon',
            maxLength: 128
        },
        street: {
            type: 'string',
            title: 'Straße',
            maxLength: 128
        },
        street_number: {
            type: 'string',
            title: 'Hausnummer',
            maxLength: 16
        },
        address_line_2: {
            type: 'string',
            title: 'Adresszusatz',
            maxLength: 128
        },
        zip: {
            type: 'string',
            title: 'PLZ',
            maxLength: 12
        },
        city: {
            type: 'string',
            title: 'Ort',
            maxLength: 100
        },
        date_of_birth: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Geburtsdatum'
        },
        legal_insurance: {
            type: 'boolean',
            nullable: true,
            title: 'Rechtsschutzversicherung'
        },
        legal_insurance_number: {
            type: 'string',
            title: 'Nummer der Rechtsschutzversicherung',
            maxLength: 128
        },
        legal_insurance_name: {
            type: 'string',
            title: 'Name der Rechtsschutzversicherung',
            maxLength: 128
        },
        legal_insurance_deductible_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Höhe der Selbstbeteiligung der Rechtsschutzversicherung'
        },
        is_company: {
            type: 'string',
            readOnly: true
        },
        company_name: {
            type: 'string',
            title: 'Firmenname',
            maxLength: 128
        },
        company_legal_form: {
            title: 'Rechtsform',
            oneOf: [
                {
                    '$ref': '#/components/schemas/CompanyLegalFormEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        company_register_number: {
            type: 'string',
            title: 'Handelsregisternummer',
            maxLength: 128
        },
        company_register_court: {
            type: 'string',
            title: 'Amtsgericht',
            maxLength: 128
        },
        company_vat_id: {
            type: 'string',
            title: 'USt. ID',
            maxLength: 128
        },
        company_tax_id: {
            type: 'string',
            title: 'Steuernummer',
            maxLength: 128
        },
        bank_name: {
            type: 'string',
            title: 'Bankname',
            maxLength: 128
        },
        iban: {
            type: 'string',
            maxLength: 34
        },
        bic: {
            type: 'string',
            maxLength: 11
        },
        institution_name: {
            type: 'string',
            title: 'Name der Institution',
            maxLength: 128
        },
        changes: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/SuperUserEntityChange'
            },
            readOnly: true
        }
    },
    required: ['changes', 'entity_type', 'is_company', 'uuid']
} as const;

export const $SuperUserEntityChange = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        entities_mapper_key: {
            '$ref': '#/components/schemas/EntitiesMapperKeyEnum'
        },
        old_value: {
            oneOf: [
                {
                    type: 'string'
                },
                {
                    type: 'integer'
                },
                {
                    type: 'boolean'
                },
                {
                    type: 'string',
                    format: 'date'
                },
                {
                    type: 'object',
                    additionalProperties: {}
                },
                {
                    type: 'array',
                    items: {}
                }
            ]
        },
        new_value: {
            oneOf: [
                {
                    type: 'string'
                },
                {
                    type: 'integer'
                },
                {
                    type: 'boolean'
                },
                {
                    type: 'string',
                    format: 'date'
                },
                {
                    type: 'object',
                    additionalProperties: {}
                },
                {
                    type: 'array',
                    items: {}
                }
            ]
        },
        change_source: {
            '$ref': '#/components/schemas/ChangeSourceEnum'
        },
        user: {
            '$ref': '#/components/schemas/SuperUserOrganisationUser'
        },
        ai_augmentation: {
            '$ref': '#/components/schemas/SuperUserAiAugmentation'
        }
    },
    required: ['ai_augmentation', 'change_source', 'created_at', 'entities_mapper_key', 'new_value', 'old_value', 'user']
} as const;

export const $SuperUserEntityChangeRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        entities_mapper_key: {
            '$ref': '#/components/schemas/EntitiesMapperKeyEnum'
        },
        old_value: {
            oneOf: [
                {
                    type: 'string'
                },
                {
                    type: 'integer'
                },
                {
                    type: 'boolean'
                },
                {
                    type: 'string',
                    format: 'date'
                },
                {
                    type: 'object',
                    additionalProperties: {}
                },
                {
                    type: 'array',
                    items: {}
                }
            ]
        },
        new_value: {
            oneOf: [
                {
                    type: 'string'
                },
                {
                    type: 'integer'
                },
                {
                    type: 'boolean'
                },
                {
                    type: 'string',
                    format: 'date'
                },
                {
                    type: 'object',
                    additionalProperties: {}
                },
                {
                    type: 'array',
                    items: {}
                }
            ]
        },
        change_source: {
            '$ref': '#/components/schemas/ChangeSourceEnum'
        },
        ai_augmentation: {
            '$ref': '#/components/schemas/SuperUserAiAugmentationRequest'
        }
    },
    required: ['ai_augmentation', 'change_source', 'entities_mapper_key', 'new_value', 'old_value']
} as const;

export const $SuperUserEntityRequest = {
    type: 'object',
    description: 'Entity representation for super users.',
    properties: {
        entity_type: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EntityTypeEnum'
                }
            ],
            title: 'Personentyp'
        },
        title: {
            title: 'Anrede',
            oneOf: [
                {
                    '$ref': '#/components/schemas/TitleEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        first_name: {
            type: 'string',
            title: 'Vorname',
            maxLength: 128
        },
        last_name: {
            type: 'string',
            title: 'Nachname',
            maxLength: 128
        },
        email: {
            type: 'string',
            format: 'email',
            title: 'E-Mail',
            maxLength: 128
        },
        phone: {
            type: 'string',
            title: 'Telefon',
            maxLength: 128
        },
        street: {
            type: 'string',
            title: 'Straße',
            maxLength: 128
        },
        street_number: {
            type: 'string',
            title: 'Hausnummer',
            maxLength: 16
        },
        address_line_2: {
            type: 'string',
            title: 'Adresszusatz',
            maxLength: 128
        },
        zip: {
            type: 'string',
            title: 'PLZ',
            maxLength: 12
        },
        city: {
            type: 'string',
            title: 'Ort',
            maxLength: 100
        },
        date_of_birth: {
            type: 'string',
            format: 'date',
            nullable: true,
            title: 'Geburtsdatum'
        },
        legal_insurance: {
            type: 'boolean',
            nullable: true,
            title: 'Rechtsschutzversicherung'
        },
        legal_insurance_number: {
            type: 'string',
            title: 'Nummer der Rechtsschutzversicherung',
            maxLength: 128
        },
        legal_insurance_name: {
            type: 'string',
            title: 'Name der Rechtsschutzversicherung',
            maxLength: 128
        },
        legal_insurance_deductible_amount: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,8}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Höhe der Selbstbeteiligung der Rechtsschutzversicherung'
        },
        company_name: {
            type: 'string',
            title: 'Firmenname',
            maxLength: 128
        },
        company_legal_form: {
            title: 'Rechtsform',
            oneOf: [
                {
                    '$ref': '#/components/schemas/CompanyLegalFormEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        company_register_number: {
            type: 'string',
            title: 'Handelsregisternummer',
            maxLength: 128
        },
        company_register_court: {
            type: 'string',
            title: 'Amtsgericht',
            maxLength: 128
        },
        company_vat_id: {
            type: 'string',
            title: 'USt. ID',
            maxLength: 128
        },
        company_tax_id: {
            type: 'string',
            title: 'Steuernummer',
            maxLength: 128
        },
        bank_name: {
            type: 'string',
            title: 'Bankname',
            maxLength: 128
        },
        iban: {
            type: 'string',
            maxLength: 34
        },
        bic: {
            type: 'string',
            maxLength: 11
        },
        institution_name: {
            type: 'string',
            title: 'Name der Institution',
            maxLength: 128
        }
    },
    required: ['entity_type']
} as const;

export const $SuperUserEntityWithRelationship = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        entity: {
            '$ref': '#/components/schemas/SuperUserEntity'
        },
        relationships: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/EntityRelationship'
            }
        }
    },
    required: ['entity', 'relationships']
} as const;

export const $SuperUserEntityWithRelationshipRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        entity: {
            '$ref': '#/components/schemas/SuperUserEntityRequest'
        },
        relationships: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/EntityRelationshipRequest'
            }
        }
    },
    required: ['entity', 'relationships']
} as const;

export const $SuperUserFeedback = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        url: {
            type: 'string',
            maxLength: 255
        },
        user: {
            allOf: [
                {
                    '$ref': '#/components/schemas/SuperUserUser'
                }
            ],
            readOnly: true
        },
        rating: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,1}(?:\\.\\d{0,1})?$'
        },
        feature: {
            '$ref': '#/components/schemas/FeatureEnum'
        },
        comment: {
            type: 'string'
        },
        related_data: {
            '$ref': '#/components/schemas/FeedbackRelatedData'
        }
    },
    required: ['created_at', 'feature', 'rating', 'related_data', 'url', 'user', 'uuid']
} as const;

export const $SuperUserFeedbackRequest = {
    type: 'object',
    properties: {
        url: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        },
        rating: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,1}(?:\\.\\d{0,1})?$'
        },
        feature: {
            '$ref': '#/components/schemas/FeatureEnum'
        },
        comment: {
            type: 'string'
        },
        related_data: {
            '$ref': '#/components/schemas/FeedbackRelatedData'
        }
    },
    required: ['feature', 'rating', 'related_data', 'url']
} as const;

export const $SuperUserForm = {
    type: 'object',
    description: 'Form representation for superusers.',
    properties: {
        id: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        organisation: {
            allOf: [
                {
                    '$ref': '#/components/schemas/SuperUserOrganisation'
                }
            ],
            readOnly: true
        },
        organisation_uuid: {
            type: 'string',
            format: 'uuid'
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        modified_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        created_by: {
            allOf: [
                {
                    '$ref': '#/components/schemas/SuperUserUser'
                }
            ],
            readOnly: true
        },
        modified_by: {
            allOf: [
                {
                    '$ref': '#/components/schemas/SuperUserUser'
                }
            ],
            readOnly: true
        },
        tag: {
            oneOf: [
                {
                    '$ref': '#/components/schemas/FormTag'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        title: {
            type: 'string',
            maxLength: 255
        },
        description: {
            type: 'string'
        },
        file: {
            type: 'string',
            format: 'uri',
            nullable: true
        },
        due_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        document_name: {
            type: 'string',
            readOnly: true
        }
    },
    required: ['created_at', 'created_by', 'document_name', 'due_at', 'id', 'modified_at', 'modified_by', 'organisation', 'organisation_uuid']
} as const;

export const $SuperUserFormRequest = {
    type: 'object',
    description: 'Form representation for superusers.',
    properties: {
        organisation_uuid: {
            type: 'string',
            format: 'uuid'
        },
        tag: {
            oneOf: [
                {
                    '$ref': '#/components/schemas/FormTag'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        title: {
            type: 'string',
            maxLength: 255
        },
        description: {
            type: 'string'
        },
        file: {
            type: 'string',
            format: 'binary',
            nullable: true
        }
    },
    required: ['organisation_uuid']
} as const;

export const $SuperUserHubSpotCompany = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        hubspot_id: {
            type: 'string',
            readOnly: true,
            nullable: true
        },
        hubspot_archived: {
            type: 'boolean',
            readOnly: true,
            nullable: true
        },
        hubspot_archived_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true,
            nullable: true
        },
        hubspot_created_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true,
            nullable: true
        },
        hubspot_updated_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true,
            nullable: true
        },
        create_date: {
            type: 'string',
            format: 'date-time',
            readOnly: true,
            nullable: true
        },
        domain: {
            type: 'string',
            readOnly: true,
            nullable: true
        },
        hs_last_modified_date: {
            type: 'string',
            format: 'date-time',
            readOnly: true,
            nullable: true
        },
        hs_object_id: {
            type: 'string',
            readOnly: true,
            nullable: true
        },
        hubspot_url: {
            type: 'string',
            readOnly: true
        },
        name: {
            type: 'string',
            readOnly: true,
            nullable: true
        }
    },
    required: ['create_date', 'domain', 'hs_last_modified_date', 'hs_object_id', 'hubspot_archived', 'hubspot_archived_at', 'hubspot_created_at', 'hubspot_id', 'hubspot_updated_at', 'hubspot_url', 'name', 'uuid']
} as const;

export const $SuperUserHubSpotContact = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        hubspot_id: {
            type: 'string',
            readOnly: true,
            nullable: true
        },
        hubspot_archived: {
            type: 'boolean',
            readOnly: true,
            nullable: true
        },
        hubspot_archived_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true,
            nullable: true
        },
        hubspot_created_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true,
            nullable: true
        },
        hubspot_updated_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true,
            nullable: true
        },
        create_date: {
            type: 'string',
            format: 'date-time',
            readOnly: true,
            nullable: true
        },
        email: {
            type: 'string',
            format: 'email',
            readOnly: true,
            nullable: true
        },
        first_name: {
            type: 'string',
            readOnly: true,
            nullable: true
        },
        hs_object_id: {
            type: 'string',
            readOnly: true,
            nullable: true
        },
        last_modified_date: {
            type: 'string',
            format: 'date-time',
            readOnly: true,
            nullable: true
        },
        last_name: {
            type: 'string',
            readOnly: true,
            nullable: true
        }
    },
    required: ['create_date', 'email', 'first_name', 'hs_object_id', 'hubspot_archived', 'hubspot_archived_at', 'hubspot_created_at', 'hubspot_id', 'hubspot_updated_at', 'last_modified_date', 'last_name', 'uuid']
} as const;

export const $SuperUserInboundEmail = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        email: {
            allOf: [
                {
                    '$ref': '#/components/schemas/SuperUserEmail'
                }
            ],
            readOnly: true
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        org: {
            allOf: [
                {
                    '$ref': '#/components/schemas/SuperUserOrganisation'
                }
            ],
            readOnly: true
        },
        is_failed: {
            type: 'boolean'
        },
        from_email: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EmailAddress'
                }
            ],
            readOnly: true
        },
        reply_to: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EmailAddress'
                }
            ],
            readOnly: true
        },
        to: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/EmailAddress'
            },
            readOnly: true
        },
        cc: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/EmailAddress'
            },
            readOnly: true
        },
        subject: {
            type: 'string',
            maxLength: 255
        },
        html: {
            type: 'string'
        },
        text: {
            type: 'string'
        },
        attachments: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/InboundEmailAttachment'
            },
            readOnly: true
        }
    },
    required: ['attachments', 'cc', 'created_at', 'email', 'from_email', 'html', 'org', 'reply_to', 'subject', 'text', 'to']
} as const;

export const $SuperUserLawyerFeedback = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        rating: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,1}(?:\\.\\d{0,1})?$'
        },
        feedback: {
            type: 'string',
            maxLength: 1024
        }
    },
    required: ['rating', 'uuid']
} as const;

export const $SuperUserLawyerFeedbackRequest = {
    type: 'object',
    properties: {
        rating: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,1}(?:\\.\\d{0,1})?$'
        },
        feedback: {
            type: 'string',
            maxLength: 1024
        },
        call_uuid: {
            type: 'string',
            format: 'uuid',
            writeOnly: true
        }
    },
    required: ['call_uuid', 'rating']
} as const;

export const $SuperUserOrganisation = {
    type: 'object',
    description: 'Organisation representation for superusers.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        oid: {
            type: 'integer',
            readOnly: true
        },
        name: {
            type: 'string',
            nullable: true,
            title: 'Name der Kanzlei',
            maxLength: 128
        },
        logo: {
            type: 'string',
            format: 'uri',
            nullable: true
        },
        description: {
            type: 'string',
            title: 'Beschreibung',
            maxLength: 400
        },
        slug: {
            type: 'string',
            maxLength: 64,
            pattern: '^[-a-zA-Z0-9_]+$'
        },
        law_fields: {},
        law_firm: {
            type: 'boolean'
        },
        short_id: {
            type: 'string',
            maxLength: 8
        },
        street: {
            type: 'string',
            nullable: true,
            title: 'Straße',
            maxLength: 96
        },
        street_number: {
            type: 'string',
            nullable: true,
            title: 'Haus',
            maxLength: 12
        },
        zip: {
            type: 'string',
            nullable: true,
            title: 'PLZ',
            maxLength: 5
        },
        city: {
            type: 'string',
            nullable: true,
            title: 'Stadt',
            maxLength: 64
        },
        country: {
            type: 'string',
            nullable: true,
            title: 'Land',
            maxLength: 96
        },
        latitude: {
            type: 'string',
            nullable: true,
            title: 'Breitengrad'
        },
        longitude: {
            type: 'string',
            nullable: true,
            title: 'Längengrad'
        },
        phone: {
            type: 'string',
            nullable: true,
            title: 'Telefonnummer',
            maxLength: 24
        },
        email: {
            type: 'string',
            format: 'email',
            nullable: true,
            maxLength: 96
        },
        inbound_email_slug: {
            type: 'string',
            maxLength: 64
        },
        inbound_email_address: {
            type: 'string',
            readOnly: true
        },
        enable_inbound_email_replies: {
            type: 'boolean',
            title: 'Aktiv'
        },
        seats: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            title: 'Sitze'
        },
        appointments_seats: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            title: 'Terminbuchungen Sitze'
        },
        email_text_color: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EmailTextColorEnum'
                }
            ],
            title: 'Textfarbe'
        },
        email_text_font: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EmailTextFontEnum'
                }
            ],
            title: 'Schriftart'
        },
        email_text_size: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EmailTextSizeEnum'
                }
            ],
            title: 'Schriftgröße',
            minimum: -2147483648,
            maximum: 2147483647
        },
        email_signature: {
            type: 'string',
            title: 'E-Mail Signatur'
        },
        email_blocked_senders: {
            title: 'Blockierte Absender'
        },
        email_spam_filter_active: {
            type: 'boolean',
            title: 'Spamfilter aktiv'
        },
        track_email_delivery_events: {
            type: 'boolean',
            title: 'E-Mail Zustell-Events tracken'
        },
        track_opened_click_email_delivery_events: {
            type: 'boolean',
            title: 'E-Mail Öffnungs- und Klick-Events tracken'
        },
        receive_questionnaire_closed_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn ein Fragebogen abgeschlossen wird'
        },
        receive_document_signed_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn ein Dokument abgeschlossen wird'
        },
        receive_new_case_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn eine neue Anfrage erstellt wird'
        },
        receive_new_case_email_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn eine neue E-Mail zu einer Anfrage eingeht'
        },
        receive_new_appointment_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn ein neuer Terminvorschlag erstellt wird'
        },
        send_document_email_reminders: {
            type: 'boolean',
            title: 'Automatisierte E-Mail Erinnerungen aktiv'
        },
        send_document_email_reminders_every_x_days: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            title: 'E-Mail Erinnerungen alle x Tage senden'
        },
        max_reminders: {
            type: 'integer',
            maximum: 2147483647,
            minimum: 1,
            title: 'Maximale Anzahl Erinnerungen pro Dokument',
            description: 'Maximum number of reminders that can be sent per document or questionnaire'
        },
        send_email_client_confirmation_on_new_case: {
            type: 'boolean',
            title: 'E-Mail Bestätigung bei neuer Anfrage senden'
        },
        send_email_client_confirmation_on_new_case_via_email: {
            type: 'boolean',
            title: 'E-Mail Bestätigung bei neuer Anfrage per E-Mail senden'
        },
        receive_clerk_change_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn ein Sachbearbeiter zugewiesen wird'
        },
        receive_email_bounce_notifications: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn eine E-Mail nicht zugestellt werden konnte'
        },
        is_actaport_export_integration_enabled: {
            type: 'boolean',
            title: 'Actaport Integration aktivieren'
        },
        questionnaire_creation_token: {
            type: 'string',
            maxLength: 48
        },
        ai_enabled: {
            type: 'boolean',
            title: 'KI Aktiv'
        },
        enable_ai_workflows: {
            type: 'boolean',
            title: 'KI-Workflows aktivieren'
        },
        is_iusta_egress_integration_enabled: {
            type: 'boolean',
            title: 'Iusta Integration aktivieren'
        },
        is_ra_micro_export_integration_enabled: {
            type: 'boolean'
        },
        ra_micro_export_integration_type: {
            nullable: true,
            title: 'Integration Type',
            oneOf: [
                {
                    '$ref': '#/components/schemas/RaMicroExportIntegrationTypeEnum'
                },
                {
                    '$ref': '#/components/schemas/NullEnum'
                }
            ]
        },
        ra_micro_oma_email_id: {
            type: 'string',
            nullable: true,
            title: 'OMA Email ID',
            maxLength: 64
        },
        ra_micro_oma_email: {
            type: 'string',
            format: 'email',
            nullable: true,
            title: 'OMA Email',
            maxLength: 96
        },
        is_advolux_export_integration_enabled: {
            type: 'boolean'
        },
        is_webhooks_egress_integration_enabled: {
            type: 'boolean'
        },
        webhook_urls: {
            type: 'string',
            nullable: true,
            maxLength: 256
        },
        is_email_egress_integration_enabled: {
            type: 'boolean'
        },
        email_egress_address: {
            type: 'string',
            format: 'email',
            nullable: true,
            title: 'Email',
            maxLength: 96
        },
        is_kleos_integration_enabled: {
            type: 'boolean'
        },
        is_advoware_export_integration_enabled: {
            type: 'boolean',
            title: 'Advoware Integration aktivieren'
        },
        is_law_firm_software_exportation_enabled: {
            type: 'boolean'
        },
        enable_appointments: {
            type: 'boolean',
            title: 'Terminbuchung aktivieren'
        },
        enable_voice: {
            type: 'boolean',
            title: 'KI-Anrufbeantworter aktivieren'
        },
        enable_cases: {
            type: 'boolean',
            title: 'Anfragen aktivieren (normale JUPUS Plattform)'
        },
        stripe_customer: {
            allOf: [
                {
                    '$ref': '#/components/schemas/SuperUserStripeCustomer'
                }
            ],
            readOnly: true
        },
        stripe_customer_uuid: {
            type: 'string',
            format: 'uuid',
            nullable: true
        },
        customer_number: {
            type: 'string',
            readOnly: true
        },
        is_hubspot_egress_integration_enabled: {
            type: 'boolean'
        },
        is_haveibeenpwned_integration_enabled: {
            type: 'boolean'
        },
        is_jurnodes_export_integration_enabled: {
            type: 'boolean',
            title: 'Jur|nodes Integration aktivieren'
        },
        is_datev_export_integration_enabled: {
            type: 'boolean'
        },
        bot_title: {
            type: 'string',
            maxLength: 64
        },
        bot_embed_uuid: {
            type: 'string',
            format: 'uuid'
        },
        bot_starttime: {
            type: 'string',
            maxLength: 8
        },
        bot_attention_message: {
            type: 'string',
            maxLength: 64
        },
        bot_title_background_color: {
            type: 'string',
            title: 'Hintergrundfarbe',
            maxLength: 64
        },
        bot_title_text_color: {
            type: 'string',
            title: 'Textfarbe',
            maxLength: 64
        },
        bot_chat_bubble_operator_color: {
            type: 'string',
            title: 'Hintergrundfarbe',
            maxLength: 64
        },
        bot_message_input_text_color: {
            type: 'string',
            title: 'Textfarbe',
            maxLength: 64
        },
        bot_custom_font_family: {
            type: 'string',
            title: 'Schriftart',
            maxLength: 64
        },
        bot_chat_auto_open: {
            type: 'boolean',
            title: 'Chat automatisch öffnen'
        },
        bot_chat_auto_open_delay: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            title: 'Zeit, nach der der Chat automatisch geöffnet wird (in Millisekunden)'
        },
        bot_chat_target_element: {
            type: 'string',
            title: 'Element, in dem der Chat-Button eingebunden werden soll',
            maxLength: 64
        },
        bot_button_auto_show: {
            type: 'boolean',
            title: 'Button automatisch anzeigen'
        },
        bot_button_auto_show_delay: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            title: 'Zeit, nach der der Button automatisch angezeigt wird (in Millisekunden)'
        },
        bot_button_position: {
            allOf: [
                {
                    '$ref': '#/components/schemas/BotButtonPositionEnum'
                }
            ],
            title: 'Die Position des Buttons zum Starten des Chats'
        },
        bot_chat_bubble_operator_text_color: {
            type: 'string',
            title: 'Textfarbe',
            maxLength: 64
        },
        bot_button_background_color: {
            type: 'string',
            title: 'Hintergrundfarbe',
            maxLength: 64
        },
        bot_button_text_color: {
            type: 'string',
            title: 'Textfarbe',
            maxLength: 64
        },
        bot_chat_bubble_contact_color: {
            type: 'string',
            title: 'Hintergrundfarbe',
            maxLength: 64
        },
        bot_chat_bubble_contact_text_color: {
            type: 'string',
            title: 'Textfarbe',
            maxLength: 64
        },
        bot_floating_custom: {
            type: 'string',
            title: 'Widget Button custom CSS'
        },
        bot_footer_content: {
            type: 'string',
            title: 'Footer CSS'
        },
        bot_background_color: {
            type: 'string',
            title: 'Hintergrundfarbe',
            maxLength: 64
        },
        bot_message_input_background_color: {
            type: 'string',
            title: 'Hintergrundfarbe',
            maxLength: 64
        },
        bot_start_without_bot: {},
        bot_start_without_bot_buttons: {},
        bot_floating_custom_button_background_color: {
            type: 'string',
            title: 'Hintergrundfarbe',
            maxLength: 64
        },
        bot_floating_custom_button_text_color: {
            type: 'string',
            title: 'Textfarbe',
            maxLength: 64
        },
        bot_floating_custom_button_width: {
            type: 'integer',
            maximum: 2147483647,
            minimum: 0,
            title: 'Breite (Pixel)'
        },
        bot_floating_custom_button_height: {
            type: 'integer',
            maximum: 2147483647,
            minimum: 0,
            title: 'Höhe (Pixel)'
        },
        bot_floating_custom_button_text: {
            type: 'string',
            title: 'Text',
            maxLength: 64
        },
        receive_monthly_updates_summary: {
            type: 'boolean',
            title: 'Monatliche Zusammenfassung per E-Mail erhalten'
        },
        hubspot_company: {
            allOf: [
                {
                    '$ref': '#/components/schemas/SuperUserHubSpotCompany'
                }
            ],
            readOnly: true
        },
        hubspot_company_uuid: {
            type: 'string',
            format: 'uuid',
            nullable: true
        },
        advoware_clerk_options: {
            type: 'string',
            readOnly: true
        },
        advoware_law_field_options: {
            type: 'string',
            readOnly: true
        },
        actaport_clerk_options: {
            type: 'string',
            readOnly: true
        },
        jurnodes_datapool_options: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    id: {
                        type: 'integer'
                    },
                    name: {
                        type: 'string'
                    }
                },
                required: ['id', 'name']
            },
            readOnly: true
        },
        jurnodes_lawyer_options: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    id: {
                        type: 'integer'
                    },
                    name: {
                        type: 'string'
                    }
                },
                required: ['id', 'name']
            },
            readOnly: true
        },
        jurnodes_law_category_options: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    id: {
                        type: 'integer'
                    },
                    name: {
                        type: 'string'
                    }
                },
                required: ['id', 'name']
            },
            readOnly: true
        },
        jurnodes_record_schema_options: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    id: {
                        type: 'integer'
                    },
                    name: {
                        type: 'string'
                    }
                },
                required: ['id', 'name']
            },
            readOnly: true
        },
        actaport_assistant_options: {
            type: 'string',
            readOnly: true
        },
        kleos_case_type_options: {
            type: 'string',
            readOnly: true
        },
        users: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/SuperUserOrganisationUser'
            },
            readOnly: true
        },
        has_churned: {
            type: 'boolean',
            title: 'Hat gekündigt'
        },
        enable_law_specific_data: {
            type: 'boolean',
            title: 'Rechtsspezifische Daten & Dokumentengenerator aktivieren'
        },
        ai_chat_question_templates: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/AiChatQuestionTemplate'
            },
            readOnly: true
        },
        is_new_ui_switch_enabled: {
            type: 'boolean'
        },
        is_forced_to_use_new_ui: {
            type: 'boolean'
        },
        vitally_id: {
            type: 'string',
            readOnly: true
        },
        vitally_updated_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true,
            nullable: true
        },
        vitally_health_score: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,3}(?:\\.\\d{0,2})?$',
            readOnly: true,
            nullable: true
        },
        is_phonebot_self_service_customer: {
            type: 'boolean',
            title: 'Phonebot Self-Service Kunde'
        },
        phonebot_self_service_plan: {
            nullable: true,
            oneOf: [
                {
                    '$ref': '#/components/schemas/PhonebotSelfServicePlanEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                },
                {
                    '$ref': '#/components/schemas/NullEnum'
                }
            ]
        },
        phonebot_trial_ends_at: {
            type: 'string',
            format: 'date',
            nullable: true
        }
    },
    required: ['actaport_assistant_options', 'actaport_clerk_options', 'advoware_clerk_options', 'advoware_law_field_options', 'ai_chat_question_templates', 'customer_number', 'hubspot_company', 'hubspot_company_uuid', 'inbound_email_address', 'jurnodes_datapool_options', 'jurnodes_law_category_options', 'jurnodes_lawyer_options', 'jurnodes_record_schema_options', 'kleos_case_type_options', 'oid', 'stripe_customer', 'stripe_customer_uuid', 'users', 'uuid', 'vitally_health_score', 'vitally_id', 'vitally_updated_at']
} as const;

export const $SuperUserOrganisationRequest = {
    type: 'object',
    description: 'Organisation representation for superusers.',
    properties: {
        name: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'Name der Kanzlei',
            maxLength: 128
        },
        logo: {
            type: 'string',
            format: 'binary',
            nullable: true
        },
        description: {
            type: 'string',
            title: 'Beschreibung',
            maxLength: 400
        },
        slug: {
            type: 'string',
            minLength: 1,
            maxLength: 64,
            pattern: '^[-a-zA-Z0-9_]+$'
        },
        law_fields: {},
        law_firm: {
            type: 'boolean'
        },
        short_id: {
            type: 'string',
            minLength: 1,
            maxLength: 8
        },
        street: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'Straße',
            maxLength: 96
        },
        street_number: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'Haus',
            maxLength: 12
        },
        zip: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'PLZ',
            maxLength: 5
        },
        city: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'Stadt',
            maxLength: 64
        },
        country: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'Land',
            maxLength: 96
        },
        latitude: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'Breitengrad'
        },
        longitude: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'Längengrad'
        },
        phone: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'Telefonnummer',
            maxLength: 24
        },
        email: {
            type: 'string',
            format: 'email',
            nullable: true,
            minLength: 1,
            maxLength: 96
        },
        inbound_email_slug: {
            type: 'string',
            minLength: 1,
            maxLength: 64
        },
        enable_inbound_email_replies: {
            type: 'boolean',
            title: 'Aktiv'
        },
        seats: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            title: 'Sitze'
        },
        appointments_seats: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            title: 'Terminbuchungen Sitze'
        },
        email_text_color: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EmailTextColorEnum'
                }
            ],
            title: 'Textfarbe'
        },
        email_text_font: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EmailTextFontEnum'
                }
            ],
            title: 'Schriftart'
        },
        email_text_size: {
            allOf: [
                {
                    '$ref': '#/components/schemas/EmailTextSizeEnum'
                }
            ],
            title: 'Schriftgröße',
            minimum: -2147483648,
            maximum: 2147483647
        },
        email_signature: {
            type: 'string',
            title: 'E-Mail Signatur'
        },
        email_blocked_senders: {
            title: 'Blockierte Absender'
        },
        email_spam_filter_active: {
            type: 'boolean',
            title: 'Spamfilter aktiv'
        },
        track_email_delivery_events: {
            type: 'boolean',
            title: 'E-Mail Zustell-Events tracken'
        },
        track_opened_click_email_delivery_events: {
            type: 'boolean',
            title: 'E-Mail Öffnungs- und Klick-Events tracken'
        },
        receive_questionnaire_closed_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn ein Fragebogen abgeschlossen wird'
        },
        receive_document_signed_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn ein Dokument abgeschlossen wird'
        },
        receive_new_case_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn eine neue Anfrage erstellt wird'
        },
        receive_new_case_email_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn eine neue E-Mail zu einer Anfrage eingeht'
        },
        receive_new_appointment_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn ein neuer Terminvorschlag erstellt wird'
        },
        send_document_email_reminders: {
            type: 'boolean',
            title: 'Automatisierte E-Mail Erinnerungen aktiv'
        },
        send_document_email_reminders_every_x_days: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            title: 'E-Mail Erinnerungen alle x Tage senden'
        },
        max_reminders: {
            type: 'integer',
            maximum: 2147483647,
            minimum: 1,
            title: 'Maximale Anzahl Erinnerungen pro Dokument',
            description: 'Maximum number of reminders that can be sent per document or questionnaire'
        },
        send_email_client_confirmation_on_new_case: {
            type: 'boolean',
            title: 'E-Mail Bestätigung bei neuer Anfrage senden'
        },
        send_email_client_confirmation_on_new_case_via_email: {
            type: 'boolean',
            title: 'E-Mail Bestätigung bei neuer Anfrage per E-Mail senden'
        },
        receive_clerk_change_mail: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn ein Sachbearbeiter zugewiesen wird'
        },
        receive_email_bounce_notifications: {
            type: 'boolean',
            title: 'E-Mail erhalten, wenn eine E-Mail nicht zugestellt werden konnte'
        },
        is_actaport_export_integration_enabled: {
            type: 'boolean',
            title: 'Actaport Integration aktivieren'
        },
        questionnaire_creation_token: {
            type: 'string',
            minLength: 1,
            maxLength: 48
        },
        ai_enabled: {
            type: 'boolean',
            title: 'KI Aktiv'
        },
        enable_ai_workflows: {
            type: 'boolean',
            title: 'KI-Workflows aktivieren'
        },
        is_iusta_egress_integration_enabled: {
            type: 'boolean',
            title: 'Iusta Integration aktivieren'
        },
        is_ra_micro_export_integration_enabled: {
            type: 'boolean'
        },
        ra_micro_export_integration_type: {
            nullable: true,
            title: 'Integration Type',
            oneOf: [
                {
                    '$ref': '#/components/schemas/RaMicroExportIntegrationTypeEnum'
                },
                {
                    '$ref': '#/components/schemas/NullEnum'
                }
            ]
        },
        ra_micro_oma_email_id: {
            type: 'string',
            nullable: true,
            minLength: 1,
            title: 'OMA Email ID',
            maxLength: 64
        },
        ra_micro_oma_email: {
            type: 'string',
            format: 'email',
            nullable: true,
            minLength: 1,
            title: 'OMA Email',
            maxLength: 96
        },
        is_advolux_export_integration_enabled: {
            type: 'boolean'
        },
        is_webhooks_egress_integration_enabled: {
            type: 'boolean'
        },
        webhook_urls: {
            type: 'string',
            nullable: true,
            maxLength: 256
        },
        is_email_egress_integration_enabled: {
            type: 'boolean'
        },
        email_egress_address: {
            type: 'string',
            format: 'email',
            nullable: true,
            minLength: 1,
            title: 'Email',
            maxLength: 96
        },
        is_kleos_integration_enabled: {
            type: 'boolean'
        },
        is_advoware_export_integration_enabled: {
            type: 'boolean',
            title: 'Advoware Integration aktivieren'
        },
        is_law_firm_software_exportation_enabled: {
            type: 'boolean'
        },
        enable_appointments: {
            type: 'boolean',
            title: 'Terminbuchung aktivieren'
        },
        enable_voice: {
            type: 'boolean',
            title: 'KI-Anrufbeantworter aktivieren'
        },
        enable_cases: {
            type: 'boolean',
            title: 'Anfragen aktivieren (normale JUPUS Plattform)'
        },
        stripe_customer_uuid: {
            type: 'string',
            format: 'uuid',
            nullable: true
        },
        is_hubspot_egress_integration_enabled: {
            type: 'boolean'
        },
        is_haveibeenpwned_integration_enabled: {
            type: 'boolean'
        },
        is_jurnodes_export_integration_enabled: {
            type: 'boolean',
            title: 'Jur|nodes Integration aktivieren'
        },
        is_datev_export_integration_enabled: {
            type: 'boolean'
        },
        bot_title: {
            type: 'string',
            maxLength: 64
        },
        bot_embed_uuid: {
            type: 'string',
            format: 'uuid'
        },
        bot_starttime: {
            type: 'string',
            minLength: 1,
            maxLength: 8
        },
        bot_attention_message: {
            type: 'string',
            maxLength: 64
        },
        bot_title_background_color: {
            type: 'string',
            minLength: 1,
            title: 'Hintergrundfarbe',
            maxLength: 64
        },
        bot_title_text_color: {
            type: 'string',
            minLength: 1,
            title: 'Textfarbe',
            maxLength: 64
        },
        bot_chat_bubble_operator_color: {
            type: 'string',
            minLength: 1,
            title: 'Hintergrundfarbe',
            maxLength: 64
        },
        bot_message_input_text_color: {
            type: 'string',
            minLength: 1,
            title: 'Textfarbe',
            maxLength: 64
        },
        bot_custom_font_family: {
            type: 'string',
            title: 'Schriftart',
            maxLength: 64
        },
        bot_chat_auto_open: {
            type: 'boolean',
            title: 'Chat automatisch öffnen'
        },
        bot_chat_auto_open_delay: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            title: 'Zeit, nach der der Chat automatisch geöffnet wird (in Millisekunden)'
        },
        bot_chat_target_element: {
            type: 'string',
            title: 'Element, in dem der Chat-Button eingebunden werden soll',
            maxLength: 64
        },
        bot_button_auto_show: {
            type: 'boolean',
            title: 'Button automatisch anzeigen'
        },
        bot_button_auto_show_delay: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            title: 'Zeit, nach der der Button automatisch angezeigt wird (in Millisekunden)'
        },
        bot_button_position: {
            allOf: [
                {
                    '$ref': '#/components/schemas/BotButtonPositionEnum'
                }
            ],
            title: 'Die Position des Buttons zum Starten des Chats'
        },
        bot_chat_bubble_operator_text_color: {
            type: 'string',
            minLength: 1,
            title: 'Textfarbe',
            maxLength: 64
        },
        bot_button_background_color: {
            type: 'string',
            minLength: 1,
            title: 'Hintergrundfarbe',
            maxLength: 64
        },
        bot_button_text_color: {
            type: 'string',
            minLength: 1,
            title: 'Textfarbe',
            maxLength: 64
        },
        bot_chat_bubble_contact_color: {
            type: 'string',
            minLength: 1,
            title: 'Hintergrundfarbe',
            maxLength: 64
        },
        bot_chat_bubble_contact_text_color: {
            type: 'string',
            minLength: 1,
            title: 'Textfarbe',
            maxLength: 64
        },
        bot_floating_custom: {
            type: 'string',
            title: 'Widget Button custom CSS'
        },
        bot_footer_content: {
            type: 'string',
            minLength: 1,
            title: 'Footer CSS'
        },
        bot_background_color: {
            type: 'string',
            minLength: 1,
            title: 'Hintergrundfarbe',
            maxLength: 64
        },
        bot_message_input_background_color: {
            type: 'string',
            minLength: 1,
            title: 'Hintergrundfarbe',
            maxLength: 64
        },
        bot_start_without_bot: {},
        bot_start_without_bot_buttons: {},
        bot_floating_custom_button_background_color: {
            type: 'string',
            minLength: 1,
            title: 'Hintergrundfarbe',
            maxLength: 64
        },
        bot_floating_custom_button_text_color: {
            type: 'string',
            minLength: 1,
            title: 'Textfarbe',
            maxLength: 64
        },
        bot_floating_custom_button_width: {
            type: 'integer',
            maximum: 2147483647,
            minimum: 0,
            title: 'Breite (Pixel)'
        },
        bot_floating_custom_button_height: {
            type: 'integer',
            maximum: 2147483647,
            minimum: 0,
            title: 'Höhe (Pixel)'
        },
        bot_floating_custom_button_text: {
            type: 'string',
            minLength: 1,
            title: 'Text',
            maxLength: 64
        },
        receive_monthly_updates_summary: {
            type: 'boolean',
            title: 'Monatliche Zusammenfassung per E-Mail erhalten'
        },
        hubspot_company_uuid: {
            type: 'string',
            format: 'uuid',
            nullable: true
        },
        has_churned: {
            type: 'boolean',
            title: 'Hat gekündigt'
        },
        enable_law_specific_data: {
            type: 'boolean',
            title: 'Rechtsspezifische Daten & Dokumentengenerator aktivieren'
        },
        is_new_ui_switch_enabled: {
            type: 'boolean'
        },
        is_forced_to_use_new_ui: {
            type: 'boolean'
        },
        is_phonebot_self_service_customer: {
            type: 'boolean',
            title: 'Phonebot Self-Service Kunde'
        },
        phonebot_self_service_plan: {
            nullable: true,
            oneOf: [
                {
                    '$ref': '#/components/schemas/PhonebotSelfServicePlanEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                },
                {
                    '$ref': '#/components/schemas/NullEnum'
                }
            ]
        },
        phonebot_trial_ends_at: {
            type: 'string',
            format: 'date',
            nullable: true
        }
    },
    required: ['hubspot_company_uuid', 'stripe_customer_uuid']
} as const;

export const $SuperUserOrganisationUser = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        email: {
            type: 'string',
            format: 'email',
            readOnly: true
        },
        first_name: {
            type: 'string',
            readOnly: true,
            title: 'Vorname'
        },
        last_name: {
            type: 'string',
            readOnly: true,
            title: 'Nachname'
        },
        avatar: {
            type: 'string',
            format: 'uri',
            readOnly: true,
            nullable: true
        }
    },
    required: ['avatar', 'email', 'first_name', 'last_name', 'uuid']
} as const;

export const $SuperUserPDFFormSubmission = {
    type: 'object',
    description: 'Serializer for superusers - full access to all fields.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        submission_status: {
            allOf: [
                {
                    '$ref': '#/components/schemas/SubmissionStatusEnum'
                }
            ],
            description: `Current status of the form submission

* \`in_progress\` - In Progress
* \`completed\` - Completed`
        },
        template_name: {
            type: 'string',
            description: 'Snapshot of template name at submission creation time',
            maxLength: 255
        },
        template_description: {
            type: 'string',
            description: 'Snapshot of template description at submission creation time'
        },
        form_fields: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/SubmissionFormField'
            }
        },
        progress_percentage: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            description: 'Completion percentage (0-100)'
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        completed_at: {
            type: 'string',
            format: 'date-time',
            nullable: true,
            description: 'When the form was completed'
        },
        updated_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        created_by: {
            type: 'integer',
            nullable: true
        },
        org: {
            type: 'integer'
        },
        template: {
            '$ref': '#/components/schemas/PDFFormTemplate'
        },
        document: {
            '$ref': '#/components/schemas/Document'
        },
        is_standalone: {
            type: 'boolean',
            description: 'Standalone submission that creates a new case (like questionnaires from settings)'
        },
        is_external: {
            type: 'boolean',
            description: 'External submission linked to existing case for third-party completion'
        }
    },
    required: ['created_at', 'document', 'form_fields', 'org', 'template', 'updated_at']
} as const;

export const $SuperUserPDFFormSubmissionRequest = {
    type: 'object',
    description: 'Serializer for superusers - full access to all fields.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        submission_status: {
            allOf: [
                {
                    '$ref': '#/components/schemas/SubmissionStatusEnum'
                }
            ],
            description: `Current status of the form submission

* \`in_progress\` - In Progress
* \`completed\` - Completed`
        },
        template_name: {
            type: 'string',
            minLength: 1,
            description: 'Snapshot of template name at submission creation time',
            maxLength: 255
        },
        template_description: {
            type: 'string',
            description: 'Snapshot of template description at submission creation time'
        },
        form_fields: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/SubmissionFormFieldRequest'
            }
        },
        progress_percentage: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483648,
            description: 'Completion percentage (0-100)'
        },
        completed_at: {
            type: 'string',
            format: 'date-time',
            nullable: true,
            description: 'When the form was completed'
        },
        created_by: {
            type: 'integer',
            nullable: true
        },
        org: {
            type: 'integer'
        },
        template: {
            '$ref': '#/components/schemas/PDFFormTemplateRequest'
        },
        is_standalone: {
            type: 'boolean',
            description: 'Standalone submission that creates a new case (like questionnaires from settings)'
        },
        is_external: {
            type: 'boolean',
            description: 'External submission linked to existing case for third-party completion'
        }
    },
    required: ['form_fields', 'org', 'template']
} as const;

export const $SuperUserPDFFormTemplate = {
    type: 'object',
    description: 'Serializer for superusers - includes organization information.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        name: {
            type: 'string',
            maxLength: 255
        },
        description: {
            type: 'string'
        },
        original_pdf: {
            type: 'string',
            format: 'uri',
            description: 'Original PDF template uploaded by user (preserved, never modified)'
        },
        processed_pdf: {
            type: 'string',
            format: 'uri',
            readOnly: true,
            nullable: true,
            description: 'Processed PDF with annotations stripped for clean display'
        },
        form_fields: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/FormField'
            }
        },
        template_creation_token: {
            type: 'string',
            readOnly: true,
            nullable: true,
            description: 'Token used to create standalone form submissions via public URLs'
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        created_by: {
            allOf: [
                {
                    '$ref': '#/components/schemas/CustomerUser'
                }
            ],
            readOnly: true
        },
        updated_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        modified_by: {
            allOf: [
                {
                    '$ref': '#/components/schemas/CustomerUser'
                }
            ],
            readOnly: true
        },
        org: {
            allOf: [
                {
                    '$ref': '#/components/schemas/ClientOrganisation'
                }
            ],
            readOnly: true
        }
    },
    required: ['created_at', 'created_by', 'modified_by', 'name', 'org', 'original_pdf', 'processed_pdf', 'template_creation_token', 'updated_at', 'uuid']
} as const;

export const $SuperUserPhoneNumber = {
    type: 'object',
    description: 'PhoneNumber representation for superusers.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        active: {
            type: 'boolean'
        },
        org: {
            allOf: [
                {
                    '$ref': '#/components/schemas/SuperUserOrganisation'
                }
            ],
            readOnly: true
        },
        phone_number: {
            type: 'string',
            readOnly: true,
            nullable: true
        },
        law_fields: {
            title: 'Rechtsgebiete'
        },
        description: {
            type: 'string',
            title: 'Bezeichnung',
            description: 'Hier können Sie eine interne Bezeichnung für die Rufnummer hinterlegen.',
            maxLength: 255
        },
        lawfirm_name: {
            type: 'string',
            title: 'Kanzleiname',
            description: 'Geben Sie hier den Namen Ihrer Kanzlei ein, wie er in der Begrüßungsansage genannt werden soll.',
            maxLength: 255
        },
        address: {
            type: 'string',
            title: 'Adresse',
            description: 'Hier können Sie die Adresse Ihrer Kanzlei hinterlegen. Bei Nachfrage geben wir diese an den Anrufer weiter. Wenn Sie keine unangekündigten Mandantenbesuch wünschen, dann geben Sie hier bitte einen entsprechenden Hinweis.',
            maxLength: 1024
        },
        opening_hours: {
            type: 'string',
            title: 'Öffnungszeiten',
            description: 'Hier können Sie Ihre Öffnungszeiten Ihrer Kanzlei hinterlegen. Bei Nachfrage geben wir diese an den Anrufer weiter.',
            maxLength: 1024
        },
        lawyer_names: {
            type: 'string',
            title: 'Anwälte/Sachbearbeiter',
            description: 'Hier können Sie die Namen Ihrer Anwälte oder Sachbearbeiter hinterlegen. Dies hilft uns dabei, den Namen des Anrufers besser zu erkennen. Bitte tragen Sie nur den Namen ein und keine weitere Bezeichnung wie zum Beispiel Anwalt oder Sachbearbeiter.',
            maxLength: 1024
        },
        has_free_initial_consultation: {
            type: 'boolean',
            title: 'Kostenlose Erstberatung',
            description: 'Bieten Sie eine kostenlose Erstberatung an? Wenn ja, dann aktivieren Sie diese Option und wir geben dies an den Anrufer weiter.'
        },
        free_initial_consultation: {
            type: 'boolean',
            description: 'COMPATIBILITY: Return the old field name for the free initial consultation.',
            readOnly: true
        },
        original_phone_number: {
            type: 'string',
            title: 'Telefonnummer',
            description: 'Wenn Sie die von uns generierte Nummer intern weiterleiten, geben Sie hier unbedingt die Originalnummer an, welche von den Mandanten angerufen wird. So stellen Sie sicher, dass wir die Anrufe korrekt zuordnen können.',
            maxLength: 255
        },
        can_record_calls: {
            type: 'boolean',
            title: 'Anrufe aufzeichnen',
            description: 'Durch das Aktivieren dieser Option Stellen wir Ihnen auf der Detailseite eines Anrufs einen Mitschnitt des Namen bzw. der E-Mail-Addresse zur Verfügung. Die Aufzeichnung von Anrufen ist in Deutschland nur mit Zustimmung des Anrufers gestattet. Wir weisen Sie darauf hin, dass Sie diese Zustimmung von dem Anrufer einholen müssen.'
        },
        is_in_answering_machine_mode: {
            type: 'boolean',
            title: 'Reiner Anrufbeantworter'
        },
        phone_number_sid: {
            type: 'string',
            nullable: true,
            readOnly: true
        },
        agent: {
            allOf: [
                {
                    '$ref': '#/components/schemas/SuperUserRetellAgent'
                }
            ],
            readOnly: true
        },
        voice_url: {
            type: 'string',
            nullable: true,
            readOnly: true
        },
        voice_method: {
            type: 'string',
            nullable: true,
            readOnly: true
        },
        status_callback: {
            type: 'string',
            nullable: true,
            readOnly: true
        },
        status_callback_method: {
            type: 'string',
            nullable: true,
            readOnly: true
        },
        begin_message: {
            type: 'string',
            title: 'Begrüßung',
            description: 'Hier können Sie eine Begrüßung für den Anrufbeantworter hinterlegen. Diese wird am Anfang des Anrufes abgespielt.',
            maxLength: 1024
        },
        end_message: {
            type: 'string',
            title: 'Abschiedsnachricht',
            description: 'Hier können Sie eine Abschiedsnachricht für den Anrufbeantworter hinterlegen. Diese wird am Ende des Anrufes abgespielt.',
            maxLength: 1024
        },
        forwarding_rules: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/PhoneForwardingRuleList'
            },
            readOnly: true
        }
    },
    required: ['agent', 'created_at', 'forwarding_rules', 'free_initial_consultation', 'org', 'phone_number', 'phone_number_sid', 'status_callback', 'status_callback_method', 'voice_method', 'voice_url']
} as const;

export const $SuperUserPhoneNumberRequest = {
    type: 'object',
    description: 'PhoneNumber representation for superusers.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        active: {
            type: 'boolean'
        },
        law_fields: {
            title: 'Rechtsgebiete'
        },
        description: {
            type: 'string',
            title: 'Bezeichnung',
            description: 'Hier können Sie eine interne Bezeichnung für die Rufnummer hinterlegen.',
            maxLength: 255
        },
        lawfirm_name: {
            type: 'string',
            title: 'Kanzleiname',
            description: 'Geben Sie hier den Namen Ihrer Kanzlei ein, wie er in der Begrüßungsansage genannt werden soll.',
            maxLength: 255
        },
        address: {
            type: 'string',
            title: 'Adresse',
            description: 'Hier können Sie die Adresse Ihrer Kanzlei hinterlegen. Bei Nachfrage geben wir diese an den Anrufer weiter. Wenn Sie keine unangekündigten Mandantenbesuch wünschen, dann geben Sie hier bitte einen entsprechenden Hinweis.',
            maxLength: 1024
        },
        opening_hours: {
            type: 'string',
            title: 'Öffnungszeiten',
            description: 'Hier können Sie Ihre Öffnungszeiten Ihrer Kanzlei hinterlegen. Bei Nachfrage geben wir diese an den Anrufer weiter.',
            maxLength: 1024
        },
        lawyer_names: {
            type: 'string',
            title: 'Anwälte/Sachbearbeiter',
            description: 'Hier können Sie die Namen Ihrer Anwälte oder Sachbearbeiter hinterlegen. Dies hilft uns dabei, den Namen des Anrufers besser zu erkennen. Bitte tragen Sie nur den Namen ein und keine weitere Bezeichnung wie zum Beispiel Anwalt oder Sachbearbeiter.',
            maxLength: 1024
        },
        has_free_initial_consultation: {
            type: 'boolean',
            title: 'Kostenlose Erstberatung',
            description: 'Bieten Sie eine kostenlose Erstberatung an? Wenn ja, dann aktivieren Sie diese Option und wir geben dies an den Anrufer weiter.'
        },
        original_phone_number: {
            type: 'string',
            title: 'Telefonnummer',
            description: 'Wenn Sie die von uns generierte Nummer intern weiterleiten, geben Sie hier unbedingt die Originalnummer an, welche von den Mandanten angerufen wird. So stellen Sie sicher, dass wir die Anrufe korrekt zuordnen können.',
            maxLength: 255
        },
        can_record_calls: {
            type: 'boolean',
            title: 'Anrufe aufzeichnen',
            description: 'Durch das Aktivieren dieser Option Stellen wir Ihnen auf der Detailseite eines Anrufs einen Mitschnitt des Namen bzw. der E-Mail-Addresse zur Verfügung. Die Aufzeichnung von Anrufen ist in Deutschland nur mit Zustimmung des Anrufers gestattet. Wir weisen Sie darauf hin, dass Sie diese Zustimmung von dem Anrufer einholen müssen.'
        },
        is_in_answering_machine_mode: {
            type: 'boolean',
            title: 'Reiner Anrufbeantworter'
        },
        agent_uuid: {
            type: 'string',
            writeOnly: true,
            minLength: 1
        },
        org_uuid: {
            type: 'string',
            writeOnly: true,
            minLength: 1
        },
        begin_message: {
            type: 'string',
            title: 'Begrüßung',
            description: 'Hier können Sie eine Begrüßung für den Anrufbeantworter hinterlegen. Diese wird am Anfang des Anrufes abgespielt.',
            maxLength: 1024
        },
        end_message: {
            type: 'string',
            title: 'Abschiedsnachricht',
            description: 'Hier können Sie eine Abschiedsnachricht für den Anrufbeantworter hinterlegen. Diese wird am Ende des Anrufes abgespielt.',
            maxLength: 1024
        }
    },
    required: ['agent_uuid', 'org_uuid']
} as const;

export const $SuperUserQuestionnaire = {
    type: 'object',
    description: 'Questionnaire representation for superusers.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        title: {
            type: 'string',
            maxLength: 64
        },
        description: {
            type: 'string'
        },
        category: {
            oneOf: [
                {
                    '$ref': '#/components/schemas/CategoryEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        law_field: {
            title: 'Rechtsgebiet',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawFieldEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        law_topic: {
            title: 'Rechtsthema',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawTopicEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        schema: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/QuestionnaireSection'
            }
        },
        theme_color: {
            type: 'string',
            readOnly: true
        },
        org: {
            allOf: [
                {
                    '$ref': '#/components/schemas/ClientOrganisation'
                }
            ],
            readOnly: true
        },
        is_jupus_template: {
            type: 'boolean',
            description: 'True if this questionnaire is a Jupus template that can be copied by organizations'
        },
        created_by_name: {
            type: 'string',
            readOnly: true
        },
        questionnaire_creation_token: {
            type: 'string',
            readOnly: true
        },
        org_questionnaire_creation_token: {
            type: 'string',
            readOnly: true
        }
    },
    required: ['created_by_name', 'org', 'org_questionnaire_creation_token', 'questionnaire_creation_token', 'schema', 'theme_color', 'title', 'uuid']
} as const;

export const $SuperUserQuestionnaireRequest = {
    type: 'object',
    description: 'Questionnaire representation for superusers.',
    properties: {
        title: {
            type: 'string',
            minLength: 1,
            maxLength: 64
        },
        description: {
            type: 'string'
        },
        category: {
            oneOf: [
                {
                    '$ref': '#/components/schemas/CategoryEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        law_field: {
            title: 'Rechtsgebiet',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawFieldEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        law_topic: {
            title: 'Rechtsthema',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawTopicEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        schema: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/QuestionnaireSectionRequest'
            }
        },
        org_uuid: {
            type: 'string',
            format: 'uuid',
            writeOnly: true,
            nullable: true
        },
        is_jupus_template: {
            type: 'boolean',
            description: 'True if this questionnaire is a Jupus template that can be copied by organizations'
        }
    },
    required: ['schema', 'title']
} as const;

export const $SuperUserQuestionnaireSubmission = {
    type: 'object',
    description: 'Questionnaire submission representation for superusers.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        case_uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        short_id: {
            type: 'string',
            readOnly: true
        },
        title: {
            type: 'string',
            readOnly: true
        },
        law_field: {
            allOf: [
                {
                    '$ref': '#/components/schemas/LawFieldEnum'
                }
            ],
            readOnly: true,
            title: 'Rechtsgebiet'
        },
        law_topic: {
            allOf: [
                {
                    '$ref': '#/components/schemas/LawTopicEnum'
                }
            ],
            readOnly: true,
            title: 'Rechtsthema'
        },
        pdf_url: {
            type: 'string',
            readOnly: true
        },
        question_count: {
            type: 'integer',
            readOnly: true
        },
        required_question_count: {
            type: 'integer',
            readOnly: true
        },
        optional_question_count: {
            type: 'integer',
            readOnly: true
        },
        answered_question_count: {
            type: 'integer',
            readOnly: true
        },
        answered_required_questions_percent: {
            type: 'number',
            format: 'double',
            readOnly: true
        },
        answered_optional_questions_count: {
            type: 'integer',
            readOnly: true
        },
        answered_questions_percent: {
            type: 'number',
            format: 'double',
            readOnly: true
        },
        answered_optional_questions_percent: {
            type: 'number',
            format: 'double',
            readOnly: true
        },
        is_third_party_questionnaire: {
            type: 'boolean',
            readOnly: true
        },
        due_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        state: {
            type: 'string',
            readOnly: true
        },
        schema: {},
        closed: {
            type: 'boolean'
        }
    },
    required: ['answered_optional_questions_count', 'answered_optional_questions_percent', 'answered_question_count', 'answered_questions_percent', 'answered_required_questions_percent', 'case_uuid', 'created_at', 'due_at', 'is_third_party_questionnaire', 'law_field', 'law_topic', 'optional_question_count', 'pdf_url', 'question_count', 'required_question_count', 'short_id', 'state', 'title', 'uuid']
} as const;

export const $SuperUserQuestionnaireSubmissionRequest = {
    type: 'object',
    description: 'Questionnaire submission representation for superusers.',
    properties: {
        schema: {},
        closed: {
            type: 'boolean'
        }
    }
} as const;

export const $SuperUserRequest = {
    type: 'object',
    properties: {
        id: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        token: {
            type: 'string',
            maxLength: 255
        },
        form: {
            type: 'string',
            format: 'uuid'
        },
        response_present: {
            type: 'object',
            additionalProperties: {},
            readOnly: true
        },
        document_uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        is_third_party: {
            type: 'boolean'
        }
    },
    required: ['document_uuid', 'form', 'id', 'response_present', 'token']
} as const;

export const $SuperUserRequestRequest = {
    type: 'object',
    properties: {
        token: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        },
        form: {
            type: 'string',
            format: 'uuid'
        },
        is_third_party: {
            type: 'boolean'
        }
    },
    required: ['form', 'token']
} as const;

export const $SuperUserRetellAgent = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        retell_agent_id: {
            type: 'string',
            readOnly: true
        },
        agent_name: {
            type: 'string',
            readOnly: true,
            nullable: true
        },
        voice_id: {
            type: 'string',
            readOnly: true
        },
        llm_websocket_url: {
            type: 'string',
            readOnly: true
        },
        opt_out_sensitive_data_storage: {
            type: 'boolean',
            readOnly: true
        }
    },
    required: ['agent_name', 'llm_websocket_url', 'opt_out_sensitive_data_storage', 'retell_agent_id', 'uuid', 'voice_id']
} as const;

export const $SuperUserService = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        active: {
            type: 'boolean',
            title: 'Diese Leistung ist buchbar'
        },
        name: {
            type: 'string',
            title: 'Titel',
            maxLength: 32
        },
        description: {
            type: 'string',
            title: 'Beschreibung',
            maxLength: 400
        },
        duration_mins: {
            type: 'integer'
        },
        buffer_mins: {
            type: 'integer'
        },
        price: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,6}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Preis'
        },
        currency: {
            type: 'string',
            title: 'Währung',
            maxLength: 8
        },
        unit: {
            type: 'string',
            title: 'Einheit',
            maxLength: 32
        },
        show_price: {
            type: 'boolean',
            title: 'Preis anzeigen',
            description: 'Wenn aktiviert, wird der Preis der Leistung während der Buchung des Termins angezeigt.'
        },
        slug: {
            type: 'string',
            maxLength: 64,
            pattern: '^[-a-zA-Z0-9_]+$'
        },
        online_appointment_enabled: {
            type: 'boolean',
            title: 'Online-Termin'
        },
        telephone_appointment_enabled: {
            type: 'boolean',
            title: 'Telefon-Termin'
        },
        in_person_appointment_enabled: {
            type: 'boolean',
            title: 'Termin vor Ort'
        },
        calendars: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/Calendar'
            },
            readOnly: true
        },
        location_types: {
            type: 'string',
            readOnly: true
        },
        availability_query: {
            type: 'object',
            additionalProperties: {},
            readOnly: true
        }
    },
    required: ['availability_query', 'buffer_mins', 'calendars', 'description', 'duration_mins', 'location_types', 'name']
} as const;

export const $SuperUserServiceRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        active: {
            type: 'boolean',
            title: 'Diese Leistung ist buchbar'
        },
        name: {
            type: 'string',
            minLength: 1,
            title: 'Titel',
            maxLength: 32
        },
        description: {
            type: 'string',
            minLength: 1,
            title: 'Beschreibung',
            maxLength: 400
        },
        duration_mins: {
            type: 'integer'
        },
        buffer_mins: {
            type: 'integer'
        },
        price: {
            type: 'string',
            format: 'decimal',
            pattern: '^-?\\d{0,6}(?:\\.\\d{0,2})?$',
            nullable: true,
            title: 'Preis'
        },
        currency: {
            type: 'string',
            minLength: 1,
            title: 'Währung',
            maxLength: 8
        },
        unit: {
            type: 'string',
            minLength: 1,
            title: 'Einheit',
            maxLength: 32
        },
        show_price: {
            type: 'boolean',
            title: 'Preis anzeigen',
            description: 'Wenn aktiviert, wird der Preis der Leistung während der Buchung des Termins angezeigt.'
        },
        slug: {
            type: 'string',
            minLength: 1,
            maxLength: 64,
            pattern: '^[-a-zA-Z0-9_]+$'
        },
        online_appointment_enabled: {
            type: 'boolean',
            title: 'Online-Termin'
        },
        telephone_appointment_enabled: {
            type: 'boolean',
            title: 'Telefon-Termin'
        },
        in_person_appointment_enabled: {
            type: 'boolean',
            title: 'Termin vor Ort'
        }
    },
    required: ['buffer_mins', 'description', 'duration_mins', 'name']
} as const;

export const $SuperUserStripeCustomer = {
    type: 'object',
    description: 'StripeCustomer representation for superusers.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        stripe_id: {
            type: 'string',
            readOnly: true
        },
        stripe_url: {
            type: 'string',
            readOnly: true
        },
        created: {
            type: 'string',
            format: 'date-time',
            readOnly: true,
            nullable: true
        },
        name: {
            type: 'string',
            readOnly: true,
            nullable: true
        },
        email: {
            type: 'string',
            format: 'email',
            readOnly: true,
            nullable: true
        },
        description: {
            type: 'string',
            readOnly: true,
            nullable: true
        }
    },
    required: ['created', 'description', 'email', 'name', 'stripe_id', 'stripe_url', 'uuid']
} as const;

export const $SuperUserStripeInvoice = {
    type: 'object',
    description: 'StripeInvoice representation for superusers.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid',
            readOnly: true
        },
        stripe_id: {
            type: 'string',
            readOnly: true
        },
        created: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        customer: {
            allOf: [
                {
                    '$ref': '#/components/schemas/SuperUserStripeCustomer'
                }
            ],
            readOnly: true
        },
        amount_due: {
            type: 'integer',
            readOnly: true
        },
        currency: {
            type: 'string',
            readOnly: true
        },
        description: {
            type: 'string',
            readOnly: true,
            nullable: true
        },
        invoice_pdf: {
            type: 'string',
            format: 'uri',
            readOnly: true,
            nullable: true
        }
    },
    required: ['amount_due', 'created', 'currency', 'customer', 'description', 'invoice_pdf', 'stripe_id', 'uuid']
} as const;

export const $SuperUserUser = {
    type: 'object',
    description: 'User representation for superusers.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        email: {
            type: 'string',
            format: 'email',
            maxLength: 254
        },
        first_name: {
            type: 'string',
            title: 'Vorname',
            maxLength: 150
        },
        last_name: {
            type: 'string',
            title: 'Nachname',
            maxLength: 150
        },
        avatar: {
            type: 'string',
            format: 'uri',
            nullable: true
        },
        org: {
            allOf: [
                {
                    '$ref': '#/components/schemas/SuperUserOrganisation'
                }
            ],
            readOnly: true
        },
        uid: {
            type: 'integer',
            readOnly: true
        },
        role: {
            nullable: true,
            oneOf: [
                {
                    '$ref': '#/components/schemas/Role5ccEnum'
                },
                {
                    '$ref': '#/components/schemas/NullEnum'
                }
            ]
        },
        is_active: {
            type: 'boolean',
            title: 'Aktiv',
            description: 'Legt fest, ob dieser Benutzer aktiv ist. Kann deaktiviert werden, anstatt Benutzer zu löschen.'
        },
        is_staff: {
            type: 'boolean',
            title: 'Mitarbeiter-Status',
            description: 'Legt fest, ob sich der Benutzer an der Administrationsseite anmelden kann.'
        },
        is_superuser: {
            type: 'boolean',
            title: 'Administrator-Status',
            description: 'Legt fest, dass der Benutzer alle Berechtigungen hat, ohne diese einzeln zuweisen zu müssen.'
        },
        is_payments_superuser: {
            type: 'boolean'
        },
        email_signature: {
            type: 'string',
            title: 'E-Mail Signatur'
        },
        notifications_receive_monthly_summary: {
            type: 'boolean'
        },
        case_dashboard_widgets: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/CaseDashboardWidgetsEnum'
            }
        },
        global_ai_chat_intro_seen: {
            type: 'boolean',
            description: 'Whether the user has seen and accepted the global AI chat intro page'
        },
        global_ai_chat_badge_dismissed: {
            type: 'boolean',
            description: 'Whether the user has clicked on Global AI Chat navigation item (badge should be hidden)'
        },
        is_impersonated_session: {
            type: 'boolean',
            description: `Check if the current session is an impersonated session.

:param obj: The user object being serialized
:return: True if this is an impersonated session, False otherwise`,
            readOnly: true
        }
    },
    required: ['case_dashboard_widgets', 'email', 'is_impersonated_session', 'org', 'uid']
} as const;

export const $SuperUserUserRequest = {
    type: 'object',
    description: 'User representation for superusers.',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        email: {
            type: 'string',
            format: 'email',
            minLength: 1,
            maxLength: 254
        },
        first_name: {
            type: 'string',
            title: 'Vorname',
            maxLength: 150
        },
        last_name: {
            type: 'string',
            title: 'Nachname',
            maxLength: 150
        },
        avatar: {
            type: 'string',
            format: 'binary',
            nullable: true
        },
        role: {
            nullable: true,
            oneOf: [
                {
                    '$ref': '#/components/schemas/Role5ccEnum'
                },
                {
                    '$ref': '#/components/schemas/NullEnum'
                }
            ]
        },
        is_active: {
            type: 'boolean',
            title: 'Aktiv',
            description: 'Legt fest, ob dieser Benutzer aktiv ist. Kann deaktiviert werden, anstatt Benutzer zu löschen.'
        },
        is_staff: {
            type: 'boolean',
            title: 'Mitarbeiter-Status',
            description: 'Legt fest, ob sich der Benutzer an der Administrationsseite anmelden kann.'
        },
        is_superuser: {
            type: 'boolean',
            title: 'Administrator-Status',
            description: 'Legt fest, dass der Benutzer alle Berechtigungen hat, ohne diese einzeln zuweisen zu müssen.'
        },
        is_payments_superuser: {
            type: 'boolean'
        },
        email_signature: {
            type: 'string',
            title: 'E-Mail Signatur'
        },
        notifications_receive_monthly_summary: {
            type: 'boolean'
        },
        case_dashboard_widgets: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/CaseDashboardWidgetsEnum'
            }
        },
        global_ai_chat_intro_seen: {
            type: 'boolean',
            description: 'Whether the user has seen and accepted the global AI chat intro page'
        },
        global_ai_chat_badge_dismissed: {
            type: 'boolean',
            description: 'Whether the user has clicked on Global AI Chat navigation item (badge should be hidden)'
        }
    },
    required: ['case_dashboard_widgets', 'email']
} as const;

export const $SuperUserWordDocumentTemplate = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        name: {
            type: 'string',
            maxLength: 255
        },
        description: {
            type: 'string'
        },
        system_prompt: {
            type: 'string'
        },
        original_docx_template: {
            type: 'string',
            format: 'uri',
            readOnly: true,
            nullable: true
        },
        docx_template: {
            type: 'string',
            format: 'uri',
            nullable: true,
            description: 'Active template used for document generation (can be original, AI-generated, or custom upload)'
        },
        ai_docx_template: {
            type: 'string',
            format: 'uri',
            nullable: true,
            description: 'AI-generated template with placeholders created from docx_template'
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        updated_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        law_field: {
            title: 'Rechtsgebiet',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawFieldEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        law_topic: {
            title: 'Rechtsthema',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawTopicEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        document: {
            allOf: [
                {
                    '$ref': '#/components/schemas/Document'
                }
            ],
            readOnly: true
        },
        is_jupus_template: {
            type: 'boolean'
        },
        replaceable_variables: {
            nullable: true
        },
        status: {
            allOf: [
                {
                    '$ref': '#/components/schemas/WordTemplateStatus'
                }
            ],
            description: `Current status of the template in the review workflow

* \`draft\` - Draft
* \`in_review\` - In Review
* \`approved\` - Approved`
        },
        org: {
            allOf: [
                {
                    '$ref': '#/components/schemas/ClientOrganisation'
                }
            ],
            readOnly: true
        },
        ai_extraction_metadata: {
            description: 'Stores AI extraction confidence scores and metadata'
        }
    },
    required: ['created_at', 'description', 'document', 'is_jupus_template', 'name', 'org', 'original_docx_template', 'system_prompt', 'updated_at']
} as const;

export const $SuperUserWordDocumentTemplateRequest = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        },
        name: {
            type: 'string',
            minLength: 1,
            maxLength: 255
        },
        description: {
            type: 'string',
            minLength: 1
        },
        system_prompt: {
            type: 'string',
            minLength: 1
        },
        docx_template: {
            type: 'string',
            format: 'binary',
            nullable: true,
            description: 'Active template used for document generation (can be original, AI-generated, or custom upload)'
        },
        ai_docx_template: {
            type: 'string',
            format: 'binary',
            nullable: true,
            description: 'AI-generated template with placeholders created from docx_template'
        },
        law_field: {
            title: 'Rechtsgebiet',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawFieldEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        law_topic: {
            title: 'Rechtsthema',
            oneOf: [
                {
                    '$ref': '#/components/schemas/LawTopicEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        is_jupus_template: {
            type: 'boolean'
        },
        replaceable_variables: {
            nullable: true
        },
        status: {
            allOf: [
                {
                    '$ref': '#/components/schemas/WordTemplateStatus'
                }
            ],
            description: `Current status of the template in the review workflow

* \`draft\` - Draft
* \`in_review\` - In Review
* \`approved\` - Approved`
        },
        ai_extraction_metadata: {
            description: 'Stores AI extraction confidence scores and metadata'
        }
    },
    required: ['description', 'is_jupus_template', 'name', 'system_prompt']
} as const;

export const $SwitchUniqueCaseDataRelationshipRequestRequest = {
    type: 'object',
    properties: {
        new_entity_relationship_which_should_hold_the_designated_relationship_uuid: {
            type: 'string',
            format: 'uuid'
        },
        case_data_uuid: {
            type: 'string',
            format: 'uuid'
        },
        relationship_type: {
            '$ref': '#/components/schemas/RelationshipTypeEnum'
        }
    },
    required: ['case_data_uuid', 'new_entity_relationship_which_should_hold_the_designated_relationship_uuid', 'relationship_type']
} as const;

export const $SwitchUniqueCaseDataRelationshipResponse = {
    type: 'object',
    properties: {
        new_entity_relationship_which_should_hold_the_designated_relationship: {
            '$ref': '#/components/schemas/CustomerEntityWithRelationship'
        },
        entity_relationship_currently_holding_the_designated_relationship: {
            '$ref': '#/components/schemas/CustomerEntityWithRelationship'
        }
    },
    required: ['entity_relationship_currently_holding_the_designated_relationship', 'new_entity_relationship_which_should_hold_the_designated_relationship']
} as const;

export const $TAIChatSession = {
    oneOf: [
        {
            '$ref': '#/components/schemas/AIChatSession'
        }
    ]
} as const;

export const $TAIChatSessionRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/AIChatSessionRequest'
        }
    ]
} as const;

export const $TAccount = {
    oneOf: [
        {
            '$ref': '#/components/schemas/CustomerAccount'
        },
        {
            '$ref': '#/components/schemas/CustomerAdminAccount'
        },
        {
            '$ref': '#/components/schemas/SuperUserAccount'
        }
    ]
} as const;

export const $TAccountRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/CustomerAccountRequest'
        },
        {
            '$ref': '#/components/schemas/CustomerAdminAccountRequest'
        },
        {
            '$ref': '#/components/schemas/SuperUserAccountRequest'
        }
    ]
} as const;

export const $TActionAutoCommitSettings = {
    oneOf: [
        {
            '$ref': '#/components/schemas/CustomerActionAutoCommitSettings'
        },
        {
            '$ref': '#/components/schemas/CustomerAdminActionAutoCommitSettings'
        },
        {
            '$ref': '#/components/schemas/SuperUserActionAutoCommitSettings'
        }
    ]
} as const;

export const $TActionAutoCommitSettingsRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/CustomerActionAutoCommitSettingsRequest'
        },
        {
            '$ref': '#/components/schemas/CustomerAdminActionAutoCommitSettingsRequest'
        },
        {
            '$ref': '#/components/schemas/SuperUserActionAutoCommitSettingsRequest'
        }
    ]
} as const;

export const $TActiveAnnouncement = {
    oneOf: [
        {
            '$ref': '#/components/schemas/Announcement'
        },
        {
            '$ref': '#/components/schemas/SuperUserAnnouncement'
        }
    ]
} as const;

export const $TActivity = {
    oneOf: [
        {
            '$ref': '#/components/schemas/CustomerActivity'
        },
        {
            '$ref': '#/components/schemas/CustomerAdminActivity'
        },
        {
            '$ref': '#/components/schemas/SuperUserActivity'
        }
    ]
} as const;

export const $TActivityRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/CustomerActivityRequest'
        },
        {
            '$ref': '#/components/schemas/CustomerAdminActivityRequest'
        },
        {
            '$ref': '#/components/schemas/SuperUserActivityRequest'
        }
    ]
} as const;

export const $TAgentAction = {
    oneOf: [
        {
            '$ref': '#/components/schemas/CustomerAgentAction'
        },
        {
            '$ref': '#/components/schemas/CustomerAdminAgentAction'
        },
        {
            '$ref': '#/components/schemas/SuperUserAgentAction'
        }
    ]
} as const;

export const $TAgentActionRequest = {
    oneOf: []
} as const;

export const $TAiAnalysis = {
    oneOf: [
        {
            '$ref': '#/components/schemas/ClientAiAnalysis'
        },
        {
            '$ref': '#/components/schemas/CustomerAiAnalysis'
        },
        {
            '$ref': '#/components/schemas/CustomerAdminAiAnalysis'
        },
        {
            '$ref': '#/components/schemas/SuperUserAiAnalysis'
        }
    ]
} as const;

export const $TAiAnalysisRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/ClientAiAnalysisRequest'
        },
        {
            '$ref': '#/components/schemas/CustomerAiAnalysisRequest'
        },
        {
            '$ref': '#/components/schemas/CustomerAdminAiAnalysisRequest'
        },
        {
            '$ref': '#/components/schemas/SuperUserAiAnalysisRequest'
        }
    ]
} as const;

export const $TAiAugmentation = {
    oneOf: [
        {
            '$ref': '#/components/schemas/ClientAiAugmentation'
        },
        {
            '$ref': '#/components/schemas/CustomerAiAugmentation'
        },
        {
            '$ref': '#/components/schemas/CustomerAdminAiAugmentation'
        },
        {
            '$ref': '#/components/schemas/SuperUserAiAugmentation'
        }
    ]
} as const;

export const $TAiAugmentationRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/ClientAiAugmentationRequest'
        },
        {
            '$ref': '#/components/schemas/CustomerAiAugmentationRequest'
        },
        {
            '$ref': '#/components/schemas/CustomerAdminAiAugmentationRequest'
        },
        {
            '$ref': '#/components/schemas/SuperUserAiAugmentationRequest'
        }
    ]
} as const;

export const $TAiChatQuestionTemplate = {
    oneOf: [
        {
            '$ref': '#/components/schemas/AiChatQuestionTemplate'
        }
    ]
} as const;

export const $TAiChatQuestionTemplateRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/AiChatQuestionTemplateRequest'
        }
    ]
} as const;

export const $TAiSettings = {
    oneOf: [
        {
            '$ref': '#/components/schemas/CustomerAiSettings'
        },
        {
            '$ref': '#/components/schemas/CustomerAdminAiSettings'
        },
        {
            '$ref': '#/components/schemas/SuperUserAiSettings'
        }
    ]
} as const;

export const $TAiSettingsRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/CustomerAiSettingsRequest'
        },
        {
            '$ref': '#/components/schemas/CustomerAdminAiSettingsRequest'
        },
        {
            '$ref': '#/components/schemas/SuperUserAiSettingsRequest'
        }
    ]
} as const;

export const $TAnnouncement = {
    oneOf: [
        {
            '$ref': '#/components/schemas/Announcement'
        },
        {
            '$ref': '#/components/schemas/SuperUserAnnouncement'
        }
    ]
} as const;

export const $TAnnouncementRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/SuperUserAnnouncementRequest'
        }
    ]
} as const;

export const $TAppointment = {
    oneOf: [
        {
            '$ref': '#/components/schemas/CustomerAppointment'
        },
        {
            '$ref': '#/components/schemas/CustomerAdminAccount'
        },
        {
            '$ref': '#/components/schemas/SuperUserAccount'
        }
    ]
} as const;

export const $TAppointmentProposal = {
    oneOf: [
        {
            '$ref': '#/components/schemas/CustomerAppointmentProposal'
        },
        {
            '$ref': '#/components/schemas/CustomerAdminAppointmentProposal'
        },
        {
            '$ref': '#/components/schemas/SuperUserAppointmentProposal'
        }
    ]
} as const;

export const $TAppointmentProposalRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/CustomerAppointmentProposalRequest'
        },
        {
            '$ref': '#/components/schemas/CustomerAdminAppointmentProposalRequest'
        },
        {
            '$ref': '#/components/schemas/SuperUserAppointmentProposalRequest'
        }
    ]
} as const;

export const $TAppointmentRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/CustomerAppointmentRequest'
        },
        {
            '$ref': '#/components/schemas/CustomerAdminAccountRequest'
        },
        {
            '$ref': '#/components/schemas/SuperUserAccountRequest'
        }
    ]
} as const;

export const $TAssignWorkflowResponse = {
    oneOf: [
        {
            '$ref': '#/components/schemas/CustomerAssignWorkflowResponse'
        },
        {
            '$ref': '#/components/schemas/CustomerAdminAssignWorkflowResponse'
        },
        {
            '$ref': '#/components/schemas/SuperUserAssignWorkflowResponse'
        }
    ]
} as const;

export const $TCalendar = {
    oneOf: [
        {
            '$ref': '#/components/schemas/CustomerCalendar'
        },
        {
            '$ref': '#/components/schemas/CustomerAdminCalendar'
        },
        {
            '$ref': '#/components/schemas/SuperUserCalendar'
        }
    ]
} as const;

export const $TCalendarRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/CustomerCalendarRequest'
        },
        {
            '$ref': '#/components/schemas/CustomerAdminCalendarRequest'
        },
        {
            '$ref': '#/components/schemas/SuperUserCalendarRequest'
        }
    ]
} as const;

export const $TCall = {
    oneOf: [
        {
            '$ref': '#/components/schemas/CustomerCall'
        },
        {
            '$ref': '#/components/schemas/SuperUserCall'
        }
    ]
} as const;

export const $TCallRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/CustomerCallRequest'
        },
        {
            '$ref': '#/components/schemas/SuperUserCallRequest'
        }
    ]
} as const;

export const $TCase = {
    oneOf: [
        {
            '$ref': '#/components/schemas/ClientCase'
        },
        {
            '$ref': '#/components/schemas/CustomerCase'
        },
        {
            '$ref': '#/components/schemas/CustomerAdminCase'
        },
        {
            '$ref': '#/components/schemas/SuperUserCase'
        }
    ]
} as const;

export const $TCaseCreatorTempDocument = {
    oneOf: [
        {
            '$ref': '#/components/schemas/CaseCreatorTempDocument'
        }
    ]
} as const;

export const $TCaseCreatorTempDocumentRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/CaseCreatorTempDocumentRequest'
        }
    ]
} as const;

export const $TCaseLifecycleState = {
    oneOf: [
        {
            '$ref': '#/components/schemas/CustomerCaseLifecycleState'
        },
        {
            '$ref': '#/components/schemas/CustomerAdminCaseLifecycleState'
        },
        {
            '$ref': '#/components/schemas/SuperUserCaseLifecycleState'
        }
    ]
} as const;

export const $TCaseLifecycleStateReasoning = {
    oneOf: [
        {
            '$ref': '#/components/schemas/CaseLifecycleStateReasoning'
        }
    ]
} as const;

export const $TCaseLifecycleStateRequestRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/CustomerCaseLifecycleStateRequest'
        },
        {
            '$ref': '#/components/schemas/CustomerAdminCaseLifecycleStateRequest'
        },
        {
            '$ref': '#/components/schemas/SuperUserCaseLifecycleStateRequest'
        }
    ]
} as const;

export const $TCaseLifecycleWorkflow = {
    oneOf: [
        {
            '$ref': '#/components/schemas/CustomerCaseLifecycleWorkflow'
        },
        {
            '$ref': '#/components/schemas/CustomerAdminCaseLifecycleWorkflow'
        },
        {
            '$ref': '#/components/schemas/SuperUserCaseLifecycleWorkflow'
        }
    ]
} as const;

export const $TCaseLifecycleWorkflowRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/CustomerCaseLifecycleWorkflowRequest'
        },
        {
            '$ref': '#/components/schemas/CustomerAdminCaseLifecycleWorkflowRequest'
        },
        {
            '$ref': '#/components/schemas/SuperUserCaseLifecycleWorkflowRequest'
        }
    ]
} as const;

export const $TCaseRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/CustomerCaseRequest'
        },
        {
            '$ref': '#/components/schemas/CustomerAdminCaseRequest'
        },
        {
            '$ref': '#/components/schemas/SuperUserCaseRequest'
        }
    ]
} as const;

export const $TChatPreference = {
    oneOf: [
        {
            '$ref': '#/components/schemas/ChatPreference'
        }
    ]
} as const;

export const $TChatPreferenceRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/ChatPreferenceRequest'
        }
    ]
} as const;

export const $TDeliveryEvent = {
    oneOf: [
        {
            '$ref': '#/components/schemas/CustomerDeliveryEvent'
        },
        {
            '$ref': '#/components/schemas/CustomerAdminDeliveryEvent'
        },
        {
            '$ref': '#/components/schemas/SuperUserDeliveryEvent'
        }
    ]
} as const;

export const $TDocument = {
    oneOf: [
        {
            '$ref': '#/components/schemas/Document'
        }
    ]
} as const;

export const $TDocumentRequest = {
    oneOf: []
} as const;

export const $TDocumentTemplate = {
    oneOf: [
        {
            '$ref': '#/components/schemas/CustomerDocumentTemplate'
        },
        {
            '$ref': '#/components/schemas/CustomerAdminDocumentTemplate'
        },
        {
            '$ref': '#/components/schemas/SuperUserDocumentTemplate'
        }
    ]
} as const;

export const $TDocumentTemplateRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/CustomerDocumentTemplateRequest'
        },
        {
            '$ref': '#/components/schemas/CustomerAdminDocumentTemplateRequest'
        },
        {
            '$ref': '#/components/schemas/SuperUserDocumentTemplateRequest'
        }
    ]
} as const;

export const $TEmail = {
    oneOf: [
        {
            '$ref': '#/components/schemas/CustomerEmail'
        },
        {
            '$ref': '#/components/schemas/CustomerAdminEmail'
        },
        {
            '$ref': '#/components/schemas/SuperUserEmail'
        }
    ]
} as const;

export const $TEmailTemplate = {
    oneOf: [
        {
            '$ref': '#/components/schemas/CustomerEmailTemplate'
        },
        {
            '$ref': '#/components/schemas/CustomerAdminEmailTemplate'
        },
        {
            '$ref': '#/components/schemas/SuperUserEmailTemplate'
        }
    ]
} as const;

export const $TEmailTemplateRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/CustomerEmailTemplateRequest'
        },
        {
            '$ref': '#/components/schemas/CustomerAdminEmailTemplateRequest'
        },
        {
            '$ref': '#/components/schemas/SuperUserEmailTemplateRequest'
        }
    ]
} as const;

export const $TEntity = {
    oneOf: [
        {
            '$ref': '#/components/schemas/ClientEntity'
        },
        {
            '$ref': '#/components/schemas/CustomerEntity'
        },
        {
            '$ref': '#/components/schemas/CustomerAdminEntity'
        },
        {
            '$ref': '#/components/schemas/SuperUserEntity'
        }
    ]
} as const;

export const $TEntityRemoveCaseDataRelationshipResponse = {
    oneOf: [
        {
            '$ref': '#/components/schemas/EntityRemoveCaseDataRelationshipCustomerResponse'
        },
        {
            '$ref': '#/components/schemas/EntityRemoveCaseDataRelationshipSuperUserResponse'
        }
    ]
} as const;

export const $TEntityRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/ClientEntityRequest'
        },
        {
            '$ref': '#/components/schemas/CustomerEntityRequest'
        },
        {
            '$ref': '#/components/schemas/CustomerAdminEntityRequest'
        },
        {
            '$ref': '#/components/schemas/SuperUserEntityRequest'
        }
    ]
} as const;

export const $TEntityWithRelationship = {
    oneOf: [
        {
            '$ref': '#/components/schemas/CustomerEntityWithRelationship'
        },
        {
            '$ref': '#/components/schemas/CustomerAdminEntityWithRelationship'
        },
        {
            '$ref': '#/components/schemas/SuperUserEntityWithRelationship'
        }
    ]
} as const;

export const $TFeedback = {
    oneOf: [
        {
            '$ref': '#/components/schemas/Feedback'
        },
        {
            '$ref': '#/components/schemas/SuperUserFeedback'
        }
    ]
} as const;

export const $TFeedbackRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/FeedbackRequest'
        },
        {
            '$ref': '#/components/schemas/SuperUserFeedbackRequest'
        }
    ]
} as const;

export const $TForm = {
    oneOf: [
        {
            '$ref': '#/components/schemas/ClientForm'
        },
        {
            '$ref': '#/components/schemas/CustomerForm'
        },
        {
            '$ref': '#/components/schemas/CustomerAdminForm'
        },
        {
            '$ref': '#/components/schemas/SuperUserForm'
        }
    ]
} as const;

export const $TFormRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/CustomerFormRequest'
        },
        {
            '$ref': '#/components/schemas/CustomerAdminFormRequest'
        },
        {
            '$ref': '#/components/schemas/SuperUserFormRequest'
        }
    ]
} as const;

export const $TGenericDataMapper = {
    oneOf: [
        {
            '$ref': '#/components/schemas/GenericDataMapper'
        },
        {
            '$ref': '#/components/schemas/GenericDataMapper'
        },
        {
            '$ref': '#/components/schemas/GenericDataMapper'
        },
        {
            '$ref': '#/components/schemas/GenericDataMapper'
        }
    ]
} as const;

export const $TInboundEmail = {
    oneOf: [
        {
            '$ref': '#/components/schemas/SuperUserInboundEmail'
        }
    ]
} as const;

export const $TLawyerFeedback = {
    oneOf: [
        {
            '$ref': '#/components/schemas/LawyerFeedback'
        },
        {
            '$ref': '#/components/schemas/CustomerLawyerFeedback'
        },
        {
            '$ref': '#/components/schemas/SuperUserLawyerFeedback'
        }
    ]
} as const;

export const $TLawyerFeedbackRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/CustomerLawyerFeedbackRequest'
        },
        {
            '$ref': '#/components/schemas/SuperUserLawyerFeedbackRequest'
        }
    ]
} as const;

export const $TOrganisation = {
    oneOf: [
        {
            '$ref': '#/components/schemas/ClientOrganisation'
        },
        {
            '$ref': '#/components/schemas/CustomerOrganisation'
        },
        {
            '$ref': '#/components/schemas/CustomerAdminOrganisation'
        },
        {
            '$ref': '#/components/schemas/SuperUserOrganisation'
        }
    ]
} as const;

export const $TOrganisationRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/CustomerOrganisationRequest'
        },
        {
            '$ref': '#/components/schemas/CustomerAdminOrganisationRequest'
        },
        {
            '$ref': '#/components/schemas/SuperUserOrganisationRequest'
        }
    ]
} as const;

export const $TPDFFormSubmission = {
    oneOf: [
        {
            '$ref': '#/components/schemas/PDFFormSubmissionBase'
        },
        {
            '$ref': '#/components/schemas/SuperUserPDFFormSubmission'
        }
    ]
} as const;

export const $TPDFFormSubmissionRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/PDFFormSubmissionBaseRequest'
        },
        {
            '$ref': '#/components/schemas/SuperUserPDFFormSubmissionRequest'
        }
    ]
} as const;

export const $TPDFFormSubmissionWithCase = {
    oneOf: [
        {
            '$ref': '#/components/schemas/PDFFormSubmissionBase'
        }
    ]
} as const;

export const $TPDFFormTemplate = {
    oneOf: [
        {
            '$ref': '#/components/schemas/PDFFormTemplate'
        },
        {
            '$ref': '#/components/schemas/SuperUserPDFFormTemplate'
        }
    ]
} as const;

export const $TPDFFormTemplateRequestRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/CreatePDFFormTemplateRequest'
        },
        {
            '$ref': '#/components/schemas/SuperUserCreatePDFFormTemplateRequest'
        }
    ]
} as const;

export const $TPhoneForwardingRule = {
    oneOf: [
        {
            '$ref': '#/components/schemas/PhoneForwardingRuleList'
        },
        {
            '$ref': '#/components/schemas/PhoneForwardingRule'
        }
    ]
} as const;

export const $TPhoneNumber = {
    oneOf: [
        {
            '$ref': '#/components/schemas/CustomerPhoneNumber'
        },
        {
            '$ref': '#/components/schemas/CustomerAdminPhoneNumber'
        },
        {
            '$ref': '#/components/schemas/SuperUserPhoneNumber'
        }
    ]
} as const;

export const $TPhoneNumberRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/CustomerAdminPhoneNumberRequest'
        },
        {
            '$ref': '#/components/schemas/SuperUserPhoneNumberRequest'
        }
    ]
} as const;

export const $TQuestionnaire = {
    oneOf: [
        {
            '$ref': '#/components/schemas/CustomerQuestionnaire'
        },
        {
            '$ref': '#/components/schemas/CustomerAdminQuestionnaire'
        },
        {
            '$ref': '#/components/schemas/SuperUserQuestionnaire'
        }
    ]
} as const;

export const $TQuestionnaireRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/CustomerQuestionnaireRequest'
        },
        {
            '$ref': '#/components/schemas/CustomerAdminQuestionnaireRequest'
        },
        {
            '$ref': '#/components/schemas/SuperUserQuestionnaireRequest'
        }
    ]
} as const;

export const $TQuestionnaireSubmission = {
    oneOf: [
        {
            '$ref': '#/components/schemas/ClientQuestionnaireSubmission'
        },
        {
            '$ref': '#/components/schemas/CustomerQuestionnaireSubmission'
        },
        {
            '$ref': '#/components/schemas/CustomerAdminQuestionnaireSubmission'
        },
        {
            '$ref': '#/components/schemas/SuperUserQuestionnaireSubmission'
        }
    ]
} as const;

export const $TQuestionnaireSubmissionRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/ClientQuestionnaireSubmissionRequest'
        },
        {
            '$ref': '#/components/schemas/CustomerQuestionnaireSubmissionRequest'
        },
        {
            '$ref': '#/components/schemas/CustomerAdminQuestionnaireSubmissionRequest'
        },
        {
            '$ref': '#/components/schemas/SuperUserQuestionnaireSubmissionRequest'
        }
    ]
} as const;

export const $TRetellAgent = {
    oneOf: [
        {
            '$ref': '#/components/schemas/SuperUserRetellAgent'
        }
    ]
} as const;

export const $TRetellAgentRequest = {
    oneOf: []
} as const;

export const $TSavedResponse = {
    oneOf: [
        {
            '$ref': '#/components/schemas/SavedResponse'
        }
    ]
} as const;

export const $TSavedResponseRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/SavedResponseRequest'
        }
    ]
} as const;

export const $TService = {
    oneOf: [
        {
            '$ref': '#/components/schemas/CustomerService'
        },
        {
            '$ref': '#/components/schemas/CustomerAdminService'
        },
        {
            '$ref': '#/components/schemas/SuperUserService'
        }
    ]
} as const;

export const $TServiceRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/CustomerServiceRequest'
        },
        {
            '$ref': '#/components/schemas/CustomerAdminServiceRequest'
        },
        {
            '$ref': '#/components/schemas/SuperUserServiceRequest'
        }
    ]
} as const;

export const $TStripeCustomer = {
    oneOf: [
        {
            '$ref': '#/components/schemas/SuperUserStripeCustomer'
        }
    ]
} as const;

export const $TStripeCustomerRequest = {
    oneOf: []
} as const;

export const $TStripeInvoice = {
    oneOf: [
        {
            '$ref': '#/components/schemas/SuperUserStripeInvoice'
        }
    ]
} as const;

export const $TStripeInvoiceRequest = {
    oneOf: []
} as const;

export const $TSwitchUniqueCaseDataRelationshipResponse = {
    oneOf: [
        {
            '$ref': '#/components/schemas/SwitchUniqueCaseDataRelationshipResponse'
        }
    ]
} as const;

export const $TUser = {
    oneOf: [
        {
            '$ref': '#/components/schemas/CustomerUser'
        },
        {
            '$ref': '#/components/schemas/CustomerAdminUser'
        },
        {
            '$ref': '#/components/schemas/SuperUserUser'
        }
    ]
} as const;

export const $TUserRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/CustomerUserRequest'
        },
        {
            '$ref': '#/components/schemas/CustomerAdminUserRequest'
        },
        {
            '$ref': '#/components/schemas/SuperUserUserRequest'
        }
    ]
} as const;

export const $TWordDocumentTemplate = {
    oneOf: [
        {
            '$ref': '#/components/schemas/CustomerWordDocumentTemplate'
        },
        {
            '$ref': '#/components/schemas/CustomerAdminWordDocumentTemplate'
        },
        {
            '$ref': '#/components/schemas/SuperUserWordDocumentTemplate'
        }
    ]
} as const;

export const $TWordDocumentTemplateRequest = {
    oneOf: [
        {
            '$ref': '#/components/schemas/CustomerWordDocumentTemplateRequest'
        },
        {
            '$ref': '#/components/schemas/CustomerAdminWordDocumentTemplateRequest'
        },
        {
            '$ref': '#/components/schemas/SuperUserWordDocumentTemplateRequest'
        }
    ]
} as const;

export const $TagRelationshipEnum = {
    enum: ['entities.opponent', 'entities.client', 'entities.other', 'entities.labor_law_employee', 'entities.labor_law_employer', 'entities.witness', 'entities.at_fault_driver', 'entities.victim_driver', 'entities.accused', 'entities.defendant', 'entities.plaintiff', 'entities.complaint', 'entities.victim', 'entities.vehicle_expert', 'entities.agency', 'entities.foreigners_authority', 'entities.vehicle_owner', 'entities.insurance', 'entities.driver', 'entities.police_officer', 'entities.police_station', 'entities.judge', 'entities.court', 'entities.prosecutor', 'entities.public_prosecutor', 'entities.opposing_counsel', 'entities.co_plaintiff', 'entities.probation_officer', 'entities.tenant', 'entities.landlord', 'entities.subtenant', 'entities.owner', 'entities.property_management', 'entities.real_estate_agent', 'entities.guarantor', 'entities.co_owner', 'entities.co_tenant', 'entities.tenants_association', 'entities.property_owners_association', 'entities.complainant', 'entities.applicant', 'entities.respondent', 'entities.principal_client', 'entities.child', 'entities.officiant', 'entities.wife', 'entities.husband', 'entities.legal_representative', 'entities.korrespondence_lawyer', 'entities.opposing_lawyer', 'entities.lawyer', 'entities.legal_expenses_insurance', 'entities.liability_insurance', 'entities.first_instance_court', 'entities.second_instance_court', 'entities.third_instance_court', 'entities.contact_person', 'entities.third_party_debtor', 'entities.road_traffic_office', 'entities.debt_collection_agency', 'entities.expert', 'entities.tax_office', 'entities.land_registry', 'entities.bank', 'entities.buyer', 'entities.dunning_court', 'entities.enforcement_court', 'entities.general_prosecutor', 'entities.seller', 'entities.expert_committee', 'entities.municipality', 'entities.administrator', 'entities.register_court', 'entities.probate_court', 'entities.registry_office', 'entities.hereditary_leaseholder', 'entities.legal_aid_court', 'entities.secondary_client', 'entities.secondary_opponent', 'entities.court_complaint', 'entities.fine_authority', 'entities.resident_registration_office', 'entities.investigator', 'entities.bailiff', 'entities.insolvency_court', 'entities.integration_office', 'entities.execution_organ', 'entities.debtor', 'entities.creditor', 'entities.lessee', 'entities.lessor', 'entities.principal', 'entities.authorized_representative', 'entities.testator', 'entities.heir', 'entities.preliminary_heir', 'entities.subsequent_heir', 'entities.curator_of_the_estate', 'entities.executor_of_the_will', 'entities.estate_administrator', 'entities.compulsory_portion_beneficiary', 'entities.notary', 'entities.trustee', 'entities.insolvency_administrator', 'entities.defendant_representative', 'entities.plaintiff_representative', 'entities.community_of_homeowners', 'entities.fractional_owner', 'entities.joint_debtor', 'entities.joint_creditor', 'entities.application_respondent', 'entities.hereditary_building_grantor', 'entities.professional_liability_insurance', 'entities.building_owners_association', 'entities.landlord_association', 'entities.landlord_community', 'entities.special_property_manager', 'entities.house_manager', 'entities.appellant', 'entities.appellee', 'entities.counter_claimant', 'entities.counter_defendant', 'entities.doctor', 'entities.legal_guardian', 'entities.guardian', 'entities.caretaker', 'entities.youth_welfare_office', 'entities.foster_parent', 'entities.parent', 'entities.maintenance_obligor', 'entities.beneficiary', 'entities.administrative_assistant', 'entities.case_worker', 'entities.managing_director', 'entities.shareholder', 'entities.supervisory_board', 'entities.commercial_agent', 'entities.limited_partner', 'entities.authorized_signatory', 'entities.social_security_office', 'entities.employment_agency', 'entities.job_center', 'entities.pension_insurance', 'entities.health_insurance', 'entities.disability_office', 'entities.social_court', 'entities.medical_service', 'entities.rehabilitation_provider', 'entities.patient', 'entities.medical_institution', 'entities.legal_assistant', 'entities.tax_authority', 'entities.affected_person'],
    type: 'string',
    description: `* \`entities.opponent\` - Opponent
* \`entities.client\` - Client
* \`entities.other\` - Other
* \`entities.labor_law_employee\` - Labor Law Employee
* \`entities.labor_law_employer\` - Labor Law Employer
* \`entities.witness\` - Witness
* \`entities.at_fault_driver\` - At Fault Driver
* \`entities.victim_driver\` - Victim Driver
* \`entities.accused\` - Accused
* \`entities.defendant\` - Defendant
* \`entities.plaintiff\` - Plaintiff
* \`entities.complaint\` - Complaint
* \`entities.victim\` - Victim
* \`entities.vehicle_expert\` - Vehicle Expert
* \`entities.agency\` - Agency
* \`entities.foreigners_authority\` - Foreigners Authority
* \`entities.vehicle_owner\` - Vehicle Owner
* \`entities.insurance\` - Insurance
* \`entities.driver\` - Driver
* \`entities.police_officer\` - Police Officer
* \`entities.police_station\` - Police Station
* \`entities.judge\` - Judge
* \`entities.court\` - Court
* \`entities.prosecutor\` - Prosecutor
* \`entities.public_prosecutor\` - Public Prosecutor
* \`entities.opposing_counsel\` - Opposing Counsel
* \`entities.co_plaintiff\` - Co Plaintiff
* \`entities.probation_officer\` - Probation Officer
* \`entities.tenant\` - Tenant
* \`entities.landlord\` - Landlord
* \`entities.subtenant\` - Subtenant
* \`entities.owner\` - Owner
* \`entities.property_management\` - Property Management
* \`entities.real_estate_agent\` - Real Estate Agent
* \`entities.guarantor\` - Guarantor
* \`entities.co_owner\` - Co Owner
* \`entities.co_tenant\` - Co Tenant
* \`entities.tenants_association\` - Tenants Association
* \`entities.property_owners_association\` - Property Owners Association
* \`entities.complainant\` - Complainant
* \`entities.applicant\` - Applicant
* \`entities.respondent\` - Respondent
* \`entities.principal_client\` - Principal Client
* \`entities.child\` - Child
* \`entities.officiant\` - Officiant
* \`entities.wife\` - Wife
* \`entities.husband\` - Husband
* \`entities.legal_representative\` - Legal Representative
* \`entities.korrespondence_lawyer\` - Korrespondence Lawyer
* \`entities.opposing_lawyer\` - Opposing Lawyer
* \`entities.lawyer\` - Lawyer
* \`entities.legal_expenses_insurance\` - Legal Expenses Insurance
* \`entities.liability_insurance\` - Liability Insurance
* \`entities.first_instance_court\` - First Instance Court
* \`entities.second_instance_court\` - Second Instance Court
* \`entities.third_instance_court\` - Third Instance Court
* \`entities.contact_person\` - Contact Person
* \`entities.third_party_debtor\` - Third Party Debtor
* \`entities.road_traffic_office\` - Road Traffic Office
* \`entities.debt_collection_agency\` - Debt Collection Agency
* \`entities.expert\` - Expert
* \`entities.tax_office\` - Tax Office
* \`entities.land_registry\` - Land Registry
* \`entities.bank\` - Bank
* \`entities.buyer\` - Buyer
* \`entities.dunning_court\` - Dunning Court
* \`entities.enforcement_court\` - Enforcement Court
* \`entities.general_prosecutor\` - General Prosecutor
* \`entities.seller\` - Seller
* \`entities.expert_committee\` - Expert Committee
* \`entities.municipality\` - Municipality
* \`entities.administrator\` - Administrator
* \`entities.register_court\` - Register Court
* \`entities.probate_court\` - Probate Court
* \`entities.registry_office\` - Registry Office
* \`entities.hereditary_leaseholder\` - Hereditary Leaseholder
* \`entities.legal_aid_court\` - Legal Aid Court
* \`entities.secondary_client\` - Secondary Client
* \`entities.secondary_opponent\` - Secondary Opponent
* \`entities.court_complaint\` - Court Complaint
* \`entities.fine_authority\` - Fine Authority
* \`entities.resident_registration_office\` - Resident Registration Office
* \`entities.investigator\` - Investigator
* \`entities.bailiff\` - Bailiff
* \`entities.insolvency_court\` - Insolvency Court
* \`entities.integration_office\` - Integration Office
* \`entities.execution_organ\` - Execution Organ
* \`entities.debtor\` - Debtor
* \`entities.creditor\` - Creditor
* \`entities.lessee\` - Lessee
* \`entities.lessor\` - Lessor
* \`entities.principal\` - Principal
* \`entities.authorized_representative\` - Authorized Representative
* \`entities.testator\` - Testator
* \`entities.heir\` - Heir
* \`entities.preliminary_heir\` - Preliminary Heir
* \`entities.subsequent_heir\` - Subsequent Heir
* \`entities.curator_of_the_estate\` - Curator Of The Estate
* \`entities.executor_of_the_will\` - Executor Of The Will
* \`entities.estate_administrator\` - Estate Administrator
* \`entities.compulsory_portion_beneficiary\` - Compulsory Portion Beneficiary
* \`entities.notary\` - Notary
* \`entities.trustee\` - Trustee
* \`entities.insolvency_administrator\` - Insolvency Administrator
* \`entities.defendant_representative\` - Defendant Representative
* \`entities.plaintiff_representative\` - Plaintiff Representative
* \`entities.community_of_homeowners\` - Community Of Homeowners
* \`entities.fractional_owner\` - Fractional Owner
* \`entities.joint_debtor\` - Joint Debtor
* \`entities.joint_creditor\` - Joint Creditor
* \`entities.application_respondent\` - Application Respondent
* \`entities.hereditary_building_grantor\` - Hereditary Building Grantor
* \`entities.professional_liability_insurance\` - Professional Liability Insurance
* \`entities.building_owners_association\` - Building Owners Association
* \`entities.landlord_association\` - Landlord Association
* \`entities.landlord_community\` - Landlord Community
* \`entities.special_property_manager\` - Special Property Manager
* \`entities.house_manager\` - House Manager
* \`entities.appellant\` - Appellant
* \`entities.appellee\` - Appellee
* \`entities.counter_claimant\` - Counter Claimant
* \`entities.counter_defendant\` - Counter Defendant
* \`entities.doctor\` - Doctor
* \`entities.legal_guardian\` - Legal Guardian
* \`entities.guardian\` - Guardian
* \`entities.caretaker\` - Caretaker
* \`entities.youth_welfare_office\` - Youth Welfare Office
* \`entities.foster_parent\` - Foster Parent
* \`entities.parent\` - Parent
* \`entities.maintenance_obligor\` - Maintenance Obligor
* \`entities.beneficiary\` - Beneficiary
* \`entities.administrative_assistant\` - Administrative Assistant
* \`entities.case_worker\` - Case Worker
* \`entities.managing_director\` - Managing Director
* \`entities.shareholder\` - Shareholder
* \`entities.supervisory_board\` - Supervisory Board
* \`entities.commercial_agent\` - Commercial Agent
* \`entities.limited_partner\` - Limited Partner
* \`entities.authorized_signatory\` - Authorized Signatory
* \`entities.social_security_office\` - Social Security Office
* \`entities.employment_agency\` - Employment Agency
* \`entities.job_center\` - Job Center
* \`entities.pension_insurance\` - Pension Insurance
* \`entities.health_insurance\` - Health Insurance
* \`entities.disability_office\` - Disability Office
* \`entities.social_court\` - Social Court
* \`entities.medical_service\` - Medical Service
* \`entities.rehabilitation_provider\` - Rehabilitation Provider
* \`entities.patient\` - Patient
* \`entities.medical_institution\` - Medical Institution
* \`entities.legal_assistant\` - Legal Assistant
* \`entities.tax_authority\` - Tax Authority
* \`entities.affected_person\` - Affected Person`
} as const;

export const $ThemeEnum = {
    enum: ['red', 'orange', 'amber', 'yellow', 'lime', 'green', 'emerald', 'teal', 'cyan', 'sky', 'blue', 'indigo', 'violet', 'purple', 'fuchsia', 'pink', 'rose'],
    type: 'string',
    description: `* \`red\` - Rot
* \`orange\` - Orange
* \`amber\` - Bernstein
* \`yellow\` - Gelb
* \`lime\` - Limette
* \`green\` - Grün
* \`emerald\` - Smaragd
* \`teal\` - Türkis
* \`cyan\` - Cyan
* \`sky\` - Himmelblau
* \`blue\` - Blau
* \`indigo\` - Indigo
* \`violet\` - Violett
* \`purple\` - Purpur
* \`fuchsia\` - Fuchsie
* \`pink\` - Rosa
* \`rose\` - Rose`
} as const;

export const $ThirdPartyDocumentCreationTokenResponse = {
    type: 'object',
    properties: {
        creation_token: {
            type: 'string'
        }
    },
    required: ['creation_token']
} as const;

export const $ThirdPartyDocumentLinkRequestRequest = {
    type: 'object',
    description: 'Serializer for third-party document link creation request.',
    properties: {
        creation_token: {
            type: 'string',
            minLength: 1,
            description: 'External document creation token for the form'
        },
        case_uuid: {
            type: 'string',
            format: 'uuid',
            description: 'UUID of the case'
        }
    },
    required: ['case_uuid', 'creation_token']
} as const;

export const $ThirdPartyDocumentLinkResponse = {
    type: 'object',
    description: 'Serializer for third-party document link creation response.',
    properties: {
        form_token: {
            type: 'string',
            description: 'Generated form token for the third-party request'
        }
    },
    required: ['form_token']
} as const;

export const $ThirdPartyQuestionnaireSubmissionCreateRequest = {
    type: 'object',
    description: 'Serializer for creating third-party questionnaire submissions.',
    properties: {
        questionnaire_id: {
            type: 'string',
            format: 'uuid'
        },
        case_id: {
            type: 'string',
            format: 'uuid'
        }
    },
    required: ['case_id', 'questionnaire_id']
} as const;

export const $TitleEnum = {
    enum: ['Herr', 'Frau', 'Divers'],
    type: 'string',
    description: `* \`\` - 
* \`Herr\` - Herr
* \`Frau\` - Frau
* \`Divers\` - Divers`
} as const;

export const $TopicEnum = {
    enum: ['AGB', 'Abfindung', 'Abmahnung', 'Abmahnung Wettbewerbsrecht', 'Abschiebungshaft', 'Abschlussarbeit', 'Abstandsregelung nicht eingehalten', 'Account hacking', 'Allgemein', 'Allgemeines Prüfungsrecht', 'Anderes', 'Arbeitsamt/ALG/Sperrzeit', 'Arbeitsunfall', 'Arbeitsvertrag', 'Arbeitszeugnis', 'Aufbau Compliancesystem', 'Aufenthaltserlaubnis', 'Aufhebungsvertrag', 'Auftragsdatenverarbeitung', 'Auseinandersetzung Erbengemeinschaft', 'Auskunft prüfen', 'Ausweisung', 'Autokauf', 'Bankkonto leergeräumt', 'Bankrecht', 'Baumangel', 'Bauvertrag', 'Behandlungsfehler Allgemein', 'Behandlungsfehler Querschnittslähmung', 'Behandlungsfehler Schlaganfall', 'Beißvorfall', 'Beratung zu Erbfall', 'Beschlagnahme Allgemein', 'Beschlagnahme Tierquälerei', 'Betreuungsrecht', 'Betrug Geldanlage', 'Betäubungsmittel', 'Burgschild Inkasso', 'Bußgeldbescheid', 'Bürgergeld', 'Coaching', 'Datenschutz', 'Datenschutz Schadensersatz', 'Datenschutzverstoß', 'Domains', 'Ehevertrag', 'Eigentumsdelikte', 'Einbürgerung', 'Einreisesperre', 'Eintrag löschen', 'Erbauseinandersetzung', 'Erbausschlagung', 'Erben/Schenken', 'Erbengemeinschaft', 'Erbschein', 'Erbscheinsantrag', 'Erbvertrag', 'Exmatrikulation', 'Fahren ohne Führerschein', 'Fahren unter Alkohol - / Drogeneinfluss', 'Fahrer - / Unfallflucht', 'Fahrverbot / Führerscheinentzug', 'Falschaussage/ Meineid', 'Familie Vorsorge', 'Forderung löschen', 'Geburtsfehler', 'Geburtsfehler Mutter', 'Geschwindigkeitsüberschreitung', 'Gesetzliche Erbfolge', 'Gewerblicher Rechtsschutz', 'Grundschuld', 'Gründung', 'Handy am Steuer', 'Hauskauf', 'Härtefallantrag', 'Immobilien', 'Immobilienübertragung', 'Kaufvertragsprüfung', 'Körperverletzung', 'Kündigung', 'Lohnzahlung', 'Maklerangelegenheit', 'Markenanmeldung', 'Markenverteidigung', 'Markenüberwachung', 'Mieterhöhung', 'Mietkaution', 'Mietminderung', 'Mietvertrag', 'Nebenkostenabrechnung', 'Niederlassungserlaubnis', 'Nutzerbewertungen Verfasser', 'Patientenverfügung/Vorsorgevollmacht', 'Personenverwechselung', 'Pflege-/Krankenversicherung', 'Pflichtteil', 'Pflichtteil Geltendmachung', 'Pflichtteil abwehren', 'Plagiatsvorwurf', 'Remonstration', 'Rente', 'Rotlichtverstoß', 'Räumungsklage', 'Schadensersatz', 'Scheidung', 'Schenkung', 'Schenkung Immobilie', 'Schulplatz einklagen', 'Schwerbehinderung', 'Sexualdelikt', 'Software Hardware', 'Sonstige Beglaubigung', 'Sorgerecht und Umgangsrecht', 'Testament', 'Testament/Erbvertrag', 'Tierkauf', 'Tierärztliche Behandlungsfehler', 'Trennung', 'Tuning', 'Täuschungsversuch', 'Tötungsdelikte', 'Unfall Querschnittslähmung', 'Unfall mit Personenschaden', 'Unterhalt', 'Unternehmen', 'Unternehmensauflösung', 'Unternehmensgründung', 'Unternehmenskauf', 'Urheberrecht', 'Urlaub', 'Vaterschaftsanerkennung', 'Vererben', 'Verkehrsunfall', 'Vermögensauseinandersetzung', 'Vermögensdelikte', 'Verstoß gegen die Anschnallpflicht', 'Vertragsprüfung', 'Vertragsrecht', 'Visum', 'Vorfälligkeitsentschädigung', 'Vorsorge', 'Vorsorgevollmacht/Patientenverfügung', 'Waffendelikte', 'Wettbewerbsrecht', 'Widerrufsrechte', 'Widerspruch/ Klage', 'Wucherzinsen Darlehen', 'Zugewinnausgleich', 'Zweiradunfall', 'unbezahlte Rechnungen', 'unerlaubtes Glücksspiel', 'Überstunden', 'Übertragung zu Lebzeiten'],
    type: 'string',
    description: `* \`AGB\` - Agb
* \`Abfindung\` - Abfindung
* \`Abmahnung\` - Abmahnung
* \`Abmahnung Wettbewerbsrecht\` - Abmahnung Wettbewerbsrecht
* \`Abschiebungshaft\` - Abschiebungshaft
* \`Abschlussarbeit\` - Abschlussarbeit
* \`Abstandsregelung nicht eingehalten\` - Abstandsregelung Nicht Eingehalten
* \`Account hacking\` - Account Hacking
* \`Allgemein\` - Allgemein
* \`Allgemeines Prüfungsrecht\` - Allgemeines Prüfungsrecht
* \`Anderes\` - Anderes
* \`Arbeitsamt/ALG/Sperrzeit\` - Arbeitsamt/Alg/Sperrzeit
* \`Arbeitsunfall\` - Arbeitsunfall
* \`Arbeitsvertrag\` - Arbeitsvertrag
* \`Arbeitszeugnis\` - Arbeitszeugnis
* \`Aufbau Compliancesystem\` - Aufbau Compliancesystem
* \`Aufenthaltserlaubnis\` - Aufenthaltserlaubnis
* \`Aufhebungsvertrag\` - Aufhebungsvertrag
* \`Auftragsdatenverarbeitung\` - Auftragsdatenverarbeitung
* \`Auseinandersetzung Erbengemeinschaft\` - Auseinandersetzung Erbengemeinschaft
* \`Auskunft prüfen\` - Auskunft Prüfen
* \`Ausweisung\` - Ausweisung
* \`Autokauf\` - Autokauf
* \`Bankkonto leergeräumt\` - Bankkonto Leergeräumt
* \`Bankrecht\` - Bankrecht
* \`Baumangel\` - Baumangel
* \`Bauvertrag\` - Bauvertrag
* \`Behandlungsfehler Allgemein\` - Behandlungsfehler Allgemein
* \`Behandlungsfehler Querschnittslähmung\` - Behandlungsfehler Querschnittslähmung
* \`Behandlungsfehler Schlaganfall\` - Behandlungsfehler Schlaganfall
* \`Beißvorfall\` - Beißvorfall
* \`Beratung zu Erbfall\` - Beratung Zu Erbfall
* \`Beschlagnahme Allgemein\` - Beschlagnahme Allgemein
* \`Beschlagnahme Tierquälerei\` - Beschlagnahme Tierquälerei
* \`Betreuungsrecht\` - Betreuungsrecht
* \`Betrug Geldanlage\` - Betrug Geldanlage
* \`Betäubungsmittel\` - Betäubungsmittel
* \`Burgschild Inkasso\` - Burgschild Inkasso
* \`Bußgeldbescheid\` - Bußgeldbescheid
* \`Bürgergeld\` - Bürgergeld
* \`Coaching\` - Coaching
* \`Datenschutz\` - Datenschutz
* \`Datenschutz Schadensersatz\` - Datenschutz Schadensersatz
* \`Datenschutzverstoß\` - Datenschutzverstoß
* \`Domains\` - Domains
* \`Ehevertrag\` - Ehevertrag
* \`Eigentumsdelikte\` - Eigentumsdelikte
* \`Einbürgerung\` - Einbürgerung
* \`Einreisesperre\` - Einreisesperre
* \`Eintrag löschen\` - Eintrag Löschen
* \`Erbauseinandersetzung\` - Erbauseinandersetzung
* \`Erbausschlagung\` - Erbausschlagung
* \`Erben/Schenken\` - Erben/Schenken
* \`Erbengemeinschaft\` - Erbengemeinschaft
* \`Erbschein\` - Erbschein
* \`Erbscheinsantrag\` - Erbscheinsantrag
* \`Erbvertrag\` - Erbvertrag
* \`Exmatrikulation\` - Exmatrikulation
* \`Fahren ohne Führerschein\` - Fahren Ohne Führerschein
* \`Fahren unter Alkohol - / Drogeneinfluss\` - Fahren Unter Alkohol - / Drogeneinfluss
* \`Fahrer - / Unfallflucht\` - Fahrer - / Unfallflucht
* \`Fahrverbot / Führerscheinentzug\` - Fahrverbot / Führerscheinentzug
* \`Falschaussage/ Meineid\` - Falschaussage/ Meineid
* \`Familie Vorsorge\` - Familie Vorsorge
* \`Forderung löschen\` - Forderung Löschen
* \`Geburtsfehler\` - Geburtsfehler
* \`Geburtsfehler Mutter\` - Geburtsfehler Mutter
* \`Geschwindigkeitsüberschreitung\` - Geschwindigkeitsüberschreitung
* \`Gesetzliche Erbfolge\` - Gesetzliche Erbfolge
* \`Gewerblicher Rechtsschutz\` - Gewerblicher Rechtsschutz
* \`Grundschuld\` - Grundschuld
* \`Gründung\` - Gründung
* \`Handy am Steuer\` - Handy Am Steuer
* \`Hauskauf\` - Hauskauf
* \`Härtefallantrag\` - Härtefallantrag
* \`Immobilien\` - Immobilien
* \`Immobilienübertragung\` - Immobilienübertragung
* \`Kaufvertragsprüfung\` - Kaufvertragsprüfung
* \`Körperverletzung\` - Körperverletzung
* \`Kündigung\` - Kündigung
* \`Lohnzahlung\` - Lohnzahlung
* \`Maklerangelegenheit\` - Maklerangelegenheit
* \`Markenanmeldung\` - Markenanmeldung
* \`Markenverteidigung\` - Markenverteidigung
* \`Markenüberwachung\` - Markenüberwachung
* \`Mieterhöhung\` - Mieterhöhung
* \`Mietkaution\` - Mietkaution
* \`Mietminderung\` - Mietminderung
* \`Mietvertrag\` - Mietvertrag
* \`Nebenkostenabrechnung\` - Nebenkostenabrechnung
* \`Niederlassungserlaubnis\` - Niederlassungserlaubnis
* \`Nutzerbewertungen Verfasser\` - Nutzerbewertungen Verfasser
* \`Patientenverfügung/Vorsorgevollmacht\` - Patientenverfügung/Vorsorgevollmacht
* \`Personenverwechselung\` - Personenverwechselung
* \`Pflege-/Krankenversicherung\` - Pflege-/Krankenversicherung
* \`Pflichtteil\` - Pflichtteil
* \`Pflichtteil Geltendmachung\` - Pflichtteil Geltendmachung
* \`Pflichtteil abwehren\` - Pflichtteil Abwehren
* \`Plagiatsvorwurf\` - Plagiatsvorwurf
* \`Remonstration\` - Remonstration
* \`Rente\` - Rente
* \`Rotlichtverstoß\` - Rotlichtverstoß
* \`Räumungsklage\` - Räumungsklage
* \`Schadensersatz\` - Schadensersatz
* \`Scheidung\` - Scheidung
* \`Schenkung\` - Schenkung
* \`Schenkung Immobilie\` - Schenkung Immobilie
* \`Schulplatz einklagen\` - Schulplatz Einklagen
* \`Schwerbehinderung\` - Schwerbehinderung
* \`Sexualdelikt\` - Sexualdelikt
* \`Software Hardware\` - Software Hardware
* \`Sonstige Beglaubigung\` - Sonstige Beglaubigung
* \`Sorgerecht und Umgangsrecht\` - Sorgerecht Und Umgangsrecht
* \`Testament\` - Testament
* \`Testament/Erbvertrag\` - Testament/Erbvertrag
* \`Tierkauf\` - Tierkauf
* \`Tierärztliche Behandlungsfehler\` - Tierärztliche Behandlungsfehler
* \`Trennung\` - Trennung
* \`Tuning\` - Tuning
* \`Täuschungsversuch\` - Täuschungsversuch
* \`Tötungsdelikte\` - Tötungsdelikte
* \`Unfall Querschnittslähmung\` - Unfall Querschnittslähmung
* \`Unfall mit Personenschaden\` - Unfall Mit Personenschaden
* \`Unterhalt\` - Unterhalt
* \`Unternehmen\` - Unternehmen
* \`Unternehmensauflösung\` - Unternehmensauflösung
* \`Unternehmensgründung\` - Unternehmensgründung
* \`Unternehmenskauf\` - Unternehmenskauf
* \`Urheberrecht\` - Urheberrecht
* \`Urlaub\` - Urlaub
* \`Vaterschaftsanerkennung\` - Vaterschaftsanerkennung
* \`Vererben\` - Vererben
* \`Verkehrsunfall\` - Verkehrsunfall
* \`Vermögensauseinandersetzung\` - Vermögensauseinandersetzung
* \`Vermögensdelikte\` - Vermögensdelikte
* \`Verstoß gegen die Anschnallpflicht\` - Verstoß Gegen Die Anschnallpflicht
* \`Vertragsprüfung\` - Vertragsprüfung
* \`Vertragsrecht\` - Vertragsrecht
* \`Visum\` - Visum
* \`Vorfälligkeitsentschädigung\` - Vorfälligkeitsentschädigung
* \`Vorsorge\` - Vorsorge
* \`Vorsorgevollmacht/Patientenverfügung\` - Vorsorgevollmacht/Patientenverfügung
* \`Waffendelikte\` - Waffendelikte
* \`Wettbewerbsrecht\` - Wettbewerbsrecht
* \`Widerrufsrechte\` - Widerrufsrechte
* \`Widerspruch/ Klage\` - Widerspruch/ Klage
* \`Wucherzinsen Darlehen\` - Wucherzinsen Darlehen
* \`Zugewinnausgleich\` - Zugewinnausgleich
* \`Zweiradunfall\` - Zweiradunfall
* \`unbezahlte Rechnungen\` - Unbezahlte Rechnungen
* \`unerlaubtes Glücksspiel\` - Unerlaubtes Glücksspiel
* \`Überstunden\` - Überstunden
* \`Übertragung zu Lebzeiten\` - Übertragung Zu Lebzeiten`
} as const;

export const $TrackingEventRequest = {
    type: 'object',
    description: 'Serializer for tracking events.',
    properties: {
        user: {
            type: 'string',
            minLength: 1
        },
        name: {
            type: 'string',
            minLength: 1
        },
        organization_uuid: {
            type: 'string',
            format: 'uuid'
        }
    },
    required: ['name', 'organization_uuid', 'user']
} as const;

export const $Translation = {
    type: 'object',
    title: 'Translation',
    properties: {
        en: {
            type: 'string'
        },
        de: {
            type: 'string'
        }
    },
    required: ['en', 'de']
} as const;

export const $UUIDCaseCreatorEntity = {
    type: 'object',
    title: 'UUIDCaseCreatorEntity',
    properties: {
        entity_type: {
            '$ref': '#/components/schemas/EntityTypeC7aEnum'
        },
        company_legal_form: {
            nullable: true,
            oneOf: [
                {
                    '$ref': '#/components/schemas/UUIDCaseCreatorEntityCompanyLegalFormEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        company_name: {
            type: 'string',
            nullable: true
        },
        institution_name: {
            type: 'string',
            nullable: true
        },
        title: {
            nullable: true,
            oneOf: [
                {
                    '$ref': '#/components/schemas/TitleEnum'
                },
                {
                    '$ref': '#/components/schemas/BlankEnum'
                }
            ]
        },
        first_name: {
            type: 'string',
            nullable: true
        },
        last_name: {
            type: 'string',
            nullable: true
        },
        phone: {
            type: 'string',
            nullable: true
        },
        email: {
            type: 'string',
            nullable: true
        },
        date_of_birth: {
            type: 'string',
            nullable: true
        },
        street: {
            type: 'string',
            nullable: true
        },
        street_number: {
            type: 'string',
            nullable: true
        },
        address_line_2: {
            type: 'string',
            nullable: true
        },
        zip: {
            type: 'string',
            nullable: true
        },
        city: {
            type: 'string',
            nullable: true
        },
        iban: {
            type: 'string',
            nullable: true
        },
        bic: {
            type: 'string',
            nullable: true
        },
        bank_name: {
            type: 'string',
            nullable: true
        },
        legal_insurance: {
            type: 'boolean',
            nullable: true
        },
        legal_insurance_number: {
            type: 'string',
            nullable: true
        },
        legal_insurance_name: {
            type: 'string',
            nullable: true
        },
        client_probability: {
            type: 'integer'
        },
        opponent_probability: {
            type: 'integer'
        },
        uuid: {
            type: 'string'
        },
        document_uuid: {
            type: 'string',
            nullable: true
        }
    },
    required: ['entity_type', 'client_probability', 'opponent_probability', 'uuid']
} as const;

export const $UUIDCaseCreatorEntityCompanyLegalFormEnum = {
    type: 'string',
    enum: ['GmbH', 'UG (haftungsbeschränkt)', 'GmbH & Co. KG', 'AG', 'AG & Co. KG', 'KG', 'OHG', 'GBR', 'PartG', 'PartG mbB', 'KGaA', 'eG', 'eV', 'Einzelunternehmen', 'Stiftung', 'SE', 'EWIV', 'Limited', 'PLC', 'SARL', 'SAS', 'SA (FR)', 'SCN', 'S.A.R.L.', 'SRL', 'SPA', 'SL', 'SA (ES)', 'BV', 'NV', 'AB', 'Oy', 'AS', 's.r.o.', 'Kft.', 'Sp. z o.o.', 'OOO']
} as const;

export const $UUIDExtractedLawData = {
    type: 'object',
    title: 'UUIDExtractedLawData',
    properties: {
        law_field: {
            allOf: [
                {
                    '$ref': '#/components/schemas/LawFieldEnum'
                }
            ],
            nullable: true
        },
        law_topic: {
            allOf: [
                {
                    '$ref': '#/components/schemas/LawTopicEnum'
                }
            ],
            nullable: true
        },
        uuid: {
            type: 'string'
        },
        document_uuid: {
            type: 'string',
            nullable: true
        }
    },
    required: ['uuid']
} as const;

export const $UUIDExtractionResult = {
    type: 'object',
    title: 'UUIDExtractionResult',
    properties: {
        extracted_entities: {
            '$ref': '#/components/schemas/UUIDCaseCreatorEntity'
        },
        extracted_law_data: {
            '$ref': '#/components/schemas/UUIDExtractedLawData',
            nullable: true
        },
        short_document_summary: {
            type: 'string',
            nullable: true
        }
    },
    required: ['extracted_entities']
} as const;

export const $UnifiedDocumentTemplate = {
    type: 'object',
    description: `Unified serializer that normalizes both Form (MASTER) and PDFFormTemplate models
into a common format for the frontend.`,
    properties: {
        id: {
            type: 'string',
            readOnly: true
        },
        template_type: {
            type: 'string'
        },
        title: {
            type: 'string'
        },
        description: {
            type: 'string'
        },
        file: {
            type: 'string',
            format: 'uri',
            readOnly: true
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        modified_at: {
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        created_by: {
            allOf: [
                {
                    '$ref': '#/components/schemas/CustomerUser'
                }
            ],
            readOnly: true
        },
        modified_by: {
            allOf: [
                {
                    '$ref': '#/components/schemas/CustomerUser'
                }
            ],
            readOnly: true
        },
        external_document_creation_token: {
            type: 'string',
            readOnly: true
        },
        form_fields: {
            type: 'array',
            items: {
                type: 'object',
                additionalProperties: {}
            },
            readOnly: true
        }
    },
    required: ['created_at', 'created_by', 'external_document_creation_token', 'file', 'form_fields', 'id', 'modified_at', 'modified_by', 'template_type']
} as const;

export const $UpdateValidationDataResponse = {
    type: 'object',
    description: 'Serializer for updating validation data response.',
    properties: {
        validation_data: {},
        updated_fields: {
            type: 'array',
            items: {
                type: 'string'
            }
        },
        preview_blob: {
            type: 'string',
            nullable: true
        }
    },
    required: ['preview_blob', 'updated_fields', 'validation_data']
} as const;

export const $UploadOriginEnum = {
    enum: ['None', 'Chatbot Upload', 'Email Anhang', 'Terminbuchung', 'Fragebogen', 'Manuell hinzugefügt', 'AI CASE CHAT', 'AI Global Chat', 'Dokument neu organisiert', 'External platform'],
    type: 'string',
    description: `* \`None\` - Not Set
* \`Chatbot Upload\` - Chatbot
* \`Email Anhang\` - Email
* \`Terminbuchung\` - Appointment
* \`Fragebogen\` - Questionnaire
* \`Manuell hinzugefügt\` - Manual
* \`AI CASE CHAT\` - Ai Case Chat
* \`AI Global Chat\` - Ai Global Chat
* \`Dokument neu organisiert\` - Reorganization
* \`External platform\` - External Platform`
} as const;

export const $ValidatePostRequestRequest = {
    type: 'object',
    description: 'Serializer for POST validate endpoint request.',
    properties: {
        use_ai_template: {
            type: 'boolean',
            default: false,
            description: 'Use AI-generated template'
        }
    }
} as const;

export const $ValidationDataResponse = {
    type: 'object',
    description: 'Serializer for validation data response.',
    properties: {
        template_id: {
            type: 'string',
            format: 'uuid'
        },
        template_name: {
            type: 'string'
        },
        placeholders: {
            type: 'array',
            items: {
                type: 'string'
            }
        },
        validation_data: {},
        preview_blob: {
            type: 'string',
            nullable: true
        }
    },
    required: ['placeholders', 'preview_blob', 'template_id', 'template_name', 'validation_data']
} as const;

export const $WordDocumentTemplate = {
    type: 'object',
    properties: {
        uuid: {
            type: 'string',
            format: 'uuid'
        }
    }
} as const;

export const $WordTemplateStatus = {
    enum: ['draft', 'in_review', 'approved'],
    type: 'string',
    description: `* \`draft\` - Draft
* \`in_review\` - In Review
* \`approved\` - Approved`
} as const;